var nm = Object.defineProperty;
var rm = (r, e, t) => e in r ? nm(r, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : r[e] = t;
var mi = (r, e, t) => (rm(r, typeof e != "symbol" ? e + "" : e, t), t);
import { j as im } from "./jsx-runtime-944c88e2.js";
import * as g from "react";
import { p as E } from "./index-efd35e77.js";
import { B as om, t as am } from "./ButtonGroup-a9850ef0.js";
import { T as sm } from "./Toolbar-08559716.js";
import { v as lm, p as cm, c as _i } from "./package-metadata-9ad1330d.js";
import { c as um, ad as fm, ae as hm, af as dm, x as pm, ag as mm, ah as gm, ai as vm, aj as ym, ak as wm, al as bm, am as Sm, an as Cm, ao as km, ap as xm, aq as Om, ar as Tm, as as Mm, at as _m, au as Im, av as Dm, aw as Em, ax as Am, a4 as Nm, ay as Rm, E as Pm, az as Lm, aA as Fm, aB as zm, aC as Bm, aD as $m, aE as Hm, aF as jm, aG as Wm, aH as Vm, aI as Um, aJ as qm, aK as Km, aL as Gm, aM as Jm, aN as Xm, aO as Ym, aP as ga, aQ as va, t as Zm, r as Qm, aR as eg, aS as tg, aT as ng, aU as rg, aV as ig, aW as og } from "./index.es-6889c727.js";
import * as ag from "react-dom";
import { B as he } from "./Button-4c83e316.js";
import { S as Cn, w as Re, x as Pe } from "./index-93802845.js";
import { d as sg, g as kl, a as lg } from "./auto-scroll-b2de6e53.js";
import { c as Cu, g as cg, K as bt, d as on, b as xl, e as ug, Z as Ol, v as fg, p as hg, f as Tl, h as dg, i as pg, j as mg, w as gg } from "./Dialog-a72b336a.js";
import { a as Xt, v as Ar, y as vg, d as yg } from "./index-a0534bb4.js";
import { b as Ni, c as Ri, F as Ft } from "./FormElement-65f04cfd.js";
import { T as wg, a as Ml } from "./TabStripTab-5182621d.js";
import { l as bg, v as Sg } from "./index-64063129.js";
import { a as Cg } from "./Popup-b6c9078b.js";
import { Z as ku } from "./index-b1011fa6.js";
import { s as kg } from "./save-as-6eb63bad.js";
import { d as xg, r as Og } from "./server.browser-2a8afecd.js";
import { v as zr, D as Tg, F as Mg, J as xu, K as Ou, G as dt, y as lo, N as Es, g as Ue, i as As, R as vn, M as _l, z as _g, f as Ig, O as Po, b as Dg, I as Tu, k as Eg, Q as ya, L as Ag } from "./surface-71c0d1c6.js";
import { T as Ng, C as Il, G as Dl } from "./text-e26620ac.js";
import { g as Rg, n as Pg, d as Mr, a as El, P as Lg, b as Fg, c as zg, B as Bg } from "./popup-da16fa2b.js";
import { K as St } from "./keys-2b65407d.js";
import { k as Al, s as $g } from "./theme-b013fa81.js";
import "./index-c07310bf.js";
import "./Label-079ad7bc.js";
import "./package-metadata-3dcf116a.js";
import "./FloatingLabel-922c628f.js";
import "./package-metadata-a152adb8.js";
import "./Animation-154b683d.js";
import "./TransitionGroup-34043d49.js";
import "./noop-d627517c.js";
import "./guid-fc0d51fd.js";
import "./keys-029ad48d.js";
import "./Chip-cb37946d.js";
import "./TreeView-aa1ef3e3.js";
import "./Reveal-e2f427f6.js";
import "./Animation-d8a017b3.js";
import "./ActionSheet-b5bf2237.js";
var Hg = globalThis && globalThis.__extends || function() {
  var r = function(e, t) {
    return r = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i)
        Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, r(e, t);
  };
  return function(e, t) {
    if (typeof t != "function" && t !== null)
      throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
    r(e, t);
    function n() {
      this.constructor = e;
    }
    e.prototype = t === null ? Object.create(t) : (n.prototype = t.prototype, new n());
  };
}(), jg = (
  /** @class */
  function(r) {
    Hg(e, r);
    function e() {
      return r !== null && r.apply(this, arguments) || this;
    }
    return e.prototype.render = function() {
      return null;
    }, e.propTypes = {
      text: E.string,
      icon: E.string,
      iconClass: E.string,
      imageUrl: E.string,
      disabled: E.bool,
      render: E.any
    }, e;
  }(g.Component)
), Wg = globalThis && globalThis.__extends || function() {
  var r = function(e, t) {
    return r = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i)
        Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, r(e, t);
  };
  return function(e, t) {
    if (typeof t != "function" && t !== null)
      throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
    r(e, t);
    function n() {
      this.constructor = e;
    }
    e.prototype = t === null ? Object.create(t) : (n.prototype = t.prototype, new n());
  };
}(), Vg = (
  /** @class */
  function(r) {
    Wg(e, r);
    function e(t) {
      var n = r.call(this, t) || this;
      return n.state = {
        focused: !1,
        focusedIndex: -1,
        opened: !1
      }, n.wrapper = null, n.mainButton = null, n.list = null, n.guid = Rg(), n.skipFocus = !1, n.buttonsData = [], n.onKeyDown = function(i) {
        var o = n.state.focusedIndex;
        if (i.altKey) {
          !n.opened && i.keyCode === St.down ? (n.dispatchPopupEvent(i, !0), n.setState({ focusedIndex: 0 }), n.setOpen(!0)) : n.opened && i.keyCode === St.up && (n.setState({ focusedIndex: -1 }), n.setOpen(!1));
          return;
        }
        var a = void 0;
        if (i.keyCode === St.enter || i.keyCode === St.space) {
          if (i.preventDefault(), n.dispatchClickEvent(i, o), o >= 0) {
            a = {
              focusedIndex: n.opened ? -1 : 0
            };
            var s = !n.opened;
            n.setOpen(s), s && n.dispatchPopupEvent(i, s);
          }
        } else if (n.opened && i.keyCode === St.esc) {
          n.setState({ focusedIndex: -1 }), n.setOpen(!1);
          return;
        }
        if (n.opened) {
          var l = Pg(o, i.keyCode, i.altKey, n.buttonsData.length);
          l !== o && (a = a || {}, a.focusedIndex = l);
          var c = i.keyCode === St.up || i.keyCode === St.down || i.keyCode === St.left || i.keyCode === St.right;
          !i.altKey && (c || i.keyCode === St.home || i.keyCode === St.end) && i.preventDefault();
        }
        a && n.setState(a);
      }, n.switchFocus = function(i) {
        n.skipFocus = !0, i(), window.setTimeout(function() {
          return n.skipFocus = !1;
        }, 0);
      }, n.onFocus = function(i) {
        n.skipFocus || (Mr(n.props.onFocus, i, n, void 0), n.setState({ focused: !0 }));
      }, n.setOpen = function(i) {
        n.openedDuringOnChange = i, n.setState({ opened: i });
      }, n.onItemClick = function(i, o) {
        var a = n.opened;
        a && (n.setState({ focusedIndex: 0 }), n.setOpen(!1)), n.dispatchClickEvent(i, o);
      }, n.onBlur = function(i) {
        n.skipFocus || (n.setState({
          focused: !1,
          focusedIndex: -1
        }), n.setOpen(!1), Mr(n.props.onBlur, i, n, void 0));
      }, n.onPopupClose = function() {
        n.state.focused && n.switchFocus(function() {
          n.element && (n.element.removeAttribute("tabindex"), n.element.focus({ preventScroll: !0 }));
        }), n.dispatchPopupEvent({}, !1);
      }, n.listRef = function(i) {
        n.list = i, i && n.state.focused && n.switchFocus(function() {
          i.focus({ preventScroll: !0 }), n.element && (n.element.tabIndex = -1);
        });
      }, n.onSplitPartClick = function(i) {
        if (n.buttonsData.length) {
          var o = !n.opened;
          o && n.dispatchPopupEvent(i, o), n.setState({
            focusedIndex: o ? 0 : -1,
            focused: !0
          }), n.setOpen(o);
        }
      }, n.onDownSplitPart = function(i) {
        i.preventDefault();
        var o = El(document);
        n.element && o !== n.element && o !== n.list && n.element.focus();
      }, n.onItemDown = function(i) {
        var o = El(document);
        o === n.list && i.preventDefault();
      }, n.dispatchPopupEvent = function(i, o) {
        Mr(o ? n.props.onOpen : n.props.onClose, i, n, void 0), n.openedDuringOnChange = void 0;
      }, lm(cm), n;
    }
    return Object.defineProperty(e.prototype, "opened", {
      get: function() {
        return this.openedDuringOnChange !== void 0 ? this.openedDuringOnChange : this.props.opened === void 0 ? this.state.opened : this.props.opened;
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.render = function() {
      var t = this;
      this.buttonsData = this.props.items || g.Children.toArray(this.props.children).filter(function(u) {
        return u && u.type === jg;
      }).map(function(u) {
        return u.props;
      });
      var n = this.isRtl(), i = n ? "rtl" : void 0, o = this.props, a = o.id, s = o.style, l = o.tabIndex, c = o.disabled;
      return g.createElement(
        "div",
        { id: a, style: s, className: _i("k-split-button", "k-button-group", {
          "k-focus": this.state.focused
        }, "k-rounded-".concat(Al.roundedMap[this.props.rounded || "medium"]), this.props.className), onKeyDown: this.onKeyDown, onFocus: this.onFocus, onBlur: this.onBlur, dir: i, ref: function(u) {
          return t.wrapper = u;
        } },
        g.createElement(he, { ref: function(u) {
          return t.mainButton = u && u.element;
        }, type: "button", size: this.props.size, rounded: this.props.rounded, fillMode: this.props.fillMode, themeColor: this.props.themeColor, onClick: function(u) {
          return t.onItemClick(u, -1);
        }, disabled: c || void 0, tabIndex: l, accessKey: this.props.accessKey, className: this.props.buttonClass, icon: this.props.icon, svgIcon: this.props.svgIcon, iconClass: this.props.iconClass, imageUrl: this.props.imageUrl, dir: i, "aria-disabled": c, "aria-haspopup": !0, "aria-expanded": this.opened || void 0, "aria-label": this.props.ariaLabel, "aria-controls": this.opened ? this.guid : void 0, id: "button-" + this.guid, title: this.props.title }, this.props.text),
        g.createElement(he, { type: "button", size: this.props.size, rounded: this.props.rounded, fillMode: this.props.fillMode, themeColor: this.props.themeColor, icon: "caret-alt-down", svgIcon: um, className: "k-split-button-arrow", disabled: c || void 0, tabIndex: -1, onClick: this.onSplitPartClick, onMouseDown: this.onDownSplitPart, onPointerDown: this.onDownSplitPart, dir: i, "aria-label": "menu toggling button" }),
        this.renderPopup(n)
      );
    }, e.prototype.componentDidMount = function() {
      (this.props.dir === void 0 && this.isRtl() || this.opened) && this.forceUpdate();
    }, Object.defineProperty(e.prototype, "element", {
      /**
       * The DOM element of main button.
       */
      get: function() {
        return this.mainButton;
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.dispatchClickEvent = function(t, n) {
      this.isItemDisabled(n) || (n === -1 ? Mr(this.props.onButtonClick, t, this, void 0) : Mr(this.props.onItemClick, t, this, {
        item: this.buttonsData[n],
        itemIndex: n
      }));
    }, e.prototype.renderPopup = function(t) {
      var n, i = this.props.popupSettings, o = i === void 0 ? {} : i, a = this.state.focusedIndex;
      return g.createElement(
        Lg,
        { anchor: this.wrapper, show: this.opened, animate: o.animate, popupClass: _i("k-menu-popup", o.popupClass), anchorAlign: o.anchorAlign || Fg(t), popupAlign: o.popupAlign || zg(t), style: t ? { direction: "rtl" } : void 0, onClose: this.onPopupClose },
        g.createElement("ul", { role: "menu", id: this.guid, "aria-labelledby": "button-" + this.guid, tabIndex: -1, ref: this.listRef, "aria-activedescendant": a >= 0 ? "".concat(this.guid, "-").concat(a) : void 0, className: _i("k-group k-menu-group k-reset", (n = {}, n["k-menu-group-".concat(Al.sizeMap[this.props.size] || this.props.size)] = this.props.size, n)) }, this.renderChildItems())
      );
    }, e.prototype.renderChildItems = function() {
      var t = this, n = this.props, i = n.item, o = n.itemRender, a = n.textField;
      return this.buttonsData.length > 0 ? this.buttonsData.map(function(s, l) {
        return g.createElement(Bg, { className: "k-menu-item", dataItem: s, textField: a, focused: t.state.focusedIndex === l, onClick: t.onItemClick, onDown: t.onItemDown, render: o, item: i, key: l, index: l, id: "".concat(t.guid, "-").concat(l) });
      }) : null;
    }, e.prototype.isItemDisabled = function(t) {
      return this.buttonsData[t] ? this.buttonsData[t].disabled : this.props.disabled;
    }, e.prototype.isRtl = function() {
      return this.props.dir !== void 0 ? this.props.dir === "rtl" : !!this.wrapper && getComputedStyle(this.wrapper).direction === "rtl";
    }, e.propTypes = {
      accessKey: E.string,
      ariaLabel: E.string,
      title: E.string,
      onButtonClick: E.func,
      onFocus: E.func,
      onBlur: E.func,
      onItemClick: E.func,
      onOpen: E.func,
      onClose: E.func,
      text: E.string,
      items: E.arrayOf(E.any),
      textField: E.string,
      tabIndex: E.number,
      disabled: E.bool,
      icon: E.string,
      svgIcon: $g,
      iconClass: E.string,
      imageUrl: E.string,
      popupSettings: E.object,
      itemRender: E.any,
      item: E.func,
      className: E.string,
      buttonClass: E.string,
      dir: E.string
    }, e.defaultProps = {
      size: "medium",
      rounded: "medium",
      fillMode: "solid",
      themeColor: "base"
    }, e;
  }(g.Component)
), Ug = globalThis && globalThis.__extends || function() {
  var r = function(e, t) {
    return r = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i)
        Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, r(e, t);
  };
  return function(e, t) {
    if (typeof t != "function" && t !== null)
      throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
    r(e, t);
    function n() {
      this.constructor = e;
    }
    e.prototype = t === null ? Object.create(t) : (n.prototype = t.prototype, new n());
  };
}(), qg = (
  /** @class */
  function(r) {
    Ug(e, r);
    function e() {
      return r !== null && r.apply(this, arguments) || this;
    }
    return e.prototype.render = function() {
      return g.createElement("div", { className: _i("k-separator", this.props.className) });
    }, e;
  }(g.PureComponent)
);
function Kg() {
  throw new Error("Template implementation missing.");
}
var fn = typeof Uint8Array < "u" && zr.browser && (!zr.browser.msie || zr.browser.version > 9), wa = function() {
  var r = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
  return {
    decode: function(e) {
      for (var t = e.replace(/[^A-Za-z0-9\+\/\=]/g, ""), n = 0, i = t.length, o = []; n < i; ) {
        var a = r.indexOf(t.charAt(n++)), s = r.indexOf(t.charAt(n++)), l = r.indexOf(t.charAt(n++)), c = r.indexOf(t.charAt(n++)), u = a << 2 | s >>> 4, f = (s & 15) << 4 | l >>> 2, h = (l & 3) << 6 | c;
        o.push(u), l != 64 && o.push(f), c != 64 && o.push(h);
      }
      return o;
    },
    encode: function(e) {
      for (var t = 0, n = e.length, i = ""; t < n; ) {
        var o = e[t++], a = e[t++], s = e[t++], l = o >>> 2, c = (o & 3) << 4 | a >>> 4, u = (a & 15) << 2 | s >>> 6, f = s & 63;
        t - n == 2 ? u = f = 64 : t - n == 1 && (f = 64), i += r.charAt(l) + r.charAt(c) + r.charAt(u) + r.charAt(f);
      }
      return i;
    }
  };
}();
function ye(r) {
  var e = 0, t = 0;
  r == null ? r = fn ? new Uint8Array(256) : [] : t = r.length;
  var n = fn ? function(O) {
    if (O >= r.length) {
      var ne = new Uint8Array(Math.max(O + 256, r.length * 2));
      ne.set(r, 0), r = ne;
    }
  } : function() {
  }, i = fn ? function() {
    return new Uint8Array(r.buffer, 0, t);
  } : function() {
    return r;
  }, o = fn ? function(O) {
    if (typeof O == "string")
      return _(O);
    var ne = O.length;
    n(e + ne), r.set(O, e), e += ne, e > t && (t = e);
  } : function(O) {
    if (typeof O == "string")
      return _(O);
    for (var ne = 0; ne < O.length; ++ne)
      c(O[ne]);
  }, a = fn ? function(O, ne) {
    if (r.buffer.slice)
      return new Uint8Array(r.buffer.slice(O, O + ne));
    var B = new Uint8Array(ne);
    return B.set(new Uint8Array(r.buffer, O, ne)), B;
  } : function(O, ne) {
    return r.slice(O, O + ne);
  };
  function s() {
    return e >= t;
  }
  function l() {
    return e < t ? r[e++] : 0;
  }
  function c(O) {
    n(e), r[e++] = O & 255, e > t && (t = e);
  }
  function u() {
    return l() << 8 | l();
  }
  function f(O) {
    c(O >> 8), c(O);
  }
  function h() {
    var O = u();
    return O >= 32768 ? O - 65536 : O;
  }
  function d(O) {
    f(O < 0 ? O + 65536 : O);
  }
  function p() {
    return u() * 65536 + u();
  }
  function m(O) {
    f(O >>> 16 & 65535), f(O & 65535);
  }
  function v() {
    var O = p();
    return O >= 2147483648 ? O - 4294967296 : O;
  }
  function y(O) {
    m(O < 0 ? O + 4294967296 : O);
  }
  function b() {
    return p() / 65536;
  }
  function k(O) {
    m(Math.round(O * 65536));
  }
  function M() {
    return v() / 65536;
  }
  function D(O) {
    y(Math.round(O * 65536));
  }
  function T(O) {
    return ee(O, l);
  }
  function z(O) {
    return String.fromCharCode.apply(String, T(O));
  }
  function _(O) {
    for (var ne = 0; ne < O.length; ++ne)
      c(O.charCodeAt(ne));
  }
  function ee(O, ne) {
    for (var B = new Array(O), R = 0; R < O; ++R)
      B[R] = ne();
    return B;
  }
  var K = {
    eof: s,
    readByte: l,
    writeByte: c,
    readShort: u,
    writeShort: f,
    readLong: p,
    writeLong: m,
    readFixed: b,
    writeFixed: k,
    // signed numbers.
    readShort_: h,
    writeShort_: d,
    readLong_: v,
    writeLong_: y,
    readFixed_: M,
    writeFixed_: D,
    read: T,
    write: o,
    readString: z,
    writeString: _,
    times: ee,
    get: i,
    slice: a,
    offset: function(O) {
      return O != null ? (e = O, K) : e;
    },
    skip: function(O) {
      e += O;
    },
    toString: function() {
      throw new Error("FIX CALLER.  BinaryStream is no longer convertible to string!");
    },
    length: function() {
      return t;
    },
    saveExcursion: function(O) {
      var ne = e;
      try {
        return O();
      } finally {
        e = ne;
      }
    },
    writeBase64: function(O) {
      window.atob ? _(window.atob(O)) : o(wa.decode(O));
    },
    base64: function() {
      return wa.encode(i());
    }
  };
  return K;
}
function Gg(r) {
  for (var e = [], t = 0, n = r.length, i, o; t < n; )
    i = r.charCodeAt(t++), i >= 55296 && i <= 56319 && t < n ? (o = r.charCodeAt(t++), (o & 64512) == 56320 ? e.push(((i & 1023) << 10) + (o & 1023) + 65536) : (e.push(i), t--)) : e.push(i);
  return e;
}
function Jg(r) {
  return r.map(function(e) {
    var t = "";
    return e > 65535 && (e -= 65536, t += String.fromCharCode(e >>> 10 & 1023 | 55296), e = 56320 | e & 1023), t += String.fromCharCode(e), t;
  }).join("");
}
function Xg(r) {
  for (var e = window.atob(r), t = new Uint8Array(e.length), n = 0; n < e.length; n++)
    t[n] = e.charCodeAt(n);
  return t;
}
function Yg(r) {
  for (var e = new Uint8Array(r.length), t = 0; t < r.length; t++)
    e[t] = r[t];
  return e;
}
function Zg(r) {
  return window.atob ? Xg(r) : Yg(wa.decode(r));
}
function Kr(r, e) {
  return Object.prototype.hasOwnProperty.call(r, e);
}
function Ns(r) {
  return Object.keys(r).sort(function(e, t) {
    return e - t;
  }).map(parseFloat);
}
var co = function(e) {
  this.raw = e, this.scalerType = e.readLong(), this.tableCount = e.readShort(), this.searchRange = e.readShort(), this.entrySelector = e.readShort(), this.rangeShift = e.readShort();
  for (var t = this.tables = {}, n = 0; n < this.tableCount; ++n) {
    var i = {
      tag: e.readString(4),
      checksum: e.readLong(),
      offset: e.readLong(),
      length: e.readLong()
    };
    t[i.tag] = i;
  }
};
co.prototype.readTable = function(e, t) {
  var n = this.tables[e];
  if (!n)
    throw new Error("Table " + e + " not found in directory");
  return this[e] = n.table = new t(this, n);
};
co.prototype.render = function(e) {
  var t = this, n = Object.keys(e).length, i = Math.pow(2, Math.floor(Math.log(n) / Math.LN2)), o = i * 16, a = Math.floor(Math.log(i) / Math.LN2), s = n * 16 - o, l = ye();
  l.writeLong(this.scalerType), l.writeShort(n), l.writeShort(o), l.writeShort(a), l.writeShort(s);
  var c = n * 16, u = l.offset() + c, f = null, h = ye();
  for (var d in e)
    if (Kr(e, d)) {
      var p = e[d];
      for (l.writeString(d), l.writeLong(t.checksum(p)), l.writeLong(u), l.writeLong(p.length), h.write(p), d == "head" && (f = u), u += p.length; u % 4; )
        h.writeByte(0), u++;
    }
  l.write(h.get());
  var m = this.checksum(l.get()), v = 2981146554 - m;
  return l.offset(f + 8), l.writeLong(v), l.get();
};
co.prototype.checksum = function(e) {
  e = ye(e);
  for (var t = 0; !e.eof(); )
    t += e.readLong();
  return t & 4294967295;
};
var vt = function(e, t) {
  this.definition = t, this.length = t.length, this.offset = t.offset, this.file = e, this.rawData = e.raw, this.parse(e.raw);
};
vt.prototype.raw = function() {
  return this.rawData.slice(this.offset, this.length);
};
vt.prototype.parse = function() {
};
var Qg = function(r) {
  function e() {
    r.apply(this, arguments);
  }
  return r && (e.__proto__ = r), e.prototype = Object.create(r && r.prototype), e.prototype.constructor = e, e.prototype.parse = function(n) {
    n.offset(this.offset), this.version = n.readLong(), this.revision = n.readLong(), this.checkSumAdjustment = n.readLong(), this.magicNumber = n.readLong(), this.flags = n.readShort(), this.unitsPerEm = n.readShort(), this.created = n.read(8), this.modified = n.read(8), this.xMin = n.readShort_(), this.yMin = n.readShort_(), this.xMax = n.readShort_(), this.yMax = n.readShort_(), this.macStyle = n.readShort(), this.lowestRecPPEM = n.readShort(), this.fontDirectionHint = n.readShort_(), this.indexToLocFormat = n.readShort_(), this.glyphDataFormat = n.readShort_();
  }, e.prototype.render = function(n) {
    var i = ye();
    return i.writeLong(this.version), i.writeLong(this.revision), i.writeLong(0), i.writeLong(this.magicNumber), i.writeShort(this.flags), i.writeShort(this.unitsPerEm), i.write(this.created), i.write(this.modified), i.writeShort_(this.xMin), i.writeShort_(this.yMin), i.writeShort_(this.xMax), i.writeShort_(this.yMax), i.writeShort(this.macStyle), i.writeShort(this.lowestRecPPEM), i.writeShort_(this.fontDirectionHint), i.writeShort_(n), i.writeShort_(this.glyphDataFormat), i.get();
  }, e;
}(vt), ev = function(r) {
  function e() {
    r.apply(this, arguments);
  }
  return r && (e.__proto__ = r), e.prototype = Object.create(r && r.prototype), e.prototype.constructor = e, e.prototype.parse = function(n) {
    n.offset(this.offset);
    var i = this.file.head.indexToLocFormat;
    i === 0 ? this.offsets = n.times(this.length / 2, function() {
      return 2 * n.readShort();
    }) : this.offsets = n.times(this.length / 4, n.readLong);
  }, e.prototype.offsetOf = function(n) {
    return this.offsets[n];
  }, e.prototype.lengthOf = function(n) {
    return this.offsets[n + 1] - this.offsets[n];
  }, e.prototype.render = function(n) {
    for (var i = ye(), o = n[n.length - 1] > 65535, a = 0; a < n.length; ++a)
      o ? i.writeLong(n[a]) : i.writeShort(n[a] / 2);
    return {
      format: o ? 1 : 0,
      table: i.get()
    };
  }, e;
}(vt), tv = function(r) {
  function e() {
    r.apply(this, arguments);
  }
  return r && (e.__proto__ = r), e.prototype = Object.create(r && r.prototype), e.prototype.constructor = e, e.prototype.parse = function(n) {
    n.offset(this.offset), this.version = n.readLong(), this.ascent = n.readShort_(), this.descent = n.readShort_(), this.lineGap = n.readShort_(), this.advanceWidthMax = n.readShort(), this.minLeftSideBearing = n.readShort_(), this.minRightSideBearing = n.readShort_(), this.xMaxExtent = n.readShort_(), this.caretSlopeRise = n.readShort_(), this.caretSlopeRun = n.readShort_(), this.caretOffset = n.readShort_(), n.skip(4 * 2), this.metricDataFormat = n.readShort_(), this.numOfLongHorMetrics = n.readShort();
  }, e.prototype.render = function(n) {
    var i = ye();
    return i.writeLong(this.version), i.writeShort_(this.ascent), i.writeShort_(this.descent), i.writeShort_(this.lineGap), i.writeShort(this.advanceWidthMax), i.writeShort_(this.minLeftSideBearing), i.writeShort_(this.minRightSideBearing), i.writeShort_(this.xMaxExtent), i.writeShort_(this.caretSlopeRise), i.writeShort_(this.caretSlopeRun), i.writeShort_(this.caretOffset), i.write([0, 0, 0, 0, 0, 0, 0, 0]), i.writeShort_(this.metricDataFormat), i.writeShort(n.length), i.get();
  }, e;
}(vt), nv = function(r) {
  function e() {
    r.apply(this, arguments);
  }
  return r && (e.__proto__ = r), e.prototype = Object.create(r && r.prototype), e.prototype.constructor = e, e.prototype.parse = function(n) {
    n.offset(this.offset), this.version = n.readLong(), this.numGlyphs = n.readShort(), this.maxPoints = n.readShort(), this.maxContours = n.readShort(), this.maxComponentPoints = n.readShort(), this.maxComponentContours = n.readShort(), this.maxZones = n.readShort(), this.maxTwilightPoints = n.readShort(), this.maxStorage = n.readShort(), this.maxFunctionDefs = n.readShort(), this.maxInstructionDefs = n.readShort(), this.maxStackElements = n.readShort(), this.maxSizeOfInstructions = n.readShort(), this.maxComponentElements = n.readShort(), this.maxComponentDepth = n.readShort();
  }, e.prototype.render = function(n) {
    var i = ye();
    return i.writeLong(this.version), i.writeShort(n.length), i.writeShort(this.maxPoints), i.writeShort(this.maxContours), i.writeShort(this.maxComponentPoints), i.writeShort(this.maxComponentContours), i.writeShort(this.maxZones), i.writeShort(this.maxTwilightPoints), i.writeShort(this.maxStorage), i.writeShort(this.maxFunctionDefs), i.writeShort(this.maxInstructionDefs), i.writeShort(this.maxStackElements), i.writeShort(this.maxSizeOfInstructions), i.writeShort(this.maxComponentElements), i.writeShort(this.maxComponentDepth), i.get();
  }, e;
}(vt), rv = function(r) {
  function e() {
    r.apply(this, arguments);
  }
  return r && (e.__proto__ = r), e.prototype = Object.create(r && r.prototype), e.prototype.constructor = e, e.prototype.parse = function(n) {
    n.offset(this.offset);
    var i = this.file, o = i.hhea;
    this.metrics = n.times(o.numOfLongHorMetrics, function() {
      return {
        advance: n.readShort(),
        lsb: n.readShort_()
      };
    });
    var a = i.maxp.numGlyphs - i.hhea.numOfLongHorMetrics;
    this.leftSideBearings = n.times(a, n.readShort_);
  }, e.prototype.forGlyph = function(n) {
    var i = this.metrics, o = i.length;
    return n < o ? i[n] : {
      advance: i[o - 1].advance,
      lsb: this.leftSideBearings[n - o]
    };
  }, e.prototype.render = function(n) {
    for (var i = this, o = ye(), a = 0; a < n.length; ++a) {
      var s = i.forGlyph(n[a]);
      o.writeShort(s.advance), o.writeShort_(s.lsb);
    }
    return o.get();
  }, e;
}(vt), iv = function() {
  var r = function(u) {
    this.raw = u;
  }, e = { compound: { configurable: !0 } };
  e.compound.get = function() {
    return !1;
  }, r.prototype.render = function() {
    return this.raw.get();
  }, Object.defineProperties(r.prototype, e);
  var t = 1, n = 8, i = 32, o = 64, a = 128, s = function(u) {
    this.raw = u;
    for (var f = this.glyphIds = [], h = this.idOffsets = []; ; ) {
      var d = u.readShort();
      if (h.push(u.offset()), f.push(u.readShort()), !(d & i))
        break;
      u.skip(d & t ? 4 : 2), d & a ? u.skip(8) : d & o ? u.skip(4) : d & n && u.skip(2);
    }
  }, l = { compound: { configurable: !0 } };
  return l.compound.get = function() {
    return !0;
  }, s.prototype.render = function(u) {
    for (var f = this, h = ye(this.raw.get()), d = 0; d < this.glyphIds.length; ++d) {
      var p = f.glyphIds[d];
      h.offset(f.idOffsets[d]), h.writeShort(u[p]);
    }
    return h.get();
  }, Object.defineProperties(s.prototype, l), function(c) {
    function u() {
      c.apply(this, arguments);
    }
    return c && (u.__proto__ = c), u.prototype = Object.create(c && c.prototype), u.prototype.constructor = u, u.prototype.parse = function() {
      this.cache = {};
    }, u.prototype.glyphFor = function(h) {
      var d = this.cache;
      if (Kr(d, h))
        return d[h];
      var p = this.file.loca, m = p.lengthOf(h);
      if (m === 0)
        return d[h] = null;
      var v = this.rawData, y = this.offset + p.offsetOf(h), b = ye(v.slice(y, m)), k = b.readShort_(), M = b.readShort_(), D = b.readShort_(), T = b.readShort_(), z = b.readShort_(), _ = d[h] = k < 0 ? new s(b) : new r(b);
      return _.numberOfContours = k, _.xMin = M, _.yMin = D, _.xMax = T, _.yMax = z, _;
    }, u.prototype.render = function(h, d, p) {
      for (var m = ye(), v = [], y = 0; y < d.length; ++y) {
        var b = d[y], k = h[b];
        m.offset() % 2 && m.writeByte(0), v.push(m.offset()), k && m.write(k.render(p));
      }
      return m.offset() % 2 && m.writeByte(0), v.push(m.offset()), {
        table: m.get(),
        offsets: v
      };
    }, u;
  }(vt);
}(), ov = function() {
  var r = function(t, n) {
    this.text = t, this.length = t.length, this.platformID = n.platformID, this.platformSpecificID = n.platformSpecificID, this.languageID = n.languageID, this.nameID = n.nameID;
  };
  return function(e) {
    function t() {
      e.apply(this, arguments);
    }
    return e && (t.__proto__ = e), t.prototype = Object.create(e && e.prototype), t.prototype.constructor = t, t.prototype.parse = function(i) {
      i.offset(this.offset), i.readShort();
      for (var o = i.readShort(), a = this.offset + i.readShort(), s = i.times(o, function() {
        return {
          platformID: i.readShort(),
          platformSpecificID: i.readShort(),
          languageID: i.readShort(),
          nameID: i.readShort(),
          length: i.readShort(),
          offset: i.readShort() + a
        };
      }), l = this.strings = {}, c = 0; c < s.length; ++c) {
        var u = s[c];
        i.offset(u.offset);
        var f = i.readString(u.length);
        l[u.nameID] || (l[u.nameID] = []), l[u.nameID].push(new r(f, u));
      }
      this.postscriptEntry = l[6][0], this.postscriptName = this.postscriptEntry.text.replace(/[^\x20-\x7F]/g, "");
    }, t.prototype.render = function(i) {
      var o = this, a = this.strings, s = 0;
      for (var l in a)
        Kr(a, l) && (s += a[l].length);
      var c = ye(), u = ye();
      c.writeShort(0), c.writeShort(s), c.writeShort(6 + 12 * s);
      for (l in a)
        if (Kr(a, l))
          for (var f = l == 6 ? [
            new r(i, o.postscriptEntry)
          ] : a[l], h = 0; h < f.length; ++h) {
            var d = f[h];
            c.writeShort(d.platformID), c.writeShort(d.platformSpecificID), c.writeShort(d.languageID), c.writeShort(d.nameID), c.writeShort(d.length), c.writeShort(u.offset()), u.writeString(d.text);
          }
      return c.write(u.get()), c.get();
    }, t;
  }(vt);
}(), av = function() {
  var r = ".notdef .null nonmarkingreturn space exclam quotedbl numbersign dollar percent ampersand quotesingle parenleft parenright asterisk plus comma hyphen period slash zero one two three four five six seven eight nine colon semicolon less equal greater question at A B C D E F G H I J K L M N O P Q R S T U V W X Y Z bracketleft backslash bracketright asciicircum underscore grave a b c d e f g h i j k l m n o p q r s t u v w x y z braceleft bar braceright asciitilde Adieresis Aring Ccedilla Eacute Ntilde Odieresis Udieresis aacute agrave acircumflex adieresis atilde aring ccedilla eacute egrave ecircumflex edieresis iacute igrave icircumflex idieresis ntilde oacute ograve ocircumflex odieresis otilde uacute ugrave ucircumflex udieresis dagger degree cent sterling section bullet paragraph germandbls registered copyright trademark acute dieresis notequal AE Oslash infinity plusminus lessequal greaterequal yen mu partialdiff summation product pi integral ordfeminine ordmasculine Omega ae oslash questiondown exclamdown logicalnot radical florin approxequal Delta guillemotleft guillemotright ellipsis nonbreakingspace Agrave Atilde Otilde OE oe endash emdash quotedblleft quotedblright quoteleft quoteright divide lozenge ydieresis Ydieresis fraction currency guilsinglleft guilsinglright fi fl daggerdbl periodcentered quotesinglbase quotedblbase perthousand Acircumflex Ecircumflex Aacute Edieresis Egrave Iacute Icircumflex Idieresis Igrave Oacute Ocircumflex apple Ograve Uacute Ucircumflex Ugrave dotlessi circumflex tilde macron breve dotaccent ring cedilla hungarumlaut ogonek caron Lslash lslash Scaron scaron Zcaron zcaron brokenbar Eth eth Yacute yacute Thorn thorn minus multiply onesuperior twosuperior threesuperior onehalf onequarter threequarters franc Gbreve gbreve Idotaccent Scedilla scedilla Cacute cacute Ccaron ccaron dcroat".split(/\s+/g);
  return function(e) {
    function t() {
      e.apply(this, arguments);
    }
    return e && (t.__proto__ = e), t.prototype = Object.create(e && e.prototype), t.prototype.constructor = t, t.prototype.parse = function(i) {
      var o = this;
      i.offset(this.offset), this.format = i.readLong(), this.italicAngle = i.readFixed_(), this.underlinePosition = i.readShort_(), this.underlineThickness = i.readShort_(), this.isFixedPitch = i.readLong(), this.minMemType42 = i.readLong(), this.maxMemType42 = i.readLong(), this.minMemType1 = i.readLong(), this.maxMemType1 = i.readLong();
      var a;
      switch (this.format) {
        case 65536:
        case 196608:
          break;
        case 131072:
          a = i.readShort(), this.glyphNameIndex = i.times(a, i.readShort), this.names = [];
          for (var s = this.offset + this.length; i.offset() < s; )
            o.names.push(i.readString(i.readByte()));
          break;
        case 151552:
          a = i.readShort(), this.offsets = i.read(a);
          break;
        case 262144:
          this.map = i.times(this.file.maxp.numGlyphs, i.readShort);
          break;
      }
    }, t.prototype.glyphFor = function(i) {
      switch (this.format) {
        case 65536:
          return r[i] || ".notdef";
        case 131072:
          var o = this.glyphNameIndex[i];
          return o < r.length ? r[o] : this.names[o - r.length] || ".notdef";
        case 151552:
        case 196608:
          return ".notdef";
        case 262144:
          return this.map[i] || 65535;
      }
    }, t.prototype.render = function(i) {
      var o = this;
      if (this.format == 196608)
        return this.raw();
      var a = ye(this.rawData.slice(this.offset, 32));
      a.writeLong(131072), a.offset(32);
      for (var s = [], l = [], c = 0; c < i.length; ++c) {
        var u = i[c], f = o.glyphFor(u), h = r.indexOf(f);
        h >= 0 ? s.push(h) : (s.push(r.length + l.length), l.push(f));
      }
      for (a.writeShort(i.length), c = 0; c < s.length; ++c)
        a.writeShort(s[c]);
      for (c = 0; c < l.length; ++c)
        a.writeByte(l[c].length), a.writeString(l[c]);
      return a.get();
    }, t;
  }(vt);
}(), Mu = function() {
  var r = function(n, i, o) {
    var a = this;
    a.platformID = n.readShort(), a.platformSpecificID = n.readShort(), a.offset = i + n.readLong(), n.saveExcursion(function() {
      var s;
      switch (n.offset(a.offset), a.format = n.readShort(), a.format) {
        case 0:
          a.length = n.readShort(), a.language = n.readShort();
          for (var l = 0; l < 256; ++l)
            o[l] = n.readByte();
          break;
        case 4:
          a.length = n.readShort(), a.language = n.readShort();
          var c = n.readShort() / 2;
          n.skip(6);
          var u = n.times(c, n.readShort);
          n.skip(2);
          var f = n.times(c, n.readShort), h = n.times(c, n.readShort_), d = n.times(c, n.readShort), p = (a.length + a.offset - n.offset()) / 2, m = n.times(p, n.readShort);
          for (l = 0; l < c; ++l) {
            var v = f[l], y = u[l];
            for (s = v; s <= y; ++s) {
              var b;
              if (d[l] === 0)
                b = s + h[l];
              else {
                var k = d[l] / 2 - (c - l) + (s - v);
                b = m[k] || 0, b !== 0 && (b += h[l]);
              }
              o[s] = b & 65535;
            }
          }
          break;
        case 6:
          a.length = n.readShort(), a.language = n.readShort(), s = n.readShort();
          for (var M = n.readShort(); M-- > 0; )
            o[s++] = n.readShort();
          break;
        case 12:
          n.readShort(), a.length = n.readLong(), a.language = n.readLong();
          for (var D = n.readLong(); D-- > 0; ) {
            s = n.readLong();
            for (var T = n.readLong(), z = n.readLong(); s <= T; )
              o[s++] = z++;
          }
          break;
        default:
          window.console && window.console.error("Unhandled CMAP format: " + a.format);
      }
    });
  };
  function e(t, n) {
    var i = Ns(t), o = [], a = [], s = null, l = null;
    function c(O) {
      return n[t[O]];
    }
    for (var u = 0; u < i.length; ++u) {
      var f = i[u], h = c(f), d = h - f;
      (s == null || d !== l) && (s && a.push(s), o.push(f), l = d), s = f;
    }
    s && a.push(s), a.push(65535), o.push(65535);
    var p = o.length, m = p * 2, v = 2 * Math.pow(2, Math.floor(Math.log(p) / Math.LN2)), y = Math.log(v / 2) / Math.LN2, b = m - v, k = [], M = [], D = [];
    for (u = 0; u < p; ++u) {
      var T = o[u], z = a[u];
      if (T == 65535) {
        k.push(0), M.push(0);
        break;
      }
      var _ = c(T);
      if (T - _ >= 32768) {
        k.push(0), M.push(2 * (D.length + p - u));
        for (var ee = T; ee <= z; ++ee)
          D.push(c(ee));
      } else
        k.push(_ - T), M.push(0);
    }
    var K = ye();
    return K.writeShort(3), K.writeShort(1), K.writeLong(12), K.writeShort(4), K.writeShort(16 + p * 8 + D.length * 2), K.writeShort(0), K.writeShort(m), K.writeShort(v), K.writeShort(y), K.writeShort(b), a.forEach(K.writeShort), K.writeShort(0), o.forEach(K.writeShort), k.forEach(K.writeShort_), M.forEach(K.writeShort), D.forEach(K.writeShort), K.get();
  }
  return function(t) {
    function n() {
      t.apply(this, arguments);
    }
    return t && (n.__proto__ = t), n.prototype = Object.create(t && t.prototype), n.prototype.constructor = n, n.prototype.parse = function(o) {
      var a = this, s = a.offset;
      o.offset(s), a.codeMap = {}, a.version = o.readShort();
      var l = o.readShort();
      a.tables = o.times(l, function() {
        return new r(o, s, a.codeMap);
      });
    }, n.render = function(o, a) {
      var s = ye();
      return s.writeShort(0), s.writeShort(1), s.write(e(o, a)), s.get();
    }, n;
  }(vt);
}(), sv = function(r) {
  function e() {
    r.apply(this, arguments);
  }
  return r && (e.__proto__ = r), e.prototype = Object.create(r && r.prototype), e.prototype.constructor = e, e.prototype.parse = function(n) {
    n.offset(this.offset), this.version = n.readShort(), this.averageCharWidth = n.readShort_(), this.weightClass = n.readShort(), this.widthClass = n.readShort(), this.type = n.readShort(), this.ySubscriptXSize = n.readShort_(), this.ySubscriptYSize = n.readShort_(), this.ySubscriptXOffset = n.readShort_(), this.ySubscriptYOffset = n.readShort_(), this.ySuperscriptXSize = n.readShort_(), this.ySuperscriptYSize = n.readShort_(), this.ySuperscriptXOffset = n.readShort_(), this.ySuperscriptYOffset = n.readShort_(), this.yStrikeoutSize = n.readShort_(), this.yStrikeoutPosition = n.readShort_(), this.familyClass = n.readShort_(), this.panose = n.times(10, n.readByte), this.charRange = n.times(4, n.readLong), this.vendorID = n.readString(4), this.selection = n.readShort(), this.firstCharIndex = n.readShort(), this.lastCharIndex = n.readShort(), this.version > 0 && (this.ascent = n.readShort_(), this.descent = n.readShort_(), this.lineGap = n.readShort_(), this.winAscent = n.readShort(), this.winDescent = n.readShort(), this.codePageRange = n.times(2, n.readLong), this.version > 1 && (this.xHeight = n.readShort(), this.capHeight = n.readShort(), this.defaultChar = n.readShort(), this.breakChar = n.readShort(), this.maxContext = n.readShort()));
  }, e.prototype.render = function() {
    return this.raw();
  }, e;
}(vt), Nl = 1e5;
function lv() {
  for (var r = "", e = String(Nl), t = 0; t < e.length; ++t)
    r += String.fromCharCode(e.charCodeAt(t) - 48 + 65);
  return ++Nl, r;
}
var Xn = function(e) {
  this.font = e, this.subset = {}, this.unicodes = {}, this.ogid2ngid = { 0: 0 }, this.ngid2ogid = { 0: 0 }, this.ncid2ogid = {}, this.next = this.firstChar = 1, this.nextGid = 1, this.psName = lv() + "+" + this.font.psName;
};
Xn.prototype.use = function(e) {
  var t = this;
  if (typeof e == "string")
    return Gg(e).reduce(function(a, s) {
      return a + String.fromCharCode(t.use(s));
    }, "");
  var n = t.unicodes[e];
  if (!n) {
    n = t.next++, t.subset[n] = e, t.unicodes[e] = n;
    var i = t.font.cmap.codeMap[e];
    if (i && (t.ncid2ogid[n] = i, t.ogid2ngid[i] == null)) {
      var o = t.nextGid++;
      t.ogid2ngid[i] = o, t.ngid2ogid[o] = i;
    }
  }
  return n;
};
Xn.prototype.encodeText = function(e) {
  return this.use(e);
};
Xn.prototype.glyphIds = function() {
  return Ns(this.ogid2ngid);
};
Xn.prototype.glyphsFor = function(e, t) {
  var n = this;
  t || (t = {});
  for (var i = 0; i < e.length; ++i) {
    var o = e[i];
    if (!t[o]) {
      var a = t[o] = n.font.glyf.glyphFor(o);
      a && a.compound && n.glyphsFor(a.glyphIds, t);
    }
  }
  return t;
};
Xn.prototype.render = function() {
  var e = this, t = this.glyphsFor(this.glyphIds());
  for (var n in t)
    if (Kr(t, n) && (n = parseInt(n, 10), e.ogid2ngid[n] == null)) {
      var i = e.nextGid++;
      e.ogid2ngid[n] = i, e.ngid2ogid[i] = n;
    }
  var o = Ns(this.ngid2ogid), a = o.map(function(f) {
    return this.ngid2ogid[f];
  }, this), s = this.font, l = s.glyf.render(t, a, this.ogid2ngid), c = s.loca.render(l.offsets);
  this.lastChar = this.next - 1;
  var u = {
    cmap: Mu.render(this.ncid2ogid, this.ogid2ngid),
    glyf: l.table,
    loca: c.table,
    hmtx: s.hmtx.render(a),
    hhea: s.hhea.render(a),
    maxp: s.maxp.render(a),
    post: s.post.render(a),
    name: s.name.render(this.psName),
    head: s.head.render(c.format),
    "OS/2": s.os2.render()
  };
  return this.font.directory.render(u);
};
Xn.prototype.cidToGidMap = function() {
  for (var e = this, t = ye(), n = 0, i = this.firstChar; i < this.next; ++i) {
    for (; n < i; )
      t.writeShort(0), n++;
    var o = e.ncid2ogid[i];
    if (o) {
      var a = e.ogid2ngid[o];
      t.writeShort(a);
    } else
      t.writeShort(0);
    n++;
  }
  return t.get();
};
var uo = function(e, t) {
  var n = this, i = n.contents = ye(e);
  if (i.readString(4) == "ttcf") {
    var o, a = function() {
      i.offset(o), n.parse();
    };
    if (!t)
      throw new Error("Must specify a name for TTC files");
    i.readLong();
    for (var s = i.readLong(), l = 0; l < s; ++l)
      if (o = i.readLong(), i.saveExcursion(a), n.psName == t)
        return;
    throw new Error("Font " + t + " not found in collection");
  } else
    i.offset(0), n.parse();
};
uo.prototype.parse = function() {
  var e = this.directory = new co(this.contents);
  this.head = e.readTable("head", Qg), this.loca = e.readTable("loca", ev), this.hhea = e.readTable("hhea", tv), this.maxp = e.readTable("maxp", nv), this.hmtx = e.readTable("hmtx", rv), this.glyf = e.readTable("glyf", iv), this.name = e.readTable("name", ov), this.post = e.readTable("post", av), this.cmap = e.readTable("cmap", Mu), this.os2 = e.readTable("OS/2", sv), this.psName = this.name.postscriptName, this.ascent = this.os2.ascent || this.hhea.ascent, this.descent = this.os2.descent || this.hhea.descent, this.lineGap = this.os2.lineGap || this.hhea.lineGap, this.scale = 1e3 / this.head.unitsPerEm;
};
uo.prototype.widthOfGlyph = function(e) {
  return this.hmtx.forGlyph(e).advance * this.scale;
};
uo.prototype.makeSubset = function() {
  return new Xn(this);
};
var cv = xg;
function uv() {
  return !0;
}
var ba = zr.browser, Q = `
`, Yn = 0, Rl = {
  a0: [2383.94, 3370.39],
  a1: [1683.78, 2383.94],
  a2: [1190.55, 1683.78],
  a3: [841.89, 1190.55],
  a4: [595.28, 841.89],
  a5: [419.53, 595.28],
  a6: [297.64, 419.53],
  a7: [209.76, 297.64],
  a8: [147.4, 209.76],
  a9: [104.88, 147.4],
  a10: [73.7, 104.88],
  b0: [2834.65, 4008.19],
  b1: [2004.09, 2834.65],
  b2: [1417.32, 2004.09],
  b3: [1000.63, 1417.32],
  b4: [708.66, 1000.63],
  b5: [498.9, 708.66],
  b6: [354.33, 498.9],
  b7: [249.45, 354.33],
  b8: [175.75, 249.45],
  b9: [124.72, 175.75],
  b10: [87.87, 124.72],
  c0: [2599.37, 3676.54],
  c1: [1836.85, 2599.37],
  c2: [1298.27, 1836.85],
  c3: [918.43, 1298.27],
  c4: [649.13, 918.43],
  c5: [459.21, 649.13],
  c6: [323.15, 459.21],
  c7: [229.61, 323.15],
  c8: [161.57, 229.61],
  c9: [113.39, 161.57],
  c10: [79.37, 113.39],
  executive: [521.86, 756],
  folio: [612, 936],
  legal: [612, 1008],
  letter: [612, 792],
  tabloid: [792, 1224]
};
function Sa() {
  var r = 0, e = ye();
  function t() {
    for (var n = arguments, i = 0; i < arguments.length; ++i) {
      var o = n[i];
      if (o === void 0)
        throw new Error("Cannot output undefined to PDF");
      if (o instanceof Qn)
        o.beforeRender(t), o.render(t);
      else if (Au(o))
        yv(o, t);
      else if (vv(o))
        wv(o, t);
      else if (typeof o == "number") {
        if (isNaN(o))
          throw new Error("Cannot output NaN to PDF");
        var a = o.toFixed(7);
        a.indexOf(".") >= 0 && (a = a.replace(/\.?0+$/, "")), a == "-0" && (a = "0"), e.writeString(a);
      } else
        /string|boolean/.test(typeof o) ? e.writeString(String(o)) : typeof o.get == "function" ? e.write(o.get()) : typeof o == "object" && (o ? t(new Le(o)) : e.writeString("null"));
    }
  }
  return t.writeData = function(n) {
    e.write(n);
  }, t.withIndent = function(n) {
    ++r, n(t), --r;
  }, t.indent = function() {
    t(Q, Eu("", r * 2, "  ")), t.apply(null, arguments);
  }, t.offset = function() {
    return e.offset();
  }, t.toString = function() {
    throw new Error("FIX CALLER");
  }, t.get = function() {
    return e.get();
  }, t.stream = function() {
    return e;
  }, t;
}
function fv(r, e) {
  var t = r.beforeRender, n = r.render;
  r.beforeRender = function() {
  }, r.render = function(i) {
    i(e, " 0 R");
  }, r.renderFull = function(i) {
    r._offset = i.offset(), i(e, " 0 obj "), t.call(r, i), n.call(r, i), i(" endobj");
  };
}
function _u(r) {
  if (typeof r != "function") {
    var e = r;
    r = function(i, o) {
      return i in e ? e[i] : o;
    };
  }
  var t = r("paperSize", Rl.a4);
  if (!t)
    return {};
  if (typeof t == "string" && (t = Rl[t.toLowerCase()], t == null))
    throw new Error("Unknown paper size");
  t[0] = In(t[0]), t[1] = In(t[1]), r("landscape", !1) && (t = [
    Math.max(t[0], t[1]),
    Math.min(t[0], t[1])
  ]);
  var n = r("margin");
  return n && (typeof n == "string" || typeof n == "number" ? (n = In(n, 0), n = { left: n, top: n, right: n, bottom: n }) : n = {
    left: In(n.left, 0),
    top: In(n.top, 0),
    right: In(n.right, 0),
    bottom: In(n.bottom, 0)
  }, r("addMargin") && (t[0] += n.left + n.right, t[1] += n.top + n.bottom)), { paperSize: t, margin: n };
}
var Ca = {
  "Times-Roman": !0,
  "Times-Bold": !0,
  "Times-Italic": !0,
  "Times-BoldItalic": !0,
  Helvetica: !0,
  "Helvetica-Bold": !0,
  "Helvetica-Oblique": !0,
  "Helvetica-BoldOblique": !0,
  Courier: !0,
  "Courier-Bold": !0,
  "Courier-Oblique": !0,
  "Courier-BoldOblique": !0,
  Symbol: !0,
  ZapfDingbats: !0
};
function hv(r, e) {
  var t;
  if (ba.msie && (t = /^data:.*?;base64,/i.exec(r))) {
    e(Zg(r.substr(t[0].length)));
    return;
  }
  function n() {
    window.console && (window.console.error ? window.console.error("Cannot load URL: %s", r) : window.console.log("Cannot load URL: %s", r)), e(null);
  }
  var i = new XMLHttpRequest();
  i.open("GET", r, !0), fn && (i.responseType = "arraybuffer"), i.onload = function() {
    i.status == 200 || i.status == 304 ? e(fn ? new Uint8Array(i.response) : new window.VBArray(i.responseBody).toArray()) : n();
  }, i.onerror = n, i.send(null);
}
function dv(r, e) {
  var t = Ca[r];
  t ? e(t) : hv(r, function(n) {
    if (n == null)
      throw new Error("Cannot load font from " + r);
    var i = new uo(n);
    Ca[r] = i, e(i);
  });
}
var or = {};
function pv() {
  or = {};
}
function mv(r, e, t, n) {
  var i = or[r], o, a;
  if (i)
    t(i);
  else if (i = new Image(), /^data:/i.test(r) || (i.crossOrigin = "Anonymous"), fn && !/^data:/i.test(r)) {
    var s = new XMLHttpRequest();
    s.onload = function() {
      if (a = s.response, ba.mozilla && a.type == "image/svg+xml") {
        var h = new FileReader();
        h.onload = function() {
          var d = new window.DOMParser().parseFromString(this.result, "image/svg+xml"), p = d.documentElement;
          if (p.getAttribute("width") && p.getAttribute("height"))
            o = URL.createObjectURL(a), l(o);
          else {
            p.setAttribute("width", e.width), p.setAttribute("height", e.height);
            var m = new window.XMLSerializer().serializeToString(p), v = "data:image/svg+xml;base64," + xu(m);
            l(v);
          }
        }, h.readAsText(a);
      } else
        o = URL.createObjectURL(a), l(o);
    }, s.onerror = u, s.open("GET", r, !0), s.responseType = "blob", s.send();
  } else
    l(r);
  function l(h) {
    i.src = h, i.complete && !ba.msie ? f.call(i) : (i.onload = f, i.onerror = u);
  }
  function c() {
    e || (e = { width: i.width, height: i.height });
    var h = document.createElement("canvas");
    h.width = e.width, h.height = e.height;
    var d = h.getContext("2d");
    d.drawImage(i, 0, 0, e.width, e.height);
    var p;
    try {
      p = d.getImageData(0, 0, e.width, e.height);
    } catch {
      u();
      return;
    } finally {
      o && URL.revokeObjectURL(o);
    }
    for (var m = !1, v = ye(), y = ye(), b = p.data, k = 0; k < b.length; ) {
      v.writeByte(b[k++]), v.writeByte(b[k++]), v.writeByte(b[k++]);
      var M = b[k++];
      M < 255 && (m = !0), y.writeByte(M);
    }
    if (m || n.keepPNG)
      i = new Mv(e.width, e.height, v, y);
    else {
      var D = h.toDataURL("image/jpeg", n.jpegQuality);
      D = D.substr(D.indexOf(";base64,") + 8);
      var T = ye();
      T.writeBase64(D), i = new Pl(T);
    }
    t(or[r] = i);
  }
  function u() {
    t(or[r] = "ERROR");
  }
  function f() {
    if (e) {
      var h = a && a.type === "image/svg+xml" || /^data:image\/svg\+xml;/i.test(this.src.substring(0, 19)), d = e.width >= i.width || e.height >= i.height;
      !h && d && (e = null);
    }
    if (!e && a && /^image\/jpe?g$/i.test(a.type)) {
      var p = new FileReader();
      p.onload = function() {
        try {
          var m = new Pl(ye(new Uint8Array(this.result)));
          URL.revokeObjectURL(o), t(or[r] = m);
        } catch {
          c();
        }
      }, p.readAsArrayBuffer(a);
    } else
      c();
  }
}
function gv(r) {
  return function(e, t) {
    var n = e.length, i = n;
    if (n === 0)
      return t();
    function o() {
      --n === 0 && t();
    }
    for (; i-- > 0; )
      r(e[i], o);
  };
}
var Iu = gv(dv), Du = function(r, e, t) {
  t = Object.assign({
    jpegQuality: 0.92,
    keepPNG: !1
  }, t);
  var n = Object.keys(r), i = n.length;
  if (i === 0)
    return e();
  function o() {
    --i === 0 && e();
  }
  n.forEach(function(a) {
    mv(a, r[a], o, t);
  });
}, Zn = function(e) {
  var t = this, n = Sa(), i = 0, o = [];
  function a(f, h) {
    return e && e[f] != null ? e[f] : h;
  }
  t.getOption = a, t.attach = function(f) {
    return o.indexOf(f) < 0 && (fv(f, ++i), o.push(f)), f;
  }, t.pages = [], t.FONTS = {}, t.IMAGES = {}, t.GRAD_COL_FUNCTIONS = {}, t.GRAD_OPC_FUNCTIONS = {}, t.GRAD_COL = {}, t.GRAD_OPC = {};
  var s = t.attach(new xv()), l = t.attach(new Ov());
  if (a("autoPrint")) {
    var c = {};
    c.JavaScript = new Le({ Names: [
      new ot("JS"),
      t.attach(new Le({
        S: J("JavaScript"),
        JS: new ot("print(true);")
      }))
    ] }), s.props.Names = new Le(c);
  }
  s.setPages(l);
  var u = t.attach(new Le({
    Producer: new ot(a("producer", "Kendo UI PDF Generator"), !0),
    // XXX: kendo.version?
    Title: new ot(a("title", ""), !0),
    Author: new ot(a("author", ""), !0),
    Subject: new ot(a("subject", ""), !0),
    Keywords: new ot(a("keywords", ""), !0),
    Creator: new ot(a("creator", "Kendo UI PDF Generator"), !0),
    CreationDate: a("date", /* @__PURE__ */ new Date())
  }));
  t.addPage = function(f) {
    var h = _u(function(M, D) {
      return f && f[M] != null ? f[M] : D;
    }), d = h.paperSize, p = h.margin, m = d[0], v = d[1];
    p && (m -= p.left + p.right, v -= p.top + p.bottom);
    var y = new Zt(Sa(), null, !0), b = {
      Contents: t.attach(y),
      Parent: l,
      MediaBox: [0, 0, d[0], d[1]]
    }, k = new Lv(t, b);
    return k._content = y, l.addPage(t.attach(k)), k.transform(1, 0, 0, -1, 0, d[1]), p && (k.translate(p.left, p.top), k.rect(0, 0, m, v), k.clip()), t.pages.push(k), k;
  }, t.render = function() {
    var f;
    for (n("%PDF-1.4", Q, "%ÂÁÚÏÎ", Q, Q), f = 0; f < o.length; ++f)
      o[f].renderFull(n), n(Q, Q);
    var h = n.offset();
    for (n("xref", Q, 0, " ", o.length + 1, Q), n("0000000000 65535 f ", Q), f = 0; f < o.length; ++f)
      n(Tt(o[f]._offset, 10), " 00000 n ", Q);
    return n(Q), n("trailer", Q), n(new Le({
      Size: o.length + 1,
      Root: s,
      Info: u
    }), Q, Q), n("startxref", Q, h, Q), n("%%EOF", Q), n.stream().offset(0);
  }, t.loadFonts = Iu, t.loadImages = Du;
};
Zn.prototype.getFont = function(e) {
  var t = this.FONTS[e];
  if (!t) {
    if (t = Ca[e], !t)
      throw new Error("Font " + e + " has not been loaded");
    t === !0 ? t = this.attach(new _v(e)) : t = this.attach(new ka(this, t)), this.FONTS[e] = t;
  }
  return t;
};
Zn.prototype.getImage = function(e) {
  var t = this.IMAGES[e];
  if (!t) {
    if (t = or[e], !t)
      throw new Error("Image " + e + " has not been loaded");
    if (t === "ERROR")
      return null;
    t = this.IMAGES[e] = this.attach(t.asStream(this));
  }
  return t;
};
Zn.prototype.getOpacityGS = function(e, t) {
  var n = parseFloat(e).toFixed(3);
  e = parseFloat(n), n += t ? "S" : "F";
  var i = this._opacityGSCache || (this._opacityGSCache = {}), o = i[n];
  if (!o) {
    var a = {
      Type: J("ExtGState")
    };
    t ? a.CA = e : a.ca = e, o = this.attach(new Le(a)), o._resourceName = J("GS" + ++Yn), i[n] = o;
  }
  return o;
};
Zn.prototype.dict = function(e) {
  return new Le(e);
};
Zn.prototype.name = function(e) {
  return J(e);
};
Zn.prototype.stream = function(e, t) {
  return new Zt(t, e);
};
function Eu(r, e, t) {
  for (; r.length < e; )
    r = t + r;
  return r;
}
function Tt(r, e) {
  return Eu(String(r), e, "0");
}
function Rs(r, e) {
  return Object.prototype.hasOwnProperty.call(r, e);
}
var Au = Array.isArray || function(r) {
  return r instanceof Array;
};
function vv(r) {
  return r instanceof Date;
}
function yv(r, e) {
  e("["), r.length > 0 && e.withIndent(function() {
    for (var t = 0; t < r.length; ++t)
      t > 0 && t % 8 === 0 ? e.indent(r[t]) : e(" ", r[t]);
  }), e(" ]");
}
function wv(r, e) {
  e(
    "(D:",
    Tt(r.getUTCFullYear(), 4),
    Tt(r.getUTCMonth() + 1, 2),
    Tt(r.getUTCDate(), 2),
    Tt(r.getUTCHours(), 2),
    Tt(r.getUTCMinutes(), 2),
    Tt(r.getUTCSeconds(), 2),
    "Z)"
  );
}
function Nu(r) {
  return r * (72 / 25.4);
}
function bv(r) {
  return Nu(r * 10);
}
function Sv(r) {
  return r * 72;
}
function In(r, e) {
  if (typeof r == "number")
    return r;
  if (typeof r == "string") {
    var t;
    if (t = /^\s*([0-9.]+)\s*(mm|cm|in|pt)\s*$/.exec(r), t) {
      var n = parseFloat(t[1]);
      if (!isNaN(n))
        return t[2] == "pt" ? n : {
          mm: Nu,
          cm: bv,
          in: Sv
        }[t[2]](n);
    }
  }
  if (e != null)
    return e;
  throw new Error("Can't parse unit: " + r);
}
var Qn = function() {
};
Qn.prototype.beforeRender = function() {
};
var ot = function(r) {
  function e(t, n) {
    r.call(this), this.value = t, this.utf16be = !!n;
  }
  return r && (e.__proto__ = r), e.prototype = Object.create(r && r.prototype), e.prototype.constructor = e, e.prototype.render = function(n) {
    var i = this.value;
    if (this.utf16be)
      i = Tg + Mg(i), i = i.replace(/([\(\)\\])/g, "\\$1"), n("(", i, ")");
    else {
      for (var o = [40], a = 0; a < i.length; ++a) {
        var s = i.charCodeAt(a) & 255;
        (s == 40 || s == 41 || s == 92) && o.push(92), o.push(s);
      }
      o.push(41), n.writeData(o);
    }
  }, e.prototype.toString = function() {
    return this.value;
  }, e;
}(Qn), Cv = function(r) {
  function e(t) {
    r.call(this, t), this.value = t;
  }
  return r && (e.__proto__ = r), e.prototype = Object.create(r && r.prototype), e.prototype.constructor = e, e.prototype.render = function(n) {
    var i = this;
    n("<");
    for (var o = 0; o < this.value.length; ++o)
      n(Tt(i.value.charCodeAt(o).toString(16), 4));
    n(">");
  }, e;
}(ot), kv = function(r) {
  function e(t) {
    r.call(this), this.name = t;
  }
  return r && (e.__proto__ = r), e.prototype = Object.create(r && r.prototype), e.prototype.constructor = e, e.get = function(n) {
    return J(n);
  }, e.prototype.render = function(n) {
    n("/" + this.escape());
  }, e.prototype.escape = function() {
    return this.name.replace(/[^\x21-\x7E]/g, function(n) {
      return "#" + Tt(n.charCodeAt(0).toString(16), 2);
    });
  }, e.prototype.toString = function() {
    return this.name;
  }, e;
}(Qn), Lo = {};
function J(r) {
  return Rs(Lo, r) ? Lo[r] : Lo[r] = new kv(r);
}
var Le = function(r) {
  function e(t) {
    r.call(this), this.props = t;
  }
  return r && (e.__proto__ = r), e.prototype = Object.create(r && r.prototype), e.prototype.constructor = e, e.prototype.render = function(n) {
    var i = this.props, o = !0;
    n("<<"), n.withIndent(function() {
      for (var a in i)
        Rs(i, a) && !/^_/.test(a) && (o = !1, n.indent(J(a), " ", i[a]));
    }), o || n.indent(), n(">>");
  }, e;
}(Qn), Zt = function(r) {
  function e(t, n, i) {
    if (r.call(this), typeof t == "string") {
      var o = ye();
      o.write(t), t = o;
    }
    this.data = t, this.props = n || {}, this.compress = i;
  }
  return r && (e.__proto__ = r), e.prototype = Object.create(r && r.prototype), e.prototype.constructor = e, e.prototype.render = function(n) {
    var i = this.data.get(), o = this.props;
    this.compress && uv() && (o.Filter ? o.Filter instanceof Array || (o.Filter = [o.Filter]) : o.Filter = [], o.Filter.unshift(J("FlateDecode")), i = cv(i)), o.Length = i.length, n(new Le(o), " stream", Q), n.writeData(i), n(Q, "endstream");
  }, e;
}(Qn), xv = function(r) {
  function e() {
    r.call(this, {
      Type: J("Catalog")
    });
  }
  return r && (e.__proto__ = r), e.prototype = Object.create(r && r.prototype), e.prototype.constructor = e, e.prototype.setPages = function(n) {
    this.props.Pages = n;
  }, e;
}(Le), Ov = function(r) {
  function e() {
    r.call(this, {
      Type: J("Pages"),
      Kids: [],
      Count: 0
    });
  }
  return r && (e.__proto__ = r), e.prototype = Object.create(r && r.prototype), e.prototype.constructor = e, e.prototype.addPage = function(n) {
    this.props.Kids.push(n), this.props.Count++;
  }, e;
}(Le), Tv = [192, 193, 194, 195, 197, 198, 199, 201, 202, 203, 205, 206, 207], Pl = function(e) {
  e.offset(0);
  var t, n, i, o, a = e.readShort();
  if (a != 65496)
    throw new Error("Invalid JPEG image");
  for (; !e.eof(); ) {
    var s = e.readByte();
    if (s != 255)
      throw new Error("Invalid JPEG image");
    var l = e.readByte(), c = e.readShort();
    if (Tv.indexOf(l) >= 0) {
      o = e.readByte(), n = e.readShort(), t = e.readShort(), i = e.readByte();
      break;
    }
    e.skip(c - 2);
  }
  if (i == null)
    throw new Error("Invalid JPEG image");
  var u = {
    Type: J("XObject"),
    Subtype: J("Image"),
    Width: t,
    Height: n,
    BitsPerComponent: o,
    Filter: J("DCTDecode")
  };
  switch (i) {
    case 1:
      u.ColorSpace = J("DeviceGray");
      break;
    case 3:
      u.ColorSpace = J("DeviceRGB");
      break;
    case 4:
      u.ColorSpace = J("DeviceCMYK"), u.Decode = [1, 0, 1, 0, 1, 0, 1, 0];
      break;
  }
  this.asStream = function() {
    e.offset(0);
    var f = new Zt(e, u);
    return f._resourceName = J("I" + ++Yn), f;
  };
}, Mv = function(e, t, n, i) {
  this.asStream = function(o) {
    var a = new Zt(i, {
      Type: J("XObject"),
      Subtype: J("Image"),
      Width: e,
      Height: t,
      BitsPerComponent: 8,
      ColorSpace: J("DeviceGray")
    }, !0), s = new Zt(n, {
      Type: J("XObject"),
      Subtype: J("Image"),
      Width: e,
      Height: t,
      BitsPerComponent: 8,
      ColorSpace: J("DeviceRGB"),
      SMask: o.attach(a)
    }, !0);
    return s._resourceName = J("I" + ++Yn), s;
  };
}, _v = function(r) {
  function e(t) {
    r.call(this, {
      Type: J("Font"),
      Subtype: J("Type1"),
      BaseFont: J(t)
    }), this._resourceName = J("F" + ++Yn);
  }
  return r && (e.__proto__ = r), e.prototype = Object.create(r && r.prototype), e.prototype.constructor = e, e.prototype.encodeText = function(n) {
    return new ot(String(n));
  }, e;
}(Le), ka = function(r) {
  function e(t, n, i) {
    r.call(this, {}), i = this.props, i.Type = J("Font"), i.Subtype = J("Type0"), i.Encoding = J("Identity-H"), this._pdf = t, this._font = n, this._sub = n.makeSubset(), this._resourceName = J("F" + ++Yn);
    var o = n.head;
    this.name = n.psName;
    var a = this.scale = n.scale;
    this.bbox = [
      o.xMin * a,
      o.yMin * a,
      o.xMax * a,
      o.yMax * a
    ], this.italicAngle = n.post.italicAngle, this.ascent = n.ascent * a, this.descent = n.descent * a, this.lineGap = n.lineGap * a, this.capHeight = n.os2.capHeight || this.ascent, this.xHeight = n.os2.xHeight || 0, this.stemV = 0, this.familyClass = (n.os2.familyClass || 0) >> 8, this.isSerif = this.familyClass >= 1 && this.familyClass <= 7, this.isScript = this.familyClass == 10, this.flags = (n.post.isFixedPitch ? 1 : 0) | (this.isSerif ? 2 : 0) | (this.isScript ? 8 : 0) | (this.italicAngle !== 0 ? 64 : 0) | 32;
  }
  return r && (e.__proto__ = r), e.prototype = Object.create(r && r.prototype), e.prototype.constructor = e, e.prototype.encodeText = function(n) {
    return new Cv(this._sub.encodeText(String(n)));
  }, e.prototype.getTextWidth = function(n, i) {
    for (var o = this, a = 0, s = this._font.cmap.codeMap, l = 0; l < i.length; ++l) {
      var c = s[i.charCodeAt(l)];
      a += o._font.widthOfGlyph(c || 0);
    }
    return a * n / 1e3;
  }, e.prototype.beforeRender = function() {
    var n = this, i = n._sub, o = i.render(), a = new Zt(ye(o), {
      Length1: o.length
    }, !0), s = n._pdf.attach(new r({
      Type: J("FontDescriptor"),
      FontName: J(n._sub.psName),
      FontBBox: n.bbox,
      Flags: n.flags,
      StemV: n.stemV,
      ItalicAngle: n.italicAngle,
      Ascent: n.ascent,
      Descent: n.descent,
      CapHeight: n.capHeight,
      XHeight: n.xHeight,
      FontFile2: n._pdf.attach(a)
    })), l = i.ncid2ogid, c = i.firstChar, u = i.lastChar, f = [];
    (function v(y, b) {
      if (y <= u) {
        var k = l[y];
        k == null ? v(y + 1) : (b || f.push(y, b = []), b.push(n._font.widthOfGlyph(k)), v(y + 1, b));
      }
    })(c);
    var h = new r({
      Type: J("Font"),
      Subtype: J("CIDFontType2"),
      BaseFont: J(n._sub.psName),
      CIDSystemInfo: new r({
        Registry: new ot("Adobe"),
        Ordering: new ot("Identity"),
        Supplement: 0
      }),
      FontDescriptor: s,
      FirstChar: c,
      LastChar: u,
      DW: Math.round(n._font.widthOfGlyph(0)),
      W: f,
      CIDToGIDMap: n._pdf.attach(n._makeCidToGidMap())
    }), d = n.props;
    d.BaseFont = J(n._sub.psName), d.DescendantFonts = [n._pdf.attach(h)];
    var p = new Iv(c, u, i.subset), m = new Zt(Sa(), null, !0);
    m.data(p), d.ToUnicode = n._pdf.attach(m);
  }, e.prototype._makeCidToGidMap = function() {
    return new Zt(ye(this._sub.cidToGidMap()), null, !0);
  }, e;
}(Le), Iv = function(r) {
  function e(t, n, i) {
    r.call(this), this.firstChar = t, this.lastChar = n, this.map = i;
  }
  return r && (e.__proto__ = r), e.prototype = Object.create(r && r.prototype), e.prototype.constructor = e, e.prototype.render = function(n) {
    n.indent("/CIDInit /ProcSet findresource begin"), n.indent("12 dict begin"), n.indent("begincmap"), n.indent("/CIDSystemInfo <<"), n.indent("  /Registry (Adobe)"), n.indent("  /Ordering (UCS)"), n.indent("  /Supplement 0"), n.indent(">> def"), n.indent("/CMapName /Adobe-Identity-UCS def"), n.indent("/CMapType 2 def"), n.indent("1 begincodespacerange"), n.indent("  <0000><ffff>"), n.indent("endcodespacerange");
    var i = this;
    n.indent(i.lastChar - i.firstChar + 1, " beginbfchar"), n.withIndent(function() {
      for (var o = i.firstChar; o <= i.lastChar; ++o) {
        var a = i.map[o], s = Jg([a]);
        n.indent("<", Tt(o.toString(16), 4), ">", "<");
        for (var l = 0; l < s.length; ++l)
          n(Tt(s.charCodeAt(l).toString(16), 4));
        n(">");
      }
    }), n.indent("endbfchar"), n.indent("endcmap"), n.indent("CMapName currentdict /CMap defineresource pop"), n.indent("end"), n.indent("end");
  }, e;
}(Qn);
function ii(r) {
  return r.map(function(e) {
    return Au(e) ? ii(e) : typeof e == "number" ? (Math.round(e * 1e3) / 1e3).toFixed(3) : e;
  }).join(" ");
}
function Dv(r, e, t, n, i, o, a) {
  var s = ii([e, t, n, i, o, a]), l = r.GRAD_COL_FUNCTIONS[s];
  return l || (l = r.GRAD_COL_FUNCTIONS[s] = r.attach(new Le({
    FunctionType: 2,
    Domain: [0, 1],
    Range: [0, 1, 0, 1, 0, 1],
    N: 1,
    C0: [e, t, n],
    C1: [i, o, a]
  }))), l;
}
function Ev(r, e, t) {
  var n = ii([e, t]), i = r.GRAD_OPC_FUNCTIONS[n];
  return i || (i = r.GRAD_OPC_FUNCTIONS[n] = r.attach(new Le({
    FunctionType: 2,
    Domain: [0, 1],
    Range: [0, 1],
    N: 1,
    C0: [e],
    C1: [t]
  }))), i;
}
function Av(r, e) {
  var t = !1, n = [], i = [], o = [], a = [], s, l, c, u, f;
  for (s = 1; s < e.length; ++s)
    l = e[s - 1], c = e[s], u = l.color, f = c.color, i.push(Dv(
      r,
      u.r,
      u.g,
      u.b,
      f.r,
      f.g,
      f.b
    )), (u.a < 1 || f.a < 1) && (t = !0), o.push(c.offset), a.push(0, 1);
  if (t)
    for (s = 1; s < e.length; ++s)
      l = e[s - 1], c = e[s], u = l.color, f = c.color, n.push(Ev(
        r,
        u.a,
        f.a
      ));
  return o.pop(), {
    hasAlpha: t,
    colors: h(i),
    opacities: t ? h(n) : null
  };
  function h(d) {
    return d.length == 1 ? d[0] : {
      FunctionType: 3,
      Functions: d,
      Domain: [0, 1],
      Bounds: o,
      Encode: a
    };
  }
}
function Nv(r, e, t, n, i, o) {
  var a, s;
  if (!o) {
    var l = [e].concat(n);
    t.forEach(function(c) {
      l.push(c.offset, c.color.r, c.color.g, c.color.b);
    }), s = ii(l), a = r.GRAD_COL[s];
  }
  return a || (a = new Le({
    Type: J("Shading"),
    ShadingType: e ? 3 : 2,
    ColorSpace: J("DeviceRGB"),
    Coords: n,
    Domain: [0, 1],
    Function: i,
    Extend: [!0, !0]
  }), r.attach(a), a._resourceName = "S" + ++Yn, s && (r.GRAD_COL[s] = a)), a;
}
function Rv(r, e, t, n, i, o) {
  var a, s;
  if (!o) {
    var l = [e].concat(n);
    t.forEach(function(c) {
      l.push(c.offset, c.color.a);
    }), s = ii(l), a = r.GRAD_OPC[s];
  }
  return a || (a = new Le({
    Type: J("ExtGState"),
    AIS: !1,
    CA: 1,
    ca: 1,
    SMask: {
      Type: J("Mask"),
      S: J("Luminosity"),
      G: r.attach(new Zt("/a0 gs /s0 sh", {
        Type: J("XObject"),
        Subtype: J("Form"),
        FormType: 1,
        BBox: o ? [
          o.left,
          o.top + o.height,
          o.left + o.width,
          o.top
        ] : [0, 1, 1, 0],
        Group: {
          Type: J("Group"),
          S: J("Transparency"),
          CS: J("DeviceGray"),
          I: !0
        },
        Resources: {
          ExtGState: {
            a0: { CA: 1, ca: 1 }
          },
          Shading: {
            s0: {
              ColorSpace: J("DeviceGray"),
              Coords: n,
              Domain: [0, 1],
              ShadingType: e ? 3 : 2,
              Function: i,
              Extend: [!0, !0]
            }
          }
        }
      }))
    }
  }), r.attach(a), a._resourceName = "O" + ++Yn, s && (r.GRAD_OPC[s] = a)), a;
}
function Pv(r, e, t) {
  var n = e.type == "radial", i = Av(r, e.stops), o = n ? [
    e.start.x,
    e.start.y,
    e.start.r,
    e.end.x,
    e.end.y,
    e.end.r
  ] : [
    e.start.x,
    e.start.y,
    e.end.x,
    e.end.y
  ], a = Nv(
    r,
    n,
    e.stops,
    o,
    i.colors,
    e.userSpace && t
  ), s = i.hasAlpha ? Rv(
    r,
    n,
    e.stops,
    o,
    i.opacities,
    e.userSpace && t
  ) : null;
  return {
    hasAlpha: i.hasAlpha,
    shading: a,
    opacity: s
  };
}
var Lv = function(r) {
  function e(t, n) {
    r.call(this, n), this._pdf = t, this._rcount = 0, this._textMode = !1, this._fontResources = {}, this._gsResources = {}, this._xResources = {}, this._patResources = {}, this._shResources = {}, this._opacity = 1, this._matrix = [1, 0, 0, 1, 0, 0], this._annotations = [], this._font = null, this._fontSize = null, this._contextStack = [], n = this.props, n.Type = J("Page"), n.ProcSet = [
      J("PDF"),
      J("Text"),
      J("ImageB"),
      J("ImageC"),
      J("ImageI")
    ], n.Resources = new r({
      Font: new r(this._fontResources),
      ExtGState: new r(this._gsResources),
      XObject: new r(this._xResources),
      Pattern: new r(this._patResources),
      Shading: new r(this._shResources)
    }), n.Annots = this._annotations;
  }
  return r && (e.__proto__ = r), e.prototype = Object.create(r && r.prototype), e.prototype.constructor = e, e.prototype._out = function() {
    this._content.data.apply(null, arguments);
  }, e.prototype.transform = function(n, i, o, a, s, l) {
    Bv(arguments) || (this._matrix = zv(arguments, this._matrix), this._out(n, " ", i, " ", o, " ", a, " ", s, " ", l, " cm"), this._out(Q));
  }, e.prototype.translate = function(n, i) {
    this.transform(1, 0, 0, 1, n, i);
  }, e.prototype.scale = function(n, i) {
    this.transform(n, 0, 0, i, 0, 0);
  }, e.prototype.rotate = function(n) {
    var i = Math.cos(n), o = Math.sin(n);
    this.transform(i, o, -o, i, 0, 0);
  }, e.prototype.beginText = function() {
    this._textMode = !0, this._out("BT", Q);
  }, e.prototype.endText = function() {
    this._textMode = !1, this._out("ET", Q);
  }, e.prototype._requireTextMode = function() {
    if (!this._textMode)
      throw new Error("Text mode required; call page.beginText() first");
  }, e.prototype._requireFont = function() {
    if (!this._font)
      throw new Error("No font selected; call page.setFont() first");
  }, e.prototype.setFont = function(n, i) {
    this._requireTextMode(), n == null ? n = this._font : n instanceof ka || (n = this._pdf.getFont(n)), i == null && (i = this._fontSize), this._fontResources[n._resourceName] = n, this._font = n, this._fontSize = i, this._out(n._resourceName, " ", i, " Tf", Q);
  }, e.prototype.setTextLeading = function(n) {
    this._requireTextMode(), this._out(n, " TL", Q);
  }, e.prototype.setTextRenderingMode = function(n) {
    this._requireTextMode(), this._out(n, " Tr", Q);
  }, e.prototype.showText = function(n, i) {
    if (this._requireFont(), n.length > 1 && i && this._font instanceof ka) {
      var o = this._font.getTextWidth(this._fontSize, n), a = i / o * 100;
      this._out(a, " Tz ");
    }
    this._out(this._font.encodeText(n), " Tj", Q);
  }, e.prototype.showTextNL = function(n) {
    this._requireFont(), this._out(this._font.encodeText(n), " '", Q);
  }, e.prototype.addLink = function(n, i) {
    var o = this._toPage({ x: i.left, y: i.bottom }), a = this._toPage({ x: i.right, y: i.top });
    this._annotations.push(new r({
      Type: J("Annot"),
      Subtype: J("Link"),
      Rect: [o.x, o.y, a.x, a.y],
      Border: [0, 0, 0],
      A: new r({
        Type: J("Action"),
        S: J("URI"),
        URI: new ot(n)
      })
    }));
  }, e.prototype.setStrokeColor = function(n, i, o) {
    this._out(n, " ", i, " ", o, " RG", Q);
  }, e.prototype.setOpacity = function(n) {
    this.setFillOpacity(n), this.setStrokeOpacity(n), this._opacity *= n;
  }, e.prototype.setStrokeOpacity = function(n) {
    if (n < 1) {
      var i = this._pdf.getOpacityGS(this._opacity * n, !0);
      this._gsResources[i._resourceName] = i, this._out(i._resourceName, " gs", Q);
    }
  }, e.prototype.setFillColor = function(n, i, o) {
    this._out(n, " ", i, " ", o, " rg", Q);
  }, e.prototype.setFillOpacity = function(n) {
    if (n < 1) {
      var i = this._pdf.getOpacityGS(this._opacity * n, !1);
      this._gsResources[i._resourceName] = i, this._out(i._resourceName, " gs", Q);
    }
  }, e.prototype.gradient = function(n, i) {
    this.save(), this.rect(i.left, i.top, i.width, i.height), this.clip(), n.userSpace || this.transform(i.width, 0, 0, i.height, i.left, i.top);
    var o = Pv(this._pdf, n, i), a = o.shading._resourceName, s;
    this._shResources[a] = o.shading, o.hasAlpha && (s = o.opacity._resourceName, this._gsResources[s] = o.opacity, this._out("/" + s + " gs ")), this._out("/" + a + " sh", Q), this.restore();
  }, e.prototype.setDashPattern = function(n, i) {
    this._out(n, " ", i, " d", Q);
  }, e.prototype.setLineWidth = function(n) {
    this._out(n, " w", Q);
  }, e.prototype.setLineCap = function(n) {
    this._out(n, " J", Q);
  }, e.prototype.setLineJoin = function(n) {
    this._out(n, " j", Q);
  }, e.prototype.setMitterLimit = function(n) {
    this._out(n, " M", Q);
  }, e.prototype.save = function() {
    this._contextStack.push(this._context()), this._out("q", Q);
  }, e.prototype.restore = function() {
    this._out("Q", Q), this._context(this._contextStack.pop());
  }, e.prototype.moveTo = function(n, i) {
    this._out(n, " ", i, " m", Q);
  }, e.prototype.lineTo = function(n, i) {
    this._out(n, " ", i, " l", Q);
  }, e.prototype.bezier = function(n, i, o, a, s, l) {
    this._out(n, " ", i, " ", o, " ", a, " ", s, " ", l, " c", Q);
  }, e.prototype.bezier1 = function(n, i, o, a) {
    this._out(n, " ", i, " ", o, " ", a, " y", Q);
  }, e.prototype.bezier2 = function(n, i, o, a) {
    this._out(n, " ", i, " ", o, " ", a, " v", Q);
  }, e.prototype.close = function() {
    this._out("h", Q);
  }, e.prototype.rect = function(n, i, o, a) {
    this._out(n, " ", i, " ", o, " ", a, " re", Q);
  }, e.prototype.ellipse = function(n, i, o, a) {
    function s(u) {
      return n + u;
    }
    function l(u) {
      return i + u;
    }
    var c = 0.5522847498307936;
    this.moveTo(s(0), l(a)), this.bezier(
      s(o * c),
      l(a),
      s(o),
      l(a * c),
      s(o),
      l(0)
    ), this.bezier(
      s(o),
      l(-a * c),
      s(o * c),
      l(-a),
      s(0),
      l(-a)
    ), this.bezier(
      s(-o * c),
      l(-a),
      s(-o),
      l(-a * c),
      s(-o),
      l(0)
    ), this.bezier(
      s(-o),
      l(a * c),
      s(-o * c),
      l(a),
      s(0),
      l(a)
    );
  }, e.prototype.circle = function(n, i, o) {
    this.ellipse(n, i, o, o);
  }, e.prototype.stroke = function() {
    this._out("S", Q);
  }, e.prototype.nop = function() {
    this._out("n", Q);
  }, e.prototype.clip = function() {
    this._out("W n", Q);
  }, e.prototype.clipStroke = function() {
    this._out("W S", Q);
  }, e.prototype.closeStroke = function() {
    this._out("s", Q);
  }, e.prototype.fill = function() {
    this._out("f", Q);
  }, e.prototype.fillStroke = function() {
    this._out("B", Q);
  }, e.prototype.drawImage = function(n) {
    var i = this._pdf.getImage(n);
    i && (this._xResources[i._resourceName] = i, this._out(i._resourceName, " Do", Q));
  }, e.prototype.comment = function(n) {
    var i = this;
    n.split(/\r?\n/g).forEach(function(o) {
      i._out("% ", o, Q);
    });
  }, e.prototype._context = function(n) {
    if (n != null)
      this._opacity = n.opacity, this._matrix = n.matrix;
    else
      return {
        opacity: this._opacity,
        matrix: this._matrix
      };
  }, e.prototype._toPage = function(n) {
    var i = this._matrix, o = i[0], a = i[1], s = i[2], l = i[3], c = i[4], u = i[5];
    return {
      x: o * n.x + s * n.y + c,
      y: a * n.x + l * n.y + u
    };
  }, e;
}(Le);
function Fv(r) {
  return r.replace(/^\s*(['"])(.*)\1\s*$/, "$2");
}
function Ru(r) {
  var e = /^\s*((normal|italic)\s+)?((normal|small-caps)\s+)?((normal|bold|\d+)\s+)?(([0-9.]+)(px|pt))(\/(([0-9.]+)(px|pt)|normal))?\s+(.*?)\s*$/i, t = e.exec(r);
  if (!t)
    return { fontSize: 12, fontFamily: "sans-serif" };
  var n = t[8] ? parseInt(t[8], 10) : 12;
  return {
    italic: t[2] && t[2].toLowerCase() == "italic",
    variant: t[4],
    bold: t[6] && /bold|700/i.test(t[6]),
    fontSize: n,
    lineHeight: t[12] ? t[12] == "normal" ? n : parseInt(t[12], 10) : null,
    fontFamily: t[14].split(/\s*,\s*/g).map(Fv)
  };
}
function Pu(r) {
  function e(a) {
    return r.bold && (a += "|bold"), r.italic && (a += "|italic"), a.toLowerCase();
  }
  var t = r.fontFamily, n, i;
  if (t instanceof Array)
    for (var o = 0; o < t.length && (n = e(t[o]), i = Ce[n], !i); ++o)
      ;
  else
    i = Ce[t.toLowerCase()];
  for (; typeof i == "function"; )
    i = i();
  return i || (i = "Times-Roman"), i;
}
var Ce = {
  serif: "Times-Roman",
  "serif|bold": "Times-Bold",
  "serif|italic": "Times-Italic",
  "serif|bold|italic": "Times-BoldItalic",
  "sans-serif": "Helvetica",
  "sans-serif|bold": "Helvetica-Bold",
  "sans-serif|italic": "Helvetica-Oblique",
  "sans-serif|bold|italic": "Helvetica-BoldOblique",
  monospace: "Courier",
  "monospace|bold": "Courier-Bold",
  "monospace|italic": "Courier-Oblique",
  "monospace|bold|italic": "Courier-BoldOblique",
  zapfdingbats: "ZapfDingbats",
  "zapfdingbats|bold": "ZapfDingbats",
  "zapfdingbats|italic": "ZapfDingbats",
  "zapfdingbats|bold|italic": "ZapfDingbats"
};
function nn(r, e) {
  r = r.toLowerCase(), Ce[r] = function() {
    return Ce[e];
  }, Ce[r + "|bold"] = function() {
    return Ce[e + "|bold"];
  }, Ce[r + "|italic"] = function() {
    return Ce[e + "|italic"];
  }, Ce[r + "|bold|italic"] = function() {
    return Ce[e + "|bold|italic"];
  };
}
nn("Times New Roman", "serif");
nn("Courier New", "monospace");
nn("Arial", "sans-serif");
nn("Helvetica", "sans-serif");
nn("Verdana", "sans-serif");
nn("Tahoma", "sans-serif");
nn("Georgia", "sans-serif");
nn("Monaco", "monospace");
nn("Andale Mono", "monospace");
function Lu(r, e) {
  if (arguments.length == 1)
    for (var t in r)
      Rs(r, t) && Lu(t, r[t]);
  else
    switch (r = r.toLowerCase(), Ce[r] = e, r) {
      case "dejavu sans":
        Ce["sans-serif"] = e;
        break;
      case "dejavu sans|bold":
        Ce["sans-serif|bold"] = e;
        break;
      case "dejavu sans|italic":
        Ce["sans-serif|italic"] = e;
        break;
      case "dejavu sans|bold|italic":
        Ce["sans-serif|bold|italic"] = e;
        break;
      case "dejavu serif":
        Ce.serif = e;
        break;
      case "dejavu serif|bold":
        Ce["serif|bold"] = e;
        break;
      case "dejavu serif|italic":
        Ce["serif|italic"] = e;
        break;
      case "dejavu serif|bold|italic":
        Ce["serif|bold|italic"] = e;
        break;
      case "dejavu mono":
        Ce.monospace = e;
        break;
      case "dejavu mono|bold":
        Ce["monospace|bold"] = e;
        break;
      case "dejavu mono|italic":
        Ce["monospace|italic"] = e;
        break;
      case "dejavu mono|bold|italic":
        Ce["monospace|bold|italic"] = e;
        break;
    }
}
function zv(r, e) {
  var t = r[0], n = r[1], i = r[2], o = r[3], a = r[4], s = r[5], l = e[0], c = e[1], u = e[2], f = e[3], h = e[4], d = e[5];
  return [
    t * l + n * u,
    t * c + n * f,
    i * l + o * u,
    i * c + o * f,
    a * l + s * u + h,
    a * c + s * f + d
  ];
}
function Bv(r) {
  return r[0] === 1 && r[1] === 0 && r[2] === 0 && r[3] === 1 && r[4] === 0 && r[5] === 0;
}
var $v = {
  fill: 0,
  stroke: 1,
  fillAndStroke: 2,
  invisible: 3,
  fillAndClip: 4,
  strokeAndClip: 5,
  fillStrokeClip: 6,
  clip: 7
}, Hv = 300, Fo = $v, jv = {
  dash: [4],
  dashDot: [4, 2, 1, 2],
  dot: [1, 2],
  longDash: [8, 2],
  longDashDot: [8, 2, 1, 2],
  longDashDotDot: [8, 2, 1, 2, 1, 2],
  solid: []
}, Wv = {
  butt: 0,
  round: 1,
  square: 2
}, Vv = {
  miter: 0,
  round: 1,
  bevel: 2
};
function Uv(r, e) {
  var t = [], n = {}, i = r.options;
  function o(u, f, h) {
    return h || (h = i), h.pdf && h.pdf[u] != null ? h.pdf[u] : f;
  }
  var a = o("multiPage"), s = o("imgDPI", Hv);
  pv(), r.traverse(function(u) {
    Ps({
      Image: function(f) {
        var h = f.src(), d = f.bbox().size;
        if (s) {
          var p = n[h];
          d = {
            width: Math.ceil(d.width * s / 72),
            height: Math.ceil(d.height * s / 72)
          }, p && (d.width = Math.max(p.width, d.width), d.height = Math.max(p.height, d.height));
        }
        n[h] = d;
      },
      Text: function(f) {
        var h = Ru(f.options.font), d = Pu(h);
        t.indexOf(d) < 0 && t.push(d);
      }
    }, u);
  });
  function l() {
    if (--c > 0)
      return;
    var u = new Zn({
      producer: o("producer"),
      title: o("title"),
      author: o("author"),
      subject: o("subject"),
      keywords: o("keywords"),
      creator: o("creator"),
      date: o("date"),
      autoPrint: o("autoPrint")
    });
    function f(h) {
      var d = h.options, p = iy(h), m = p.bbox;
      h = p.root;
      var v = o("paperSize", o("paperSize", "auto"), d), y = !1;
      if (v == "auto")
        if (m) {
          var b = m.getSize();
          v = [b.width, b.height], y = !0;
          var k = m.getOrigin();
          p = new dt(), p.transform(new lo(1, 0, 0, 1, -k.x, -k.y)), p.append(h), h = p;
        } else
          v = "A4";
      var M;
      M = u.addPage({
        paperSize: v,
        margin: o("margin", o("margin"), d),
        addMargin: y,
        landscape: o("landscape", o("landscape", !1), d)
      }), Fu(h, M, u);
    }
    a ? r.children.forEach(f) : f(r), e(u.render(), u);
  }
  var c = 2;
  Iu(t, l), Du(n, l, {
    jpegQuality: o("jpegQuality", 0.92),
    keepPNG: o("keepPNG", !1)
  });
}
function qv(r, e) {
  Uv(r, function(t) {
    e("data:application/pdf;base64," + t.base64());
  });
}
function Ps(r, e) {
  var t = r[e.nodeType];
  return t ? t.call.apply(t, arguments) : e;
}
function Fu(r, e, t) {
  r.options._pdfDebug && e.comment("BEGIN: " + r.options._pdfDebug);
  var n = r.transform(), i = r.opacity();
  if (e.save(), i != null && i < 1 && e.setOpacity(i), Kv(r, e), Gv(r, e), n) {
    var o = n.matrix();
    e.transform(o.a, o.b, o.c, o.d, o.e, o.f);
  }
  Jv(r, e), Ps({
    Path: zu,
    MultiPath: Yv,
    Circle: Zv,
    Arc: Qv,
    Text: ey,
    Image: ny,
    Group: ty,
    Rect: ry
  }, r, e, t), e.restore(), r.options._pdfDebug && e.comment("END: " + r.options._pdfDebug);
}
function Kv(r, e) {
  var t = r.stroke && r.stroke();
  if (t) {
    var n = t.color;
    if (n) {
      if (n = Fs(n), n == null)
        return;
      e.setStrokeColor(n.r, n.g, n.b), n.a != 1 && e.setStrokeOpacity(n.a);
    }
    var i = t.width;
    if (i != null) {
      if (i === 0)
        return;
      e.setLineWidth(i);
    }
    var o = t.dashType;
    o && e.setDashPattern(jv[o], 0);
    var a = t.lineCap;
    a && e.setLineCap(Wv[a]);
    var s = t.lineJoin;
    s && e.setLineJoin(Vv[s]);
    var l = t.opacity;
    l != null && e.setStrokeOpacity(l);
  }
}
function Gv(r, e) {
  var t = r.fill && r.fill();
  if (t && !(t instanceof Es)) {
    var n = t.color;
    if (n) {
      if (n = Fs(n), n == null)
        return;
      e.setFillColor(n.r, n.g, n.b), n.a != 1 && e.setFillOpacity(n.a);
    }
    var i = t.opacity;
    i != null && e.setFillOpacity(i);
  }
}
function Jv(r, e, t) {
  var n = r.clip();
  n && (Ls(n, e), e.clip());
}
function ar(r) {
  return r && (r instanceof Es || r.color && !/^(none|transparent)$/i.test(r.color) && (r.width == null || r.width > 0) && (r.opacity == null || r.opacity > 0));
}
function Ll(r, e, t, n) {
  var i = r.fill();
  if (i instanceof Es) {
    n ? e.clipStroke() : e.clip();
    var o = i instanceof _g, a, s;
    o ? (a = { x: i.center().x, y: i.center().y, r: 0 }, s = { x: i.center().x, y: i.center().y, r: i.radius() }) : (a = { x: i.start().x, y: i.start().y }, s = { x: i.end().x, y: i.end().y });
    var l = i.stops.elements().map(function(d) {
      var p = d.offset();
      /%$/.test(p) ? p = parseFloat(p) / 100 : p = parseFloat(p);
      var m = Fs(d.color());
      return m.a *= d.opacity(), {
        offset: p,
        color: m
      };
    });
    l.unshift(l[0]), l.push(l[l.length - 1]);
    var c = {
      userSpace: i.userSpace(),
      type: o ? "radial" : "linear",
      start: a,
      end: s,
      stops: l
    }, u = r.rawBBox(), f = u.topLeft(), h = u.getSize();
    return u = {
      left: f.x,
      top: f.y,
      width: h.width,
      height: h.height
    }, e.gradient(c, u), !0;
  }
}
function oi(r, e, t) {
  ar(r.fill()) && ar(r.stroke()) ? Ll(r, e, t, !0) || e.fillStroke() : ar(r.fill()) ? Ll(r, e, t, !1) || e.fill() : ar(r.stroke()) ? e.stroke() : e.nop();
}
function Xv(r, e) {
  var t = r.segments;
  if (t.length == 4 && r.options.closed) {
    for (var n = [], i = 0; i < t.length; ++i) {
      if (t[i].controlIn())
        return !1;
      n[i] = t[i].anchor();
    }
    var o = n[0].y == n[1].y && n[1].x == n[2].x && n[2].y == n[3].y && n[3].x == n[0].x || n[0].x == n[1].x && n[1].y == n[2].y && n[2].x == n[3].x && n[3].y == n[0].y;
    if (o)
      return e.rect(
        n[0].x,
        n[0].y,
        n[2].x - n[0].x,
        n[2].y - n[0].y
        /*height*/
      ), !0;
  }
}
function Ls(r, e, t) {
  var n = r.segments;
  if (n.length !== 0 && !Xv(r, e)) {
    for (var i, o = 0; o < n.length; ++o) {
      var a = n[o], s = a.anchor();
      if (!i)
        e.moveTo(s.x, s.y);
      else {
        var l = i.controlOut(), c = a.controlIn();
        l && c ? e.bezier(
          l.x,
          l.y,
          c.x,
          c.y,
          s.x,
          s.y
        ) : e.lineTo(s.x, s.y);
      }
      i = a;
    }
    r.options.closed && e.close();
  }
}
function zu(r, e, t) {
  Ls(r, e), oi(r, e, t);
}
function Yv(r, e, t) {
  for (var n = r.paths, i = 0; i < n.length; ++i)
    Ls(n[i], e);
  oi(r, e, t);
}
function Zv(r, e, t) {
  var n = r.geometry();
  e.circle(n.center.x, n.center.y, n.radius), oi(r, e, t);
}
function Qv(r, e, t) {
  var n = r.geometry().curvePoints();
  e.moveTo(n[0].x, n[0].y);
  for (var i = 1; i < n.length; )
    e.bezier(
      n[i].x,
      n[i++].y,
      n[i].x,
      n[i++].y,
      n[i].x,
      n[i++].y
    );
  oi(r, e, t);
}
function ey(r, e) {
  var t = Ru(r.options.font), n = r._position, i;
  r.fill() && r.stroke() ? i = Fo.fillAndStroke : r.fill() ? i = Fo.fill : r.stroke() && (i = Fo.stroke), e.transform(1, 0, 0, -1, n.x, n.y + t.fontSize), e.beginText(), e.setFont(Pu(t), t.fontSize), e.setTextRenderingMode(i), e.showText(r.content(), r._pdfRect ? r._pdfRect.width() : null), e.endText();
}
function ty(r, e, t) {
  r._pdfLink && e.addLink(r._pdfLink.url, r._pdfLink);
  for (var n = r.children, i = 0; i < n.length; ++i)
    Fu(n[i], e, t);
}
function ny(r, e) {
  var t = r.src();
  if (t) {
    var n = r.rect(), i = n.getOrigin(), o = n.getSize();
    e.transform(o.width, 0, 0, -o.height, i.x, i.y + o.height), e.drawImage(t);
  }
}
function ry(r, e, t) {
  var n = r.geometry(), i = n.cornerRadius, o = i[0], a = i[1];
  o === 0 && a === 0 ? (e.rect(n.origin.x, n.origin.y, n.size.width, n.size.height), oi(r, e, t)) : zu(Ue.fromRect(n, r.options), e, t);
}
function Fs(r) {
  var e = As(r, !0);
  return e ? e.toRGB() : null;
}
function iy(r) {
  var e = !1, t = lo.unit(), n = null, i;
  do
    i = !1, r = u(r);
  while (r && i);
  return { root: r, bbox: n };
  function o(f) {
    return i = !0, f;
  }
  function a(f) {
    return f.visible() && f.opacity() > 0 && (ar(f.fill()) || ar(f.stroke()));
  }
  function s(f) {
    for (var h = [], d = 0; d < f.length; ++d) {
      var p = u(f[d]);
      p != null && h.push(p);
    }
    return h;
  }
  function l(f, h) {
    var d = e, p = t;
    f.transform() && (t = t.multiplyCopy(f.transform().matrix()));
    var m = f.clip();
    m && (m = m.bbox(), m && (m = m.bbox(t), e = e ? vn.intersect(e, m) : m));
    try {
      return h();
    } finally {
      e = d, t = p;
    }
  }
  function c(f) {
    if (e == null)
      return !1;
    var h = f.rawBBox().bbox(t);
    return e && h && (h = vn.intersect(h, e)), h;
  }
  function u(f) {
    return l(f, function() {
      if (!(f instanceof dt || f instanceof _l)) {
        var h = c(f);
        if (!h)
          return o(null);
        n = n ? vn.union(n, h) : h;
      }
      return Ps({
        Path: function(d) {
          return d.segments.length === 0 || !a(d) ? o(null) : d;
        },
        MultiPath: function(d) {
          if (!a(d))
            return o(null);
          var p = new _l(d.options);
          return p.paths = s(d.paths), p.paths.length === 0 ? o(null) : p;
        },
        Circle: function(d) {
          return a(d) ? d : o(null);
        },
        Arc: function(d) {
          return a(d) ? d : o(null);
        },
        Text: function(d) {
          return !/\S/.test(d.content()) || !a(d) ? o(null) : d;
        },
        Image: function(d) {
          return d.visible() && d.opacity() > 0 ? d : o(null);
        },
        Group: function(d) {
          if (!(d.visible() && d.opacity() > 0))
            return o(null);
          var p = new dt(d.options);
          return p.children = s(d.children), p._pdfLink = d._pdfLink, d !== r && p.children.length === 0 && !d._pdfLink ? o(null) : p;
        },
        Rect: function(d) {
          return a(d) ? d : o(null);
        }
      }, f);
    });
  }
}
function oy(r, e) {
  var t = Ou();
  for (var n in e)
    n == "margin" && r.options.pdf && r.options.pdf._ignoreMargin || r.options.set("pdf." + n, e[n]);
  return qv(r, t.resolve), t;
}
var ct = zr.browser || {};
function Qt(r) {
  return Array.prototype.slice.call(r);
}
var Gr = "KENDO-PSEUDO-ELEMENT", Nr = {}, re = {};
re._root = re;
var ay = typeof window < "u", zn = ay ? ct.msie || ct.edge : !1, sy = function(r) {
  function e(t, n, i) {
    r.call(this, t, n.getOrigin(), i), this._pdfRect = n;
  }
  return r && (e.__proto__ = r), e.prototype = Object.create(r && r.prototype), e.prototype.constructor = e, e.prototype.rect = function() {
    return this._pdfRect;
  }, e.prototype.rawBBox = function() {
    return this._pdfRect;
  }, e;
}(Ng);
function ly(r, e) {
  r.classList ? r.classList.add(e) : r.className += " " + e;
}
function cy(r, e) {
  r.classList ? r.classList.remove(e) : r.className = r.className.split(/\s+/).reduce(function(t, n) {
    return n != e && t.push(n), t;
  }, []).join(" ");
}
function _r(r, e) {
  Object.keys(e).forEach(function(t) {
    r.style[t] = e[t];
  });
}
var Pi = typeof Element < "u" && Element.prototype && function(r) {
  return r.matches ? function(e, t) {
    return e.matches(t);
  } : r.webkitMatchesSelector ? function(e, t) {
    return e.webkitMatchesSelector(t);
  } : r.mozMatchesSelector ? function(e, t) {
    return e.mozMatchesSelector(t);
  } : r.msMatchesSelector ? function(e, t) {
    return e.msMatchesSelector(t);
  } : function(e) {
    return [].indexOf.call(document.querySelectorAll(e), this) !== -1;
  };
}(Element.prototype);
function Ir(r, e) {
  if (r.closest)
    return r.closest(e);
  for (; r && !/^\[object (?:HTML)?Document\]$/.test(String(r)); ) {
    if (r.nodeType == 1 && Pi(r, e))
      return r;
    r = r.parentNode;
  }
}
var uy = function(r) {
  return r ? function e(t) {
    var n = t.cloneNode(!1);
    if (t.nodeType == 1) {
      var i = r(t), o = r(n), a, s = i.data();
      for (a in s)
        o.data(a, s[a]);
      for (/^canvas$/i.test(t.tagName) ? n.getContext("2d").drawImage(t, 0, 0) : /^(?:input|select|textarea|option)$/i.test(t.tagName) && (n.removeAttribute("id"), n.removeAttribute("name"), /^textarea$/i.test(t.tagName) || (n.value = t.value), n.checked = t.checked, n.selected = t.selected), a = t.firstChild; a; a = a.nextSibling)
        n.appendChild(e(a));
    }
    return n;
  } : function(t) {
    var n = function a(s) {
      var l = s.cloneNode(!1);
      s._kendoExportVisual && (l._kendoExportVisual = s._kendoExportVisual);
      for (var c = s.firstChild; c; c = c.nextSibling)
        l.appendChild(a(c));
      return l;
    }(t), i = t.querySelectorAll("canvas");
    i.length && Qt(n.querySelectorAll("canvas")).forEach(function(a, s) {
      a.getContext("2d").drawImage(i[s], 0, 0);
    });
    var o = t.querySelectorAll("input, select, textarea, option");
    return Qt(n.querySelectorAll("input, select, textarea, option")).forEach(function(a, s) {
      a.removeAttribute("id"), a.removeAttribute("name"), /^textarea$/i.test(a.tagName) || (a.value = o[s].value), a.checked = o[s].checked, a.selected = o[s].selected;
    }), n;
  };
}(typeof window < "u" && window.kendo && window.kendo.jQuery);
function fy(r) {
  return typeof r == "number" ? { x: r, y: r } : Array.isArray(r) ? { x: r[0], y: r[1] } : { x: r.x, y: r.y };
}
function hy(r, e) {
  e || (e = {});
  var t = Ou();
  if (!r)
    return t.reject("No element to export");
  if (typeof window.getComputedStyle != "function")
    throw new Error("window.getComputedStyle is missing.  You are using an unsupported browser, or running in IE8 compatibility mode.  Drawing HTML is supported in Chrome, Firefox, Safari and IE9+.");
  Lu(py(r.ownerDocument));
  var n = fy(e.scale || 1);
  function i(s) {
    var l = new dt(), c = s.getBoundingClientRect();
    return Li(l, [
      n.x,
      0,
      0,
      n.y,
      -c.left * n.x,
      -c.top * n.y
    ]), re._clipbox = !1, re._matrix = lo.unit(), re._stackingContext = {
      element: s,
      group: l
    }, e.avoidLinks === !0 ? re._avoidLinks = "a" : re._avoidLinks = e.avoidLinks, ly(s, "k-pdf-export"), $r(s, l), cy(s, "k-pdf-export"), l;
  }
  Bl([r], function() {
    var s = e && e.forcePageBreak, l = e && e.paperSize && e.paperSize != "auto", c = _u(function(m, v) {
      return m == "paperSize" ? l ? e[m] : "A4" : m in e ? e[m] : v;
    }), u = l && c.paperSize[0], f = l && c.paperSize[1], h = e.margin && c.margin, d = !!h;
    if (s || f) {
      h || (h = { left: 0, top: 0, right: 0, bottom: 0 }), u && (u /= n.x), f && (f /= n.y), h.left /= n.x, h.right /= n.x, h.top /= n.y, h.bottom /= n.y;
      var p = new dt({
        pdf: {
          multiPage: !0,
          paperSize: l ? c.paperSize : "auto",
          _ignoreMargin: d
          // HACK!  see exportPDF in pdf/drawing.js
        }
      });
      a(
        function(m) {
          if (e.progress) {
            var v = !1, y = 0;
            (function b() {
              if (y < m.pages.length) {
                var k = i(m.pages[y]);
                p.append(k), e.progress({
                  page: k,
                  pageNum: ++y,
                  totalPages: m.pages.length,
                  cancel: function() {
                    v = !0;
                  }
                }), v ? m.container.parentNode.removeChild(m.container) : setTimeout(b);
              } else
                m.container.parentNode.removeChild(m.container), t.resolve(p);
            })();
          } else
            m.pages.forEach(function(b) {
              p.append(i(b));
            }), m.container.parentNode.removeChild(m.container), t.resolve(p);
        },
        r,
        s,
        u ? u - h.left - h.right : null,
        f ? f - h.top - h.bottom : null,
        h,
        e
      );
    } else
      t.resolve(i(r));
  });
  function o(s) {
    if (s != null)
      return typeof s == "string" && (s = Kg(s.replace(/^\s+|\s+$/g, ""))), typeof s == "function" ? function(l) {
        var c = s(l);
        if (c && typeof c == "string") {
          var u = document.createElement("div");
          u.innerHTML = c, c = u.firstElementChild;
        }
        return c;
      } : function() {
        return s.cloneNode(!0);
      };
  }
  function a(s, l, c, u, f, h, d) {
    var p = o(d.template), m = l.ownerDocument, v = [], y = d._destructive ? l : uy(l), b = m.createElement("KENDO-PDF-DOCUMENT"), k = 0;
    Qt(y.querySelectorAll("tfoot")).forEach(function(B) {
      B.parentNode.appendChild(B);
    }), Qt(y.querySelectorAll("ol")).forEach(function(B) {
      Qt(B.children).forEach(function(R, U) {
        R.setAttribute("kendo-split-index", U);
      });
    }), _r(b, {
      display: "block",
      position: "absolute",
      boxSizing: "content-box",
      left: "-10000px",
      top: "-10000px"
    }), u && (_r(b, {
      width: u + "px",
      paddingLeft: h.left + "px",
      paddingRight: h.right + "px"
    }), _r(y, { overflow: "hidden" })), l.parentNode.insertBefore(b, l), b.appendChild(y), d.beforePageBreak ? xa([b], function() {
      d.beforePageBreak(b, M);
    }) : xa([b], M);
    function M() {
      (c != "-" || f) && T(y);
      {
        var B = ee();
        y.parentNode.insertBefore(B, y), B.appendChild(y);
      }
      p && v.forEach(function(R, U) {
        var S = p({
          element: R,
          pageNum: U + 1,
          totalPages: v.length
        });
        S && R.appendChild(S);
      }), Bl(v, s.bind(null, { pages: v, container: b }));
    }
    function D(B) {
      if (d.keepTogether && Pi(B, d.keepTogether) && B.offsetHeight <= f - k)
        return !0;
      var R = B.tagName;
      return /^h[1-6]$/i.test(R) && B.offsetHeight >= f - k ? !1 : B.getAttribute("data-kendo-chart") || /^(?:img|tr|thead|th|tfoot|iframe|svg|object|canvas|input|textarea|select|video|h[1-6])/i.test(B.tagName);
    }
    function T(B) {
      if (B.tagName == "TABLE" && _r(B, { tableLayout: "fixed" }), !D(B)) {
        var R = Je(B), U = parseFloat(V(R, "padding-bottom")), S = parseFloat(V(R, "border-bottom-width")), W = k;
        k += U + S;
        for (var j = !0, H = B.firstChild; H; H = H.nextSibling)
          if (H.nodeType == 1) {
            if (j = !1, Pi(H, c)) {
              _(H);
              continue;
            }
            if (!f) {
              T(H);
              continue;
            }
            if (!/^(?:static|relative)$/.test(V(Je(H), "position")))
              continue;
            var Z = K(H);
            Z == 1 || Z && D(H) ? _(H) : T(H);
          } else
            H.nodeType == 3 && f && (O(H, j), j = !1);
        k = W;
      }
    }
    function z(B) {
      var R = B.parentNode, U = R.firstChild;
      if (B === U)
        return !0;
      if (B === R.children[0]) {
        if (U.nodeType == 7 || U.nodeType == 8)
          return !0;
        if (U.nodeType == 3)
          return !/\S/.test(U.data);
      }
      return !1;
    }
    function _(B) {
      if (B.nodeType == 1 && B !== y && z(B))
        return _(B.parentNode);
      var R, U, S, W, j;
      R = Ir(B, "table"), U = R && R.querySelector("colgroup"), d.repeatHeaders && (S = R && R.querySelector("thead"), W = Ir(B, ".k-grid.k-widget"), W && W.querySelector(".k-auto-scrollable") && (j = W.querySelector(".k-grid-header")));
      var H = ee(), Z = m.createRange();
      Z.setStartBefore(y), Z.setEndBefore(B), H.appendChild(Z.extractContents()), y.parentNode.insertBefore(H, y), ne(B.parentNode), R && (R = Ir(B, "table"), d.repeatHeaders && S && R.insertBefore(S.cloneNode(!0), R.firstChild), U && R.insertBefore(U.cloneNode(!0), R.firstChild)), d.repeatHeaders && j && (W = Ir(B, ".k-grid.k-widget"), W.insertBefore(j.cloneNode(!0), W.firstChild));
    }
    function ee() {
      var B = m.createElement("KENDO-PDF-PAGE");
      return _r(B, {
        display: "block",
        boxSizing: "content-box",
        width: u ? u + "px" : "auto",
        padding: h.top + "px " + h.right + "px " + h.bottom + "px " + h.left + "px",
        // allow absolutely positioned elements to be relative to current page
        position: "relative",
        // without the following we might affect layout of subsequent pages
        height: f ? f + "px" : "auto",
        overflow: f || u ? "hidden" : "visible",
        clear: "both"
      }), d && d.pageClassName && (B.className = d.pageClassName), v.push(B), B;
    }
    function K(B) {
      var R = B.getBoundingClientRect();
      if (R.width === 0 || R.height === 0)
        return 0;
      var U = y.getBoundingClientRect().top, S = f - k;
      return R.height > S ? 3 : R.top - U > S ? 1 : R.bottom - U > S ? 2 : 0;
    }
    function O(B, R) {
      if (/\S/.test(B.data)) {
        var U = B.data.length, S = m.createRange();
        S.selectNodeContents(B);
        var W = K(S);
        if (W) {
          var j = B;
          if (W == 1)
            _(R ? B.parentNode : B);
          else if (function Z(C, N, q) {
            return S.setEnd(B, N), C == N || N == q ? N : K(S) ? Z(C, C + N >> 1, N) : Z(N, N + q >> 1, q);
          }(0, U >> 1, U), !/\S/.test(S.toString()) && R)
            _(B.parentNode);
          else {
            j = B.splitText(S.endOffset);
            var H = ee();
            S.setStartBefore(y), H.appendChild(S.extractContents()), y.parentNode.insertBefore(H, y), ne(j.parentNode);
          }
          O(j);
        }
      }
    }
    function ne(B) {
      var R = Ir(B, "li");
      R && (R.setAttribute("kendo-no-bullet", "1"), ne(R.parentNode));
    }
  }
  return t;
}
var Bu = function() {
  var r = /^((-webkit-|-moz-|-o-|-ms-)?linear-gradient\s*)\(/, e = /^([-0-9.]+%)/, t = /^([-0-9.]+px)/, n = /^(left|right|top|bottom|to|center)\W/, i = /^([-0-9.]+(deg|grad|rad|turn)|0)/, o = /^(\s+)/, a = /^(\()/, s = /^(\))/, l = /^(,)/, c = /^(url)\(/, u = /^(.*?)\)/, f = {}, h = {};
  function d(p) {
    var m = p;
    if (Jr(f, m))
      return f[m];
    function v() {
      var T = o.exec(p);
      T && (p = p.substr(T[1].length));
    }
    function y(T) {
      v();
      var z = T.exec(p);
      if (z)
        return p = p.substr(z[1].length), z[1];
    }
    function b() {
      var T = As(p, !0), z, _;
      if (T) {
        var ee = /^#[0-9a-f]+/i.exec(p) || /^rgba?\(.*?\)/i.exec(p) || /^..*?\b/.exec(p);
        return p = p.substr(ee[0].length), T = T.toRGB(), (z = y(t)) || (_ = y(e)), { color: T, length: z, percent: _ };
      }
    }
    function k(T) {
      var z, _, ee, K = [], O = !1;
      if (y(a)) {
        if (z = y(i), z == "0" && (z = "0deg"), z ? (z = xy(z), y(l)) : (_ = y(n), _ == "to" ? _ = y(n) : _ && /^-/.test(T) && (O = !0), ee = y(n), y(l)), /-moz-/.test(T) && z == null && _ == null) {
          var ne = y(e), B = y(e);
          O = !0, ne == "0%" ? _ = "left" : ne == "100%" && (_ = "right"), B == "0%" ? ee = "top" : B == "100%" && (ee = "bottom"), y(l);
        }
        for (; p && !y(s); ) {
          var R = b();
          if (!R)
            break;
          K.push(R), y(l);
        }
        return {
          type: "linear",
          angle: z,
          to: _ && ee ? _ + " " + ee : _ || ee || null,
          stops: K,
          reverse: O
        };
      }
    }
    function M() {
      if (y(a)) {
        var T = y(u);
        return T = T.replace(/^['"]+|["']+$/g, ""), y(s), { type: "url", url: T };
      }
    }
    var D;
    return (D = y(r)) ? D = k(D) : (D = y(c)) && (D = M()), f[m] = D || { type: "none" };
  }
  return function(p) {
    return Jr(h, p) ? h[p] : h[p] = lt(p).map(d);
  };
}(), lt = function() {
  var r = {};
  return function(e, t) {
    t || (t = /^\s*,\s*/);
    var n = e + t;
    if (Jr(r, n))
      return r[n];
    var i = [], o = 0, a = 0, s = 0, l = !1, c;
    function u(h) {
      return c = h.exec(e.substr(a));
    }
    function f(h) {
      return h.replace(/^\s+|\s+$/g, "");
    }
    for (; a < e.length; )
      !l && u(/^[\(\[\{]/) ? (s++, a++) : !l && u(/^[\)\]\}]/) ? (s--, a++) : !l && u(/^[\"\']/) ? (l = c[0], a++) : l == "'" && u(/^\\\'/) || l == '"' && u(/^\\\"/) ? a += 2 : l == "'" && u(/^\'/) || l == '"' && u(/^\"/) ? (l = !1, a++) : u(t) ? (!l && !s && a > o && (i.push(f(e.substring(o, a))), o = a + c[0].length), a += c[0].length) : a++;
    return o < a && i.push(f(e.substring(o, a))), r[n] = i;
  };
}(), Fl = function(r) {
  return function(e) {
    var t = r[e];
    if (!t) {
      var n;
      ((n = /url\((['"]?)([^'")]*?)\1\)\s+format\((['"]?)truetype\3\)/.exec(e)) || (n = /url\((['"]?)([^'")]*?\.ttf)\1\)/.exec(e))) && (t = r[e] = n[2]);
    }
    return t;
  };
}(/* @__PURE__ */ Object.create(null)), dy = function(r) {
  return function(e) {
    var t = r[e];
    return t == null && (t = r[e] = Dg("Mapq", { font: e }).height), t;
  };
}(/* @__PURE__ */ Object.create(null));
function py(r) {
  r == null && (r = document);
  for (var e = {}, t = 0; t < r.styleSheets.length; ++t)
    n(r.styleSheets[t]);
  return e;
  function n(s) {
    if (s) {
      var l = null;
      try {
        l = s.cssRules;
      } catch {
      }
      l && o(s, l);
    }
  }
  function i(s) {
    var l = V(s.style, "src");
    if (l)
      return lt(l).reduce(function(u, f) {
        var h = Fl(f);
        return h && u.push(h), u;
      }, []);
    var c = Fl(s.cssText);
    return c ? [c] : [];
  }
  function o(s, l) {
    for (var c = 0; c < l.length; ++c) {
      var u = l[c];
      switch (u.type) {
        case 3:
          n(u.styleSheet);
          break;
        case 5:
          var f = u.style, h = lt(V(f, "font-family")), d = /^([56789]00|bold)$/i.test(V(f, "font-weight")), p = V(f, "font-style") == "italic", m = i(u);
          m.length > 0 && a(s, h, d, p, m[0]);
      }
    }
  }
  function a(s, l, c, u, f) {
    /^data:/i.test(f) || /^[^\/:]+:\/\//.test(f) || /^\//.test(f) || (f = String(s.href).replace(/[^\/]*$/, "") + f), l.forEach(function(h) {
      h = h.replace(/^(['"]?)(.*?)\1$/, "$2"), c && (h += "|bold"), u && (h += "|italic"), e[h] = f;
    });
  }
}
function Jr(r, e) {
  return Object.prototype.hasOwnProperty.call(r, e);
}
function my(r) {
  return r = "_counter_" + r, re[r];
}
function gy(r) {
  var e = [], t = re;
  for (r = "_counter_" + r; t; )
    Jr(t, r) && e.push(t[r]), t = Object.getPrototypeOf(t);
  return e.reverse();
}
function vy(r, e) {
  var t = re;
  for (r = "_counter_" + r; t && !Jr(t, r); )
    t = Object.getPrototypeOf(t);
  t || (t = re._root), t[r] = (t[r] || 0) + (e ?? 1);
}
function yy(r, e) {
  r = "_counter_" + r, re[r] = e ?? 0;
}
function zl(r, e, t) {
  for (var n = 0; n < r.length; ) {
    var i = r[n++], o = parseFloat(r[n]);
    isNaN(o) ? e(i, t) : (e(i, o), ++n);
  }
}
function $u(r) {
  var e = V(r, "counter-reset");
  e && zl(lt(e, /^\s+/), yy, 0);
  var t = V(r, "counter-increment");
  t && zl(lt(t, /^\s+/), vy, 1);
}
function Hu(r, e) {
  var t = As(r, !0);
  return t && (t = t.toRGB(), e ? t = t.toCssRgba() : t.a === 0 && (t = null)), t;
}
function xa(r, e) {
  var t = 0, n = !1;
  r.forEach(function(o) {
    for (var a = o.querySelectorAll("img"), s = 0; s < a.length; ++s) {
      var l = a[s];
      l.complete || (t++, l.onload = l.onerror = i);
    }
  }), t || i();
  function i() {
    !n && --t <= 0 && (e(), n = !0);
  }
}
function Bl(r, e) {
  var t = [];
  function n(a) {
    Nr[a] || (Nr[a] = !0, t.push(a));
  }
  r.forEach(function a(s) {
    /^img$/i.test(s.tagName) && n(s.src), Bu(
      V(
        Je(s),
        "background-image"
      )
    ).forEach(function(l) {
      l.type == "url" && n(l.url);
    }), s.children && Qt(s.children).forEach(a);
  });
  var i = t.length;
  function o() {
    --i <= 0 && xa(r, e);
  }
  i === 0 && o(), t.forEach(function(a) {
    var s = Nr[a] = new window.Image();
    /^data:/i.test(a) || (s.crossOrigin = "Anonymous"), s.src = a, s.complete ? o() : (s.onload = o, s.onerror = function() {
      Nr[a] = null, o();
    });
  });
}
function Oa(r) {
  var e = "";
  do {
    var t = r % 26;
    e = String.fromCharCode(97 + t) + e, r = Math.floor(r / 26);
  } while (r > 0);
  return e;
}
function wy(r, e, t) {
  re = Object.create(re), re[r.tagName.toLowerCase()] = {
    element: r,
    style: e
  };
  var n = V(e, "text-decoration");
  if (n && n != "none") {
    var i = V(e, "text-decoration-color");
    n.split(/\s+/g).forEach(function(o) {
      if (!re[o] && (re[o] = i, o == "underline")) {
        var a = V(e, "text-underline-offset");
        a != "auto" && (re["underline-offset"] = parseFloat(a));
      }
    });
  }
  Cy(e) && (re._stackingContext = {
    element: r,
    group: t
  });
}
function by() {
  re = Object.getPrototypeOf(re);
}
function $l(r) {
  if (re._clipbox != null) {
    var e = r.bbox(re._matrix);
    re._clipbox ? re._clipbox = vn.intersect(re._clipbox, e) : re._clipbox = e;
  }
}
function Sy() {
  var r = re._clipbox;
  if (r == null)
    return !0;
  if (r)
    return r.width() === 0 || r.height() === 0;
}
function Cy(r) {
  function e(t) {
    return V(r, t);
  }
  if (e("transform") != "none" || e("position") != "static" || e("z-index") != "auto" || e("opacity") < 1)
    return !0;
}
function Je(r, e) {
  return window.getComputedStyle(r, e || null);
}
function V(r, e, t) {
  var n = r.getPropertyValue(e);
  return (n == null || n === "") && (ct.webkit ? n = r.getPropertyValue("-webkit-" + e) : ct.mozilla ? n = r.getPropertyValue("-moz-" + e) : ct.opera ? n = r.getPropertyValue("-o-" + e) : zn && (n = r.getPropertyValue("-ms-" + e))), arguments.length > 2 && (n == null || n === "") ? t : n;
}
function zo(r, e, t, n) {
  r.setProperty(e, t, n), ct.webkit ? r.setProperty("-webkit-" + e, t, n) : ct.mozilla ? r.setProperty("-moz-" + e, t, n) : ct.opera ? r.setProperty("-o-" + e, t, n) : zn && (r.setProperty("-ms-" + e, t, n), e = "ms" + e.replace(/(^|-)([a-z])/g, function(i, o, a) {
    return o + a.toUpperCase();
  }), r[e] = t);
}
function Pt(r, e) {
  return e = "border-" + e, {
    width: parseFloat(V(r, e + "-width")),
    style: V(r, e + "-style"),
    color: Hu(V(r, e + "-color"), !0)
  };
}
function ju(r, e) {
  var t = r.style.cssText, n = e();
  return r.style.cssText = t, n;
}
function pn(r, e) {
  var t = V(r, "border-" + e + "-radius").split(/\s+/g).map(parseFloat);
  return t.length == 1 && t.push(t[0]), Ta({ x: t[0], y: t[1] });
}
function Wu(r) {
  var e = r.getBoundingClientRect();
  return e = En(e, "border-*-width", r), e = En(e, "padding-*", r), e;
}
function En(r, e, t) {
  var n, i, o, a, s;
  return typeof e == "string" ? (n = Je(t), i = parseFloat(V(n, e.replace("*", "top"))), o = parseFloat(V(n, e.replace("*", "right"))), a = parseFloat(V(n, e.replace("*", "bottom"))), s = parseFloat(V(n, e.replace("*", "left")))) : typeof e == "number" && (i = o = a = s = e), {
    top: r.top + i,
    right: r.right - o,
    bottom: r.bottom - a,
    left: r.left + s,
    width: r.right - r.left - o - s,
    height: r.bottom - r.top - a - i
  };
}
function ky(r) {
  var e = V(r, "transform");
  if (e == "none")
    return null;
  var t = /^\s*matrix\(\s*(.*?)\s*\)\s*$/.exec(e);
  if (t) {
    var n = V(r, "transform-origin");
    return t = t[1].split(/\s*,\s*/g).map(parseFloat), n = n.split(/\s+/g).map(parseFloat), {
      matrix: t,
      origin: n
    };
  }
}
function Hl(r) {
  return 180 * r / Math.PI % 360;
}
function xy(r) {
  var e = parseFloat(r);
  if (/grad$/.test(r))
    return Math.PI * e / 200;
  if (/rad$/.test(r))
    return e;
  if (/turn$/.test(r))
    return Math.PI * e * 2;
  if (/deg$/.test(r))
    return Math.PI * e / 180;
}
function Li(r, e) {
  return e = new lo(e[0], e[1], e[2], e[3], e[4], e[5]), r.transform(e), e;
}
function Br(r, e) {
  r.clip(e);
}
function sr(r, e, t, n) {
  for (var i = new Eg([e, t], n).curvePoints(), o = 1; o < i.length; )
    r.curveTo(i[o++], i[o++], i[o++]);
}
function Ta(r) {
  return (r.x <= 0 || r.y <= 0) && (r.x = r.y = 0), r;
}
function Vu(r, e, t, n, i) {
  var o = Math.max(0, e.x), a = Math.max(0, e.y), s = Math.max(0, t.x), l = Math.max(0, t.y), c = Math.max(0, n.x), u = Math.max(0, n.y), f = Math.max(0, i.x), h = Math.max(0, i.y), d = Math.min(
    r.width / (o + s),
    r.height / (l + u),
    r.width / (c + f),
    r.height / (h + a)
  );
  return d < 1 && (o *= d, a *= d, s *= d, l *= d, c *= d, u *= d, f *= d, h *= d), {
    tl: { x: o, y: a },
    tr: { x: s, y: l },
    br: { x: c, y: u },
    bl: { x: f, y: h }
  };
}
function Ma(r, e, t) {
  var n = Je(r), i = pn(n, "top-left"), o = pn(n, "top-right"), a = pn(n, "bottom-left"), s = pn(n, "bottom-right");
  if (t == "padding" || t == "content") {
    var l = Pt(n, "top"), c = Pt(n, "right"), u = Pt(n, "bottom"), f = Pt(n, "left");
    if (i.x -= f.width, i.y -= l.width, o.x -= c.width, o.y -= l.width, s.x -= c.width, s.y -= u.width, a.x -= f.width, a.y -= u.width, t == "content") {
      var h = parseFloat(V(n, "padding-top")), d = parseFloat(V(n, "padding-right")), p = parseFloat(V(n, "padding-bottom")), m = parseFloat(V(n, "padding-left"));
      i.x -= m, i.y -= h, o.x -= d, o.y -= h, s.x -= d, s.y -= p, a.x -= m, a.y -= p;
    }
  }
  return typeof t == "number" && (i.x -= t, i.y -= t, o.x -= t, o.y -= t, s.x -= t, s.y -= t, a.x -= t, a.y -= t), Uu(e, i, o, s, a);
}
function Uu(r, e, t, n, i) {
  var o = Vu(r, e, t, n, i), a = o.tl, s = o.tr, l = o.br, c = o.bl, u = new Ue({ fill: null, stroke: null });
  return u.moveTo(r.left, r.top + a.y), a.x && sr(u, r.left + a.x, r.top + a.y, {
    startAngle: -180,
    endAngle: -90,
    radiusX: a.x,
    radiusY: a.y
  }), u.lineTo(r.right - s.x, r.top), s.x && sr(u, r.right - s.x, r.top + s.y, {
    startAngle: -90,
    endAngle: 0,
    radiusX: s.x,
    radiusY: s.y
  }), u.lineTo(r.right, r.bottom - l.y), l.x && sr(u, r.right - l.x, r.bottom - l.y, {
    startAngle: 0,
    endAngle: 90,
    radiusX: l.x,
    radiusY: l.y
  }), u.lineTo(r.left + c.x, r.bottom), c.x && sr(u, r.left + c.x, r.bottom - c.y, {
    startAngle: 90,
    endAngle: 180,
    radiusX: c.x,
    radiusY: c.y
  }), u.close();
}
function jl(r, e) {
  var t = String(parseFloat(r));
  switch (e) {
    case "decimal-leading-zero":
      return t.length < 2 && (t = "0" + t), t;
    case "lower-roman":
      return ya(r).toLowerCase();
    case "upper-roman":
      return ya(r).toUpperCase();
    case "lower-latin":
    case "lower-alpha":
      return Oa(r - 1);
    case "upper-latin":
    case "upper-alpha":
      return Oa(r - 1).toUpperCase();
    default:
      return t;
  }
}
function Oy(r, e) {
  function t(a, s, l) {
    return l ? (l = l.replace(/^\s*(["'])(.*)\1\s*$/, "$2"), gy(a).map(function(c) {
      return jl(c, s);
    }).join(l)) : jl(my(a) || 0, s);
  }
  var n = lt(e, /^\s+/), i = [], o;
  return n.forEach(function(a) {
    var s;
    (o = /^\s*(["'])(.*)\1\s*$/.exec(a)) ? i.push(o[2].replace(/\\([0-9a-f]{4})/gi, function(l, c) {
      return String.fromCharCode(parseInt(c, 16));
    })) : (o = /^\s*counter\((.*?)\)\s*$/.exec(a)) ? (s = lt(o[1]), i.push(t(s[0], s[1]))) : (o = /^\s*counters\((.*?)\)\s*$/.exec(a)) ? (s = lt(o[1]), i.push(t(s[0], s[2], s[1]))) : (o = /^\s*attr\((.*?)\)\s*$/.exec(a)) ? i.push(r.getAttribute(o[1]) || "") : i.push(a);
  }), i.join("");
}
function _a(r) {
  if (r.cssText)
    return r.cssText;
  for (var e = [], t = 0; t < r.length; ++t)
    e.push(r[t] + ": " + V(r, r[t]));
  return e.join(`;
`);
}
function Wl(r, e) {
  if (r.tagName == Gr) {
    Bo(r, e);
    return;
  }
  var t = [];
  function n(o, a) {
    var s = Je(r, o), l = s.content;
    if ($u(s), l && l != "normal" && l != "none" && s.width != "0px") {
      var c = r.ownerDocument.createElement(Gr);
      c.style.cssText = _a(s), c.textContent = Oy(r, l), r.insertBefore(c, a), t.push(c);
    }
  }
  if (n(":before", r.firstChild), n(":after", null), t.length > 0) {
    var i = r.className;
    r.className += " kendo-pdf-hide-pseudo-elements", Bo(r, e), r.className = i, t.forEach(function(o) {
      r.removeChild(o);
    });
  } else
    Bo(r, e);
}
function Bo(r, e) {
  var t = Je(r), n = Pt(t, "top"), i = Pt(t, "right"), o = Pt(t, "bottom"), a = Pt(t, "left"), s = pn(t, "top-left"), l = pn(t, "top-right"), c = pn(t, "bottom-left"), u = pn(t, "bottom-right"), f = V(t, "direction"), h = V(t, "background-color");
  h = Hu(h);
  var d = Bu(V(t, "background-image")), p = lt(V(t, "background-repeat")), m = lt(V(t, "background-position")), v = lt(V(t, "background-origin")), y = lt(V(t, "background-size")), b, k;
  zn && (b = t.textOverflow, b == "ellipsis" && (k = r.style.textOverflow, r.style.textOverflow = "clip")), ct.msie && ct.version < 10 && (m = lt(r.currentStyle.backgroundPosition));
  var M = En(r.getBoundingClientRect(), "border-*-width", r);
  (function() {
    var S = V(t, "clip"), W = /^\s*rect\((.*)\)\s*$/.exec(S);
    if (W) {
      var j = W[1].split(/[ ,]+/g), H = j[0] == "auto" ? M.top : parseFloat(j[0]) + M.top, Z = j[1] == "auto" ? M.right : parseFloat(j[1]) + M.left, C = j[2] == "auto" ? M.bottom : parseFloat(j[2]) + M.top, N = j[3] == "auto" ? M.left : parseFloat(j[3]) + M.left, q = new dt(), de = new Ue().moveTo(N, H).lineTo(Z, H).lineTo(Z, C).lineTo(N, C).close();
      Br(q, de), e.append(q), e = q, $l(de);
    }
  })();
  var D, T, z, _ = V(t, "display");
  if (_ == "table-row")
    for (D = [], T = 0, z = r.children; T < z.length; ++T)
      D.push(z[T].getBoundingClientRect());
  else
    D = r.getClientRects(), D.length == 1 && (D = [r.getBoundingClientRect()]);
  for (D = K(D), T = 0; T < D.length; ++T)
    U(D[T], T === 0, T == D.length - 1);
  if (r.tagName == "A" && r.href && !/^#?$/.test(r.getAttribute("href")) && (!re._avoidLinks || !Pi(r, re._avoidLinks))) {
    var ee = document.createRange();
    ee.selectNodeContents(r), Qt(ee.getClientRects()).forEach(function(S) {
      var W = new dt();
      W._pdfLink = {
        url: r.href,
        top: S.top,
        right: S.right,
        bottom: S.bottom,
        left: S.left
      }, e.append(W);
    });
  }
  return D.length > 0 && _ == "list-item" && !r.getAttribute("kendo-no-bullet") && R(D[0]), function() {
    function S() {
      var W = Ma(r, M, "padding"), j = new dt();
      Br(j, W), e.append(j), e = j, $l(W);
    }
    (_y(r) || /^(hidden|auto|scroll)/.test(V(t, "overflow")) || /^(hidden|auto|scroll)/.test(V(t, "overflow-x")) || /^(hidden|auto|scroll)/.test(V(t, "overflow-y"))) && S();
  }(), My(r, e) || qu(r, e), zn && b == "ellipsis" && (r.style.textOverflow = k), e;
  function K(S) {
    if (/^td$/i.test(r.tagName)) {
      var W = re.table;
      if (W && V(W.style, "border-collapse") == "collapse") {
        var j = Pt(W.style, "left").width, H = Pt(W.style, "top").width;
        if (j === 0 && H === 0)
          return S;
        var Z = W.element.getBoundingClientRect(), C = W.element.rows[0].cells[0], N = C.getBoundingClientRect();
        if (N.top == Z.top || N.left == Z.left)
          return Qt(S).map(function(q) {
            return {
              left: q.left + j,
              top: q.top + H,
              right: q.right + j,
              bottom: q.bottom + H,
              height: q.height,
              width: q.width
            };
          });
      }
    }
    return S;
  }
  function O(S, W, j, H, Z, C, N, q) {
    if (j <= 0)
      return;
    var de, ce = new dt();
    Li(ce, q), e.append(ce), Ta(C), Ta(N), de = new Ue({
      fill: { color: S },
      stroke: null
    }), ce.append(de), de.moveTo(C.x ? Math.max(C.x, H) : 0, 0).lineTo(W - (N.x ? Math.max(N.x, Z) : 0), 0).lineTo(W - Math.max(N.x, Z), j).lineTo(Math.max(C.x, H), j).close(), C.x && be(H, C, [-1, 0, 0, 1, C.x, 0]), N.x && be(Z, N, [1, 0, 0, 1, W - N.x, 0]);
    function be(pe, ue, yt) {
      var wt = Math.PI / 2 * pe / (pe + j), ke = {
        x: ue.x - pe,
        y: ue.y - j
      }, ve = new Ue({
        fill: { color: S },
        stroke: null
      }).moveTo(0, 0);
      Li(ve, yt), sr(ve, 0, ue.y, {
        startAngle: -90,
        endAngle: -Hl(wt),
        radiusX: ue.x,
        radiusY: ue.y
      }), ke.x > 0 && ke.y > 0 ? (ve.lineTo(ke.x * Math.cos(wt), ue.y - ke.y * Math.sin(wt)), sr(ve, 0, ue.y, {
        startAngle: -Hl(wt),
        endAngle: -90,
        radiusX: ke.x,
        radiusY: ke.y,
        anticlockwise: !0
      })) : ke.x > 0 ? ve.lineTo(ke.x, j).lineTo(0, j) : ve.lineTo(ke.x, j).lineTo(ke.x, 0), ce.append(ve.close());
    }
  }
  function ne(S) {
    var W = new dt();
    if (Br(W, Uu(S, s, l, u, c)), e.append(W), h) {
      var j = new Ue({
        fill: { color: h.toCssRgba() },
        stroke: null
      });
      j.moveTo(S.left, S.top).lineTo(S.right, S.top).lineTo(S.right, S.bottom).lineTo(S.left, S.bottom).close(), W.append(j);
    }
    for (var H = d.length; --H >= 0; )
      B(
        W,
        S,
        d[H],
        p[H % p.length],
        m[H % m.length],
        v[H % v.length],
        y[H % y.length]
      );
  }
  function B(S, W, j, H, Z, C, N) {
    if (!j || j == "none")
      return;
    if (j.type == "url") {
      var q = Nr[j.url];
      q && q.width > 0 && q.height > 0 && de(S, W, q.width, q.height, function(ce, be) {
        ce.append(new Tu(j.url, be));
      });
    } else if (j.type == "linear")
      de(S, W, W.width, W.height, Ty(j));
    else
      return;
    function de(ce, be, pe, ue, yt) {
      var wt = pe / ue, ke, ve = be;
      if (C == "content-box" ? (ve = En(ve, "border-*-width", r), ve = En(ve, "padding-*", r)) : C == "padding-box" && (ve = En(ve, "border-*-width", r)), !/^\s*auto(\s+auto)?\s*$/.test(N))
        if (N == "contain")
          ke = Math.min(
            ve.width / pe,
            ve.height / ue
          ), pe *= ke, ue *= ke;
        else if (N == "cover")
          ke = Math.max(
            ve.width / pe,
            ve.height / ue
          ), pe *= ke, ue *= ke;
        else {
          var it = N.split(/\s+/g);
          /%$/.test(it[0]) ? pe = ve.width * parseFloat(it[0]) / 100 : pe = parseFloat(it[0]), it.length == 1 || it[1] == "auto" ? ue = pe / wt : /%$/.test(it[1]) ? ue = ve.height * parseFloat(it[1]) / 100 : ue = parseFloat(it[1]);
        }
      var le = String(Z);
      switch (le) {
        case "bottom":
          le = "50% 100%";
          break;
        case "top":
          le = "50% 0";
          break;
        case "left":
          le = "0 50%";
          break;
        case "right":
          le = "100% 50%";
          break;
        case "center":
          le = "50% 50%";
          break;
      }
      le = le.split(/\s+/), le.length == 1 && (le[1] = "50%"), /%$/.test(le[0]) ? le[0] = parseFloat(le[0]) / 100 * (ve.width - pe) : le[0] = parseFloat(le[0]), /%$/.test(le[1]) ? le[1] = parseFloat(le[1]) / 100 * (ve.height - ue) : le[1] = parseFloat(le[1]);
      var De = new vn([ve.left + le[0], ve.top + le[1]], [pe, ue]);
      function Mn() {
        for (; De.origin.x > be.left; )
          De.origin.x -= pe;
      }
      function _n() {
        for (; De.origin.y > be.top; )
          De.origin.y -= ue;
      }
      function Et() {
        for (; De.origin.x < be.right; )
          yt(ce, De.clone()), De.origin.x += pe;
      }
      if (H == "no-repeat")
        yt(ce, De);
      else if (H == "repeat-x")
        Mn(), Et();
      else if (H == "repeat-y")
        for (_n(); De.origin.y < be.bottom; )
          yt(ce, De.clone()), De.origin.y += ue;
      else if (H == "repeat") {
        Mn(), _n();
        for (var qt = De.origin.clone(); De.origin.y < be.bottom; )
          De.origin.x = qt.x, Et(), De.origin.y += ue;
      }
    }
  }
  function R() {
    var S = V(t, "list-style-type");
    if (S == "none")
      return;
    var W = V(t, "list-style-position");
    function j(Z) {
      ju(r, function() {
        r.style.position = "relative";
        var C = r.ownerDocument.createElement(Gr);
        C.style.position = "absolute", C.style.boxSizing = "border-box", W == "outside" ? (C.style.width = "6em", C.style.left = "-6.8em", C.style.textAlign = "right") : C.style.left = "0px", Z(C), r.insertBefore(C, r.firstChild), $r(C, e), r.removeChild(C);
      });
    }
    function H(Z) {
      var C = r.parentNode.children, N = r.getAttribute("kendo-split-index");
      if (N != null)
        return Z(N | 0, C.length);
      for (var q = 0; q < C.length; ++q)
        if (C[q] === r)
          return Z(q, C.length);
    }
    switch (S) {
      case "circle":
      case "disc":
      case "square":
        j(function(Z) {
          Z.style.fontSize = "60%", Z.style.lineHeight = "200%", Z.style.paddingRight = "0.5em", Z.style.fontFamily = "DejaVu Serif", Z.innerHTML = {
            disc: "●",
            circle: "◯",
            square: "■"
          }[S];
        });
        break;
      case "decimal":
      case "decimal-leading-zero":
        j(function(Z) {
          H(function(C) {
            ++C, S == "decimal-leading-zero" && C < 10 && (C = "0" + C), Z.innerHTML = C + ".";
          });
        });
        break;
      case "lower-roman":
      case "upper-roman":
        j(function(Z) {
          H(function(C) {
            C = ya(C + 1), S == "upper-roman" && (C = C.toUpperCase()), Z.innerHTML = C + ".";
          });
        });
        break;
      case "lower-latin":
      case "lower-alpha":
      case "upper-latin":
      case "upper-alpha":
        j(function(Z) {
          H(function(C) {
            C = Oa(C), /^upper/i.test(S) && (C = C.toUpperCase()), Z.innerHTML = C + ".";
          });
        });
        break;
    }
  }
  function U(S, W, j) {
    if (S.width === 0 || S.height === 0)
      return;
    ne(S);
    var H = a.width > 0 && (W && f == "ltr" || j && f == "rtl"), Z = i.width > 0 && (j && f == "ltr" || W && f == "rtl");
    if (n.width === 0 && a.width === 0 && i.width === 0 && o.width === 0)
      return;
    if (n.color == i.color && n.color == o.color && n.color == a.color && n.width == i.width && n.width == o.width && n.width == a.width && H && Z) {
      S = En(S, n.width / 2);
      var C = Ma(r, S, n.width / 2);
      C.options.stroke = {
        color: n.color,
        width: n.width
      }, e.append(C);
      return;
    }
    if (s.x === 0 && l.x === 0 && u.x === 0 && c.x === 0 && n.width < 2 && a.width < 2 && i.width < 2 && o.width < 2) {
      n.width > 0 && e.append(
        new Ue({
          stroke: { width: n.width, color: n.color }
        }).moveTo(S.left, S.top + n.width / 2).lineTo(S.right, S.top + n.width / 2)
      ), o.width > 0 && e.append(
        new Ue({
          stroke: { width: o.width, color: o.color }
        }).moveTo(S.left, S.bottom - o.width / 2).lineTo(S.right, S.bottom - o.width / 2)
      ), H && e.append(
        new Ue({
          stroke: { width: a.width, color: a.color }
        }).moveTo(S.left + a.width / 2, S.top).lineTo(S.left + a.width / 2, S.bottom)
      ), Z && e.append(
        new Ue({
          stroke: { width: i.width, color: i.color }
        }).moveTo(S.right - i.width / 2, S.top).lineTo(S.right - i.width / 2, S.bottom)
      );
      return;
    }
    var N = Vu(S, s, l, u, c), q = N.tl, de = N.tr, ce = N.br, be = N.bl;
    O(
      n.color,
      S.width,
      n.width,
      a.width,
      i.width,
      q,
      de,
      [1, 0, 0, 1, S.left, S.top]
    ), O(
      o.color,
      S.width,
      o.width,
      i.width,
      a.width,
      ce,
      be,
      [-1, 0, 0, -1, S.right, S.bottom]
    );
    function pe(ue) {
      return { x: ue.y, y: ue.x };
    }
    O(
      a.color,
      S.height,
      a.width,
      o.width,
      n.width,
      pe(be),
      pe(q),
      [0, -1, 1, 0, S.left, S.bottom]
    ), O(
      i.color,
      S.height,
      i.width,
      n.width,
      o.width,
      pe(de),
      pe(ce),
      [0, 1, -1, 0, S.right, S.top]
    );
  }
}
function Ty(r) {
  return function(e, t) {
    var n = t.width(), i = t.height();
    switch (r.type) {
      case "linear":
        var o = r.angle != null ? r.angle : Math.PI;
        switch (r.to) {
          case "top":
            o = 0;
            break;
          case "left":
            o = -Math.PI / 2;
            break;
          case "bottom":
            o = Math.PI;
            break;
          case "right":
            o = Math.PI / 2;
            break;
          case "top left":
          case "left top":
            o = -Math.atan2(i, n);
            break;
          case "top right":
          case "right top":
            o = Math.atan2(i, n);
            break;
          case "bottom left":
          case "left bottom":
            o = Math.PI + Math.atan2(i, n);
            break;
          case "bottom right":
          case "right bottom":
            o = Math.PI - Math.atan2(i, n);
            break;
        }
        r.reverse && (o -= Math.PI), o %= 2 * Math.PI, o < 0 && (o += 2 * Math.PI);
        var a = Math.abs(n * Math.sin(o)) + Math.abs(i * Math.cos(o)), s = Math.atan(n * Math.tan(o) / i), l = Math.sin(s), c = Math.cos(s), u = Math.abs(l) + Math.abs(c), f = u / 2 * l, h = u / 2 * c;
        o > Math.PI / 2 && o <= 3 * Math.PI / 2 && (f = -f, h = -h);
        var d = [], p = 0, m = r.stops.map(function(b, k) {
          var M = b.percent;
          M ? M = parseFloat(M) / 100 : b.length ? M = parseFloat(b.length) / a : k === 0 ? M = 0 : k == r.stops.length - 1 && (M = 1);
          var D = {
            color: b.color.toCssRgba(),
            offset: M
          };
          return M != null ? (p = M, d.forEach(function(T, z) {
            var _ = T.stop;
            _.offset = T.left + (p - T.left) * (z + 1) / (d.length + 1);
          }), d = []) : d.push({ left: p, stop: D }), D;
        }), v = [0.5 - f, 0.5 + h], y = [0.5 + f, 0.5 - h];
        e.append(
          Ue.fromRect(t).stroke(null).fill(new Ag({
            start: v,
            end: y,
            stops: m,
            userSpace: !1
          }))
        );
        break;
      case "radial":
        window.console && window.console.log && window.console.log("Radial gradients are not yet supported in HTML renderer");
        break;
    }
  };
}
function My(r, e) {
  var t;
  if (r._kendoExportVisual)
    t = r._kendoExportVisual();
  else if (window.kendo && window.kendo.jQuery && r.getAttribute(window.kendo.attr("role"))) {
    var n = window.kendo.widgetInstance(window.kendo.jQuery(r));
    n && (n.exportDOMVisual || n.exportVisual) && (n.exportDOMVisual ? t = n.exportDOMVisual() : t = n.exportVisual());
  }
  if (!t)
    return !1;
  var i = new dt();
  i.children.push(t);
  var o = r.getBoundingClientRect();
  return i.transform(Ig().translate(o.left, o.top)), e.append(i), !0;
}
function $o(r, e, t) {
  var n = Wu(r), i = new vn([n.left, n.top], [n.width, n.height]), o = new Tu(e, i);
  Br(o, Ma(r, n, "content")), t.append(o);
}
function Ho(r, e) {
  var t = Je(r), n = Je(e), i = parseFloat(V(t, "z-index")), o = parseFloat(V(n, "z-index")), a = V(t, "position"), s = V(n, "position");
  return isNaN(i) && isNaN(o) ? /static|absolute/.test(a) && /static|absolute/.test(s) ? 0 : a == "static" ? -1 : s == "static" ? 1 : 0 : isNaN(i) ? o === 0 ? 0 : o > 0 ? -1 : 1 : isNaN(o) ? i === 0 ? 0 : i > 0 ? 1 : -1 : parseFloat(i) - parseFloat(o);
}
function _y(r) {
  return /^(?:textarea|select|input)$/i.test(r.tagName);
}
function Iy(r) {
  return r.selectedOptions && r.selectedOptions.length > 0 ? r.selectedOptions[0] : r.options[r.selectedIndex];
}
function Dy(r, e) {
  var t = Je(r), n = V(t, "color"), i = r.getBoundingClientRect();
  r.type == "checkbox" ? (e.append(
    Ue.fromRect(
      new vn(
        [i.left + 1, i.top + 1],
        [i.width - 2, i.height - 2]
      )
    ).stroke(n, 1)
  ), r.checked && e.append(
    new Ue().stroke(n, 1.2).moveTo(
      i.left + 0.22 * i.width,
      i.top + 0.55 * i.height
    ).lineTo(
      i.left + 0.45 * i.width,
      i.top + 0.75 * i.height
    ).lineTo(
      i.left + 0.78 * i.width,
      i.top + 0.22 * i.width
    )
  )) : (e.append(
    new Il(
      new Dl([
        (i.left + i.right) / 2,
        (i.top + i.bottom) / 2
      ], Math.min(i.width - 2, i.height - 2) / 2)
    ).stroke(n, 1)
  ), r.checked && e.append(
    new Il(
      new Dl([
        (i.left + i.right) / 2,
        (i.top + i.bottom) / 2
      ], Math.min(i.width - 8, i.height - 8) / 2)
    ).fill(n).stroke(null)
  ));
}
function Ey(r, e) {
  var t = r.tagName.toLowerCase();
  if (t == "input" && (r.type == "checkbox" || r.type == "radio"))
    return Dy(r, e);
  var n = r.parentNode, i = r.ownerDocument, o = i.createElement(Gr), a;
  if (o.style.cssText = _a(Je(r)), t == "input" && (o.style.whiteSpace = "pre"), (t == "select" || t == "textarea") && (o.style.overflow = "auto"), t == "select")
    if (r.multiple)
      for (var s = 0; s < r.options.length; ++s)
        a = i.createElement(Gr), a.style.cssText = _a(Je(r.options[s])), a.style.display = "block", a.textContent = r.options[s].textContent, o.appendChild(a);
    else
      a = Iy(r), a && (o.textContent = a.textContent);
  else
    o.textContent = r.value;
  n.insertBefore(o, r), o.scrollLeft = r.scrollLeft, o.scrollTop = r.scrollTop, r.style.display = "none", qu(o, e), r.style.display = "", n.removeChild(o);
}
function Ay(r) {
  var e = new window.XMLSerializer(), t = e.serializeToString(r);
  if (ct.mozilla && !(r.getAttribute("width") && r.getAttribute("height"))) {
    var n = new window.DOMParser().parseFromString(t, "image/svg+xml"), i = n.documentElement, o = Wu(r);
    i.setAttribute("width", o.width), i.setAttribute("height", o.height), t = e.serializeToString(i);
  }
  return t;
}
function qu(r, e) {
  switch (re._stackingContext.element === r && (re._stackingContext.group = e), r.tagName.toLowerCase()) {
    case "img":
      $o(r, r.src, e);
      break;
    case "svg":
      var t = Ay(r), n = "data:image/svg+xml;base64," + xu(t);
      $o(r, n, e);
      break;
    case "canvas":
      try {
        $o(r, r.toDataURL("image/png"), e);
      } catch {
      }
      break;
    case "textarea":
    case "input":
    case "select":
      Ey(r, e);
      break;
    default:
      for (var i = [], o = [], a = [], s = r.firstChild; s; s = s.nextSibling)
        switch (s.nodeType) {
          case 3:
            /\S/.test(s.data) && Ny(r, s, e);
            break;
          case 1:
            var l = Je(s), c = V(l, "float"), u = V(l, "position");
            u != "static" ? a.push(s) : c != "none" ? o.push(s) : i.push(s);
            break;
        }
      Po(i, Ho).forEach(function(f) {
        $r(f, e);
      }), Po(o, Ho).forEach(function(f) {
        $r(f, e);
      }), Po(a, Ho).forEach(function(f) {
        $r(f, e);
      });
  }
}
function Ny(r, e, t) {
  if (Sy())
    return;
  var n = Je(r);
  if (parseFloat(V(n, "text-indent")) < -500)
    return;
  var i = e.data, o = 0, a = i.search(/\S\s*$/) + 1;
  if (!a)
    return;
  var s = V(n, "font-size"), l = V(n, "line-height"), c = [
    V(n, "font-style"),
    V(n, "font-variant"),
    V(n, "font-weight"),
    s,
    // no need for line height here; it breaks layout in FF
    V(n, "font-family")
  ].join(" ");
  if (s = parseFloat(s), l = parseFloat(l), s === 0 || isNaN(s))
    return;
  var u = V(n, "color"), f = r.ownerDocument.createRange(), h = V(n, "text-align"), d = h == "justify", p = V(n, "column-count", 1), m = V(n, "white-space"), v = V(n, "text-transform"), y = r.getBoundingClientRect().width / s * 5;
  y === 0 && (y = 500);
  var b = null, k = re.underline, M = re["line-through"], D = re.overline, T = re["underline-offset"];
  for (k && z(B); !ee(); )
    ;
  (M || D) && z(ne);
  return;
  function z(R) {
    f.selectNode(e);
    var U = Qt(f.getClientRects());
    z = function(S) {
      return U.forEach(S);
    }, z(R);
  }
  function _(R) {
    if (zn || ct.chrome || ct.safari) {
      for (var U = R.getClientRects(), S = {
        top: 1 / 0,
        right: -1 / 0,
        bottom: -1 / 0,
        left: 1 / 0
      }, W = !1, j = 0; j < U.length; ++j) {
        var H = U[j];
        H.width <= 1 || H.bottom === b || (S.left = Math.min(H.left, S.left), S.top = Math.min(H.top, S.top), S.right = Math.max(H.right, S.right), S.bottom = Math.max(H.bottom, S.bottom), W = !0);
      }
      return W ? (S.width = S.right - S.left, S.height = S.bottom - S.top, S) : R.getBoundingClientRect();
    }
    return R.getBoundingClientRect();
  }
  function ee() {
    var R = o, U, S = i.substr(o).search(/\S/);
    if (o += S, S < 0 || o >= a)
      return !0;
    f.setStart(e, o), f.setEnd(e, o + 1), U = _(f);
    var W = !1;
    if ((d || p > 1) && (S = i.substr(o).search(/\s/), S >= 0)) {
      f.setEnd(e, o + S);
      var j = _(f);
      j.bottom == U.bottom && (U = j, W = !0, o += S);
    }
    if (!W) {
      if (S = function q(de, ce, be) {
        f.setEnd(e, ce);
        var pe = _(f);
        return pe.bottom != U.bottom && de < ce ? q(de, de + ce >> 1, ce) : pe.right != U.right ? (U = pe, ce < be ? q(ce, ce + be >> 1, be) : ce) : ce;
      }(o, Math.min(a, o + y), a), S == o)
        return !0;
      if (o = S, S = f.toString().search(/\s+$/), S === 0)
        return !1;
      S > 0 && (f.setEnd(e, f.startOffset + S), U = _(f));
    }
    zn && (U = f.getClientRects()[0]);
    var H = f.toString();
    if (!/^(?:pre|pre-wrap)$/i.test(m))
      H = H.replace(/\s+/g, " ");
    else if (/\t/.test(H)) {
      var Z = 0;
      for (S = R; S < f.startOffset; ++S) {
        var C = i.charCodeAt(S);
        C == 9 ? Z += 8 - Z % 8 : C == 10 || C == 13 ? Z = 0 : Z++;
      }
      for (; (S = H.search("	")) >= 0; ) {
        var N = "        ".substr(0, 8 - (Z + S) % 8);
        H = H.substr(0, S) + N + H.substr(S + 1);
      }
    }
    W || (b = U.bottom), K(H, U);
  }
  function K(R, U) {
    if (zn && !isNaN(l)) {
      var S = dy(c), W = (U.top + U.bottom - S) / 2;
      U = {
        top: W,
        right: U.right,
        bottom: W + S,
        left: U.left,
        height: S,
        width: U.right - U.left
      };
    }
    switch (v) {
      case "uppercase":
        R = R.toUpperCase();
        break;
      case "lowercase":
        R = R.toLowerCase();
        break;
      case "capitalize":
        R = R.replace(/(?:^|\s)\S/g, function(H) {
          return H.toUpperCase();
        });
        break;
    }
    var j = new sy(
      R,
      new vn(
        [U.left, U.top],
        [U.width, U.height]
      ),
      {
        font: c,
        fill: { color: u }
      }
    );
    t.append(j);
  }
  function O(R, U, S, W) {
    if (S) {
      var j = new Ue({ stroke: {
        width: R,
        color: S
      } });
      W -= R, j.moveTo(U.left, W).lineTo(U.right, W), t.append(j);
    }
  }
  function ne(R) {
    var U = s / 12;
    O(U, R, M, R.bottom - R.height / 2.7), O(U, R, D, R.top);
  }
  function B(R) {
    var U = s / 12, S = R.bottom;
    T != null ? S += T : S += U, O(U, R, k, S);
  }
}
function Ry(r, e, t) {
  var n;
  t != "auto" ? (n = re._stackingContext.group, t = parseFloat(t)) : (n = e, t = 0);
  for (var i = n.children, o = 0; o < i.length && !(i[o]._dom_zIndex != null && i[o]._dom_zIndex > t); ++o)
    ;
  var a = new dt();
  if (n.insert(o, a), a._dom_zIndex = t, n !== e && re._clipbox) {
    var s = re._matrix.invert(), l = re._clipbox.transformCopy(s);
    Br(a, Ue.fromRect(l));
  }
  return a;
}
function $r(r, e) {
  var t = Je(r);
  if ($u(t), !/^(style|script|link|meta|iframe|col|colgroup)$/i.test(r.tagName) && re._clipbox != null) {
    var n = parseFloat(V(t, "opacity")), i = V(t, "visibility"), o = V(t, "display");
    if (!(n === 0 || i == "hidden" || o == "none")) {
      var a = ky(t), s, l = V(t, "z-index");
      (a || n < 1) && l == "auto" && (l = 0), s = Ry(r, e, l), n < 1 && s.opacity(n * s.opacity()), wy(r, t, s), a ? ju(r, function() {
        zo(r.style, "transform", "none", "important"), zo(r.style, "transition", "none", "important"), V(t, "position") == "static" && zo(r.style, "position", "relative", "important");
        var c = r.getBoundingClientRect(), u = c.left + a.origin[0], f = c.top + a.origin[1], h = [1, 0, 0, 1, -u, -f];
        h = Vl(h, a.matrix), h = Vl(h, [1, 0, 0, 1, u, f]), h = Li(s, h), re._matrix = re._matrix.multiplyCopy(h), Wl(r, s);
      }) : Wl(r, s), by();
    }
  }
}
function Vl(r, e) {
  var t = r[0], n = r[1], i = r[2], o = r[3], a = r[4], s = r[5], l = e[0], c = e[1], u = e[2], f = e[3], h = e[4], d = e[5];
  return [
    t * l + n * u,
    t * c + n * f,
    i * l + o * u,
    i * c + o * f,
    a * l + s * u + h,
    a * c + s * f + d
  ];
}
var at = function() {
}, Ul = function(r, e) {
  var t = g.useContext(r), n = t[0], i = t[1], o = g.useState(e), a = o[0], s = o[1], l = n !== void 0 ? n : a, c = function() {
    for (var u = [], f = 0; f < arguments.length; f++)
      u[f] = arguments[f];
    n !== void 0 ? i.apply(void 0, u) : s(u[0]);
  };
  return [
    l,
    c
  ];
}, Py = g.createContext([
  void 0,
  at
]), Ly = g.createContext([
  void 0,
  at
]), Fy = g.createContext([[], at, at]), zy = g.createContext([[], at, at]), By = 2e3;
function $y(r, e, t) {
  t === void 0 && (t = {});
  var n = e.onPress, i = n === void 0 ? at : n, o = e.onRelease, a = o === void 0 ? at : o, s = e.onDragStart, l = s === void 0 ? at : s, c = e.onDrag, u = c === void 0 ? at : c, f = e.onDragEnd, h = f === void 0 ? at : f, d = t.hint, p = d === void 0 ? null : d, m = t.mouseOnly, v = m === void 0 ? !1 : m, y = t.autoScroll, b = y === void 0 ? !0 : y, k = t.scrollContainer, M = k === void 0 ? null : k, D = g.useState(!1), T = D[0], z = D[1], _ = g.useState(!1), ee = _[0], K = _[1], O = Ul(Ly)[0], ne = Ul(Py), B = ne[0], R = ne[1], U = g.useContext(zy)[0], S = g.useContext(Fy), W = S[0], j = S[1], H = S[2], Z = g.useRef({ x: 0, y: 0 }), C = g.useRef(), N = g.useRef(!1), q = g.useRef(), de = g.useRef(null), ce = g.useRef(!1), be = g.useRef({ x: 0, y: 0 }), pe = g.useRef({ x: 0, y: 0 }), ue = g.useRef({ x: 0, y: 0 }), yt = g.useRef({ x: 0, y: 0 }), wt = g.useRef({ x: 0, y: 0 }), ke = g.useRef({ x: 0, y: 0 }), ve = !!(typeof window < "u" && window.PointerEvent), it = !v && ve, le = g.useCallback(function() {
    return r.current && r.current.element ? r.current.element : r.current;
  }, [r]), De = g.useCallback(function() {
    return p && p.current && p.current.element ? p.current.element : p ? p.current : null;
  }, [p]), Mn = g.useCallback(function() {
    return M && M.current && M.current.element ? M.current.element : M ? M.current : null;
  }, [M]), _n = g.useCallback(function() {
    return typeof b == "object" && b.boundaryElementRef && b.boundaryElementRef.current && b.boundaryElementRef.current.element ? b.boundaryElementRef.current.element : typeof b == "object" && b.boundaryElementRef && b.boundaryElementRef.current ? b.boundaryElementRef.current : null;
  }, [b]), Et = g.useRef(null);
  g.useImperativeHandle(Et, function() {
    return {
      element: le(),
      hint: De(),
      onPress: Xp,
      onDragStart: Zp,
      onDrag: Qp,
      onDragEnd: em,
      onRelease: Yp,
      data: r.current
    };
  });
  var qt = g.useCallback(function() {
    var L = le();
    return L && L.ownerDocument || document;
  }, [le]), rn = g.useCallback(function() {
    var L = qt();
    return L && L.defaultView || window;
  }, [qt]), Tr = g.useCallback(function() {
    return {
      drag: B ? B.current : null,
      drop: O ? O.current : null,
      drags: W.map(function(L) {
        return L.current;
      }),
      drops: U.map(function(L) {
        return L.current;
      }),
      pressed: T,
      ignoreMouse: N.current,
      scrollOffset: wt.current,
      offset: be.current,
      pageOffset: pe.current,
      initialScrollOffset: ke.current,
      clientOffset: ue.current,
      initialClientOffset: yt.current,
      velocity: Z.current,
      autoScroll: !!(typeof b == "object" ? b.enabled !== !1 : b),
      scrollableParent: _n(),
      autoScrollDirection: typeof b == "object" ? b.direction : { horizontal: !0, vertical: !0 },
      isScrolling: ee
    };
  }, [B, O, W, U, T, b, _n, ee]), di = g.useCallback(function(L) {
    z(L);
  }, []), pi = g.useCallback(function(L) {
    K(L);
  }, []), w = g.useCallback(function(L) {
    Z.current = L;
  }, []), x = g.useCallback(function(L) {
    be.current = L;
  }, []), gl = g.useCallback(function(L) {
    ue.current = L;
  }, []), vl = g.useCallback(function(L) {
    pe.current = L;
  }, []), yl = g.useCallback(function(L) {
    yt.current = L;
  }, []), wl = g.useCallback(function(L) {
    wt.current = L;
  }, []), bl = g.useCallback(function(L) {
    ke.current = L;
  }, []), Xp = g.useCallback(function(L) {
    i(L);
  }, [i]), Yp = g.useCallback(function(L) {
    a(L);
  }, [a]), Zp = g.useCallback(function(L) {
    R(Et, { target: r.current, event: L }), l(L);
  }, [R, r, l]), Qp = g.useCallback(function(L) {
    u(L);
  }, [u]), em = g.useCallback(function(L) {
    ce.current || (R(null, { target: r.current, event: L }), h(L));
  }, [h, R, r]), Se = g.useCallback(function(L) {
    sg(Tr(), { event: L, payload: Et.current }, {
      onVelocityChange: w,
      onOffsetChange: x,
      onClientOffsetChange: gl,
      onPageOffsetChange: vl,
      onInitialClientOffsetChange: yl,
      onScrollOffsetChange: wl,
      onInitialScrollOffsetChange: bl,
      onIsPressedChange: di,
      onIsScrollingChange: pi
    });
  }, [
    Tr,
    w,
    x,
    vl,
    gl,
    yl,
    bl,
    di,
    wl,
    pi
  ]), ko = g.useCallback(function(L) {
    Se(L);
  }, [Se]), xo = g.useCallback(function(L) {
    Se(L);
  }, [Se]), Oo = g.useCallback(function(L) {
    Se(L);
  }, [Se]), To = g.useCallback(function(L) {
    Se(L);
  }, [Se]), Mo = g.useCallback(function(L) {
    Se(L);
  }, [Se]), _o = g.useCallback(function(L) {
    Se(L);
  }, [Se]), Io = g.useCallback(function(L) {
    Se(L);
  }, [Se]), Do = g.useCallback(function(L) {
    L.preventDefault(), Se(L);
  }, [Se]), Eo = g.useCallback(function(L) {
    L.preventDefault(), Se(L);
  }, [Se]), Ao = g.useCallback(function(L) {
    L.preventDefault(), Se(L);
  }, [Se]), No = g.useCallback(function(L) {
    if (L.touches.length === 0 && L.changedTouches.length === 1) {
      var Ie = rn();
      N.current = !0, q.current = Ie.setTimeout(function() {
        N.current = !1;
      }, By);
    }
    Se(L);
  }, [Se, rn]), Ro = g.useCallback(function(L) {
    Se(L);
  }, [Se]), Sl = g.useCallback(function() {
    var L = le();
    if (L) {
      var Ie = L.style.touchAction;
      return L.style.touchAction = "none", function() {
        L.style.touchAction = Ie;
      };
    }
  }, [le]), Cl = g.useCallback(function() {
    return j(Et), function() {
      H(Et);
    };
  }, [H, j]), tm = function() {
    var L = rn(), Ie = le(), ft = qt();
    return it ? (Ie && (de.current = kl(Ie), de.current && de.current.addEventListener("scroll", Ro, { passive: !0 }), Ie.addEventListener("pointerdown", ko, { passive: !0 })), T && (ft.addEventListener("pointermove", xo), ft.addEventListener("pointerup", To, !0), ft.addEventListener("contextmenu", Do), ft.addEventListener("pointercancel", Oo, { passive: !0 }))) : (L.addEventListener("touchmove", at, { capture: !1, passive: !1 }), Ie && (Ie.addEventListener("mousedown", Mo, { passive: !0 }), v || (Ie.addEventListener("touchstart", Eo, { passive: !0 }), T && (Ie.addEventListener("touchmove", Ao, { passive: !0 }), Ie.addEventListener("touchend", No, { passive: !0 })))), T && (ft.addEventListener("mousemove", _o, { passive: !0 }), ft.addEventListener("mouseup", Io, { passive: !0 }))), function() {
      de.current && de.current.removeEventListener("scroll", Ro), Ie && (Ie.removeEventListener("pointerdown", ko), Ie.removeEventListener("mousedown", Mo), Ie.removeEventListener("touchstart", Eo), Ie.removeEventListener("touchmove", Ao), Ie.removeEventListener("touchend", No)), ft.removeEventListener("pointermove", xo), ft.removeEventListener("pointerup", To, !0), ft.removeEventListener("contextmenu", Do), ft.removeEventListener("pointercancel", Oo), ft.removeEventListener("mousemove", _o), ft.removeEventListener("mouseup", Io), L.removeEventListener("touchmove", at), L.clearTimeout(q.current);
    };
  };
  g.useEffect(function() {
    var L = rn();
    if (ee) {
      var Ie = Mn() || kl(document.elementFromPoint(ue.current.x, ue.current.y));
      L.clearInterval(C.current), C.current = L.setInterval(function() {
        lg(Ie, { x: Z.current.x, y: Z.current.y });
      }, 50);
    }
    return function() {
      L.clearInterval(C.current);
    };
  }, [le, Mn, rn, ee]), g.useEffect(Sl, [Sl]), g.useEffect(tm, [
    T,
    rn,
    le,
    qt,
    v,
    it,
    Do,
    Mo,
    _o,
    Io,
    Oo,
    ko,
    xo,
    To,
    No,
    Ao,
    Eo,
    Ro
  ]), g.useEffect(function() {
    return ce.current = !1, function() {
      ce.current = !0;
    };
  }, []), g.useLayoutEffect(Cl, [Cl]);
}
var zs = g.forwardRef(function(r, e) {
  var t = g.useRef(null), n = g.useRef(null), i = g.useCallback(function() {
    return t.current && t.current.element ? t.current.element : t.current;
  }, [t]);
  g.useImperativeHandle(n, function() {
    return { element: i() || null };
  }), g.useImperativeHandle(e, function() {
    return n.current;
  }), g.useImperativeHandle(r.childRef, function() {
    return t.current;
  });
  var o = g.useCallback(function(u) {
    r.onPress && r.onPress({
      element: i(),
      target: n.current,
      event: u
    });
  }, [i, r.onPress]), a = g.useCallback(function(u) {
    r.onRelease && r.onRelease({
      element: i(),
      target: n.current,
      event: u
    });
  }, [i, r.onRelease]), s = g.useCallback(function(u) {
    r.onDragStart && r.onDragStart({
      element: i(),
      target: n.current,
      event: u
    });
  }, [r, i]), l = g.useCallback(function(u) {
    r.onDrag && r.onDrag({
      element: i(),
      target: n.current,
      event: u
    });
  }, [i, r.onDrag]), c = g.useCallback(function(u) {
    r.onDragEnd && r.onDragEnd({
      element: i(),
      target: n.current,
      event: u
    });
  }, [i, r.onDragEnd]);
  return $y(t, {
    onPress: o,
    onRelease: a,
    onDragStart: s,
    onDrag: l,
    onDragEnd: c
  }, {
    mouseOnly: r.mouseOnly,
    autoScroll: r.autoScroll,
    hint: r.hint,
    scrollContainer: r.scrollContainer
  }), r.children ? g.cloneElement(g.Children.only(r.children), { ref: t }) : null;
});
zs.displayName = "KendoReactDraggable";
var se;
(function(r) {
  r.DEFAULT = "DEFAULT", r.FULLSCREEN = "FULLSCREEN", r.MINIMIZED = "MINIMIZED";
})(se || (se = {}));
var tr, Ia = "dialogs.windowMaximizeButton", Da = "dialogs.windowMinimizeButton", Ea = "dialogs.windowRestoreButton", Aa = "dialogs.windowCloseButton", gi = (tr = {}, tr[Ia] = "maximize", tr[Da] = "minimize", tr[Ea] = "restore", tr[Aa] = "close", tr), Na = globalThis && globalThis.__assign || function() {
  return Na = Object.assign || function(r) {
    for (var e, t = 1, n = arguments.length; t < n; t++) {
      e = arguments[t];
      for (var i in e)
        Object.prototype.hasOwnProperty.call(e, i) && (r[i] = e[i]);
    }
    return r;
  }, Na.apply(this, arguments);
}, Hy = function(r) {
  var e = r.children, t = r.onCloseButtonClick, n = r.onMinimizeButtonClick, i = r.onFullScreenButtonClick, o = r.onRestoreButtonClick, a = r.onDoubleClick, s = r.stage, l = r.forwardedRef, c = r.id, u = Cn(), f = r.minimizeButton ? g.createElement(r.minimizeButton, { onClick: n, stage: s }) : g.createElement(he, { fillMode: "flat", icon: "window-minimize", svgIcon: fm, className: "k-window-titlebar-action", onClick: n, "aria-label": u.toLanguageString(Da, gi[Da]) }), h = r.maximizeButton ? g.createElement(r.maximizeButton, { onClick: i, stage: s }) : g.createElement(he, { fillMode: "flat", icon: "window-maximize", svgIcon: hm, className: "k-window-titlebar-action", onClick: i, "aria-label": u.toLanguageString(Ia, gi[Ia]) }), d = r.restoreButton ? g.createElement(r.restoreButton, { onClick: o, stage: s }) : g.createElement(he, { fillMode: "flat", icon: "window-restore", svgIcon: dm, className: "k-window-titlebar-action", onClick: o, "aria-label": u.toLanguageString(Ea, gi[Ea]) }), p = r.closeButton ? g.createElement(r.closeButton, { onClick: t, stage: s }) : g.createElement(he, { fillMode: "flat", icon: "x", svgIcon: pm, className: "k-window-titlebar-action", onClick: t, "aria-label": u.toLanguageString(Aa, gi[Aa]) });
  return g.createElement(
    "div",
    { className: "k-window-titlebar", style: { touchAction: "none" }, ref: l, onDoubleClick: a },
    g.createElement("div", { className: "k-window-title", id: c }, e || ""),
    g.createElement(
      "div",
      { className: "k-window-titlebar-actions" },
      s === se.DEFAULT && f,
      s === se.DEFAULT && h,
      s !== se.DEFAULT && d,
      p
    )
  );
}, jy = g.forwardRef(function(r, e) {
  return g.createElement(Hy, Na({}, r, { forwardedRef: e }));
}), Wy = globalThis && globalThis.__extends || function() {
  var r = function(e, t) {
    return r = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i)
        Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, r(e, t);
  };
  return function(e, t) {
    if (typeof t != "function" && t !== null)
      throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
    r(e, t);
    function n() {
      this.constructor = e;
    }
    e.prototype = t === null ? Object.create(t) : (n.prototype = t.prototype, new n());
  };
}(), Vy = ["n", "e", "s", "w", "se", "sw", "ne", "nw"], Uy = (
  /** @class */
  function(r) {
    Wy(e, r);
    function e() {
      return r !== null && r.apply(this, arguments) || this;
    }
    return e.prototype.render = function() {
      var t = this;
      return g.createElement(
        "div",
        { className: "k-resize-handles-wrapper" },
        " ",
        Vy.map(function(n, i) {
          return g.createElement(
            zs,
            { key: i, onDrag: function(o) {
              var a = o.event;
              a.originalEvent.preventDefault(), t.props.onResize(a, { end: !1, direction: n });
            }, onRelease: function(o) {
              var a = o.event;
              a.originalEvent.preventDefault(), t.props.onResize(a, { end: !0, direction: n });
            } },
            g.createElement("div", { className: "k-resize-handle k-resize-" + n, style: { display: "block", touchAction: "none" } })
          );
        })
      );
    }, e;
  }(g.Component)
), qy = globalThis && globalThis.__extends || function() {
  var r = function(e, t) {
    return r = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i)
        Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, r(e, t);
  };
  return function(e, t) {
    if (typeof t != "function" && t !== null)
      throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
    r(e, t);
    function n() {
      this.constructor = e;
    }
    e.prototype = t === null ? Object.create(t) : (n.prototype = t.prototype, new n());
  };
}(), Ky = (
  /** @class */
  function(r) {
    qy(e, r);
    function e() {
      return r !== null && r.apply(this, arguments) || this;
    }
    return e.prototype.shouldComponentUpdate = function(t) {
      return t.shouldUpdateOnDrag || !t.isDragging;
    }, e.prototype.render = function() {
      return this.props.children;
    }, e;
  }(g.Component)
), gr = function(r) {
  var e = r.layout, t = e === void 0 ? Gy.layout : e, n = r.children, i = Cu("k-actions", "k-window-actions", "k-actions-horizontal", "k-hstack", {
    "k-justify-content-start": t === "start",
    "k-justify-content-center": t === "center",
    "k-justify-content-end": t === "end",
    "k-justify-content-stretch": t === "stretched"
  });
  return g.createElement("div", { className: i }, n);
};
gr.propTypes = {
  children: E.any,
  layout: E.oneOf(["start", "center", "end", "stretched"])
};
var Gy = {
  layout: "end"
}, Jy = globalThis && globalThis.__extends || function() {
  var r = function(e, t) {
    return r = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i)
        Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, r(e, t);
  };
  return function(e, t) {
    if (typeof t != "function" && t !== null)
      throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
    r(e, t);
    function n() {
      this.constructor = e;
    }
    e.prototype = t === null ? Object.create(t) : (n.prototype = t.prototype, new n());
  };
}(), Hr = globalThis && globalThis.__assign || function() {
  return Hr = Object.assign || function(r) {
    for (var e, t = 1, n = arguments.length; t < n; t++) {
      e = arguments[t];
      for (var i in e)
        Object.prototype.hasOwnProperty.call(e, i) && (r[i] = e[i]);
    }
    return r;
  }, Hr.apply(this, arguments);
}, ql = 300, Kl = 300, jo = 120, Wo = 100, At = 5, Xy = (
  /** @class */
  function(r) {
    Jy(e, r);
    function e(t) {
      var n = r.call(this, t) || this;
      return n.context = 0, n.draggable = null, n.offSetCoordinates = { x: 0, y: 0 }, n._id = cg(), n.titleId = n.generateTitleId(), n.mounted = !1, n.onKeyDown = function(i) {
        if (i.target === i.currentTarget) {
          var o = n.props.minWidth || jo, a = n.props.minHeight || Wo;
          if (i.ctrlKey && n.props.resizable) {
            switch (i.keyCode) {
              case bt.up:
                i.preventDefault(), a <= n.height - At && n.setState({ height: n.height - At });
                break;
              case bt.down:
                i.preventDefault(), n.setState({ height: n.height + At });
                break;
              case bt.left:
                o <= n.width - At && n.setState({ width: n.width - At });
                break;
              case bt.right:
                n.setState({ width: n.width + At });
                break;
              default:
                return;
            }
            n.dispatchMoveEvent(n.props.onResize, i, !1, void 0);
            return;
          }
          if (i.altKey) {
            switch (i.keyCode) {
              case bt.up:
                n.windowStage === se.MINIMIZED ? (n.handleRestore(i), on(n.props.onStageChange, i, n, { state: se.DEFAULT })) : n.windowStage === se.DEFAULT && (n.handleFullscreen(i), on(n.props.onStageChange, i, n, { state: se.FULLSCREEN }));
                break;
              case bt.down:
                n.windowStage === se.FULLSCREEN ? (n.handleRestore(i), on(n.props.onStageChange, i, n, { state: se.DEFAULT })) : n.windowStage === se.DEFAULT && (n.handleMinimize(i), on(n.props.onStageChange, i, n, { state: se.MINIMIZED }));
                break;
            }
            return;
          }
          if (!i.ctrlKey)
            switch (i.keyCode) {
              case bt.esc:
                n.props.onClose && n.handleCloseWindow(i);
                return;
              case bt.up:
                n.setState({ top: n.state.top - At });
                break;
              case bt.down:
                n.setState({ top: n.state.top + At });
                break;
              case bt.left:
                n.setState({ left: n.state.left - At });
                break;
              case bt.right:
                n.setState({ left: n.state.left + At });
                break;
              default:
                return;
            }
          n.dispatchMoveEvent(n.props.onMove, i, !1, void 0);
        }
      }, n.onPress = function(i) {
        var o = i.event;
        n.windowCoordinatesState.differenceLeft = o.pageX - n.left, n.windowCoordinatesState.differenceTop = o.pageY - n.top;
      }, n.onDrag = function(i) {
        var o = i.event;
        o.originalEvent.preventDefault(), n.windowStage !== se.FULLSCREEN && n.props.draggable && (n.setState({
          top: Math.max(o.pageY - n.windowCoordinatesState.differenceTop, 0),
          left: o.pageX - n.windowCoordinatesState.differenceLeft,
          isDragging: !0
        }), n.props.onMove && n.dispatchMoveEvent(n.props.onMove, o, !0, !1));
      }, n.onRelease = function(i) {
        var o = i.event;
        n.windowStage !== se.FULLSCREEN && n.props.draggable && n.props.onMove && n.dispatchMoveEvent(n.props.onMove, o, !0, !0), n.setState({
          isDragging: !1
        });
      }, n.onFocus = function() {
        n._blurTimeout ? (clearTimeout(n._blurTimeout), n._blurTimeout = void 0) : n.setState({
          focused: !0,
          zIndex: xl(n.getCurrentZIndex(), n.getDocument(), n._id)
        });
      }, n.onBlur = function() {
        clearTimeout(n._blurTimeout);
        var i = n.getWindow();
        i && (n._blurTimeout = i.setTimeout(function() {
          n.mounted && n.setState({ focused: !1 }), n._blurTimeout = void 0;
        }));
      }, n.getInitialTop = function() {
        if (n.props.top !== void 0)
          return n.props.top;
        if (n.props.initialTop !== void 0)
          return n.props.initialTop;
        var i = Kl;
        if (n.props.height !== void 0 ? i = n.props.height : n.props.initialHeight !== void 0 && (i = n.props.initialHeight), n.props.appendTo)
          return n.props.appendTo.offsetHeight / 2 - i / 2;
        var o = n.getWindow();
        return o ? o.innerHeight / 2 - i / 2 : 0;
      }, n.getInitialLeft = function() {
        if (n.props.left !== void 0)
          return n.props.left;
        if (n.props.initialLeft !== void 0)
          return n.props.initialLeft;
        var i = ql;
        if (n.props.width !== void 0 ? i = n.props.width : n.props.initialWidth !== void 0 && (i = n.props.initialWidth), n.props.appendTo)
          return n.props.appendTo.offsetWidth / 2 - i / 2;
        var o = n.getWindow();
        return o ? o.innerWidth / 2 - i / 2 : 0;
      }, n.getInitialWidth = function() {
        var i = ql;
        return n.props.width !== void 0 ? i = n.props.width : n.props.initialWidth !== void 0 && (i = n.props.initialWidth), i;
      }, n.getInitialHeight = function() {
        var i = Kl;
        return n.props.height !== void 0 ? i = n.props.height : n.props.initialHeight !== void 0 && (i = n.props.initialHeight), i;
      }, n.handleMinimize = function(i) {
        i.preventDefault(), n.windowCoordinatesState.leftBeforeAction = n.left, n.windowCoordinatesState.topBeforeAction = n.top, n.windowCoordinatesState.widthBeforeAction = n.width, n.windowCoordinatesState.heightBeforeAction = n.height, n.setState({
          stage: se.MINIMIZED,
          height: 0
        }), on(n.props.onStageChange, i, n, { state: se.MINIMIZED });
      }, n.handleFullscreen = function(i) {
        i.preventDefault(), n.windowCoordinatesState.leftBeforeAction = n.left, n.windowCoordinatesState.topBeforeAction = n.top, n.windowCoordinatesState.widthBeforeAction = n.width, n.windowCoordinatesState.heightBeforeAction = n.height;
        var o = n.getWindow(), a = o ? o.innerWidth : 0, s = o ? o.innerHeight : 0;
        n.setState({
          left: 0,
          top: 0,
          width: n.props.appendTo ? n.props.appendTo.offsetWidth : a,
          height: n.props.appendTo ? n.props.appendTo.offsetHeight : s,
          stage: se.FULLSCREEN
        }), on(n.props.onStageChange, i, n, { state: se.FULLSCREEN });
      }, n.handleRestore = function(i) {
        i.preventDefault(), n.windowStage === se.FULLSCREEN ? n.setState({
          stage: se.DEFAULT,
          left: n.windowCoordinatesState.leftBeforeAction,
          top: n.windowCoordinatesState.topBeforeAction,
          width: n.windowCoordinatesState.widthBeforeAction,
          height: n.windowCoordinatesState.heightBeforeAction
        }) : n.windowStage === se.MINIMIZED && n.setState({
          stage: se.DEFAULT,
          height: n.windowCoordinatesState.heightBeforeAction
        }), on(n.props.onStageChange, i, n, { state: se.DEFAULT });
      }, n.handleCloseWindow = function(i) {
        i.preventDefault(), on(n.props.onClose, i, n, { state: void 0 });
      }, n.handleDoubleClick = function(i) {
        n.windowStage === se.FULLSCREEN || n.windowStage === se.MINIMIZED ? n.handleRestore(i) : n.handleFullscreen(i);
      }, n.handleResize = function(i, o) {
        var a = n.props.appendTo ? i.pageX - n.offSetCoordinates.x : i.pageX, s = n.props.appendTo ? i.pageY - n.offSetCoordinates.y : i.pageY, l = n.width, c = n.height, u = n.props.minWidth || jo, f = n.props.minHeight || Wo, h = n.top - s, d = n.left - a, p = a - n.left, m = s - n.top, v = Object.assign({}, n.state, { isDragging: !o.end });
        o.direction.indexOf("n") >= 0 && f - (c + h) < 0 && (n.top > 0 && (v.height = c + h), v.top = s), o.direction.indexOf("s") >= 0 && f - m < 0 && (v.height = m), o.direction.indexOf("w") >= 0 && u - (l + d) < 0 && (n.left > 0 && (v.width = l + d), v.left = a), o.direction.indexOf("e") >= 0 && u - p < 0 && (v.width = p), n.setState(v), n.dispatchMoveEvent(n.props.onResize, i, !0, o.end);
      }, n.dispatchMoveEvent = function(i, o, a, s) {
        i && i.call(void 0, {
          nativeEvent: o.nativeEvent ? o.nativeEvent : o.originalEvent,
          drag: a,
          end: s,
          target: n,
          left: n.state.left,
          top: n.state.top,
          width: n.state.width,
          hight: n.state.height,
          height: n.state.height
        });
      }, n.handleBrowserWindowResize = function() {
        if (n.windowStage === se.FULLSCREEN) {
          var i = n.getWindow(), o = i ? i.innerWidth : 0, a = i ? i.innerHeight : 0;
          n.setState({
            width: n.props.appendTo ? n.props.appendTo.offsetWidth : o,
            height: n.props.appendTo ? n.props.appendTo.offsetHeight : a
          });
        }
      }, n.getCurrentZIndex = function() {
        return !n.state || n.context === void 0 ? n.context ? n.context : ug : n.state.zIndex > (n.context ? n.context + Ol : 0) ? n.state.zIndex : n.context + Ol;
      }, n.getDocument = function() {
        return n.props.appendTo ? n.props.appendTo.ownerDocument : document;
      }, n.getWindow = function() {
        var i = n.getDocument();
        return i && i.defaultView;
      }, fg(hg), n.state = {
        stage: n.props.stage || se.DEFAULT,
        isDragging: !1,
        top: n.getInitialTop(),
        left: n.getInitialLeft(),
        width: n.getInitialWidth(),
        height: n.getInitialHeight(),
        focused: !0,
        zIndex: xl(n.getCurrentZIndex(), n.getDocument(), n._id)
      }, n.windowCoordinatesState = {
        leftBeforeAction: n.getInitialLeft(),
        topBeforeAction: n.getInitialTop(),
        widthBeforeAction: n.getInitialWidth(),
        heightBeforeAction: n.getInitialHeight()
      }, n;
    }
    return e.prototype.componentDidMount = function() {
      var t = this.getWindow();
      t && t.addEventListener("resize", this.handleBrowserWindowResize);
      var n = this.getDocument();
      if (this.props.appendTo && n) {
        var i = this.props.appendTo.getBoundingClientRect(), o = n.body.getBoundingClientRect();
        this.offSetCoordinates.x = i.left - o.left, this.offSetCoordinates.y = i.top - o.top;
      }
      this.mounted = !0;
    }, e.prototype.componentWillUnmount = function() {
      var t = this.getWindow();
      t && t.removeEventListener("resize", this.handleBrowserWindowResize), this.mounted = !1;
    }, e.prototype.componentDidUpdate = function() {
      var t = this.getDocument();
      if (this.props.appendTo && t) {
        var n = this.props.appendTo.getBoundingClientRect(), i = t.body.getBoundingClientRect();
        this.offSetCoordinates.x = n.left - i.left, this.offSetCoordinates.y = n.top - i.top;
      }
      this.mounted = !0;
    }, e.prototype.render = function() {
      var t, n, i = this, o = g.Children.toArray(this.props.children), a = this.getContent(o), s = this.getActionBar(o), l = this.getCurrentZIndex(), c = Cu("k-window", this.props.className, (t = {}, t["k-window-".concat(this.props.themeColor)] = this.props.themeColor, t["k-window-minimized"] = this.state.stage === "MINIMIZED", t["k-window-focused"] = this.state.focused, t)), u = g.createElement(
        Tl.Provider,
        { value: l },
        g.createElement(
          g.Fragment,
          null,
          this.props.modal && g.createElement("div", { className: "k-overlay", style: Hr({ zIndex: l }, this.props.overlayStyle) }),
          g.createElement(
            "div",
            Hr({}, (n = {}, n[dg] = this._id, n), { tabIndex: 0, role: "dialog", "aria-labelledby": this.titleId, onFocus: this.onFocus, onBlur: this.onBlur, onKeyDown: this.onKeyDown, ref: function(f) {
              i.windowElement = f, i.element = f;
            }, className: c, style: Hr({ top: this.top, left: this.left, width: this.width, height: this.height || "", zIndex: l }, this.props.style) }),
            g.createElement(
              Ky,
              { shouldUpdateOnDrag: this.props.shouldUpdateOnDrag || !1, isDragging: this.state.isDragging },
              g.createElement(
                zs,
                { onPress: this.onPress, onDrag: this.onDrag, onRelease: this.onRelease, ref: function(f) {
                  return i.draggable = f;
                } },
                g.createElement(jy, { stage: this.windowStage, onDoubleClick: this.props.doubleClickStageChange ? this.handleDoubleClick : void 0, onMinimizeButtonClick: this.handleMinimize, onFullScreenButtonClick: this.handleFullscreen, onRestoreButtonClick: this.handleRestore, onCloseButtonClick: this.handleCloseWindow, closeButton: this.props.closeButton, minimizeButton: this.props.minimizeButton, maximizeButton: this.props.maximizeButton, restoreButton: this.props.restoreButton, id: this.titleId }, this.props.title)
              ),
              this.windowStage !== se.MINIMIZED ? g.createElement(
                g.Fragment,
                null,
                g.createElement("div", { className: "k-window-content" }, a),
                s
              ) : null,
              this.windowStage === se.DEFAULT && this.props.resizable ? g.createElement(Uy, { onResize: this.handleResize }) : null
            )
          )
        )
      );
      return pg ? this.props.appendTo !== null ? ag.createPortal(u, this.props.appendTo || document.body) : u : null;
    }, Object.defineProperty(e.prototype, "top", {
      // Getters
      get: function() {
        return this.windowStage !== se.FULLSCREEN ? Math.max(this.props.top || this.state.top, 0) : 0;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "left", {
      get: function() {
        return this.windowStage !== se.FULLSCREEN ? Math.max(this.props.left || this.state.left, 0) : 0;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "width", {
      get: function() {
        var t = this.props.width || this.state.width;
        if (this.windowStage === se.FULLSCREEN) {
          if (this.props.appendTo)
            return t = this.props.appendTo.offsetWidth, t;
          var n = this.getWindow();
          t = n ? n.innerWidth : 0;
        }
        return t;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "height", {
      get: function() {
        var t = this.props.height || this.state.height;
        if (this.windowStage === se.FULLSCREEN) {
          if (this.props.appendTo)
            return t = this.props.appendTo.offsetHeight, t;
          var n = this.getWindow();
          t = n ? n.innerHeight : 0;
        } else
          this.windowStage === se.MINIMIZED && (t = 0);
        return t;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "windowStage", {
      get: function() {
        return this.props.stage || this.state.stage;
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.getActionBar = function(t) {
      return t.filter(function(n) {
        return n && n.type === gr;
      });
    }, e.prototype.getContent = function(t) {
      return t.filter(function(n) {
        return n && n.type !== gr;
      });
    }, e.prototype.generateTitleId = function() {
      return "window-title-" + this._id;
    }, e.displayName = "Window", e.propTypes = {
      width: E.number,
      height: E.number,
      left: E.number,
      top: E.number,
      initialWidth: E.number,
      initialHeight: E.number,
      initialLeft: E.number,
      initialTop: E.number,
      minWidth: E.number,
      minHeight: E.number,
      resizable: E.bool,
      draggable: E.bool,
      title: E.any,
      shouldUpdateOnDrag: E.bool,
      stage: E.oneOf(["DEFAULT", "MINIMIZED", "FULLSCREEN"]),
      className: E.string,
      style: E.object,
      overlayStyle: E.object
    }, e.defaultProps = {
      minWidth: jo,
      minHeight: Wo,
      resizable: !0,
      draggable: !0,
      modal: !1,
      doubleClickStageChange: !0
    }, e.contextType = Tl, e;
  }(g.Component)
), Yy = mg(), ai = gg(Yy, Xy);
ai.displayName = "KendoReactWindow";
var ut = function() {
  for (var r = [], e = 0; e < arguments.length; e++)
    r[e] = arguments[e];
  var t = {}, n = function(o) {
    return typeof o == "object" ? Object.keys(o).forEach(function(a) {
      t[a] = o[a];
    }) : t[o] = !0;
  }, i = function(o) {
    return o.filter(function(a) {
      return a !== !0 && !!a;
    }).map(function(a) {
      return Array.isArray(a) ? i(a) : n(a);
    });
  };
  return i(r), Object.keys(t).map(function(o) {
    return t[o] && o || null;
  }).filter(function(o) {
    return o !== null;
  }).join(" ");
}, Zy = function(r, e, t) {
  t === void 0 && (t = {});
  var n = g.useCallback(function(h) {
    t.onMouseDown && t.onMouseDown.call(void 0, h), r.onMouseDown && r.onMouseDown.call(void 0, {
      target: e.current,
      syntheticEvent: h
    });
  }, [t.onMouseDown, r.onMouseDown, e]), i = g.useCallback(function(h) {
    t.onMouseUp && t.onMouseUp.call(void 0, h), r.onMouseUp && r.onMouseUp.call(void 0, {
      target: e.current,
      syntheticEvent: h
    });
  }, [t.onMouseUp, r.onMouseUp, e]), o = g.useCallback(function(h) {
    t.onClick && t.onClick.call(void 0, h), r.onClick && r.onClick.call(void 0, {
      target: e.current,
      syntheticEvent: h
    });
  }, [t.onClick, r.onClick, e]), a = g.useCallback(function(h) {
    t.onDoubleClick && t.onDoubleClick.call(void 0, h), r.onDoubleClick && r.onDoubleClick.call(void 0, {
      target: e.current,
      syntheticEvent: h
    });
  }, [t.onDoubleClick, r.onDoubleClick, e]), s = g.useCallback(function(h) {
    t.onMouseEnter && t.onMouseEnter.call(void 0, h), r.onMouseEnter && r.onMouseEnter.call(void 0, {
      target: e.current,
      syntheticEvent: h
    });
  }, [t.onMouseEnter, r.onMouseEnter, e]), l = g.useCallback(function(h) {
    t.onMouseLeave && t.onMouseLeave.call(void 0, h), r.onMouseLeave && r.onMouseLeave.call(void 0, {
      target: e.current,
      syntheticEvent: h
    });
  }, [t.onMouseLeave, r.onMouseLeave, e]), c = g.useCallback(function(h) {
    t.onMouseMove && t.onMouseMove.call(void 0, h), r.onMouseMove && r.onMouseMove.call(void 0, {
      target: e.current,
      syntheticEvent: h
    });
  }, [t.onMouseMove, r.onMouseMove, e]), u = g.useCallback(function(h) {
    t.onMouseOut && t.onMouseOut.call(void 0, h), r.onMouseOut && r.onMouseOut.call(void 0, {
      target: e.current,
      syntheticEvent: h
    });
  }, [t.onMouseOut, r.onMouseOut, e]), f = g.useCallback(function(h) {
    t.onMouseOver && t.onMouseOver.call(void 0, h), r.onMouseOver && r.onMouseOver.call(void 0, {
      target: e.current,
      syntheticEvent: h
    });
  }, [t.onMouseOver, r.onMouseOver, e]);
  return {
    onClick: o,
    onMouseUp: i,
    onMouseDown: n,
    onDoubleClick: a,
    onMouseEnter: s,
    onMouseLeave: l,
    onMouseMove: c,
    onMouseOut: u,
    onMouseOver: f
  };
}, Ku = {
  default: "",
  xsmall: "k-icon-xs",
  small: "k-icon-sm",
  medium: "k-icon-md",
  large: "k-icon-lg",
  xlarge: "k-icon-xl",
  xxlarge: "k-icon-xxl",
  xxxlarge: "k-icon-xxxl"
}, Ra = globalThis && globalThis.__assign || function() {
  return Ra = Object.assign || function(r) {
    for (var e, t = 1, n = arguments.length; t < n; t++) {
      e = arguments[t];
      for (var i in e)
        Object.prototype.hasOwnProperty.call(e, i) && (r[i] = e[i]);
    }
    return r;
  }, Ra.apply(this, arguments);
}, Qy = globalThis && globalThis.__rest || function(r, e) {
  var t = {};
  for (var n in r)
    Object.prototype.hasOwnProperty.call(r, n) && e.indexOf(n) < 0 && (t[n] = r[n]);
  if (r != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, n = Object.getOwnPropertySymbols(r); i < n.length; i++)
      e.indexOf(n[i]) < 0 && Object.prototype.propertyIsEnumerable.call(r, n[i]) && (t[n[i]] = r[n[i]]);
  return t;
}, Bs = g.forwardRef(function(r, e) {
  var t = r.className, n = r.name, i = r.themeColor, o = r.size, a = r.flip, s = r.style, l = r.id, c = r.tabIndex, u = Qy(r, ["className", "name", "themeColor", "size", "flip", "style", "id", "tabIndex"]), f = g.useRef(null), h = g.useRef(null);
  g.useImperativeHandle(f, function() {
    return {
      element: h.current
    };
  }), g.useImperativeHandle(e, function() {
    return f.current;
  });
  var d = g.useMemo(function() {
    return o || Gl.size;
  }, [o]), p = g.useMemo(function() {
    return a || Gl.flip;
  }, [a]), m = g.useMemo(function() {
    var y;
    return ut("k-icon", n && nw(n), (y = {}, y["k-color-".concat(i)] = i, y["k-flip-h"] = p === "horizontal" || p === "both", y["k-flip-v"] = p === "vertical" || p === "both", y), Ku[d], t);
  }, [n, i, d, p, t]), v = Zy(r, f);
  return g.createElement("span", Ra({ ref: h }, u, v, { className: m, id: l, tabIndex: c, style: s, role: "presentation" }));
});
Bs.propTypes = {
  style: E.object,
  classNames: E.string,
  name: E.string,
  themeColor: E.oneOf([
    "inherit",
    "primary",
    "secondary",
    "tertiary",
    "info",
    "success",
    "error",
    "warning",
    "dark",
    "light",
    "inverse"
  ]),
  size: E.oneOf(["default", "xsmall", "small", "medium", "large", "xlarge", "xxlarge", "xxxlarge"]),
  flip: E.oneOf(["default", "horizontal", "vertical", "both"])
};
var Gl = {
  size: "default",
  flip: "default"
};
Bs.displayName = "KendoIcon";
var An = globalThis && globalThis.__assign || function() {
  return An = Object.assign || function(r) {
    for (var e, t = 1, n = arguments.length; t < n; t++) {
      e = arguments[t];
      for (var i in e)
        Object.prototype.hasOwnProperty.call(e, i) && (r[i] = e[i]);
    }
    return r;
  }, An.apply(this, arguments);
}, ew = globalThis && globalThis.__rest || function(r, e) {
  var t = {};
  for (var n in r)
    Object.prototype.hasOwnProperty.call(r, n) && e.indexOf(n) < 0 && (t[n] = r[n]);
  if (r != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, n = Object.getOwnPropertySymbols(r); i < n.length; i++)
      e.indexOf(n[i]) < 0 && Object.prototype.propertyIsEnumerable.call(r, n[i]) && (t[n[i]] = r[n[i]]);
  return t;
}, $s = g.forwardRef(function(r, e) {
  var t = r.children, n = r.className, i = r.svgClassName, o = r.icon, a = r.flip, s = r.id, l = r.tabIndex, c = r.size, u = r.style, f = r.svgStyle, h = r.themeColor, d = r.viewBox;
  r.name;
  var p = ew(r, ["children", "className", "svgClassName", "icon", "flip", "id", "tabIndex", "size", "style", "svgStyle", "themeColor", "viewBox", "name"]), m = g.useRef(null);
  g.useImperativeHandle(e, function() {
    return {
      element: m.current
    };
  });
  var v = g.useMemo(function() {
    return o ? o.name : vi.icon;
  }, [o]), y = g.useMemo(function() {
    return c || vi.size;
  }, [c]), b = g.useMemo(function() {
    return a || vi.flip;
  }, [a]), k = g.useMemo(function() {
    return d || vi.viewBox;
  }, [d]), M = g.useMemo(function() {
    var T;
    return ut("k-svg-icon", "k-svg-i-" + v, (T = {}, T["k-color-".concat(h)] = h, T["k-flip-h"] = b === "horizontal" || b === "both", T["k-flip-v"] = b === "vertical" || b === "both", T), Ku[y], n);
  }, [v, h, y, b, n]), D = g.useMemo(function() {
    return r.width && r.height ? An({ width: r.width, height: r.height }, u) : r.width ? An({ width: r.width, height: r.width }, u) : r.height ? An({ width: r.height, height: r.height }, u) : An({}, u);
  }, [r.width, r.height, u]);
  return g.createElement(
    "span",
    { className: M, style: D, ref: m },
    g.createElement("svg", An({ id: s, className: i, style: f, "aria-hidden": !0, tabIndex: l, focusable: !1, xmlns: "http://www.w3.org/2000/svg", viewBox: o ? o.viewBox : k, dangerouslySetInnerHTML: o ? { __html: o.content } : void 0 }, p), o ? void 0 : t)
  );
});
$s.propTypes = {
  style: E.object,
  classNames: E.string,
  children: E.any,
  icon: E.object,
  themeColor: E.oneOf([
    "inherit",
    "primary",
    "secondary",
    "tertiary",
    "info",
    "success",
    "error",
    "warning",
    "dark",
    "light",
    "inverse"
  ]),
  size: E.oneOf(["default", "xsmall", "small", "medium", "large", "xlarge", "xxlarge", "xxxlarge"]),
  flip: E.oneOf(["default", "horizontal", "vertical", "both"])
};
var vi = {
  size: "default",
  flip: "default",
  icon: "",
  viewBox: "0 0 24 24"
};
$s.displayName = "KendoSvgIcon";
var Gu = g.createContext({ type: "svg" });
Gu.displayName = "KendoReactIconsContext";
var Fi = globalThis && globalThis.__assign || function() {
  return Fi = Object.assign || function(r) {
    for (var e, t = 1, n = arguments.length; t < n; t++) {
      e = arguments[t];
      for (var i in e)
        Object.prototype.hasOwnProperty.call(e, i) && (r[i] = e[i]);
    }
    return r;
  }, Fi.apply(this, arguments);
}, tw = globalThis && globalThis.__rest || function(r, e) {
  var t = {};
  for (var n in r)
    Object.prototype.hasOwnProperty.call(r, n) && e.indexOf(n) < 0 && (t[n] = r[n]);
  if (r != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, n = Object.getOwnPropertySymbols(r); i < n.length; i++)
      e.indexOf(n[i]) < 0 && Object.prototype.propertyIsEnumerable.call(r, n[i]) && (t[n[i]] = r[n[i]]);
  return t;
}, Pa = g.forwardRef(function(r, e) {
  var t, n = g.useContext(Gu), i = n.type, o = n.icons, a = r.icon, s = tw(r, ["icon"]), l = ((t = r.icon) === null || t === void 0 ? void 0 : t.name) || r.name, c = l && o && o[l] && typeof o[l] != "string" ? o[l] : a;
  return l = l && o && o[l] && typeof o[l] == "string" ? o[l] : l, i === "svg" && c ? g.createElement($s, Fi({}, r, { icon: c, ref: e })) : g.createElement(Bs, Fi({}, s, { name: l, ref: e }));
});
Pa.displayName = "KendoIconWrap";
var nw = function(r) {
  return "k-i-" + r;
};
E.shape({
  name: E.string.isRequired,
  content: E.string.isRequired,
  viewBox: E.string.isRequired
});
function ze(r) {
  this.content = r;
}
ze.prototype = {
  constructor: ze,
  find: function(r) {
    for (var e = 0; e < this.content.length; e += 2)
      if (this.content[e] === r)
        return e;
    return -1;
  },
  // :: (string) → ?any
  // Retrieve the value stored under `key`, or return undefined when
  // no such key exists.
  get: function(r) {
    var e = this.find(r);
    return e == -1 ? void 0 : this.content[e + 1];
  },
  // :: (string, any, ?string) → OrderedMap
  // Create a new map by replacing the value of `key` with a new
  // value, or adding a binding to the end of the map. If `newKey` is
  // given, the key of the binding will be replaced with that key.
  update: function(r, e, t) {
    var n = t && t != r ? this.remove(t) : this, i = n.find(r), o = n.content.slice();
    return i == -1 ? o.push(t || r, e) : (o[i + 1] = e, t && (o[i] = t)), new ze(o);
  },
  // :: (string) → OrderedMap
  // Return a map with the given key removed, if it existed.
  remove: function(r) {
    var e = this.find(r);
    if (e == -1)
      return this;
    var t = this.content.slice();
    return t.splice(e, 2), new ze(t);
  },
  // :: (string, any) → OrderedMap
  // Add a new key to the start of the map.
  addToStart: function(r, e) {
    return new ze([r, e].concat(this.remove(r).content));
  },
  // :: (string, any) → OrderedMap
  // Add a new key to the end of the map.
  addToEnd: function(r, e) {
    var t = this.remove(r).content.slice();
    return t.push(r, e), new ze(t);
  },
  // :: (string, string, any) → OrderedMap
  // Add a key after the given key. If `place` is not found, the new
  // key is added to the end.
  addBefore: function(r, e, t) {
    var n = this.remove(e), i = n.content.slice(), o = n.find(r);
    return i.splice(o == -1 ? i.length : o, 0, e, t), new ze(i);
  },
  // :: ((key: string, value: any))
  // Call the given function for each key/value pair in the map, in
  // order.
  forEach: function(r) {
    for (var e = 0; e < this.content.length; e += 2)
      r(this.content[e], this.content[e + 1]);
  },
  // :: (union<Object, OrderedMap>) → OrderedMap
  // Create a new map by prepending the keys in this map that don't
  // appear in `map` before the keys in `map`.
  prepend: function(r) {
    return r = ze.from(r), r.size ? new ze(r.content.concat(this.subtract(r).content)) : this;
  },
  // :: (union<Object, OrderedMap>) → OrderedMap
  // Create a new map by appending the keys in this map that don't
  // appear in `map` after the keys in `map`.
  append: function(r) {
    return r = ze.from(r), r.size ? new ze(this.subtract(r).content.concat(r.content)) : this;
  },
  // :: (union<Object, OrderedMap>) → OrderedMap
  // Create a map containing all the keys in this map that don't
  // appear in `map`.
  subtract: function(r) {
    var e = this;
    r = ze.from(r);
    for (var t = 0; t < r.content.length; t += 2)
      e = e.remove(r.content[t]);
    return e;
  },
  // :: () → Object
  // Turn ordered map into a plain object.
  toObject: function() {
    var r = {};
    return this.forEach(function(e, t) {
      r[e] = t;
    }), r;
  },
  // :: number
  // The amount of keys in this map.
  get size() {
    return this.content.length >> 1;
  }
};
ze.from = function(r) {
  if (r instanceof ze)
    return r;
  var e = [];
  if (r)
    for (var t in r)
      e.push(t, r[t]);
  return new ze(e);
};
function Ju(r, e, t) {
  for (let n = 0; ; n++) {
    if (n == r.childCount || n == e.childCount)
      return r.childCount == e.childCount ? null : t;
    let i = r.child(n), o = e.child(n);
    if (i == o) {
      t += i.nodeSize;
      continue;
    }
    if (!i.sameMarkup(o))
      return t;
    if (i.isText && i.text != o.text) {
      for (let a = 0; i.text[a] == o.text[a]; a++)
        t++;
      return t;
    }
    if (i.content.size || o.content.size) {
      let a = Ju(i.content, o.content, t + 1);
      if (a != null)
        return a;
    }
    t += i.nodeSize;
  }
}
function Xu(r, e, t, n) {
  for (let i = r.childCount, o = e.childCount; ; ) {
    if (i == 0 || o == 0)
      return i == o ? null : { a: t, b: n };
    let a = r.child(--i), s = e.child(--o), l = a.nodeSize;
    if (a == s) {
      t -= l, n -= l;
      continue;
    }
    if (!a.sameMarkup(s))
      return { a: t, b: n };
    if (a.isText && a.text != s.text) {
      let c = 0, u = Math.min(a.text.length, s.text.length);
      for (; c < u && a.text[a.text.length - c - 1] == s.text[s.text.length - c - 1]; )
        c++, t--, n--;
      return { a: t, b: n };
    }
    if (a.content.size || s.content.size) {
      let c = Xu(a.content, s.content, t - 1, n - 1);
      if (c)
        return c;
    }
    t -= l, n -= l;
  }
}
class I {
  /**
  @internal
  */
  constructor(e, t) {
    if (this.content = e, this.size = t || 0, t == null)
      for (let n = 0; n < e.length; n++)
        this.size += e[n].nodeSize;
  }
  /**
  Invoke a callback for all descendant nodes between the given two
  positions (relative to start of this fragment). Doesn't descend
  into a node when the callback returns `false`.
  */
  nodesBetween(e, t, n, i = 0, o) {
    for (let a = 0, s = 0; s < t; a++) {
      let l = this.content[a], c = s + l.nodeSize;
      if (c > e && n(l, i + s, o || null, a) !== !1 && l.content.size) {
        let u = s + 1;
        l.nodesBetween(Math.max(0, e - u), Math.min(l.content.size, t - u), n, i + u);
      }
      s = c;
    }
  }
  /**
  Call the given callback for every descendant node. `pos` will be
  relative to the start of the fragment. The callback may return
  `false` to prevent traversal of a given node's children.
  */
  descendants(e) {
    this.nodesBetween(0, this.size, e);
  }
  /**
  Extract the text between `from` and `to`. See the same method on
  [`Node`](https://prosemirror.net/docs/ref/#model.Node.textBetween).
  */
  textBetween(e, t, n, i) {
    let o = "", a = !0;
    return this.nodesBetween(e, t, (s, l) => {
      s.isText ? (o += s.text.slice(Math.max(e, l) - l, t - l), a = !n) : s.isLeaf ? (i ? o += typeof i == "function" ? i(s) : i : s.type.spec.leafText && (o += s.type.spec.leafText(s)), a = !n) : !a && s.isBlock && (o += n, a = !0);
    }, 0), o;
  }
  /**
  Create a new fragment containing the combined content of this
  fragment and the other.
  */
  append(e) {
    if (!e.size)
      return this;
    if (!this.size)
      return e;
    let t = this.lastChild, n = e.firstChild, i = this.content.slice(), o = 0;
    for (t.isText && t.sameMarkup(n) && (i[i.length - 1] = t.withText(t.text + n.text), o = 1); o < e.content.length; o++)
      i.push(e.content[o]);
    return new I(i, this.size + e.size);
  }
  /**
  Cut out the sub-fragment between the two given positions.
  */
  cut(e, t = this.size) {
    if (e == 0 && t == this.size)
      return this;
    let n = [], i = 0;
    if (t > e)
      for (let o = 0, a = 0; a < t; o++) {
        let s = this.content[o], l = a + s.nodeSize;
        l > e && ((a < e || l > t) && (s.isText ? s = s.cut(Math.max(0, e - a), Math.min(s.text.length, t - a)) : s = s.cut(Math.max(0, e - a - 1), Math.min(s.content.size, t - a - 1))), n.push(s), i += s.nodeSize), a = l;
      }
    return new I(n, i);
  }
  /**
  @internal
  */
  cutByIndex(e, t) {
    return e == t ? I.empty : e == 0 && t == this.content.length ? this : new I(this.content.slice(e, t));
  }
  /**
  Create a new fragment in which the node at the given index is
  replaced by the given node.
  */
  replaceChild(e, t) {
    let n = this.content[e];
    if (n == t)
      return this;
    let i = this.content.slice(), o = this.size + t.nodeSize - n.nodeSize;
    return i[e] = t, new I(i, o);
  }
  /**
  Create a new fragment by prepending the given node to this
  fragment.
  */
  addToStart(e) {
    return new I([e].concat(this.content), this.size + e.nodeSize);
  }
  /**
  Create a new fragment by appending the given node to this
  fragment.
  */
  addToEnd(e) {
    return new I(this.content.concat(e), this.size + e.nodeSize);
  }
  /**
  Compare this fragment to another one.
  */
  eq(e) {
    if (this.content.length != e.content.length)
      return !1;
    for (let t = 0; t < this.content.length; t++)
      if (!this.content[t].eq(e.content[t]))
        return !1;
    return !0;
  }
  /**
  The first child of the fragment, or `null` if it is empty.
  */
  get firstChild() {
    return this.content.length ? this.content[0] : null;
  }
  /**
  The last child of the fragment, or `null` if it is empty.
  */
  get lastChild() {
    return this.content.length ? this.content[this.content.length - 1] : null;
  }
  /**
  The number of child nodes in this fragment.
  */
  get childCount() {
    return this.content.length;
  }
  /**
  Get the child node at the given index. Raise an error when the
  index is out of range.
  */
  child(e) {
    let t = this.content[e];
    if (!t)
      throw new RangeError("Index " + e + " out of range for " + this);
    return t;
  }
  /**
  Get the child node at the given index, if it exists.
  */
  maybeChild(e) {
    return this.content[e] || null;
  }
  /**
  Call `f` for every child node, passing the node, its offset
  into this parent node, and its index.
  */
  forEach(e) {
    for (let t = 0, n = 0; t < this.content.length; t++) {
      let i = this.content[t];
      e(i, n, t), n += i.nodeSize;
    }
  }
  /**
  Find the first position at which this fragment and another
  fragment differ, or `null` if they are the same.
  */
  findDiffStart(e, t = 0) {
    return Ju(this, e, t);
  }
  /**
  Find the first position, searching from the end, at which this
  fragment and the given fragment differ, or `null` if they are
  the same. Since this position will not be the same in both
  nodes, an object with two separate positions is returned.
  */
  findDiffEnd(e, t = this.size, n = e.size) {
    return Xu(this, e, t, n);
  }
  /**
  Find the index and inner offset corresponding to a given relative
  position in this fragment. The result object will be reused
  (overwritten) the next time the function is called. (Not public.)
  */
  findIndex(e, t = -1) {
    if (e == 0)
      return yi(0, e);
    if (e == this.size)
      return yi(this.content.length, e);
    if (e > this.size || e < 0)
      throw new RangeError(`Position ${e} outside of fragment (${this})`);
    for (let n = 0, i = 0; ; n++) {
      let o = this.child(n), a = i + o.nodeSize;
      if (a >= e)
        return a == e || t > 0 ? yi(n + 1, a) : yi(n, i);
      i = a;
    }
  }
  /**
  Return a debugging string that describes this fragment.
  */
  toString() {
    return "<" + this.toStringInner() + ">";
  }
  /**
  @internal
  */
  toStringInner() {
    return this.content.join(", ");
  }
  /**
  Create a JSON-serializeable representation of this fragment.
  */
  toJSON() {
    return this.content.length ? this.content.map((e) => e.toJSON()) : null;
  }
  /**
  Deserialize a fragment from its JSON representation.
  */
  static fromJSON(e, t) {
    if (!t)
      return I.empty;
    if (!Array.isArray(t))
      throw new RangeError("Invalid input for Fragment.fromJSON");
    return new I(t.map(e.nodeFromJSON));
  }
  /**
  Build a fragment from an array of nodes. Ensures that adjacent
  text nodes with the same marks are joined together.
  */
  static fromArray(e) {
    if (!e.length)
      return I.empty;
    let t, n = 0;
    for (let i = 0; i < e.length; i++) {
      let o = e[i];
      n += o.nodeSize, i && o.isText && e[i - 1].sameMarkup(o) ? (t || (t = e.slice(0, i)), t[t.length - 1] = o.withText(t[t.length - 1].text + o.text)) : t && t.push(o);
    }
    return new I(t || e, n);
  }
  /**
  Create a fragment from something that can be interpreted as a
  set of nodes. For `null`, it returns the empty fragment. For a
  fragment, the fragment itself. For a node or array of nodes, a
  fragment containing those nodes.
  */
  static from(e) {
    if (!e)
      return I.empty;
    if (e instanceof I)
      return e;
    if (Array.isArray(e))
      return this.fromArray(e);
    if (e.attrs)
      return new I([e], e.nodeSize);
    throw new RangeError("Can not convert " + e + " to a Fragment" + (e.nodesBetween ? " (looks like multiple versions of prosemirror-model were loaded)" : ""));
  }
}
I.empty = new I([], 0);
const Vo = { index: 0, offset: 0 };
function yi(r, e) {
  return Vo.index = r, Vo.offset = e, Vo;
}
function zi(r, e) {
  if (r === e)
    return !0;
  if (!(r && typeof r == "object") || !(e && typeof e == "object"))
    return !1;
  let t = Array.isArray(r);
  if (Array.isArray(e) != t)
    return !1;
  if (t) {
    if (r.length != e.length)
      return !1;
    for (let n = 0; n < r.length; n++)
      if (!zi(r[n], e[n]))
        return !1;
  } else {
    for (let n in r)
      if (!(n in e) || !zi(r[n], e[n]))
        return !1;
    for (let n in e)
      if (!(n in r))
        return !1;
  }
  return !0;
}
class me {
  /**
  @internal
  */
  constructor(e, t) {
    this.type = e, this.attrs = t;
  }
  /**
  Given a set of marks, create a new set which contains this one as
  well, in the right position. If this mark is already in the set,
  the set itself is returned. If any marks that are set to be
  [exclusive](https://prosemirror.net/docs/ref/#model.MarkSpec.excludes) with this mark are present,
  those are replaced by this one.
  */
  addToSet(e) {
    let t, n = !1;
    for (let i = 0; i < e.length; i++) {
      let o = e[i];
      if (this.eq(o))
        return e;
      if (this.type.excludes(o.type))
        t || (t = e.slice(0, i));
      else {
        if (o.type.excludes(this.type))
          return e;
        !n && o.type.rank > this.type.rank && (t || (t = e.slice(0, i)), t.push(this), n = !0), t && t.push(o);
      }
    }
    return t || (t = e.slice()), n || t.push(this), t;
  }
  /**
  Remove this mark from the given set, returning a new set. If this
  mark is not in the set, the set itself is returned.
  */
  removeFromSet(e) {
    for (let t = 0; t < e.length; t++)
      if (this.eq(e[t]))
        return e.slice(0, t).concat(e.slice(t + 1));
    return e;
  }
  /**
  Test whether this mark is in the given set of marks.
  */
  isInSet(e) {
    for (let t = 0; t < e.length; t++)
      if (this.eq(e[t]))
        return !0;
    return !1;
  }
  /**
  Test whether this mark has the same type and attributes as
  another mark.
  */
  eq(e) {
    return this == e || this.type == e.type && zi(this.attrs, e.attrs);
  }
  /**
  Convert this mark to a JSON-serializeable representation.
  */
  toJSON() {
    let e = { type: this.type.name };
    for (let t in this.attrs) {
      e.attrs = this.attrs;
      break;
    }
    return e;
  }
  /**
  Deserialize a mark from JSON.
  */
  static fromJSON(e, t) {
    if (!t)
      throw new RangeError("Invalid input for Mark.fromJSON");
    let n = e.marks[t.type];
    if (!n)
      throw new RangeError(`There is no mark type ${t.type} in this schema`);
    return n.create(t.attrs);
  }
  /**
  Test whether two sets of marks are identical.
  */
  static sameSet(e, t) {
    if (e == t)
      return !0;
    if (e.length != t.length)
      return !1;
    for (let n = 0; n < e.length; n++)
      if (!e[n].eq(t[n]))
        return !1;
    return !0;
  }
  /**
  Create a properly sorted mark set from null, a single mark, or an
  unsorted array of marks.
  */
  static setFrom(e) {
    if (!e || Array.isArray(e) && e.length == 0)
      return me.none;
    if (e instanceof me)
      return [e];
    let t = e.slice();
    return t.sort((n, i) => n.type.rank - i.type.rank), t;
  }
}
me.none = [];
class Bi extends Error {
}
class $ {
  /**
  Create a slice. When specifying a non-zero open depth, you must
  make sure that there are nodes of at least that depth at the
  appropriate side of the fragment—i.e. if the fragment is an
  empty paragraph node, `openStart` and `openEnd` can't be greater
  than 1.
  
  It is not necessary for the content of open nodes to conform to
  the schema's content constraints, though it should be a valid
  start/end/middle for such a node, depending on which sides are
  open.
  */
  constructor(e, t, n) {
    this.content = e, this.openStart = t, this.openEnd = n;
  }
  /**
  The size this slice would add when inserted into a document.
  */
  get size() {
    return this.content.size - this.openStart - this.openEnd;
  }
  /**
  @internal
  */
  insertAt(e, t) {
    let n = Zu(this.content, e + this.openStart, t);
    return n && new $(n, this.openStart, this.openEnd);
  }
  /**
  @internal
  */
  removeBetween(e, t) {
    return new $(Yu(this.content, e + this.openStart, t + this.openStart), this.openStart, this.openEnd);
  }
  /**
  Tests whether this slice is equal to another slice.
  */
  eq(e) {
    return this.content.eq(e.content) && this.openStart == e.openStart && this.openEnd == e.openEnd;
  }
  /**
  @internal
  */
  toString() {
    return this.content + "(" + this.openStart + "," + this.openEnd + ")";
  }
  /**
  Convert a slice to a JSON-serializable representation.
  */
  toJSON() {
    if (!this.content.size)
      return null;
    let e = { content: this.content.toJSON() };
    return this.openStart > 0 && (e.openStart = this.openStart), this.openEnd > 0 && (e.openEnd = this.openEnd), e;
  }
  /**
  Deserialize a slice from its JSON representation.
  */
  static fromJSON(e, t) {
    if (!t)
      return $.empty;
    let n = t.openStart || 0, i = t.openEnd || 0;
    if (typeof n != "number" || typeof i != "number")
      throw new RangeError("Invalid input for Slice.fromJSON");
    return new $(I.fromJSON(e, t.content), n, i);
  }
  /**
  Create a slice from a fragment by taking the maximum possible
  open value on both side of the fragment.
  */
  static maxOpen(e, t = !0) {
    let n = 0, i = 0;
    for (let o = e.firstChild; o && !o.isLeaf && (t || !o.type.spec.isolating); o = o.firstChild)
      n++;
    for (let o = e.lastChild; o && !o.isLeaf && (t || !o.type.spec.isolating); o = o.lastChild)
      i++;
    return new $(e, n, i);
  }
}
$.empty = new $(I.empty, 0, 0);
function Yu(r, e, t) {
  let { index: n, offset: i } = r.findIndex(e), o = r.maybeChild(n), { index: a, offset: s } = r.findIndex(t);
  if (i == e || o.isText) {
    if (s != t && !r.child(a).isText)
      throw new RangeError("Removing non-flat range");
    return r.cut(0, e).append(r.cut(t));
  }
  if (n != a)
    throw new RangeError("Removing non-flat range");
  return r.replaceChild(n, o.copy(Yu(o.content, e - i - 1, t - i - 1)));
}
function Zu(r, e, t, n) {
  let { index: i, offset: o } = r.findIndex(e), a = r.maybeChild(i);
  if (o == e || a.isText)
    return n && !n.canReplace(i, i, t) ? null : r.cut(0, e).append(t).append(r.cut(e));
  let s = Zu(a.content, e - o - 1, t);
  return s && r.replaceChild(i, a.copy(s));
}
function rw(r, e, t) {
  if (t.openStart > r.depth)
    throw new Bi("Inserted content deeper than insertion position");
  if (r.depth - t.openStart != e.depth - t.openEnd)
    throw new Bi("Inconsistent open depths");
  return Qu(r, e, t, 0);
}
function Qu(r, e, t, n) {
  let i = r.index(n), o = r.node(n);
  if (i == e.index(n) && n < r.depth - t.openStart) {
    let a = Qu(r, e, t, n + 1);
    return o.copy(o.content.replaceChild(i, a));
  } else if (t.content.size)
    if (!t.openStart && !t.openEnd && r.depth == n && e.depth == n) {
      let a = r.parent, s = a.content;
      return $n(a, s.cut(0, r.parentOffset).append(t.content).append(s.cut(e.parentOffset)));
    } else {
      let { start: a, end: s } = iw(t, r);
      return $n(o, tf(r, a, s, e, n));
    }
  else
    return $n(o, $i(r, e, n));
}
function ef(r, e) {
  if (!e.type.compatibleContent(r.type))
    throw new Bi("Cannot join " + e.type.name + " onto " + r.type.name);
}
function La(r, e, t) {
  let n = r.node(t);
  return ef(n, e.node(t)), n;
}
function Bn(r, e) {
  let t = e.length - 1;
  t >= 0 && r.isText && r.sameMarkup(e[t]) ? e[t] = r.withText(e[t].text + r.text) : e.push(r);
}
function jr(r, e, t, n) {
  let i = (e || r).node(t), o = 0, a = e ? e.index(t) : i.childCount;
  r && (o = r.index(t), r.depth > t ? o++ : r.textOffset && (Bn(r.nodeAfter, n), o++));
  for (let s = o; s < a; s++)
    Bn(i.child(s), n);
  e && e.depth == t && e.textOffset && Bn(e.nodeBefore, n);
}
function $n(r, e) {
  return r.type.checkContent(e), r.copy(e);
}
function tf(r, e, t, n, i) {
  let o = r.depth > i && La(r, e, i + 1), a = n.depth > i && La(t, n, i + 1), s = [];
  return jr(null, r, i, s), o && a && e.index(i) == t.index(i) ? (ef(o, a), Bn($n(o, tf(r, e, t, n, i + 1)), s)) : (o && Bn($n(o, $i(r, e, i + 1)), s), jr(e, t, i, s), a && Bn($n(a, $i(t, n, i + 1)), s)), jr(n, null, i, s), new I(s);
}
function $i(r, e, t) {
  let n = [];
  if (jr(null, r, t, n), r.depth > t) {
    let i = La(r, e, t + 1);
    Bn($n(i, $i(r, e, t + 1)), n);
  }
  return jr(e, null, t, n), new I(n);
}
function iw(r, e) {
  let t = e.depth - r.openStart, i = e.node(t).copy(r.content);
  for (let o = t - 1; o >= 0; o--)
    i = e.node(o).copy(I.from(i));
  return {
    start: i.resolveNoCache(r.openStart + t),
    end: i.resolveNoCache(i.content.size - r.openEnd - t)
  };
}
class Xr {
  /**
  @internal
  */
  constructor(e, t, n) {
    this.pos = e, this.path = t, this.parentOffset = n, this.depth = t.length / 3 - 1;
  }
  /**
  @internal
  */
  resolveDepth(e) {
    return e == null ? this.depth : e < 0 ? this.depth + e : e;
  }
  /**
  The parent node that the position points into. Note that even if
  a position points into a text node, that node is not considered
  the parent—text nodes are ‘flat’ in this model, and have no content.
  */
  get parent() {
    return this.node(this.depth);
  }
  /**
  The root node in which the position was resolved.
  */
  get doc() {
    return this.node(0);
  }
  /**
  The ancestor node at the given level. `p.node(p.depth)` is the
  same as `p.parent`.
  */
  node(e) {
    return this.path[this.resolveDepth(e) * 3];
  }
  /**
  The index into the ancestor at the given level. If this points
  at the 3rd node in the 2nd paragraph on the top level, for
  example, `p.index(0)` is 1 and `p.index(1)` is 2.
  */
  index(e) {
    return this.path[this.resolveDepth(e) * 3 + 1];
  }
  /**
  The index pointing after this position into the ancestor at the
  given level.
  */
  indexAfter(e) {
    return e = this.resolveDepth(e), this.index(e) + (e == this.depth && !this.textOffset ? 0 : 1);
  }
  /**
  The (absolute) position at the start of the node at the given
  level.
  */
  start(e) {
    return e = this.resolveDepth(e), e == 0 ? 0 : this.path[e * 3 - 1] + 1;
  }
  /**
  The (absolute) position at the end of the node at the given
  level.
  */
  end(e) {
    return e = this.resolveDepth(e), this.start(e) + this.node(e).content.size;
  }
  /**
  The (absolute) position directly before the wrapping node at the
  given level, or, when `depth` is `this.depth + 1`, the original
  position.
  */
  before(e) {
    if (e = this.resolveDepth(e), !e)
      throw new RangeError("There is no position before the top-level node");
    return e == this.depth + 1 ? this.pos : this.path[e * 3 - 1];
  }
  /**
  The (absolute) position directly after the wrapping node at the
  given level, or the original position when `depth` is `this.depth + 1`.
  */
  after(e) {
    if (e = this.resolveDepth(e), !e)
      throw new RangeError("There is no position after the top-level node");
    return e == this.depth + 1 ? this.pos : this.path[e * 3 - 1] + this.path[e * 3].nodeSize;
  }
  /**
  When this position points into a text node, this returns the
  distance between the position and the start of the text node.
  Will be zero for positions that point between nodes.
  */
  get textOffset() {
    return this.pos - this.path[this.path.length - 1];
  }
  /**
  Get the node directly after the position, if any. If the position
  points into a text node, only the part of that node after the
  position is returned.
  */
  get nodeAfter() {
    let e = this.parent, t = this.index(this.depth);
    if (t == e.childCount)
      return null;
    let n = this.pos - this.path[this.path.length - 1], i = e.child(t);
    return n ? e.child(t).cut(n) : i;
  }
  /**
  Get the node directly before the position, if any. If the
  position points into a text node, only the part of that node
  before the position is returned.
  */
  get nodeBefore() {
    let e = this.index(this.depth), t = this.pos - this.path[this.path.length - 1];
    return t ? this.parent.child(e).cut(0, t) : e == 0 ? null : this.parent.child(e - 1);
  }
  /**
  Get the position at the given index in the parent node at the
  given depth (which defaults to `this.depth`).
  */
  posAtIndex(e, t) {
    t = this.resolveDepth(t);
    let n = this.path[t * 3], i = t == 0 ? 0 : this.path[t * 3 - 1] + 1;
    for (let o = 0; o < e; o++)
      i += n.child(o).nodeSize;
    return i;
  }
  /**
  Get the marks at this position, factoring in the surrounding
  marks' [`inclusive`](https://prosemirror.net/docs/ref/#model.MarkSpec.inclusive) property. If the
  position is at the start of a non-empty node, the marks of the
  node after it (if any) are returned.
  */
  marks() {
    let e = this.parent, t = this.index();
    if (e.content.size == 0)
      return me.none;
    if (this.textOffset)
      return e.child(t).marks;
    let n = e.maybeChild(t - 1), i = e.maybeChild(t);
    if (!n) {
      let s = n;
      n = i, i = s;
    }
    let o = n.marks;
    for (var a = 0; a < o.length; a++)
      o[a].type.spec.inclusive === !1 && (!i || !o[a].isInSet(i.marks)) && (o = o[a--].removeFromSet(o));
    return o;
  }
  /**
  Get the marks after the current position, if any, except those
  that are non-inclusive and not present at position `$end`. This
  is mostly useful for getting the set of marks to preserve after a
  deletion. Will return `null` if this position is at the end of
  its parent node or its parent node isn't a textblock (in which
  case no marks should be preserved).
  */
  marksAcross(e) {
    let t = this.parent.maybeChild(this.index());
    if (!t || !t.isInline)
      return null;
    let n = t.marks, i = e.parent.maybeChild(e.index());
    for (var o = 0; o < n.length; o++)
      n[o].type.spec.inclusive === !1 && (!i || !n[o].isInSet(i.marks)) && (n = n[o--].removeFromSet(n));
    return n;
  }
  /**
  The depth up to which this position and the given (non-resolved)
  position share the same parent nodes.
  */
  sharedDepth(e) {
    for (let t = this.depth; t > 0; t--)
      if (this.start(t) <= e && this.end(t) >= e)
        return t;
    return 0;
  }
  /**
  Returns a range based on the place where this position and the
  given position diverge around block content. If both point into
  the same textblock, for example, a range around that textblock
  will be returned. If they point into different blocks, the range
  around those blocks in their shared ancestor is returned. You can
  pass in an optional predicate that will be called with a parent
  node to see if a range into that parent is acceptable.
  */
  blockRange(e = this, t) {
    if (e.pos < this.pos)
      return e.blockRange(this);
    for (let n = this.depth - (this.parent.inlineContent || this.pos == e.pos ? 1 : 0); n >= 0; n--)
      if (e.pos <= this.end(n) && (!t || t(this.node(n))))
        return new Yr(this, e, n);
    return null;
  }
  /**
  Query whether the given position shares the same parent node.
  */
  sameParent(e) {
    return this.pos - this.parentOffset == e.pos - e.parentOffset;
  }
  /**
  Return the greater of this and the given position.
  */
  max(e) {
    return e.pos > this.pos ? e : this;
  }
  /**
  Return the smaller of this and the given position.
  */
  min(e) {
    return e.pos < this.pos ? e : this;
  }
  /**
  @internal
  */
  toString() {
    let e = "";
    for (let t = 1; t <= this.depth; t++)
      e += (e ? "/" : "") + this.node(t).type.name + "_" + this.index(t - 1);
    return e + ":" + this.parentOffset;
  }
  /**
  @internal
  */
  static resolve(e, t) {
    if (!(t >= 0 && t <= e.content.size))
      throw new RangeError("Position " + t + " out of range");
    let n = [], i = 0, o = t;
    for (let a = e; ; ) {
      let { index: s, offset: l } = a.content.findIndex(o), c = o - l;
      if (n.push(a, s, i + l), !c || (a = a.child(s), a.isText))
        break;
      o = c - 1, i += l + 1;
    }
    return new Xr(t, n, o);
  }
  /**
  @internal
  */
  static resolveCached(e, t) {
    for (let i = 0; i < Uo.length; i++) {
      let o = Uo[i];
      if (o.pos == t && o.doc == e)
        return o;
    }
    let n = Uo[qo] = Xr.resolve(e, t);
    return qo = (qo + 1) % ow, n;
  }
}
let Uo = [], qo = 0, ow = 12;
class Yr {
  /**
  Construct a node range. `$from` and `$to` should point into the
  same node until at least the given `depth`, since a node range
  denotes an adjacent set of nodes in a single parent node.
  */
  constructor(e, t, n) {
    this.$from = e, this.$to = t, this.depth = n;
  }
  /**
  The position at the start of the range.
  */
  get start() {
    return this.$from.before(this.depth + 1);
  }
  /**
  The position at the end of the range.
  */
  get end() {
    return this.$to.after(this.depth + 1);
  }
  /**
  The parent node that the range points into.
  */
  get parent() {
    return this.$from.node(this.depth);
  }
  /**
  The start index of the range in the parent node.
  */
  get startIndex() {
    return this.$from.index(this.depth);
  }
  /**
  The end index of the range in the parent node.
  */
  get endIndex() {
    return this.$to.indexAfter(this.depth);
  }
}
const aw = /* @__PURE__ */ Object.create(null);
let yn = class Fa {
  /**
  @internal
  */
  constructor(e, t, n, i = me.none) {
    this.type = e, this.attrs = t, this.marks = i, this.content = n || I.empty;
  }
  /**
  The size of this node, as defined by the integer-based [indexing
  scheme](/docs/guide/#doc.indexing). For text nodes, this is the
  amount of characters. For other leaf nodes, it is one. For
  non-leaf nodes, it is the size of the content plus two (the
  start and end token).
  */
  get nodeSize() {
    return this.isLeaf ? 1 : 2 + this.content.size;
  }
  /**
  The number of children that the node has.
  */
  get childCount() {
    return this.content.childCount;
  }
  /**
  Get the child node at the given index. Raises an error when the
  index is out of range.
  */
  child(e) {
    return this.content.child(e);
  }
  /**
  Get the child node at the given index, if it exists.
  */
  maybeChild(e) {
    return this.content.maybeChild(e);
  }
  /**
  Call `f` for every child node, passing the node, its offset
  into this parent node, and its index.
  */
  forEach(e) {
    this.content.forEach(e);
  }
  /**
  Invoke a callback for all descendant nodes recursively between
  the given two positions that are relative to start of this
  node's content. The callback is invoked with the node, its
  parent-relative position, its parent node, and its child index.
  When the callback returns false for a given node, that node's
  children will not be recursed over. The last parameter can be
  used to specify a starting position to count from.
  */
  nodesBetween(e, t, n, i = 0) {
    this.content.nodesBetween(e, t, n, i, this);
  }
  /**
  Call the given callback for every descendant node. Doesn't
  descend into a node when the callback returns `false`.
  */
  descendants(e) {
    this.nodesBetween(0, this.content.size, e);
  }
  /**
  Concatenates all the text nodes found in this fragment and its
  children.
  */
  get textContent() {
    return this.isLeaf && this.type.spec.leafText ? this.type.spec.leafText(this) : this.textBetween(0, this.content.size, "");
  }
  /**
  Get all text between positions `from` and `to`. When
  `blockSeparator` is given, it will be inserted to separate text
  from different block nodes. If `leafText` is given, it'll be
  inserted for every non-text leaf node encountered, otherwise
  [`leafText`](https://prosemirror.net/docs/ref/#model.NodeSpec^leafText) will be used.
  */
  textBetween(e, t, n, i) {
    return this.content.textBetween(e, t, n, i);
  }
  /**
  Returns this node's first child, or `null` if there are no
  children.
  */
  get firstChild() {
    return this.content.firstChild;
  }
  /**
  Returns this node's last child, or `null` if there are no
  children.
  */
  get lastChild() {
    return this.content.lastChild;
  }
  /**
  Test whether two nodes represent the same piece of document.
  */
  eq(e) {
    return this == e || this.sameMarkup(e) && this.content.eq(e.content);
  }
  /**
  Compare the markup (type, attributes, and marks) of this node to
  those of another. Returns `true` if both have the same markup.
  */
  sameMarkup(e) {
    return this.hasMarkup(e.type, e.attrs, e.marks);
  }
  /**
  Check whether this node's markup correspond to the given type,
  attributes, and marks.
  */
  hasMarkup(e, t, n) {
    return this.type == e && zi(this.attrs, t || e.defaultAttrs || aw) && me.sameSet(this.marks, n || me.none);
  }
  /**
  Create a new node with the same markup as this node, containing
  the given content (or empty, if no content is given).
  */
  copy(e = null) {
    return e == this.content ? this : new Fa(this.type, this.attrs, e, this.marks);
  }
  /**
  Create a copy of this node, with the given set of marks instead
  of the node's own marks.
  */
  mark(e) {
    return e == this.marks ? this : new Fa(this.type, this.attrs, this.content, e);
  }
  /**
  Create a copy of this node with only the content between the
  given positions. If `to` is not given, it defaults to the end of
  the node.
  */
  cut(e, t = this.content.size) {
    return e == 0 && t == this.content.size ? this : this.copy(this.content.cut(e, t));
  }
  /**
  Cut out the part of the document between the given positions, and
  return it as a `Slice` object.
  */
  slice(e, t = this.content.size, n = !1) {
    if (e == t)
      return $.empty;
    let i = this.resolve(e), o = this.resolve(t), a = n ? 0 : i.sharedDepth(t), s = i.start(a), c = i.node(a).content.cut(i.pos - s, o.pos - s);
    return new $(c, i.depth - a, o.depth - a);
  }
  /**
  Replace the part of the document between the given positions with
  the given slice. The slice must 'fit', meaning its open sides
  must be able to connect to the surrounding content, and its
  content nodes must be valid children for the node they are placed
  into. If any of this is violated, an error of type
  [`ReplaceError`](https://prosemirror.net/docs/ref/#model.ReplaceError) is thrown.
  */
  replace(e, t, n) {
    return rw(this.resolve(e), this.resolve(t), n);
  }
  /**
  Find the node directly after the given position.
  */
  nodeAt(e) {
    for (let t = this; ; ) {
      let { index: n, offset: i } = t.content.findIndex(e);
      if (t = t.maybeChild(n), !t)
        return null;
      if (i == e || t.isText)
        return t;
      e -= i + 1;
    }
  }
  /**
  Find the (direct) child node after the given offset, if any,
  and return it along with its index and offset relative to this
  node.
  */
  childAfter(e) {
    let { index: t, offset: n } = this.content.findIndex(e);
    return { node: this.content.maybeChild(t), index: t, offset: n };
  }
  /**
  Find the (direct) child node before the given offset, if any,
  and return it along with its index and offset relative to this
  node.
  */
  childBefore(e) {
    if (e == 0)
      return { node: null, index: 0, offset: 0 };
    let { index: t, offset: n } = this.content.findIndex(e);
    if (n < e)
      return { node: this.content.child(t), index: t, offset: n };
    let i = this.content.child(t - 1);
    return { node: i, index: t - 1, offset: n - i.nodeSize };
  }
  /**
  Resolve the given position in the document, returning an
  [object](https://prosemirror.net/docs/ref/#model.ResolvedPos) with information about its context.
  */
  resolve(e) {
    return Xr.resolveCached(this, e);
  }
  /**
  @internal
  */
  resolveNoCache(e) {
    return Xr.resolve(this, e);
  }
  /**
  Test whether a given mark or mark type occurs in this document
  between the two given positions.
  */
  rangeHasMark(e, t, n) {
    let i = !1;
    return t > e && this.nodesBetween(e, t, (o) => (n.isInSet(o.marks) && (i = !0), !i)), i;
  }
  /**
  True when this is a block (non-inline node)
  */
  get isBlock() {
    return this.type.isBlock;
  }
  /**
  True when this is a textblock node, a block node with inline
  content.
  */
  get isTextblock() {
    return this.type.isTextblock;
  }
  /**
  True when this node allows inline content.
  */
  get inlineContent() {
    return this.type.inlineContent;
  }
  /**
  True when this is an inline node (a text node or a node that can
  appear among text).
  */
  get isInline() {
    return this.type.isInline;
  }
  /**
  True when this is a text node.
  */
  get isText() {
    return this.type.isText;
  }
  /**
  True when this is a leaf node.
  */
  get isLeaf() {
    return this.type.isLeaf;
  }
  /**
  True when this is an atom, i.e. when it does not have directly
  editable content. This is usually the same as `isLeaf`, but can
  be configured with the [`atom` property](https://prosemirror.net/docs/ref/#model.NodeSpec.atom)
  on a node's spec (typically used when the node is displayed as
  an uneditable [node view](https://prosemirror.net/docs/ref/#view.NodeView)).
  */
  get isAtom() {
    return this.type.isAtom;
  }
  /**
  Return a string representation of this node for debugging
  purposes.
  */
  toString() {
    if (this.type.spec.toDebugString)
      return this.type.spec.toDebugString(this);
    let e = this.type.name;
    return this.content.size && (e += "(" + this.content.toStringInner() + ")"), nf(this.marks, e);
  }
  /**
  Get the content match in this node at the given index.
  */
  contentMatchAt(e) {
    let t = this.type.contentMatch.matchFragment(this.content, 0, e);
    if (!t)
      throw new Error("Called contentMatchAt on a node with invalid content");
    return t;
  }
  /**
  Test whether replacing the range between `from` and `to` (by
  child index) with the given replacement fragment (which defaults
  to the empty fragment) would leave the node's content valid. You
  can optionally pass `start` and `end` indices into the
  replacement fragment.
  */
  canReplace(e, t, n = I.empty, i = 0, o = n.childCount) {
    let a = this.contentMatchAt(e).matchFragment(n, i, o), s = a && a.matchFragment(this.content, t);
    if (!s || !s.validEnd)
      return !1;
    for (let l = i; l < o; l++)
      if (!this.type.allowsMarks(n.child(l).marks))
        return !1;
    return !0;
  }
  /**
  Test whether replacing the range `from` to `to` (by index) with
  a node of the given type would leave the node's content valid.
  */
  canReplaceWith(e, t, n, i) {
    if (i && !this.type.allowsMarks(i))
      return !1;
    let o = this.contentMatchAt(e).matchType(n), a = o && o.matchFragment(this.content, t);
    return a ? a.validEnd : !1;
  }
  /**
  Test whether the given node's content could be appended to this
  node. If that node is empty, this will only return true if there
  is at least one node type that can appear in both nodes (to avoid
  merging completely incompatible nodes).
  */
  canAppend(e) {
    return e.content.size ? this.canReplace(this.childCount, this.childCount, e.content) : this.type.compatibleContent(e.type);
  }
  /**
  Check whether this node and its descendants conform to the
  schema, and raise error when they do not.
  */
  check() {
    this.type.checkContent(this.content);
    let e = me.none;
    for (let t = 0; t < this.marks.length; t++)
      e = this.marks[t].addToSet(e);
    if (!me.sameSet(e, this.marks))
      throw new RangeError(`Invalid collection of marks for node ${this.type.name}: ${this.marks.map((t) => t.type.name)}`);
    this.content.forEach((t) => t.check());
  }
  /**
  Return a JSON-serializeable representation of this node.
  */
  toJSON() {
    let e = { type: this.type.name };
    for (let t in this.attrs) {
      e.attrs = this.attrs;
      break;
    }
    return this.content.size && (e.content = this.content.toJSON()), this.marks.length && (e.marks = this.marks.map((t) => t.toJSON())), e;
  }
  /**
  Deserialize a node from its JSON representation.
  */
  static fromJSON(e, t) {
    if (!t)
      throw new RangeError("Invalid input for Node.fromJSON");
    let n = null;
    if (t.marks) {
      if (!Array.isArray(t.marks))
        throw new RangeError("Invalid mark data for Node.fromJSON");
      n = t.marks.map(e.markFromJSON);
    }
    if (t.type == "text") {
      if (typeof t.text != "string")
        throw new RangeError("Invalid text node in JSON");
      return e.text(t.text, n);
    }
    let i = I.fromJSON(e, t.content);
    return e.nodeType(t.type).create(t.attrs, i, n);
  }
};
yn.prototype.text = void 0;
class Hi extends yn {
  /**
  @internal
  */
  constructor(e, t, n, i) {
    if (super(e, t, null, i), !n)
      throw new RangeError("Empty text nodes are not allowed");
    this.text = n;
  }
  toString() {
    return this.type.spec.toDebugString ? this.type.spec.toDebugString(this) : nf(this.marks, JSON.stringify(this.text));
  }
  get textContent() {
    return this.text;
  }
  textBetween(e, t) {
    return this.text.slice(e, t);
  }
  get nodeSize() {
    return this.text.length;
  }
  mark(e) {
    return e == this.marks ? this : new Hi(this.type, this.attrs, this.text, e);
  }
  withText(e) {
    return e == this.text ? this : new Hi(this.type, this.attrs, e, this.marks);
  }
  cut(e = 0, t = this.text.length) {
    return e == 0 && t == this.text.length ? this : this.withText(this.text.slice(e, t));
  }
  eq(e) {
    return this.sameMarkup(e) && this.text == e.text;
  }
  toJSON() {
    let e = super.toJSON();
    return e.text = this.text, e;
  }
}
function nf(r, e) {
  for (let t = r.length - 1; t >= 0; t--)
    e = r[t].type.name + "(" + e + ")";
  return e;
}
class Vn {
  /**
  @internal
  */
  constructor(e) {
    this.validEnd = e, this.next = [], this.wrapCache = [];
  }
  /**
  @internal
  */
  static parse(e, t) {
    let n = new sw(e, t);
    if (n.next == null)
      return Vn.empty;
    let i = rf(n);
    n.next && n.err("Unexpected trailing text");
    let o = pw(dw(i));
    return mw(o, n), o;
  }
  /**
  Match a node type, returning a match after that node if
  successful.
  */
  matchType(e) {
    for (let t = 0; t < this.next.length; t++)
      if (this.next[t].type == e)
        return this.next[t].next;
    return null;
  }
  /**
  Try to match a fragment. Returns the resulting match when
  successful.
  */
  matchFragment(e, t = 0, n = e.childCount) {
    let i = this;
    for (let o = t; i && o < n; o++)
      i = i.matchType(e.child(o).type);
    return i;
  }
  /**
  @internal
  */
  get inlineContent() {
    return this.next.length != 0 && this.next[0].type.isInline;
  }
  /**
  Get the first matching node type at this match position that can
  be generated.
  */
  get defaultType() {
    for (let e = 0; e < this.next.length; e++) {
      let { type: t } = this.next[e];
      if (!(t.isText || t.hasRequiredAttrs()))
        return t;
    }
    return null;
  }
  /**
  @internal
  */
  compatible(e) {
    for (let t = 0; t < this.next.length; t++)
      for (let n = 0; n < e.next.length; n++)
        if (this.next[t].type == e.next[n].type)
          return !0;
    return !1;
  }
  /**
  Try to match the given fragment, and if that fails, see if it can
  be made to match by inserting nodes in front of it. When
  successful, return a fragment of inserted nodes (which may be
  empty if nothing had to be inserted). When `toEnd` is true, only
  return a fragment if the resulting match goes to the end of the
  content expression.
  */
  fillBefore(e, t = !1, n = 0) {
    let i = [this];
    function o(a, s) {
      let l = a.matchFragment(e, n);
      if (l && (!t || l.validEnd))
        return I.from(s.map((c) => c.createAndFill()));
      for (let c = 0; c < a.next.length; c++) {
        let { type: u, next: f } = a.next[c];
        if (!(u.isText || u.hasRequiredAttrs()) && i.indexOf(f) == -1) {
          i.push(f);
          let h = o(f, s.concat(u));
          if (h)
            return h;
        }
      }
      return null;
    }
    return o(this, []);
  }
  /**
  Find a set of wrapping node types that would allow a node of the
  given type to appear at this position. The result may be empty
  (when it fits directly) and will be null when no such wrapping
  exists.
  */
  findWrapping(e) {
    for (let n = 0; n < this.wrapCache.length; n += 2)
      if (this.wrapCache[n] == e)
        return this.wrapCache[n + 1];
    let t = this.computeWrapping(e);
    return this.wrapCache.push(e, t), t;
  }
  /**
  @internal
  */
  computeWrapping(e) {
    let t = /* @__PURE__ */ Object.create(null), n = [{ match: this, type: null, via: null }];
    for (; n.length; ) {
      let i = n.shift(), o = i.match;
      if (o.matchType(e)) {
        let a = [];
        for (let s = i; s.type; s = s.via)
          a.push(s.type);
        return a.reverse();
      }
      for (let a = 0; a < o.next.length; a++) {
        let { type: s, next: l } = o.next[a];
        !s.isLeaf && !s.hasRequiredAttrs() && !(s.name in t) && (!i.type || l.validEnd) && (n.push({ match: s.contentMatch, type: s, via: i }), t[s.name] = !0);
      }
    }
    return null;
  }
  /**
  The number of outgoing edges this node has in the finite
  automaton that describes the content expression.
  */
  get edgeCount() {
    return this.next.length;
  }
  /**
  Get the _n_​th outgoing edge from this node in the finite
  automaton that describes the content expression.
  */
  edge(e) {
    if (e >= this.next.length)
      throw new RangeError(`There's no ${e}th edge in this content match`);
    return this.next[e];
  }
  /**
  @internal
  */
  toString() {
    let e = [];
    function t(n) {
      e.push(n);
      for (let i = 0; i < n.next.length; i++)
        e.indexOf(n.next[i].next) == -1 && t(n.next[i].next);
    }
    return t(this), e.map((n, i) => {
      let o = i + (n.validEnd ? "*" : " ") + " ";
      for (let a = 0; a < n.next.length; a++)
        o += (a ? ", " : "") + n.next[a].type.name + "->" + e.indexOf(n.next[a].next);
      return o;
    }).join(`
`);
  }
}
Vn.empty = new Vn(!0);
class sw {
  constructor(e, t) {
    this.string = e, this.nodeTypes = t, this.inline = null, this.pos = 0, this.tokens = e.split(/\s*(?=\b|\W|$)/), this.tokens[this.tokens.length - 1] == "" && this.tokens.pop(), this.tokens[0] == "" && this.tokens.shift();
  }
  get next() {
    return this.tokens[this.pos];
  }
  eat(e) {
    return this.next == e && (this.pos++ || !0);
  }
  err(e) {
    throw new SyntaxError(e + " (in content expression '" + this.string + "')");
  }
}
function rf(r) {
  let e = [];
  do
    e.push(lw(r));
  while (r.eat("|"));
  return e.length == 1 ? e[0] : { type: "choice", exprs: e };
}
function lw(r) {
  let e = [];
  do
    e.push(cw(r));
  while (r.next && r.next != ")" && r.next != "|");
  return e.length == 1 ? e[0] : { type: "seq", exprs: e };
}
function cw(r) {
  let e = hw(r);
  for (; ; )
    if (r.eat("+"))
      e = { type: "plus", expr: e };
    else if (r.eat("*"))
      e = { type: "star", expr: e };
    else if (r.eat("?"))
      e = { type: "opt", expr: e };
    else if (r.eat("{"))
      e = uw(r, e);
    else
      break;
  return e;
}
function Jl(r) {
  /\D/.test(r.next) && r.err("Expected number, got '" + r.next + "'");
  let e = Number(r.next);
  return r.pos++, e;
}
function uw(r, e) {
  let t = Jl(r), n = t;
  return r.eat(",") && (r.next != "}" ? n = Jl(r) : n = -1), r.eat("}") || r.err("Unclosed braced range"), { type: "range", min: t, max: n, expr: e };
}
function fw(r, e) {
  let t = r.nodeTypes, n = t[e];
  if (n)
    return [n];
  let i = [];
  for (let o in t) {
    let a = t[o];
    a.groups.indexOf(e) > -1 && i.push(a);
  }
  return i.length == 0 && r.err("No node type or group '" + e + "' found"), i;
}
function hw(r) {
  if (r.eat("(")) {
    let e = rf(r);
    return r.eat(")") || r.err("Missing closing paren"), e;
  } else if (/\W/.test(r.next))
    r.err("Unexpected token '" + r.next + "'");
  else {
    let e = fw(r, r.next).map((t) => (r.inline == null ? r.inline = t.isInline : r.inline != t.isInline && r.err("Mixing inline and block content"), { type: "name", value: t }));
    return r.pos++, e.length == 1 ? e[0] : { type: "choice", exprs: e };
  }
}
function dw(r) {
  let e = [[]];
  return i(o(r, 0), t()), e;
  function t() {
    return e.push([]) - 1;
  }
  function n(a, s, l) {
    let c = { term: l, to: s };
    return e[a].push(c), c;
  }
  function i(a, s) {
    a.forEach((l) => l.to = s);
  }
  function o(a, s) {
    if (a.type == "choice")
      return a.exprs.reduce((l, c) => l.concat(o(c, s)), []);
    if (a.type == "seq")
      for (let l = 0; ; l++) {
        let c = o(a.exprs[l], s);
        if (l == a.exprs.length - 1)
          return c;
        i(c, s = t());
      }
    else if (a.type == "star") {
      let l = t();
      return n(s, l), i(o(a.expr, l), l), [n(l)];
    } else if (a.type == "plus") {
      let l = t();
      return i(o(a.expr, s), l), i(o(a.expr, l), l), [n(l)];
    } else {
      if (a.type == "opt")
        return [n(s)].concat(o(a.expr, s));
      if (a.type == "range") {
        let l = s;
        for (let c = 0; c < a.min; c++) {
          let u = t();
          i(o(a.expr, l), u), l = u;
        }
        if (a.max == -1)
          i(o(a.expr, l), l);
        else
          for (let c = a.min; c < a.max; c++) {
            let u = t();
            n(l, u), i(o(a.expr, l), u), l = u;
          }
        return [n(l)];
      } else {
        if (a.type == "name")
          return [n(s, void 0, a.value)];
        throw new Error("Unknown expr type");
      }
    }
  }
}
function of(r, e) {
  return e - r;
}
function Xl(r, e) {
  let t = [];
  return n(e), t.sort(of);
  function n(i) {
    let o = r[i];
    if (o.length == 1 && !o[0].term)
      return n(o[0].to);
    t.push(i);
    for (let a = 0; a < o.length; a++) {
      let { term: s, to: l } = o[a];
      !s && t.indexOf(l) == -1 && n(l);
    }
  }
}
function pw(r) {
  let e = /* @__PURE__ */ Object.create(null);
  return t(Xl(r, 0));
  function t(n) {
    let i = [];
    n.forEach((a) => {
      r[a].forEach(({ term: s, to: l }) => {
        if (!s)
          return;
        let c;
        for (let u = 0; u < i.length; u++)
          i[u][0] == s && (c = i[u][1]);
        Xl(r, l).forEach((u) => {
          c || i.push([s, c = []]), c.indexOf(u) == -1 && c.push(u);
        });
      });
    });
    let o = e[n.join(",")] = new Vn(n.indexOf(r.length - 1) > -1);
    for (let a = 0; a < i.length; a++) {
      let s = i[a][1].sort(of);
      o.next.push({ type: i[a][0], next: e[s.join(",")] || t(s) });
    }
    return o;
  }
}
function mw(r, e) {
  for (let t = 0, n = [r]; t < n.length; t++) {
    let i = n[t], o = !i.validEnd, a = [];
    for (let s = 0; s < i.next.length; s++) {
      let { type: l, next: c } = i.next[s];
      a.push(l.name), o && !(l.isText || l.hasRequiredAttrs()) && (o = !1), n.indexOf(c) == -1 && n.push(c);
    }
    o && e.err("Only non-generatable nodes (" + a.join(", ") + ") in a required position (see https://prosemirror.net/docs/guide/#generatable)");
  }
}
function af(r) {
  let e = /* @__PURE__ */ Object.create(null);
  for (let t in r) {
    let n = r[t];
    if (!n.hasDefault)
      return null;
    e[t] = n.default;
  }
  return e;
}
function sf(r, e) {
  let t = /* @__PURE__ */ Object.create(null);
  for (let n in r) {
    let i = e && e[n];
    if (i === void 0) {
      let o = r[n];
      if (o.hasDefault)
        i = o.default;
      else
        throw new RangeError("No value supplied for attribute " + n);
    }
    t[n] = i;
  }
  return t;
}
function lf(r) {
  let e = /* @__PURE__ */ Object.create(null);
  if (r)
    for (let t in r)
      e[t] = new gw(r[t]);
  return e;
}
let Yl = class cf {
  /**
  @internal
  */
  constructor(e, t, n) {
    this.name = e, this.schema = t, this.spec = n, this.markSet = null, this.groups = n.group ? n.group.split(" ") : [], this.attrs = lf(n.attrs), this.defaultAttrs = af(this.attrs), this.contentMatch = null, this.inlineContent = null, this.isBlock = !(n.inline || e == "text"), this.isText = e == "text";
  }
  /**
  True if this is an inline type.
  */
  get isInline() {
    return !this.isBlock;
  }
  /**
  True if this is a textblock type, a block that contains inline
  content.
  */
  get isTextblock() {
    return this.isBlock && this.inlineContent;
  }
  /**
  True for node types that allow no content.
  */
  get isLeaf() {
    return this.contentMatch == Vn.empty;
  }
  /**
  True when this node is an atom, i.e. when it does not have
  directly editable content.
  */
  get isAtom() {
    return this.isLeaf || !!this.spec.atom;
  }
  /**
  The node type's [whitespace](https://prosemirror.net/docs/ref/#model.NodeSpec.whitespace) option.
  */
  get whitespace() {
    return this.spec.whitespace || (this.spec.code ? "pre" : "normal");
  }
  /**
  Tells you whether this node type has any required attributes.
  */
  hasRequiredAttrs() {
    for (let e in this.attrs)
      if (this.attrs[e].isRequired)
        return !0;
    return !1;
  }
  /**
  Indicates whether this node allows some of the same content as
  the given node type.
  */
  compatibleContent(e) {
    return this == e || this.contentMatch.compatible(e.contentMatch);
  }
  /**
  @internal
  */
  computeAttrs(e) {
    return !e && this.defaultAttrs ? this.defaultAttrs : sf(this.attrs, e);
  }
  /**
  Create a `Node` of this type. The given attributes are
  checked and defaulted (you can pass `null` to use the type's
  defaults entirely, if no required attributes exist). `content`
  may be a `Fragment`, a node, an array of nodes, or
  `null`. Similarly `marks` may be `null` to default to the empty
  set of marks.
  */
  create(e = null, t, n) {
    if (this.isText)
      throw new Error("NodeType.create can't construct text nodes");
    return new yn(this, this.computeAttrs(e), I.from(t), me.setFrom(n));
  }
  /**
  Like [`create`](https://prosemirror.net/docs/ref/#model.NodeType.create), but check the given content
  against the node type's content restrictions, and throw an error
  if it doesn't match.
  */
  createChecked(e = null, t, n) {
    return t = I.from(t), this.checkContent(t), new yn(this, this.computeAttrs(e), t, me.setFrom(n));
  }
  /**
  Like [`create`](https://prosemirror.net/docs/ref/#model.NodeType.create), but see if it is
  necessary to add nodes to the start or end of the given fragment
  to make it fit the node. If no fitting wrapping can be found,
  return null. Note that, due to the fact that required nodes can
  always be created, this will always succeed if you pass null or
  `Fragment.empty` as content.
  */
  createAndFill(e = null, t, n) {
    if (e = this.computeAttrs(e), t = I.from(t), t.size) {
      let a = this.contentMatch.fillBefore(t);
      if (!a)
        return null;
      t = a.append(t);
    }
    let i = this.contentMatch.matchFragment(t), o = i && i.fillBefore(I.empty, !0);
    return o ? new yn(this, e, t.append(o), me.setFrom(n)) : null;
  }
  /**
  Returns true if the given fragment is valid content for this node
  type with the given attributes.
  */
  validContent(e) {
    let t = this.contentMatch.matchFragment(e);
    if (!t || !t.validEnd)
      return !1;
    for (let n = 0; n < e.childCount; n++)
      if (!this.allowsMarks(e.child(n).marks))
        return !1;
    return !0;
  }
  /**
  Throws a RangeError if the given fragment is not valid content for this
  node type.
  @internal
  */
  checkContent(e) {
    if (!this.validContent(e))
      throw new RangeError(`Invalid content for node ${this.name}: ${e.toString().slice(0, 50)}`);
  }
  /**
  Check whether the given mark type is allowed in this node.
  */
  allowsMarkType(e) {
    return this.markSet == null || this.markSet.indexOf(e) > -1;
  }
  /**
  Test whether the given set of marks are allowed in this node.
  */
  allowsMarks(e) {
    if (this.markSet == null)
      return !0;
    for (let t = 0; t < e.length; t++)
      if (!this.allowsMarkType(e[t].type))
        return !1;
    return !0;
  }
  /**
  Removes the marks that are not allowed in this node from the given set.
  */
  allowedMarks(e) {
    if (this.markSet == null)
      return e;
    let t;
    for (let n = 0; n < e.length; n++)
      this.allowsMarkType(e[n].type) ? t && t.push(e[n]) : t || (t = e.slice(0, n));
    return t ? t.length ? t : me.none : e;
  }
  /**
  @internal
  */
  static compile(e, t) {
    let n = /* @__PURE__ */ Object.create(null);
    e.forEach((o, a) => n[o] = new cf(o, t, a));
    let i = t.spec.topNode || "doc";
    if (!n[i])
      throw new RangeError("Schema is missing its top node type ('" + i + "')");
    if (!n.text)
      throw new RangeError("Every schema needs a 'text' type");
    for (let o in n.text.attrs)
      throw new RangeError("The text node type should not have attributes");
    return n;
  }
};
class gw {
  constructor(e) {
    this.hasDefault = Object.prototype.hasOwnProperty.call(e, "default"), this.default = e.default;
  }
  get isRequired() {
    return !this.hasDefault;
  }
}
class si {
  /**
  @internal
  */
  constructor(e, t, n, i) {
    this.name = e, this.rank = t, this.schema = n, this.spec = i, this.attrs = lf(i.attrs), this.excluded = null;
    let o = af(this.attrs);
    this.instance = o ? new me(this, o) : null;
  }
  /**
  Create a mark of this type. `attrs` may be `null` or an object
  containing only some of the mark's attributes. The others, if
  they have defaults, will be added.
  */
  create(e = null) {
    return !e && this.instance ? this.instance : new me(this, sf(this.attrs, e));
  }
  /**
  @internal
  */
  static compile(e, t) {
    let n = /* @__PURE__ */ Object.create(null), i = 0;
    return e.forEach((o, a) => n[o] = new si(o, i++, t, a)), n;
  }
  /**
  When there is a mark of this type in the given set, a new set
  without it is returned. Otherwise, the input set is returned.
  */
  removeFromSet(e) {
    for (var t = 0; t < e.length; t++)
      e[t].type == this && (e = e.slice(0, t).concat(e.slice(t + 1)), t--);
    return e;
  }
  /**
  Tests whether there is a mark of this type in the given set.
  */
  isInSet(e) {
    for (let t = 0; t < e.length; t++)
      if (e[t].type == this)
        return e[t];
  }
  /**
  Queries whether a given mark type is
  [excluded](https://prosemirror.net/docs/ref/#model.MarkSpec.excludes) by this one.
  */
  excludes(e) {
    return this.excluded.indexOf(e) > -1;
  }
}
class uf {
  /**
  Construct a schema from a schema [specification](https://prosemirror.net/docs/ref/#model.SchemaSpec).
  */
  constructor(e) {
    this.cached = /* @__PURE__ */ Object.create(null);
    let t = this.spec = {};
    for (let i in e)
      t[i] = e[i];
    t.nodes = ze.from(e.nodes), t.marks = ze.from(e.marks || {}), this.nodes = Yl.compile(this.spec.nodes, this), this.marks = si.compile(this.spec.marks, this);
    let n = /* @__PURE__ */ Object.create(null);
    for (let i in this.nodes) {
      if (i in this.marks)
        throw new RangeError(i + " can not be both a node and a mark");
      let o = this.nodes[i], a = o.spec.content || "", s = o.spec.marks;
      o.contentMatch = n[a] || (n[a] = Vn.parse(a, this.nodes)), o.inlineContent = o.contentMatch.inlineContent, o.markSet = s == "_" ? null : s ? Zl(this, s.split(" ")) : s == "" || !o.inlineContent ? [] : null;
    }
    for (let i in this.marks) {
      let o = this.marks[i], a = o.spec.excludes;
      o.excluded = a == null ? [o] : a == "" ? [] : Zl(this, a.split(" "));
    }
    this.nodeFromJSON = this.nodeFromJSON.bind(this), this.markFromJSON = this.markFromJSON.bind(this), this.topNodeType = this.nodes[this.spec.topNode || "doc"], this.cached.wrappings = /* @__PURE__ */ Object.create(null);
  }
  /**
  Create a node in this schema. The `type` may be a string or a
  `NodeType` instance. Attributes will be extended with defaults,
  `content` may be a `Fragment`, `null`, a `Node`, or an array of
  nodes.
  */
  node(e, t = null, n, i) {
    if (typeof e == "string")
      e = this.nodeType(e);
    else if (e instanceof Yl) {
      if (e.schema != this)
        throw new RangeError("Node type from different schema used (" + e.name + ")");
    } else
      throw new RangeError("Invalid node type: " + e);
    return e.createChecked(t, n, i);
  }
  /**
  Create a text node in the schema. Empty text nodes are not
  allowed.
  */
  text(e, t) {
    let n = this.nodes.text;
    return new Hi(n, n.defaultAttrs, e, me.setFrom(t));
  }
  /**
  Create a mark with the given type and attributes.
  */
  mark(e, t) {
    return typeof e == "string" && (e = this.marks[e]), e.create(t);
  }
  /**
  Deserialize a node from its JSON representation. This method is
  bound.
  */
  nodeFromJSON(e) {
    return yn.fromJSON(this, e);
  }
  /**
  Deserialize a mark from its JSON representation. This method is
  bound.
  */
  markFromJSON(e) {
    return me.fromJSON(this, e);
  }
  /**
  @internal
  */
  nodeType(e) {
    let t = this.nodes[e];
    if (!t)
      throw new RangeError("Unknown node type: " + e);
    return t;
  }
}
function Zl(r, e) {
  let t = [];
  for (let n = 0; n < e.length; n++) {
    let i = e[n], o = r.marks[i], a = o;
    if (o)
      t.push(o);
    else
      for (let s in r.marks) {
        let l = r.marks[s];
        (i == "_" || l.spec.group && l.spec.group.split(" ").indexOf(i) > -1) && t.push(a = l);
      }
    if (!a)
      throw new SyntaxError("Unknown mark type: '" + e[n] + "'");
  }
  return t;
}
let Hs = class za {
  /**
  Create a parser that targets the given schema, using the given
  parsing rules.
  */
  constructor(e, t) {
    this.schema = e, this.rules = t, this.tags = [], this.styles = [], t.forEach((n) => {
      n.tag ? this.tags.push(n) : n.style && this.styles.push(n);
    }), this.normalizeLists = !this.tags.some((n) => {
      if (!/^(ul|ol)\b/.test(n.tag) || !n.node)
        return !1;
      let i = e.nodes[n.node];
      return i.contentMatch.matchType(i);
    });
  }
  /**
  Parse a document from the content of a DOM node.
  */
  parse(e, t = {}) {
    let n = new ec(this, t, !1);
    return n.addAll(e, t.from, t.to), n.finish();
  }
  /**
  Parses the content of the given DOM node, like
  [`parse`](https://prosemirror.net/docs/ref/#model.DOMParser.parse), and takes the same set of
  options. But unlike that method, which produces a whole node,
  this one returns a slice that is open at the sides, meaning that
  the schema constraints aren't applied to the start of nodes to
  the left of the input and the end of nodes at the end.
  */
  parseSlice(e, t = {}) {
    let n = new ec(this, t, !0);
    return n.addAll(e, t.from, t.to), $.maxOpen(n.finish());
  }
  /**
  @internal
  */
  matchTag(e, t, n) {
    for (let i = n ? this.tags.indexOf(n) + 1 : 0; i < this.tags.length; i++) {
      let o = this.tags[i];
      if (ww(e, o.tag) && (o.namespace === void 0 || e.namespaceURI == o.namespace) && (!o.context || t.matchesContext(o.context))) {
        if (o.getAttrs) {
          let a = o.getAttrs(e);
          if (a === !1)
            continue;
          o.attrs = a || void 0;
        }
        return o;
      }
    }
  }
  /**
  @internal
  */
  matchStyle(e, t, n, i) {
    for (let o = i ? this.styles.indexOf(i) + 1 : 0; o < this.styles.length; o++) {
      let a = this.styles[o], s = a.style;
      if (!(s.indexOf(e) != 0 || a.context && !n.matchesContext(a.context) || // Test that the style string either precisely matches the prop,
      // or has an '=' sign after the prop, followed by the given
      // value.
      s.length > e.length && (s.charCodeAt(e.length) != 61 || s.slice(e.length + 1) != t))) {
        if (a.getAttrs) {
          let l = a.getAttrs(t);
          if (l === !1)
            continue;
          a.attrs = l || void 0;
        }
        return a;
      }
    }
  }
  /**
  @internal
  */
  static schemaRules(e) {
    let t = [];
    function n(i) {
      let o = i.priority == null ? 50 : i.priority, a = 0;
      for (; a < t.length; a++) {
        let s = t[a];
        if ((s.priority == null ? 50 : s.priority) < o)
          break;
      }
      t.splice(a, 0, i);
    }
    for (let i in e.marks) {
      let o = e.marks[i].spec.parseDOM;
      o && o.forEach((a) => {
        n(a = tc(a)), a.mark || a.ignore || a.clearMark || (a.mark = i);
      });
    }
    for (let i in e.nodes) {
      let o = e.nodes[i].spec.parseDOM;
      o && o.forEach((a) => {
        n(a = tc(a)), a.node || a.ignore || a.mark || (a.node = i);
      });
    }
    return t;
  }
  /**
  Construct a DOM parser using the parsing rules listed in a
  schema's [node specs](https://prosemirror.net/docs/ref/#model.NodeSpec.parseDOM), reordered by
  [priority](https://prosemirror.net/docs/ref/#model.ParseRule.priority).
  */
  static fromSchema(e) {
    return e.cached.domParser || (e.cached.domParser = new za(e, za.schemaRules(e)));
  }
};
const ff = {
  address: !0,
  article: !0,
  aside: !0,
  blockquote: !0,
  canvas: !0,
  dd: !0,
  div: !0,
  dl: !0,
  fieldset: !0,
  figcaption: !0,
  figure: !0,
  footer: !0,
  form: !0,
  h1: !0,
  h2: !0,
  h3: !0,
  h4: !0,
  h5: !0,
  h6: !0,
  header: !0,
  hgroup: !0,
  hr: !0,
  li: !0,
  noscript: !0,
  ol: !0,
  output: !0,
  p: !0,
  pre: !0,
  section: !0,
  table: !0,
  tfoot: !0,
  ul: !0
}, vw = {
  head: !0,
  noscript: !0,
  object: !0,
  script: !0,
  style: !0,
  title: !0
}, hf = { ol: !0, ul: !0 }, ji = 1, Wi = 2, Wr = 4;
function Ql(r, e, t) {
  return e != null ? (e ? ji : 0) | (e === "full" ? Wi : 0) : r && r.whitespace == "pre" ? ji | Wi : t & ~Wr;
}
class wi {
  constructor(e, t, n, i, o, a, s) {
    this.type = e, this.attrs = t, this.marks = n, this.pendingMarks = i, this.solid = o, this.options = s, this.content = [], this.activeMarks = me.none, this.stashMarks = [], this.match = a || (s & Wr ? null : e.contentMatch);
  }
  findWrapping(e) {
    if (!this.match) {
      if (!this.type)
        return [];
      let t = this.type.contentMatch.fillBefore(I.from(e));
      if (t)
        this.match = this.type.contentMatch.matchFragment(t);
      else {
        let n = this.type.contentMatch, i;
        return (i = n.findWrapping(e.type)) ? (this.match = n, i) : null;
      }
    }
    return this.match.findWrapping(e.type);
  }
  finish(e) {
    if (!(this.options & ji)) {
      let n = this.content[this.content.length - 1], i;
      if (n && n.isText && (i = /[ \t\r\n\u000c]+$/.exec(n.text))) {
        let o = n;
        n.text.length == i[0].length ? this.content.pop() : this.content[this.content.length - 1] = o.withText(o.text.slice(0, o.text.length - i[0].length));
      }
    }
    let t = I.from(this.content);
    return !e && this.match && (t = t.append(this.match.fillBefore(I.empty, !0))), this.type ? this.type.create(this.attrs, t, this.marks) : t;
  }
  popFromStashMark(e) {
    for (let t = this.stashMarks.length - 1; t >= 0; t--)
      if (e.eq(this.stashMarks[t]))
        return this.stashMarks.splice(t, 1)[0];
  }
  applyPending(e) {
    for (let t = 0, n = this.pendingMarks; t < n.length; t++) {
      let i = n[t];
      (this.type ? this.type.allowsMarkType(i.type) : Sw(i.type, e)) && !i.isInSet(this.activeMarks) && (this.activeMarks = i.addToSet(this.activeMarks), this.pendingMarks = i.removeFromSet(this.pendingMarks));
    }
  }
  inlineContext(e) {
    return this.type ? this.type.inlineContent : this.content.length ? this.content[0].isInline : e.parentNode && !ff.hasOwnProperty(e.parentNode.nodeName.toLowerCase());
  }
}
class ec {
  constructor(e, t, n) {
    this.parser = e, this.options = t, this.isOpen = n, this.open = 0;
    let i = t.topNode, o, a = Ql(null, t.preserveWhitespace, 0) | (n ? Wr : 0);
    i ? o = new wi(i.type, i.attrs, me.none, me.none, !0, t.topMatch || i.type.contentMatch, a) : n ? o = new wi(null, null, me.none, me.none, !0, null, a) : o = new wi(e.schema.topNodeType, null, me.none, me.none, !0, null, a), this.nodes = [o], this.find = t.findPositions, this.needsBlock = !1;
  }
  get top() {
    return this.nodes[this.open];
  }
  // Add a DOM node to the content. Text is inserted as text node,
  // otherwise, the node is passed to `addElement` or, if it has a
  // `style` attribute, `addElementWithStyles`.
  addDOM(e) {
    if (e.nodeType == 3)
      this.addTextNode(e);
    else if (e.nodeType == 1) {
      let t = e.getAttribute("style");
      if (!t)
        this.addElement(e);
      else {
        let n = this.readStyles(bw(t));
        if (!n)
          return;
        let [i, o] = n, a = this.top;
        for (let s = 0; s < o.length; s++)
          this.removePendingMark(o[s], a);
        for (let s = 0; s < i.length; s++)
          this.addPendingMark(i[s]);
        this.addElement(e);
        for (let s = 0; s < i.length; s++)
          this.removePendingMark(i[s], a);
        for (let s = 0; s < o.length; s++)
          this.addPendingMark(o[s]);
      }
    }
  }
  addTextNode(e) {
    let t = e.nodeValue, n = this.top;
    if (n.options & Wi || n.inlineContext(e) || /[^ \t\r\n\u000c]/.test(t)) {
      if (n.options & ji)
        n.options & Wi ? t = t.replace(/\r\n?/g, `
`) : t = t.replace(/\r?\n|\r/g, " ");
      else if (t = t.replace(/[ \t\r\n\u000c]+/g, " "), /^[ \t\r\n\u000c]/.test(t) && this.open == this.nodes.length - 1) {
        let i = n.content[n.content.length - 1], o = e.previousSibling;
        (!i || o && o.nodeName == "BR" || i.isText && /[ \t\r\n\u000c]$/.test(i.text)) && (t = t.slice(1));
      }
      t && this.insertNode(this.parser.schema.text(t)), this.findInText(e);
    } else
      this.findInside(e);
  }
  // Try to find a handler for the given tag and use that to parse. If
  // none is found, the element's content nodes are added directly.
  addElement(e, t) {
    let n = e.nodeName.toLowerCase(), i;
    hf.hasOwnProperty(n) && this.parser.normalizeLists && yw(e);
    let o = this.options.ruleFromNode && this.options.ruleFromNode(e) || (i = this.parser.matchTag(e, this, t));
    if (o ? o.ignore : vw.hasOwnProperty(n))
      this.findInside(e), this.ignoreFallback(e);
    else if (!o || o.skip || o.closeParent) {
      o && o.closeParent ? this.open = Math.max(0, this.open - 1) : o && o.skip.nodeType && (e = o.skip);
      let a, s = this.top, l = this.needsBlock;
      if (ff.hasOwnProperty(n))
        s.content.length && s.content[0].isInline && this.open && (this.open--, s = this.top), a = !0, s.type || (this.needsBlock = !0);
      else if (!e.firstChild) {
        this.leafFallback(e);
        return;
      }
      this.addAll(e), a && this.sync(s), this.needsBlock = l;
    } else
      this.addElementByRule(e, o, o.consuming === !1 ? i : void 0);
  }
  // Called for leaf DOM nodes that would otherwise be ignored
  leafFallback(e) {
    e.nodeName == "BR" && this.top.type && this.top.type.inlineContent && this.addTextNode(e.ownerDocument.createTextNode(`
`));
  }
  // Called for ignored nodes
  ignoreFallback(e) {
    e.nodeName == "BR" && (!this.top.type || !this.top.type.inlineContent) && this.findPlace(this.parser.schema.text("-"));
  }
  // Run any style parser associated with the node's styles. Either
  // return an array of marks, or null to indicate some of the styles
  // had a rule with `ignore` set.
  readStyles(e) {
    let t = me.none, n = me.none;
    e:
      for (let i = 0; i < e.length; i += 2)
        for (let o = void 0; ; ) {
          let a = this.parser.matchStyle(e[i], e[i + 1], this, o);
          if (!a)
            continue e;
          if (a.ignore)
            return null;
          if (a.clearMark ? this.top.pendingMarks.forEach((s) => {
            a.clearMark(s) && (n = s.addToSet(n));
          }) : t = this.parser.schema.marks[a.mark].create(a.attrs).addToSet(t), a.consuming === !1)
            o = a;
          else
            break;
        }
    return [t, n];
  }
  // Look up a handler for the given node. If none are found, return
  // false. Otherwise, apply it, use its return value to drive the way
  // the node's content is wrapped, and return true.
  addElementByRule(e, t, n) {
    let i, o, a;
    t.node ? (o = this.parser.schema.nodes[t.node], o.isLeaf ? this.insertNode(o.create(t.attrs)) || this.leafFallback(e) : i = this.enter(o, t.attrs || null, t.preserveWhitespace)) : (a = this.parser.schema.marks[t.mark].create(t.attrs), this.addPendingMark(a));
    let s = this.top;
    if (o && o.isLeaf)
      this.findInside(e);
    else if (n)
      this.addElement(e, n);
    else if (t.getContent)
      this.findInside(e), t.getContent(e, this.parser.schema).forEach((l) => this.insertNode(l));
    else {
      let l = e;
      typeof t.contentElement == "string" ? l = e.querySelector(t.contentElement) : typeof t.contentElement == "function" ? l = t.contentElement(e) : t.contentElement && (l = t.contentElement), this.findAround(e, l, !0), this.addAll(l);
    }
    i && this.sync(s) && this.open--, a && this.removePendingMark(a, s);
  }
  // Add all child nodes between `startIndex` and `endIndex` (or the
  // whole node, if not given). If `sync` is passed, use it to
  // synchronize after every block element.
  addAll(e, t, n) {
    let i = t || 0;
    for (let o = t ? e.childNodes[t] : e.firstChild, a = n == null ? null : e.childNodes[n]; o != a; o = o.nextSibling, ++i)
      this.findAtPoint(e, i), this.addDOM(o);
    this.findAtPoint(e, i);
  }
  // Try to find a way to fit the given node type into the current
  // context. May add intermediate wrappers and/or leave non-solid
  // nodes that we're in.
  findPlace(e) {
    let t, n;
    for (let i = this.open; i >= 0; i--) {
      let o = this.nodes[i], a = o.findWrapping(e);
      if (a && (!t || t.length > a.length) && (t = a, n = o, !a.length) || o.solid)
        break;
    }
    if (!t)
      return !1;
    this.sync(n);
    for (let i = 0; i < t.length; i++)
      this.enterInner(t[i], null, !1);
    return !0;
  }
  // Try to insert the given node, adjusting the context when needed.
  insertNode(e) {
    if (e.isInline && this.needsBlock && !this.top.type) {
      let t = this.textblockFromContext();
      t && this.enterInner(t);
    }
    if (this.findPlace(e)) {
      this.closeExtra();
      let t = this.top;
      t.applyPending(e.type), t.match && (t.match = t.match.matchType(e.type));
      let n = t.activeMarks;
      for (let i = 0; i < e.marks.length; i++)
        (!t.type || t.type.allowsMarkType(e.marks[i].type)) && (n = e.marks[i].addToSet(n));
      return t.content.push(e.mark(n)), !0;
    }
    return !1;
  }
  // Try to start a node of the given type, adjusting the context when
  // necessary.
  enter(e, t, n) {
    let i = this.findPlace(e.create(t));
    return i && this.enterInner(e, t, !0, n), i;
  }
  // Open a node of the given type
  enterInner(e, t = null, n = !1, i) {
    this.closeExtra();
    let o = this.top;
    o.applyPending(e), o.match = o.match && o.match.matchType(e);
    let a = Ql(e, i, o.options);
    o.options & Wr && o.content.length == 0 && (a |= Wr), this.nodes.push(new wi(e, t, o.activeMarks, o.pendingMarks, n, null, a)), this.open++;
  }
  // Make sure all nodes above this.open are finished and added to
  // their parents
  closeExtra(e = !1) {
    let t = this.nodes.length - 1;
    if (t > this.open) {
      for (; t > this.open; t--)
        this.nodes[t - 1].content.push(this.nodes[t].finish(e));
      this.nodes.length = this.open + 1;
    }
  }
  finish() {
    return this.open = 0, this.closeExtra(this.isOpen), this.nodes[0].finish(this.isOpen || this.options.topOpen);
  }
  sync(e) {
    for (let t = this.open; t >= 0; t--)
      if (this.nodes[t] == e)
        return this.open = t, !0;
    return !1;
  }
  get currentPos() {
    this.closeExtra();
    let e = 0;
    for (let t = this.open; t >= 0; t--) {
      let n = this.nodes[t].content;
      for (let i = n.length - 1; i >= 0; i--)
        e += n[i].nodeSize;
      t && e++;
    }
    return e;
  }
  findAtPoint(e, t) {
    if (this.find)
      for (let n = 0; n < this.find.length; n++)
        this.find[n].node == e && this.find[n].offset == t && (this.find[n].pos = this.currentPos);
  }
  findInside(e) {
    if (this.find)
      for (let t = 0; t < this.find.length; t++)
        this.find[t].pos == null && e.nodeType == 1 && e.contains(this.find[t].node) && (this.find[t].pos = this.currentPos);
  }
  findAround(e, t, n) {
    if (e != t && this.find)
      for (let i = 0; i < this.find.length; i++)
        this.find[i].pos == null && e.nodeType == 1 && e.contains(this.find[i].node) && t.compareDocumentPosition(this.find[i].node) & (n ? 2 : 4) && (this.find[i].pos = this.currentPos);
  }
  findInText(e) {
    if (this.find)
      for (let t = 0; t < this.find.length; t++)
        this.find[t].node == e && (this.find[t].pos = this.currentPos - (e.nodeValue.length - this.find[t].offset));
  }
  // Determines whether the given context string matches this context.
  matchesContext(e) {
    if (e.indexOf("|") > -1)
      return e.split(/\s*\|\s*/).some(this.matchesContext, this);
    let t = e.split("/"), n = this.options.context, i = !this.isOpen && (!n || n.parent.type == this.nodes[0].type), o = -(n ? n.depth + 1 : 0) + (i ? 0 : 1), a = (s, l) => {
      for (; s >= 0; s--) {
        let c = t[s];
        if (c == "") {
          if (s == t.length - 1 || s == 0)
            continue;
          for (; l >= o; l--)
            if (a(s - 1, l))
              return !0;
          return !1;
        } else {
          let u = l > 0 || l == 0 && i ? this.nodes[l].type : n && l >= o ? n.node(l - o).type : null;
          if (!u || u.name != c && u.groups.indexOf(c) == -1)
            return !1;
          l--;
        }
      }
      return !0;
    };
    return a(t.length - 1, this.open);
  }
  textblockFromContext() {
    let e = this.options.context;
    if (e)
      for (let t = e.depth; t >= 0; t--) {
        let n = e.node(t).contentMatchAt(e.indexAfter(t)).defaultType;
        if (n && n.isTextblock && n.defaultAttrs)
          return n;
      }
    for (let t in this.parser.schema.nodes) {
      let n = this.parser.schema.nodes[t];
      if (n.isTextblock && n.defaultAttrs)
        return n;
    }
  }
  addPendingMark(e) {
    let t = Cw(e, this.top.pendingMarks);
    t && this.top.stashMarks.push(t), this.top.pendingMarks = e.addToSet(this.top.pendingMarks);
  }
  removePendingMark(e, t) {
    for (let n = this.open; n >= 0; n--) {
      let i = this.nodes[n];
      if (i.pendingMarks.lastIndexOf(e) > -1)
        i.pendingMarks = e.removeFromSet(i.pendingMarks);
      else {
        i.activeMarks = e.removeFromSet(i.activeMarks);
        let a = i.popFromStashMark(e);
        a && i.type && i.type.allowsMarkType(a.type) && (i.activeMarks = a.addToSet(i.activeMarks));
      }
      if (i == t)
        break;
    }
  }
}
function yw(r) {
  for (let e = r.firstChild, t = null; e; e = e.nextSibling) {
    let n = e.nodeType == 1 ? e.nodeName.toLowerCase() : null;
    n && hf.hasOwnProperty(n) && t ? (t.appendChild(e), e = t) : n == "li" ? t = e : n && (t = null);
  }
}
function ww(r, e) {
  return (r.matches || r.msMatchesSelector || r.webkitMatchesSelector || r.mozMatchesSelector).call(r, e);
}
function bw(r) {
  let e = /\s*([\w-]+)\s*:\s*([^;]+)/g, t, n = [];
  for (; t = e.exec(r); )
    n.push(t[1], t[2].trim());
  return n;
}
function tc(r) {
  let e = {};
  for (let t in r)
    e[t] = r[t];
  return e;
}
function Sw(r, e) {
  let t = e.schema.nodes;
  for (let n in t) {
    let i = t[n];
    if (!i.allowsMarkType(r))
      continue;
    let o = [], a = (s) => {
      o.push(s);
      for (let l = 0; l < s.edgeCount; l++) {
        let { type: c, next: u } = s.edge(l);
        if (c == e || o.indexOf(u) < 0 && a(u))
          return !0;
      }
    };
    if (a(i.contentMatch))
      return !0;
  }
}
function Cw(r, e) {
  for (let t = 0; t < e.length; t++)
    if (r.eq(e[t]))
      return e[t];
}
class Bt {
  /**
  Create a serializer. `nodes` should map node names to functions
  that take a node and return a description of the corresponding
  DOM. `marks` does the same for mark names, but also gets an
  argument that tells it whether the mark's content is block or
  inline content (for typical use, it'll always be inline). A mark
  serializer may be `null` to indicate that marks of that type
  should not be serialized.
  */
  constructor(e, t) {
    this.nodes = e, this.marks = t;
  }
  /**
  Serialize the content of this fragment to a DOM fragment. When
  not in the browser, the `document` option, containing a DOM
  document, should be passed so that the serializer can create
  nodes.
  */
  serializeFragment(e, t = {}, n) {
    n || (n = Ko(t).createDocumentFragment());
    let i = n, o = [];
    return e.forEach((a) => {
      if (o.length || a.marks.length) {
        let s = 0, l = 0;
        for (; s < o.length && l < a.marks.length; ) {
          let c = a.marks[l];
          if (!this.marks[c.type.name]) {
            l++;
            continue;
          }
          if (!c.eq(o[s][0]) || c.type.spec.spanning === !1)
            break;
          s++, l++;
        }
        for (; s < o.length; )
          i = o.pop()[1];
        for (; l < a.marks.length; ) {
          let c = a.marks[l++], u = this.serializeMark(c, a.isInline, t);
          u && (o.push([c, i]), i.appendChild(u.dom), i = u.contentDOM || u.dom);
        }
      }
      i.appendChild(this.serializeNodeInner(a, t));
    }), n;
  }
  /**
  @internal
  */
  serializeNodeInner(e, t) {
    let { dom: n, contentDOM: i } = Bt.renderSpec(Ko(t), this.nodes[e.type.name](e));
    if (i) {
      if (e.isLeaf)
        throw new RangeError("Content hole not allowed in a leaf node spec");
      this.serializeFragment(e.content, t, i);
    }
    return n;
  }
  /**
  Serialize this node to a DOM node. This can be useful when you
  need to serialize a part of a document, as opposed to the whole
  document. To serialize a whole document, use
  [`serializeFragment`](https://prosemirror.net/docs/ref/#model.DOMSerializer.serializeFragment) on
  its [content](https://prosemirror.net/docs/ref/#model.Node.content).
  */
  serializeNode(e, t = {}) {
    let n = this.serializeNodeInner(e, t);
    for (let i = e.marks.length - 1; i >= 0; i--) {
      let o = this.serializeMark(e.marks[i], e.isInline, t);
      o && ((o.contentDOM || o.dom).appendChild(n), n = o.dom);
    }
    return n;
  }
  /**
  @internal
  */
  serializeMark(e, t, n = {}) {
    let i = this.marks[e.type.name];
    return i && Bt.renderSpec(Ko(n), i(e, t));
  }
  /**
  Render an [output spec](https://prosemirror.net/docs/ref/#model.DOMOutputSpec) to a DOM node. If
  the spec has a hole (zero) in it, `contentDOM` will point at the
  node with the hole.
  */
  static renderSpec(e, t, n = null) {
    if (typeof t == "string")
      return { dom: e.createTextNode(t) };
    if (t.nodeType != null)
      return { dom: t };
    if (t.dom && t.dom.nodeType != null)
      return t;
    let i = t[0], o = i.indexOf(" ");
    o > 0 && (n = i.slice(0, o), i = i.slice(o + 1));
    let a, s = n ? e.createElementNS(n, i) : e.createElement(i), l = t[1], c = 1;
    if (l && typeof l == "object" && l.nodeType == null && !Array.isArray(l)) {
      c = 2;
      for (let u in l)
        if (l[u] != null) {
          let f = u.indexOf(" ");
          f > 0 ? s.setAttributeNS(u.slice(0, f), u.slice(f + 1), l[u]) : s.setAttribute(u, l[u]);
        }
    }
    for (let u = c; u < t.length; u++) {
      let f = t[u];
      if (f === 0) {
        if (u < t.length - 1 || u > c)
          throw new RangeError("Content hole must be the only child of its parent node");
        return { dom: s, contentDOM: s };
      } else {
        let { dom: h, contentDOM: d } = Bt.renderSpec(e, f, n);
        if (s.appendChild(h), d) {
          if (a)
            throw new RangeError("Multiple content holes");
          a = d;
        }
      }
    }
    return { dom: s, contentDOM: a };
  }
  /**
  Build a serializer using the [`toDOM`](https://prosemirror.net/docs/ref/#model.NodeSpec.toDOM)
  properties in a schema's node and mark specs.
  */
  static fromSchema(e) {
    return e.cached.domSerializer || (e.cached.domSerializer = new Bt(this.nodesFromSchema(e), this.marksFromSchema(e)));
  }
  /**
  Gather the serializers in a schema's node specs into an object.
  This can be useful as a base to build a custom serializer from.
  */
  static nodesFromSchema(e) {
    let t = nc(e.nodes);
    return t.text || (t.text = (n) => n.text), t;
  }
  /**
  Gather the serializers in a schema's mark specs into an object.
  */
  static marksFromSchema(e) {
    return nc(e.marks);
  }
}
function nc(r) {
  let e = {};
  for (let t in r) {
    let n = r[t].spec.toDOM;
    n && (e[t] = n);
  }
  return e;
}
function Ko(r) {
  return r.document || window.document;
}
const df = 65535, pf = Math.pow(2, 16);
function kw(r, e) {
  return r + e * pf;
}
function rc(r) {
  return r & df;
}
function xw(r) {
  return (r - (r & df)) / pf;
}
const mf = 1, gf = 2, Ii = 4, vf = 8;
class Ba {
  /**
  @internal
  */
  constructor(e, t, n) {
    this.pos = e, this.delInfo = t, this.recover = n;
  }
  /**
  Tells you whether the position was deleted, that is, whether the
  step removed the token on the side queried (via the `assoc`)
  argument from the document.
  */
  get deleted() {
    return (this.delInfo & vf) > 0;
  }
  /**
  Tells you whether the token before the mapped position was deleted.
  */
  get deletedBefore() {
    return (this.delInfo & (mf | Ii)) > 0;
  }
  /**
  True when the token after the mapped position was deleted.
  */
  get deletedAfter() {
    return (this.delInfo & (gf | Ii)) > 0;
  }
  /**
  Tells whether any of the steps mapped through deletes across the
  position (including both the token before and after the
  position).
  */
  get deletedAcross() {
    return (this.delInfo & Ii) > 0;
  }
}
class pt {
  /**
  Create a position map. The modifications to the document are
  represented as an array of numbers, in which each group of three
  represents a modified chunk as `[start, oldSize, newSize]`.
  */
  constructor(e, t = !1) {
    if (this.ranges = e, this.inverted = t, !e.length && pt.empty)
      return pt.empty;
  }
  /**
  @internal
  */
  recover(e) {
    let t = 0, n = rc(e);
    if (!this.inverted)
      for (let i = 0; i < n; i++)
        t += this.ranges[i * 3 + 2] - this.ranges[i * 3 + 1];
    return this.ranges[n * 3] + t + xw(e);
  }
  mapResult(e, t = 1) {
    return this._map(e, t, !1);
  }
  map(e, t = 1) {
    return this._map(e, t, !0);
  }
  /**
  @internal
  */
  _map(e, t, n) {
    let i = 0, o = this.inverted ? 2 : 1, a = this.inverted ? 1 : 2;
    for (let s = 0; s < this.ranges.length; s += 3) {
      let l = this.ranges[s] - (this.inverted ? i : 0);
      if (l > e)
        break;
      let c = this.ranges[s + o], u = this.ranges[s + a], f = l + c;
      if (e <= f) {
        let h = c ? e == l ? -1 : e == f ? 1 : t : t, d = l + i + (h < 0 ? 0 : u);
        if (n)
          return d;
        let p = e == (t < 0 ? l : f) ? null : kw(s / 3, e - l), m = e == l ? gf : e == f ? mf : Ii;
        return (t < 0 ? e != l : e != f) && (m |= vf), new Ba(d, m, p);
      }
      i += u - c;
    }
    return n ? e + i : new Ba(e + i, 0, null);
  }
  /**
  @internal
  */
  touches(e, t) {
    let n = 0, i = rc(t), o = this.inverted ? 2 : 1, a = this.inverted ? 1 : 2;
    for (let s = 0; s < this.ranges.length; s += 3) {
      let l = this.ranges[s] - (this.inverted ? n : 0);
      if (l > e)
        break;
      let c = this.ranges[s + o], u = l + c;
      if (e <= u && s == i * 3)
        return !0;
      n += this.ranges[s + a] - c;
    }
    return !1;
  }
  /**
  Calls the given function on each of the changed ranges included in
  this map.
  */
  forEach(e) {
    let t = this.inverted ? 2 : 1, n = this.inverted ? 1 : 2;
    for (let i = 0, o = 0; i < this.ranges.length; i += 3) {
      let a = this.ranges[i], s = a - (this.inverted ? o : 0), l = a + (this.inverted ? 0 : o), c = this.ranges[i + t], u = this.ranges[i + n];
      e(s, s + c, l, l + u), o += u - c;
    }
  }
  /**
  Create an inverted version of this map. The result can be used to
  map positions in the post-step document to the pre-step document.
  */
  invert() {
    return new pt(this.ranges, !this.inverted);
  }
  /**
  @internal
  */
  toString() {
    return (this.inverted ? "-" : "") + JSON.stringify(this.ranges);
  }
  /**
  Create a map that moves all positions by offset `n` (which may be
  negative). This can be useful when applying steps meant for a
  sub-document to a larger document, or vice-versa.
  */
  static offset(e) {
    return e == 0 ? pt.empty : new pt(e < 0 ? [0, -e, 0] : [0, 0, e]);
  }
}
pt.empty = new pt([]);
class ur {
  /**
  Create a new mapping with the given position maps.
  */
  constructor(e = [], t, n = 0, i = e.length) {
    this.maps = e, this.mirror = t, this.from = n, this.to = i;
  }
  /**
  Create a mapping that maps only through a part of this one.
  */
  slice(e = 0, t = this.maps.length) {
    return new ur(this.maps, this.mirror, e, t);
  }
  /**
  @internal
  */
  copy() {
    return new ur(this.maps.slice(), this.mirror && this.mirror.slice(), this.from, this.to);
  }
  /**
  Add a step map to the end of this mapping. If `mirrors` is
  given, it should be the index of the step map that is the mirror
  image of this one.
  */
  appendMap(e, t) {
    this.to = this.maps.push(e), t != null && this.setMirror(this.maps.length - 1, t);
  }
  /**
  Add all the step maps in a given mapping to this one (preserving
  mirroring information).
  */
  appendMapping(e) {
    for (let t = 0, n = this.maps.length; t < e.maps.length; t++) {
      let i = e.getMirror(t);
      this.appendMap(e.maps[t], i != null && i < t ? n + i : void 0);
    }
  }
  /**
  Finds the offset of the step map that mirrors the map at the
  given offset, in this mapping (as per the second argument to
  `appendMap`).
  */
  getMirror(e) {
    if (this.mirror) {
      for (let t = 0; t < this.mirror.length; t++)
        if (this.mirror[t] == e)
          return this.mirror[t + (t % 2 ? -1 : 1)];
    }
  }
  /**
  @internal
  */
  setMirror(e, t) {
    this.mirror || (this.mirror = []), this.mirror.push(e, t);
  }
  /**
  Append the inverse of the given mapping to this one.
  */
  appendMappingInverted(e) {
    for (let t = e.maps.length - 1, n = this.maps.length + e.maps.length; t >= 0; t--) {
      let i = e.getMirror(t);
      this.appendMap(e.maps[t].invert(), i != null && i > t ? n - i - 1 : void 0);
    }
  }
  /**
  Create an inverted version of this mapping.
  */
  invert() {
    let e = new ur();
    return e.appendMappingInverted(this), e;
  }
  /**
  Map a position through this mapping.
  */
  map(e, t = 1) {
    if (this.mirror)
      return this._map(e, t, !0);
    for (let n = this.from; n < this.to; n++)
      e = this.maps[n].map(e, t);
    return e;
  }
  /**
  Map a position through this mapping, returning a mapping
  result.
  */
  mapResult(e, t = 1) {
    return this._map(e, t, !1);
  }
  /**
  @internal
  */
  _map(e, t, n) {
    let i = 0;
    for (let o = this.from; o < this.to; o++) {
      let a = this.maps[o], s = a.mapResult(e, t);
      if (s.recover != null) {
        let l = this.getMirror(o);
        if (l != null && l > o && l < this.to) {
          o = l, e = this.maps[l].recover(s.recover);
          continue;
        }
      }
      i |= s.delInfo, e = s.pos;
    }
    return n ? e : new Ba(e, i, null);
  }
}
const Go = /* @__PURE__ */ Object.create(null);
class rt {
  /**
  Get the step map that represents the changes made by this step,
  and which can be used to transform between positions in the old
  and the new document.
  */
  getMap() {
    return pt.empty;
  }
  /**
  Try to merge this step with another one, to be applied directly
  after it. Returns the merged step when possible, null if the
  steps can't be merged.
  */
  merge(e) {
    return null;
  }
  /**
  Deserialize a step from its JSON representation. Will call
  through to the step class' own implementation of this method.
  */
  static fromJSON(e, t) {
    if (!t || !t.stepType)
      throw new RangeError("Invalid input for Step.fromJSON");
    let n = Go[t.stepType];
    if (!n)
      throw new RangeError(`No step type ${t.stepType} defined`);
    return n.fromJSON(e, t);
  }
  /**
  To be able to serialize steps to JSON, each step needs a string
  ID to attach to its JSON representation. Use this method to
  register an ID for your step classes. Try to pick something
  that's unlikely to clash with steps from other modules.
  */
  static jsonID(e, t) {
    if (e in Go)
      throw new RangeError("Duplicate use of step JSON ID " + e);
    return Go[e] = t, t.prototype.jsonID = e, t;
  }
}
class Ee {
  /**
  @internal
  */
  constructor(e, t) {
    this.doc = e, this.failed = t;
  }
  /**
  Create a successful step result.
  */
  static ok(e) {
    return new Ee(e, null);
  }
  /**
  Create a failed step result.
  */
  static fail(e) {
    return new Ee(null, e);
  }
  /**
  Call [`Node.replace`](https://prosemirror.net/docs/ref/#model.Node.replace) with the given
  arguments. Create a successful result if it succeeds, and a
  failed one if it throws a `ReplaceError`.
  */
  static fromReplace(e, t, n, i) {
    try {
      return Ee.ok(e.replace(t, n, i));
    } catch (o) {
      if (o instanceof Bi)
        return Ee.fail(o.message);
      throw o;
    }
  }
}
function js(r, e, t) {
  let n = [];
  for (let i = 0; i < r.childCount; i++) {
    let o = r.child(i);
    o.content.size && (o = o.copy(js(o.content, e, o))), o.isInline && (o = e(o, t, i)), n.push(o);
  }
  return I.fromArray(n);
}
class Yt extends rt {
  /**
  Create a mark step.
  */
  constructor(e, t, n) {
    super(), this.from = e, this.to = t, this.mark = n;
  }
  apply(e) {
    let t = e.slice(this.from, this.to), n = e.resolve(this.from), i = n.node(n.sharedDepth(this.to)), o = new $(js(t.content, (a, s) => !a.isAtom || !s.type.allowsMarkType(this.mark.type) ? a : a.mark(this.mark.addToSet(a.marks)), i), t.openStart, t.openEnd);
    return Ee.fromReplace(e, this.from, this.to, o);
  }
  invert() {
    return new gt(this.from, this.to, this.mark);
  }
  map(e) {
    let t = e.mapResult(this.from, 1), n = e.mapResult(this.to, -1);
    return t.deleted && n.deleted || t.pos >= n.pos ? null : new Yt(t.pos, n.pos, this.mark);
  }
  merge(e) {
    return e instanceof Yt && e.mark.eq(this.mark) && this.from <= e.to && this.to >= e.from ? new Yt(Math.min(this.from, e.from), Math.max(this.to, e.to), this.mark) : null;
  }
  toJSON() {
    return {
      stepType: "addMark",
      mark: this.mark.toJSON(),
      from: this.from,
      to: this.to
    };
  }
  /**
  @internal
  */
  static fromJSON(e, t) {
    if (typeof t.from != "number" || typeof t.to != "number")
      throw new RangeError("Invalid input for AddMarkStep.fromJSON");
    return new Yt(t.from, t.to, e.markFromJSON(t.mark));
  }
}
rt.jsonID("addMark", Yt);
class gt extends rt {
  /**
  Create a mark-removing step.
  */
  constructor(e, t, n) {
    super(), this.from = e, this.to = t, this.mark = n;
  }
  apply(e) {
    let t = e.slice(this.from, this.to), n = new $(js(t.content, (i) => i.mark(this.mark.removeFromSet(i.marks)), e), t.openStart, t.openEnd);
    return Ee.fromReplace(e, this.from, this.to, n);
  }
  invert() {
    return new Yt(this.from, this.to, this.mark);
  }
  map(e) {
    let t = e.mapResult(this.from, 1), n = e.mapResult(this.to, -1);
    return t.deleted && n.deleted || t.pos >= n.pos ? null : new gt(t.pos, n.pos, this.mark);
  }
  merge(e) {
    return e instanceof gt && e.mark.eq(this.mark) && this.from <= e.to && this.to >= e.from ? new gt(Math.min(this.from, e.from), Math.max(this.to, e.to), this.mark) : null;
  }
  toJSON() {
    return {
      stepType: "removeMark",
      mark: this.mark.toJSON(),
      from: this.from,
      to: this.to
    };
  }
  /**
  @internal
  */
  static fromJSON(e, t) {
    if (typeof t.from != "number" || typeof t.to != "number")
      throw new RangeError("Invalid input for RemoveMarkStep.fromJSON");
    return new gt(t.from, t.to, e.markFromJSON(t.mark));
  }
}
rt.jsonID("removeMark", gt);
class mn extends rt {
  /**
  Create a node mark step.
  */
  constructor(e, t) {
    super(), this.pos = e, this.mark = t;
  }
  apply(e) {
    let t = e.nodeAt(this.pos);
    if (!t)
      return Ee.fail("No node at mark step's position");
    let n = t.type.create(t.attrs, null, this.mark.addToSet(t.marks));
    return Ee.fromReplace(e, this.pos, this.pos + 1, new $(I.from(n), 0, t.isLeaf ? 0 : 1));
  }
  invert(e) {
    let t = e.nodeAt(this.pos);
    if (t) {
      let n = this.mark.addToSet(t.marks);
      if (n.length == t.marks.length) {
        for (let i = 0; i < t.marks.length; i++)
          if (!t.marks[i].isInSet(n))
            return new mn(this.pos, t.marks[i]);
        return new mn(this.pos, this.mark);
      }
    }
    return new vr(this.pos, this.mark);
  }
  map(e) {
    let t = e.mapResult(this.pos, 1);
    return t.deletedAfter ? null : new mn(t.pos, this.mark);
  }
  toJSON() {
    return { stepType: "addNodeMark", pos: this.pos, mark: this.mark.toJSON() };
  }
  /**
  @internal
  */
  static fromJSON(e, t) {
    if (typeof t.pos != "number")
      throw new RangeError("Invalid input for AddNodeMarkStep.fromJSON");
    return new mn(t.pos, e.markFromJSON(t.mark));
  }
}
rt.jsonID("addNodeMark", mn);
class vr extends rt {
  /**
  Create a mark-removing step.
  */
  constructor(e, t) {
    super(), this.pos = e, this.mark = t;
  }
  apply(e) {
    let t = e.nodeAt(this.pos);
    if (!t)
      return Ee.fail("No node at mark step's position");
    let n = t.type.create(t.attrs, null, this.mark.removeFromSet(t.marks));
    return Ee.fromReplace(e, this.pos, this.pos + 1, new $(I.from(n), 0, t.isLeaf ? 0 : 1));
  }
  invert(e) {
    let t = e.nodeAt(this.pos);
    return !t || !this.mark.isInSet(t.marks) ? this : new mn(this.pos, this.mark);
  }
  map(e) {
    let t = e.mapResult(this.pos, 1);
    return t.deletedAfter ? null : new vr(t.pos, this.mark);
  }
  toJSON() {
    return { stepType: "removeNodeMark", pos: this.pos, mark: this.mark.toJSON() };
  }
  /**
  @internal
  */
  static fromJSON(e, t) {
    if (typeof t.pos != "number")
      throw new RangeError("Invalid input for RemoveNodeMarkStep.fromJSON");
    return new vr(t.pos, e.markFromJSON(t.mark));
  }
}
rt.jsonID("removeNodeMark", vr);
class qe extends rt {
  /**
  The given `slice` should fit the 'gap' between `from` and
  `to`—the depths must line up, and the surrounding nodes must be
  able to be joined with the open sides of the slice. When
  `structure` is true, the step will fail if the content between
  from and to is not just a sequence of closing and then opening
  tokens (this is to guard against rebased replace steps
  overwriting something they weren't supposed to).
  */
  constructor(e, t, n, i = !1) {
    super(), this.from = e, this.to = t, this.slice = n, this.structure = i;
  }
  apply(e) {
    return this.structure && $a(e, this.from, this.to) ? Ee.fail("Structure replace would overwrite content") : Ee.fromReplace(e, this.from, this.to, this.slice);
  }
  getMap() {
    return new pt([this.from, this.to - this.from, this.slice.size]);
  }
  invert(e) {
    return new qe(this.from, this.from + this.slice.size, e.slice(this.from, this.to));
  }
  map(e) {
    let t = e.mapResult(this.from, 1), n = e.mapResult(this.to, -1);
    return t.deletedAcross && n.deletedAcross ? null : new qe(t.pos, Math.max(t.pos, n.pos), this.slice);
  }
  merge(e) {
    if (!(e instanceof qe) || e.structure || this.structure)
      return null;
    if (this.from + this.slice.size == e.from && !this.slice.openEnd && !e.slice.openStart) {
      let t = this.slice.size + e.slice.size == 0 ? $.empty : new $(this.slice.content.append(e.slice.content), this.slice.openStart, e.slice.openEnd);
      return new qe(this.from, this.to + (e.to - e.from), t, this.structure);
    } else if (e.to == this.from && !this.slice.openStart && !e.slice.openEnd) {
      let t = this.slice.size + e.slice.size == 0 ? $.empty : new $(e.slice.content.append(this.slice.content), e.slice.openStart, this.slice.openEnd);
      return new qe(e.from, this.to, t, this.structure);
    } else
      return null;
  }
  toJSON() {
    let e = { stepType: "replace", from: this.from, to: this.to };
    return this.slice.size && (e.slice = this.slice.toJSON()), this.structure && (e.structure = !0), e;
  }
  /**
  @internal
  */
  static fromJSON(e, t) {
    if (typeof t.from != "number" || typeof t.to != "number")
      throw new RangeError("Invalid input for ReplaceStep.fromJSON");
    return new qe(t.from, t.to, $.fromJSON(e, t.slice), !!t.structure);
  }
}
rt.jsonID("replace", qe);
class Ne extends rt {
  /**
  Create a replace-around step with the given range and gap.
  `insert` should be the point in the slice into which the content
  of the gap should be moved. `structure` has the same meaning as
  it has in the [`ReplaceStep`](https://prosemirror.net/docs/ref/#transform.ReplaceStep) class.
  */
  constructor(e, t, n, i, o, a, s = !1) {
    super(), this.from = e, this.to = t, this.gapFrom = n, this.gapTo = i, this.slice = o, this.insert = a, this.structure = s;
  }
  apply(e) {
    if (this.structure && ($a(e, this.from, this.gapFrom) || $a(e, this.gapTo, this.to)))
      return Ee.fail("Structure gap-replace would overwrite content");
    let t = e.slice(this.gapFrom, this.gapTo);
    if (t.openStart || t.openEnd)
      return Ee.fail("Gap is not a flat range");
    let n = this.slice.insertAt(this.insert, t.content);
    return n ? Ee.fromReplace(e, this.from, this.to, n) : Ee.fail("Content does not fit in gap");
  }
  getMap() {
    return new pt([
      this.from,
      this.gapFrom - this.from,
      this.insert,
      this.gapTo,
      this.to - this.gapTo,
      this.slice.size - this.insert
    ]);
  }
  invert(e) {
    let t = this.gapTo - this.gapFrom;
    return new Ne(this.from, this.from + this.slice.size + t, this.from + this.insert, this.from + this.insert + t, e.slice(this.from, this.to).removeBetween(this.gapFrom - this.from, this.gapTo - this.from), this.gapFrom - this.from, this.structure);
  }
  map(e) {
    let t = e.mapResult(this.from, 1), n = e.mapResult(this.to, -1), i = e.map(this.gapFrom, -1), o = e.map(this.gapTo, 1);
    return t.deletedAcross && n.deletedAcross || i < t.pos || o > n.pos ? null : new Ne(t.pos, n.pos, i, o, this.slice, this.insert, this.structure);
  }
  toJSON() {
    let e = {
      stepType: "replaceAround",
      from: this.from,
      to: this.to,
      gapFrom: this.gapFrom,
      gapTo: this.gapTo,
      insert: this.insert
    };
    return this.slice.size && (e.slice = this.slice.toJSON()), this.structure && (e.structure = !0), e;
  }
  /**
  @internal
  */
  static fromJSON(e, t) {
    if (typeof t.from != "number" || typeof t.to != "number" || typeof t.gapFrom != "number" || typeof t.gapTo != "number" || typeof t.insert != "number")
      throw new RangeError("Invalid input for ReplaceAroundStep.fromJSON");
    return new Ne(t.from, t.to, t.gapFrom, t.gapTo, $.fromJSON(e, t.slice), t.insert, !!t.structure);
  }
}
rt.jsonID("replaceAround", Ne);
function $a(r, e, t) {
  let n = r.resolve(e), i = t - e, o = n.depth;
  for (; i > 0 && o > 0 && n.indexAfter(o) == n.node(o).childCount; )
    o--, i--;
  if (i > 0) {
    let a = n.node(o).maybeChild(n.indexAfter(o));
    for (; i > 0; ) {
      if (!a || a.isLeaf)
        return !0;
      a = a.firstChild, i--;
    }
  }
  return !1;
}
function Ow(r, e, t, n) {
  let i = [], o = [], a, s;
  r.doc.nodesBetween(e, t, (l, c, u) => {
    if (!l.isInline)
      return;
    let f = l.marks;
    if (!n.isInSet(f) && u.type.allowsMarkType(n.type)) {
      let h = Math.max(c, e), d = Math.min(c + l.nodeSize, t), p = n.addToSet(f);
      for (let m = 0; m < f.length; m++)
        f[m].isInSet(p) || (a && a.to == h && a.mark.eq(f[m]) ? a.to = d : i.push(a = new gt(h, d, f[m])));
      s && s.to == h ? s.to = d : o.push(s = new Yt(h, d, n));
    }
  }), i.forEach((l) => r.step(l)), o.forEach((l) => r.step(l));
}
function Tw(r, e, t, n) {
  let i = [], o = 0;
  r.doc.nodesBetween(e, t, (a, s) => {
    if (!a.isInline)
      return;
    o++;
    let l = null;
    if (n instanceof si) {
      let c = a.marks, u;
      for (; u = n.isInSet(c); )
        (l || (l = [])).push(u), c = u.removeFromSet(c);
    } else
      n ? n.isInSet(a.marks) && (l = [n]) : l = a.marks;
    if (l && l.length) {
      let c = Math.min(s + a.nodeSize, t);
      for (let u = 0; u < l.length; u++) {
        let f = l[u], h;
        for (let d = 0; d < i.length; d++) {
          let p = i[d];
          p.step == o - 1 && f.eq(i[d].style) && (h = p);
        }
        h ? (h.to = c, h.step = o) : i.push({ style: f, from: Math.max(s, e), to: c, step: o });
      }
    }
  }), i.forEach((a) => r.step(new gt(a.from, a.to, a.style)));
}
function Mw(r, e, t, n = t.contentMatch) {
  let i = r.doc.nodeAt(e), o = [], a = e + 1;
  for (let s = 0; s < i.childCount; s++) {
    let l = i.child(s), c = a + l.nodeSize, u = n.matchType(l.type);
    if (!u)
      o.push(new qe(a, c, $.empty));
    else {
      n = u;
      for (let f = 0; f < l.marks.length; f++)
        t.allowsMarkType(l.marks[f].type) || r.step(new gt(a, c, l.marks[f]));
    }
    a = c;
  }
  if (!n.validEnd) {
    let s = n.fillBefore(I.empty, !0);
    r.replace(a, a, new $(s, 0, 0));
  }
  for (let s = o.length - 1; s >= 0; s--)
    r.step(o[s]);
}
function _w(r, e, t) {
  return (e == 0 || r.canReplace(e, r.childCount)) && (t == r.childCount || r.canReplace(0, t));
}
function Or(r) {
  let t = r.parent.content.cutByIndex(r.startIndex, r.endIndex);
  for (let n = r.depth; ; --n) {
    let i = r.$from.node(n), o = r.$from.index(n), a = r.$to.indexAfter(n);
    if (n < r.depth && i.canReplace(o, a, t))
      return n;
    if (n == 0 || i.type.spec.isolating || !_w(i, o, a))
      break;
  }
  return null;
}
function Iw(r, e, t) {
  let { $from: n, $to: i, depth: o } = e, a = n.before(o + 1), s = i.after(o + 1), l = a, c = s, u = I.empty, f = 0;
  for (let p = o, m = !1; p > t; p--)
    m || n.index(p) > 0 ? (m = !0, u = I.from(n.node(p).copy(u)), f++) : l--;
  let h = I.empty, d = 0;
  for (let p = o, m = !1; p > t; p--)
    m || i.after(p + 1) < i.end(p) ? (m = !0, h = I.from(i.node(p).copy(h)), d++) : c++;
  r.step(new Ne(l, c, a, s, new $(u.append(h), f, d), u.size - f, !0));
}
function Dw(r, e, t = null, n = r) {
  let i = Ew(r, e), o = i && Aw(n, e);
  return o ? i.map(ic).concat({ type: e, attrs: t }).concat(o.map(ic)) : null;
}
function ic(r) {
  return { type: r, attrs: null };
}
function Ew(r, e) {
  let { parent: t, startIndex: n, endIndex: i } = r, o = t.contentMatchAt(n).findWrapping(e);
  if (!o)
    return null;
  let a = o.length ? o[0] : e;
  return t.canReplaceWith(n, i, a) ? o : null;
}
function Aw(r, e) {
  let { parent: t, startIndex: n, endIndex: i } = r, o = t.child(n), a = e.contentMatch.findWrapping(o.type);
  if (!a)
    return null;
  let l = (a.length ? a[a.length - 1] : e).contentMatch;
  for (let c = n; l && c < i; c++)
    l = l.matchType(t.child(c).type);
  return !l || !l.validEnd ? null : a;
}
function Nw(r, e, t) {
  let n = I.empty;
  for (let a = t.length - 1; a >= 0; a--) {
    if (n.size) {
      let s = t[a].type.contentMatch.matchFragment(n);
      if (!s || !s.validEnd)
        throw new RangeError("Wrapper type given to Transform.wrap does not form valid content of its parent wrapper");
    }
    n = I.from(t[a].type.create(t[a].attrs, n));
  }
  let i = e.start, o = e.end;
  r.step(new Ne(i, o, i, o, new $(n, 0, 0), t.length, !0));
}
function Rw(r, e, t, n, i) {
  if (!n.isTextblock)
    throw new RangeError("Type given to setBlockType should be a textblock");
  let o = r.steps.length;
  r.doc.nodesBetween(e, t, (a, s) => {
    if (a.isTextblock && !a.hasMarkup(n, i) && Pw(r.doc, r.mapping.slice(o).map(s), n)) {
      r.clearIncompatible(r.mapping.slice(o).map(s, 1), n);
      let l = r.mapping.slice(o), c = l.map(s, 1), u = l.map(s + a.nodeSize, 1);
      return r.step(new Ne(c, u, c + 1, u - 1, new $(I.from(n.create(i, null, a.marks)), 0, 0), 1, !0)), !1;
    }
  });
}
function Pw(r, e, t) {
  let n = r.resolve(e), i = n.index();
  return n.parent.canReplaceWith(i, i + 1, t);
}
function Lw(r, e, t, n, i) {
  let o = r.doc.nodeAt(e);
  if (!o)
    throw new RangeError("No node at given position");
  t || (t = o.type);
  let a = t.create(n, null, i || o.marks);
  if (o.isLeaf)
    return r.replaceWith(e, e + o.nodeSize, a);
  if (!t.validContent(o.content))
    throw new RangeError("Invalid content for node type " + t.name);
  r.step(new Ne(e, e + o.nodeSize, e + 1, e + o.nodeSize - 1, new $(I.from(a), 0, 0), 1, !0));
}
function fr(r, e, t = 1, n) {
  let i = r.resolve(e), o = i.depth - t, a = n && n[n.length - 1] || i.parent;
  if (o < 0 || i.parent.type.spec.isolating || !i.parent.canReplace(i.index(), i.parent.childCount) || !a.type.validContent(i.parent.content.cutByIndex(i.index(), i.parent.childCount)))
    return !1;
  for (let c = i.depth - 1, u = t - 2; c > o; c--, u--) {
    let f = i.node(c), h = i.index(c);
    if (f.type.spec.isolating)
      return !1;
    let d = f.content.cutByIndex(h, f.childCount), p = n && n[u] || f;
    if (p != f && (d = d.replaceChild(0, p.type.create(p.attrs))), !f.canReplace(h + 1, f.childCount) || !p.type.validContent(d))
      return !1;
  }
  let s = i.indexAfter(o), l = n && n[0];
  return i.node(o).canReplaceWith(s, s, l ? l.type : i.node(o + 1).type);
}
function Fw(r, e, t = 1, n) {
  let i = r.doc.resolve(e), o = I.empty, a = I.empty;
  for (let s = i.depth, l = i.depth - t, c = t - 1; s > l; s--, c--) {
    o = I.from(i.node(s).copy(o));
    let u = n && n[c];
    a = I.from(u ? u.type.create(u.attrs, a) : i.node(s).copy(a));
  }
  r.step(new qe(e, e, new $(o.append(a), t, t), !0));
}
function fo(r, e) {
  let t = r.resolve(e), n = t.index();
  return zw(t.nodeBefore, t.nodeAfter) && t.parent.canReplace(n, n + 1);
}
function zw(r, e) {
  return !!(r && e && !r.isLeaf && r.canAppend(e));
}
function Bw(r, e, t) {
  let n = new qe(e - t, e + t, $.empty, !0);
  r.step(n);
}
function $w(r, e, t) {
  let n = r.resolve(e);
  if (n.parent.canReplaceWith(n.index(), n.index(), t))
    return e;
  if (n.parentOffset == 0)
    for (let i = n.depth - 1; i >= 0; i--) {
      let o = n.index(i);
      if (n.node(i).canReplaceWith(o, o, t))
        return n.before(i + 1);
      if (o > 0)
        return null;
    }
  if (n.parentOffset == n.parent.content.size)
    for (let i = n.depth - 1; i >= 0; i--) {
      let o = n.indexAfter(i);
      if (n.node(i).canReplaceWith(o, o, t))
        return n.after(i + 1);
      if (o < n.node(i).childCount)
        return null;
    }
  return null;
}
function yf(r, e, t) {
  let n = r.resolve(e);
  if (!t.content.size)
    return e;
  let i = t.content;
  for (let o = 0; o < t.openStart; o++)
    i = i.firstChild.content;
  for (let o = 1; o <= (t.openStart == 0 && t.size ? 2 : 1); o++)
    for (let a = n.depth; a >= 0; a--) {
      let s = a == n.depth ? 0 : n.pos <= (n.start(a + 1) + n.end(a + 1)) / 2 ? -1 : 1, l = n.index(a) + (s > 0 ? 1 : 0), c = n.node(a), u = !1;
      if (o == 1)
        u = c.canReplace(l, l, i);
      else {
        let f = c.contentMatchAt(l).findWrapping(i.firstChild.type);
        u = f && c.canReplaceWith(l, l, f[0]);
      }
      if (u)
        return s == 0 ? n.pos : s < 0 ? n.before(a + 1) : n.after(a + 1);
    }
  return null;
}
function Ws(r, e, t = e, n = $.empty) {
  if (e == t && !n.size)
    return null;
  let i = r.resolve(e), o = r.resolve(t);
  return wf(i, o, n) ? new qe(e, t, n) : new Hw(i, o, n).fit();
}
function wf(r, e, t) {
  return !t.openStart && !t.openEnd && r.start() == e.start() && r.parent.canReplace(r.index(), e.index(), t.content);
}
class Hw {
  constructor(e, t, n) {
    this.$from = e, this.$to = t, this.unplaced = n, this.frontier = [], this.placed = I.empty;
    for (let i = 0; i <= e.depth; i++) {
      let o = e.node(i);
      this.frontier.push({
        type: o.type,
        match: o.contentMatchAt(e.indexAfter(i))
      });
    }
    for (let i = e.depth; i > 0; i--)
      this.placed = I.from(e.node(i).copy(this.placed));
  }
  get depth() {
    return this.frontier.length - 1;
  }
  fit() {
    for (; this.unplaced.size; ) {
      let c = this.findFittable();
      c ? this.placeNodes(c) : this.openMore() || this.dropNode();
    }
    let e = this.mustMoveInline(), t = this.placed.size - this.depth - this.$from.depth, n = this.$from, i = this.close(e < 0 ? this.$to : n.doc.resolve(e));
    if (!i)
      return null;
    let o = this.placed, a = n.depth, s = i.depth;
    for (; a && s && o.childCount == 1; )
      o = o.firstChild.content, a--, s--;
    let l = new $(o, a, s);
    return e > -1 ? new Ne(n.pos, e, this.$to.pos, this.$to.end(), l, t) : l.size || n.pos != this.$to.pos ? new qe(n.pos, i.pos, l) : null;
  }
  // Find a position on the start spine of `this.unplaced` that has
  // content that can be moved somewhere on the frontier. Returns two
  // depths, one for the slice and one for the frontier.
  findFittable() {
    let e = this.unplaced.openStart;
    for (let t = this.unplaced.content, n = 0, i = this.unplaced.openEnd; n < e; n++) {
      let o = t.firstChild;
      if (t.childCount > 1 && (i = 0), o.type.spec.isolating && i <= n) {
        e = n;
        break;
      }
      t = o.content;
    }
    for (let t = 1; t <= 2; t++)
      for (let n = t == 1 ? e : this.unplaced.openStart; n >= 0; n--) {
        let i, o = null;
        n ? (o = Jo(this.unplaced.content, n - 1).firstChild, i = o.content) : i = this.unplaced.content;
        let a = i.firstChild;
        for (let s = this.depth; s >= 0; s--) {
          let { type: l, match: c } = this.frontier[s], u, f = null;
          if (t == 1 && (a ? c.matchType(a.type) || (f = c.fillBefore(I.from(a), !1)) : o && l.compatibleContent(o.type)))
            return { sliceDepth: n, frontierDepth: s, parent: o, inject: f };
          if (t == 2 && a && (u = c.findWrapping(a.type)))
            return { sliceDepth: n, frontierDepth: s, parent: o, wrap: u };
          if (o && c.matchType(o.type))
            break;
        }
      }
  }
  openMore() {
    let { content: e, openStart: t, openEnd: n } = this.unplaced, i = Jo(e, t);
    return !i.childCount || i.firstChild.isLeaf ? !1 : (this.unplaced = new $(e, t + 1, Math.max(n, i.size + t >= e.size - n ? t + 1 : 0)), !0);
  }
  dropNode() {
    let { content: e, openStart: t, openEnd: n } = this.unplaced, i = Jo(e, t);
    if (i.childCount <= 1 && t > 0) {
      let o = e.size - t <= t + i.size;
      this.unplaced = new $(Rr(e, t - 1, 1), t - 1, o ? t - 1 : n);
    } else
      this.unplaced = new $(Rr(e, t, 1), t, n);
  }
  // Move content from the unplaced slice at `sliceDepth` to the
  // frontier node at `frontierDepth`. Close that frontier node when
  // applicable.
  placeNodes({ sliceDepth: e, frontierDepth: t, parent: n, inject: i, wrap: o }) {
    for (; this.depth > t; )
      this.closeFrontierNode();
    if (o)
      for (let m = 0; m < o.length; m++)
        this.openFrontierNode(o[m]);
    let a = this.unplaced, s = n ? n.content : a.content, l = a.openStart - e, c = 0, u = [], { match: f, type: h } = this.frontier[t];
    if (i) {
      for (let m = 0; m < i.childCount; m++)
        u.push(i.child(m));
      f = f.matchFragment(i);
    }
    let d = s.size + e - (a.content.size - a.openEnd);
    for (; c < s.childCount; ) {
      let m = s.child(c), v = f.matchType(m.type);
      if (!v)
        break;
      c++, (c > 1 || l == 0 || m.content.size) && (f = v, u.push(bf(m.mark(h.allowedMarks(m.marks)), c == 1 ? l : 0, c == s.childCount ? d : -1)));
    }
    let p = c == s.childCount;
    p || (d = -1), this.placed = Pr(this.placed, t, I.from(u)), this.frontier[t].match = f, p && d < 0 && n && n.type == this.frontier[this.depth].type && this.frontier.length > 1 && this.closeFrontierNode();
    for (let m = 0, v = s; m < d; m++) {
      let y = v.lastChild;
      this.frontier.push({ type: y.type, match: y.contentMatchAt(y.childCount) }), v = y.content;
    }
    this.unplaced = p ? e == 0 ? $.empty : new $(Rr(a.content, e - 1, 1), e - 1, d < 0 ? a.openEnd : e - 1) : new $(Rr(a.content, e, c), a.openStart, a.openEnd);
  }
  mustMoveInline() {
    if (!this.$to.parent.isTextblock)
      return -1;
    let e = this.frontier[this.depth], t;
    if (!e.type.isTextblock || !Xo(this.$to, this.$to.depth, e.type, e.match, !1) || this.$to.depth == this.depth && (t = this.findCloseLevel(this.$to)) && t.depth == this.depth)
      return -1;
    let { depth: n } = this.$to, i = this.$to.after(n);
    for (; n > 1 && i == this.$to.end(--n); )
      ++i;
    return i;
  }
  findCloseLevel(e) {
    e:
      for (let t = Math.min(this.depth, e.depth); t >= 0; t--) {
        let { match: n, type: i } = this.frontier[t], o = t < e.depth && e.end(t + 1) == e.pos + (e.depth - (t + 1)), a = Xo(e, t, i, n, o);
        if (a) {
          for (let s = t - 1; s >= 0; s--) {
            let { match: l, type: c } = this.frontier[s], u = Xo(e, s, c, l, !0);
            if (!u || u.childCount)
              continue e;
          }
          return { depth: t, fit: a, move: o ? e.doc.resolve(e.after(t + 1)) : e };
        }
      }
  }
  close(e) {
    let t = this.findCloseLevel(e);
    if (!t)
      return null;
    for (; this.depth > t.depth; )
      this.closeFrontierNode();
    t.fit.childCount && (this.placed = Pr(this.placed, t.depth, t.fit)), e = t.move;
    for (let n = t.depth + 1; n <= e.depth; n++) {
      let i = e.node(n), o = i.type.contentMatch.fillBefore(i.content, !0, e.index(n));
      this.openFrontierNode(i.type, i.attrs, o);
    }
    return e;
  }
  openFrontierNode(e, t = null, n) {
    let i = this.frontier[this.depth];
    i.match = i.match.matchType(e), this.placed = Pr(this.placed, this.depth, I.from(e.create(t, n))), this.frontier.push({ type: e, match: e.contentMatch });
  }
  closeFrontierNode() {
    let t = this.frontier.pop().match.fillBefore(I.empty, !0);
    t.childCount && (this.placed = Pr(this.placed, this.frontier.length, t));
  }
}
function Rr(r, e, t) {
  return e == 0 ? r.cutByIndex(t, r.childCount) : r.replaceChild(0, r.firstChild.copy(Rr(r.firstChild.content, e - 1, t)));
}
function Pr(r, e, t) {
  return e == 0 ? r.append(t) : r.replaceChild(r.childCount - 1, r.lastChild.copy(Pr(r.lastChild.content, e - 1, t)));
}
function Jo(r, e) {
  for (let t = 0; t < e; t++)
    r = r.firstChild.content;
  return r;
}
function bf(r, e, t) {
  if (e <= 0)
    return r;
  let n = r.content;
  return e > 1 && (n = n.replaceChild(0, bf(n.firstChild, e - 1, n.childCount == 1 ? t - 1 : 0))), e > 0 && (n = r.type.contentMatch.fillBefore(n).append(n), t <= 0 && (n = n.append(r.type.contentMatch.matchFragment(n).fillBefore(I.empty, !0)))), r.copy(n);
}
function Xo(r, e, t, n, i) {
  let o = r.node(e), a = i ? r.indexAfter(e) : r.index(e);
  if (a == o.childCount && !t.compatibleContent(o.type))
    return null;
  let s = n.fillBefore(o.content, !0, a);
  return s && !jw(t, o.content, a) ? s : null;
}
function jw(r, e, t) {
  for (let n = t; n < e.childCount; n++)
    if (!r.allowsMarks(e.child(n).marks))
      return !0;
  return !1;
}
function Ww(r) {
  return r.spec.defining || r.spec.definingForContent;
}
function Vw(r, e, t, n) {
  if (!n.size)
    return r.deleteRange(e, t);
  let i = r.doc.resolve(e), o = r.doc.resolve(t);
  if (wf(i, o, n))
    return r.step(new qe(e, t, n));
  let a = Cf(i, r.doc.resolve(t));
  a[a.length - 1] == 0 && a.pop();
  let s = -(i.depth + 1);
  a.unshift(s);
  for (let h = i.depth, d = i.pos - 1; h > 0; h--, d--) {
    let p = i.node(h).type.spec;
    if (p.defining || p.definingAsContext || p.isolating)
      break;
    a.indexOf(h) > -1 ? s = h : i.before(h) == d && a.splice(1, 0, -h);
  }
  let l = a.indexOf(s), c = [], u = n.openStart;
  for (let h = n.content, d = 0; ; d++) {
    let p = h.firstChild;
    if (c.push(p), d == n.openStart)
      break;
    h = p.content;
  }
  for (let h = u - 1; h >= 0; h--) {
    let d = c[h].type, p = Ww(d);
    if (p && i.node(l).type != d)
      u = h;
    else if (p || !d.isTextblock)
      break;
  }
  for (let h = n.openStart; h >= 0; h--) {
    let d = (h + u + 1) % (n.openStart + 1), p = c[d];
    if (p)
      for (let m = 0; m < a.length; m++) {
        let v = a[(m + l) % a.length], y = !0;
        v < 0 && (y = !1, v = -v);
        let b = i.node(v - 1), k = i.index(v - 1);
        if (b.canReplaceWith(k, k, p.type, p.marks))
          return r.replace(i.before(v), y ? o.after(v) : t, new $(Sf(n.content, 0, n.openStart, d), d, n.openEnd));
      }
  }
  let f = r.steps.length;
  for (let h = a.length - 1; h >= 0 && (r.replace(e, t, n), !(r.steps.length > f)); h--) {
    let d = a[h];
    d < 0 || (e = i.before(d), t = o.after(d));
  }
}
function Sf(r, e, t, n, i) {
  if (e < t) {
    let o = r.firstChild;
    r = r.replaceChild(0, o.copy(Sf(o.content, e + 1, t, n, o)));
  }
  if (e > n) {
    let o = i.contentMatchAt(0), a = o.fillBefore(r).append(r);
    r = a.append(o.matchFragment(a).fillBefore(I.empty, !0));
  }
  return r;
}
function Uw(r, e, t, n) {
  if (!n.isInline && e == t && r.doc.resolve(e).parent.content.size) {
    let i = $w(r.doc, e, n.type);
    i != null && (e = t = i);
  }
  r.replaceRange(e, t, new $(I.from(n), 0, 0));
}
function qw(r, e, t) {
  let n = r.doc.resolve(e), i = r.doc.resolve(t), o = Cf(n, i);
  for (let a = 0; a < o.length; a++) {
    let s = o[a], l = a == o.length - 1;
    if (l && s == 0 || n.node(s).type.contentMatch.validEnd)
      return r.delete(n.start(s), i.end(s));
    if (s > 0 && (l || n.node(s - 1).canReplace(n.index(s - 1), i.indexAfter(s - 1))))
      return r.delete(n.before(s), i.after(s));
  }
  for (let a = 1; a <= n.depth && a <= i.depth; a++)
    if (e - n.start(a) == n.depth - a && t > n.end(a) && i.end(a) - t != i.depth - a)
      return r.delete(n.before(a), t);
  r.delete(e, t);
}
function Cf(r, e) {
  let t = [], n = Math.min(r.depth, e.depth);
  for (let i = n; i >= 0; i--) {
    let o = r.start(i);
    if (o < r.pos - (r.depth - i) || e.end(i) > e.pos + (e.depth - i) || r.node(i).type.spec.isolating || e.node(i).type.spec.isolating)
      break;
    (o == e.start(i) || i == r.depth && i == e.depth && r.parent.inlineContent && e.parent.inlineContent && i && e.start(i - 1) == o - 1) && t.push(i);
  }
  return t;
}
class hr extends rt {
  /**
  Construct an attribute step.
  */
  constructor(e, t, n) {
    super(), this.pos = e, this.attr = t, this.value = n;
  }
  apply(e) {
    let t = e.nodeAt(this.pos);
    if (!t)
      return Ee.fail("No node at attribute step's position");
    let n = /* @__PURE__ */ Object.create(null);
    for (let o in t.attrs)
      n[o] = t.attrs[o];
    n[this.attr] = this.value;
    let i = t.type.create(n, null, t.marks);
    return Ee.fromReplace(e, this.pos, this.pos + 1, new $(I.from(i), 0, t.isLeaf ? 0 : 1));
  }
  getMap() {
    return pt.empty;
  }
  invert(e) {
    return new hr(this.pos, this.attr, e.nodeAt(this.pos).attrs[this.attr]);
  }
  map(e) {
    let t = e.mapResult(this.pos, 1);
    return t.deletedAfter ? null : new hr(t.pos, this.attr, this.value);
  }
  toJSON() {
    return { stepType: "attr", pos: this.pos, attr: this.attr, value: this.value };
  }
  static fromJSON(e, t) {
    if (typeof t.pos != "number" || typeof t.attr != "string")
      throw new RangeError("Invalid input for AttrStep.fromJSON");
    return new hr(t.pos, t.attr, t.value);
  }
}
rt.jsonID("attr", hr);
let yr = class extends Error {
};
yr = function r(e) {
  let t = Error.call(this, e);
  return t.__proto__ = r.prototype, t;
};
yr.prototype = Object.create(Error.prototype);
yr.prototype.constructor = yr;
yr.prototype.name = "TransformError";
class kf {
  /**
  Create a transform that starts with the given document.
  */
  constructor(e) {
    this.doc = e, this.steps = [], this.docs = [], this.mapping = new ur();
  }
  /**
  The starting document.
  */
  get before() {
    return this.docs.length ? this.docs[0] : this.doc;
  }
  /**
  Apply a new step in this transform, saving the result. Throws an
  error when the step fails.
  */
  step(e) {
    let t = this.maybeStep(e);
    if (t.failed)
      throw new yr(t.failed);
    return this;
  }
  /**
  Try to apply a step in this transformation, ignoring it if it
  fails. Returns the step result.
  */
  maybeStep(e) {
    let t = e.apply(this.doc);
    return t.failed || this.addStep(e, t.doc), t;
  }
  /**
  True when the document has been changed (when there are any
  steps).
  */
  get docChanged() {
    return this.steps.length > 0;
  }
  /**
  @internal
  */
  addStep(e, t) {
    this.docs.push(this.doc), this.steps.push(e), this.mapping.appendMap(e.getMap()), this.doc = t;
  }
  /**
  Replace the part of the document between `from` and `to` with the
  given `slice`.
  */
  replace(e, t = e, n = $.empty) {
    let i = Ws(this.doc, e, t, n);
    return i && this.step(i), this;
  }
  /**
  Replace the given range with the given content, which may be a
  fragment, node, or array of nodes.
  */
  replaceWith(e, t, n) {
    return this.replace(e, t, new $(I.from(n), 0, 0));
  }
  /**
  Delete the content between the given positions.
  */
  delete(e, t) {
    return this.replace(e, t, $.empty);
  }
  /**
  Insert the given content at the given position.
  */
  insert(e, t) {
    return this.replaceWith(e, e, t);
  }
  /**
  Replace a range of the document with a given slice, using
  `from`, `to`, and the slice's
  [`openStart`](https://prosemirror.net/docs/ref/#model.Slice.openStart) property as hints, rather
  than fixed start and end points. This method may grow the
  replaced area or close open nodes in the slice in order to get a
  fit that is more in line with WYSIWYG expectations, by dropping
  fully covered parent nodes of the replaced region when they are
  marked [non-defining as
  context](https://prosemirror.net/docs/ref/#model.NodeSpec.definingAsContext), or including an
  open parent node from the slice that _is_ marked as [defining
  its content](https://prosemirror.net/docs/ref/#model.NodeSpec.definingForContent).
  
  This is the method, for example, to handle paste. The similar
  [`replace`](https://prosemirror.net/docs/ref/#transform.Transform.replace) method is a more
  primitive tool which will _not_ move the start and end of its given
  range, and is useful in situations where you need more precise
  control over what happens.
  */
  replaceRange(e, t, n) {
    return Vw(this, e, t, n), this;
  }
  /**
  Replace the given range with a node, but use `from` and `to` as
  hints, rather than precise positions. When from and to are the same
  and are at the start or end of a parent node in which the given
  node doesn't fit, this method may _move_ them out towards a parent
  that does allow the given node to be placed. When the given range
  completely covers a parent node, this method may completely replace
  that parent node.
  */
  replaceRangeWith(e, t, n) {
    return Uw(this, e, t, n), this;
  }
  /**
  Delete the given range, expanding it to cover fully covered
  parent nodes until a valid replace is found.
  */
  deleteRange(e, t) {
    return qw(this, e, t), this;
  }
  /**
  Split the content in the given range off from its parent, if there
  is sibling content before or after it, and move it up the tree to
  the depth specified by `target`. You'll probably want to use
  [`liftTarget`](https://prosemirror.net/docs/ref/#transform.liftTarget) to compute `target`, to make
  sure the lift is valid.
  */
  lift(e, t) {
    return Iw(this, e, t), this;
  }
  /**
  Join the blocks around the given position. If depth is 2, their
  last and first siblings are also joined, and so on.
  */
  join(e, t = 1) {
    return Bw(this, e, t), this;
  }
  /**
  Wrap the given [range](https://prosemirror.net/docs/ref/#model.NodeRange) in the given set of wrappers.
  The wrappers are assumed to be valid in this position, and should
  probably be computed with [`findWrapping`](https://prosemirror.net/docs/ref/#transform.findWrapping).
  */
  wrap(e, t) {
    return Nw(this, e, t), this;
  }
  /**
  Set the type of all textblocks (partly) between `from` and `to` to
  the given node type with the given attributes.
  */
  setBlockType(e, t = e, n, i = null) {
    return Rw(this, e, t, n, i), this;
  }
  /**
  Change the type, attributes, and/or marks of the node at `pos`.
  When `type` isn't given, the existing node type is preserved,
  */
  setNodeMarkup(e, t, n = null, i) {
    return Lw(this, e, t, n, i), this;
  }
  /**
  Set a single attribute on a given node to a new value.
  */
  setNodeAttribute(e, t, n) {
    return this.step(new hr(e, t, n)), this;
  }
  /**
  Add a mark to the node at position `pos`.
  */
  addNodeMark(e, t) {
    return this.step(new mn(e, t)), this;
  }
  /**
  Remove a mark (or a mark of the given type) from the node at
  position `pos`.
  */
  removeNodeMark(e, t) {
    if (!(t instanceof me)) {
      let n = this.doc.nodeAt(e);
      if (!n)
        throw new RangeError("No node at position " + e);
      if (t = t.isInSet(n.marks), !t)
        return this;
    }
    return this.step(new vr(e, t)), this;
  }
  /**
  Split the node at the given position, and optionally, if `depth` is
  greater than one, any number of nodes above that. By default, the
  parts split off will inherit the node type of the original node.
  This can be changed by passing an array of types and attributes to
  use after the split.
  */
  split(e, t = 1, n) {
    return Fw(this, e, t, n), this;
  }
  /**
  Add the given mark to the inline content between `from` and `to`.
  */
  addMark(e, t, n) {
    return Ow(this, e, t, n), this;
  }
  /**
  Remove marks from inline nodes between `from` and `to`. When
  `mark` is a single mark, remove precisely that mark. When it is
  a mark type, remove all marks of that type. When it is null,
  remove all marks of any type.
  */
  removeMark(e, t, n) {
    return Tw(this, e, t, n), this;
  }
  /**
  Removes all marks and nodes from the content of the node at
  `pos` that don't match the given new parent node type. Accepts
  an optional starting [content match](https://prosemirror.net/docs/ref/#model.ContentMatch) as
  third argument.
  */
  clearIncompatible(e, t, n) {
    return Mw(this, e, t, n), this;
  }
}
const Yo = /* @__PURE__ */ Object.create(null);
class ie {
  /**
  Initialize a selection with the head and anchor and ranges. If no
  ranges are given, constructs a single range across `$anchor` and
  `$head`.
  */
  constructor(e, t, n) {
    this.$anchor = e, this.$head = t, this.ranges = n || [new xf(e.min(t), e.max(t))];
  }
  /**
  The selection's anchor, as an unresolved position.
  */
  get anchor() {
    return this.$anchor.pos;
  }
  /**
  The selection's head.
  */
  get head() {
    return this.$head.pos;
  }
  /**
  The lower bound of the selection's main range.
  */
  get from() {
    return this.$from.pos;
  }
  /**
  The upper bound of the selection's main range.
  */
  get to() {
    return this.$to.pos;
  }
  /**
  The resolved lower  bound of the selection's main range.
  */
  get $from() {
    return this.ranges[0].$from;
  }
  /**
  The resolved upper bound of the selection's main range.
  */
  get $to() {
    return this.ranges[0].$to;
  }
  /**
  Indicates whether the selection contains any content.
  */
  get empty() {
    let e = this.ranges;
    for (let t = 0; t < e.length; t++)
      if (e[t].$from.pos != e[t].$to.pos)
        return !1;
    return !0;
  }
  /**
  Get the content of this selection as a slice.
  */
  content() {
    return this.$from.doc.slice(this.from, this.to, !0);
  }
  /**
  Replace the selection with a slice or, if no slice is given,
  delete the selection. Will append to the given transaction.
  */
  replace(e, t = $.empty) {
    let n = t.content.lastChild, i = null;
    for (let s = 0; s < t.openEnd; s++)
      i = n, n = n.lastChild;
    let o = e.steps.length, a = this.ranges;
    for (let s = 0; s < a.length; s++) {
      let { $from: l, $to: c } = a[s], u = e.mapping.slice(o);
      e.replaceRange(u.map(l.pos), u.map(c.pos), s ? $.empty : t), s == 0 && sc(e, o, (n ? n.isInline : i && i.isTextblock) ? -1 : 1);
    }
  }
  /**
  Replace the selection with the given node, appending the changes
  to the given transaction.
  */
  replaceWith(e, t) {
    let n = e.steps.length, i = this.ranges;
    for (let o = 0; o < i.length; o++) {
      let { $from: a, $to: s } = i[o], l = e.mapping.slice(n), c = l.map(a.pos), u = l.map(s.pos);
      o ? e.deleteRange(c, u) : (e.replaceRangeWith(c, u, t), sc(e, n, t.isInline ? -1 : 1));
    }
  }
  /**
  Find a valid cursor or leaf node selection starting at the given
  position and searching back if `dir` is negative, and forward if
  positive. When `textOnly` is true, only consider cursor
  selections. Will return null when no valid selection position is
  found.
  */
  static findFrom(e, t, n = !1) {
    let i = e.parent.inlineContent ? new oe(e) : rr(e.node(0), e.parent, e.pos, e.index(), t, n);
    if (i)
      return i;
    for (let o = e.depth - 1; o >= 0; o--) {
      let a = t < 0 ? rr(e.node(0), e.node(o), e.before(o + 1), e.index(o), t, n) : rr(e.node(0), e.node(o), e.after(o + 1), e.index(o) + 1, t, n);
      if (a)
        return a;
    }
    return null;
  }
  /**
  Find a valid cursor or leaf node selection near the given
  position. Searches forward first by default, but if `bias` is
  negative, it will search backwards first.
  */
  static near(e, t = 1) {
    return this.findFrom(e, t) || this.findFrom(e, -t) || new We(e.node(0));
  }
  /**
  Find the cursor or leaf node selection closest to the start of
  the given document. Will return an
  [`AllSelection`](https://prosemirror.net/docs/ref/#state.AllSelection) if no valid position
  exists.
  */
  static atStart(e) {
    return rr(e, e, 0, 0, 1) || new We(e);
  }
  /**
  Find the cursor or leaf node selection closest to the end of the
  given document.
  */
  static atEnd(e) {
    return rr(e, e, e.content.size, e.childCount, -1) || new We(e);
  }
  /**
  Deserialize the JSON representation of a selection. Must be
  implemented for custom classes (as a static class method).
  */
  static fromJSON(e, t) {
    if (!t || !t.type)
      throw new RangeError("Invalid input for Selection.fromJSON");
    let n = Yo[t.type];
    if (!n)
      throw new RangeError(`No selection type ${t.type} defined`);
    return n.fromJSON(e, t);
  }
  /**
  To be able to deserialize selections from JSON, custom selection
  classes must register themselves with an ID string, so that they
  can be disambiguated. Try to pick something that's unlikely to
  clash with classes from other modules.
  */
  static jsonID(e, t) {
    if (e in Yo)
      throw new RangeError("Duplicate use of selection JSON ID " + e);
    return Yo[e] = t, t.prototype.jsonID = e, t;
  }
  /**
  Get a [bookmark](https://prosemirror.net/docs/ref/#state.SelectionBookmark) for this selection,
  which is a value that can be mapped without having access to a
  current document, and later resolved to a real selection for a
  given document again. (This is used mostly by the history to
  track and restore old selections.) The default implementation of
  this method just converts the selection to a text selection and
  returns the bookmark for that.
  */
  getBookmark() {
    return oe.between(this.$anchor, this.$head).getBookmark();
  }
}
ie.prototype.visible = !0;
class xf {
  /**
  Create a range.
  */
  constructor(e, t) {
    this.$from = e, this.$to = t;
  }
}
let oc = !1;
function ac(r) {
  !oc && !r.parent.inlineContent && (oc = !0, console.warn("TextSelection endpoint not pointing into a node with inline content (" + r.parent.type.name + ")"));
}
class oe extends ie {
  /**
  Construct a text selection between the given points.
  */
  constructor(e, t = e) {
    ac(e), ac(t), super(e, t);
  }
  /**
  Returns a resolved position if this is a cursor selection (an
  empty text selection), and null otherwise.
  */
  get $cursor() {
    return this.$anchor.pos == this.$head.pos ? this.$head : null;
  }
  map(e, t) {
    let n = e.resolve(t.map(this.head));
    if (!n.parent.inlineContent)
      return ie.near(n);
    let i = e.resolve(t.map(this.anchor));
    return new oe(i.parent.inlineContent ? i : n, n);
  }
  replace(e, t = $.empty) {
    if (super.replace(e, t), t == $.empty) {
      let n = this.$from.marksAcross(this.$to);
      n && e.ensureMarks(n);
    }
  }
  eq(e) {
    return e instanceof oe && e.anchor == this.anchor && e.head == this.head;
  }
  getBookmark() {
    return new ho(this.anchor, this.head);
  }
  toJSON() {
    return { type: "text", anchor: this.anchor, head: this.head };
  }
  /**
  @internal
  */
  static fromJSON(e, t) {
    if (typeof t.anchor != "number" || typeof t.head != "number")
      throw new RangeError("Invalid input for TextSelection.fromJSON");
    return new oe(e.resolve(t.anchor), e.resolve(t.head));
  }
  /**
  Create a text selection from non-resolved positions.
  */
  static create(e, t, n = t) {
    let i = e.resolve(t);
    return new this(i, n == t ? i : e.resolve(n));
  }
  /**
  Return a text selection that spans the given positions or, if
  they aren't text positions, find a text selection near them.
  `bias` determines whether the method searches forward (default)
  or backwards (negative number) first. Will fall back to calling
  [`Selection.near`](https://prosemirror.net/docs/ref/#state.Selection^near) when the document
  doesn't contain a valid text position.
  */
  static between(e, t, n) {
    let i = e.pos - t.pos;
    if ((!n || i) && (n = i >= 0 ? 1 : -1), !t.parent.inlineContent) {
      let o = ie.findFrom(t, n, !0) || ie.findFrom(t, -n, !0);
      if (o)
        t = o.$head;
      else
        return ie.near(t, n);
    }
    return e.parent.inlineContent || (i == 0 ? e = t : (e = (ie.findFrom(e, -n, !0) || ie.findFrom(e, n, !0)).$anchor, e.pos < t.pos != i < 0 && (e = t))), new oe(e, t);
  }
}
ie.jsonID("text", oe);
class ho {
  constructor(e, t) {
    this.anchor = e, this.head = t;
  }
  map(e) {
    return new ho(e.map(this.anchor), e.map(this.head));
  }
  resolve(e) {
    return oe.between(e.resolve(this.anchor), e.resolve(this.head));
  }
}
class te extends ie {
  /**
  Create a node selection. Does not verify the validity of its
  argument.
  */
  constructor(e) {
    let t = e.nodeAfter, n = e.node(0).resolve(e.pos + t.nodeSize);
    super(e, n), this.node = t;
  }
  map(e, t) {
    let { deleted: n, pos: i } = t.mapResult(this.anchor), o = e.resolve(i);
    return n ? ie.near(o) : new te(o);
  }
  content() {
    return new $(I.from(this.node), 0, 0);
  }
  eq(e) {
    return e instanceof te && e.anchor == this.anchor;
  }
  toJSON() {
    return { type: "node", anchor: this.anchor };
  }
  getBookmark() {
    return new Vs(this.anchor);
  }
  /**
  @internal
  */
  static fromJSON(e, t) {
    if (typeof t.anchor != "number")
      throw new RangeError("Invalid input for NodeSelection.fromJSON");
    return new te(e.resolve(t.anchor));
  }
  /**
  Create a node selection from non-resolved positions.
  */
  static create(e, t) {
    return new te(e.resolve(t));
  }
  /**
  Determines whether the given node may be selected as a node
  selection.
  */
  static isSelectable(e) {
    return !e.isText && e.type.spec.selectable !== !1;
  }
}
te.prototype.visible = !1;
ie.jsonID("node", te);
class Vs {
  constructor(e) {
    this.anchor = e;
  }
  map(e) {
    let { deleted: t, pos: n } = e.mapResult(this.anchor);
    return t ? new ho(n, n) : new Vs(n);
  }
  resolve(e) {
    let t = e.resolve(this.anchor), n = t.nodeAfter;
    return n && te.isSelectable(n) ? new te(t) : ie.near(t);
  }
}
class We extends ie {
  /**
  Create an all-selection over the given document.
  */
  constructor(e) {
    super(e.resolve(0), e.resolve(e.content.size));
  }
  replace(e, t = $.empty) {
    if (t == $.empty) {
      e.delete(0, e.doc.content.size);
      let n = ie.atStart(e.doc);
      n.eq(e.selection) || e.setSelection(n);
    } else
      super.replace(e, t);
  }
  toJSON() {
    return { type: "all" };
  }
  /**
  @internal
  */
  static fromJSON(e) {
    return new We(e);
  }
  map(e) {
    return new We(e);
  }
  eq(e) {
    return e instanceof We;
  }
  getBookmark() {
    return Kw;
  }
}
ie.jsonID("all", We);
const Kw = {
  map() {
    return this;
  },
  resolve(r) {
    return new We(r);
  }
};
function rr(r, e, t, n, i, o = !1) {
  if (e.inlineContent)
    return oe.create(r, t);
  for (let a = n - (i > 0 ? 0 : 1); i > 0 ? a < e.childCount : a >= 0; a += i) {
    let s = e.child(a);
    if (s.isAtom) {
      if (!o && te.isSelectable(s))
        return te.create(r, t - (i < 0 ? s.nodeSize : 0));
    } else {
      let l = rr(r, s, t + i, i < 0 ? s.childCount : 0, i, o);
      if (l)
        return l;
    }
    t += s.nodeSize * i;
  }
  return null;
}
function sc(r, e, t) {
  let n = r.steps.length - 1;
  if (n < e)
    return;
  let i = r.steps[n];
  if (!(i instanceof qe || i instanceof Ne))
    return;
  let o = r.mapping.maps[n], a;
  o.forEach((s, l, c, u) => {
    a == null && (a = u);
  }), r.setSelection(ie.near(r.doc.resolve(a), t));
}
const lc = 1, bi = 2, cc = 4;
class Gw extends kf {
  /**
  @internal
  */
  constructor(e) {
    super(e.doc), this.curSelectionFor = 0, this.updated = 0, this.meta = /* @__PURE__ */ Object.create(null), this.time = Date.now(), this.curSelection = e.selection, this.storedMarks = e.storedMarks;
  }
  /**
  The transaction's current selection. This defaults to the editor
  selection [mapped](https://prosemirror.net/docs/ref/#state.Selection.map) through the steps in the
  transaction, but can be overwritten with
  [`setSelection`](https://prosemirror.net/docs/ref/#state.Transaction.setSelection).
  */
  get selection() {
    return this.curSelectionFor < this.steps.length && (this.curSelection = this.curSelection.map(this.doc, this.mapping.slice(this.curSelectionFor)), this.curSelectionFor = this.steps.length), this.curSelection;
  }
  /**
  Update the transaction's current selection. Will determine the
  selection that the editor gets when the transaction is applied.
  */
  setSelection(e) {
    if (e.$from.doc != this.doc)
      throw new RangeError("Selection passed to setSelection must point at the current document");
    return this.curSelection = e, this.curSelectionFor = this.steps.length, this.updated = (this.updated | lc) & ~bi, this.storedMarks = null, this;
  }
  /**
  Whether the selection was explicitly updated by this transaction.
  */
  get selectionSet() {
    return (this.updated & lc) > 0;
  }
  /**
  Set the current stored marks.
  */
  setStoredMarks(e) {
    return this.storedMarks = e, this.updated |= bi, this;
  }
  /**
  Make sure the current stored marks or, if that is null, the marks
  at the selection, match the given set of marks. Does nothing if
  this is already the case.
  */
  ensureMarks(e) {
    return me.sameSet(this.storedMarks || this.selection.$from.marks(), e) || this.setStoredMarks(e), this;
  }
  /**
  Add a mark to the set of stored marks.
  */
  addStoredMark(e) {
    return this.ensureMarks(e.addToSet(this.storedMarks || this.selection.$head.marks()));
  }
  /**
  Remove a mark or mark type from the set of stored marks.
  */
  removeStoredMark(e) {
    return this.ensureMarks(e.removeFromSet(this.storedMarks || this.selection.$head.marks()));
  }
  /**
  Whether the stored marks were explicitly set for this transaction.
  */
  get storedMarksSet() {
    return (this.updated & bi) > 0;
  }
  /**
  @internal
  */
  addStep(e, t) {
    super.addStep(e, t), this.updated = this.updated & ~bi, this.storedMarks = null;
  }
  /**
  Update the timestamp for the transaction.
  */
  setTime(e) {
    return this.time = e, this;
  }
  /**
  Replace the current selection with the given slice.
  */
  replaceSelection(e) {
    return this.selection.replace(this, e), this;
  }
  /**
  Replace the selection with the given node. When `inheritMarks` is
  true and the content is inline, it inherits the marks from the
  place where it is inserted.
  */
  replaceSelectionWith(e, t = !0) {
    let n = this.selection;
    return t && (e = e.mark(this.storedMarks || (n.empty ? n.$from.marks() : n.$from.marksAcross(n.$to) || me.none))), n.replaceWith(this, e), this;
  }
  /**
  Delete the selection.
  */
  deleteSelection() {
    return this.selection.replace(this), this;
  }
  /**
  Replace the given range, or the selection if no range is given,
  with a text node containing the given string.
  */
  insertText(e, t, n) {
    let i = this.doc.type.schema;
    if (t == null)
      return e ? this.replaceSelectionWith(i.text(e), !0) : this.deleteSelection();
    {
      if (n == null && (n = t), n = n ?? t, !e)
        return this.deleteRange(t, n);
      let o = this.storedMarks;
      if (!o) {
        let a = this.doc.resolve(t);
        o = n == t ? a.marks() : a.marksAcross(this.doc.resolve(n));
      }
      return this.replaceRangeWith(t, n, i.text(e, o)), this.selection.empty || this.setSelection(ie.near(this.selection.$to)), this;
    }
  }
  /**
  Store a metadata property in this transaction, keyed either by
  name or by plugin.
  */
  setMeta(e, t) {
    return this.meta[typeof e == "string" ? e : e.key] = t, this;
  }
  /**
  Retrieve a metadata property for a given name or plugin.
  */
  getMeta(e) {
    return this.meta[typeof e == "string" ? e : e.key];
  }
  /**
  Returns true if this transaction doesn't contain any metadata,
  and can thus safely be extended.
  */
  get isGeneric() {
    for (let e in this.meta)
      return !1;
    return !0;
  }
  /**
  Indicate that the editor should scroll the selection into view
  when updated to the state produced by this transaction.
  */
  scrollIntoView() {
    return this.updated |= cc, this;
  }
  /**
  True when this transaction has had `scrollIntoView` called on it.
  */
  get scrolledIntoView() {
    return (this.updated & cc) > 0;
  }
}
function uc(r, e) {
  return !e || !r ? r : r.bind(e);
}
class Lr {
  constructor(e, t, n) {
    this.name = e, this.init = uc(t.init, n), this.apply = uc(t.apply, n);
  }
}
const Jw = [
  new Lr("doc", {
    init(r) {
      return r.doc || r.schema.topNodeType.createAndFill();
    },
    apply(r) {
      return r.doc;
    }
  }),
  new Lr("selection", {
    init(r, e) {
      return r.selection || ie.atStart(e.doc);
    },
    apply(r) {
      return r.selection;
    }
  }),
  new Lr("storedMarks", {
    init(r) {
      return r.storedMarks || null;
    },
    apply(r, e, t, n) {
      return n.selection.$cursor ? r.storedMarks : null;
    }
  }),
  new Lr("scrollToSelection", {
    init() {
      return 0;
    },
    apply(r, e) {
      return r.scrolledIntoView ? e + 1 : e;
    }
  })
];
class Zo {
  constructor(e, t) {
    this.schema = e, this.plugins = [], this.pluginsByKey = /* @__PURE__ */ Object.create(null), this.fields = Jw.slice(), t && t.forEach((n) => {
      if (this.pluginsByKey[n.key])
        throw new RangeError("Adding different instances of a keyed plugin (" + n.key + ")");
      this.plugins.push(n), this.pluginsByKey[n.key] = n, n.spec.state && this.fields.push(new Lr(n.key, n.spec.state, n));
    });
  }
}
class Ln {
  /**
  @internal
  */
  constructor(e) {
    this.config = e;
  }
  /**
  The schema of the state's document.
  */
  get schema() {
    return this.config.schema;
  }
  /**
  The plugins that are active in this state.
  */
  get plugins() {
    return this.config.plugins;
  }
  /**
  Apply the given transaction to produce a new state.
  */
  apply(e) {
    return this.applyTransaction(e).state;
  }
  /**
  @internal
  */
  filterTransaction(e, t = -1) {
    for (let n = 0; n < this.config.plugins.length; n++)
      if (n != t) {
        let i = this.config.plugins[n];
        if (i.spec.filterTransaction && !i.spec.filterTransaction.call(i, e, this))
          return !1;
      }
    return !0;
  }
  /**
  Verbose variant of [`apply`](https://prosemirror.net/docs/ref/#state.EditorState.apply) that
  returns the precise transactions that were applied (which might
  be influenced by the [transaction
  hooks](https://prosemirror.net/docs/ref/#state.PluginSpec.filterTransaction) of
  plugins) along with the new state.
  */
  applyTransaction(e) {
    if (!this.filterTransaction(e))
      return { state: this, transactions: [] };
    let t = [e], n = this.applyInner(e), i = null;
    for (; ; ) {
      let o = !1;
      for (let a = 0; a < this.config.plugins.length; a++) {
        let s = this.config.plugins[a];
        if (s.spec.appendTransaction) {
          let l = i ? i[a].n : 0, c = i ? i[a].state : this, u = l < t.length && s.spec.appendTransaction.call(s, l ? t.slice(l) : t, c, n);
          if (u && n.filterTransaction(u, a)) {
            if (u.setMeta("appendedTransaction", e), !i) {
              i = [];
              for (let f = 0; f < this.config.plugins.length; f++)
                i.push(f < a ? { state: n, n: t.length } : { state: this, n: 0 });
            }
            t.push(u), n = n.applyInner(u), o = !0;
          }
          i && (i[a] = { state: n, n: t.length });
        }
      }
      if (!o)
        return { state: n, transactions: t };
    }
  }
  /**
  @internal
  */
  applyInner(e) {
    if (!e.before.eq(this.doc))
      throw new RangeError("Applying a mismatched transaction");
    let t = new Ln(this.config), n = this.config.fields;
    for (let i = 0; i < n.length; i++) {
      let o = n[i];
      t[o.name] = o.apply(e, this[o.name], this, t);
    }
    return t;
  }
  /**
  Start a [transaction](https://prosemirror.net/docs/ref/#state.Transaction) from this state.
  */
  get tr() {
    return new Gw(this);
  }
  /**
  Create a new state.
  */
  static create(e) {
    let t = new Zo(e.doc ? e.doc.type.schema : e.schema, e.plugins), n = new Ln(t);
    for (let i = 0; i < t.fields.length; i++)
      n[t.fields[i].name] = t.fields[i].init(e, n);
    return n;
  }
  /**
  Create a new state based on this one, but with an adjusted set
  of active plugins. State fields that exist in both sets of
  plugins are kept unchanged. Those that no longer exist are
  dropped, and those that are new are initialized using their
  [`init`](https://prosemirror.net/docs/ref/#state.StateField.init) method, passing in the new
  configuration object..
  */
  reconfigure(e) {
    let t = new Zo(this.schema, e.plugins), n = t.fields, i = new Ln(t);
    for (let o = 0; o < n.length; o++) {
      let a = n[o].name;
      i[a] = this.hasOwnProperty(a) ? this[a] : n[o].init(e, i);
    }
    return i;
  }
  /**
  Serialize this state to JSON. If you want to serialize the state
  of plugins, pass an object mapping property names to use in the
  resulting JSON object to plugin objects. The argument may also be
  a string or number, in which case it is ignored, to support the
  way `JSON.stringify` calls `toString` methods.
  */
  toJSON(e) {
    let t = { doc: this.doc.toJSON(), selection: this.selection.toJSON() };
    if (this.storedMarks && (t.storedMarks = this.storedMarks.map((n) => n.toJSON())), e && typeof e == "object")
      for (let n in e) {
        if (n == "doc" || n == "selection")
          throw new RangeError("The JSON fields `doc` and `selection` are reserved");
        let i = e[n], o = i.spec.state;
        o && o.toJSON && (t[n] = o.toJSON.call(i, this[i.key]));
      }
    return t;
  }
  /**
  Deserialize a JSON representation of a state. `config` should
  have at least a `schema` field, and should contain array of
  plugins to initialize the state with. `pluginFields` can be used
  to deserialize the state of plugins, by associating plugin
  instances with the property names they use in the JSON object.
  */
  static fromJSON(e, t, n) {
    if (!t)
      throw new RangeError("Invalid input for EditorState.fromJSON");
    if (!e.schema)
      throw new RangeError("Required config field 'schema' missing");
    let i = new Zo(e.schema, e.plugins), o = new Ln(i);
    return i.fields.forEach((a) => {
      if (a.name == "doc")
        o.doc = yn.fromJSON(e.schema, t.doc);
      else if (a.name == "selection")
        o.selection = ie.fromJSON(o.doc, t.selection);
      else if (a.name == "storedMarks")
        t.storedMarks && (o.storedMarks = t.storedMarks.map(e.schema.markFromJSON));
      else {
        if (n)
          for (let s in n) {
            let l = n[s], c = l.spec.state;
            if (l.key == a.name && c && c.fromJSON && Object.prototype.hasOwnProperty.call(t, s)) {
              o[a.name] = c.fromJSON.call(l, e, t[s], o);
              return;
            }
          }
        o[a.name] = a.init(e, o);
      }
    }), o;
  }
}
function Of(r, e, t) {
  for (let n in r) {
    let i = r[n];
    i instanceof Function ? i = i.bind(e) : n == "handleDOMEvents" && (i = Of(i, e, {})), t[n] = i;
  }
  return t;
}
class Ge {
  /**
  Create a plugin.
  */
  constructor(e) {
    this.spec = e, this.props = {}, e.props && Of(e.props, this, this.props), this.key = e.key ? e.key.key : Tf("plugin");
  }
  /**
  Extract the plugin's state field from an editor state.
  */
  getState(e) {
    return e[this.key];
  }
}
const Qo = /* @__PURE__ */ Object.create(null);
function Tf(r) {
  return r in Qo ? r + "$" + ++Qo[r] : (Qo[r] = 0, r + "$");
}
class Xe {
  /**
  Create a plugin key.
  */
  constructor(e = "key") {
    this.key = Tf(e);
  }
  /**
  Get the active plugin with this key, if any, from an editor
  state.
  */
  get(e) {
    return e.config.pluginsByKey[this.key];
  }
  /**
  Get the plugin's state from an editor state.
  */
  getState(e) {
    return e[this.key];
  }
}
var $t = "k-parent-node", we = "k-colgroup-data", Lt = "k-resizable-node", Xw = "k-editor-resize-wrap-element", Ha = "k-editor-resize-handle", Mf = "data-dir-table-resize", _f = "data-dir-image-resize", Yw = [
  "div",
  "ol",
  "ul",
  "li",
  "table",
  "tbody",
  "thead",
  "tfoot",
  "td",
  "th",
  "p",
  "tr",
  "col",
  "colgroup",
  "article",
  "main",
  "nav",
  "header",
  "footer",
  "aside",
  "section"
], ea = function(r, e) {
  var t = (r.ownerDocument || document).createElement(e);
  Array.from(r.rows).filter(function(n) {
    return n.getAttribute($t) === e;
  }).forEach(function(n) {
    n.removeAttribute($t), t.appendChild(n);
  }), t.children.length && r.appendChild(t);
}, Zw = function(r) {
  Array.from(r.querySelectorAll("table")).forEach(function(e) {
    ea(e, "thead"), ea(e, "tbody"), ea(e, "tfoot");
    var t = Array.from(e.children).find(function(n) {
      return n.children.length === 0;
    });
    t && t.remove();
  });
}, ta = function(r, e) {
  var t = e.toUpperCase();
  r.filter(function(n) {
    return n.nodeName === t;
  }).forEach(function(n) {
    Array.from(n.children).forEach(function(i) {
      i.setAttribute($t, e), n.parentNode && n.parentNode.insertBefore(i, n);
    }), n.remove();
  });
}, Qw = function(r) {
  Array.from(r.querySelectorAll("table")).forEach(function(e) {
    var t = Array.from(e.children);
    t.some(function(i) {
      return i.nodeName === "THEAD" || i.nodeName === "TFOOT";
    }) && (ta(t, "thead"), ta(t, "tbody"), ta(t, "tfoot"));
    var n = t.find(function(i) {
      return i.nodeName === "COLGROUP";
    });
    n && (e.setAttribute(we, n.outerHTML), n.remove());
  });
}, ja = function(r, e) {
  e === void 0 && (e = Yw);
  var t = e.join("|");
  return r.replace(new RegExp("\\s*(<(?:" + t + ")(?:\\s[^>]*?)?>)", "g"), "$1").replace(new RegExp("(<\\/(?:" + t + ")(?:\\s[^>]*?)?>)\\s*", "g"), "$1");
}, li = function(r) {
  var e = document.createElement("template"), t;
  if ("content" in e)
    e.innerHTML = r, t = e.content;
  else {
    var n = new DOMParser().parseFromString(r, "text/html");
    t = document.createDocumentFragment();
    for (var i = n.body; i && i.firstChild; )
      t.appendChild(i.firstChild);
  }
  return t;
}, If = function(r) {
  return Array.from(r.children).reduce(function(e, t) {
    return e + (t.outerHTML || t.textContent || "");
  }, "");
}, Df = function(r) {
  var e = Bt.fromSchema(r.type.schema).serializeFragment(r.content);
  return Zw(e), e;
}, Ef = function(r, e, t) {
  return Hs.fromSchema(e).parse(r, t);
}, Af = function(r, e, t) {
  var n = li(r);
  return Qw(n), Ef(n, e, t);
}, Nf = function(r) {
  var e = Df(r.doc), t = document.createElement("div");
  return t.appendChild(e), t.innerHTML;
}, Rf = function(r, e, t) {
  return e === void 0 && (e = "setHTML"), t === void 0 && (t = { preserveWhitespace: "full" }), function(n, i) {
    return i(n.tr.setSelection(new We(n.doc)).replaceSelectionWith(Af(r, n.schema, t)).setMeta("commandName", e));
  };
}, A = function() {
  return A = Object.assign || function(e) {
    for (var t, n = 1, i = arguments.length; n < i; n++) {
      t = arguments[n];
      for (var o in t)
        Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
    }
    return e;
  }, A.apply(this, arguments);
};
function Vi(r, e) {
  var t = {};
  for (var n in r)
    Object.prototype.hasOwnProperty.call(r, n) && e.indexOf(n) < 0 && (t[n] = r[n]);
  if (r != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, n = Object.getOwnPropertySymbols(r); i < n.length; i++)
      e.indexOf(n[i]) < 0 && Object.prototype.propertyIsEnumerable.call(r, n[i]) && (t[n[i]] = r[n[i]]);
  return t;
}
function e0(r, e, t) {
  if (t || arguments.length === 2)
    for (var n = 0, i = e.length, o; n < i; n++)
      (o || !(n in e)) && (o || (o = Array.prototype.slice.call(e, 0, n)), o[n] = e[n]);
  return r.concat(o || Array.prototype.slice.call(e));
}
var wr = function(r, e) {
  var t = e.style, n = e.value, i = e.newValue;
  if (!r)
    return { changed: !1, style: null };
  var o = r.split(/\s*;\s*/).filter(function(s) {
    return !!s;
  }), a = o.filter(function(s) {
    var l = s.split(/\s*:\s*/);
    return !(l[0].toLowerCase() === t && n.test(l[1]));
  });
  return i && a.push(t + ": " + i), {
    style: a.join("; ") + (a.length ? ";" : ""),
    changed: !!i || a.length !== o.length
  };
}, Us = function(r, e) {
  for (var t = r.selection.$from, n = t.depth; n >= 0; n--) {
    var i = t.index(n);
    if (t.node(n).canReplaceWith(i, i, e))
      return !0;
  }
  return !1;
}, fc = function(r) {
  return r instanceof yn ? r.type.name : r.name;
}, t0 = function(r, e) {
  return e === void 0 && (e = 1), function(t) {
    for (var n = t.$from, i = n.depth; i > 0; i--) {
      var o = n.node(i);
      if (r(o) && (e = e - 1, e === 0))
        return { depth: i, node: o };
    }
  };
}, hc = function(r, e) {
  return e === void 0 && (e = 1), function(t) {
    return t0(function(n) {
      return fc(n) === fc(r);
    }, e)(t);
  };
}, qs = function(r, e) {
  return function(t, n) {
    var i = t.tr.replaceSelectionWith(r);
    e && i.scrollIntoView(), n(i);
  };
}, n0 = function(r) {
  var e = r.selection;
  if (e instanceof oe || e instanceof We) {
    var t = e.content().content;
    return t.textBetween(0, t.size);
  }
  return "";
}, r0 = function(r) {
  var e = "", t = !1, n = r.selection, i = r.doc, o = n.$from, a = n.$to, s = n.from, l = n.to;
  return o.sameParent(a) && (i.nodesBetween(s, l, function(c) {
    t = t || c.isLeaf && !c.isText;
  }), t || (e = n0(r))), e;
}, Pf = function(r) {
  return r.replace(/<\/(p|li|ul|ol|h[1-6]|table|tr|td|th)>/ig, `</$1>
`).replace(/<(ul|ol)([^>]*)><li/ig, `<$1$2>
<li`).replace(/<br \/>/ig, `<br />
`).replace(/\n$/, "");
}, i0 = function(r, e) {
  var t = Object.keys(r), n = Object.keys(e);
  return t.length === n.length && t.every(function(i) {
    return r[i] === e[i];
  });
}, Ks = function(r, e, t) {
  for (var n = function(a) {
    var s = e[a], l = s.$from, c = s.$to, u = l.depth === 0 ? r.type.allowsMarkType(t) : !1;
    if (r.nodesBetween(l.pos, c.pos, function(f) {
      if (u)
        return !1;
      u = f.inlineContent && f.type.allowsMarkType(t);
    }), u)
      return { v: !0 };
  }, i = 0; i < e.length; i++) {
    var o = n(i);
    if (o)
      return o.v;
  }
  return !1;
}, Lf = function(r, e, t) {
  return function(n, i) {
    var o = n.selection, a = o.empty, s = o.$cursor, l = o.ranges;
    if (a && !s || !Ks(n.doc, l, r))
      return !1;
    if (i)
      if (s)
        r.isInSet(n.storedMarks || s.marks()) ? i(t.removeStoredMark(r)) : i(t.addStoredMark(r.create(e)));
      else {
        for (var c = !1, u = 0; !c && u < l.length; u++) {
          var f = l[u], h = f.$from, d = f.$to;
          c = n.doc.rangeHasMark(h.pos, d.pos, r);
        }
        for (var u = 0; u < l.length; u++) {
          var p = l[u], h = p.$from, d = p.$to;
          c ? t.removeMark(h.pos, d.pos, r) : t.addMark(h.pos, d.pos, r.create(e));
        }
        i(t.scrollIntoView());
      }
    return !0;
  };
}, Ff = function(r, e, t, n) {
  n === void 0 && (n = null);
  var i = [], o = 0;
  return r.doc.nodesBetween(e, t, function(a, s) {
    if (a.isInline) {
      o++;
      var l = null;
      if (n instanceof si) {
        var c = n.isInSet(a.marks);
        c && (l = [c]);
      } else
        n ? n.isInSet(a.marks) && (l = [n]) : l = a.marks;
      if (l && l.length)
        for (var u = Math.min(s + a.nodeSize, t), f = 0; f < l.length; f++) {
          for (var h = l[f], d = void 0, p = 0; p < i.length; p++) {
            var m = i[p];
            m.step === o - 1 && h.eq(m.style) && (d = m);
          }
          d ? (d.to = u, d.step = o) : i.push({ style: h, from: Math.max(s, e), to: u, step: o });
        }
    }
  }), i.forEach(function(a) {
    return r.step(new gt(a.from, a.to, a.style));
  }), r;
}, o0 = function(r, e, t, n) {
  var i = e.selection, o = i.$cursor, a = i.ranges;
  if (n = n || e.tr, o)
    r.forEach(function(c) {
      c.isInSet(e.storedMarks || o.marks()) && t(n.removeStoredMark(c));
    });
  else {
    for (var s = function(c) {
      var u = a[c], f = u.$from, h = u.$to;
      r.forEach(function(d) {
        Ff(n, f.pos, h.pos, d);
      });
    }, l = 0; l < a.length; l++)
      s(l);
    t(n.scrollIntoView());
  }
  return !0;
}, a0 = function(r, e) {
  var t = e.except, n = r.doc, i = r.selection, o = n.type.schema, a = i.empty, s = i.ranges, l = (t || []).map(function(u) {
    return u.name;
  });
  if (!a) {
    var c = Object.keys(o.marks).map(function(u) {
      return o.marks[u];
    }).filter(function(u) {
      return l.indexOf(u.name) === -1;
    });
    s.forEach(function(u) {
      var f = u.$from, h = u.$to;
      c.forEach(function(d) {
        return r.removeMark(f.pos, h.pos, d);
      });
    });
  }
}, ci = function(r, e) {
  var t = r.schema.marks, n = (e.altMarks || []).filter(function(p) {
    return t[p];
  }), i = e.altStyle, o = r.selection, a = o.from, s = o.$from, l = o.to, c = o.empty, u = t[e.mark], f = r.doc, h = !1, d;
  return c ? (d = r.storedMarks || s.marks(), h = u && u.isInSet(d) || n.some(function(p) {
    return t[p].isInSet(d);
  })) : h = u && f.rangeHasMark(a, l, u) || n.some(function(p) {
    return f.rangeHasMark(a, l, t[p]);
  }), !h && i && t.style ? po(r, t.style).some(function(p) {
    return Gs(p, i) !== null;
  }) : !!h;
}, Gs = function(r, e) {
  for (var t = r && r.attrs.style || "", n = t.split(/\s*;\s*/).filter(function(a) {
    return !!a;
  }), i = 0; i < n.length; i++) {
    var o = n[i].split(/\s*:\s*/);
    if (o[0].toLowerCase() === e.name && e.value.test(o[1]))
      return o[1];
  }
  return null;
}, po = function(r, e) {
  var t = r.selection, n = t.from, i = t.$from, o = t.to, a = t.empty, s = [];
  return a ? s.push(e.isInSet(r.storedMarks || i.marks())) : r.doc.nodesBetween(n, o, function(l) {
    l.isInline && s.push(e.isInSet(l.marks));
  }), s;
}, mo = function(r, e) {
  var t = po(r, e), n = t.filter(function(i) {
    return !!i;
  });
  return t.length === n.length ? t[0] : void 0;
}, zf = function(r, e) {
  var t = r.find(function(i) {
    return i.type.name === "style";
  }), n = t && t.attrs.style;
  return wr(n, e);
}, s0 = function(r, e, t, n, i) {
  var o = i.create({ style: n.style }), a = [], s = [], l = null, c = null;
  return r.doc.nodesBetween(e, t, function(u, f, h) {
    if (u.isInline) {
      var d = u.marks;
      if (!o.isInSet(d) && h.type.allowsMarkType(o.type)) {
        var p = Math.max(f, e), m = Math.min(f + u.nodeSize, t), v = zf(d, n);
        if (v.changed || n.newValue) {
          for (var y = v.changed ? { style: v.style || null } : { style: [n.style] + ": " + n.newValue + ";" }, b = i.isInSet(d) ? d.find(function(ee) {
            return ee.type.name === "style";
          }) : null, k = b ? A(A({}, b.attrs), y) : y, M = i.create(k), D = M.addToSet(d), T = 0; T < d.length; T++)
            d[T].isInSet(D) || (l && l.to === p && l.mark.eq(d[T]) ? l.to = m : (l = new gt(p, m, d[T]), a.push(l)));
          var z = c && c.to === p, _ = z && M.attrs.style === c.mark.attrs.style;
          z && _ ? c.to = m : Object.keys(k).some(function(ee) {
            return k[ee] !== null;
          }) && (c = new Yt(p, m, M), s.push(c));
        }
      }
    }
  }), a.forEach(function(u) {
    return r.step(u);
  }), s.forEach(function(u) {
    return r.step(u);
  }), a.length + s.length > 0;
}, Bf = function(r, e) {
  var t = r.schema.marks.style, n = t ? po(r, t) : [];
  return n.map(function(i) {
    return Gs(i, e);
  }).filter(function(i) {
    return i !== null;
  });
}, $f = function(r, e) {
  return function(t, n, i) {
    var o = t.selection, a = o.empty, s = o.$cursor, l = o.ranges;
    if (a && !s || !Ks(t.doc, l, r))
      return !1;
    var c = !1;
    if (n) {
      var u = i || t.tr;
      if (s) {
        var f = t.storedMarks || s.marks();
        if (r.isInSet(f)) {
          var h = zf(f, e), d = f.find(function(k) {
            return k.type.name === "style";
          }), p = A(A({}, d ? d.attrs : {}), { style: h.style || null });
          if (i0(d.attrs, p))
            return !1;
          n(u.removeStoredMark(r)), Object.keys(p).some(function(k) {
            return p[k] !== null;
          }) && n(u.addStoredMark(r.create(p))), c = !0;
        }
      } else {
        for (var m = 0; m < l.length; m++) {
          var v = l[m], y = v.$from, b = v.$to;
          c = s0(u, y.pos, b.pos, e, r);
        }
        c && (u.scrollIntoView(), n(u));
      }
    }
    return c;
  };
}, Hn = function(r, e, t) {
  return function(n, i) {
    var o = n.schema.marks, a = r.altStyle, s = r.altMarks, l = s === void 0 ? [] : s, c = r.mark, u = e || n.tr, f = !1, h = !1, d = function() {
      return h = !0;
    };
    if (a && o.style) {
      var p = $f(o.style, { style: a.name, value: a.value });
      f = p(n, d, u);
    }
    var m = e0([c], l).filter(function(y) {
      return o[y];
    }), v = m.map(function(y) {
      return ci(n, { mark: y }) && o[y];
    }).filter(function(y) {
      return y;
    });
    return v.length ? o0(v, n, d, u) : f || Lf(o[c], t, u)(n, d), h && i(u), h;
  };
}, Js = function(r, e) {
  return function(t, n) {
    var i = t.schema.marks, o = i.style, a = {
      style: r.style,
      value: /^.+$/,
      newValue: r.value
    }, s = t.tr;
    e && s.setMeta("commandName", e), s.setMeta("args", r);
    var l = t.selection, c = l.empty, u = l.$cursor, f = l.ranges;
    if (c && !u || !o || !Ks(t.doc, f, o))
      return !1;
    if (u) {
      var h = t.storedMarks || u.marks(), d = o.isInSet(h) ? h.find(function(y) {
        return y.type.name === "style";
      }) : null, p = { style: null };
      if (d && d.attrs.style) {
        var m = wr(d.attrs.style, a);
        m.changed && m.style && (p.style = m.style);
      } else
        a.newValue && (p.style = [a.style] + ": " + a.newValue + ";");
      var v = d ? A(A({}, d.attrs), p) : p;
      return Object.keys(v).some(function(y) {
        return v[y] !== null;
      }) ? n(s.addStoredMark(o.create(v))) : n(s.removeStoredMark(o)), !0;
    }
    return $f(o, a)(t, n, s);
  };
}, l0 = function(r, e) {
  return function(t, n) {
    var i = t.selection, o = i.$cursor, a = i.from, s = i.to, l = t.schema.marks[r.mark];
    if (!o)
      e.doc.nodesBetween(a, s, function(y, b) {
        y.isInline && l.isInSet(y.marks) && (e.removeMark(b, b + y.nodeSize, l), e.addMark(b, b + y.nodeSize, l.create(r.attrs)), n(e));
      });
    else {
      var c = o.parent, u = o.index(), f = c.child(u).marks.find(function(y) {
        return y.type === l;
      }), h = c.childCount, d = o.pos - o.textOffset, p = c.child(u).nodeSize, m = void 0, v = void 0;
      for (m = u - 1; m >= 0 && f.isInSet(c.child(m).marks); )
        v = c.child(m).nodeSize, p += v, d -= v, m -= 1;
      for (m = u + 1; m < h && f.isInSet(c.child(m).marks); )
        p += c.child(m).nodeSize, m += 1;
      e.removeMark(d, d + p, l), e.addMark(d, d + p, l.create(r.attrs)), n(e);
    }
  };
}, Hf = function(r, e) {
  return function(t, n) {
    var i = t.selection.$cursor;
    if (!i)
      Hn(r, e)(t, n);
    else {
      var o = i.parent, a = i.index(), s = t.schema.marks[r.mark], l = o.child(a).marks.find(function(p) {
        return p.type === s;
      }), c = o.childCount, u = i.pos - i.textOffset, f = o.child(a).nodeSize, h = void 0, d = void 0;
      for (h = a - 1; h >= 0 && l.isInSet(o.child(h).marks); )
        d = o.child(h).nodeSize, f += d, u -= d, h -= 1;
      for (h = a + 1; h < c && l.isInSet(o.child(h).marks); )
        f += o.child(h).nodeSize, h += 1;
      n(Ff(e || t.tr, u, u + f, l));
    }
  };
}, c0 = function(r, e) {
  var t = po(r, e);
  return t.length === 1 && t[0] ? t[0] : null;
}, jf = function(r, e) {
  var t = r.mark, n = r.attrs;
  return e === void 0 && (e = "link"), function(i, o) {
    var a = i.schema.marks, s = i.tr;
    e && (s.setMeta("commandName", e), s.setMeta("args", n));
    var l = !1, c = function() {
      return l = !0;
    };
    if (c0(i, a[t]))
      l0({ mark: t, attrs: n }, s)(i, c);
    else {
      var u = i;
      ci(i, { mark: t }) && (Hf({ mark: t, attrs: n }, s)(i, c), u = Ln.create({ doc: s.doc, selection: s.selection })), l ? Lf(a[t], n, s)(u, c) : Hn({ mark: t }, s, n)(u, c);
    }
    return l && o(s), l;
  };
}, u0 = function(r, e, t) {
  var n = r.resolve(e), i = n.index();
  return n.parent.canReplaceWith(i, i + 1, t);
}, dr = function(r, e, t, n) {
  if (!t.isTextblock)
    return !1;
  var i = r.selection.ranges;
  i.forEach(function(o) {
    var a = r.steps.length, s = o.$from.pos, l = o.$to.pos;
    r.doc.nodesBetween(s, l, function(c, u) {
      if (c.eq(e) && c.isTextblock && !c.hasMarkup(t, n) && u0(r.doc, r.mapping.slice(a).map(u), t)) {
        r.clearIncompatible(r.mapping.slice(a).map(u, 1), t);
        var f = r.mapping.slice(a), h = f.map(u, 1), d = f.map(u + c.nodeSize, 1), p = new $(I.from(t.create(n, null, c.marks)), 0, 0);
        return r.step(new Ne(h, d, h + 1, d - 1, p, 1, !0)), !1;
      }
    });
  });
}, er = function(r, e) {
  e === void 0 && (e = { blocksInSelection: !1 });
  var t = r.doc, n = r.selection, i = n.$from, o = n.ranges, a = e.blocksInSelection, s = [], l = n instanceof te ? n.node : void 0;
  return l ? l.isBlock ? (s.push(l), l.nodesBetween(0, l.content.size, function(c) {
    c.isBlock && s.push(c);
  })) : !a && i.parent && i.parent.isBlock && s.push(i.parent) : o.forEach(function(c) {
    var u = c.$from.pos, f = c.$to.pos;
    t.nodesBetween(u, f, function(h, d, p, m) {
      h.isBlock && (!a || d >= u && d + h.content.size + 2 <= f) && s.push(h);
    });
  }), s;
}, Wf = function(r, e) {
  return function(t, n) {
    var i = er(t), o = t.schema.nodes, a = t.tr;
    a.setMeta("commandName", e), a.setMeta("args", { value: r }), i.forEach(function(l) {
      if (l.type.isTextblock) {
        if (r === "p") {
          var c = l.attrs, u = c.level, f = Vi(c, ["level"]);
          dr(a, l, o.paragraph, f);
        } else if (/^h[1-6]$/i.test(r)) {
          var u = parseInt(r.substr(1), 10);
          dr(a, l, o.heading, A(A({}, l.attrs), { level: u }));
        } else if (r === "blockquote") {
          var h = l.attrs, u = h.level, f = Vi(h, ["level"]);
          dr(a, l, o.blockquote, f);
        }
      }
    });
    var s = a.docChanged;
    return s && n(a.scrollIntoView()), s;
  };
}, f0 = function(r, e) {
  e === void 0 && (e = { blocksInSelection: !0 });
  var t = r.doc, n = r.selection, i = e.blocksInSelection, o = e.blockNodeType, a = er({ doc: t, selection: n }, { blocksInSelection: i }), s = a.filter(function(l) {
    return l.isTextblock;
  });
  s.forEach(function(l) {
    var c = l.attrs || {}, u = c.style, f = u === void 0 ? "" : u, h = c.class, d = h === void 0 ? "" : h, p = Vi(c, ["style", "class"]), m = o || l.type;
    (f || d || m !== l.type) && dr(r, l, m, p);
  });
}, Vf = function(r) {
  var e = er(r), t = r.schema.nodes, n = [];
  return e.forEach(function(i) {
    i.type === t.paragraph ? n.push("p") : i.type === t.heading ? n.push("h" + i.attrs.level) : i.type === t.blockquote && t.blockquote.isTextblock && n.push("blockquote");
  }), n;
}, Uf = function(r, e) {
  var t = r.attrs.style, n, i;
  t && e.forEach(function(a) {
    i = { style: a.name, value: /^.+$/, newValue: a.value }, n = wr(t, i), t = n.changed ? n.style : t;
  });
  var o = function(a, s) {
    return (a && s.value ? a + " " : "") + s.value ? s.name + ": " + s.value + ";" : "";
  };
  return t = t || e.reduce(o, ""), Object.assign({}, r.attrs, { style: t || null });
}, Zr = function(r, e) {
  var t = r.selection, n = t.from, i = t.to, o = !1;
  return r.doc.nodesBetween(n, i, function(a) {
    return o = o || a.type === e, !o;
  }), o;
}, qf = function(r, e) {
  return function(t, n) {
    var i = er(t), o = t.tr;
    o.setMeta("commandName", e), i.forEach(function(s) {
      if (s.type.isTextblock) {
        var l = {}, c = r.find(function(u) {
          return u.node === s.type.name;
        });
        c && (l = Uf(s, c.style)), dr(o, s, s.type, l);
      }
    });
    var a = o.docChanged;
    return a && n(o.scrollIntoView()), a;
  };
}, Kf = function(r, e) {
  var t = er(r), n = !1;
  return t.forEach(function(i) {
    if (!n && i.type.isTextblock && i.attrs.style) {
      var o = e.find(function(a) {
        return a.node === i.type.name;
      });
      o && (n = o.style.every(function(a) {
        return !!a.value && new RegExp(a.name + ":\\s?" + a.value, "i").test(i.attrs.style);
      }));
    }
  }), n;
}, h0 = function(r) {
  return r === void 0 && (r = { blocksInSelection: !0 }), function(e, t) {
    var n = e.tr, i = r.blocksInSelection, o = r.blockNodeType, a = r.exceptMarks, s = (a || [e.schema.marks.link]).filter(Boolean);
    a0(n, { except: s }), f0(n, { blocksInSelection: i, blockNodeType: o });
    var l = n.docChanged;
    return l && t && t(n), l;
  };
};
function d0(r, e = null) {
  return function(t, n) {
    let { $from: i, $to: o } = t.selection, a = i.blockRange(o), s = !1, l = a;
    if (!a)
      return !1;
    if (a.depth >= 2 && i.node(a.depth - 1).type.compatibleContent(r) && a.startIndex == 0) {
      if (i.index(a.depth - 1) == 0)
        return !1;
      let u = t.doc.resolve(a.start - 2);
      l = new Yr(u, u, a.depth), a.endIndex < a.parent.childCount && (a = new Yr(i, t.doc.resolve(o.end(a.depth)), a.depth)), s = !0;
    }
    let c = Dw(l, r, e, a);
    return c ? (n && n(p0(t.tr, a, c, s, r).scrollIntoView()), !0) : !1;
  };
}
function p0(r, e, t, n, i) {
  let o = I.empty;
  for (let u = t.length - 1; u >= 0; u--)
    o = I.from(t[u].type.create(t[u].attrs, o));
  r.step(new Ne(e.start - (n ? 2 : 0), e.end, e.start, e.end, new $(o, 0, 0), t.length, !0));
  let a = 0;
  for (let u = 0; u < t.length; u++)
    t[u].type == i && (a = u + 1);
  let s = t.length - a, l = e.start + t.length - (n ? 2 : 0), c = e.parent;
  for (let u = e.startIndex, f = e.endIndex, h = !0; u < f; u++, h = !1)
    !h && fr(r.doc, l, s) && (r.split(l, s), l += 2 * s), l += c.child(u).nodeSize;
  return r;
}
function m0(r) {
  return function(e, t) {
    let { $from: n, $to: i, node: o } = e.selection;
    if (o && o.isBlock || n.depth < 2 || !n.sameParent(i))
      return !1;
    let a = n.node(-1);
    if (a.type != r)
      return !1;
    if (n.parent.content.size == 0 && n.node(-1).childCount == n.indexAfter(-1)) {
      if (n.depth == 3 || n.node(-3).type != r || n.index(-2) != n.node(-2).childCount - 1)
        return !1;
      if (t) {
        let u = I.empty, f = n.index(-1) ? 1 : n.index(-2) ? 2 : 3;
        for (let v = n.depth - f; v >= n.depth - 3; v--)
          u = I.from(n.node(v).copy(u));
        let h = n.indexAfter(-1) < n.node(-2).childCount ? 1 : n.indexAfter(-2) < n.node(-3).childCount ? 2 : 3;
        u = u.append(I.from(r.createAndFill()));
        let d = n.before(n.depth - (f - 1)), p = e.tr.replace(d, n.after(-h), new $(u, 4 - f, 0)), m = -1;
        p.doc.nodesBetween(d, p.doc.content.size, (v, y) => {
          if (m > -1)
            return !1;
          v.isTextblock && v.content.size == 0 && (m = y + 1);
        }), m > -1 && p.setSelection(ie.near(p.doc.resolve(m))), t(p.scrollIntoView());
      }
      return !0;
    }
    let s = i.pos == n.end() ? a.contentMatchAt(0).defaultType : null, l = e.tr.delete(n.pos, i.pos), c = s ? [null, { type: s }] : void 0;
    return fr(l.doc, n.pos, 2, c) ? (t && t(l.split(n.pos, 2, c).scrollIntoView()), !0) : !1;
  };
}
function Gf(r) {
  return function(e, t) {
    let { $from: n, $to: i } = e.selection, o = n.blockRange(i, (a) => a.childCount > 0 && a.firstChild.type == r);
    return o ? t ? n.node(o.depth - 1).type == r ? g0(e, t, r, o) : v0(e, t, o) : !0 : !1;
  };
}
function g0(r, e, t, n) {
  let i = r.tr, o = n.end, a = n.$to.end(n.depth);
  o < a && (i.step(new Ne(o - 1, a, o, a, new $(I.from(t.create(null, n.parent.copy())), 1, 0), 1, !0)), n = new Yr(i.doc.resolve(n.$from.pos), i.doc.resolve(a), n.depth));
  const s = Or(n);
  if (s == null)
    return !1;
  i.lift(n, s);
  let l = i.mapping.map(o, -1) - 1;
  return fo(i.doc, l) && i.join(l), e(i.scrollIntoView()), !0;
}
function v0(r, e, t) {
  let n = r.tr, i = t.parent;
  for (let d = t.end, p = t.endIndex - 1, m = t.startIndex; p > m; p--)
    d -= i.child(p).nodeSize, n.delete(d - 1, d + 1);
  let o = n.doc.resolve(t.start), a = o.nodeAfter;
  if (n.mapping.map(t.end) != t.start + o.nodeAfter.nodeSize)
    return !1;
  let s = t.startIndex == 0, l = t.endIndex == i.childCount, c = o.node(-1), u = o.index(-1);
  if (!c.canReplace(u + (s ? 0 : 1), u + 1, a.content.append(l ? I.empty : I.from(i))))
    return !1;
  let f = o.pos, h = f + a.nodeSize;
  return n.step(new Ne(f - (s ? 1 : 0), h + (l ? 1 : 0), f + 1, h - 1, new $((s ? I.empty : I.from(i.copy(I.empty))).append(l ? I.empty : I.from(i.copy(I.empty))), s ? 0 : 1, l ? 0 : 1), s ? 0 : 1)), e(n.scrollIntoView()), !0;
}
function Jf(r) {
  return function(e, t) {
    let { $from: n, $to: i } = e.selection, o = n.blockRange(i, (c) => c.childCount > 0 && c.firstChild.type == r);
    if (!o)
      return !1;
    let a = o.startIndex;
    if (a == 0)
      return !1;
    let s = o.parent, l = s.child(a - 1);
    if (l.type != r)
      return !1;
    if (t) {
      let c = l.lastChild && l.lastChild.type == s.type, u = I.from(c ? r.create() : null), f = new $(I.from(r.create(null, I.from(s.type.create(null, u)))), c ? 3 : 1, 0), h = o.start, d = o.end;
      t(e.tr.step(new Ne(h - (c ? 3 : 1), d, h, d, f, 1, !0)).scrollIntoView());
    }
    return !0;
  };
}
var br = {
  orderedList: "ordered_list",
  bulletList: "bullet_list",
  listItem: "list_item"
};
br.orderedList, A({}, br);
br.bulletList, A({}, br);
var Xf = {
  nodes: [{
    node: "paragraph",
    style: "margin-left",
    rtlStyle: "margin-right",
    step: 30,
    unit: "px"
  }, {
    node: "heading",
    style: "margin-left",
    rtlStyle: "margin-right",
    step: 30,
    unit: "px"
  }],
  listsTypes: A({}, br)
}, y0 = {
  nodes: [{
    node: "paragraph",
    style: "margin-left",
    rtlStyle: "margin-right",
    step: -30,
    unit: "px"
  }, {
    node: "heading",
    style: "margin-left",
    rtlStyle: "margin-right",
    step: -30,
    unit: "px"
  }],
  listsTypes: A({}, br)
};
const Yf = (r, e) => r.selection.empty ? !1 : (e && e(r.tr.deleteSelection().scrollIntoView()), !0);
function w0(r, e) {
  let { $cursor: t } = r.selection;
  return !t || (e ? !e.endOfTextblock("backward", r) : t.parentOffset > 0) ? null : t;
}
const b0 = (r, e, t) => {
  let n = w0(r, t);
  if (!n)
    return !1;
  let i = Zf(n);
  if (!i) {
    let a = n.blockRange(), s = a && Or(a);
    return s == null ? !1 : (e && e(r.tr.lift(a, s).scrollIntoView()), !0);
  }
  let o = i.nodeBefore;
  if (!o.type.spec.isolating && nh(r, i, e))
    return !0;
  if (n.parent.content.size == 0 && (Sr(o, "end") || te.isSelectable(o))) {
    let a = Ws(r.doc, n.before(), n.after(), $.empty);
    if (a && a.slice.size < a.to - a.from) {
      if (e) {
        let s = r.tr.step(a);
        s.setSelection(Sr(o, "end") ? ie.findFrom(s.doc.resolve(s.mapping.map(i.pos, -1)), -1) : te.create(s.doc, i.pos - o.nodeSize)), e(s.scrollIntoView());
      }
      return !0;
    }
  }
  return o.isAtom && i.depth == n.depth - 1 ? (e && e(r.tr.delete(i.pos - o.nodeSize, i.pos).scrollIntoView()), !0) : !1;
};
function Sr(r, e, t = !1) {
  for (let n = r; n; n = e == "start" ? n.firstChild : n.lastChild) {
    if (n.isTextblock)
      return !0;
    if (t && n.childCount != 1)
      return !1;
  }
  return !1;
}
const S0 = (r, e, t) => {
  let { $head: n, empty: i } = r.selection, o = n;
  if (!i)
    return !1;
  if (n.parent.isTextblock) {
    if (t ? !t.endOfTextblock("backward", r) : n.parentOffset > 0)
      return !1;
    o = Zf(n);
  }
  let a = o && o.nodeBefore;
  return !a || !te.isSelectable(a) ? !1 : (e && e(r.tr.setSelection(te.create(r.doc, o.pos - a.nodeSize)).scrollIntoView()), !0);
};
function Zf(r) {
  if (!r.parent.type.spec.isolating)
    for (let e = r.depth - 1; e >= 0; e--) {
      if (r.index(e) > 0)
        return r.doc.resolve(r.before(e + 1));
      if (r.node(e).type.spec.isolating)
        break;
    }
  return null;
}
function C0(r, e) {
  let { $cursor: t } = r.selection;
  return !t || (e ? !e.endOfTextblock("forward", r) : t.parentOffset < t.parent.content.size) ? null : t;
}
const k0 = (r, e, t) => {
  let n = C0(r, t);
  if (!n)
    return !1;
  let i = Qf(n);
  if (!i)
    return !1;
  let o = i.nodeAfter;
  if (nh(r, i, e))
    return !0;
  if (n.parent.content.size == 0 && (Sr(o, "start") || te.isSelectable(o))) {
    let a = Ws(r.doc, n.before(), n.after(), $.empty);
    if (a && a.slice.size < a.to - a.from) {
      if (e) {
        let s = r.tr.step(a);
        s.setSelection(Sr(o, "start") ? ie.findFrom(s.doc.resolve(s.mapping.map(i.pos)), 1) : te.create(s.doc, s.mapping.map(i.pos))), e(s.scrollIntoView());
      }
      return !0;
    }
  }
  return o.isAtom && i.depth == n.depth - 1 ? (e && e(r.tr.delete(i.pos, i.pos + o.nodeSize).scrollIntoView()), !0) : !1;
}, x0 = (r, e, t) => {
  let { $head: n, empty: i } = r.selection, o = n;
  if (!i)
    return !1;
  if (n.parent.isTextblock) {
    if (t ? !t.endOfTextblock("forward", r) : n.parentOffset < n.parent.content.size)
      return !1;
    o = Qf(n);
  }
  let a = o && o.nodeAfter;
  return !a || !te.isSelectable(a) ? !1 : (e && e(r.tr.setSelection(te.create(r.doc, o.pos)).scrollIntoView()), !0);
};
function Qf(r) {
  if (!r.parent.type.spec.isolating)
    for (let e = r.depth - 1; e >= 0; e--) {
      let t = r.node(e);
      if (r.index(e) + 1 < t.childCount)
        return r.doc.resolve(r.after(e + 1));
      if (t.type.spec.isolating)
        break;
    }
  return null;
}
const O0 = (r, e) => {
  let { $head: t, $anchor: n } = r.selection;
  return !t.parent.type.spec.code || !t.sameParent(n) ? !1 : (e && e(r.tr.insertText(`
`).scrollIntoView()), !0);
};
function Xs(r) {
  for (let e = 0; e < r.edgeCount; e++) {
    let { type: t } = r.edge(e);
    if (t.isTextblock && !t.hasRequiredAttrs())
      return t;
  }
  return null;
}
const eh = (r, e) => {
  let { $head: t, $anchor: n } = r.selection;
  if (!t.parent.type.spec.code || !t.sameParent(n))
    return !1;
  let i = t.node(-1), o = t.indexAfter(-1), a = Xs(i.contentMatchAt(o));
  if (!a || !i.canReplaceWith(o, o, a))
    return !1;
  if (e) {
    let s = t.after(), l = r.tr.replaceWith(s, s, a.createAndFill());
    l.setSelection(ie.near(l.doc.resolve(s), 1)), e(l.scrollIntoView());
  }
  return !0;
}, T0 = (r, e) => {
  let t = r.selection, { $from: n, $to: i } = t;
  if (t instanceof We || n.parent.inlineContent || i.parent.inlineContent)
    return !1;
  let o = Xs(i.parent.contentMatchAt(i.indexAfter()));
  if (!o || !o.isTextblock)
    return !1;
  if (e) {
    let a = (!n.parentOffset && i.index() < i.parent.childCount ? n : i).pos, s = r.tr.insert(a, o.createAndFill());
    s.setSelection(oe.create(s.doc, a + 1)), e(s.scrollIntoView());
  }
  return !0;
}, M0 = (r, e) => {
  let { $cursor: t } = r.selection;
  if (!t || t.parent.content.size)
    return !1;
  if (t.depth > 1 && t.after() != t.end(-1)) {
    let o = t.before();
    if (fr(r.doc, o))
      return e && e(r.tr.split(o).scrollIntoView()), !0;
  }
  let n = t.blockRange(), i = n && Or(n);
  return i == null ? !1 : (e && e(r.tr.lift(n, i).scrollIntoView()), !0);
};
function _0(r) {
  return (e, t) => {
    let { $from: n, $to: i } = e.selection;
    if (e.selection instanceof te && e.selection.node.isBlock)
      return !n.parentOffset || !fr(e.doc, n.pos) ? !1 : (t && t(e.tr.split(n.pos).scrollIntoView()), !0);
    if (!n.parent.isBlock)
      return !1;
    if (t) {
      let o = i.parentOffset == i.parent.content.size, a = e.tr;
      (e.selection instanceof oe || e.selection instanceof We) && a.deleteSelection();
      let s = n.depth == 0 ? null : Xs(n.node(-1).contentMatchAt(n.indexAfter(-1))), l = r && r(i.parent, o), c = l ? [l] : o && s ? [{ type: s }] : void 0, u = fr(a.doc, a.mapping.map(n.pos), 1, c);
      if (!c && !u && fr(a.doc, a.mapping.map(n.pos), 1, s ? [{ type: s }] : void 0) && (s && (c = [{ type: s }]), u = !0), u && (a.split(a.mapping.map(n.pos), 1, c), !o && !n.parentOffset && n.parent.type != s)) {
        let f = a.mapping.map(n.before()), h = a.doc.resolve(f);
        s && n.node(-1).canReplaceWith(h.index(), h.index() + 1, s) && a.setNodeMarkup(a.mapping.map(n.before()), s);
      }
      t(a.scrollIntoView());
    }
    return !0;
  };
}
const I0 = _0(), th = (r, e) => (e && e(r.tr.setSelection(new We(r.doc))), !0);
function D0(r, e, t) {
  let n = e.nodeBefore, i = e.nodeAfter, o = e.index();
  return !n || !i || !n.type.compatibleContent(i.type) ? !1 : !n.content.size && e.parent.canReplace(o - 1, o) ? (t && t(r.tr.delete(e.pos - n.nodeSize, e.pos).scrollIntoView()), !0) : !e.parent.canReplace(o, o + 1) || !(i.isTextblock || fo(r.doc, e.pos)) ? !1 : (t && t(r.tr.clearIncompatible(e.pos, n.type, n.contentMatchAt(n.childCount)).join(e.pos).scrollIntoView()), !0);
}
function nh(r, e, t) {
  let n = e.nodeBefore, i = e.nodeAfter, o, a;
  if (n.type.spec.isolating || i.type.spec.isolating)
    return !1;
  if (D0(r, e, t))
    return !0;
  let s = e.parent.canReplace(e.index(), e.index() + 1);
  if (s && (o = (a = n.contentMatchAt(n.childCount)).findWrapping(i.type)) && a.matchType(o[0] || i.type).validEnd) {
    if (t) {
      let f = e.pos + i.nodeSize, h = I.empty;
      for (let m = o.length - 1; m >= 0; m--)
        h = I.from(o[m].create(null, h));
      h = I.from(n.copy(h));
      let d = r.tr.step(new Ne(e.pos - 1, f, e.pos, f, new $(h, 1, 0), o.length, !0)), p = f + 2 * o.length;
      fo(d.doc, p) && d.join(p), t(d.scrollIntoView());
    }
    return !0;
  }
  let l = ie.findFrom(e, 1), c = l && l.$from.blockRange(l.$to), u = c && Or(c);
  if (u != null && u >= e.depth)
    return t && t(r.tr.lift(c, u).scrollIntoView()), !0;
  if (s && Sr(i, "start", !0) && Sr(n, "end")) {
    let f = n, h = [];
    for (; h.push(f), !f.isTextblock; )
      f = f.lastChild;
    let d = i, p = 1;
    for (; !d.isTextblock; d = d.firstChild)
      p++;
    if (f.canReplace(f.childCount, f.childCount, d.content)) {
      if (t) {
        let m = I.empty;
        for (let y = h.length - 1; y >= 0; y--)
          m = I.from(h[y].copy(m));
        let v = r.tr.step(new Ne(e.pos - h.length, e.pos + i.nodeSize, e.pos + p, e.pos + i.nodeSize - p, new $(m, h.length, 0), 0, !0));
        t(v.scrollIntoView());
      }
      return !0;
    }
  }
  return !1;
}
function rh(r) {
  return function(e, t) {
    let n = e.selection, i = r < 0 ? n.$from : n.$to, o = i.depth;
    for (; i.node(o).isInline; ) {
      if (!o)
        return !1;
      o--;
    }
    return i.node(o).isTextblock ? (t && t(e.tr.setSelection(oe.create(e.doc, r < 0 ? i.start(o) : i.end(o)))), !0) : !1;
  };
}
const E0 = rh(-1), A0 = rh(1);
function N0(r, e) {
  return (t) => {
    if (!t.isGeneric)
      return r(t);
    let n = [];
    for (let o = 0; o < t.mapping.maps.length; o++) {
      let a = t.mapping.maps[o];
      for (let s = 0; s < n.length; s++)
        n[s] = a.map(n[s]);
      a.forEach((s, l, c, u) => n.push(c, u));
    }
    let i = [];
    for (let o = 0; o < n.length; o += 2) {
      let a = n[o], s = n[o + 1], l = t.doc.resolve(a), c = l.sharedDepth(s), u = l.node(c);
      for (let f = l.indexAfter(c), h = l.after(c + 1); h <= s; ++f) {
        let d = u.maybeChild(f);
        if (!d)
          break;
        if (f && i.indexOf(h) == -1) {
          let p = u.child(f - 1);
          p.type == d.type && e(p, d) && i.push(h);
        }
        h += d.nodeSize;
      }
    }
    i.sort((o, a) => o - a);
    for (let o = i.length - 1; o >= 0; o--)
      fo(t.doc, i[o]) && t.join(i[o]);
    r(t);
  };
}
function R0(r, e) {
  let t = Array.isArray(e) ? (n) => e.indexOf(n.type.name) > -1 : e;
  return (n, i, o) => r(n, i && N0(i, t), o);
}
function go(...r) {
  return function(e, t, n) {
    for (let i = 0; i < r.length; i++)
      if (r[i](e, t, n))
        return !0;
    return !1;
  };
}
let na = go(Yf, b0, S0), dc = go(Yf, k0, x0);
const Jt = {
  Enter: go(O0, T0, M0, I0),
  "Mod-Enter": eh,
  Backspace: na,
  "Mod-Backspace": na,
  "Shift-Backspace": na,
  Delete: dc,
  "Mod-Delete": dc,
  "Mod-a": th
}, ih = {
  "Ctrl-h": Jt.Backspace,
  "Alt-Backspace": Jt["Mod-Backspace"],
  "Ctrl-d": Jt.Delete,
  "Ctrl-Alt-Backspace": Jt["Mod-Delete"],
  "Alt-Delete": Jt["Mod-Delete"],
  "Alt-d": Jt["Mod-Delete"],
  "Ctrl-a": E0,
  "Ctrl-e": A0
};
for (let r in Jt)
  ih[r] = Jt[r];
const P0 = typeof navigator < "u" ? /Mac|iP(hone|[oa]d)/.test(navigator.platform) : typeof os < "u" && os.platform ? os.platform() == "darwin" : !1, L0 = P0 ? ih : Jt;
var Ys = function(r, e, t) {
  return function(n, i) {
    var o = er(n), a = n.tr;
    a.setMeta("commandName", e), o.forEach(function(l) {
      if (l.type.isTextblock) {
        var c = void 0, u = r.find(function(v) {
          return v.node === l.type.name;
        });
        if (u) {
          var f = t === "rtl" ? u.rtlStyle : u.style, h = {
            name: f,
            value: u.step > 0 ? "" + u.step + u.unit : ""
          };
          if (l.attrs.style) {
            var d = new RegExp(f + ":\\s?(\\d+)" + u.unit, "i"), p = l.attrs.style.match(d);
            if (p) {
              var m = parseFloat(p[1]) + u.step;
              m = m <= 0 ? "" : m, h.value = "" + m + (m ? u.unit : "");
            }
          }
          c = Uf(l, [h]);
        }
        c && dr(a, l, l.type, c);
      }
    });
    var s = a.docChanged;
    return s && i(a.scrollIntoView()), s;
  };
}, Zs = function(r, e, t) {
  var n = er(r), i = !1;
  return n.forEach(function(o) {
    if (!i && o.type.isTextblock && o.attrs.style) {
      var a = e.find(function(c) {
        return c.node === o.type.name;
      });
      if (a) {
        var s = t === "rtl" ? a.rtlStyle : a.style, l = new RegExp(s + ":\\s?\\d+" + a.unit, "i");
        i = l.test(o.attrs.style);
      }
    }
  }), i;
}, oh = function(r, e) {
  return Jf(e)(r);
}, ah = function(r, e) {
  var t = r.schema.nodes[e.listsTypes.listItem], n = r.schema.nodes[e.listsTypes.orderedList], i = r.schema.nodes[e.listsTypes.bulletList], o = !!hc(n, 2)(r.selection), a = !!hc(i, 2)(r.selection);
  return (o || a) && Gf(t)(r);
}, F0 = function(r, e) {
  for (var t = e.bulletList, n = e.orderedList, i = e.listItem, o, a = r.depth - 1; a > 0; a--) {
    var s = r.node(a);
    if ((s.type === t || s.type === n) && (o = a), s.type !== t && s.type !== n && s.type !== i)
      break;
  }
  return o;
}, z0 = function(r, e, t) {
  for (var n = e.depth, i = r.nodes[t.bulletList], o = r.nodes[t.orderedList], a = r.nodes[t.listItem], s = e.depth; s > 0; s--) {
    var l = e.node(s);
    if ((l.type === i || l.type === o) && (n = s), l.type !== i && l.type !== o && l.type !== a)
      break;
  }
  return n - 1;
};
function B0(r, e, t) {
  var n = r.selection, i = n.from, o = n.to, a = r.schema.nodes, s = a.paragraph, l = a.heading, c = [];
  e.doc.nodesBetween(i, o, function(m, v) {
    (m.type === s || m.type === l) && c.push({ node: m, pos: v });
  });
  for (var u = c.length - 1; u >= 0; u--) {
    var f = c[u], h = e.doc.resolve(e.mapping.map(f.pos));
    if (h.depth > 0) {
      var d = void 0;
      f.node.textContent && f.node.textContent.length > 0 ? d = e.doc.resolve(e.mapping.map(f.pos + f.node.textContent.length)) : d = e.doc.resolve(e.mapping.map(f.pos + 1));
      var p = h.blockRange(d);
      p && e.lift(p, z0(r.schema, h, t));
    }
  }
  return e;
}
function $0(r) {
  return function(e, t, n) {
    if (!n)
      return !1;
    e = n.state;
    var i = e.schema.nodes[r.listType], o = e.selection, a = o.$from, s = o.$to, l = a.node(-2), c = a.node(-3), u = W0(e.doc, a, s, i);
    return (l && l.type === i || c && c.type === i) && u ? pc(r)(e, t) : (u || (pc(r)(e, t), e = n.state), q0(i, r.listAttrs)(e, t));
  };
}
function H0(r, e, t, n) {
  var i = n || r.schema.nodes.listItem, o = e.$from, a = e.$to, s = o.blockRange(a, function(u) {
    return u.childCount && u.firstChild.type === i;
  });
  if (!s || s.depth < 2 || o.node(s.depth - 1).type !== i)
    return t;
  var l = s.end, c = a.end(s.depth);
  return l < c && (t.step(new Ne(l - 1, c, l, c, new $(I.from(i.create(void 0, s.parent.copy())), 1, 0), 1, !0)), s = new Yr(t.doc.resolve(o.pos), t.doc.resolve(c), s.depth)), t.lift(s, Or(s)).scrollIntoView();
}
function j0(r, e, t, n, i, o) {
  o || (o = r.schema.nodes.listItem);
  var a = !1;
  return i.doc.nodesBetween(e, t, function(s, l) {
    if (!a && s.type === o && l > e) {
      a = !0;
      for (var c = n + 3; c > n + 2; ) {
        var u = i.doc.resolve(i.mapping.map(l));
        c = u.depth;
        var f = i.doc.resolve(i.mapping.map(l + s.textContent.length)), h = new oe(u, f);
        i = H0(r, h, i, o);
      }
    }
  }), i;
}
function W0(r, e, t, n) {
  return V0(r, e, t).filter(function(i) {
    return i.type !== n;
  }).length === 0;
}
function V0(r, e, t) {
  for (var n = Array(), i = U0(r, e).depth, o = r.resolve(e.start(i)); o.pos <= t.start(t.depth); ) {
    var a = Math.min(o.depth, i), s = o.node(a);
    if (s && n.push(s), a === 0)
      break;
    var l = r.resolve(o.after(a));
    if (l.start(a) >= r.nodeSize - 2)
      break;
    l.depth !== o.depth && (l = r.resolve(l.pos + 2)), l.depth ? o = r.resolve(l.start(l.depth)) : o = r.resolve(l.end(l.depth));
  }
  return n;
}
function U0(r, e) {
  var t = ["blockquote", "bulletList", "orderedList"];
  if (e.depth === 1)
    return e;
  for (var n = e.node(e.depth), i = e; e.depth >= 1; )
    e = r.resolve(e.before(e.depth)), n = e.node(e.depth), n && t.indexOf(n.type.name) !== -1 && (i = e);
  return i;
}
function pc(r) {
  return function(e, t) {
    var n = e.tr, i = e.selection, o = i.$from, a = i.$to;
    return n.doc.nodesBetween(o.pos, a.pos, function(s, l) {
      if (s.isTextblock || s.type.name === "blockquote" || s.type.name === "div") {
        var c = new te(n.doc.resolve(n.mapping.map(l))), u = c.$from.blockRange(c.$to);
        if (!u || c.$from.parent.type !== e.schema.nodes[r.listItem])
          return !1;
        var f = u && Or(u);
        if (f == null)
          return !1;
        n.lift(u, f);
      }
    }), t && t(n), !0;
  };
}
function q0(r, e) {
  return e === void 0 && (e = {}), R0(d0(r, e), function(t, n) {
    return t.type === n.type && t.type === r;
  });
}
var K0 = /list\-style\-type:\s?([\w-]+)/, lr = function(r) {
  var e = r.style || "", t = K0.exec(e);
  return t && t[1] || "";
}, Ui = function(r, e, t, n, i) {
  var o = n.listType, a = n.listAttrs, s = a === void 0 ? { style: null } : a, l = r.selection, c = l.$from.node(l.$from.depth - 2), u = l.$to.node(l.$to.depth - 2);
  if (!c || c.type.name !== o || lr(c.attrs) !== lr(s) || !u || u.type.name !== o || lr(u.attrs) !== lr(s))
    return $0(n)(r, e, t);
  var f = t.state.schema.nodes, h = {
    bulletList: f[n.bulletList],
    orderedList: f[n.orderedList],
    listItem: f[n.listItem]
  }, d = F0(l.$to, h), p = j0(r, l.$to.pos, l.$to.end(d), d, t.state.tr, h.listItem);
  return p = B0(r, p, n), p.setMeta("commandName", i), e(p), !0;
}, jt = function(r, e) {
  return { name: r, value: e };
}, G0 = [
  { node: "paragraph", style: [jt("text-align", "left")] },
  { node: "heading", style: [jt("text-align", "left")] }
], J0 = [
  { node: "paragraph", style: [jt("text-align", "right")] },
  { node: "heading", style: [jt("text-align", "right")] }
], X0 = [
  { node: "paragraph", style: [jt("text-align", "center")] },
  { node: "heading", style: [jt("text-align", "center")] }
], Y0 = [
  { node: "paragraph", style: [jt("text-align", "justify")] },
  { node: "heading", style: [jt("text-align", "justify")] }
], Z0 = [
  { node: "paragraph", style: [jt("text-align", "")] },
  { node: "heading", style: [jt("text-align", "")] }
];
const st = function(r) {
  for (var e = 0; ; e++)
    if (r = r.previousSibling, !r)
      return e;
}, Qr = function(r) {
  let e = r.assignedSlot || r.parentNode;
  return e && e.nodeType == 11 ? e.host : e;
};
let mc = null;
const Gt = function(r, e, t) {
  let n = mc || (mc = document.createRange());
  return n.setEnd(r, t ?? r.nodeValue.length), n.setStart(r, e || 0), n;
}, Un = function(r, e, t, n) {
  return t && (gc(r, e, t, n, -1) || gc(r, e, t, n, 1));
}, Q0 = /^(img|br|input|textarea|hr)$/i;
function gc(r, e, t, n, i) {
  for (; ; ) {
    if (r == t && e == n)
      return !0;
    if (e == (i < 0 ? 0 : zt(r))) {
      let o = r.parentNode;
      if (!o || o.nodeType != 1 || tb(r) || Q0.test(r.nodeName) || r.contentEditable == "false")
        return !1;
      e = st(r) + (i < 0 ? 0 : 1), r = o;
    } else if (r.nodeType == 1) {
      if (r = r.childNodes[e + (i < 0 ? -1 : 0)], r.contentEditable == "false")
        return !1;
      e = i < 0 ? zt(r) : 0;
    } else
      return !1;
  }
}
function zt(r) {
  return r.nodeType == 3 ? r.nodeValue.length : r.childNodes.length;
}
function eb(r, e, t) {
  for (let n = e == 0, i = e == zt(r); n || i; ) {
    if (r == t)
      return !0;
    let o = st(r);
    if (r = r.parentNode, !r)
      return !1;
    n = n && o == 0, i = i && o == zt(r);
  }
}
function tb(r) {
  let e;
  for (let t = r; t && !(e = t.pmViewDesc); t = t.parentNode)
    ;
  return e && e.node && e.node.isBlock && (e.dom == r || e.contentDOM == r);
}
const vo = function(r) {
  return r.focusNode && Un(r.focusNode, r.focusOffset, r.anchorNode, r.anchorOffset);
};
function Nn(r, e) {
  let t = document.createEvent("Event");
  return t.initEvent("keydown", !0, !0), t.keyCode = r, t.key = t.code = e, t;
}
function nb(r) {
  let e = r.activeElement;
  for (; e && e.shadowRoot; )
    e = e.shadowRoot.activeElement;
  return e;
}
const kn = typeof navigator < "u" ? navigator : null, vc = typeof document < "u" ? document : null, Tn = kn && kn.userAgent || "", Wa = /Edge\/(\d+)/.exec(Tn), sh = /MSIE \d/.exec(Tn), Va = /Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec(Tn), nt = !!(sh || Va || Wa), wn = sh ? document.documentMode : Va ? +Va[1] : Wa ? +Wa[1] : 0, Dt = !nt && /gecko\/(\d+)/i.test(Tn);
Dt && +(/Firefox\/(\d+)/.exec(Tn) || [0, 0])[1];
const Ua = !nt && /Chrome\/(\d+)/.exec(Tn), Ke = !!Ua, rb = Ua ? +Ua[1] : 0, Ye = !nt && !!kn && /Apple Computer/.test(kn.vendor), Cr = Ye && (/Mobile\/\w+/.test(Tn) || !!kn && kn.maxTouchPoints > 2), ht = Cr || (kn ? /Mac/.test(kn.platform) : !1), Mt = /Android \d/.test(Tn), yo = !!vc && "webkitFontSmoothing" in vc.documentElement.style, ib = yo ? +(/\bAppleWebKit\/(\d+)/.exec(navigator.userAgent) || [0, 0])[1] : 0;
function ob(r) {
  return {
    left: 0,
    right: r.documentElement.clientWidth,
    top: 0,
    bottom: r.documentElement.clientHeight
  };
}
function an(r, e) {
  return typeof r == "number" ? r : r[e];
}
function ab(r) {
  let e = r.getBoundingClientRect(), t = e.width / r.offsetWidth || 1, n = e.height / r.offsetHeight || 1;
  return {
    left: e.left,
    right: e.left + r.clientWidth * t,
    top: e.top,
    bottom: e.top + r.clientHeight * n
  };
}
function yc(r, e, t) {
  let n = r.someProp("scrollThreshold") || 0, i = r.someProp("scrollMargin") || 5, o = r.dom.ownerDocument;
  for (let a = t || r.dom; a; a = Qr(a)) {
    if (a.nodeType != 1)
      continue;
    let s = a, l = s == o.body, c = l ? ob(o) : ab(s), u = 0, f = 0;
    if (e.top < c.top + an(n, "top") ? f = -(c.top - e.top + an(i, "top")) : e.bottom > c.bottom - an(n, "bottom") && (f = e.bottom - c.bottom + an(i, "bottom")), e.left < c.left + an(n, "left") ? u = -(c.left - e.left + an(i, "left")) : e.right > c.right - an(n, "right") && (u = e.right - c.right + an(i, "right")), u || f)
      if (l)
        o.defaultView.scrollBy(u, f);
      else {
        let h = s.scrollLeft, d = s.scrollTop;
        f && (s.scrollTop += f), u && (s.scrollLeft += u);
        let p = s.scrollLeft - h, m = s.scrollTop - d;
        e = { left: e.left - p, top: e.top - m, right: e.right - p, bottom: e.bottom - m };
      }
    if (l)
      break;
  }
}
function sb(r) {
  let e = r.dom.getBoundingClientRect(), t = Math.max(0, e.top), n, i;
  for (let o = (e.left + e.right) / 2, a = t + 1; a < Math.min(innerHeight, e.bottom); a += 5) {
    let s = r.root.elementFromPoint(o, a);
    if (!s || s == r.dom || !r.dom.contains(s))
      continue;
    let l = s.getBoundingClientRect();
    if (l.top >= t - 20) {
      n = s, i = l.top;
      break;
    }
  }
  return { refDOM: n, refTop: i, stack: lh(r.dom) };
}
function lh(r) {
  let e = [], t = r.ownerDocument;
  for (let n = r; n && (e.push({ dom: n, top: n.scrollTop, left: n.scrollLeft }), r != t); n = Qr(n))
    ;
  return e;
}
function lb({ refDOM: r, refTop: e, stack: t }) {
  let n = r ? r.getBoundingClientRect().top : 0;
  ch(t, n == 0 ? 0 : n - e);
}
function ch(r, e) {
  for (let t = 0; t < r.length; t++) {
    let { dom: n, top: i, left: o } = r[t];
    n.scrollTop != i + e && (n.scrollTop = i + e), n.scrollLeft != o && (n.scrollLeft = o);
  }
}
let nr = null;
function cb(r) {
  if (r.setActive)
    return r.setActive();
  if (nr)
    return r.focus(nr);
  let e = lh(r);
  r.focus(nr == null ? {
    get preventScroll() {
      return nr = { preventScroll: !0 }, !0;
    }
  } : void 0), nr || (nr = !1, ch(e, 0));
}
function uh(r, e) {
  let t, n = 2e8, i, o = 0, a = e.top, s = e.top;
  for (let l = r.firstChild, c = 0; l; l = l.nextSibling, c++) {
    let u;
    if (l.nodeType == 1)
      u = l.getClientRects();
    else if (l.nodeType == 3)
      u = Gt(l).getClientRects();
    else
      continue;
    for (let f = 0; f < u.length; f++) {
      let h = u[f];
      if (h.top <= a && h.bottom >= s) {
        a = Math.max(h.bottom, a), s = Math.min(h.top, s);
        let d = h.left > e.left ? h.left - e.left : h.right < e.left ? e.left - h.right : 0;
        if (d < n) {
          t = l, n = d, i = d && t.nodeType == 3 ? {
            left: h.right < e.left ? h.right : h.left,
            top: e.top
          } : e, l.nodeType == 1 && d && (o = c + (e.left >= (h.left + h.right) / 2 ? 1 : 0));
          continue;
        }
      }
      !t && (e.left >= h.right && e.top >= h.top || e.left >= h.left && e.top >= h.bottom) && (o = c + 1);
    }
  }
  return t && t.nodeType == 3 ? ub(t, i) : !t || n && t.nodeType == 1 ? { node: r, offset: o } : uh(t, i);
}
function ub(r, e) {
  let t = r.nodeValue.length, n = document.createRange();
  for (let i = 0; i < t; i++) {
    n.setEnd(r, i + 1), n.setStart(r, i);
    let o = sn(n, 1);
    if (o.top != o.bottom && Qs(e, o))
      return { node: r, offset: i + (e.left >= (o.left + o.right) / 2 ? 1 : 0) };
  }
  return { node: r, offset: 0 };
}
function Qs(r, e) {
  return r.left >= e.left - 1 && r.left <= e.right + 1 && r.top >= e.top - 1 && r.top <= e.bottom + 1;
}
function fb(r, e) {
  let t = r.parentNode;
  return t && /^li$/i.test(t.nodeName) && e.left < r.getBoundingClientRect().left ? t : r;
}
function hb(r, e, t) {
  let { node: n, offset: i } = uh(e, t), o = -1;
  if (n.nodeType == 1 && !n.firstChild) {
    let a = n.getBoundingClientRect();
    o = a.left != a.right && t.left > (a.left + a.right) / 2 ? 1 : -1;
  }
  return r.docView.posFromDOM(n, i, o);
}
function db(r, e, t, n) {
  let i = -1;
  for (let o = e, a = !1; o != r.dom; ) {
    let s = r.docView.nearestDesc(o, !0);
    if (!s)
      return null;
    if (s.dom.nodeType == 1 && (s.node.isBlock && s.parent && !a || !s.contentDOM)) {
      let l = s.dom.getBoundingClientRect();
      if (s.node.isBlock && s.parent && !a && (a = !0, l.left > n.left || l.top > n.top ? i = s.posBefore : (l.right < n.left || l.bottom < n.top) && (i = s.posAfter)), !s.contentDOM && i < 0)
        return (s.node.isBlock ? n.top < (l.top + l.bottom) / 2 : n.left < (l.left + l.right) / 2) ? s.posBefore : s.posAfter;
    }
    o = s.dom.parentNode;
  }
  return i > -1 ? i : r.docView.posFromDOM(e, t, -1);
}
function fh(r, e, t) {
  let n = r.childNodes.length;
  if (n && t.top < t.bottom)
    for (let i = Math.max(0, Math.min(n - 1, Math.floor(n * (e.top - t.top) / (t.bottom - t.top)) - 2)), o = i; ; ) {
      let a = r.childNodes[o];
      if (a.nodeType == 1) {
        let s = a.getClientRects();
        for (let l = 0; l < s.length; l++) {
          let c = s[l];
          if (Qs(e, c))
            return fh(a, e, c);
        }
      }
      if ((o = (o + 1) % n) == i)
        break;
    }
  return r;
}
function pb(r, e) {
  let t = r.dom.ownerDocument, n, i = 0;
  if (t.caretPositionFromPoint)
    try {
      let l = t.caretPositionFromPoint(e.left, e.top);
      l && ({ offsetNode: n, offset: i } = l);
    } catch {
    }
  if (!n && t.caretRangeFromPoint) {
    let l = t.caretRangeFromPoint(e.left, e.top);
    l && ({ startContainer: n, startOffset: i } = l);
  }
  let o = (r.root.elementFromPoint ? r.root : t).elementFromPoint(e.left, e.top), a;
  if (!o || !r.dom.contains(o.nodeType != 1 ? o.parentNode : o)) {
    let l = r.dom.getBoundingClientRect();
    if (!Qs(e, l) || (o = fh(r.dom, e, l), !o))
      return null;
  }
  if (Ye)
    for (let l = o; n && l; l = Qr(l))
      l.draggable && (n = void 0);
  if (o = fb(o, e), n) {
    if (Dt && n.nodeType == 1 && (i = Math.min(i, n.childNodes.length), i < n.childNodes.length)) {
      let l = n.childNodes[i], c;
      l.nodeName == "IMG" && (c = l.getBoundingClientRect()).right <= e.left && c.bottom > e.top && i++;
    }
    n == r.dom && i == n.childNodes.length - 1 && n.lastChild.nodeType == 1 && e.top > n.lastChild.getBoundingClientRect().bottom ? a = r.state.doc.content.size : (i == 0 || n.nodeType != 1 || n.childNodes[i - 1].nodeName != "BR") && (a = db(r, n, i, e));
  }
  a == null && (a = hb(r, o, e));
  let s = r.docView.nearestDesc(o, !0);
  return { pos: a, inside: s ? s.posAtStart - s.border : -1 };
}
function sn(r, e) {
  let t = r.getClientRects();
  return t.length ? t[e < 0 ? 0 : t.length - 1] : r.getBoundingClientRect();
}
const mb = /[\u0590-\u05f4\u0600-\u06ff\u0700-\u08ac]/;
function hh(r, e, t) {
  let { node: n, offset: i, atom: o } = r.docView.domFromPos(e, t < 0 ? -1 : 1), a = yo || Dt;
  if (n.nodeType == 3)
    if (a && (mb.test(n.nodeValue) || (t < 0 ? !i : i == n.nodeValue.length))) {
      let l = sn(Gt(n, i, i), t);
      if (Dt && i && /\s/.test(n.nodeValue[i - 1]) && i < n.nodeValue.length) {
        let c = sn(Gt(n, i - 1, i - 1), -1);
        if (c.top == l.top) {
          let u = sn(Gt(n, i, i + 1), -1);
          if (u.top != l.top)
            return Dr(u, u.left < c.left);
        }
      }
      return l;
    } else {
      let l = i, c = i, u = t < 0 ? 1 : -1;
      return t < 0 && !i ? (c++, u = -1) : t >= 0 && i == n.nodeValue.length ? (l--, u = 1) : t < 0 ? l-- : c++, Dr(sn(Gt(n, l, c), 1), u < 0);
    }
  if (!r.state.doc.resolve(e - (o || 0)).parent.inlineContent) {
    if (o == null && i && (t < 0 || i == zt(n))) {
      let l = n.childNodes[i - 1];
      if (l.nodeType == 1)
        return ra(l.getBoundingClientRect(), !1);
    }
    if (o == null && i < zt(n)) {
      let l = n.childNodes[i];
      if (l.nodeType == 1)
        return ra(l.getBoundingClientRect(), !0);
    }
    return ra(n.getBoundingClientRect(), t >= 0);
  }
  if (o == null && i && (t < 0 || i == zt(n))) {
    let l = n.childNodes[i - 1], c = l.nodeType == 3 ? Gt(l, zt(l) - (a ? 0 : 1)) : l.nodeType == 1 && (l.nodeName != "BR" || !l.nextSibling) ? l : null;
    if (c)
      return Dr(sn(c, 1), !1);
  }
  if (o == null && i < zt(n)) {
    let l = n.childNodes[i];
    for (; l.pmViewDesc && l.pmViewDesc.ignoreForCoords; )
      l = l.nextSibling;
    let c = l ? l.nodeType == 3 ? Gt(l, 0, a ? 0 : 1) : l.nodeType == 1 ? l : null : null;
    if (c)
      return Dr(sn(c, -1), !0);
  }
  return Dr(sn(n.nodeType == 3 ? Gt(n) : n, -t), t >= 0);
}
function Dr(r, e) {
  if (r.width == 0)
    return r;
  let t = e ? r.left : r.right;
  return { top: r.top, bottom: r.bottom, left: t, right: t };
}
function ra(r, e) {
  if (r.height == 0)
    return r;
  let t = e ? r.top : r.bottom;
  return { top: t, bottom: t, left: r.left, right: r.right };
}
function dh(r, e, t) {
  let n = r.state, i = r.root.activeElement;
  n != e && r.updateState(e), i != r.dom && r.focus();
  try {
    return t();
  } finally {
    n != e && r.updateState(n), i != r.dom && i && i.focus();
  }
}
function gb(r, e, t) {
  let n = e.selection, i = t == "up" ? n.$from : n.$to;
  return dh(r, e, () => {
    let { node: o } = r.docView.domFromPos(i.pos, t == "up" ? -1 : 1);
    for (; ; ) {
      let s = r.docView.nearestDesc(o, !0);
      if (!s)
        break;
      if (s.node.isBlock) {
        o = s.contentDOM || s.dom;
        break;
      }
      o = s.dom.parentNode;
    }
    let a = hh(r, i.pos, 1);
    for (let s = o.firstChild; s; s = s.nextSibling) {
      let l;
      if (s.nodeType == 1)
        l = s.getClientRects();
      else if (s.nodeType == 3)
        l = Gt(s, 0, s.nodeValue.length).getClientRects();
      else
        continue;
      for (let c = 0; c < l.length; c++) {
        let u = l[c];
        if (u.bottom > u.top + 1 && (t == "up" ? a.top - u.top > (u.bottom - a.top) * 2 : u.bottom - a.bottom > (a.bottom - u.top) * 2))
          return !1;
      }
    }
    return !0;
  });
}
const vb = /[\u0590-\u08ac]/;
function yb(r, e, t) {
  let { $head: n } = e.selection;
  if (!n.parent.isTextblock)
    return !1;
  let i = n.parentOffset, o = !i, a = i == n.parent.content.size, s = r.domSelection();
  return !vb.test(n.parent.textContent) || !s.modify ? t == "left" || t == "backward" ? o : a : dh(r, e, () => {
    let { focusNode: l, focusOffset: c, anchorNode: u, anchorOffset: f } = r.domSelectionRange(), h = s.caretBidiLevel;
    s.modify("move", t, "character");
    let d = n.depth ? r.docView.domAfterPos(n.before()) : r.dom, { focusNode: p, focusOffset: m } = r.domSelectionRange(), v = p && !d.contains(p.nodeType == 1 ? p : p.parentNode) || l == p && c == m;
    try {
      s.collapse(u, f), l && (l != u || c != f) && s.extend && s.extend(l, c);
    } catch {
    }
    return h != null && (s.caretBidiLevel = h), v;
  });
}
let wc = null, bc = null, Sc = !1;
function wb(r, e, t) {
  return wc == e && bc == t ? Sc : (wc = e, bc = t, Sc = t == "up" || t == "down" ? gb(r, e, t) : yb(r, e, t));
}
const It = 0, Cc = 1, cr = 2, Wt = 3;
class ui {
  constructor(e, t, n, i) {
    this.parent = e, this.children = t, this.dom = n, this.contentDOM = i, this.dirty = It, n.pmViewDesc = this;
  }
  // Used to check whether a given description corresponds to a
  // widget/mark/node.
  matchesWidget(e) {
    return !1;
  }
  matchesMark(e) {
    return !1;
  }
  matchesNode(e, t, n) {
    return !1;
  }
  matchesHack(e) {
    return !1;
  }
  // When parsing in-editor content (in domchange.js), we allow
  // descriptions to determine the parse rules that should be used to
  // parse them.
  parseRule() {
    return null;
  }
  // Used by the editor's event handler to ignore events that come
  // from certain descs.
  stopEvent(e) {
    return !1;
  }
  // The size of the content represented by this desc.
  get size() {
    let e = 0;
    for (let t = 0; t < this.children.length; t++)
      e += this.children[t].size;
    return e;
  }
  // For block nodes, this represents the space taken up by their
  // start/end tokens.
  get border() {
    return 0;
  }
  destroy() {
    this.parent = void 0, this.dom.pmViewDesc == this && (this.dom.pmViewDesc = void 0);
    for (let e = 0; e < this.children.length; e++)
      this.children[e].destroy();
  }
  posBeforeChild(e) {
    for (let t = 0, n = this.posAtStart; ; t++) {
      let i = this.children[t];
      if (i == e)
        return n;
      n += i.size;
    }
  }
  get posBefore() {
    return this.parent.posBeforeChild(this);
  }
  get posAtStart() {
    return this.parent ? this.parent.posBeforeChild(this) + this.border : 0;
  }
  get posAfter() {
    return this.posBefore + this.size;
  }
  get posAtEnd() {
    return this.posAtStart + this.size - 2 * this.border;
  }
  localPosFromDOM(e, t, n) {
    if (this.contentDOM && this.contentDOM.contains(e.nodeType == 1 ? e : e.parentNode))
      if (n < 0) {
        let o, a;
        if (e == this.contentDOM)
          o = e.childNodes[t - 1];
        else {
          for (; e.parentNode != this.contentDOM; )
            e = e.parentNode;
          o = e.previousSibling;
        }
        for (; o && !((a = o.pmViewDesc) && a.parent == this); )
          o = o.previousSibling;
        return o ? this.posBeforeChild(a) + a.size : this.posAtStart;
      } else {
        let o, a;
        if (e == this.contentDOM)
          o = e.childNodes[t];
        else {
          for (; e.parentNode != this.contentDOM; )
            e = e.parentNode;
          o = e.nextSibling;
        }
        for (; o && !((a = o.pmViewDesc) && a.parent == this); )
          o = o.nextSibling;
        return o ? this.posBeforeChild(a) : this.posAtEnd;
      }
    let i;
    if (e == this.dom && this.contentDOM)
      i = t > st(this.contentDOM);
    else if (this.contentDOM && this.contentDOM != this.dom && this.dom.contains(this.contentDOM))
      i = e.compareDocumentPosition(this.contentDOM) & 2;
    else if (this.dom.firstChild) {
      if (t == 0)
        for (let o = e; ; o = o.parentNode) {
          if (o == this.dom) {
            i = !1;
            break;
          }
          if (o.previousSibling)
            break;
        }
      if (i == null && t == e.childNodes.length)
        for (let o = e; ; o = o.parentNode) {
          if (o == this.dom) {
            i = !0;
            break;
          }
          if (o.nextSibling)
            break;
        }
    }
    return i ?? n > 0 ? this.posAtEnd : this.posAtStart;
  }
  nearestDesc(e, t = !1) {
    for (let n = !0, i = e; i; i = i.parentNode) {
      let o = this.getDesc(i), a;
      if (o && (!t || o.node))
        if (n && (a = o.nodeDOM) && !(a.nodeType == 1 ? a.contains(e.nodeType == 1 ? e : e.parentNode) : a == e))
          n = !1;
        else
          return o;
    }
  }
  getDesc(e) {
    let t = e.pmViewDesc;
    for (let n = t; n; n = n.parent)
      if (n == this)
        return t;
  }
  posFromDOM(e, t, n) {
    for (let i = e; i; i = i.parentNode) {
      let o = this.getDesc(i);
      if (o)
        return o.localPosFromDOM(e, t, n);
    }
    return -1;
  }
  // Find the desc for the node after the given pos, if any. (When a
  // parent node overrode rendering, there might not be one.)
  descAt(e) {
    for (let t = 0, n = 0; t < this.children.length; t++) {
      let i = this.children[t], o = n + i.size;
      if (n == e && o != n) {
        for (; !i.border && i.children.length; )
          i = i.children[0];
        return i;
      }
      if (e < o)
        return i.descAt(e - n - i.border);
      n = o;
    }
  }
  domFromPos(e, t) {
    if (!this.contentDOM)
      return { node: this.dom, offset: 0, atom: e + 1 };
    let n = 0, i = 0;
    for (let o = 0; n < this.children.length; n++) {
      let a = this.children[n], s = o + a.size;
      if (s > e || a instanceof mh) {
        i = e - o;
        break;
      }
      o = s;
    }
    if (i)
      return this.children[n].domFromPos(i - this.children[n].border, t);
    for (let o; n && !(o = this.children[n - 1]).size && o instanceof ph && o.side >= 0; n--)
      ;
    if (t <= 0) {
      let o, a = !0;
      for (; o = n ? this.children[n - 1] : null, !(!o || o.dom.parentNode == this.contentDOM); n--, a = !1)
        ;
      return o && t && a && !o.border && !o.domAtom ? o.domFromPos(o.size, t) : { node: this.contentDOM, offset: o ? st(o.dom) + 1 : 0 };
    } else {
      let o, a = !0;
      for (; o = n < this.children.length ? this.children[n] : null, !(!o || o.dom.parentNode == this.contentDOM); n++, a = !1)
        ;
      return o && a && !o.border && !o.domAtom ? o.domFromPos(0, t) : { node: this.contentDOM, offset: o ? st(o.dom) : this.contentDOM.childNodes.length };
    }
  }
  // Used to find a DOM range in a single parent for a given changed
  // range.
  parseRange(e, t, n = 0) {
    if (this.children.length == 0)
      return { node: this.contentDOM, from: e, to: t, fromOffset: 0, toOffset: this.contentDOM.childNodes.length };
    let i = -1, o = -1;
    for (let a = n, s = 0; ; s++) {
      let l = this.children[s], c = a + l.size;
      if (i == -1 && e <= c) {
        let u = a + l.border;
        if (e >= u && t <= c - l.border && l.node && l.contentDOM && this.contentDOM.contains(l.contentDOM))
          return l.parseRange(e, t, u);
        e = a;
        for (let f = s; f > 0; f--) {
          let h = this.children[f - 1];
          if (h.size && h.dom.parentNode == this.contentDOM && !h.emptyChildAt(1)) {
            i = st(h.dom) + 1;
            break;
          }
          e -= h.size;
        }
        i == -1 && (i = 0);
      }
      if (i > -1 && (c > t || s == this.children.length - 1)) {
        t = c;
        for (let u = s + 1; u < this.children.length; u++) {
          let f = this.children[u];
          if (f.size && f.dom.parentNode == this.contentDOM && !f.emptyChildAt(-1)) {
            o = st(f.dom);
            break;
          }
          t += f.size;
        }
        o == -1 && (o = this.contentDOM.childNodes.length);
        break;
      }
      a = c;
    }
    return { node: this.contentDOM, from: e, to: t, fromOffset: i, toOffset: o };
  }
  emptyChildAt(e) {
    if (this.border || !this.contentDOM || !this.children.length)
      return !1;
    let t = this.children[e < 0 ? 0 : this.children.length - 1];
    return t.size == 0 || t.emptyChildAt(e);
  }
  domAfterPos(e) {
    let { node: t, offset: n } = this.domFromPos(e, 0);
    if (t.nodeType != 1 || n == t.childNodes.length)
      throw new RangeError("No node after pos " + e);
    return t.childNodes[n];
  }
  // View descs are responsible for setting any selection that falls
  // entirely inside of them, so that custom implementations can do
  // custom things with the selection. Note that this falls apart when
  // a selection starts in such a node and ends in another, in which
  // case we just use whatever domFromPos produces as a best effort.
  setSelection(e, t, n, i = !1) {
    let o = Math.min(e, t), a = Math.max(e, t);
    for (let h = 0, d = 0; h < this.children.length; h++) {
      let p = this.children[h], m = d + p.size;
      if (o > d && a < m)
        return p.setSelection(e - d - p.border, t - d - p.border, n, i);
      d = m;
    }
    let s = this.domFromPos(e, e ? -1 : 1), l = t == e ? s : this.domFromPos(t, t ? -1 : 1), c = n.getSelection(), u = !1;
    if ((Dt || Ye) && e == t) {
      let { node: h, offset: d } = s;
      if (h.nodeType == 3) {
        if (u = !!(d && h.nodeValue[d - 1] == `
`), u && d == h.nodeValue.length)
          for (let p = h, m; p; p = p.parentNode) {
            if (m = p.nextSibling) {
              m.nodeName == "BR" && (s = l = { node: m.parentNode, offset: st(m) + 1 });
              break;
            }
            let v = p.pmViewDesc;
            if (v && v.node && v.node.isBlock)
              break;
          }
      } else {
        let p = h.childNodes[d - 1];
        u = p && (p.nodeName == "BR" || p.contentEditable == "false");
      }
    }
    if (Dt && c.focusNode && c.focusNode != l.node && c.focusNode.nodeType == 1) {
      let h = c.focusNode.childNodes[c.focusOffset];
      h && h.contentEditable == "false" && (i = !0);
    }
    if (!(i || u && Ye) && Un(s.node, s.offset, c.anchorNode, c.anchorOffset) && Un(l.node, l.offset, c.focusNode, c.focusOffset))
      return;
    let f = !1;
    if ((c.extend || e == t) && !u) {
      c.collapse(s.node, s.offset);
      try {
        e != t && c.extend(l.node, l.offset), f = !0;
      } catch {
      }
    }
    if (!f) {
      if (e > t) {
        let d = s;
        s = l, l = d;
      }
      let h = document.createRange();
      h.setEnd(l.node, l.offset), h.setStart(s.node, s.offset), c.removeAllRanges(), c.addRange(h);
    }
  }
  ignoreMutation(e) {
    return !this.contentDOM && e.type != "selection";
  }
  get contentLost() {
    return this.contentDOM && this.contentDOM != this.dom && !this.dom.contains(this.contentDOM);
  }
  // Remove a subtree of the element tree that has been touched
  // by a DOM change, so that the next update will redraw it.
  markDirty(e, t) {
    for (let n = 0, i = 0; i < this.children.length; i++) {
      let o = this.children[i], a = n + o.size;
      if (n == a ? e <= a && t >= n : e < a && t > n) {
        let s = n + o.border, l = a - o.border;
        if (e >= s && t <= l) {
          this.dirty = e == n || t == a ? cr : Cc, e == s && t == l && (o.contentLost || o.dom.parentNode != this.contentDOM) ? o.dirty = Wt : o.markDirty(e - s, t - s);
          return;
        } else
          o.dirty = o.dom == o.contentDOM && o.dom.parentNode == this.contentDOM && !o.children.length ? cr : Wt;
      }
      n = a;
    }
    this.dirty = cr;
  }
  markParentsDirty() {
    let e = 1;
    for (let t = this.parent; t; t = t.parent, e++) {
      let n = e == 1 ? cr : Cc;
      t.dirty < n && (t.dirty = n);
    }
  }
  get domAtom() {
    return !1;
  }
  get ignoreForCoords() {
    return !1;
  }
}
class ph extends ui {
  constructor(e, t, n, i) {
    let o, a = t.type.toDOM;
    if (typeof a == "function" && (a = a(n, () => {
      if (!o)
        return i;
      if (o.parent)
        return o.parent.posBeforeChild(o);
    })), !t.type.spec.raw) {
      if (a.nodeType != 1) {
        let s = document.createElement("span");
        s.appendChild(a), a = s;
      }
      a.contentEditable = "false", a.classList.add("ProseMirror-widget");
    }
    super(e, [], a, null), this.widget = t, this.widget = t, o = this;
  }
  matchesWidget(e) {
    return this.dirty == It && e.type.eq(this.widget.type);
  }
  parseRule() {
    return { ignore: !0 };
  }
  stopEvent(e) {
    let t = this.widget.spec.stopEvent;
    return t ? t(e) : !1;
  }
  ignoreMutation(e) {
    return e.type != "selection" || this.widget.spec.ignoreSelection;
  }
  destroy() {
    this.widget.type.destroy(this.dom), super.destroy();
  }
  get domAtom() {
    return !0;
  }
  get side() {
    return this.widget.type.side;
  }
}
class bb extends ui {
  constructor(e, t, n, i) {
    super(e, [], t, null), this.textDOM = n, this.text = i;
  }
  get size() {
    return this.text.length;
  }
  localPosFromDOM(e, t) {
    return e != this.textDOM ? this.posAtStart + (t ? this.size : 0) : this.posAtStart + t;
  }
  domFromPos(e) {
    return { node: this.textDOM, offset: e };
  }
  ignoreMutation(e) {
    return e.type === "characterData" && e.target.nodeValue == e.oldValue;
  }
}
class qn extends ui {
  constructor(e, t, n, i) {
    super(e, [], n, i), this.mark = t;
  }
  static create(e, t, n, i) {
    let o = i.nodeViews[t.type.name], a = o && o(t, i, n);
    return (!a || !a.dom) && (a = Bt.renderSpec(document, t.type.spec.toDOM(t, n))), new qn(e, t, a.dom, a.contentDOM || a.dom);
  }
  parseRule() {
    return this.dirty & Wt || this.mark.type.spec.reparseInView ? null : { mark: this.mark.type.name, attrs: this.mark.attrs, contentElement: this.contentDOM || void 0 };
  }
  matchesMark(e) {
    return this.dirty != Wt && this.mark.eq(e);
  }
  markDirty(e, t) {
    if (super.markDirty(e, t), this.dirty != It) {
      let n = this.parent;
      for (; !n.node; )
        n = n.parent;
      n.dirty < this.dirty && (n.dirty = this.dirty), this.dirty = It;
    }
  }
  slice(e, t, n) {
    let i = qn.create(this.parent, this.mark, !0, n), o = this.children, a = this.size;
    t < a && (o = Ga(o, t, a, n)), e > 0 && (o = Ga(o, 0, e, n));
    for (let s = 0; s < o.length; s++)
      o[s].parent = i;
    return i.children = o, i;
  }
}
class Kn extends ui {
  constructor(e, t, n, i, o, a, s, l, c) {
    super(e, [], o, a), this.node = t, this.outerDeco = n, this.innerDeco = i, this.nodeDOM = s, a && this.updateChildren(l, c);
  }
  // By default, a node is rendered using the `toDOM` method from the
  // node type spec. But client code can use the `nodeViews` spec to
  // supply a custom node view, which can influence various aspects of
  // the way the node works.
  //
  // (Using subclassing for this was intentionally decided against,
  // since it'd require exposing a whole slew of finicky
  // implementation details to the user code that they probably will
  // never need.)
  static create(e, t, n, i, o, a) {
    let s = o.nodeViews[t.type.name], l, c = s && s(t, o, () => {
      if (!l)
        return a;
      if (l.parent)
        return l.parent.posBeforeChild(l);
    }, n, i), u = c && c.dom, f = c && c.contentDOM;
    if (t.isText) {
      if (!u)
        u = document.createTextNode(t.text);
      else if (u.nodeType != 3)
        throw new RangeError("Text must be rendered as a DOM text node");
    } else
      u || ({ dom: u, contentDOM: f } = Bt.renderSpec(document, t.type.spec.toDOM(t)));
    !f && !t.isText && u.nodeName != "BR" && (u.hasAttribute("contenteditable") || (u.contentEditable = "false"), t.type.spec.draggable && (u.draggable = !0));
    let h = u;
    return u = yh(u, n, t), c ? l = new Sb(e, t, n, i, u, f || null, h, c, o, a + 1) : t.isText ? new wo(e, t, n, i, u, h, o) : new Kn(e, t, n, i, u, f || null, h, o, a + 1);
  }
  parseRule() {
    if (this.node.type.spec.reparseInView)
      return null;
    let e = { node: this.node.type.name, attrs: this.node.attrs };
    if (this.node.type.whitespace == "pre" && (e.preserveWhitespace = "full"), !this.contentDOM)
      e.getContent = () => this.node.content;
    else if (!this.contentLost)
      e.contentElement = this.contentDOM;
    else {
      for (let t = this.children.length - 1; t >= 0; t--) {
        let n = this.children[t];
        if (this.dom.contains(n.dom.parentNode)) {
          e.contentElement = n.dom.parentNode;
          break;
        }
      }
      e.contentElement || (e.getContent = () => I.empty);
    }
    return e;
  }
  matchesNode(e, t, n) {
    return this.dirty == It && e.eq(this.node) && Ka(t, this.outerDeco) && n.eq(this.innerDeco);
  }
  get size() {
    return this.node.nodeSize;
  }
  get border() {
    return this.node.isLeaf ? 0 : 1;
  }
  // Syncs `this.children` to match `this.node.content` and the local
  // decorations, possibly introducing nesting for marks. Then, in a
  // separate step, syncs the DOM inside `this.contentDOM` to
  // `this.children`.
  updateChildren(e, t) {
    let n = this.node.inlineContent, i = t, o = e.composing ? this.localCompositionInfo(e, t) : null, a = o && o.pos > -1 ? o : null, s = o && o.pos < 0, l = new kb(this, a && a.node, e);
    Tb(this.node, this.innerDeco, (c, u, f) => {
      c.spec.marks ? l.syncToMarks(c.spec.marks, n, e) : c.type.side >= 0 && !f && l.syncToMarks(u == this.node.childCount ? me.none : this.node.child(u).marks, n, e), l.placeWidget(c, e, i);
    }, (c, u, f, h) => {
      l.syncToMarks(c.marks, n, e);
      let d;
      l.findNodeMatch(c, u, f, h) || s && e.state.selection.from > i && e.state.selection.to < i + c.nodeSize && (d = l.findIndexWithChild(o.node)) > -1 && l.updateNodeAt(c, u, f, d, e) || l.updateNextNode(c, u, f, e, h) || l.addNode(c, u, f, e, i), i += c.nodeSize;
    }), l.syncToMarks([], n, e), this.node.isTextblock && l.addTextblockHacks(), l.destroyRest(), (l.changed || this.dirty == cr) && (a && this.protectLocalComposition(e, a), gh(this.contentDOM, this.children, e), Cr && Mb(this.dom));
  }
  localCompositionInfo(e, t) {
    let { from: n, to: i } = e.state.selection;
    if (!(e.state.selection instanceof oe) || n < t || i > t + this.node.content.size)
      return null;
    let o = e.domSelectionRange(), a = _b(o.focusNode, o.focusOffset);
    if (!a || !this.dom.contains(a.parentNode))
      return null;
    if (this.node.inlineContent) {
      let s = a.nodeValue, l = Ib(this.node.content, s, n - t, i - t);
      return l < 0 ? null : { node: a, pos: l, text: s };
    } else
      return { node: a, pos: -1, text: "" };
  }
  protectLocalComposition(e, { node: t, pos: n, text: i }) {
    if (this.getDesc(t))
      return;
    let o = t;
    for (; o.parentNode != this.contentDOM; o = o.parentNode) {
      for (; o.previousSibling; )
        o.parentNode.removeChild(o.previousSibling);
      for (; o.nextSibling; )
        o.parentNode.removeChild(o.nextSibling);
      o.pmViewDesc && (o.pmViewDesc = void 0);
    }
    let a = new bb(this, o, t, i);
    e.input.compositionNodes.push(a), this.children = Ga(this.children, n, n + i.length, e, a);
  }
  // If this desc must be updated to match the given node decoration,
  // do so and return true.
  update(e, t, n, i) {
    return this.dirty == Wt || !e.sameMarkup(this.node) ? !1 : (this.updateInner(e, t, n, i), !0);
  }
  updateInner(e, t, n, i) {
    this.updateOuterDeco(t), this.node = e, this.innerDeco = n, this.contentDOM && this.updateChildren(i, this.posAtStart), this.dirty = It;
  }
  updateOuterDeco(e) {
    if (Ka(e, this.outerDeco))
      return;
    let t = this.nodeDOM.nodeType != 1, n = this.dom;
    this.dom = vh(this.dom, this.nodeDOM, qa(this.outerDeco, this.node, t), qa(e, this.node, t)), this.dom != n && (n.pmViewDesc = void 0, this.dom.pmViewDesc = this), this.outerDeco = e;
  }
  // Mark this node as being the selected node.
  selectNode() {
    this.nodeDOM.nodeType == 1 && this.nodeDOM.classList.add("ProseMirror-selectednode"), (this.contentDOM || !this.node.type.spec.draggable) && (this.dom.draggable = !0);
  }
  // Remove selected node marking from this node.
  deselectNode() {
    this.nodeDOM.nodeType == 1 && this.nodeDOM.classList.remove("ProseMirror-selectednode"), (this.contentDOM || !this.node.type.spec.draggable) && this.dom.removeAttribute("draggable");
  }
  get domAtom() {
    return this.node.isAtom;
  }
}
function kc(r, e, t, n, i) {
  return yh(n, e, r), new Kn(void 0, r, e, t, n, n, n, i, 0);
}
class wo extends Kn {
  constructor(e, t, n, i, o, a, s) {
    super(e, t, n, i, o, null, a, s, 0);
  }
  parseRule() {
    let e = this.nodeDOM.parentNode;
    for (; e && e != this.dom && !e.pmIsDeco; )
      e = e.parentNode;
    return { skip: e || !0 };
  }
  update(e, t, n, i) {
    return this.dirty == Wt || this.dirty != It && !this.inParent() || !e.sameMarkup(this.node) ? !1 : (this.updateOuterDeco(t), (this.dirty != It || e.text != this.node.text) && e.text != this.nodeDOM.nodeValue && (this.nodeDOM.nodeValue = e.text, i.trackWrites == this.nodeDOM && (i.trackWrites = null)), this.node = e, this.dirty = It, !0);
  }
  inParent() {
    let e = this.parent.contentDOM;
    for (let t = this.nodeDOM; t; t = t.parentNode)
      if (t == e)
        return !0;
    return !1;
  }
  domFromPos(e) {
    return { node: this.nodeDOM, offset: e };
  }
  localPosFromDOM(e, t, n) {
    return e == this.nodeDOM ? this.posAtStart + Math.min(t, this.node.text.length) : super.localPosFromDOM(e, t, n);
  }
  ignoreMutation(e) {
    return e.type != "characterData" && e.type != "selection";
  }
  slice(e, t, n) {
    let i = this.node.cut(e, t), o = document.createTextNode(i.text);
    return new wo(this.parent, i, this.outerDeco, this.innerDeco, o, o, n);
  }
  markDirty(e, t) {
    super.markDirty(e, t), this.dom != this.nodeDOM && (e == 0 || t == this.nodeDOM.nodeValue.length) && (this.dirty = Wt);
  }
  get domAtom() {
    return !1;
  }
}
class mh extends ui {
  parseRule() {
    return { ignore: !0 };
  }
  matchesHack(e) {
    return this.dirty == It && this.dom.nodeName == e;
  }
  get domAtom() {
    return !0;
  }
  get ignoreForCoords() {
    return this.dom.nodeName == "IMG";
  }
}
class Sb extends Kn {
  constructor(e, t, n, i, o, a, s, l, c, u) {
    super(e, t, n, i, o, a, s, c, u), this.spec = l;
  }
  // A custom `update` method gets to decide whether the update goes
  // through. If it does, and there's a `contentDOM` node, our logic
  // updates the children.
  update(e, t, n, i) {
    if (this.dirty == Wt)
      return !1;
    if (this.spec.update) {
      let o = this.spec.update(e, t, n);
      return o && this.updateInner(e, t, n, i), o;
    } else
      return !this.contentDOM && !e.isLeaf ? !1 : super.update(e, t, n, i);
  }
  selectNode() {
    this.spec.selectNode ? this.spec.selectNode() : super.selectNode();
  }
  deselectNode() {
    this.spec.deselectNode ? this.spec.deselectNode() : super.deselectNode();
  }
  setSelection(e, t, n, i) {
    this.spec.setSelection ? this.spec.setSelection(e, t, n) : super.setSelection(e, t, n, i);
  }
  destroy() {
    this.spec.destroy && this.spec.destroy(), super.destroy();
  }
  stopEvent(e) {
    return this.spec.stopEvent ? this.spec.stopEvent(e) : !1;
  }
  ignoreMutation(e) {
    return this.spec.ignoreMutation ? this.spec.ignoreMutation(e) : super.ignoreMutation(e);
  }
}
function gh(r, e, t) {
  let n = r.firstChild, i = !1;
  for (let o = 0; o < e.length; o++) {
    let a = e[o], s = a.dom;
    if (s.parentNode == r) {
      for (; s != n; )
        n = xc(n), i = !0;
      n = n.nextSibling;
    } else
      i = !0, r.insertBefore(s, n);
    if (a instanceof qn) {
      let l = n ? n.previousSibling : r.lastChild;
      gh(a.contentDOM, a.children, t), n = l ? l.nextSibling : r.firstChild;
    }
  }
  for (; n; )
    n = xc(n), i = !0;
  i && t.trackWrites == r && (t.trackWrites = null);
}
const Vr = function(r) {
  r && (this.nodeName = r);
};
Vr.prototype = /* @__PURE__ */ Object.create(null);
const Fn = [new Vr()];
function qa(r, e, t) {
  if (r.length == 0)
    return Fn;
  let n = t ? Fn[0] : new Vr(), i = [n];
  for (let o = 0; o < r.length; o++) {
    let a = r[o].type.attrs;
    if (a) {
      a.nodeName && i.push(n = new Vr(a.nodeName));
      for (let s in a) {
        let l = a[s];
        l != null && (t && i.length == 1 && i.push(n = new Vr(e.isInline ? "span" : "div")), s == "class" ? n.class = (n.class ? n.class + " " : "") + l : s == "style" ? n.style = (n.style ? n.style + ";" : "") + l : s != "nodeName" && (n[s] = l));
      }
    }
  }
  return i;
}
function vh(r, e, t, n) {
  if (t == Fn && n == Fn)
    return e;
  let i = e;
  for (let o = 0; o < n.length; o++) {
    let a = n[o], s = t[o];
    if (o) {
      let l;
      s && s.nodeName == a.nodeName && i != r && (l = i.parentNode) && l.nodeName.toLowerCase() == a.nodeName || (l = document.createElement(a.nodeName), l.pmIsDeco = !0, l.appendChild(i), s = Fn[0]), i = l;
    }
    Cb(i, s || Fn[0], a);
  }
  return i;
}
function Cb(r, e, t) {
  for (let n in e)
    n != "class" && n != "style" && n != "nodeName" && !(n in t) && r.removeAttribute(n);
  for (let n in t)
    n != "class" && n != "style" && n != "nodeName" && t[n] != e[n] && r.setAttribute(n, t[n]);
  if (e.class != t.class) {
    let n = e.class ? e.class.split(" ").filter(Boolean) : [], i = t.class ? t.class.split(" ").filter(Boolean) : [];
    for (let o = 0; o < n.length; o++)
      i.indexOf(n[o]) == -1 && r.classList.remove(n[o]);
    for (let o = 0; o < i.length; o++)
      n.indexOf(i[o]) == -1 && r.classList.add(i[o]);
    r.classList.length == 0 && r.removeAttribute("class");
  }
  if (e.style != t.style) {
    if (e.style) {
      let n = /\s*([\w\-\xa1-\uffff]+)\s*:(?:"(?:\\.|[^"])*"|'(?:\\.|[^'])*'|\(.*?\)|[^;])*/g, i;
      for (; i = n.exec(e.style); )
        r.style.removeProperty(i[1]);
    }
    t.style && (r.style.cssText += t.style);
  }
}
function yh(r, e, t) {
  return vh(r, r, Fn, qa(e, t, r.nodeType != 1));
}
function Ka(r, e) {
  if (r.length != e.length)
    return !1;
  for (let t = 0; t < r.length; t++)
    if (!r[t].type.eq(e[t].type))
      return !1;
  return !0;
}
function xc(r) {
  let e = r.nextSibling;
  return r.parentNode.removeChild(r), e;
}
class kb {
  constructor(e, t, n) {
    this.lock = t, this.view = n, this.index = 0, this.stack = [], this.changed = !1, this.top = e, this.preMatch = xb(e.node.content, e);
  }
  // Destroy and remove the children between the given indices in
  // `this.top`.
  destroyBetween(e, t) {
    if (e != t) {
      for (let n = e; n < t; n++)
        this.top.children[n].destroy();
      this.top.children.splice(e, t - e), this.changed = !0;
    }
  }
  // Destroy all remaining children in `this.top`.
  destroyRest() {
    this.destroyBetween(this.index, this.top.children.length);
  }
  // Sync the current stack of mark descs with the given array of
  // marks, reusing existing mark descs when possible.
  syncToMarks(e, t, n) {
    let i = 0, o = this.stack.length >> 1, a = Math.min(o, e.length);
    for (; i < a && (i == o - 1 ? this.top : this.stack[i + 1 << 1]).matchesMark(e[i]) && e[i].type.spec.spanning !== !1; )
      i++;
    for (; i < o; )
      this.destroyRest(), this.top.dirty = It, this.index = this.stack.pop(), this.top = this.stack.pop(), o--;
    for (; o < e.length; ) {
      this.stack.push(this.top, this.index + 1);
      let s = -1;
      for (let l = this.index; l < Math.min(this.index + 3, this.top.children.length); l++) {
        let c = this.top.children[l];
        if (c.matchesMark(e[o]) && !this.isLocked(c.dom)) {
          s = l;
          break;
        }
      }
      if (s > -1)
        s > this.index && (this.changed = !0, this.destroyBetween(this.index, s)), this.top = this.top.children[this.index];
      else {
        let l = qn.create(this.top, e[o], t, n);
        this.top.children.splice(this.index, 0, l), this.top = l, this.changed = !0;
      }
      this.index = 0, o++;
    }
  }
  // Try to find a node desc matching the given data. Skip over it and
  // return true when successful.
  findNodeMatch(e, t, n, i) {
    let o = -1, a;
    if (i >= this.preMatch.index && (a = this.preMatch.matches[i - this.preMatch.index]).parent == this.top && a.matchesNode(e, t, n))
      o = this.top.children.indexOf(a, this.index);
    else
      for (let s = this.index, l = Math.min(this.top.children.length, s + 5); s < l; s++) {
        let c = this.top.children[s];
        if (c.matchesNode(e, t, n) && !this.preMatch.matched.has(c)) {
          o = s;
          break;
        }
      }
    return o < 0 ? !1 : (this.destroyBetween(this.index, o), this.index++, !0);
  }
  updateNodeAt(e, t, n, i, o) {
    let a = this.top.children[i];
    return a.dirty == Wt && a.dom == a.contentDOM && (a.dirty = cr), a.update(e, t, n, o) ? (this.destroyBetween(this.index, i), this.index++, !0) : !1;
  }
  findIndexWithChild(e) {
    for (; ; ) {
      let t = e.parentNode;
      if (!t)
        return -1;
      if (t == this.top.contentDOM) {
        let n = e.pmViewDesc;
        if (n) {
          for (let i = this.index; i < this.top.children.length; i++)
            if (this.top.children[i] == n)
              return i;
        }
        return -1;
      }
      e = t;
    }
  }
  // Try to update the next node, if any, to the given data. Checks
  // pre-matches to avoid overwriting nodes that could still be used.
  updateNextNode(e, t, n, i, o) {
    for (let a = this.index; a < this.top.children.length; a++) {
      let s = this.top.children[a];
      if (s instanceof Kn) {
        let l = this.preMatch.matched.get(s);
        if (l != null && l != o)
          return !1;
        let c = s.dom;
        if (!(this.isLocked(c) && !(e.isText && s.node && s.node.isText && s.nodeDOM.nodeValue == e.text && s.dirty != Wt && Ka(t, s.outerDeco))) && s.update(e, t, n, i))
          return this.destroyBetween(this.index, a), s.dom != c && (this.changed = !0), this.index++, !0;
        break;
      }
    }
    return !1;
  }
  // Insert the node as a newly created node desc.
  addNode(e, t, n, i, o) {
    this.top.children.splice(this.index++, 0, Kn.create(this.top, e, t, n, i, o)), this.changed = !0;
  }
  placeWidget(e, t, n) {
    let i = this.index < this.top.children.length ? this.top.children[this.index] : null;
    if (i && i.matchesWidget(e) && (e == i.widget || !i.widget.type.toDOM.parentNode))
      this.index++;
    else {
      let o = new ph(this.top, e, t, n);
      this.top.children.splice(this.index++, 0, o), this.changed = !0;
    }
  }
  // Make sure a textblock looks and behaves correctly in
  // contentEditable.
  addTextblockHacks() {
    let e = this.top.children[this.index - 1], t = this.top;
    for (; e instanceof qn; )
      t = e, e = t.children[t.children.length - 1];
    (!e || // Empty textblock
    !(e instanceof wo) || /\n$/.test(e.node.text) || this.view.requiresGeckoHackNode && /\s$/.test(e.node.text)) && ((Ye || Ke) && e && e.dom.contentEditable == "false" && this.addHackNode("IMG", t), this.addHackNode("BR", this.top));
  }
  addHackNode(e, t) {
    if (t == this.top && this.index < t.children.length && t.children[this.index].matchesHack(e))
      this.index++;
    else {
      let n = document.createElement(e);
      e == "IMG" && (n.className = "ProseMirror-separator", n.alt = ""), e == "BR" && (n.className = "ProseMirror-trailingBreak");
      let i = new mh(this.top, [], n, null);
      t != this.top ? t.children.push(i) : t.children.splice(this.index++, 0, i), this.changed = !0;
    }
  }
  isLocked(e) {
    return this.lock && (e == this.lock || e.nodeType == 1 && e.contains(this.lock.parentNode));
  }
}
function xb(r, e) {
  let t = e, n = t.children.length, i = r.childCount, o = /* @__PURE__ */ new Map(), a = [];
  e:
    for (; i > 0; ) {
      let s;
      for (; ; )
        if (n) {
          let c = t.children[n - 1];
          if (c instanceof qn)
            t = c, n = c.children.length;
          else {
            s = c, n--;
            break;
          }
        } else {
          if (t == e)
            break e;
          n = t.parent.children.indexOf(t), t = t.parent;
        }
      let l = s.node;
      if (l) {
        if (l != r.child(i - 1))
          break;
        --i, o.set(s, i), a.push(s);
      }
    }
  return { index: i, matched: o, matches: a.reverse() };
}
function Ob(r, e) {
  return r.type.side - e.type.side;
}
function Tb(r, e, t, n) {
  let i = e.locals(r), o = 0;
  if (i.length == 0) {
    for (let c = 0; c < r.childCount; c++) {
      let u = r.child(c);
      n(u, i, e.forChild(o, u), c), o += u.nodeSize;
    }
    return;
  }
  let a = 0, s = [], l = null;
  for (let c = 0; ; ) {
    if (a < i.length && i[a].to == o) {
      let p = i[a++], m;
      for (; a < i.length && i[a].to == o; )
        (m || (m = [p])).push(i[a++]);
      if (m) {
        m.sort(Ob);
        for (let v = 0; v < m.length; v++)
          t(m[v], c, !!l);
      } else
        t(p, c, !!l);
    }
    let u, f;
    if (l)
      f = -1, u = l, l = null;
    else if (c < r.childCount)
      f = c, u = r.child(c++);
    else
      break;
    for (let p = 0; p < s.length; p++)
      s[p].to <= o && s.splice(p--, 1);
    for (; a < i.length && i[a].from <= o && i[a].to > o; )
      s.push(i[a++]);
    let h = o + u.nodeSize;
    if (u.isText) {
      let p = h;
      a < i.length && i[a].from < p && (p = i[a].from);
      for (let m = 0; m < s.length; m++)
        s[m].to < p && (p = s[m].to);
      p < h && (l = u.cut(p - o), u = u.cut(0, p - o), h = p, f = -1);
    }
    let d = u.isInline && !u.isLeaf ? s.filter((p) => !p.inline) : s.slice();
    n(u, d, e.forChild(o, u), f), o = h;
  }
}
function Mb(r) {
  if (r.nodeName == "UL" || r.nodeName == "OL") {
    let e = r.style.cssText;
    r.style.cssText = e + "; list-style: square !important", window.getComputedStyle(r).listStyle, r.style.cssText = e;
  }
}
function _b(r, e) {
  for (; ; ) {
    if (r.nodeType == 3)
      return r;
    if (r.nodeType == 1 && e > 0) {
      if (r.childNodes.length > e && r.childNodes[e].nodeType == 3)
        return r.childNodes[e];
      r = r.childNodes[e - 1], e = zt(r);
    } else if (r.nodeType == 1 && e < r.childNodes.length)
      r = r.childNodes[e], e = 0;
    else
      return null;
  }
}
function Ib(r, e, t, n) {
  for (let i = 0, o = 0; i < r.childCount && o <= n; ) {
    let a = r.child(i++), s = o;
    if (o += a.nodeSize, !a.isText)
      continue;
    let l = a.text;
    for (; i < r.childCount; ) {
      let c = r.child(i++);
      if (o += c.nodeSize, !c.isText)
        break;
      l += c.text;
    }
    if (o >= t) {
      let c = s < n ? l.lastIndexOf(e, n - s - 1) : -1;
      if (c >= 0 && c + e.length + s >= t)
        return s + c;
      if (t == n && l.length >= n + e.length - s && l.slice(n - s, n - s + e.length) == e)
        return n;
    }
  }
  return -1;
}
function Ga(r, e, t, n, i) {
  let o = [];
  for (let a = 0, s = 0; a < r.length; a++) {
    let l = r[a], c = s, u = s += l.size;
    c >= t || u <= e ? o.push(l) : (c < e && o.push(l.slice(0, e - c, n)), i && (o.push(i), i = void 0), u > t && o.push(l.slice(t - c, l.size, n)));
  }
  return o;
}
function el(r, e = null) {
  let t = r.domSelectionRange(), n = r.state.doc;
  if (!t.focusNode)
    return null;
  let i = r.docView.nearestDesc(t.focusNode), o = i && i.size == 0, a = r.docView.posFromDOM(t.focusNode, t.focusOffset, 1);
  if (a < 0)
    return null;
  let s = n.resolve(a), l, c;
  if (vo(t)) {
    for (l = s; i && !i.node; )
      i = i.parent;
    let u = i.node;
    if (i && u.isAtom && te.isSelectable(u) && i.parent && !(u.isInline && eb(t.focusNode, t.focusOffset, i.dom))) {
      let f = i.posBefore;
      c = new te(a == f ? s : n.resolve(f));
    }
  } else {
    let u = r.docView.posFromDOM(t.anchorNode, t.anchorOffset, 1);
    if (u < 0)
      return null;
    l = n.resolve(u);
  }
  if (!c) {
    let u = e == "pointer" || r.state.selection.head < s.pos && !o ? 1 : -1;
    c = tl(r, l, s, u);
  }
  return c;
}
function wh(r) {
  return r.editable ? r.hasFocus() : Sh(r) && document.activeElement && document.activeElement.contains(r.dom);
}
function en(r, e = !1) {
  let t = r.state.selection;
  if (bh(r, t), !!wh(r)) {
    if (!e && r.input.mouseDown && r.input.mouseDown.allowDefault && Ke) {
      let n = r.domSelectionRange(), i = r.domObserver.currentSelection;
      if (n.anchorNode && i.anchorNode && Un(n.anchorNode, n.anchorOffset, i.anchorNode, i.anchorOffset)) {
        r.input.mouseDown.delayedSelectionSync = !0, r.domObserver.setCurSelection();
        return;
      }
    }
    if (r.domObserver.disconnectSelection(), r.cursorWrapper)
      Eb(r);
    else {
      let { anchor: n, head: i } = t, o, a;
      Oc && !(t instanceof oe) && (t.$from.parent.inlineContent || (o = Tc(r, t.from)), !t.empty && !t.$from.parent.inlineContent && (a = Tc(r, t.to))), r.docView.setSelection(n, i, r.root, e), Oc && (o && Mc(o), a && Mc(a)), t.visible ? r.dom.classList.remove("ProseMirror-hideselection") : (r.dom.classList.add("ProseMirror-hideselection"), "onselectionchange" in document && Db(r));
    }
    r.domObserver.setCurSelection(), r.domObserver.connectSelection();
  }
}
const Oc = Ye || Ke && rb < 63;
function Tc(r, e) {
  let { node: t, offset: n } = r.docView.domFromPos(e, 0), i = n < t.childNodes.length ? t.childNodes[n] : null, o = n ? t.childNodes[n - 1] : null;
  if (Ye && i && i.contentEditable == "false")
    return ia(i);
  if ((!i || i.contentEditable == "false") && (!o || o.contentEditable == "false")) {
    if (i)
      return ia(i);
    if (o)
      return ia(o);
  }
}
function ia(r) {
  return r.contentEditable = "true", Ye && r.draggable && (r.draggable = !1, r.wasDraggable = !0), r;
}
function Mc(r) {
  r.contentEditable = "false", r.wasDraggable && (r.draggable = !0, r.wasDraggable = null);
}
function Db(r) {
  let e = r.dom.ownerDocument;
  e.removeEventListener("selectionchange", r.input.hideSelectionGuard);
  let t = r.domSelectionRange(), n = t.anchorNode, i = t.anchorOffset;
  e.addEventListener("selectionchange", r.input.hideSelectionGuard = () => {
    (t.anchorNode != n || t.anchorOffset != i) && (e.removeEventListener("selectionchange", r.input.hideSelectionGuard), setTimeout(() => {
      (!wh(r) || r.state.selection.visible) && r.dom.classList.remove("ProseMirror-hideselection");
    }, 20));
  });
}
function Eb(r) {
  let e = r.domSelection(), t = document.createRange(), n = r.cursorWrapper.dom, i = n.nodeName == "IMG";
  i ? t.setEnd(n.parentNode, st(n) + 1) : t.setEnd(n, 0), t.collapse(!1), e.removeAllRanges(), e.addRange(t), !i && !r.state.selection.visible && nt && wn <= 11 && (n.disabled = !0, n.disabled = !1);
}
function bh(r, e) {
  if (e instanceof te) {
    let t = r.docView.descAt(e.from);
    t != r.lastSelectedViewDesc && (_c(r), t && t.selectNode(), r.lastSelectedViewDesc = t);
  } else
    _c(r);
}
function _c(r) {
  r.lastSelectedViewDesc && (r.lastSelectedViewDesc.parent && r.lastSelectedViewDesc.deselectNode(), r.lastSelectedViewDesc = void 0);
}
function tl(r, e, t, n) {
  return r.someProp("createSelectionBetween", (i) => i(r, e, t)) || oe.between(e, t, n);
}
function Ic(r) {
  return r.editable && !r.hasFocus() ? !1 : Sh(r);
}
function Sh(r) {
  let e = r.domSelectionRange();
  if (!e.anchorNode)
    return !1;
  try {
    return r.dom.contains(e.anchorNode.nodeType == 3 ? e.anchorNode.parentNode : e.anchorNode) && (r.editable || r.dom.contains(e.focusNode.nodeType == 3 ? e.focusNode.parentNode : e.focusNode));
  } catch {
    return !1;
  }
}
function Ab(r) {
  let e = r.docView.domFromPos(r.state.selection.anchor, 0), t = r.domSelectionRange();
  return Un(e.node, e.offset, t.anchorNode, t.anchorOffset);
}
function Ja(r, e) {
  let { $anchor: t, $head: n } = r.selection, i = e > 0 ? t.max(n) : t.min(n), o = i.parent.inlineContent ? i.depth ? r.doc.resolve(e > 0 ? i.after() : i.before()) : null : i;
  return o && ie.findFrom(o, e);
}
function Rn(r, e) {
  return r.dispatch(r.state.tr.setSelection(e).scrollIntoView()), !0;
}
function Dc(r, e, t) {
  let n = r.state.selection;
  if (n instanceof oe) {
    if (!n.empty || t.indexOf("s") > -1)
      return !1;
    if (r.endOfTextblock(e > 0 ? "right" : "left")) {
      let i = Ja(r.state, e);
      return i && i instanceof te ? Rn(r, i) : !1;
    } else if (!(ht && t.indexOf("m") > -1)) {
      let i = n.$head, o = i.textOffset ? null : e < 0 ? i.nodeBefore : i.nodeAfter, a;
      if (!o || o.isText)
        return !1;
      let s = e < 0 ? i.pos - o.nodeSize : i.pos;
      return o.isAtom || (a = r.docView.descAt(s)) && !a.contentDOM ? te.isSelectable(o) ? Rn(r, new te(e < 0 ? r.state.doc.resolve(i.pos - o.nodeSize) : i)) : yo ? Rn(r, new oe(r.state.doc.resolve(e < 0 ? s : s + o.nodeSize))) : !1 : !1;
    }
  } else {
    if (n instanceof te && n.node.isInline)
      return Rn(r, new oe(e > 0 ? n.$to : n.$from));
    {
      let i = Ja(r.state, e);
      return i ? Rn(r, i) : !1;
    }
  }
}
function qi(r) {
  return r.nodeType == 3 ? r.nodeValue.length : r.childNodes.length;
}
function Ur(r) {
  let e = r.pmViewDesc;
  return e && e.size == 0 && (r.nextSibling || r.nodeName != "BR");
}
function oa(r) {
  let e = r.domSelectionRange(), t = e.focusNode, n = e.focusOffset;
  if (!t)
    return;
  let i, o, a = !1;
  for (Dt && t.nodeType == 1 && n < qi(t) && Ur(t.childNodes[n]) && (a = !0); ; )
    if (n > 0) {
      if (t.nodeType != 1)
        break;
      {
        let s = t.childNodes[n - 1];
        if (Ur(s))
          i = t, o = --n;
        else if (s.nodeType == 3)
          t = s, n = t.nodeValue.length;
        else
          break;
      }
    } else {
      if (Ch(t))
        break;
      {
        let s = t.previousSibling;
        for (; s && Ur(s); )
          i = t.parentNode, o = st(s), s = s.previousSibling;
        if (s)
          t = s, n = qi(t);
        else {
          if (t = t.parentNode, t == r.dom)
            break;
          n = 0;
        }
      }
    }
  a ? Xa(r, t, n) : i && Xa(r, i, o);
}
function aa(r) {
  let e = r.domSelectionRange(), t = e.focusNode, n = e.focusOffset;
  if (!t)
    return;
  let i = qi(t), o, a;
  for (; ; )
    if (n < i) {
      if (t.nodeType != 1)
        break;
      let s = t.childNodes[n];
      if (Ur(s))
        o = t, a = ++n;
      else
        break;
    } else {
      if (Ch(t))
        break;
      {
        let s = t.nextSibling;
        for (; s && Ur(s); )
          o = s.parentNode, a = st(s) + 1, s = s.nextSibling;
        if (s)
          t = s, n = 0, i = qi(t);
        else {
          if (t = t.parentNode, t == r.dom)
            break;
          n = i = 0;
        }
      }
    }
  o && Xa(r, o, a);
}
function Ch(r) {
  let e = r.pmViewDesc;
  return e && e.node && e.node.isBlock;
}
function Xa(r, e, t) {
  let n = r.domSelection();
  if (vo(n)) {
    let o = document.createRange();
    o.setEnd(e, t), o.setStart(e, t), n.removeAllRanges(), n.addRange(o);
  } else
    n.extend && n.extend(e, t);
  r.domObserver.setCurSelection();
  let { state: i } = r;
  setTimeout(() => {
    r.state == i && en(r);
  }, 50);
}
function Ec(r, e, t) {
  let n = r.state.selection;
  if (n instanceof oe && !n.empty || t.indexOf("s") > -1 || ht && t.indexOf("m") > -1)
    return !1;
  let { $from: i, $to: o } = n;
  if (!i.parent.inlineContent || r.endOfTextblock(e < 0 ? "up" : "down")) {
    let a = Ja(r.state, e);
    if (a && a instanceof te)
      return Rn(r, a);
  }
  if (!i.parent.inlineContent) {
    let a = e < 0 ? i : o, s = n instanceof We ? ie.near(a, e) : ie.findFrom(a, e);
    return s ? Rn(r, s) : !1;
  }
  return !1;
}
function Ac(r, e) {
  if (!(r.state.selection instanceof oe))
    return !0;
  let { $head: t, $anchor: n, empty: i } = r.state.selection;
  if (!t.sameParent(n))
    return !0;
  if (!i)
    return !1;
  if (r.endOfTextblock(e > 0 ? "forward" : "backward"))
    return !0;
  let o = !t.textOffset && (e < 0 ? t.nodeBefore : t.nodeAfter);
  if (o && !o.isText) {
    let a = r.state.tr;
    return e < 0 ? a.delete(t.pos - o.nodeSize, t.pos) : a.delete(t.pos, t.pos + o.nodeSize), r.dispatch(a), !0;
  }
  return !1;
}
function Nc(r, e, t) {
  r.domObserver.stop(), e.contentEditable = t, r.domObserver.start();
}
function Nb(r) {
  if (!Ye || r.state.selection.$head.parentOffset > 0)
    return !1;
  let { focusNode: e, focusOffset: t } = r.domSelectionRange();
  if (e && e.nodeType == 1 && t == 0 && e.firstChild && e.firstChild.contentEditable == "false") {
    let n = e.firstChild;
    Nc(r, n, "true"), setTimeout(() => Nc(r, n, "false"), 20);
  }
  return !1;
}
function Rb(r) {
  let e = "";
  return r.ctrlKey && (e += "c"), r.metaKey && (e += "m"), r.altKey && (e += "a"), r.shiftKey && (e += "s"), e;
}
function Pb(r, e) {
  let t = e.keyCode, n = Rb(e);
  return t == 8 || ht && t == 72 && n == "c" ? Ac(r, -1) || oa(r) : t == 46 || ht && t == 68 && n == "c" ? Ac(r, 1) || aa(r) : t == 13 || t == 27 ? !0 : t == 37 || ht && t == 66 && n == "c" ? Dc(r, -1, n) || oa(r) : t == 39 || ht && t == 70 && n == "c" ? Dc(r, 1, n) || aa(r) : t == 38 || ht && t == 80 && n == "c" ? Ec(r, -1, n) || oa(r) : t == 40 || ht && t == 78 && n == "c" ? Nb(r) || Ec(r, 1, n) || aa(r) : n == (ht ? "m" : "c") && (t == 66 || t == 73 || t == 89 || t == 90);
}
function kh(r, e) {
  r.someProp("transformCopied", (d) => {
    e = d(e, r);
  });
  let t = [], { content: n, openStart: i, openEnd: o } = e;
  for (; i > 1 && o > 1 && n.childCount == 1 && n.firstChild.childCount == 1; ) {
    i--, o--;
    let d = n.firstChild;
    t.push(d.type.name, d.attrs != d.type.defaultAttrs ? d.attrs : null), n = d.content;
  }
  let a = r.someProp("clipboardSerializer") || Bt.fromSchema(r.state.schema), s = Ih(), l = s.createElement("div");
  l.appendChild(a.serializeFragment(n, { document: s }));
  let c = l.firstChild, u, f = 0;
  for (; c && c.nodeType == 1 && (u = _h[c.nodeName.toLowerCase()]); ) {
    for (let d = u.length - 1; d >= 0; d--) {
      let p = s.createElement(u[d]);
      for (; l.firstChild; )
        p.appendChild(l.firstChild);
      l.appendChild(p), f++;
    }
    c = l.firstChild;
  }
  c && c.nodeType == 1 && c.setAttribute("data-pm-slice", `${i} ${o}${f ? ` -${f}` : ""} ${JSON.stringify(t)}`);
  let h = r.someProp("clipboardTextSerializer", (d) => d(e, r)) || e.content.textBetween(0, e.content.size, `

`);
  return { dom: l, text: h };
}
function xh(r, e, t, n, i) {
  let o = i.parent.type.spec.code, a, s;
  if (!t && !e)
    return null;
  let l = e && (n || o || !t);
  if (l) {
    if (r.someProp("transformPastedText", (h) => {
      e = h(e, o || n, r);
    }), o)
      return e ? new $(I.from(r.state.schema.text(e.replace(/\r\n?/g, `
`))), 0, 0) : $.empty;
    let f = r.someProp("clipboardTextParser", (h) => h(e, i, n, r));
    if (f)
      s = f;
    else {
      let h = i.marks(), { schema: d } = r.state, p = Bt.fromSchema(d);
      a = document.createElement("div"), e.split(/(?:\r\n?|\n)+/).forEach((m) => {
        let v = a.appendChild(document.createElement("p"));
        m && v.appendChild(p.serializeNode(d.text(m, h)));
      });
    }
  } else
    r.someProp("transformPastedHTML", (f) => {
      t = f(t, r);
    }), a = zb(t), yo && Bb(a);
  let c = a && a.querySelector("[data-pm-slice]"), u = c && /^(\d+) (\d+)(?: -(\d+))? (.*)/.exec(c.getAttribute("data-pm-slice") || "");
  if (u && u[3])
    for (let f = +u[3]; f > 0; f--) {
      let h = a.firstChild;
      for (; h && h.nodeType != 1; )
        h = h.nextSibling;
      if (!h)
        break;
      a = h;
    }
  if (s || (s = (r.someProp("clipboardParser") || r.someProp("domParser") || Hs.fromSchema(r.state.schema)).parseSlice(a, {
    preserveWhitespace: !!(l || u),
    context: i,
    ruleFromNode(h) {
      return h.nodeName == "BR" && !h.nextSibling && h.parentNode && !Lb.test(h.parentNode.nodeName) ? { ignore: !0 } : null;
    }
  })), u)
    s = $b(Rc(s, +u[1], +u[2]), u[4]);
  else if (s = $.maxOpen(Fb(s.content, i), !0), s.openStart || s.openEnd) {
    let f = 0, h = 0;
    for (let d = s.content.firstChild; f < s.openStart && !d.type.spec.isolating; f++, d = d.firstChild)
      ;
    for (let d = s.content.lastChild; h < s.openEnd && !d.type.spec.isolating; h++, d = d.lastChild)
      ;
    s = Rc(s, f, h);
  }
  return r.someProp("transformPasted", (f) => {
    s = f(s, r);
  }), s;
}
const Lb = /^(a|abbr|acronym|b|cite|code|del|em|i|ins|kbd|label|output|q|ruby|s|samp|span|strong|sub|sup|time|u|tt|var)$/i;
function Fb(r, e) {
  if (r.childCount < 2)
    return r;
  for (let t = e.depth; t >= 0; t--) {
    let i = e.node(t).contentMatchAt(e.index(t)), o, a = [];
    if (r.forEach((s) => {
      if (!a)
        return;
      let l = i.findWrapping(s.type), c;
      if (!l)
        return a = null;
      if (c = a.length && o.length && Th(l, o, s, a[a.length - 1], 0))
        a[a.length - 1] = c;
      else {
        a.length && (a[a.length - 1] = Mh(a[a.length - 1], o.length));
        let u = Oh(s, l);
        a.push(u), i = i.matchType(u.type), o = l;
      }
    }), a)
      return I.from(a);
  }
  return r;
}
function Oh(r, e, t = 0) {
  for (let n = e.length - 1; n >= t; n--)
    r = e[n].create(null, I.from(r));
  return r;
}
function Th(r, e, t, n, i) {
  if (i < r.length && i < e.length && r[i] == e[i]) {
    let o = Th(r, e, t, n.lastChild, i + 1);
    if (o)
      return n.copy(n.content.replaceChild(n.childCount - 1, o));
    if (n.contentMatchAt(n.childCount).matchType(i == r.length - 1 ? t.type : r[i + 1]))
      return n.copy(n.content.append(I.from(Oh(t, r, i + 1))));
  }
}
function Mh(r, e) {
  if (e == 0)
    return r;
  let t = r.content.replaceChild(r.childCount - 1, Mh(r.lastChild, e - 1)), n = r.contentMatchAt(r.childCount).fillBefore(I.empty, !0);
  return r.copy(t.append(n));
}
function Ya(r, e, t, n, i, o) {
  let a = e < 0 ? r.firstChild : r.lastChild, s = a.content;
  return i < n - 1 && (s = Ya(s, e, t, n, i + 1, o)), i >= t && (s = e < 0 ? a.contentMatchAt(0).fillBefore(s, r.childCount > 1 || o <= i).append(s) : s.append(a.contentMatchAt(a.childCount).fillBefore(I.empty, !0))), r.replaceChild(e < 0 ? 0 : r.childCount - 1, a.copy(s));
}
function Rc(r, e, t) {
  return e < r.openStart && (r = new $(Ya(r.content, -1, e, r.openStart, 0, r.openEnd), e, r.openEnd)), t < r.openEnd && (r = new $(Ya(r.content, 1, t, r.openEnd, 0, 0), r.openStart, t)), r;
}
const _h = {
  thead: ["table"],
  tbody: ["table"],
  tfoot: ["table"],
  caption: ["table"],
  colgroup: ["table"],
  col: ["table", "colgroup"],
  tr: ["table", "tbody"],
  td: ["table", "tbody", "tr"],
  th: ["table", "tbody", "tr"]
};
let Pc = null;
function Ih() {
  return Pc || (Pc = document.implementation.createHTMLDocument("title"));
}
function zb(r) {
  let e = /^(\s*<meta [^>]*>)*/.exec(r);
  e && (r = r.slice(e[0].length));
  let t = Ih().createElement("div"), n = /<([a-z][^>\s]+)/i.exec(r), i;
  if ((i = n && _h[n[1].toLowerCase()]) && (r = i.map((o) => "<" + o + ">").join("") + r + i.map((o) => "</" + o + ">").reverse().join("")), t.innerHTML = r, i)
    for (let o = 0; o < i.length; o++)
      t = t.querySelector(i[o]) || t;
  return t;
}
function Bb(r) {
  let e = r.querySelectorAll(Ke ? "span:not([class]):not([style])" : "span.Apple-converted-space");
  for (let t = 0; t < e.length; t++) {
    let n = e[t];
    n.childNodes.length == 1 && n.textContent == " " && n.parentNode && n.parentNode.replaceChild(r.ownerDocument.createTextNode(" "), n);
  }
}
function $b(r, e) {
  if (!r.size)
    return r;
  let t = r.content.firstChild.type.schema, n;
  try {
    n = JSON.parse(e);
  } catch {
    return r;
  }
  let { content: i, openStart: o, openEnd: a } = r;
  for (let s = n.length - 2; s >= 0; s -= 2) {
    let l = t.nodes[n[s]];
    if (!l || l.hasRequiredAttrs())
      break;
    i = I.from(l.create(n[s + 1], i)), o++, a++;
  }
  return new $(i, o, a);
}
const Ze = {}, Qe = {}, Hb = { touchstart: !0, touchmove: !0 };
class jb {
  constructor() {
    this.shiftKey = !1, this.mouseDown = null, this.lastKeyCode = null, this.lastKeyCodeTime = 0, this.lastClick = { time: 0, x: 0, y: 0, type: "" }, this.lastSelectionOrigin = null, this.lastSelectionTime = 0, this.lastIOSEnter = 0, this.lastIOSEnterFallbackTimeout = -1, this.lastFocus = 0, this.lastTouch = 0, this.lastAndroidDelete = 0, this.composing = !1, this.composingTimeout = -1, this.compositionNodes = [], this.compositionEndedAt = -2e8, this.domChangeCount = 0, this.eventHandlers = /* @__PURE__ */ Object.create(null), this.hideSelectionGuard = null;
  }
}
function Wb(r) {
  for (let e in Ze) {
    let t = Ze[e];
    r.dom.addEventListener(e, r.input.eventHandlers[e] = (n) => {
      Ub(r, n) && !nl(r, n) && (r.editable || !(n.type in Qe)) && t(r, n);
    }, Hb[e] ? { passive: !0 } : void 0);
  }
  Ye && r.dom.addEventListener("input", () => null), Za(r);
}
function gn(r, e) {
  r.input.lastSelectionOrigin = e, r.input.lastSelectionTime = Date.now();
}
function Vb(r) {
  r.domObserver.stop();
  for (let e in r.input.eventHandlers)
    r.dom.removeEventListener(e, r.input.eventHandlers[e]);
  clearTimeout(r.input.composingTimeout), clearTimeout(r.input.lastIOSEnterFallbackTimeout);
}
function Za(r) {
  r.someProp("handleDOMEvents", (e) => {
    for (let t in e)
      r.input.eventHandlers[t] || r.dom.addEventListener(t, r.input.eventHandlers[t] = (n) => nl(r, n));
  });
}
function nl(r, e) {
  return r.someProp("handleDOMEvents", (t) => {
    let n = t[e.type];
    return n ? n(r, e) || e.defaultPrevented : !1;
  });
}
function Ub(r, e) {
  if (!e.bubbles)
    return !0;
  if (e.defaultPrevented)
    return !1;
  for (let t = e.target; t != r.dom; t = t.parentNode)
    if (!t || t.nodeType == 11 || t.pmViewDesc && t.pmViewDesc.stopEvent(e))
      return !1;
  return !0;
}
function qb(r, e) {
  !nl(r, e) && Ze[e.type] && (r.editable || !(e.type in Qe)) && Ze[e.type](r, e);
}
Qe.keydown = (r, e) => {
  let t = e;
  if (r.input.shiftKey = t.keyCode == 16 || t.shiftKey, !Eh(r, t) && (r.input.lastKeyCode = t.keyCode, r.input.lastKeyCodeTime = Date.now(), !(Mt && Ke && t.keyCode == 13)))
    if (t.keyCode != 229 && r.domObserver.forceFlush(), Cr && t.keyCode == 13 && !t.ctrlKey && !t.altKey && !t.metaKey) {
      let n = Date.now();
      r.input.lastIOSEnter = n, r.input.lastIOSEnterFallbackTimeout = setTimeout(() => {
        r.input.lastIOSEnter == n && (r.someProp("handleKeyDown", (i) => i(r, Nn(13, "Enter"))), r.input.lastIOSEnter = 0);
      }, 200);
    } else
      r.someProp("handleKeyDown", (n) => n(r, t)) || Pb(r, t) ? t.preventDefault() : gn(r, "key");
};
Qe.keyup = (r, e) => {
  e.keyCode == 16 && (r.input.shiftKey = !1);
};
Qe.keypress = (r, e) => {
  let t = e;
  if (Eh(r, t) || !t.charCode || t.ctrlKey && !t.altKey || ht && t.metaKey)
    return;
  if (r.someProp("handleKeyPress", (i) => i(r, t))) {
    t.preventDefault();
    return;
  }
  let n = r.state.selection;
  if (!(n instanceof oe) || !n.$from.sameParent(n.$to)) {
    let i = String.fromCharCode(t.charCode);
    !/[\r\n]/.test(i) && !r.someProp("handleTextInput", (o) => o(r, n.$from.pos, n.$to.pos, i)) && r.dispatch(r.state.tr.insertText(i).scrollIntoView()), t.preventDefault();
  }
};
function bo(r) {
  return { left: r.clientX, top: r.clientY };
}
function Kb(r, e) {
  let t = e.x - r.clientX, n = e.y - r.clientY;
  return t * t + n * n < 100;
}
function rl(r, e, t, n, i) {
  if (n == -1)
    return !1;
  let o = r.state.doc.resolve(n);
  for (let a = o.depth + 1; a > 0; a--)
    if (r.someProp(e, (s) => a > o.depth ? s(r, t, o.nodeAfter, o.before(a), i, !0) : s(r, t, o.node(a), o.before(a), i, !1)))
      return !0;
  return !1;
}
function pr(r, e, t) {
  r.focused || r.focus();
  let n = r.state.tr.setSelection(e);
  t == "pointer" && n.setMeta("pointer", !0), r.dispatch(n);
}
function Gb(r, e) {
  if (e == -1)
    return !1;
  let t = r.state.doc.resolve(e), n = t.nodeAfter;
  return n && n.isAtom && te.isSelectable(n) ? (pr(r, new te(t), "pointer"), !0) : !1;
}
function Jb(r, e) {
  if (e == -1)
    return !1;
  let t = r.state.selection, n, i;
  t instanceof te && (n = t.node);
  let o = r.state.doc.resolve(e);
  for (let a = o.depth + 1; a > 0; a--) {
    let s = a > o.depth ? o.nodeAfter : o.node(a);
    if (te.isSelectable(s)) {
      n && t.$from.depth > 0 && a >= t.$from.depth && o.before(t.$from.depth + 1) == t.$from.pos ? i = o.before(t.$from.depth) : i = o.before(a);
      break;
    }
  }
  return i != null ? (pr(r, te.create(r.state.doc, i), "pointer"), !0) : !1;
}
function Xb(r, e, t, n, i) {
  return rl(r, "handleClickOn", e, t, n) || r.someProp("handleClick", (o) => o(r, e, n)) || (i ? Jb(r, t) : Gb(r, t));
}
function Yb(r, e, t, n) {
  return rl(r, "handleDoubleClickOn", e, t, n) || r.someProp("handleDoubleClick", (i) => i(r, e, n));
}
function Zb(r, e, t, n) {
  return rl(r, "handleTripleClickOn", e, t, n) || r.someProp("handleTripleClick", (i) => i(r, e, n)) || Qb(r, t, n);
}
function Qb(r, e, t) {
  if (t.button != 0)
    return !1;
  let n = r.state.doc;
  if (e == -1)
    return n.inlineContent ? (pr(r, oe.create(n, 0, n.content.size), "pointer"), !0) : !1;
  let i = n.resolve(e);
  for (let o = i.depth + 1; o > 0; o--) {
    let a = o > i.depth ? i.nodeAfter : i.node(o), s = i.before(o);
    if (a.inlineContent)
      pr(r, oe.create(n, s + 1, s + 1 + a.content.size), "pointer");
    else if (te.isSelectable(a))
      pr(r, te.create(n, s), "pointer");
    else
      continue;
    return !0;
  }
}
function il(r) {
  return Ki(r);
}
const Dh = ht ? "metaKey" : "ctrlKey";
Ze.mousedown = (r, e) => {
  let t = e;
  r.input.shiftKey = t.shiftKey;
  let n = il(r), i = Date.now(), o = "singleClick";
  i - r.input.lastClick.time < 500 && Kb(t, r.input.lastClick) && !t[Dh] && (r.input.lastClick.type == "singleClick" ? o = "doubleClick" : r.input.lastClick.type == "doubleClick" && (o = "tripleClick")), r.input.lastClick = { time: i, x: t.clientX, y: t.clientY, type: o };
  let a = r.posAtCoords(bo(t));
  a && (o == "singleClick" ? (r.input.mouseDown && r.input.mouseDown.done(), r.input.mouseDown = new eS(r, a, t, !!n)) : (o == "doubleClick" ? Yb : Zb)(r, a.pos, a.inside, t) ? t.preventDefault() : gn(r, "pointer"));
};
class eS {
  constructor(e, t, n, i) {
    this.view = e, this.pos = t, this.event = n, this.flushed = i, this.delayedSelectionSync = !1, this.mightDrag = null, this.startDoc = e.state.doc, this.selectNode = !!n[Dh], this.allowDefault = n.shiftKey;
    let o, a;
    if (t.inside > -1)
      o = e.state.doc.nodeAt(t.inside), a = t.inside;
    else {
      let u = e.state.doc.resolve(t.pos);
      o = u.parent, a = u.depth ? u.before() : 0;
    }
    const s = i ? null : n.target, l = s ? e.docView.nearestDesc(s, !0) : null;
    this.target = l ? l.dom : null;
    let { selection: c } = e.state;
    (n.button == 0 && o.type.spec.draggable && o.type.spec.selectable !== !1 || c instanceof te && c.from <= a && c.to > a) && (this.mightDrag = {
      node: o,
      pos: a,
      addAttr: !!(this.target && !this.target.draggable),
      setUneditable: !!(this.target && Dt && !this.target.hasAttribute("contentEditable"))
    }), this.target && this.mightDrag && (this.mightDrag.addAttr || this.mightDrag.setUneditable) && (this.view.domObserver.stop(), this.mightDrag.addAttr && (this.target.draggable = !0), this.mightDrag.setUneditable && setTimeout(() => {
      this.view.input.mouseDown == this && this.target.setAttribute("contentEditable", "false");
    }, 20), this.view.domObserver.start()), e.root.addEventListener("mouseup", this.up = this.up.bind(this)), e.root.addEventListener("mousemove", this.move = this.move.bind(this)), gn(e, "pointer");
  }
  done() {
    this.view.root.removeEventListener("mouseup", this.up), this.view.root.removeEventListener("mousemove", this.move), this.mightDrag && this.target && (this.view.domObserver.stop(), this.mightDrag.addAttr && this.target.removeAttribute("draggable"), this.mightDrag.setUneditable && this.target.removeAttribute("contentEditable"), this.view.domObserver.start()), this.delayedSelectionSync && setTimeout(() => en(this.view)), this.view.input.mouseDown = null;
  }
  up(e) {
    if (this.done(), !this.view.dom.contains(e.target))
      return;
    let t = this.pos;
    this.view.state.doc != this.startDoc && (t = this.view.posAtCoords(bo(e))), this.updateAllowDefault(e), this.allowDefault || !t ? gn(this.view, "pointer") : Xb(this.view, t.pos, t.inside, e, this.selectNode) ? e.preventDefault() : e.button == 0 && (this.flushed || // Safari ignores clicks on draggable elements
    Ye && this.mightDrag && !this.mightDrag.node.isAtom || // Chrome will sometimes treat a node selection as a
    // cursor, but still report that the node is selected
    // when asked through getSelection. You'll then get a
    // situation where clicking at the point where that
    // (hidden) cursor is doesn't change the selection, and
    // thus doesn't get a reaction from ProseMirror. This
    // works around that.
    Ke && !this.view.state.selection.visible && Math.min(Math.abs(t.pos - this.view.state.selection.from), Math.abs(t.pos - this.view.state.selection.to)) <= 2) ? (pr(this.view, ie.near(this.view.state.doc.resolve(t.pos)), "pointer"), e.preventDefault()) : gn(this.view, "pointer");
  }
  move(e) {
    this.updateAllowDefault(e), gn(this.view, "pointer"), e.buttons == 0 && this.done();
  }
  updateAllowDefault(e) {
    !this.allowDefault && (Math.abs(this.event.x - e.clientX) > 4 || Math.abs(this.event.y - e.clientY) > 4) && (this.allowDefault = !0);
  }
}
Ze.touchstart = (r) => {
  r.input.lastTouch = Date.now(), il(r), gn(r, "pointer");
};
Ze.touchmove = (r) => {
  r.input.lastTouch = Date.now(), gn(r, "pointer");
};
Ze.contextmenu = (r) => il(r);
function Eh(r, e) {
  return r.composing ? !0 : Ye && Math.abs(e.timeStamp - r.input.compositionEndedAt) < 500 ? (r.input.compositionEndedAt = -2e8, !0) : !1;
}
const tS = Mt ? 5e3 : -1;
Qe.compositionstart = Qe.compositionupdate = (r) => {
  if (!r.composing) {
    r.domObserver.flush();
    let { state: e } = r, t = e.selection.$from;
    if (e.selection.empty && (e.storedMarks || !t.textOffset && t.parentOffset && t.nodeBefore.marks.some((n) => n.type.spec.inclusive === !1)))
      r.markCursor = r.state.storedMarks || t.marks(), Ki(r, !0), r.markCursor = null;
    else if (Ki(r), Dt && e.selection.empty && t.parentOffset && !t.textOffset && t.nodeBefore.marks.length) {
      let n = r.domSelectionRange();
      for (let i = n.focusNode, o = n.focusOffset; i && i.nodeType == 1 && o != 0; ) {
        let a = o < 0 ? i.lastChild : i.childNodes[o - 1];
        if (!a)
          break;
        if (a.nodeType == 3) {
          r.domSelection().collapse(a, a.nodeValue.length);
          break;
        } else
          i = a, o = -1;
      }
    }
    r.input.composing = !0;
  }
  Ah(r, tS);
};
Qe.compositionend = (r, e) => {
  r.composing && (r.input.composing = !1, r.input.compositionEndedAt = e.timeStamp, Ah(r, 20));
};
function Ah(r, e) {
  clearTimeout(r.input.composingTimeout), e > -1 && (r.input.composingTimeout = setTimeout(() => Ki(r), e));
}
function Nh(r) {
  for (r.composing && (r.input.composing = !1, r.input.compositionEndedAt = nS()); r.input.compositionNodes.length > 0; )
    r.input.compositionNodes.pop().markParentsDirty();
}
function nS() {
  let r = document.createEvent("Event");
  return r.initEvent("event", !0, !0), r.timeStamp;
}
function Ki(r, e = !1) {
  if (!(Mt && r.domObserver.flushingSoon >= 0)) {
    if (r.domObserver.forceFlush(), Nh(r), e || r.docView && r.docView.dirty) {
      let t = el(r);
      return t && !t.eq(r.state.selection) ? r.dispatch(r.state.tr.setSelection(t)) : r.updateState(r.state), !0;
    }
    return !1;
  }
}
function rS(r, e) {
  if (!r.dom.parentNode)
    return;
  let t = r.dom.parentNode.appendChild(document.createElement("div"));
  t.appendChild(e), t.style.cssText = "position: fixed; left: -10000px; top: 10px";
  let n = getSelection(), i = document.createRange();
  i.selectNodeContents(e), r.dom.blur(), n.removeAllRanges(), n.addRange(i), setTimeout(() => {
    t.parentNode && t.parentNode.removeChild(t), r.focus();
  }, 50);
}
const kr = nt && wn < 15 || Cr && ib < 604;
Ze.copy = Qe.cut = (r, e) => {
  let t = e, n = r.state.selection, i = t.type == "cut";
  if (n.empty)
    return;
  let o = kr ? null : t.clipboardData, a = n.content(), { dom: s, text: l } = kh(r, a);
  o ? (t.preventDefault(), o.clearData(), o.setData("text/html", s.innerHTML), o.setData("text/plain", l)) : rS(r, s), i && r.dispatch(r.state.tr.deleteSelection().scrollIntoView().setMeta("uiEvent", "cut"));
};
function iS(r) {
  return r.openStart == 0 && r.openEnd == 0 && r.content.childCount == 1 ? r.content.firstChild : null;
}
function oS(r, e) {
  if (!r.dom.parentNode)
    return;
  let t = r.input.shiftKey || r.state.selection.$from.parent.type.spec.code, n = r.dom.parentNode.appendChild(document.createElement(t ? "textarea" : "div"));
  t || (n.contentEditable = "true"), n.style.cssText = "position: fixed; left: -10000px; top: 10px", n.focus(), setTimeout(() => {
    r.focus(), n.parentNode && n.parentNode.removeChild(n), t ? ei(r, n.value, null, r.input.shiftKey, e) : ei(r, n.textContent, n.innerHTML, r.input.shiftKey, e);
  }, 50);
}
function ei(r, e, t, n, i) {
  let o = xh(r, e, t, n, r.state.selection.$from);
  if (r.someProp("handlePaste", (l) => l(r, i, o || $.empty)))
    return !0;
  if (!o)
    return !1;
  let a = iS(o), s = a ? r.state.tr.replaceSelectionWith(a, r.input.shiftKey) : r.state.tr.replaceSelection(o);
  return r.dispatch(s.scrollIntoView().setMeta("paste", !0).setMeta("uiEvent", "paste")), !0;
}
Qe.paste = (r, e) => {
  let t = e;
  if (r.composing && !Mt)
    return;
  let n = kr ? null : t.clipboardData;
  n && ei(r, n.getData("text/plain"), n.getData("text/html"), r.input.shiftKey, t) ? t.preventDefault() : oS(r, t);
};
class aS {
  constructor(e, t) {
    this.slice = e, this.move = t;
  }
}
const Rh = ht ? "altKey" : "ctrlKey";
Ze.dragstart = (r, e) => {
  let t = e, n = r.input.mouseDown;
  if (n && n.done(), !t.dataTransfer)
    return;
  let i = r.state.selection, o = i.empty ? null : r.posAtCoords(bo(t));
  if (!(o && o.pos >= i.from && o.pos <= (i instanceof te ? i.to - 1 : i.to))) {
    if (n && n.mightDrag)
      r.dispatch(r.state.tr.setSelection(te.create(r.state.doc, n.mightDrag.pos)));
    else if (t.target && t.target.nodeType == 1) {
      let c = r.docView.nearestDesc(t.target, !0);
      c && c.node.type.spec.draggable && c != r.docView && r.dispatch(r.state.tr.setSelection(te.create(r.state.doc, c.posBefore)));
    }
  }
  let a = r.state.selection.content(), { dom: s, text: l } = kh(r, a);
  t.dataTransfer.clearData(), t.dataTransfer.setData(kr ? "Text" : "text/html", s.innerHTML), t.dataTransfer.effectAllowed = "copyMove", kr || t.dataTransfer.setData("text/plain", l), r.dragging = new aS(a, !t[Rh]);
};
Ze.dragend = (r) => {
  let e = r.dragging;
  window.setTimeout(() => {
    r.dragging == e && (r.dragging = null);
  }, 50);
};
Qe.dragover = Qe.dragenter = (r, e) => e.preventDefault();
Qe.drop = (r, e) => {
  let t = e, n = r.dragging;
  if (r.dragging = null, !t.dataTransfer)
    return;
  let i = r.posAtCoords(bo(t));
  if (!i)
    return;
  let o = r.state.doc.resolve(i.pos), a = n && n.slice;
  a ? r.someProp("transformPasted", (p) => {
    a = p(a, r);
  }) : a = xh(r, t.dataTransfer.getData(kr ? "Text" : "text/plain"), kr ? null : t.dataTransfer.getData("text/html"), !1, o);
  let s = !!(n && !t[Rh]);
  if (r.someProp("handleDrop", (p) => p(r, t, a || $.empty, s))) {
    t.preventDefault();
    return;
  }
  if (!a)
    return;
  t.preventDefault();
  let l = a ? yf(r.state.doc, o.pos, a) : o.pos;
  l == null && (l = o.pos);
  let c = r.state.tr;
  s && c.deleteSelection();
  let u = c.mapping.map(l), f = a.openStart == 0 && a.openEnd == 0 && a.content.childCount == 1, h = c.doc;
  if (f ? c.replaceRangeWith(u, u, a.content.firstChild) : c.replaceRange(u, u, a), c.doc.eq(h))
    return;
  let d = c.doc.resolve(u);
  if (f && te.isSelectable(a.content.firstChild) && d.nodeAfter && d.nodeAfter.sameMarkup(a.content.firstChild))
    c.setSelection(new te(d));
  else {
    let p = c.mapping.map(l);
    c.mapping.maps[c.mapping.maps.length - 1].forEach((m, v, y, b) => p = b), c.setSelection(tl(r, d, c.doc.resolve(p)));
  }
  r.focus(), r.dispatch(c.setMeta("uiEvent", "drop"));
};
Ze.focus = (r) => {
  r.input.lastFocus = Date.now(), r.focused || (r.domObserver.stop(), r.dom.classList.add("ProseMirror-focused"), r.domObserver.start(), r.focused = !0, setTimeout(() => {
    r.docView && r.hasFocus() && !r.domObserver.currentSelection.eq(r.domSelectionRange()) && en(r);
  }, 20));
};
Ze.blur = (r, e) => {
  let t = e;
  r.focused && (r.domObserver.stop(), r.dom.classList.remove("ProseMirror-focused"), r.domObserver.start(), t.relatedTarget && r.dom.contains(t.relatedTarget) && r.domObserver.currentSelection.clear(), r.focused = !1);
};
Ze.beforeinput = (r, e) => {
  if (Ke && Mt && e.inputType == "deleteContentBackward") {
    r.domObserver.flushSoon();
    let { domChangeCount: n } = r.input;
    setTimeout(() => {
      if (r.input.domChangeCount != n || (r.dom.blur(), r.focus(), r.someProp("handleKeyDown", (o) => o(r, Nn(8, "Backspace")))))
        return;
      let { $cursor: i } = r.state.selection;
      i && i.pos > 0 && r.dispatch(r.state.tr.delete(i.pos - 1, i.pos).scrollIntoView());
    }, 50);
  }
};
for (let r in Qe)
  Ze[r] = Qe[r];
function ti(r, e) {
  if (r == e)
    return !0;
  for (let t in r)
    if (r[t] !== e[t])
      return !1;
  for (let t in e)
    if (!(t in r))
      return !1;
  return !0;
}
class ol {
  constructor(e, t) {
    this.toDOM = e, this.spec = t || jn, this.side = this.spec.side || 0;
  }
  map(e, t, n, i) {
    let { pos: o, deleted: a } = e.mapResult(t.from + i, this.side < 0 ? -1 : 1);
    return a ? null : new Ae(o - n, o - n, this);
  }
  valid() {
    return !0;
  }
  eq(e) {
    return this == e || e instanceof ol && (this.spec.key && this.spec.key == e.spec.key || this.toDOM == e.toDOM && ti(this.spec, e.spec));
  }
  destroy(e) {
    this.spec.destroy && this.spec.destroy(e);
  }
}
class bn {
  constructor(e, t) {
    this.attrs = e, this.spec = t || jn;
  }
  map(e, t, n, i) {
    let o = e.map(t.from + i, this.spec.inclusiveStart ? -1 : 1) - n, a = e.map(t.to + i, this.spec.inclusiveEnd ? 1 : -1) - n;
    return o >= a ? null : new Ae(o, a, this);
  }
  valid(e, t) {
    return t.from < t.to;
  }
  eq(e) {
    return this == e || e instanceof bn && ti(this.attrs, e.attrs) && ti(this.spec, e.spec);
  }
  static is(e) {
    return e.type instanceof bn;
  }
  destroy() {
  }
}
class al {
  constructor(e, t) {
    this.attrs = e, this.spec = t || jn;
  }
  map(e, t, n, i) {
    let o = e.mapResult(t.from + i, 1);
    if (o.deleted)
      return null;
    let a = e.mapResult(t.to + i, -1);
    return a.deleted || a.pos <= o.pos ? null : new Ae(o.pos - n, a.pos - n, this);
  }
  valid(e, t) {
    let { index: n, offset: i } = e.content.findIndex(t.from), o;
    return i == t.from && !(o = e.child(n)).isText && i + o.nodeSize == t.to;
  }
  eq(e) {
    return this == e || e instanceof al && ti(this.attrs, e.attrs) && ti(this.spec, e.spec);
  }
  destroy() {
  }
}
class Ae {
  /**
  @internal
  */
  constructor(e, t, n) {
    this.from = e, this.to = t, this.type = n;
  }
  /**
  @internal
  */
  copy(e, t) {
    return new Ae(e, t, this.type);
  }
  /**
  @internal
  */
  eq(e, t = 0) {
    return this.type.eq(e.type) && this.from + t == e.from && this.to + t == e.to;
  }
  /**
  @internal
  */
  map(e, t, n) {
    return this.type.map(e, this, t, n);
  }
  /**
  Creates a widget decoration, which is a DOM node that's shown in
  the document at the given position. It is recommended that you
  delay rendering the widget by passing a function that will be
  called when the widget is actually drawn in a view, but you can
  also directly pass a DOM node. `getPos` can be used to find the
  widget's current document position.
  */
  static widget(e, t, n) {
    return new Ae(e, e, new ol(t, n));
  }
  /**
  Creates an inline decoration, which adds the given attributes to
  each inline node between `from` and `to`.
  */
  static inline(e, t, n, i) {
    return new Ae(e, t, new bn(n, i));
  }
  /**
  Creates a node decoration. `from` and `to` should point precisely
  before and after a node in the document. That node, and only that
  node, will receive the given attributes.
  */
  static node(e, t, n, i) {
    return new Ae(e, t, new al(n, i));
  }
  /**
  The spec provided when creating this decoration. Can be useful
  if you've stored extra information in that object.
  */
  get spec() {
    return this.type.spec;
  }
  /**
  @internal
  */
  get inline() {
    return this.type instanceof bn;
  }
}
const ir = [], jn = {};
class fe {
  /**
  @internal
  */
  constructor(e, t) {
    this.local = e.length ? e : ir, this.children = t.length ? t : ir;
  }
  /**
  Create a set of decorations, using the structure of the given
  document.
  */
  static create(e, t) {
    return t.length ? Gi(t, e, 0, jn) : je;
  }
  /**
  Find all decorations in this set which touch the given range
  (including decorations that start or end directly at the
  boundaries) and match the given predicate on their spec. When
  `start` and `end` are omitted, all decorations in the set are
  considered. When `predicate` isn't given, all decorations are
  assumed to match.
  */
  find(e, t, n) {
    let i = [];
    return this.findInner(e ?? 0, t ?? 1e9, i, 0, n), i;
  }
  findInner(e, t, n, i, o) {
    for (let a = 0; a < this.local.length; a++) {
      let s = this.local[a];
      s.from <= t && s.to >= e && (!o || o(s.spec)) && n.push(s.copy(s.from + i, s.to + i));
    }
    for (let a = 0; a < this.children.length; a += 3)
      if (this.children[a] < t && this.children[a + 1] > e) {
        let s = this.children[a] + 1;
        this.children[a + 2].findInner(e - s, t - s, n, i + s, o);
      }
  }
  /**
  Map the set of decorations in response to a change in the
  document.
  */
  map(e, t, n) {
    return this == je || e.maps.length == 0 ? this : this.mapInner(e, t, 0, 0, n || jn);
  }
  /**
  @internal
  */
  mapInner(e, t, n, i, o) {
    let a;
    for (let s = 0; s < this.local.length; s++) {
      let l = this.local[s].map(e, n, i);
      l && l.type.valid(t, l) ? (a || (a = [])).push(l) : o.onRemove && o.onRemove(this.local[s].spec);
    }
    return this.children.length ? sS(this.children, a || [], e, t, n, i, o) : a ? new fe(a.sort(Wn), ir) : je;
  }
  /**
  Add the given array of decorations to the ones in the set,
  producing a new set. Needs access to the current document to
  create the appropriate tree structure.
  */
  add(e, t) {
    return t.length ? this == je ? fe.create(e, t) : this.addInner(e, t, 0) : this;
  }
  addInner(e, t, n) {
    let i, o = 0;
    e.forEach((s, l) => {
      let c = l + n, u;
      if (u = Lh(t, s, c)) {
        for (i || (i = this.children.slice()); o < i.length && i[o] < l; )
          o += 3;
        i[o] == l ? i[o + 2] = i[o + 2].addInner(s, u, c + 1) : i.splice(o, 0, l, l + s.nodeSize, Gi(u, s, c + 1, jn)), o += 3;
      }
    });
    let a = Ph(o ? Fh(t) : t, -n);
    for (let s = 0; s < a.length; s++)
      a[s].type.valid(e, a[s]) || a.splice(s--, 1);
    return new fe(a.length ? this.local.concat(a).sort(Wn) : this.local, i || this.children);
  }
  /**
  Create a new set that contains the decorations in this set, minus
  the ones in the given array.
  */
  remove(e) {
    return e.length == 0 || this == je ? this : this.removeInner(e, 0);
  }
  removeInner(e, t) {
    let n = this.children, i = this.local;
    for (let o = 0; o < n.length; o += 3) {
      let a, s = n[o] + t, l = n[o + 1] + t;
      for (let u = 0, f; u < e.length; u++)
        (f = e[u]) && f.from > s && f.to < l && (e[u] = null, (a || (a = [])).push(f));
      if (!a)
        continue;
      n == this.children && (n = this.children.slice());
      let c = n[o + 2].removeInner(a, s + 1);
      c != je ? n[o + 2] = c : (n.splice(o, 3), o -= 3);
    }
    if (i.length) {
      for (let o = 0, a; o < e.length; o++)
        if (a = e[o])
          for (let s = 0; s < i.length; s++)
            i[s].eq(a, t) && (i == this.local && (i = this.local.slice()), i.splice(s--, 1));
    }
    return n == this.children && i == this.local ? this : i.length || n.length ? new fe(i, n) : je;
  }
  /**
  @internal
  */
  forChild(e, t) {
    if (this == je)
      return this;
    if (t.isLeaf)
      return fe.empty;
    let n, i;
    for (let s = 0; s < this.children.length; s += 3)
      if (this.children[s] >= e) {
        this.children[s] == e && (n = this.children[s + 2]);
        break;
      }
    let o = e + 1, a = o + t.content.size;
    for (let s = 0; s < this.local.length; s++) {
      let l = this.local[s];
      if (l.from < a && l.to > o && l.type instanceof bn) {
        let c = Math.max(o, l.from) - o, u = Math.min(a, l.to) - o;
        c < u && (i || (i = [])).push(l.copy(c, u));
      }
    }
    if (i) {
      let s = new fe(i.sort(Wn), ir);
      return n ? new hn([s, n]) : s;
    }
    return n || je;
  }
  /**
  @internal
  */
  eq(e) {
    if (this == e)
      return !0;
    if (!(e instanceof fe) || this.local.length != e.local.length || this.children.length != e.children.length)
      return !1;
    for (let t = 0; t < this.local.length; t++)
      if (!this.local[t].eq(e.local[t]))
        return !1;
    for (let t = 0; t < this.children.length; t += 3)
      if (this.children[t] != e.children[t] || this.children[t + 1] != e.children[t + 1] || !this.children[t + 2].eq(e.children[t + 2]))
        return !1;
    return !0;
  }
  /**
  @internal
  */
  locals(e) {
    return sl(this.localsInner(e));
  }
  /**
  @internal
  */
  localsInner(e) {
    if (this == je)
      return ir;
    if (e.inlineContent || !this.local.some(bn.is))
      return this.local;
    let t = [];
    for (let n = 0; n < this.local.length; n++)
      this.local[n].type instanceof bn || t.push(this.local[n]);
    return t;
  }
}
fe.empty = new fe([], []);
fe.removeOverlap = sl;
const je = fe.empty;
class hn {
  constructor(e) {
    this.members = e;
  }
  map(e, t) {
    const n = this.members.map((i) => i.map(e, t, jn));
    return hn.from(n);
  }
  forChild(e, t) {
    if (t.isLeaf)
      return fe.empty;
    let n = [];
    for (let i = 0; i < this.members.length; i++) {
      let o = this.members[i].forChild(e, t);
      o != je && (o instanceof hn ? n = n.concat(o.members) : n.push(o));
    }
    return hn.from(n);
  }
  eq(e) {
    if (!(e instanceof hn) || e.members.length != this.members.length)
      return !1;
    for (let t = 0; t < this.members.length; t++)
      if (!this.members[t].eq(e.members[t]))
        return !1;
    return !0;
  }
  locals(e) {
    let t, n = !0;
    for (let i = 0; i < this.members.length; i++) {
      let o = this.members[i].localsInner(e);
      if (o.length)
        if (!t)
          t = o;
        else {
          n && (t = t.slice(), n = !1);
          for (let a = 0; a < o.length; a++)
            t.push(o[a]);
        }
    }
    return t ? sl(n ? t : t.sort(Wn)) : ir;
  }
  // Create a group for the given array of decoration sets, or return
  // a single set when possible.
  static from(e) {
    switch (e.length) {
      case 0:
        return je;
      case 1:
        return e[0];
      default:
        return new hn(e.every((t) => t instanceof fe) ? e : e.reduce((t, n) => t.concat(n instanceof fe ? n : n.members), []));
    }
  }
}
function sS(r, e, t, n, i, o, a) {
  let s = r.slice();
  for (let c = 0, u = o; c < t.maps.length; c++) {
    let f = 0;
    t.maps[c].forEach((h, d, p, m) => {
      let v = m - p - (d - h);
      for (let y = 0; y < s.length; y += 3) {
        let b = s[y + 1];
        if (b < 0 || h > b + u - f)
          continue;
        let k = s[y] + u - f;
        d >= k ? s[y + 1] = h <= k ? -2 : -1 : p >= i && v && (s[y] += v, s[y + 1] += v);
      }
      f += v;
    }), u = t.maps[c].map(u, -1);
  }
  let l = !1;
  for (let c = 0; c < s.length; c += 3)
    if (s[c + 1] < 0) {
      if (s[c + 1] == -2) {
        l = !0, s[c + 1] = -1;
        continue;
      }
      let u = t.map(r[c] + o), f = u - i;
      if (f < 0 || f >= n.content.size) {
        l = !0;
        continue;
      }
      let h = t.map(r[c + 1] + o, -1), d = h - i, { index: p, offset: m } = n.content.findIndex(f), v = n.maybeChild(p);
      if (v && m == f && m + v.nodeSize == d) {
        let y = s[c + 2].mapInner(t, v, u + 1, r[c] + o + 1, a);
        y != je ? (s[c] = f, s[c + 1] = d, s[c + 2] = y) : (s[c + 1] = -2, l = !0);
      } else
        l = !0;
    }
  if (l) {
    let c = lS(s, r, e, t, i, o, a), u = Gi(c, n, 0, a);
    e = u.local;
    for (let f = 0; f < s.length; f += 3)
      s[f + 1] < 0 && (s.splice(f, 3), f -= 3);
    for (let f = 0, h = 0; f < u.children.length; f += 3) {
      let d = u.children[f];
      for (; h < s.length && s[h] < d; )
        h += 3;
      s.splice(h, 0, u.children[f], u.children[f + 1], u.children[f + 2]);
    }
  }
  return new fe(e.sort(Wn), s);
}
function Ph(r, e) {
  if (!e || !r.length)
    return r;
  let t = [];
  for (let n = 0; n < r.length; n++) {
    let i = r[n];
    t.push(new Ae(i.from + e, i.to + e, i.type));
  }
  return t;
}
function lS(r, e, t, n, i, o, a) {
  function s(l, c) {
    for (let u = 0; u < l.local.length; u++) {
      let f = l.local[u].map(n, i, c);
      f ? t.push(f) : a.onRemove && a.onRemove(l.local[u].spec);
    }
    for (let u = 0; u < l.children.length; u += 3)
      s(l.children[u + 2], l.children[u] + c + 1);
  }
  for (let l = 0; l < r.length; l += 3)
    r[l + 1] == -1 && s(r[l + 2], e[l] + o + 1);
  return t;
}
function Lh(r, e, t) {
  if (e.isLeaf)
    return null;
  let n = t + e.nodeSize, i = null;
  for (let o = 0, a; o < r.length; o++)
    (a = r[o]) && a.from > t && a.to < n && ((i || (i = [])).push(a), r[o] = null);
  return i;
}
function Fh(r) {
  let e = [];
  for (let t = 0; t < r.length; t++)
    r[t] != null && e.push(r[t]);
  return e;
}
function Gi(r, e, t, n) {
  let i = [], o = !1;
  e.forEach((s, l) => {
    let c = Lh(r, s, l + t);
    if (c) {
      o = !0;
      let u = Gi(c, s, t + l + 1, n);
      u != je && i.push(l, l + s.nodeSize, u);
    }
  });
  let a = Ph(o ? Fh(r) : r, -t).sort(Wn);
  for (let s = 0; s < a.length; s++)
    a[s].type.valid(e, a[s]) || (n.onRemove && n.onRemove(a[s].spec), a.splice(s--, 1));
  return a.length || i.length ? new fe(a, i) : je;
}
function Wn(r, e) {
  return r.from - e.from || r.to - e.to;
}
function sl(r) {
  let e = r;
  for (let t = 0; t < e.length - 1; t++) {
    let n = e[t];
    if (n.from != n.to)
      for (let i = t + 1; i < e.length; i++) {
        let o = e[i];
        if (o.from == n.from) {
          o.to != n.to && (e == r && (e = r.slice()), e[i] = o.copy(o.from, n.to), Lc(e, i + 1, o.copy(n.to, o.to)));
          continue;
        } else {
          o.from < n.to && (e == r && (e = r.slice()), e[t] = n.copy(n.from, o.from), Lc(e, i, n.copy(o.from, n.to)));
          break;
        }
      }
  }
  return e;
}
function Lc(r, e, t) {
  for (; e < r.length && Wn(t, r[e]) > 0; )
    e++;
  r.splice(e, 0, t);
}
function sa(r) {
  let e = [];
  return r.someProp("decorations", (t) => {
    let n = t(r.state);
    n && n != je && e.push(n);
  }), r.cursorWrapper && e.push(fe.create(r.state.doc, [r.cursorWrapper.deco])), hn.from(e);
}
const cS = {
  childList: !0,
  characterData: !0,
  characterDataOldValue: !0,
  attributes: !0,
  attributeOldValue: !0,
  subtree: !0
}, uS = nt && wn <= 11;
class fS {
  constructor() {
    this.anchorNode = null, this.anchorOffset = 0, this.focusNode = null, this.focusOffset = 0;
  }
  set(e) {
    this.anchorNode = e.anchorNode, this.anchorOffset = e.anchorOffset, this.focusNode = e.focusNode, this.focusOffset = e.focusOffset;
  }
  clear() {
    this.anchorNode = this.focusNode = null;
  }
  eq(e) {
    return e.anchorNode == this.anchorNode && e.anchorOffset == this.anchorOffset && e.focusNode == this.focusNode && e.focusOffset == this.focusOffset;
  }
}
class hS {
  constructor(e, t) {
    this.view = e, this.handleDOMChange = t, this.queue = [], this.flushingSoon = -1, this.observer = null, this.currentSelection = new fS(), this.onCharData = null, this.suppressingSelectionUpdates = !1, this.observer = window.MutationObserver && new window.MutationObserver((n) => {
      for (let i = 0; i < n.length; i++)
        this.queue.push(n[i]);
      nt && wn <= 11 && n.some((i) => i.type == "childList" && i.removedNodes.length || i.type == "characterData" && i.oldValue.length > i.target.nodeValue.length) ? this.flushSoon() : this.flush();
    }), uS && (this.onCharData = (n) => {
      this.queue.push({ target: n.target, type: "characterData", oldValue: n.prevValue }), this.flushSoon();
    }), this.onSelectionChange = this.onSelectionChange.bind(this);
  }
  flushSoon() {
    this.flushingSoon < 0 && (this.flushingSoon = window.setTimeout(() => {
      this.flushingSoon = -1, this.flush();
    }, 20));
  }
  forceFlush() {
    this.flushingSoon > -1 && (window.clearTimeout(this.flushingSoon), this.flushingSoon = -1, this.flush());
  }
  start() {
    this.observer && (this.observer.takeRecords(), this.observer.observe(this.view.dom, cS)), this.onCharData && this.view.dom.addEventListener("DOMCharacterDataModified", this.onCharData), this.connectSelection();
  }
  stop() {
    if (this.observer) {
      let e = this.observer.takeRecords();
      if (e.length) {
        for (let t = 0; t < e.length; t++)
          this.queue.push(e[t]);
        window.setTimeout(() => this.flush(), 20);
      }
      this.observer.disconnect();
    }
    this.onCharData && this.view.dom.removeEventListener("DOMCharacterDataModified", this.onCharData), this.disconnectSelection();
  }
  connectSelection() {
    this.view.dom.ownerDocument.addEventListener("selectionchange", this.onSelectionChange);
  }
  disconnectSelection() {
    this.view.dom.ownerDocument.removeEventListener("selectionchange", this.onSelectionChange);
  }
  suppressSelectionUpdates() {
    this.suppressingSelectionUpdates = !0, setTimeout(() => this.suppressingSelectionUpdates = !1, 50);
  }
  onSelectionChange() {
    if (Ic(this.view)) {
      if (this.suppressingSelectionUpdates)
        return en(this.view);
      if (nt && wn <= 11 && !this.view.state.selection.empty) {
        let e = this.view.domSelectionRange();
        if (e.focusNode && Un(e.focusNode, e.focusOffset, e.anchorNode, e.anchorOffset))
          return this.flushSoon();
      }
      this.flush();
    }
  }
  setCurSelection() {
    this.currentSelection.set(this.view.domSelectionRange());
  }
  ignoreSelectionChange(e) {
    if (!e.focusNode)
      return !0;
    let t = /* @__PURE__ */ new Set(), n;
    for (let o = e.focusNode; o; o = Qr(o))
      t.add(o);
    for (let o = e.anchorNode; o; o = Qr(o))
      if (t.has(o)) {
        n = o;
        break;
      }
    let i = n && this.view.docView.nearestDesc(n);
    if (i && i.ignoreMutation({
      type: "selection",
      target: n.nodeType == 3 ? n.parentNode : n
    }))
      return this.setCurSelection(), !0;
  }
  flush() {
    let { view: e } = this;
    if (!e.docView || this.flushingSoon > -1)
      return;
    let t = this.observer ? this.observer.takeRecords() : [];
    this.queue.length && (t = this.queue.concat(t), this.queue.length = 0);
    let n = e.domSelectionRange(), i = !this.suppressingSelectionUpdates && !this.currentSelection.eq(n) && Ic(e) && !this.ignoreSelectionChange(n), o = -1, a = -1, s = !1, l = [];
    if (e.editable)
      for (let u = 0; u < t.length; u++) {
        let f = this.registerMutation(t[u], l);
        f && (o = o < 0 ? f.from : Math.min(f.from, o), a = a < 0 ? f.to : Math.max(f.to, a), f.typeOver && (s = !0));
      }
    if (Dt && l.length > 1) {
      let u = l.filter((f) => f.nodeName == "BR");
      if (u.length == 2) {
        let f = u[0], h = u[1];
        f.parentNode && f.parentNode.parentNode == h.parentNode ? h.remove() : f.remove();
      }
    }
    let c = null;
    o < 0 && i && e.input.lastFocus > Date.now() - 200 && Math.max(e.input.lastTouch, e.input.lastClick.time) < Date.now() - 300 && vo(n) && (c = el(e)) && c.eq(ie.near(e.state.doc.resolve(0), 1)) ? (e.input.lastFocus = 0, en(e), this.currentSelection.set(n), e.scrollToSelection()) : (o > -1 || i) && (o > -1 && (e.docView.markDirty(o, a), dS(e)), this.handleDOMChange(o, a, s, l), e.docView && e.docView.dirty ? e.updateState(e.state) : this.currentSelection.eq(n) || en(e), this.currentSelection.set(n));
  }
  registerMutation(e, t) {
    if (t.indexOf(e.target) > -1)
      return null;
    let n = this.view.docView.nearestDesc(e.target);
    if (e.type == "attributes" && (n == this.view.docView || e.attributeName == "contenteditable" || // Firefox sometimes fires spurious events for null/empty styles
    e.attributeName == "style" && !e.oldValue && !e.target.getAttribute("style")) || !n || n.ignoreMutation(e))
      return null;
    if (e.type == "childList") {
      for (let u = 0; u < e.addedNodes.length; u++)
        t.push(e.addedNodes[u]);
      if (n.contentDOM && n.contentDOM != n.dom && !n.contentDOM.contains(e.target))
        return { from: n.posBefore, to: n.posAfter };
      let i = e.previousSibling, o = e.nextSibling;
      if (nt && wn <= 11 && e.addedNodes.length)
        for (let u = 0; u < e.addedNodes.length; u++) {
          let { previousSibling: f, nextSibling: h } = e.addedNodes[u];
          (!f || Array.prototype.indexOf.call(e.addedNodes, f) < 0) && (i = f), (!h || Array.prototype.indexOf.call(e.addedNodes, h) < 0) && (o = h);
        }
      let a = i && i.parentNode == e.target ? st(i) + 1 : 0, s = n.localPosFromDOM(e.target, a, -1), l = o && o.parentNode == e.target ? st(o) : e.target.childNodes.length, c = n.localPosFromDOM(e.target, l, 1);
      return { from: s, to: c };
    } else
      return e.type == "attributes" ? { from: n.posAtStart - n.border, to: n.posAtEnd + n.border } : {
        from: n.posAtStart,
        to: n.posAtEnd,
        // An event was generated for a text change that didn't change
        // any text. Mark the dom change to fall back to assuming the
        // selection was typed over with an identical value if it can't
        // find another change.
        typeOver: e.target.nodeValue == e.oldValue
      };
  }
}
let Fc = /* @__PURE__ */ new WeakMap(), zc = !1;
function dS(r) {
  if (!Fc.has(r) && (Fc.set(r, null), ["normal", "nowrap", "pre-line"].indexOf(getComputedStyle(r.dom).whiteSpace) !== -1)) {
    if (r.requiresGeckoHackNode = Dt, zc)
      return;
    console.warn("ProseMirror expects the CSS white-space property to be set, preferably to 'pre-wrap'. It is recommended to load style/prosemirror.css from the prosemirror-view package."), zc = !0;
  }
}
function pS(r) {
  let e;
  function t(l) {
    l.preventDefault(), l.stopImmediatePropagation(), e = l.getTargetRanges()[0];
  }
  r.dom.addEventListener("beforeinput", t, !0), document.execCommand("indent"), r.dom.removeEventListener("beforeinput", t, !0);
  let n = e.startContainer, i = e.startOffset, o = e.endContainer, a = e.endOffset, s = r.domAtPos(r.state.selection.anchor);
  return Un(s.node, s.offset, o, a) && ([n, i, o, a] = [o, a, n, i]), { anchorNode: n, anchorOffset: i, focusNode: o, focusOffset: a };
}
function mS(r, e, t) {
  let { node: n, fromOffset: i, toOffset: o, from: a, to: s } = r.docView.parseRange(e, t), l = r.domSelectionRange(), c, u = l.anchorNode;
  if (u && r.dom.contains(u.nodeType == 1 ? u : u.parentNode) && (c = [{ node: u, offset: l.anchorOffset }], vo(l) || c.push({ node: l.focusNode, offset: l.focusOffset })), Ke && r.input.lastKeyCode === 8)
    for (let v = o; v > i; v--) {
      let y = n.childNodes[v - 1], b = y.pmViewDesc;
      if (y.nodeName == "BR" && !b) {
        o = v;
        break;
      }
      if (!b || b.size)
        break;
    }
  let f = r.state.doc, h = r.someProp("domParser") || Hs.fromSchema(r.state.schema), d = f.resolve(a), p = null, m = h.parse(n, {
    topNode: d.parent,
    topMatch: d.parent.contentMatchAt(d.index()),
    topOpen: !0,
    from: i,
    to: o,
    preserveWhitespace: d.parent.type.whitespace == "pre" ? "full" : !0,
    findPositions: c,
    ruleFromNode: gS,
    context: d
  });
  if (c && c[0].pos != null) {
    let v = c[0].pos, y = c[1] && c[1].pos;
    y == null && (y = v), p = { anchor: v + a, head: y + a };
  }
  return { doc: m, sel: p, from: a, to: s };
}
function gS(r) {
  let e = r.pmViewDesc;
  if (e)
    return e.parseRule();
  if (r.nodeName == "BR" && r.parentNode) {
    if (Ye && /^(ul|ol)$/i.test(r.parentNode.nodeName)) {
      let t = document.createElement("div");
      return t.appendChild(document.createElement("li")), { skip: t };
    } else if (r.parentNode.lastChild == r || Ye && /^(tr|table)$/i.test(r.parentNode.nodeName))
      return { ignore: !0 };
  } else if (r.nodeName == "IMG" && r.getAttribute("mark-placeholder"))
    return { ignore: !0 };
  return null;
}
const vS = /^(a|abbr|acronym|b|bd[io]|big|br|button|cite|code|data(list)?|del|dfn|em|i|ins|kbd|label|map|mark|meter|output|q|ruby|s|samp|small|span|strong|su[bp]|time|u|tt|var)$/i;
function yS(r, e, t, n, i) {
  if (e < 0) {
    let _ = r.input.lastSelectionTime > Date.now() - 50 ? r.input.lastSelectionOrigin : null, ee = el(r, _);
    if (ee && !r.state.selection.eq(ee)) {
      if (Ke && Mt && r.input.lastKeyCode === 13 && Date.now() - 100 < r.input.lastKeyCodeTime && r.someProp("handleKeyDown", (O) => O(r, Nn(13, "Enter"))))
        return;
      let K = r.state.tr.setSelection(ee);
      _ == "pointer" ? K.setMeta("pointer", !0) : _ == "key" && K.scrollIntoView(), r.dispatch(K);
    }
    return;
  }
  let o = r.state.doc.resolve(e), a = o.sharedDepth(t);
  e = o.before(a + 1), t = r.state.doc.resolve(t).after(a + 1);
  let s = r.state.selection, l = mS(r, e, t), c = r.state.doc, u = c.slice(l.from, l.to), f, h;
  r.input.lastKeyCode === 8 && Date.now() - 100 < r.input.lastKeyCodeTime ? (f = r.state.selection.to, h = "end") : (f = r.state.selection.from, h = "start"), r.input.lastKeyCode = null;
  let d = SS(u.content, l.doc.content, l.from, f, h);
  if ((Cr && r.input.lastIOSEnter > Date.now() - 225 || Mt) && i.some((_) => _.nodeType == 1 && !vS.test(_.nodeName)) && (!d || d.endA >= d.endB) && r.someProp("handleKeyDown", (_) => _(r, Nn(13, "Enter")))) {
    r.input.lastIOSEnter = 0;
    return;
  }
  if (!d)
    if (n && s instanceof oe && !s.empty && s.$head.sameParent(s.$anchor) && !r.composing && !(l.sel && l.sel.anchor != l.sel.head))
      d = { start: s.from, endA: s.to, endB: s.to };
    else {
      if (l.sel) {
        let _ = Bc(r, r.state.doc, l.sel);
        _ && !_.eq(r.state.selection) && r.dispatch(r.state.tr.setSelection(_));
      }
      return;
    }
  if (Ke && r.cursorWrapper && l.sel && l.sel.anchor == r.cursorWrapper.deco.from && l.sel.head == l.sel.anchor) {
    let _ = d.endB - d.start;
    l.sel = { anchor: l.sel.anchor + _, head: l.sel.anchor + _ };
  }
  r.input.domChangeCount++, r.state.selection.from < r.state.selection.to && d.start == d.endB && r.state.selection instanceof oe && (d.start > r.state.selection.from && d.start <= r.state.selection.from + 2 && r.state.selection.from >= l.from ? d.start = r.state.selection.from : d.endA < r.state.selection.to && d.endA >= r.state.selection.to - 2 && r.state.selection.to <= l.to && (d.endB += r.state.selection.to - d.endA, d.endA = r.state.selection.to)), nt && wn <= 11 && d.endB == d.start + 1 && d.endA == d.start && d.start > l.from && l.doc.textBetween(d.start - l.from - 1, d.start - l.from + 1) == "  " && (d.start--, d.endA--, d.endB--);
  let p = l.doc.resolveNoCache(d.start - l.from), m = l.doc.resolveNoCache(d.endB - l.from), v = c.resolve(d.start), y = p.sameParent(m) && p.parent.inlineContent && v.end() >= d.endA, b;
  if ((Cr && r.input.lastIOSEnter > Date.now() - 225 && (!y || i.some((_) => _.nodeName == "DIV" || _.nodeName == "P")) || !y && p.pos < l.doc.content.size && (b = ie.findFrom(l.doc.resolve(p.pos + 1), 1, !0)) && b.head == m.pos) && r.someProp("handleKeyDown", (_) => _(r, Nn(13, "Enter")))) {
    r.input.lastIOSEnter = 0;
    return;
  }
  if (r.state.selection.anchor > d.start && bS(c, d.start, d.endA, p, m) && r.someProp("handleKeyDown", (_) => _(r, Nn(8, "Backspace")))) {
    Mt && Ke && r.domObserver.suppressSelectionUpdates();
    return;
  }
  Ke && Mt && d.endB == d.start && (r.input.lastAndroidDelete = Date.now()), Mt && !y && p.start() != m.start() && m.parentOffset == 0 && p.depth == m.depth && l.sel && l.sel.anchor == l.sel.head && l.sel.head == d.endA && (d.endB -= 2, m = l.doc.resolveNoCache(d.endB - l.from), setTimeout(() => {
    r.someProp("handleKeyDown", function(_) {
      return _(r, Nn(13, "Enter"));
    });
  }, 20));
  let k = d.start, M = d.endA, D, T, z;
  if (y) {
    if (p.pos == m.pos)
      nt && wn <= 11 && p.parentOffset == 0 && (r.domObserver.suppressSelectionUpdates(), setTimeout(() => en(r), 20)), D = r.state.tr.delete(k, M), T = c.resolve(d.start).marksAcross(c.resolve(d.endA));
    else if (
      // Adding or removing a mark
      d.endA == d.endB && (z = wS(p.parent.content.cut(p.parentOffset, m.parentOffset), v.parent.content.cut(v.parentOffset, d.endA - v.start())))
    )
      D = r.state.tr, z.type == "add" ? D.addMark(k, M, z.mark) : D.removeMark(k, M, z.mark);
    else if (p.parent.child(p.index()).isText && p.index() == m.index() - (m.textOffset ? 0 : 1)) {
      let _ = p.parent.textBetween(p.parentOffset, m.parentOffset);
      if (r.someProp("handleTextInput", (ee) => ee(r, k, M, _)))
        return;
      D = r.state.tr.insertText(_, k, M);
    }
  }
  if (D || (D = r.state.tr.replace(k, M, l.doc.slice(d.start - l.from, d.endB - l.from))), l.sel) {
    let _ = Bc(r, D.doc, l.sel);
    _ && !(Ke && Mt && r.composing && _.empty && (d.start != d.endB || r.input.lastAndroidDelete < Date.now() - 100) && (_.head == k || _.head == D.mapping.map(M) - 1) || nt && _.empty && _.head == k) && D.setSelection(_);
  }
  T && D.ensureMarks(T), r.dispatch(D.scrollIntoView());
}
function Bc(r, e, t) {
  return Math.max(t.anchor, t.head) > e.content.size ? null : tl(r, e.resolve(t.anchor), e.resolve(t.head));
}
function wS(r, e) {
  let t = r.firstChild.marks, n = e.firstChild.marks, i = t, o = n, a, s, l;
  for (let u = 0; u < n.length; u++)
    i = n[u].removeFromSet(i);
  for (let u = 0; u < t.length; u++)
    o = t[u].removeFromSet(o);
  if (i.length == 1 && o.length == 0)
    s = i[0], a = "add", l = (u) => u.mark(s.addToSet(u.marks));
  else if (i.length == 0 && o.length == 1)
    s = o[0], a = "remove", l = (u) => u.mark(s.removeFromSet(u.marks));
  else
    return null;
  let c = [];
  for (let u = 0; u < e.childCount; u++)
    c.push(l(e.child(u)));
  if (I.from(c).eq(r))
    return { mark: s, type: a };
}
function bS(r, e, t, n, i) {
  if (!n.parent.isTextblock || // The content must have shrunk
  t - e <= i.pos - n.pos || // newEnd must point directly at or after the end of the block that newStart points into
  la(n, !0, !1) < i.pos)
    return !1;
  let o = r.resolve(e);
  if (o.parentOffset < o.parent.content.size || !o.parent.isTextblock)
    return !1;
  let a = r.resolve(la(o, !0, !0));
  return !a.parent.isTextblock || a.pos > t || la(a, !0, !1) < t ? !1 : n.parent.content.cut(n.parentOffset).eq(a.parent.content);
}
function la(r, e, t) {
  let n = r.depth, i = e ? r.end() : r.pos;
  for (; n > 0 && (e || r.indexAfter(n) == r.node(n).childCount); )
    n--, i++, e = !1;
  if (t) {
    let o = r.node(n).maybeChild(r.indexAfter(n));
    for (; o && !o.isLeaf; )
      o = o.firstChild, i++;
  }
  return i;
}
function SS(r, e, t, n, i) {
  let o = r.findDiffStart(e, t);
  if (o == null)
    return null;
  let { a, b: s } = r.findDiffEnd(e, t + r.size, t + e.size);
  if (i == "end") {
    let l = Math.max(0, o - Math.min(a, s));
    n -= a + l - o;
  }
  if (a < o && r.size < e.size) {
    let l = n <= o && n >= a ? o - n : 0;
    o -= l, s = o + (s - a), a = o;
  } else if (s < o) {
    let l = n <= o && n >= s ? o - n : 0;
    o -= l, a = o + (a - s), s = o;
  }
  return { start: o, endA: a, endB: s };
}
class CS {
  /**
  Create a view. `place` may be a DOM node that the editor should
  be appended to, a function that will place it into the document,
  or an object whose `mount` property holds the node to use as the
  document container. If it is `null`, the editor will not be
  added to the document.
  */
  constructor(e, t) {
    this._root = null, this.focused = !1, this.trackWrites = null, this.mounted = !1, this.markCursor = null, this.cursorWrapper = null, this.lastSelectedViewDesc = void 0, this.input = new jb(), this.prevDirectPlugins = [], this.pluginViews = [], this.requiresGeckoHackNode = !1, this.dragging = null, this._props = t, this.state = t.state, this.directPlugins = t.plugins || [], this.directPlugins.forEach(Vc), this.dispatch = this.dispatch.bind(this), this.dom = e && e.mount || document.createElement("div"), e && (e.appendChild ? e.appendChild(this.dom) : typeof e == "function" ? e(this.dom) : e.mount && (this.mounted = !0)), this.editable = jc(this), Hc(this), this.nodeViews = Wc(this), this.docView = kc(this.state.doc, $c(this), sa(this), this.dom, this), this.domObserver = new hS(this, (n, i, o, a) => yS(this, n, i, o, a)), this.domObserver.start(), Wb(this), this.updatePluginViews();
  }
  /**
  Holds `true` when a
  [composition](https://w3c.github.io/uievents/#events-compositionevents)
  is active.
  */
  get composing() {
    return this.input.composing;
  }
  /**
  The view's current [props](https://prosemirror.net/docs/ref/#view.EditorProps).
  */
  get props() {
    if (this._props.state != this.state) {
      let e = this._props;
      this._props = {};
      for (let t in e)
        this._props[t] = e[t];
      this._props.state = this.state;
    }
    return this._props;
  }
  /**
  Update the view's props. Will immediately cause an update to
  the DOM.
  */
  update(e) {
    e.handleDOMEvents != this._props.handleDOMEvents && Za(this);
    let t = this._props;
    this._props = e, e.plugins && (e.plugins.forEach(Vc), this.directPlugins = e.plugins), this.updateStateInner(e.state, t);
  }
  /**
  Update the view by updating existing props object with the object
  given as argument. Equivalent to `view.update(Object.assign({},
  view.props, props))`.
  */
  setProps(e) {
    let t = {};
    for (let n in this._props)
      t[n] = this._props[n];
    t.state = this.state;
    for (let n in e)
      t[n] = e[n];
    this.update(t);
  }
  /**
  Update the editor's `state` prop, without touching any of the
  other props.
  */
  updateState(e) {
    this.updateStateInner(e, this._props);
  }
  updateStateInner(e, t) {
    let n = this.state, i = !1, o = !1;
    e.storedMarks && this.composing && (Nh(this), o = !0), this.state = e;
    let a = n.plugins != e.plugins || this._props.plugins != t.plugins;
    if (a || this._props.plugins != t.plugins || this._props.nodeViews != t.nodeViews) {
      let h = Wc(this);
      xS(h, this.nodeViews) && (this.nodeViews = h, i = !0);
    }
    (a || t.handleDOMEvents != this._props.handleDOMEvents) && Za(this), this.editable = jc(this), Hc(this);
    let s = sa(this), l = $c(this), c = n.plugins != e.plugins && !n.doc.eq(e.doc) ? "reset" : e.scrollToSelection > n.scrollToSelection ? "to selection" : "preserve", u = i || !this.docView.matchesNode(e.doc, l, s);
    (u || !e.selection.eq(n.selection)) && (o = !0);
    let f = c == "preserve" && o && this.dom.style.overflowAnchor == null && sb(this);
    if (o) {
      this.domObserver.stop();
      let h = u && (nt || Ke) && !this.composing && !n.selection.empty && !e.selection.empty && kS(n.selection, e.selection);
      if (u) {
        let d = Ke ? this.trackWrites = this.domSelectionRange().focusNode : null;
        (i || !this.docView.update(e.doc, l, s, this)) && (this.docView.updateOuterDeco([]), this.docView.destroy(), this.docView = kc(e.doc, l, s, this.dom, this)), d && !this.trackWrites && (h = !0);
      }
      h || !(this.input.mouseDown && this.domObserver.currentSelection.eq(this.domSelectionRange()) && Ab(this)) ? en(this, h) : (bh(this, e.selection), this.domObserver.setCurSelection()), this.domObserver.start();
    }
    this.updatePluginViews(n), c == "reset" ? this.dom.scrollTop = 0 : c == "to selection" ? this.scrollToSelection() : f && lb(f);
  }
  /**
  @internal
  */
  scrollToSelection() {
    let e = this.domSelectionRange().focusNode;
    if (!this.someProp("handleScrollToSelection", (t) => t(this)))
      if (this.state.selection instanceof te) {
        let t = this.docView.domAfterPos(this.state.selection.from);
        t.nodeType == 1 && yc(this, t.getBoundingClientRect(), e);
      } else
        yc(this, this.coordsAtPos(this.state.selection.head, 1), e);
  }
  destroyPluginViews() {
    let e;
    for (; e = this.pluginViews.pop(); )
      e.destroy && e.destroy();
  }
  updatePluginViews(e) {
    if (!e || e.plugins != this.state.plugins || this.directPlugins != this.prevDirectPlugins) {
      this.prevDirectPlugins = this.directPlugins, this.destroyPluginViews();
      for (let t = 0; t < this.directPlugins.length; t++) {
        let n = this.directPlugins[t];
        n.spec.view && this.pluginViews.push(n.spec.view(this));
      }
      for (let t = 0; t < this.state.plugins.length; t++) {
        let n = this.state.plugins[t];
        n.spec.view && this.pluginViews.push(n.spec.view(this));
      }
    } else
      for (let t = 0; t < this.pluginViews.length; t++) {
        let n = this.pluginViews[t];
        n.update && n.update(this, e);
      }
  }
  someProp(e, t) {
    let n = this._props && this._props[e], i;
    if (n != null && (i = t ? t(n) : n))
      return i;
    for (let a = 0; a < this.directPlugins.length; a++) {
      let s = this.directPlugins[a].props[e];
      if (s != null && (i = t ? t(s) : s))
        return i;
    }
    let o = this.state.plugins;
    if (o)
      for (let a = 0; a < o.length; a++) {
        let s = o[a].props[e];
        if (s != null && (i = t ? t(s) : s))
          return i;
      }
  }
  /**
  Query whether the view has focus.
  */
  hasFocus() {
    if (nt) {
      let e = this.root.activeElement;
      if (e == this.dom)
        return !0;
      if (!e || !this.dom.contains(e))
        return !1;
      for (; e && this.dom != e && this.dom.contains(e); ) {
        if (e.contentEditable == "false")
          return !1;
        e = e.parentElement;
      }
      return !0;
    }
    return this.root.activeElement == this.dom;
  }
  /**
  Focus the editor.
  */
  focus() {
    this.domObserver.stop(), this.editable && cb(this.dom), en(this), this.domObserver.start();
  }
  /**
  Get the document root in which the editor exists. This will
  usually be the top-level `document`, but might be a [shadow
  DOM](https://developer.mozilla.org/en-US/docs/Web/Web_Components/Shadow_DOM)
  root if the editor is inside one.
  */
  get root() {
    let e = this._root;
    if (e == null) {
      for (let t = this.dom.parentNode; t; t = t.parentNode)
        if (t.nodeType == 9 || t.nodeType == 11 && t.host)
          return t.getSelection || (Object.getPrototypeOf(t).getSelection = () => t.ownerDocument.getSelection()), this._root = t;
    }
    return e || document;
  }
  /**
  Given a pair of viewport coordinates, return the document
  position that corresponds to them. May return null if the given
  coordinates aren't inside of the editor. When an object is
  returned, its `pos` property is the position nearest to the
  coordinates, and its `inside` property holds the position of the
  inner node that the position falls inside of, or -1 if it is at
  the top level, not in any node.
  */
  posAtCoords(e) {
    return pb(this, e);
  }
  /**
  Returns the viewport rectangle at a given document position.
  `left` and `right` will be the same number, as this returns a
  flat cursor-ish rectangle. If the position is between two things
  that aren't directly adjacent, `side` determines which element
  is used. When < 0, the element before the position is used,
  otherwise the element after.
  */
  coordsAtPos(e, t = 1) {
    return hh(this, e, t);
  }
  /**
  Find the DOM position that corresponds to the given document
  position. When `side` is negative, find the position as close as
  possible to the content before the position. When positive,
  prefer positions close to the content after the position. When
  zero, prefer as shallow a position as possible.
  
  Note that you should **not** mutate the editor's internal DOM,
  only inspect it (and even that is usually not necessary).
  */
  domAtPos(e, t = 0) {
    return this.docView.domFromPos(e, t);
  }
  /**
  Find the DOM node that represents the document node after the
  given position. May return `null` when the position doesn't point
  in front of a node or if the node is inside an opaque node view.
  
  This is intended to be able to call things like
  `getBoundingClientRect` on that DOM node. Do **not** mutate the
  editor DOM directly, or add styling this way, since that will be
  immediately overriden by the editor as it redraws the node.
  */
  nodeDOM(e) {
    let t = this.docView.descAt(e);
    return t ? t.nodeDOM : null;
  }
  /**
  Find the document position that corresponds to a given DOM
  position. (Whenever possible, it is preferable to inspect the
  document structure directly, rather than poking around in the
  DOM, but sometimes—for example when interpreting an event
  target—you don't have a choice.)
  
  The `bias` parameter can be used to influence which side of a DOM
  node to use when the position is inside a leaf node.
  */
  posAtDOM(e, t, n = -1) {
    let i = this.docView.posFromDOM(e, t, n);
    if (i == null)
      throw new RangeError("DOM position not inside the editor");
    return i;
  }
  /**
  Find out whether the selection is at the end of a textblock when
  moving in a given direction. When, for example, given `"left"`,
  it will return true if moving left from the current cursor
  position would leave that position's parent textblock. Will apply
  to the view's current state by default, but it is possible to
  pass a different state.
  */
  endOfTextblock(e, t) {
    return wb(this, t || this.state, e);
  }
  /**
  Run the editor's paste logic with the given HTML string. The
  `event`, if given, will be passed to the
  [`handlePaste`](https://prosemirror.net/docs/ref/#view.EditorProps.handlePaste) hook.
  */
  pasteHTML(e, t) {
    return ei(this, "", e, !1, t || new ClipboardEvent("paste"));
  }
  /**
  Run the editor's paste logic with the given plain-text input.
  */
  pasteText(e, t) {
    return ei(this, e, null, !0, t || new ClipboardEvent("paste"));
  }
  /**
  Removes the editor from the DOM and destroys all [node
  views](https://prosemirror.net/docs/ref/#view.NodeView).
  */
  destroy() {
    this.docView && (Vb(this), this.destroyPluginViews(), this.mounted ? (this.docView.update(this.state.doc, [], sa(this), this), this.dom.textContent = "") : this.dom.parentNode && this.dom.parentNode.removeChild(this.dom), this.docView.destroy(), this.docView = null);
  }
  /**
  This is true when the view has been
  [destroyed](https://prosemirror.net/docs/ref/#view.EditorView.destroy) (and thus should not be
  used anymore).
  */
  get isDestroyed() {
    return this.docView == null;
  }
  /**
  Used for testing.
  */
  dispatchEvent(e) {
    return qb(this, e);
  }
  /**
  Dispatch a transaction. Will call
  [`dispatchTransaction`](https://prosemirror.net/docs/ref/#view.DirectEditorProps.dispatchTransaction)
  when given, and otherwise defaults to applying the transaction to
  the current state and calling
  [`updateState`](https://prosemirror.net/docs/ref/#view.EditorView.updateState) with the result.
  This method is bound to the view instance, so that it can be
  easily passed around.
  */
  dispatch(e) {
    let t = this._props.dispatchTransaction;
    t ? t.call(this, e) : this.updateState(this.state.apply(e));
  }
  /**
  @internal
  */
  domSelectionRange() {
    return Ye && this.root.nodeType === 11 && nb(this.dom.ownerDocument) == this.dom ? pS(this) : this.domSelection();
  }
  /**
  @internal
  */
  domSelection() {
    return this.root.getSelection();
  }
}
function $c(r) {
  let e = /* @__PURE__ */ Object.create(null);
  return e.class = "ProseMirror", e.contenteditable = String(r.editable), e.translate = "no", r.someProp("attributes", (t) => {
    if (typeof t == "function" && (t = t(r.state)), t)
      for (let n in t)
        n == "class" && (e.class += " " + t[n]), n == "style" ? e.style = (e.style ? e.style + ";" : "") + t[n] : !e[n] && n != "contenteditable" && n != "nodeName" && (e[n] = String(t[n]));
  }), [Ae.node(0, r.state.doc.content.size, e)];
}
function Hc(r) {
  if (r.markCursor) {
    let e = document.createElement("img");
    e.className = "ProseMirror-separator", e.setAttribute("mark-placeholder", "true"), e.setAttribute("alt", ""), r.cursorWrapper = { dom: e, deco: Ae.widget(r.state.selection.head, e, { raw: !0, marks: r.markCursor }) };
  } else
    r.cursorWrapper = null;
}
function jc(r) {
  return !r.someProp("editable", (e) => e(r.state) === !1);
}
function kS(r, e) {
  let t = Math.min(r.$anchor.sharedDepth(r.head), e.$anchor.sharedDepth(e.head));
  return r.$anchor.start(t) != e.$anchor.start(t);
}
function Wc(r) {
  let e = /* @__PURE__ */ Object.create(null);
  function t(n) {
    for (let i in n)
      Object.prototype.hasOwnProperty.call(e, i) || (e[i] = n[i]);
  }
  return r.someProp("nodeViews", t), r.someProp("markViews", t), e;
}
function xS(r, e) {
  let t = 0, n = 0;
  for (let i in r) {
    if (r[i] != e[i])
      return !0;
    t++;
  }
  for (let i in e)
    n++;
  return t != n;
}
function Vc(r) {
  if (r.spec.state || r.spec.filterTransaction || r.spec.appendTransaction)
    throw new RangeError("Plugins passed directly to the view must not have a state component");
}
var xn = {
  8: "Backspace",
  9: "Tab",
  10: "Enter",
  12: "NumLock",
  13: "Enter",
  16: "Shift",
  17: "Control",
  18: "Alt",
  20: "CapsLock",
  27: "Escape",
  32: " ",
  33: "PageUp",
  34: "PageDown",
  35: "End",
  36: "Home",
  37: "ArrowLeft",
  38: "ArrowUp",
  39: "ArrowRight",
  40: "ArrowDown",
  44: "PrintScreen",
  45: "Insert",
  46: "Delete",
  59: ";",
  61: "=",
  91: "Meta",
  92: "Meta",
  106: "*",
  107: "+",
  108: ",",
  109: "-",
  110: ".",
  111: "/",
  144: "NumLock",
  145: "ScrollLock",
  160: "Shift",
  161: "Shift",
  162: "Control",
  163: "Control",
  164: "Alt",
  165: "Alt",
  173: "-",
  186: ";",
  187: "=",
  188: ",",
  189: "-",
  190: ".",
  191: "/",
  192: "`",
  219: "[",
  220: "\\",
  221: "]",
  222: "'"
}, Ji = {
  48: ")",
  49: "!",
  50: "@",
  51: "#",
  52: "$",
  53: "%",
  54: "^",
  55: "&",
  56: "*",
  57: "(",
  59: ":",
  61: "+",
  173: "_",
  186: ":",
  187: "+",
  188: "<",
  189: "_",
  190: ">",
  191: "?",
  192: "~",
  219: "{",
  220: "|",
  221: "}",
  222: '"'
}, OS = typeof navigator < "u" && /Mac/.test(navigator.platform), TS = typeof navigator < "u" && /MSIE \d|Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec(navigator.userAgent);
for (var $e = 0; $e < 10; $e++)
  xn[48 + $e] = xn[96 + $e] = String($e);
for (var $e = 1; $e <= 24; $e++)
  xn[$e + 111] = "F" + $e;
for (var $e = 65; $e <= 90; $e++)
  xn[$e] = String.fromCharCode($e + 32), Ji[$e] = String.fromCharCode($e);
for (var ca in xn)
  Ji.hasOwnProperty(ca) || (Ji[ca] = xn[ca]);
function MS(r) {
  var e = OS && r.metaKey && r.shiftKey && !r.ctrlKey && !r.altKey || TS && r.shiftKey && r.key && r.key.length == 1 || r.key == "Unidentified", t = !e && r.key || (r.shiftKey ? Ji : xn)[r.keyCode] || r.key || "Unidentified";
  return t == "Esc" && (t = "Escape"), t == "Del" && (t = "Delete"), t == "Left" && (t = "ArrowLeft"), t == "Up" && (t = "ArrowUp"), t == "Right" && (t = "ArrowRight"), t == "Down" && (t = "ArrowDown"), t;
}
const _S = typeof navigator < "u" ? /Mac|iP(hone|[oa]d)/.test(navigator.platform) : !1;
function IS(r) {
  let e = r.split(/-(?!$)/), t = e[e.length - 1];
  t == "Space" && (t = " ");
  let n, i, o, a;
  for (let s = 0; s < e.length - 1; s++) {
    let l = e[s];
    if (/^(cmd|meta|m)$/i.test(l))
      a = !0;
    else if (/^a(lt)?$/i.test(l))
      n = !0;
    else if (/^(c|ctrl|control)$/i.test(l))
      i = !0;
    else if (/^s(hift)?$/i.test(l))
      o = !0;
    else if (/^mod$/i.test(l))
      _S ? a = !0 : i = !0;
    else
      throw new Error("Unrecognized modifier name: " + l);
  }
  return n && (t = "Alt-" + t), i && (t = "Ctrl-" + t), a && (t = "Meta-" + t), o && (t = "Shift-" + t), t;
}
function DS(r) {
  let e = /* @__PURE__ */ Object.create(null);
  for (let t in r)
    e[IS(t)] = r[t];
  return e;
}
function ua(r, e, t = !0) {
  return e.altKey && (r = "Alt-" + r), e.ctrlKey && (r = "Ctrl-" + r), e.metaKey && (r = "Meta-" + r), t && e.shiftKey && (r = "Shift-" + r), r;
}
function Uc(r) {
  return new Ge({ props: { handleKeyDown: ll(r) } });
}
function ll(r) {
  let e = DS(r);
  return function(t, n) {
    let i = MS(n), o, a = e[ua(i, n)];
    if (a && a(t.state, t.dispatch, t))
      return !0;
    if (i.length == 1 && i != " ") {
      if (n.shiftKey) {
        let s = e[ua(i, n, !1)];
        if (s && s(t.state, t.dispatch, t))
          return !0;
      }
      if ((n.shiftKey || n.altKey || n.metaKey || i.charCodeAt(0) > 127) && (o = xn[n.keyCode]) && o != i) {
        let s = e[ua(o, n)];
        if (s && s(t.state, t.dispatch, t))
          return !0;
      }
    }
    return !1;
  };
}
var Qa, es;
if (typeof WeakMap < "u") {
  let r = /* @__PURE__ */ new WeakMap();
  Qa = (e) => r.get(e), es = (e, t) => (r.set(e, t), t);
} else {
  const r = [];
  let t = 0;
  Qa = (n) => {
    for (let i = 0; i < r.length; i += 2)
      if (r[i] == n)
        return r[i + 1];
  }, es = (n, i) => (t == 10 && (t = 0), r[t++] = n, r[t++] = i);
}
var Te = class {
  constructor(r, e, t, n) {
    this.width = r, this.height = e, this.map = t, this.problems = n;
  }
  findCell(r) {
    for (let e = 0; e < this.map.length; e++) {
      const t = this.map[e];
      if (t != r)
        continue;
      const n = e % this.width, i = e / this.width | 0;
      let o = n + 1, a = i + 1;
      for (let s = 1; o < this.width && this.map[e + s] == t; s++)
        o++;
      for (let s = 1; a < this.height && this.map[e + this.width * s] == t; s++)
        a++;
      return { left: n, top: i, right: o, bottom: a };
    }
    throw new RangeError(`No cell with offset ${r} found`);
  }
  colCount(r) {
    for (let e = 0; e < this.map.length; e++)
      if (this.map[e] == r)
        return e % this.width;
    throw new RangeError(`No cell with offset ${r} found`);
  }
  nextCell(r, e, t) {
    const { left: n, right: i, top: o, bottom: a } = this.findCell(r);
    return e == "horiz" ? (t < 0 ? n == 0 : i == this.width) ? null : this.map[o * this.width + (t < 0 ? n - 1 : i)] : (t < 0 ? o == 0 : a == this.height) ? null : this.map[n + this.width * (t < 0 ? o - 1 : a)];
  }
  rectBetween(r, e) {
    const {
      left: t,
      right: n,
      top: i,
      bottom: o
    } = this.findCell(r), {
      left: a,
      right: s,
      top: l,
      bottom: c
    } = this.findCell(e);
    return {
      left: Math.min(t, a),
      top: Math.min(i, l),
      right: Math.max(n, s),
      bottom: Math.max(o, c)
    };
  }
  cellsInRect(r) {
    const e = [], t = {};
    for (let n = r.top; n < r.bottom; n++)
      for (let i = r.left; i < r.right; i++) {
        const o = n * this.width + i, a = this.map[o];
        t[a] || (t[a] = !0, !(i == r.left && i && this.map[o - 1] == a || n == r.top && n && this.map[o - this.width] == a) && e.push(a));
      }
    return e;
  }
  positionAt(r, e, t) {
    for (let n = 0, i = 0; ; n++) {
      const o = i + t.child(n).nodeSize;
      if (n == r) {
        let a = e + r * this.width;
        const s = (r + 1) * this.width;
        for (; a < s && this.map[a] < i; )
          a++;
        return a == s ? o - 1 : this.map[a];
      }
      i = o;
    }
  }
  static get(r) {
    return Qa(r) || es(r, ES(r));
  }
};
function ES(r) {
  if (r.type.spec.tableRole != "table")
    throw new RangeError("Not a table node: " + r.type.name);
  const e = AS(r), t = r.childCount, n = [];
  let i = 0, o = null;
  const a = [];
  for (let c = 0, u = e * t; c < u; c++)
    n[c] = 0;
  for (let c = 0, u = 0; c < t; c++) {
    const f = r.child(c);
    u++;
    for (let p = 0; ; p++) {
      for (; i < n.length && n[i] != 0; )
        i++;
      if (p == f.childCount)
        break;
      const m = f.child(p), { colspan: v, rowspan: y, colwidth: b } = m.attrs;
      for (let k = 0; k < y; k++) {
        if (k + c >= t) {
          (o || (o = [])).push({
            type: "overlong_rowspan",
            pos: u,
            n: y - k
          });
          break;
        }
        const M = i + k * e;
        for (let D = 0; D < v; D++) {
          n[M + D] == 0 ? n[M + D] = u : (o || (o = [])).push({
            type: "collision",
            row: c,
            pos: u,
            n: v - D
          });
          const T = b && b[D];
          if (T) {
            const z = (M + D) % e * 2, _ = a[z];
            _ == null || _ != T && a[z + 1] == 1 ? (a[z] = T, a[z + 1] = 1) : _ == T && a[z + 1]++;
          }
        }
      }
      i += v, u += m.nodeSize;
    }
    const h = (c + 1) * e;
    let d = 0;
    for (; i < h; )
      n[i++] == 0 && d++;
    d && (o || (o = [])).push({ type: "missing", row: c, n: d }), u++;
  }
  const s = new Te(e, t, n, o);
  let l = !1;
  for (let c = 0; !l && c < a.length; c += 2)
    a[c] != null && a[c + 1] < t && (l = !0);
  return l && NS(s, a, r), s;
}
function AS(r) {
  let e = -1, t = !1;
  for (let n = 0; n < r.childCount; n++) {
    const i = r.child(n);
    let o = 0;
    if (t)
      for (let a = 0; a < n; a++) {
        const s = r.child(a);
        for (let l = 0; l < s.childCount; l++) {
          const c = s.child(l);
          a + c.attrs.rowspan > n && (o += c.attrs.colspan);
        }
      }
    for (let a = 0; a < i.childCount; a++) {
      const s = i.child(a);
      o += s.attrs.colspan, s.attrs.rowspan > 1 && (t = !0);
    }
    e == -1 ? e = o : e != o && (e = Math.max(e, o));
  }
  return e;
}
function NS(r, e, t) {
  r.problems || (r.problems = []);
  const n = {};
  for (let i = 0; i < r.map.length; i++) {
    const o = r.map[i];
    if (n[o])
      continue;
    n[o] = !0;
    const a = t.nodeAt(o);
    if (!a)
      throw new RangeError(`No cell with offset ${o} found`);
    let s = null;
    const l = a.attrs;
    for (let c = 0; c < l.colspan; c++) {
      const u = (i + c) % r.width, f = e[u * 2];
      f != null && (!l.colwidth || l.colwidth[c] != f) && ((s || (s = RS(l)))[c] = f);
    }
    s && r.problems.unshift({
      type: "colwidth mismatch",
      pos: o,
      colwidth: s
    });
  }
}
function RS(r) {
  if (r.colwidth)
    return r.colwidth.slice();
  const e = [];
  for (let t = 0; t < r.colspan; t++)
    e.push(0);
  return e;
}
function qc(r, e) {
  if (typeof r == "string")
    return {};
  const t = r.getAttribute("data-colwidth"), n = t && /^\d+(,\d+)*$/.test(t) ? t.split(",").map((a) => Number(a)) : null, i = Number(r.getAttribute("colspan") || 1), o = {
    colspan: i,
    rowspan: Number(r.getAttribute("rowspan") || 1),
    colwidth: n && n.length == i ? n : null
  };
  for (const a in e) {
    const s = e[a].getFromDOM, l = s && s(r);
    l != null && (o[a] = l);
  }
  return o;
}
function Kc(r, e) {
  const t = {};
  r.attrs.colspan != 1 && (t.colspan = r.attrs.colspan), r.attrs.rowspan != 1 && (t.rowspan = r.attrs.rowspan), r.attrs.colwidth && (t["data-colwidth"] = r.attrs.colwidth.join(","));
  for (const n in e) {
    const i = e[n].setDOMAttr;
    i && i(r.attrs[n], t);
  }
  return t;
}
function PS(r) {
  const e = r.cellAttributes || {}, t = {
    colspan: { default: 1 },
    rowspan: { default: 1 },
    colwidth: { default: null }
  };
  for (const n in e)
    t[n] = { default: e[n].default };
  return {
    table: {
      content: "table_row+",
      tableRole: "table",
      isolating: !0,
      group: r.tableGroup,
      parseDOM: [{ tag: "table" }],
      toDOM() {
        return ["table", ["tbody", 0]];
      }
    },
    table_row: {
      content: "(table_cell | table_header)*",
      tableRole: "row",
      parseDOM: [{ tag: "tr" }],
      toDOM() {
        return ["tr", 0];
      }
    },
    table_cell: {
      content: r.cellContent,
      attrs: t,
      tableRole: "cell",
      isolating: !0,
      parseDOM: [
        { tag: "td", getAttrs: (n) => qc(n, e) }
      ],
      toDOM(n) {
        return ["td", Kc(n, e), 0];
      }
    },
    table_header: {
      content: r.cellContent,
      attrs: t,
      tableRole: "header_cell",
      isolating: !0,
      parseDOM: [
        { tag: "th", getAttrs: (n) => qc(n, e) }
      ],
      toDOM(n) {
        return ["th", Kc(n, e), 0];
      }
    }
  };
}
function He(r) {
  let e = r.cached.tableNodeTypes;
  if (!e) {
    e = r.cached.tableNodeTypes = {};
    for (const t in r.nodes) {
      const n = r.nodes[t], i = n.spec.tableRole;
      i && (e[i] = n);
    }
  }
  return e;
}
var dn = new Xe("selectingCells");
function fi(r) {
  for (let e = r.depth - 1; e > 0; e--)
    if (r.node(e).type.spec.tableRole == "row")
      return r.node(0).resolve(r.before(e + 1));
  return null;
}
function LS(r) {
  for (let e = r.depth; e > 0; e--) {
    const t = r.node(e).type.spec.tableRole;
    if (t === "cell" || t === "header_cell")
      return r.node(e);
  }
  return null;
}
function Vt(r) {
  const e = r.selection.$head;
  for (let t = e.depth; t > 0; t--)
    if (e.node(t).type.spec.tableRole == "row")
      return !0;
  return !1;
}
function hi(r) {
  const e = r.selection;
  if ("$anchorCell" in e && e.$anchorCell)
    return e.$anchorCell.pos > e.$headCell.pos ? e.$anchorCell : e.$headCell;
  if ("node" in e && e.node && e.node.type.spec.tableRole == "cell")
    return e.$anchor;
  const t = fi(e.$head) || FS(e.$head);
  if (t)
    return t;
  throw new RangeError(`No cell found around position ${e.head}`);
}
function FS(r) {
  for (let e = r.nodeAfter, t = r.pos; e; e = e.firstChild, t++) {
    const n = e.type.spec.tableRole;
    if (n == "cell" || n == "header_cell")
      return r.doc.resolve(t);
  }
  for (let e = r.nodeBefore, t = r.pos; e; e = e.lastChild, t--) {
    const n = e.type.spec.tableRole;
    if (n == "cell" || n == "header_cell")
      return r.doc.resolve(t - e.nodeSize);
  }
}
function Gc(r) {
  return r.parent.type.spec.tableRole == "row" && !!r.nodeAfter;
}
function zS(r) {
  return r.node(0).resolve(r.pos + r.nodeAfter.nodeSize);
}
function cl(r, e) {
  return r.depth == e.depth && r.pos >= e.start(-1) && r.pos <= e.end(-1);
}
function zh(r, e, t) {
  const n = r.node(-1), i = Te.get(n), o = r.start(-1), a = i.nextCell(r.pos - o, e, t);
  return a == null ? null : r.node(0).resolve(o + a);
}
function Gn(r, e, t = 1) {
  const n = { ...r, colspan: r.colspan - t };
  return n.colwidth && (n.colwidth = n.colwidth.slice(), n.colwidth.splice(e, t), n.colwidth.some((i) => i > 0) || (n.colwidth = null)), n;
}
function Bh(r, e, t = 1) {
  const n = { ...r, colspan: r.colspan + t };
  if (n.colwidth) {
    n.colwidth = n.colwidth.slice();
    for (let i = 0; i < t; i++)
      n.colwidth.splice(e, 0, 0);
  }
  return n;
}
function BS(r, e, t) {
  const n = He(e.type.schema).header_cell;
  for (let i = 0; i < r.height; i++)
    if (e.nodeAt(r.map[t + i * r.width]).type != n)
      return !1;
  return !0;
}
var ge = class extends ie {
  constructor(r, e = r) {
    const t = r.node(-1), n = Te.get(t), i = r.start(-1), o = n.rectBetween(
      r.pos - i,
      e.pos - i
    ), a = r.node(0), s = n.cellsInRect(o).filter((c) => c != e.pos - i);
    s.unshift(e.pos - i);
    const l = s.map((c) => {
      const u = t.nodeAt(c);
      if (!u)
        throw RangeError(`No cell with offset ${c} found`);
      const f = i + c + 1;
      return new xf(
        a.resolve(f),
        a.resolve(f + u.content.size)
      );
    });
    super(l[0].$from, l[0].$to, l), this.$anchorCell = r, this.$headCell = e;
  }
  map(r, e) {
    const t = r.resolve(e.map(this.$anchorCell.pos)), n = r.resolve(e.map(this.$headCell.pos));
    if (Gc(t) && Gc(n) && cl(t, n)) {
      const i = this.$anchorCell.node(-1) != t.node(-1);
      return i && this.isRowSelection() ? ge.rowSelection(t, n) : i && this.isColSelection() ? ge.colSelection(t, n) : new ge(t, n);
    }
    return oe.between(t, n);
  }
  content() {
    const r = this.$anchorCell.node(-1), e = Te.get(r), t = this.$anchorCell.start(-1), n = e.rectBetween(
      this.$anchorCell.pos - t,
      this.$headCell.pos - t
    ), i = {}, o = [];
    for (let s = n.top; s < n.bottom; s++) {
      const l = [];
      for (let c = s * e.width + n.left, u = n.left; u < n.right; u++, c++) {
        const f = e.map[c];
        if (i[f])
          continue;
        i[f] = !0;
        const h = e.findCell(f);
        let d = r.nodeAt(f);
        if (!d)
          throw RangeError(`No cell with offset ${f} found`);
        const p = n.left - h.left, m = h.right - n.right;
        if (p > 0 || m > 0) {
          let v = d.attrs;
          if (p > 0 && (v = Gn(v, 0, p)), m > 0 && (v = Gn(
            v,
            v.colspan - m,
            m
          )), h.left < n.left) {
            if (d = d.type.createAndFill(v), !d)
              throw RangeError(
                `Could not create cell with attrs ${JSON.stringify(v)}`
              );
          } else
            d = d.type.create(v, d.content);
        }
        if (h.top < n.top || h.bottom > n.bottom) {
          const v = {
            ...d.attrs,
            rowspan: Math.min(h.bottom, n.bottom) - Math.max(h.top, n.top)
          };
          h.top < n.top ? d = d.type.createAndFill(v) : d = d.type.create(v, d.content);
        }
        l.push(d);
      }
      o.push(r.child(s).copy(I.from(l)));
    }
    const a = this.isColSelection() && this.isRowSelection() ? r : o;
    return new $(I.from(a), 1, 1);
  }
  replace(r, e = $.empty) {
    const t = r.steps.length, n = this.ranges;
    for (let o = 0; o < n.length; o++) {
      const { $from: a, $to: s } = n[o], l = r.mapping.slice(t);
      r.replace(
        l.map(a.pos),
        l.map(s.pos),
        o ? $.empty : e
      );
    }
    const i = ie.findFrom(
      r.doc.resolve(r.mapping.slice(t).map(this.to)),
      -1
    );
    i && r.setSelection(i);
  }
  replaceWith(r, e) {
    this.replace(r, new $(I.from(e), 0, 0));
  }
  forEachCell(r) {
    const e = this.$anchorCell.node(-1), t = Te.get(e), n = this.$anchorCell.start(-1), i = t.cellsInRect(
      t.rectBetween(
        this.$anchorCell.pos - n,
        this.$headCell.pos - n
      )
    );
    for (let o = 0; o < i.length; o++)
      r(e.nodeAt(i[o]), n + i[o]);
  }
  isColSelection() {
    const r = this.$anchorCell.index(-1), e = this.$headCell.index(-1);
    if (Math.min(r, e) > 0)
      return !1;
    const t = r + this.$anchorCell.nodeAfter.attrs.rowspan, n = e + this.$headCell.nodeAfter.attrs.rowspan;
    return Math.max(t, n) == this.$headCell.node(-1).childCount;
  }
  static colSelection(r, e = r) {
    const t = r.node(-1), n = Te.get(t), i = r.start(-1), o = n.findCell(r.pos - i), a = n.findCell(e.pos - i), s = r.node(0);
    return o.top <= a.top ? (o.top > 0 && (r = s.resolve(i + n.map[o.left])), a.bottom < n.height && (e = s.resolve(
      i + n.map[n.width * (n.height - 1) + a.right - 1]
    ))) : (a.top > 0 && (e = s.resolve(i + n.map[a.left])), o.bottom < n.height && (r = s.resolve(
      i + n.map[n.width * (n.height - 1) + o.right - 1]
    ))), new ge(r, e);
  }
  isRowSelection() {
    const r = this.$anchorCell.node(-1), e = Te.get(r), t = this.$anchorCell.start(-1), n = e.colCount(this.$anchorCell.pos - t), i = e.colCount(this.$headCell.pos - t);
    if (Math.min(n, i) > 0)
      return !1;
    const o = n + this.$anchorCell.nodeAfter.attrs.colspan, a = i + this.$headCell.nodeAfter.attrs.colspan;
    return Math.max(o, a) == e.width;
  }
  eq(r) {
    return r instanceof ge && r.$anchorCell.pos == this.$anchorCell.pos && r.$headCell.pos == this.$headCell.pos;
  }
  static rowSelection(r, e = r) {
    const t = r.node(-1), n = Te.get(t), i = r.start(-1), o = n.findCell(r.pos - i), a = n.findCell(e.pos - i), s = r.node(0);
    return o.left <= a.left ? (o.left > 0 && (r = s.resolve(
      i + n.map[o.top * n.width]
    )), a.right < n.width && (e = s.resolve(
      i + n.map[n.width * (a.top + 1) - 1]
    ))) : (a.left > 0 && (e = s.resolve(i + n.map[a.top * n.width])), o.right < n.width && (r = s.resolve(
      i + n.map[n.width * (o.top + 1) - 1]
    ))), new ge(r, e);
  }
  toJSON() {
    return {
      type: "cell",
      anchor: this.$anchorCell.pos,
      head: this.$headCell.pos
    };
  }
  static fromJSON(r, e) {
    return new ge(r.resolve(e.anchor), r.resolve(e.head));
  }
  static create(r, e, t = e) {
    return new ge(r.resolve(e), r.resolve(t));
  }
  getBookmark() {
    return new $h(this.$anchorCell.pos, this.$headCell.pos);
  }
};
ge.prototype.visible = !1;
ie.jsonID("cell", ge);
var $h = class {
  constructor(r, e) {
    this.anchor = r, this.head = e;
  }
  map(r) {
    return new $h(r.map(this.anchor), r.map(this.head));
  }
  resolve(r) {
    const e = r.resolve(this.anchor), t = r.resolve(this.head);
    return e.parent.type.spec.tableRole == "row" && t.parent.type.spec.tableRole == "row" && e.index() < e.parent.childCount && t.index() < t.parent.childCount && cl(e, t) ? new ge(e, t) : ie.near(t, 1);
  }
};
function $S(r) {
  if (!(r.selection instanceof ge))
    return null;
  const e = [];
  return r.selection.forEachCell((t, n) => {
    e.push(
      Ae.node(n, n + t.nodeSize, { class: "selectedCell" })
    );
  }), fe.create(r.doc, e);
}
function HS({ $from: r, $to: e }) {
  if (r.pos == e.pos || r.pos < r.pos - 6)
    return !1;
  let t = r.pos, n = e.pos, i = r.depth;
  for (; i >= 0 && !(r.after(i + 1) < r.end(i)); i--, t++)
    ;
  for (let o = e.depth; o >= 0 && !(e.before(o + 1) > e.start(o)); o--, n--)
    ;
  return t == n && /row|table/.test(r.node(i).type.spec.tableRole);
}
function jS({ $from: r, $to: e }) {
  let t, n;
  for (let i = r.depth; i > 0; i--) {
    const o = r.node(i);
    if (o.type.spec.tableRole === "cell" || o.type.spec.tableRole === "header_cell") {
      t = o;
      break;
    }
  }
  for (let i = e.depth; i > 0; i--) {
    const o = e.node(i);
    if (o.type.spec.tableRole === "cell" || o.type.spec.tableRole === "header_cell") {
      n = o;
      break;
    }
  }
  return t !== n && e.parentOffset === 0;
}
function WS(r, e, t) {
  const n = (e || r).selection, i = (e || r).doc;
  let o, a;
  if (n instanceof te && (a = n.node.type.spec.tableRole)) {
    if (a == "cell" || a == "header_cell")
      o = ge.create(i, n.from);
    else if (a == "row") {
      const s = i.resolve(n.from + 1);
      o = ge.rowSelection(s, s);
    } else if (!t) {
      const s = Te.get(n.node), l = n.from + 1, c = l + s.map[s.width * s.height - 1];
      o = ge.create(i, l + 1, c);
    }
  } else
    n instanceof oe && HS(n) ? o = oe.create(i, n.from) : n instanceof oe && jS(n) && (o = oe.create(i, n.$from.start(), n.$from.end()));
  return o && (e || (e = r.tr)).setSelection(o), e;
}
var VS = new Xe("fix-tables");
function Hh(r, e, t, n) {
  const i = r.childCount, o = e.childCount;
  e:
    for (let a = 0, s = 0; a < o; a++) {
      const l = e.child(a);
      for (let c = s, u = Math.min(i, a + 3); c < u; c++)
        if (r.child(c) == l) {
          s = c + 1, t += l.nodeSize;
          continue e;
        }
      n(l, t), s < i && r.child(s).sameMarkup(l) ? Hh(r.child(s), l, t + 1, n) : l.nodesBetween(0, l.content.size, n, t + 1), t += l.nodeSize;
    }
}
function US(r, e) {
  let t;
  const n = (i, o) => {
    i.type.spec.tableRole == "table" && (t = qS(r, i, o, t));
  };
  return e ? e.doc != r.doc && Hh(e.doc, r.doc, 0, n) : r.doc.descendants(n), t;
}
function qS(r, e, t, n) {
  const i = Te.get(e);
  if (!i.problems)
    return n;
  n || (n = r.tr);
  const o = [];
  for (let l = 0; l < i.height; l++)
    o.push(0);
  for (let l = 0; l < i.problems.length; l++) {
    const c = i.problems[l];
    if (c.type == "collision") {
      const u = e.nodeAt(c.pos);
      if (!u)
        continue;
      const f = u.attrs;
      for (let h = 0; h < f.rowspan; h++)
        o[c.row + h] += c.n;
      n.setNodeMarkup(
        n.mapping.map(t + 1 + c.pos),
        null,
        Gn(f, f.colspan - c.n, c.n)
      );
    } else if (c.type == "missing")
      o[c.row] += c.n;
    else if (c.type == "overlong_rowspan") {
      const u = e.nodeAt(c.pos);
      if (!u)
        continue;
      n.setNodeMarkup(n.mapping.map(t + 1 + c.pos), null, {
        ...u.attrs,
        rowspan: u.attrs.rowspan - c.n
      });
    } else if (c.type == "colwidth mismatch") {
      const u = e.nodeAt(c.pos);
      if (!u)
        continue;
      n.setNodeMarkup(n.mapping.map(t + 1 + c.pos), null, {
        ...u.attrs,
        colwidth: c.colwidth
      });
    }
  }
  let a, s;
  for (let l = 0; l < o.length; l++)
    o[l] && (a == null && (a = l), s = l);
  for (let l = 0, c = t + 1; l < i.height; l++) {
    const u = e.child(l), f = c + u.nodeSize, h = o[l];
    if (h > 0) {
      let d = "cell";
      u.firstChild && (d = u.firstChild.type.spec.tableRole);
      const p = [];
      for (let v = 0; v < h; v++) {
        const y = He(r.schema)[d].createAndFill();
        y && p.push(y);
      }
      const m = (l == 0 || a == l - 1) && s == l ? c + 1 : f - 1;
      n.insert(n.mapping.map(m), p);
    }
    c = f;
  }
  return n.setMeta(VS, { fixTables: !0 });
}
function KS(r) {
  if (!r.size)
    return null;
  let { content: e, openStart: t, openEnd: n } = r;
  for (; e.childCount == 1 && (t > 0 && n > 0 || e.child(0).type.spec.tableRole == "table"); )
    t--, n--, e = e.child(0).content;
  const i = e.child(0), o = i.type.spec.tableRole, a = i.type.schema, s = [];
  if (o == "row")
    for (let l = 0; l < e.childCount; l++) {
      let c = e.child(l).content;
      const u = l ? 0 : Math.max(0, t - 1), f = l < e.childCount - 1 ? 0 : Math.max(0, n - 1);
      (u || f) && (c = ts(
        He(a).row,
        new $(c, u, f)
      ).content), s.push(c);
    }
  else if (o == "cell" || o == "header_cell")
    s.push(
      t || n ? ts(
        He(a).row,
        new $(e, t, n)
      ).content : e
    );
  else
    return null;
  return GS(a, s);
}
function GS(r, e) {
  const t = [];
  for (let i = 0; i < e.length; i++) {
    const o = e[i];
    for (let a = o.childCount - 1; a >= 0; a--) {
      const { rowspan: s, colspan: l } = o.child(a).attrs;
      for (let c = i; c < i + s; c++)
        t[c] = (t[c] || 0) + l;
    }
  }
  let n = 0;
  for (let i = 0; i < t.length; i++)
    n = Math.max(n, t[i]);
  for (let i = 0; i < t.length; i++)
    if (i >= e.length && e.push(I.empty), t[i] < n) {
      const o = He(r).cell.createAndFill(), a = [];
      for (let s = t[i]; s < n; s++)
        a.push(o);
      e[i] = e[i].append(I.from(a));
    }
  return { height: e.length, width: n, rows: e };
}
function ts(r, e) {
  const t = r.createAndFill();
  return new kf(t).replace(0, t.content.size, e).doc;
}
function JS({ width: r, height: e, rows: t }, n, i) {
  if (r != n) {
    const o = [], a = [];
    for (let s = 0; s < t.length; s++) {
      const l = t[s], c = [];
      for (let u = o[s] || 0, f = 0; u < n; f++) {
        let h = l.child(f % l.childCount);
        u + h.attrs.colspan > n && (h = h.type.createChecked(
          Gn(
            h.attrs,
            h.attrs.colspan,
            u + h.attrs.colspan - n
          ),
          h.content
        )), c.push(h), u += h.attrs.colspan;
        for (let d = 1; d < h.attrs.rowspan; d++)
          o[s + d] = (o[s + d] || 0) + h.attrs.colspan;
      }
      a.push(I.from(c));
    }
    t = a, r = n;
  }
  if (e != i) {
    const o = [];
    for (let a = 0, s = 0; a < i; a++, s++) {
      const l = [], c = t[s % e];
      for (let u = 0; u < c.childCount; u++) {
        let f = c.child(u);
        a + f.attrs.rowspan > i && (f = f.type.create(
          {
            ...f.attrs,
            rowspan: Math.max(1, i - f.attrs.rowspan)
          },
          f.content
        )), l.push(f);
      }
      o.push(I.from(l));
    }
    t = o, e = i;
  }
  return { width: r, height: e, rows: t };
}
function XS(r, e, t, n, i, o, a) {
  const s = r.doc.type.schema, l = He(s);
  let c, u;
  if (i > e.width)
    for (let f = 0, h = 0; f < e.height; f++) {
      const d = t.child(f);
      h += d.nodeSize;
      const p = [];
      let m;
      d.lastChild == null || d.lastChild.type == l.cell ? m = c || (c = l.cell.createAndFill()) : m = u || (u = l.header_cell.createAndFill());
      for (let v = e.width; v < i; v++)
        p.push(m);
      r.insert(r.mapping.slice(a).map(h - 1 + n), p);
    }
  if (o > e.height) {
    const f = [];
    for (let p = 0, m = (e.height - 1) * e.width; p < Math.max(e.width, i); p++) {
      const v = p >= e.width ? !1 : t.nodeAt(e.map[m + p]).type == l.header_cell;
      f.push(
        v ? u || (u = l.header_cell.createAndFill()) : c || (c = l.cell.createAndFill())
      );
    }
    const h = l.row.create(null, I.from(f)), d = [];
    for (let p = e.height; p < o; p++)
      d.push(h);
    r.insert(r.mapping.slice(a).map(n + t.nodeSize - 2), d);
  }
  return !!(c || u);
}
function Jc(r, e, t, n, i, o, a, s) {
  if (a == 0 || a == e.height)
    return !1;
  let l = !1;
  for (let c = i; c < o; c++) {
    const u = a * e.width + c, f = e.map[u];
    if (e.map[u - e.width] == f) {
      l = !0;
      const h = t.nodeAt(f), { top: d, left: p } = e.findCell(f);
      r.setNodeMarkup(r.mapping.slice(s).map(f + n), null, {
        ...h.attrs,
        rowspan: a - d
      }), r.insert(
        r.mapping.slice(s).map(e.positionAt(a, p, t)),
        h.type.createAndFill({
          ...h.attrs,
          rowspan: d + h.attrs.rowspan - a
        })
      ), c += h.attrs.colspan - 1;
    }
  }
  return l;
}
function Xc(r, e, t, n, i, o, a, s) {
  if (a == 0 || a == e.width)
    return !1;
  let l = !1;
  for (let c = i; c < o; c++) {
    const u = c * e.width + a, f = e.map[u];
    if (e.map[u - 1] == f) {
      l = !0;
      const h = t.nodeAt(f), d = e.colCount(f), p = r.mapping.slice(s).map(f + n);
      r.setNodeMarkup(
        p,
        null,
        Gn(
          h.attrs,
          a - d,
          h.attrs.colspan - (a - d)
        )
      ), r.insert(
        p + h.nodeSize,
        h.type.createAndFill(
          Gn(h.attrs, 0, a - d)
        )
      ), c += h.attrs.rowspan - 1;
    }
  }
  return l;
}
function Yc(r, e, t, n, i) {
  let o = t ? r.doc.nodeAt(t - 1) : r.doc;
  if (!o)
    throw new Error("No table found");
  let a = Te.get(o);
  const { top: s, left: l } = n, c = l + i.width, u = s + i.height, f = r.tr;
  let h = 0;
  function d() {
    if (o = t ? f.doc.nodeAt(t - 1) : f.doc, !o)
      throw new Error("No table found");
    a = Te.get(o), h = f.mapping.maps.length;
  }
  XS(f, a, o, t, c, u, h) && d(), Jc(f, a, o, t, l, c, s, h) && d(), Jc(f, a, o, t, l, c, u, h) && d(), Xc(f, a, o, t, s, u, l, h) && d(), Xc(f, a, o, t, s, u, c, h) && d();
  for (let p = s; p < u; p++) {
    const m = a.positionAt(p, l, o), v = a.positionAt(p, c, o);
    f.replace(
      f.mapping.slice(h).map(m + t),
      f.mapping.slice(h).map(v + t),
      new $(i.rows[p - s], 0, 0)
    );
  }
  d(), f.setSelection(
    new ge(
      f.doc.resolve(t + a.positionAt(s, l, o)),
      f.doc.resolve(t + a.positionAt(u - 1, c - 1, o))
    )
  ), e(f);
}
var YS = ll({
  ArrowLeft: Si("horiz", -1),
  ArrowRight: Si("horiz", 1),
  ArrowUp: Si("vert", -1),
  ArrowDown: Si("vert", 1),
  "Shift-ArrowLeft": Ci("horiz", -1),
  "Shift-ArrowRight": Ci("horiz", 1),
  "Shift-ArrowUp": Ci("vert", -1),
  "Shift-ArrowDown": Ci("vert", 1),
  Backspace: ki,
  "Mod-Backspace": ki,
  Delete: ki,
  "Mod-Delete": ki
});
function Di(r, e, t) {
  return t.eq(r.selection) ? !1 : (e && e(r.tr.setSelection(t).scrollIntoView()), !0);
}
function Si(r, e) {
  return (t, n, i) => {
    if (!i)
      return !1;
    const o = t.selection;
    if (o instanceof ge)
      return Di(
        t,
        n,
        ie.near(o.$headCell, e)
      );
    if (r != "horiz" && !o.empty)
      return !1;
    const a = jh(i, r, e);
    if (a == null)
      return !1;
    if (r == "horiz")
      return Di(
        t,
        n,
        ie.near(t.doc.resolve(o.head + e), e)
      );
    {
      const s = t.doc.resolve(a), l = zh(s, r, e);
      let c;
      return l ? c = ie.near(l, 1) : e < 0 ? c = ie.near(t.doc.resolve(s.before(-1)), -1) : c = ie.near(t.doc.resolve(s.after(-1)), 1), Di(t, n, c);
    }
  };
}
function Ci(r, e) {
  return (t, n, i) => {
    if (!i)
      return !1;
    const o = t.selection;
    let a;
    if (o instanceof ge)
      a = o;
    else {
      const l = jh(i, r, e);
      if (l == null)
        return !1;
      a = new ge(t.doc.resolve(l));
    }
    const s = zh(a.$headCell, r, e);
    return s ? Di(
      t,
      n,
      new ge(a.$anchorCell, s)
    ) : !1;
  };
}
function ki(r, e) {
  const t = r.selection;
  if (!(t instanceof ge))
    return !1;
  if (e) {
    const n = r.tr, i = He(r.schema).cell.createAndFill().content;
    t.forEachCell((o, a) => {
      o.content.eq(i) || n.replace(
        n.mapping.map(a + 1),
        n.mapping.map(a + o.nodeSize - 1),
        new $(i, 0, 0)
      );
    }), n.docChanged && e(n);
  }
  return !0;
}
function ZS(r, e) {
  const t = r.state.doc, n = fi(t.resolve(e));
  return n ? (r.dispatch(r.state.tr.setSelection(new ge(n))), !0) : !1;
}
function QS(r, e, t) {
  if (!Vt(r.state))
    return !1;
  let n = KS(t);
  const i = r.state.selection;
  if (i instanceof ge) {
    n || (n = {
      width: 1,
      height: 1,
      rows: [
        I.from(
          ts(He(r.state.schema).cell, t)
        )
      ]
    });
    const o = i.$anchorCell.node(-1), a = i.$anchorCell.start(-1), s = Te.get(o).rectBetween(
      i.$anchorCell.pos - a,
      i.$headCell.pos - a
    );
    return n = JS(n, s.right - s.left, s.bottom - s.top), Yc(r.state, r.dispatch, a, s, n), !0;
  } else if (n) {
    const o = hi(r.state), a = o.start(-1);
    return Yc(
      r.state,
      r.dispatch,
      a,
      Te.get(o.node(-1)).findCell(o.pos - a),
      n
    ), !0;
  } else
    return !1;
}
function eC(r, e) {
  var t;
  if (e.ctrlKey || e.metaKey)
    return;
  const n = Zc(r, e.target);
  let i;
  if (e.shiftKey && r.state.selection instanceof ge)
    o(r.state.selection.$anchorCell, e), e.preventDefault();
  else if (e.shiftKey && n && (i = fi(r.state.selection.$anchor)) != null && ((t = fa(r, e)) == null ? void 0 : t.pos) != i.pos)
    o(i, e), e.preventDefault();
  else if (!n)
    return;
  function o(l, c) {
    let u = fa(r, c);
    const f = dn.getState(r.state) == null;
    if (!u || !cl(l, u))
      if (f)
        u = l;
      else
        return;
    const h = new ge(l, u);
    if (f || !r.state.selection.eq(h)) {
      const d = r.state.tr.setSelection(h);
      f && d.setMeta(dn, l.pos), r.dispatch(d);
    }
  }
  function a() {
    r.root.removeEventListener("mouseup", a), r.root.removeEventListener("dragstart", a), r.root.removeEventListener("mousemove", s), dn.getState(r.state) != null && r.dispatch(r.state.tr.setMeta(dn, -1));
  }
  function s(l) {
    const c = l, u = dn.getState(r.state);
    let f;
    if (u != null)
      f = r.state.doc.resolve(u);
    else if (Zc(r, c.target) != n && (f = fa(r, e), !f))
      return a();
    f && o(f, c);
  }
  r.root.addEventListener("mouseup", a), r.root.addEventListener("dragstart", a), r.root.addEventListener("mousemove", s);
}
function jh(r, e, t) {
  if (!(r.state.selection instanceof oe))
    return null;
  const { $head: n } = r.state.selection;
  for (let i = n.depth - 1; i >= 0; i--) {
    const o = n.node(i);
    if ((t < 0 ? n.index(i) : n.indexAfter(i)) != (t < 0 ? 0 : o.childCount))
      return null;
    if (o.type.spec.tableRole == "cell" || o.type.spec.tableRole == "header_cell") {
      const s = n.before(i), l = e == "vert" ? t > 0 ? "down" : "up" : t > 0 ? "right" : "left";
      return r.endOfTextblock(l) ? s : null;
    }
  }
  return null;
}
function Zc(r, e) {
  for (; e && e != r.dom; e = e.parentNode)
    if (e.nodeName == "TD" || e.nodeName == "TH")
      return e;
  return null;
}
function fa(r, e) {
  const t = r.posAtCoords({
    left: e.clientX,
    top: e.clientY
  });
  return t && t ? fi(r.state.doc.resolve(t.pos)) : null;
}
new Xe(
  "tableColumnResizing"
);
function Ut(r) {
  const e = r.selection, t = hi(r), n = t.node(-1), i = t.start(-1), o = Te.get(n);
  return { ...e instanceof ge ? o.rectBetween(
    e.$anchorCell.pos - i,
    e.$headCell.pos - i
  ) : o.findCell(t.pos - i), tableStart: i, map: o, table: n };
}
function Wh(r, { map: e, tableStart: t, table: n }, i) {
  let o = i > 0 ? -1 : 0;
  BS(e, n, i + o) && (o = i == 0 || i == e.width ? null : 0);
  for (let a = 0; a < e.height; a++) {
    const s = a * e.width + i;
    if (i > 0 && i < e.width && e.map[s - 1] == e.map[s]) {
      const l = e.map[s], c = n.nodeAt(l);
      r.setNodeMarkup(
        r.mapping.map(t + l),
        null,
        Bh(c.attrs, i - e.colCount(l))
      ), a += c.attrs.rowspan - 1;
    } else {
      const l = o == null ? He(n.type.schema).cell : n.nodeAt(e.map[s + o]).type, c = e.positionAt(a, i, n);
      r.insert(r.mapping.map(t + c), l.createAndFill());
    }
  }
  return r;
}
function tC(r, e) {
  if (!Vt(r))
    return !1;
  if (e) {
    const t = Ut(r);
    e(Wh(r.tr, t, t.left));
  }
  return !0;
}
function nC(r, e) {
  if (!Vt(r))
    return !1;
  if (e) {
    const t = Ut(r);
    e(Wh(r.tr, t, t.right));
  }
  return !0;
}
function rC(r, { map: e, table: t, tableStart: n }, i) {
  const o = r.mapping.maps.length;
  for (let a = 0; a < e.height; ) {
    const s = a * e.width + i, l = e.map[s], c = t.nodeAt(l), u = c.attrs;
    if (i > 0 && e.map[s - 1] == l || i < e.width - 1 && e.map[s + 1] == l)
      r.setNodeMarkup(
        r.mapping.slice(o).map(n + l),
        null,
        Gn(u, i - e.colCount(l))
      );
    else {
      const f = r.mapping.slice(o).map(n + l);
      r.delete(f, f + c.nodeSize);
    }
    a += u.rowspan;
  }
}
function iC(r, e) {
  if (!Vt(r))
    return !1;
  if (e) {
    const t = Ut(r), n = r.tr;
    if (t.left == 0 && t.right == t.map.width)
      return !1;
    for (let i = t.right - 1; rC(n, t, i), i != t.left; i--) {
      const o = t.tableStart ? n.doc.nodeAt(t.tableStart - 1) : n.doc;
      if (!o)
        throw RangeError("No table found");
      t.table = o, t.map = Te.get(o);
    }
    e(n);
  }
  return !0;
}
function oC(r, e, t) {
  var n;
  const i = He(e.type.schema).header_cell;
  for (let o = 0; o < r.width; o++)
    if (((n = e.nodeAt(r.map[o + t * r.width])) == null ? void 0 : n.type) != i)
      return !1;
  return !0;
}
function Vh(r, { map: e, tableStart: t, table: n }, i) {
  var o;
  let a = t;
  for (let c = 0; c < i; c++)
    a += n.child(c).nodeSize;
  const s = [];
  let l = i > 0 ? -1 : 0;
  oC(e, n, i + l) && (l = i == 0 || i == e.height ? null : 0);
  for (let c = 0, u = e.width * i; c < e.width; c++, u++)
    if (i > 0 && i < e.height && e.map[u] == e.map[u - e.width]) {
      const f = e.map[u], h = n.nodeAt(f).attrs;
      r.setNodeMarkup(t + f, null, {
        ...h,
        rowspan: h.rowspan + 1
      }), c += h.colspan - 1;
    } else {
      const f = l == null ? He(n.type.schema).cell : (o = n.nodeAt(e.map[u + l * e.width])) == null ? void 0 : o.type, h = f == null ? void 0 : f.createAndFill();
      h && s.push(h);
    }
  return r.insert(a, He(n.type.schema).row.create(null, s)), r;
}
function aC(r, e) {
  if (!Vt(r))
    return !1;
  if (e) {
    const t = Ut(r);
    e(Vh(r.tr, t, t.top));
  }
  return !0;
}
function sC(r, e) {
  if (!Vt(r))
    return !1;
  if (e) {
    const t = Ut(r);
    e(Vh(r.tr, t, t.bottom));
  }
  return !0;
}
function lC(r, { map: e, table: t, tableStart: n }, i) {
  let o = 0;
  for (let l = 0; l < i; l++)
    o += t.child(l).nodeSize;
  const a = o + t.child(i).nodeSize, s = r.mapping.maps.length;
  r.delete(o + n, a + n);
  for (let l = 0, c = i * e.width; l < e.width; l++, c++) {
    const u = e.map[c];
    if (i > 0 && u == e.map[c - e.width]) {
      const f = t.nodeAt(u).attrs;
      r.setNodeMarkup(r.mapping.slice(s).map(u + n), null, {
        ...f,
        rowspan: f.rowspan - 1
      }), l += f.colspan - 1;
    } else if (i < e.width && u == e.map[c + e.width]) {
      const f = t.nodeAt(u), h = f.attrs, d = f.type.create(
        { ...h, rowspan: f.attrs.rowspan - 1 },
        f.content
      ), p = e.positionAt(i + 1, l, t);
      r.insert(r.mapping.slice(s).map(n + p), d), l += h.colspan - 1;
    }
  }
}
function cC(r, e) {
  if (!Vt(r))
    return !1;
  if (e) {
    const t = Ut(r), n = r.tr;
    if (t.top == 0 && t.bottom == t.map.height)
      return !1;
    for (let i = t.bottom - 1; lC(n, t, i), i != t.top; i--) {
      const o = t.tableStart ? n.doc.nodeAt(t.tableStart - 1) : n.doc;
      if (!o)
        throw RangeError("No table found");
      t.table = o, t.map = Te.get(t.table);
    }
    e(n);
  }
  return !0;
}
function Qc(r) {
  const e = r.content;
  return e.childCount == 1 && e.child(0).isTextblock && e.child(0).childCount == 0;
}
function uC({ width: r, height: e, map: t }, n) {
  let i = n.top * r + n.left, o = i, a = (n.bottom - 1) * r + n.left, s = i + (n.right - n.left - 1);
  for (let l = n.top; l < n.bottom; l++) {
    if (n.left > 0 && t[o] == t[o - 1] || n.right < r && t[s] == t[s + 1])
      return !0;
    o += r, s += r;
  }
  for (let l = n.left; l < n.right; l++) {
    if (n.top > 0 && t[i] == t[i - r] || n.bottom < e && t[a] == t[a + r])
      return !0;
    i++, a++;
  }
  return !1;
}
function fC(r, e) {
  const t = r.selection;
  if (!(t instanceof ge) || t.$anchorCell.pos == t.$headCell.pos)
    return !1;
  const n = Ut(r), { map: i } = n;
  if (uC(i, n))
    return !1;
  if (e) {
    const o = r.tr, a = {};
    let s = I.empty, l, c;
    for (let u = n.top; u < n.bottom; u++)
      for (let f = n.left; f < n.right; f++) {
        const h = i.map[u * i.width + f], d = n.table.nodeAt(h);
        if (!(a[h] || !d))
          if (a[h] = !0, l == null)
            l = h, c = d;
          else {
            Qc(d) || (s = s.append(d.content));
            const p = o.mapping.map(h + n.tableStart);
            o.delete(p, p + d.nodeSize);
          }
      }
    if (l == null || c == null)
      return !0;
    if (o.setNodeMarkup(l + n.tableStart, null, {
      ...Bh(
        c.attrs,
        c.attrs.colspan,
        n.right - n.left - c.attrs.colspan
      ),
      rowspan: n.bottom - n.top
    }), s.size) {
      const u = l + 1 + c.content.size, f = Qc(c) ? l + 1 : u;
      o.replaceWith(f + n.tableStart, u + n.tableStart, s);
    }
    o.setSelection(
      new ge(o.doc.resolve(l + n.tableStart))
    ), e(o);
  }
  return !0;
}
function hC(r, e) {
  const t = He(r.schema);
  return dC(({ node: n }) => t[n.type.spec.tableRole])(r, e);
}
function dC(r) {
  return (e, t) => {
    var n;
    const i = e.selection;
    let o, a;
    if (i instanceof ge) {
      if (i.$anchorCell.pos != i.$headCell.pos)
        return !1;
      o = i.$anchorCell.nodeAfter, a = i.$anchorCell.pos;
    } else {
      if (o = LS(i.$from), !o)
        return !1;
      a = (n = fi(i.$from)) == null ? void 0 : n.pos;
    }
    if (o == null || a == null || o.attrs.colspan == 1 && o.attrs.rowspan == 1)
      return !1;
    if (t) {
      let s = o.attrs;
      const l = [], c = s.colwidth;
      s.rowspan > 1 && (s = { ...s, rowspan: 1 }), s.colspan > 1 && (s = { ...s, colspan: 1 });
      const u = Ut(e), f = e.tr;
      for (let d = 0; d < u.right - u.left; d++)
        l.push(
          c ? {
            ...s,
            colwidth: c && c[d] ? [c[d]] : null
          } : s
        );
      let h;
      for (let d = u.top; d < u.bottom; d++) {
        let p = u.map.positionAt(d, u.left, u.table);
        d == u.top && (p += o.nodeSize);
        for (let m = u.left, v = 0; m < u.right; m++, v++)
          m == u.left && d == u.top || f.insert(
            h = f.mapping.map(p + u.tableStart, 1),
            r({ node: o, row: d, col: m }).createAndFill(l[v])
          );
      }
      f.setNodeMarkup(
        a,
        r({ node: o, row: u.top, col: u.left }),
        l[0]
      ), i instanceof ge && f.setSelection(
        new ge(
          f.doc.resolve(i.$anchorCell.pos),
          h ? f.doc.resolve(h) : void 0
        )
      ), t(f);
    }
    return !0;
  };
}
function pC(r) {
  return function(e, t) {
    if (!Vt(e))
      return !1;
    if (t) {
      const n = He(e.schema), i = Ut(e), o = e.tr, a = i.map.cellsInRect(
        r == "column" ? {
          left: i.left,
          top: 0,
          right: i.right,
          bottom: i.map.height
        } : r == "row" ? {
          left: 0,
          top: i.top,
          right: i.map.width,
          bottom: i.bottom
        } : i
      ), s = a.map((l) => i.table.nodeAt(l));
      for (let l = 0; l < a.length; l++)
        s[l].type == n.header_cell && o.setNodeMarkup(
          i.tableStart + a[l],
          n.cell,
          s[l].attrs
        );
      if (o.steps.length == 0)
        for (let l = 0; l < a.length; l++)
          o.setNodeMarkup(
            i.tableStart + a[l],
            n.header_cell,
            s[l].attrs
          );
      t(o);
    }
    return !0;
  };
}
function eu(r, e, t) {
  const n = e.map.cellsInRect({
    left: 0,
    top: 0,
    right: r == "row" ? e.map.width : 1,
    bottom: r == "column" ? e.map.height : 1
  });
  for (let i = 0; i < n.length; i++) {
    const o = e.table.nodeAt(n[i]);
    if (o && o.type !== t.header_cell)
      return !1;
  }
  return !0;
}
function ul(r, e) {
  return e = e || { useDeprecatedLogic: !1 }, e.useDeprecatedLogic ? pC(r) : function(t, n) {
    if (!Vt(t))
      return !1;
    if (n) {
      const i = He(t.schema), o = Ut(t), a = t.tr, s = eu("row", o, i), l = eu(
        "column",
        o,
        i
      ), u = (r === "column" ? s : r === "row" ? l : !1) ? 1 : 0, f = r == "column" ? {
        left: 0,
        top: u,
        right: 1,
        bottom: o.map.height
      } : r == "row" ? {
        left: u,
        top: 0,
        right: o.map.width,
        bottom: 1
      } : o, h = r == "column" ? l ? i.cell : i.header_cell : r == "row" ? s ? i.cell : i.header_cell : i.cell;
      o.map.cellsInRect(f).forEach((d) => {
        const p = d + o.tableStart, m = a.doc.nodeAt(p);
        m && a.setNodeMarkup(p, h, m.attrs);
      }), n(a);
    }
    return !0;
  };
}
ul("row", {
  useDeprecatedLogic: !0
});
ul("column", {
  useDeprecatedLogic: !0
});
ul("cell", {
  useDeprecatedLogic: !0
});
function mC(r, e) {
  if (e < 0) {
    const t = r.nodeBefore;
    if (t)
      return r.pos - t.nodeSize;
    for (let n = r.index(-1) - 1, i = r.before(); n >= 0; n--) {
      const o = r.node(-1).child(n), a = o.lastChild;
      if (a)
        return i - 1 - a.nodeSize;
      i -= o.nodeSize;
    }
  } else {
    if (r.index() < r.parent.childCount - 1)
      return r.pos + r.nodeAfter.nodeSize;
    const t = r.node(-1);
    for (let n = r.indexAfter(-1), i = r.after(); n < t.childCount; n++) {
      const o = t.child(n);
      if (o.childCount)
        return i + 1;
      i += o.nodeSize;
    }
  }
  return null;
}
function tu(r) {
  return function(e, t) {
    if (!Vt(e))
      return !1;
    const n = mC(hi(e), r);
    if (n == null)
      return !1;
    if (t) {
      const i = e.doc.resolve(n);
      t(
        e.tr.setSelection(oe.between(i, zS(i))).scrollIntoView()
      );
    }
    return !0;
  };
}
function gC(r, e) {
  const t = r.selection.$anchor;
  for (let n = t.depth; n > 0; n--)
    if (t.node(n).type.spec.tableRole == "table")
      return e && e(
        r.tr.delete(t.before(n), t.after(n)).scrollIntoView()
      ), !0;
  return !1;
}
function vC({
  allowTableNodeSelection: r = !1
} = {}) {
  return new Ge({
    key: dn,
    state: {
      init() {
        return null;
      },
      apply(e, t) {
        const n = e.getMeta(dn);
        if (n != null)
          return n == -1 ? null : n;
        if (t == null || !e.docChanged)
          return t;
        const { deleted: i, pos: o } = e.mapping.mapResult(t);
        return i ? null : o;
      }
    },
    props: {
      decorations: $S,
      handleDOMEvents: {
        mousedown: eC
      },
      createSelectionBetween(e) {
        return dn.getState(e.state) != null ? e.state.selection : null;
      },
      handleTripleClick: ZS,
      handleKeyDown: YS,
      handlePaste: QS
    },
    appendTransaction(e, t, n) {
      return WS(
        n,
        US(n, t),
        r
      );
    }
  });
}
var Be = 0, yC = ["blockquote", Be], wC = ["hr"], bC = ["pre", ["code", Be]], SC = ["ol", 0], CC = ["ul", 0], kC = ["li", 0], xe = function(r) {
  for (var e = {}, t = r.attributes, n, i = 0; i < t.length; i++)
    n = t[i], e[n.name] = n.value;
  return e;
}, ni = function(r) {
  var e = {};
  return r.forEach(function(t) {
    e[t] = { default: null };
  }), e;
}, Ct = function() {
  return ni(["style", "class", "id"]);
}, kt = function(r, e) {
  for (var t in r)
    if (t && r[t] !== null && t !== e)
      return !0;
  return !1;
}, et = function(r, e) {
  e === void 0 && (e = []);
  var t = {}, n = function(o) {
    o && r[o] !== null && !e.find(function(a) {
      return a === o;
    }) && (t[o] = r[o]);
  };
  for (var i in r)
    n(i);
  return t;
}, Kt = function(r) {
  var e;
  return e = {}, e[r] = {
    name: r,
    inclusive: !0,
    parseDOM: [{ tag: r }],
    toDOM: function() {
      return [r, Be];
    }
  }, e;
}, Uh = A(A(A(A(A(A(A(A(A(A({
  // :: MarkSpec A link. Has `href` and `title` attributes. `title`
  // defaults to the empty string. Rendered and parsed as an `<a>`
  // element.
  link: {
    attrs: A(A({}, Ct()), { href: { default: null }, target: { default: null }, title: { default: null } }),
    inclusive: !1,
    parseDOM: [{ tag: "a", getAttrs: xe }],
    toDOM: function(r) {
      return ["a", et(r.attrs), Be];
    }
  }
}, Kt("strong")), Kt("b")), Kt("em")), Kt("i")), Kt("u")), Kt("del")), Kt("sub")), Kt("sup")), Kt("code")), { style: {
  attrs: A({}, Ct()),
  parseDOM: [{
    tag: "span",
    getAttrs: xe
  }],
  toDOM: function(r) {
    return kt(r.attrs) ? ["span", et(r.attrs), Be] : ["span", Be];
  }
} }), xi = function(r) {
  var e;
  return e = {}, e[r] = {
    default: null,
    getFromDOM: function(t) {
      return t.getAttribute(r);
    },
    setDOMAttr: function(t, n) {
      n[r] = t;
    }
  }, e;
}, xC = A(A(A(A({}, xi("style")), xi("class")), xi("id")), xi("headers")), OC = {
  doc: { content: "colgroup*" },
  col: {
    attrs: ni(["id", "class", "style", "span"]),
    parseDOM: [{ getAttrs: xe, tag: "col" }],
    toDOM: function(r) {
      return ["col", r.attrs];
    }
  },
  colgroup: {
    attrs: ni(["id", "class", "style", "span"]),
    content: "col*",
    parseDOM: [{ getAttrs: xe, tag: "colgroup" }],
    toDOM: function(r) {
      return ["colgroup", r.attrs, 0];
    }
  },
  text: { inline: !0, group: "inline" }
}, TC = new uf({ nodes: OC, marks: {} }), MC = function(r) {
  for (var e = !1, t = r.child(0), n = 0; n < t.childCount; n++) {
    var i = t.child(n);
    if (i.attrs.colwidth) {
      e = !0;
      break;
    }
  }
  return e;
}, So = function(r) {
  var e = Ef(li(r), TC, { preserveWhitespace: !1 }), t = Df(e), n = t.firstChild;
  return n;
}, tn = PS({ tableGroup: "block", cellContent: "block+", cellAttributes: xC });
tn.table_row.attrs = A(A({}, tn.table_row.attrs), ni([$t, "style", "class", "id"]));
tn.table_row.toDOM = function(r) {
  return ["tr", et(r.attrs), 0];
};
tn.table_row.parseDOM = [{ tag: "tr", getAttrs: xe }];
tn.table.attrs = A(A({}, tn.table.attrs), ni(["style", "class", "id", we, Lt]));
tn.table.toDOM = function(r) {
  var e = kt(r.attrs) ? et(r.attrs, [we, Lt]) : {}, t = null;
  if (r.attrs[we] && !MC(r)) {
    var n = So(r.attrs[we]);
    if (n) {
      var i = Array.from(n.children).map(function(o) {
        return ["col", xe(o)];
      });
      t = [
        "colgroup",
        xe(n)
      ].concat(i);
    }
  }
  return t ? ["table", e, t, ["tbody", 0]] : ["table", e, ["tbody", 0]];
};
tn.table.parseDOM = [{
  tag: "table",
  getAttrs: function(r) {
    var e = xe(r), t = Array.from(r.childNodes).find(function(n) {
      return n.nodeName === "COLGROUP";
    });
    return t && (e[we] = t.outerHTML), e;
  }
}];
var qh = A({
  // :: NodeSpec The top level document node.
  doc: {
    content: "block+"
  },
  // :: NodeSpec A plain paragraph textblock. Represented in the DOM
  // as a `<p>` element.
  paragraph: {
    content: "inline*",
    group: "block",
    attrs: A({}, Ct()),
    parseDOM: [{
      tag: "p",
      getAttrs: xe
    }],
    toDOM: function(r) {
      return kt(r.attrs) ? ["p", et(r.attrs), Be] : ["p", Be];
    }
  },
  div: {
    // Uncaught SyntaxError: Mixing inline and block content (in content expression '(block | inline)*')
    // content: '(block | inline)*',
    content: "block*",
    group: "block",
    attrs: A({}, Ct()),
    parseDOM: [{
      tag: "div",
      getAttrs: xe
    }],
    toDOM: function(r) {
      return kt(r.attrs) ? ["div", et(r.attrs), Be] : ["div", Be];
    }
  },
  // :: NodeSpec A blockquote (`<blockquote>`) wrapping one or more blocks.
  blockquote: {
    attrs: A({}, Ct()),
    content: "block+",
    group: "block",
    defining: !0,
    parseDOM: [{
      tag: "blockquote",
      getAttrs: xe
    }],
    toDOM: function(r) {
      return kt(r.attrs) ? ["blockquote", et(r.attrs), Be] : yC;
    }
  },
  // :: NodeSpec A horizontal rule (`<hr>`).
  horizontal_rule: {
    group: "block",
    parseDOM: [{ tag: "hr" }],
    toDOM: function() {
      return wC;
    }
  },
  // :: NodeSpec A heading textblock, with a `level` attribute that
  // has to hold the numbers from 1 to 6. Parsed and serialized as `<h1>` to
  // `<h6>` elements.
  heading: {
    attrs: A(A({}, Ct()), { level: { default: 1 } }),
    content: "inline*",
    group: "block",
    defining: !0,
    parseDOM: [
      { tag: "h1", getAttrs: function(r) {
        return A(A({}, xe(r)), { level: 1 });
      } },
      { tag: "h2", getAttrs: function(r) {
        return A(A({}, xe(r)), { level: 2 });
      } },
      { tag: "h3", getAttrs: function(r) {
        return A(A({}, xe(r)), { level: 3 });
      } },
      { tag: "h4", getAttrs: function(r) {
        return A(A({}, xe(r)), { level: 4 });
      } },
      { tag: "h5", getAttrs: function(r) {
        return A(A({}, xe(r)), { level: 5 });
      } },
      { tag: "h6", getAttrs: function(r) {
        return A(A({}, xe(r)), { level: 6 });
      } }
    ],
    toDOM: function(r) {
      return kt(r.attrs, "level") ? ["h" + r.attrs.level, et(r.attrs, ["level"]), Be] : ["h" + r.attrs.level, Be];
    }
  },
  // :: NodeSpec A code listing. Disallows marks or non-text inline
  // nodes by default. Represented as a `<pre>` element with a
  // `<code>` element inside it.
  code_block: {
    content: "text*",
    marks: "",
    group: "block",
    code: !0,
    defining: !0,
    parseDOM: [{ tag: "pre", preserveWhitespace: "full" }],
    toDOM: function() {
      return bC;
    }
  },
  // :: NodeSpec The text node.
  text: {
    inline: !0,
    group: "inline"
  },
  // :: NodeSpec An inline image (`<img>`) node. Supports `src`,
  // `alt`, and `href` attributes. The latter two default to an empty
  // string.
  image: {
    inline: !0,
    attrs: A({ src: { default: null }, alt: { default: null }, title: { default: null }, width: { default: null }, height: { default: null } }, Ct()),
    group: "inline",
    draggable: !0,
    parseDOM: [{ tag: "img", getAttrs: xe }],
    toDOM: function(r) {
      return kt(r.attrs) ? ["img", et(r.attrs)] : ["img"];
    }
  },
  // :: NodeSpec A hard line break represented in the DOM as a `<br>` element.
  hard_break: {
    inline: !0,
    attrs: A({}, Ct()),
    group: "inline",
    selectable: !1,
    parseDOM: [{
      tag: "br",
      getAttrs: xe
    }],
    toDOM: function(r) {
      return kt(r.attrs) ? ["br", et(r.attrs)] : ["br"];
    }
  },
  // :: NodeSpec
  // An ordered list [node spec](#model.NodeSpec). Has a single
  // attribute, `order`, which determines the number at which the list
  // starts counting, and defaults to 1. Represented as an `<ol>`
  // element.
  ordered_list: {
    content: "list_item+",
    group: "block",
    attrs: A(A({}, Ct()), { type: { default: null }, order: { default: 1 } }),
    parseDOM: [{ tag: "ol", getAttrs: function(r) {
      return A(A({}, xe(r)), { order: r.hasAttribute("start") ? parseInt(r.getAttribute("start") || "1", 10) : 1 });
    } }],
    toDOM: function(r) {
      return r.attrs.order === 1 ? kt(r.attrs, "order") ? ["ol", et(r.attrs, ["order"]), Be] : SC : ["ol", A(A({}, et(r.attrs, ["order"])), { start: r.attrs.order }), Be];
    }
  },
  // :: NodeSpec
  // A bullet list node specification represented in the DOM as a `<ul>` element.
  bullet_list: {
    content: "list_item+",
    group: "block",
    attrs: A({}, Ct()),
    parseDOM: [{ tag: "ul", getAttrs: xe }],
    toDOM: function(r) {
      return kt(r.attrs) ? ["ul", et(r.attrs), Be] : CC;
    }
  },
  // :: NodeSpec
  // A list item (`<li>`) specification.
  list_item: {
    content: "(paragraph | heading) block*",
    attrs: A({}, Ct()),
    parseDOM: [{ tag: "li", getAttrs: xe }],
    toDOM: function(r) {
      return kt(r.attrs) ? ["li", et(r.attrs), Be] : kC;
    },
    defining: !0
  }
}, tn), Xi = 200, Fe = function() {
};
Fe.prototype.append = function(e) {
  return e.length ? (e = Fe.from(e), !this.length && e || e.length < Xi && this.leafAppend(e) || this.length < Xi && e.leafPrepend(this) || this.appendInner(e)) : this;
};
Fe.prototype.prepend = function(e) {
  return e.length ? Fe.from(e).append(this) : this;
};
Fe.prototype.appendInner = function(e) {
  return new _C(this, e);
};
Fe.prototype.slice = function(e, t) {
  return e === void 0 && (e = 0), t === void 0 && (t = this.length), e >= t ? Fe.empty : this.sliceInner(Math.max(0, e), Math.min(this.length, t));
};
Fe.prototype.get = function(e) {
  if (!(e < 0 || e >= this.length))
    return this.getInner(e);
};
Fe.prototype.forEach = function(e, t, n) {
  t === void 0 && (t = 0), n === void 0 && (n = this.length), t <= n ? this.forEachInner(e, t, n, 0) : this.forEachInvertedInner(e, t, n, 0);
};
Fe.prototype.map = function(e, t, n) {
  t === void 0 && (t = 0), n === void 0 && (n = this.length);
  var i = [];
  return this.forEach(function(o, a) {
    return i.push(e(o, a));
  }, t, n), i;
};
Fe.from = function(e) {
  return e instanceof Fe ? e : e && e.length ? new Kh(e) : Fe.empty;
};
var Kh = /* @__PURE__ */ function(r) {
  function e(n) {
    r.call(this), this.values = n;
  }
  r && (e.__proto__ = r), e.prototype = Object.create(r && r.prototype), e.prototype.constructor = e;
  var t = { length: { configurable: !0 }, depth: { configurable: !0 } };
  return e.prototype.flatten = function() {
    return this.values;
  }, e.prototype.sliceInner = function(i, o) {
    return i == 0 && o == this.length ? this : new e(this.values.slice(i, o));
  }, e.prototype.getInner = function(i) {
    return this.values[i];
  }, e.prototype.forEachInner = function(i, o, a, s) {
    for (var l = o; l < a; l++)
      if (i(this.values[l], s + l) === !1)
        return !1;
  }, e.prototype.forEachInvertedInner = function(i, o, a, s) {
    for (var l = o - 1; l >= a; l--)
      if (i(this.values[l], s + l) === !1)
        return !1;
  }, e.prototype.leafAppend = function(i) {
    if (this.length + i.length <= Xi)
      return new e(this.values.concat(i.flatten()));
  }, e.prototype.leafPrepend = function(i) {
    if (this.length + i.length <= Xi)
      return new e(i.flatten().concat(this.values));
  }, t.length.get = function() {
    return this.values.length;
  }, t.depth.get = function() {
    return 0;
  }, Object.defineProperties(e.prototype, t), e;
}(Fe);
Fe.empty = new Kh([]);
var _C = /* @__PURE__ */ function(r) {
  function e(t, n) {
    r.call(this), this.left = t, this.right = n, this.length = t.length + n.length, this.depth = Math.max(t.depth, n.depth) + 1;
  }
  return r && (e.__proto__ = r), e.prototype = Object.create(r && r.prototype), e.prototype.constructor = e, e.prototype.flatten = function() {
    return this.left.flatten().concat(this.right.flatten());
  }, e.prototype.getInner = function(n) {
    return n < this.left.length ? this.left.get(n) : this.right.get(n - this.left.length);
  }, e.prototype.forEachInner = function(n, i, o, a) {
    var s = this.left.length;
    if (i < s && this.left.forEachInner(n, i, Math.min(o, s), a) === !1 || o > s && this.right.forEachInner(n, Math.max(i - s, 0), Math.min(this.length, o) - s, a + s) === !1)
      return !1;
  }, e.prototype.forEachInvertedInner = function(n, i, o, a) {
    var s = this.left.length;
    if (i > s && this.right.forEachInvertedInner(n, i - s, Math.max(o, s) - s, a + s) === !1 || o < s && this.left.forEachInvertedInner(n, Math.min(i, s), o, a) === !1)
      return !1;
  }, e.prototype.sliceInner = function(n, i) {
    if (n == 0 && i == this.length)
      return this;
    var o = this.left.length;
    return i <= o ? this.left.slice(n, i) : n >= o ? this.right.slice(n - o, i - o) : this.left.slice(n, o).append(this.right.slice(0, i - o));
  }, e.prototype.leafAppend = function(n) {
    var i = this.right.leafAppend(n);
    if (i)
      return new e(this.left, i);
  }, e.prototype.leafPrepend = function(n) {
    var i = this.left.leafPrepend(n);
    if (i)
      return new e(i, this.right);
  }, e.prototype.appendInner = function(n) {
    return this.left.depth >= Math.max(this.right.depth, n.depth) + 1 ? new e(this.left, new e(this.right, n)) : new e(this, n);
  }, e;
}(Fe);
const IC = 500;
class _t {
  constructor(e, t) {
    this.items = e, this.eventCount = t;
  }
  // Pop the latest event off the branch's history and apply it
  // to a document transform.
  popEvent(e, t) {
    if (this.eventCount == 0)
      return null;
    let n = this.items.length;
    for (; ; n--)
      if (this.items.get(n - 1).selection) {
        --n;
        break;
      }
    let i, o;
    t && (i = this.remapping(n, this.items.length), o = i.maps.length);
    let a = e.tr, s, l, c = [], u = [];
    return this.items.forEach((f, h) => {
      if (!f.step) {
        i || (i = this.remapping(n, h + 1), o = i.maps.length), o--, u.push(f);
        return;
      }
      if (i) {
        u.push(new Nt(f.map));
        let d = f.step.map(i.slice(o)), p;
        d && a.maybeStep(d).doc && (p = a.mapping.maps[a.mapping.maps.length - 1], c.push(new Nt(p, void 0, void 0, c.length + u.length))), o--, p && i.appendMap(p, o);
      } else
        a.maybeStep(f.step);
      if (f.selection)
        return s = i ? f.selection.map(i.slice(o)) : f.selection, l = new _t(this.items.slice(0, n).append(u.reverse().concat(c)), this.eventCount - 1), !1;
    }, this.items.length, 0), { remaining: l, transform: a, selection: s };
  }
  // Create a new branch with the given transform added.
  addTransform(e, t, n, i) {
    let o = [], a = this.eventCount, s = this.items, l = !i && s.length ? s.get(s.length - 1) : null;
    for (let u = 0; u < e.steps.length; u++) {
      let f = e.steps[u].invert(e.docs[u]), h = new Nt(e.mapping.maps[u], f, t), d;
      (d = l && l.merge(h)) && (h = d, u ? o.pop() : s = s.slice(0, s.length - 1)), o.push(h), t && (a++, t = void 0), i || (l = h);
    }
    let c = a - n.depth;
    return c > EC && (s = DC(s, c), a -= c), new _t(s.append(o), a);
  }
  remapping(e, t) {
    let n = new ur();
    return this.items.forEach((i, o) => {
      let a = i.mirrorOffset != null && o - i.mirrorOffset >= e ? n.maps.length - i.mirrorOffset : void 0;
      n.appendMap(i.map, a);
    }, e, t), n;
  }
  addMaps(e) {
    return this.eventCount == 0 ? this : new _t(this.items.append(e.map((t) => new Nt(t))), this.eventCount);
  }
  // When the collab module receives remote changes, the history has
  // to know about those, so that it can adjust the steps that were
  // rebased on top of the remote changes, and include the position
  // maps for the remote changes in its array of items.
  rebased(e, t) {
    if (!this.eventCount)
      return this;
    let n = [], i = Math.max(0, this.items.length - t), o = e.mapping, a = e.steps.length, s = this.eventCount;
    this.items.forEach((h) => {
      h.selection && s--;
    }, i);
    let l = t;
    this.items.forEach((h) => {
      let d = o.getMirror(--l);
      if (d == null)
        return;
      a = Math.min(a, d);
      let p = o.maps[d];
      if (h.step) {
        let m = e.steps[d].invert(e.docs[d]), v = h.selection && h.selection.map(o.slice(l + 1, d));
        v && s++, n.push(new Nt(p, m, v));
      } else
        n.push(new Nt(p));
    }, i);
    let c = [];
    for (let h = t; h < a; h++)
      c.push(new Nt(o.maps[h]));
    let u = this.items.slice(0, i).append(c).append(n), f = new _t(u, s);
    return f.emptyItemCount() > IC && (f = f.compress(this.items.length - n.length)), f;
  }
  emptyItemCount() {
    let e = 0;
    return this.items.forEach((t) => {
      t.step || e++;
    }), e;
  }
  // Compressing a branch means rewriting it to push the air (map-only
  // items) out. During collaboration, these naturally accumulate
  // because each remote change adds one. The `upto` argument is used
  // to ensure that only the items below a given level are compressed,
  // because `rebased` relies on a clean, untouched set of items in
  // order to associate old items with rebased steps.
  compress(e = this.items.length) {
    let t = this.remapping(0, e), n = t.maps.length, i = [], o = 0;
    return this.items.forEach((a, s) => {
      if (s >= e)
        i.push(a), a.selection && o++;
      else if (a.step) {
        let l = a.step.map(t.slice(n)), c = l && l.getMap();
        if (n--, c && t.appendMap(c, n), l) {
          let u = a.selection && a.selection.map(t.slice(n));
          u && o++;
          let f = new Nt(c.invert(), l, u), h, d = i.length - 1;
          (h = i.length && i[d].merge(f)) ? i[d] = h : i.push(f);
        }
      } else
        a.map && n--;
    }, this.items.length, 0), new _t(Fe.from(i.reverse()), o);
  }
}
_t.empty = new _t(Fe.empty, 0);
function DC(r, e) {
  let t;
  return r.forEach((n, i) => {
    if (n.selection && e-- == 0)
      return t = i, !1;
  }), r.slice(t);
}
class Nt {
  constructor(e, t, n, i) {
    this.map = e, this.step = t, this.selection = n, this.mirrorOffset = i;
  }
  merge(e) {
    if (this.step && e.step && !e.selection) {
      let t = e.step.merge(this.step);
      if (t)
        return new Nt(t.getMap().invert(), t, this.selection);
    }
  }
}
class ln {
  constructor(e, t, n, i) {
    this.done = e, this.undone = t, this.prevRanges = n, this.prevTime = i;
  }
}
const EC = 20;
function AC(r, e, t, n) {
  let i = t.getMeta(Sn), o;
  if (i)
    return i.historyState;
  t.getMeta(RC) && (r = new ln(r.done, r.undone, null, 0));
  let a = t.getMeta("appendedTransaction");
  if (t.steps.length == 0)
    return r;
  if (a && a.getMeta(Sn))
    return a.getMeta(Sn).redo ? new ln(r.done.addTransform(t, void 0, n, Ei(e)), r.undone, nu(t.mapping.maps[t.steps.length - 1]), r.prevTime) : new ln(r.done, r.undone.addTransform(t, void 0, n, Ei(e)), null, r.prevTime);
  if (t.getMeta("addToHistory") !== !1 && !(a && a.getMeta("addToHistory") === !1)) {
    let s = r.prevTime == 0 || !a && (r.prevTime < (t.time || 0) - n.newGroupDelay || !NC(t, r.prevRanges)), l = a ? ha(r.prevRanges, t.mapping) : nu(t.mapping.maps[t.steps.length - 1]);
    return new ln(r.done.addTransform(t, s ? e.selection.getBookmark() : void 0, n, Ei(e)), _t.empty, l, t.time);
  } else
    return (o = t.getMeta("rebased")) ? new ln(r.done.rebased(t, o), r.undone.rebased(t, o), ha(r.prevRanges, t.mapping), r.prevTime) : new ln(r.done.addMaps(t.mapping.maps), r.undone.addMaps(t.mapping.maps), ha(r.prevRanges, t.mapping), r.prevTime);
}
function NC(r, e) {
  if (!e)
    return !1;
  if (!r.docChanged)
    return !0;
  let t = !1;
  return r.mapping.maps[0].forEach((n, i) => {
    for (let o = 0; o < e.length; o += 2)
      n <= e[o + 1] && i >= e[o] && (t = !0);
  }), t;
}
function nu(r) {
  let e = [];
  return r.forEach((t, n, i, o) => e.push(i, o)), e;
}
function ha(r, e) {
  if (!r)
    return null;
  let t = [];
  for (let n = 0; n < r.length; n += 2) {
    let i = e.map(r[n], 1), o = e.map(r[n + 1], -1);
    i <= o && t.push(i, o);
  }
  return t;
}
function Gh(r, e, t, n) {
  let i = Ei(e), o = Sn.get(e).spec.config, a = (n ? r.undone : r.done).popEvent(e, i);
  if (!a)
    return;
  let s = a.selection.resolve(a.transform.doc), l = (n ? r.done : r.undone).addTransform(a.transform, e.selection.getBookmark(), o, i), c = new ln(n ? l : a.remaining, n ? a.remaining : l, null, 0);
  t(a.transform.setSelection(s).setMeta(Sn, { redo: n, historyState: c }).scrollIntoView());
}
let da = !1, ru = null;
function Ei(r) {
  let e = r.plugins;
  if (ru != e) {
    da = !1, ru = e;
    for (let t = 0; t < e.length; t++)
      if (e[t].spec.historyPreserveItems) {
        da = !0;
        break;
      }
  }
  return da;
}
const Sn = new Xe("history"), RC = new Xe("closeHistory");
function PC(r = {}) {
  return r = {
    depth: r.depth || 100,
    newGroupDelay: r.newGroupDelay || 500
  }, new Ge({
    key: Sn,
    state: {
      init() {
        return new ln(_t.empty, _t.empty, null, 0);
      },
      apply(e, t, n) {
        return AC(t, n, e, r);
      }
    },
    config: r,
    props: {
      handleDOMEvents: {
        beforeinput(e, t) {
          let n = t.inputType, i = n == "historyUndo" ? fl : n == "historyRedo" ? Yi : null;
          return i ? (t.preventDefault(), i(e.state, e.dispatch)) : !1;
        }
      }
    }
  });
}
const fl = (r, e) => {
  let t = Sn.getState(r);
  return !t || t.done.eventCount == 0 ? !1 : (e && Gh(t, r, e, !1), !0);
}, Yi = (r, e) => {
  let t = Sn.getState(r);
  return !t || t.undone.eventCount == 0 ? !1 : (e && Gh(t, r, e, !0), !0);
}, LC = (r, e) => {
  let t = r.plugins;
  for (let n = 0; n < t.length; n++) {
    let i = t[n], o;
    if (i.spec.isInputRules && (o = i.getState(r))) {
      if (e) {
        let a = r.tr, s = o.transform;
        for (let l = s.steps.length - 1; l >= 0; l--)
          a.step(s.steps[l].invert(s.docs[l]));
        if (o.text) {
          let l = a.doc.resolve(o.from).marks();
          a.replaceWith(o.from, o.to, r.schema.text(o.text, l));
        } else
          a.delete(o.from, o.to);
        e(a);
      }
      return !0;
    }
  }
  return !1;
};
var FC = {
  mark: "strong",
  altMarks: ["b"],
  altStyle: { name: "font-weight", value: /^(bold(er)?|[5-9]\d{2,})$/ }
}, zC = {
  mark: "em",
  altMarks: ["i"],
  altStyle: { name: "font-style", value: /^italic$/i }
}, BC = {
  mark: "u",
  altStyle: { name: "text-decoration", value: /^underline$/i }
}, $C = {
  mark: "del",
  altStyle: { name: "text-decoration", value: /^line-through$/i }
}, HC = {
  mark: "sub"
}, jC = {
  mark: "sup"
}, pa = {
  mark: "link"
}, WC = /style=['"]?[^'"]*?mso-list:\s*[a-zA-Z]+(\d+)\s[a-zA-Z]+(\d+)\s(\w+)/gi, VC = function(r) {
  return r = r.replace(WC, function(e, t, n) {
    return 'datalist="' + t + '" datalevel="' + n + '" ' + e;
  }), r;
}, Jh = function(r) {
  return /^MsoListParagraph/.test(r.className);
}, ns = function(r) {
  var e = r.innerHTML;
  return e = e.replace(/<!--(.|\s)*?-->/gi, ""), e = e.replace(/<\/?[^>]+?\/?>/gm, ""), e;
}, iu = function(r, e) {
  var t = document.createElement(r);
  return t.style.listStyleType = e, t;
}, UC = function(r) {
  return /^[\u2022\u00b7\u00FC\u00D8\u002dv-]/.test(r) ? null : /^o/.test(r) ? "circle" : "square";
}, qC = function(r) {
  var e = null;
  return /^\d/.test(r) || (e = (/^[a-z]/.test(r) ? "lower-" : "upper-") + (/^[ivxlcdm]/i.test(r) ? "roman" : "alpha")), e;
}, rs = function(r, e) {
  var t = [];
  Array.from(r).forEach(function(n) {
    if (n.nodeType === Node.ELEMENT_NODE) {
      var i = n;
      i.getAttribute("datalist") ? (t.push(n), e.add(t)) : Jh(i) && t.length ? t.push(n) : (t = [], i.nodeName === "DIV" ? rs(i.children, e) : i.nodeName === "TABLE" && Array.from(i.querySelectorAll("td,th")).forEach(function(o) {
        rs(o.children, e);
      }));
    }
  });
}, KC = function(r) {
  var e = r.innerHTML, t = function(n) {
    return n.replace(/^(?:&nbsp;|[\u00a0\n\r\s])+/, "");
  };
  if (e = e.replace(/<\/?\w+[^>]*>/g, "").replace(/&nbsp;/g, " "), /^[\u2022\u00b7\u00a7\u00d8oØüvn][\u00a0 ]+/.test(e))
    return {
      tag: "ul",
      style: UC(t(ns(r)))
    };
  if (/^\s*\w+[\.\)][\u00a0 ]{2,}/.test(e))
    return {
      tag: "ol",
      style: qC(t(ns(r)))
    };
}, GC = function(r) {
  var e, t = r.nodeName.toLowerCase();
  r.firstChild && r.firstChild.nodeType === Node.COMMENT_NODE && r.removeChild(r.firstChild), r.childNodes.length === 1 ? e = r.firstChild.nodeType === Node.TEXT_NODE ? ns(r) : r.firstChild.innerHTML.replace(/^\w+[\.\)](&nbsp;)+ /, "") : (r.removeChild(r.firstChild), r.firstChild.nodeType === 3 && /^[ivxlcdm]+\.$/i.test(r.firstChild.nodeValue) && r.removeChild(r.firstChild), /^(&nbsp;|\s)+$/i.test(r.firstChild.innerHTML) && r.removeChild(r.firstChild), t !== "p" ? e = "<" + t + ">" + r.innerHTML + "</" + t + ">" : e = r.innerHTML), r.parentNode.removeChild(r);
  var n = document.createElement("li");
  return n.appendChild(li(e)), n;
}, JC = function(r) {
  var e = -1, t = {}, n, i, o, a, s, l, c, u, f, h, d, p, m;
  for (u = 0; u < r.length; u++) {
    f = r[u], m = {
      datalist: f.getAttribute("datalist"),
      datalevel: f.getAttribute("datalevel")
    };
    var v = m.datalist, y = KC(f);
    if (h = y && y.tag, !h) {
      n && (!s || Jh(f)) && (f.style.marginLeft && (f.style.marginLeft = ""), f.style.marginLeft && (f.style.margin = ""), n.appendChild(f));
      continue;
    }
    if (d = m.datalevel || parseFloat(f.style.marginLeft || 0), !(!m.datalevel && !f.style.marginLeft)) {
      var b = h + v;
      t[d] || (t[d] = {}), (!i || i < 0) && (i = d, o = v, c = r.filter(function(k) {
        return k.getAttribute("datalist") === String(o);
      }), a = c[c.length - 1], l = iu(h, y && y.style), f.parentNode.insertBefore(l, f), e = d, t[d][b] = l), s = a === f, p = t[d][b], (d > e || !p) && (p = iu(h, y && y.style), t[d][b] = p, n.appendChild(p)), n = GC(f), p.appendChild(n), s ? i = e = -1 : e = d;
    }
  }
}, Xh = function(r) {
  var e = li(VC(r)), t = /* @__PURE__ */ new Set();
  return rs(e.children, t), t.forEach(function(n) {
    return JC(n);
  }), If(e);
}, XC = function(r) {
  return r = r.replace(/^[\s\S]+?<!--StartFragment-->\s*([\s\S]*?)\s*<!--EndFragment-->[\s\S]+$/, "$1"), r = r.replace(/<\/?[ovw]:[^>]*?>/gi, ""), r = r.replace(/<\\?\??xml[^>]*>/gi, ""), r = r.replace(/<(?:link|meta) [^>]+?>/ig, ""), r = r.replace(/<style[^>]*?>\s*<\/style>/ig, ""), r = r.replace(/<\/?st1:.*?>/gi, ""), r = r.replace(/<a name="[a-zA-Z0-9_]+">/gmi, ""), r = r.replace(/v:shapes?="[^"]+"/ig, ""), r = r.replace(/<!\[if !supportLists\]>/ig, ""), r = r.replace(/<!\[endif\]>/ig, ""), r;
}, YC = function(r) {
  return r.replace(/<!--[\s\S]+?-->/g, "");
}, Yh = function(r, e) {
  return r.replace(new RegExp("<\\/?(" + e + ")(?:\\s[^>]*?)?>", "gi"), "");
}, hl = function(r) {
  r.ownerElement && r.ownerElement.removeAttribute(r.name);
}, ZC = function(r) {
  /^Mso/.test(r.value) && hl(r);
}, QC = /\s*;\s*/, ek = /\s*:\s*/, tk = function(r) {
  var e = r.value.split(QC).filter(function(s) {
    return !!s;
  }), t = r.ownerElement, n = t.style, i = "", o, a;
  e.forEach(function(s) {
    var l;
    l = s.split(ek), o = l[0], a = l[1], n[o] !== void 0 && (i += o + ": " + a + "; ");
  }), i = i.trim(), i ? r.value = i : hl(r);
}, nk = function(r) {
  var e = r.parentNode;
  if (e) {
    for (; r.firstChild; )
      e.insertBefore(r.firstChild, r);
    e.removeChild(r);
  }
}, rk = function(r, e) {
  if (r.nodeType === Node.ELEMENT_NODE) {
    for (var t = r.attributes.length - 1; t >= 0; t--) {
      var n = r.attributes[t];
      e[n.name] ? e[n.name](n) : e["*"] && e["*"](n);
    }
    r.nodeName === "SPAN" && r.attributes.length === 0 && nk(r);
  }
}, ik = function(r, e) {
  var t = r;
  if (e.convertMsLists && (t = Xh(t)), e.stripTags && (t = Yh(t, e.stripTags)), e.attributes) {
    var n = li(t);
    Array.from(n.querySelectorAll("*")).forEach(function(i) {
      return rk(i, e.attributes);
    }), t = If(n);
  }
  return t;
};
function ok(r) {
  for (var e = r.length, t = new Array(e / 2), n = 0; n < e; n += 2)
    t[n] = String.fromCharCode(parseInt(r.substring(n, n + 2), 16));
  return btoa(t.join(""));
}
var ou = /<img\s[^>]*?src=(?:'|")file:\/[^'"]+(?:'|")[^>]*>/gi, Zh = /{\\pict[\s\S]+?\\bliptag-?\d+(\\blipupi-?\d+)?({\\\*\\blipuid\s?[\da-fA-F]+)?[\s}]*?/, ak = new RegExp("(?:(" + Zh.source + "))([\\da-fA-F\\s]+)\\}", "g"), sk = /[^\da-fA-F]/g, lk = /file:\/[^'"]+\.(jpg|png|gif)/i, ck = /\\(png|jpeg)blip\\/, au = "text/rtf", uk = function(r, e) {
  var t = r.match(ou);
  if (!t || e.types.indexOf(au) === -1)
    return r;
  var n = e.getData(au), i = [], o = n.match(ak);
  if (!n || !o)
    return r;
  for (var a = 0, s = o; a < s.length; a++) {
    var l = s[a], c = ck.exec(l);
    if (c) {
      var u = l.replace(Zh, "").replace(sk, "");
      i.push("data:image/" + c[1] + ";base64," + ok(u));
    }
  }
  return t.length !== i.length ? r : r.replace(ou, function(f) {
    var h = i.shift() || "";
    return f.replace(lk, h);
  });
}, Fr = function(r, e, t, n, i) {
  var o = [], a, s, l, c, u, f, h = [], d = e.matchCase, p = e.matchWord, m = e.useRegExp, v = e.text;
  if (m && (/^\\$/.test(v) || /[^\\]\\$/.test(v)) && (v = v.substring(0, v.length - 1)), !v)
    return o;
  var y = d ? "g" : "gi", b = m ? new RegExp(v, y) : mk(v, y);
  return r.nodesBetween(t, n, function(k, M, D) {
    if (i(o))
      return !1;
    k.inlineContent && M + k.content.size >= t && (h.length = 0, k.nodesBetween(0, k.content.size, function(T, z, _, ee) {
      if (i(o))
        return !1;
      var K = 1 + M + z;
      if (T.isText && K + T.nodeSize >= t) {
        if (u = T.text || "", f = _.childCount - 1 >= ee + 1 && _.child(ee + 1), h.push(t <= K ? { text: u, start: K } : { text: u.slice(t - K), start: t }), f && f.isText)
          return;
        for (s = h.map(function(O) {
          return O.text;
        }).join(""), a = b.exec(s); a !== null && (l = h[0].start + a.index, c = l + a[0].length, t <= l && n >= c && pk(a, p) && o.push(oe.create(r, l, c)), !i(o)); )
          a = b.exec(s);
      } else
        h.length = 0;
    }));
  }), o;
}, fk = function(r, e) {
  var t = e.backward, n = e.matchCyclic, i = Vi(e, ["backward", "matchCyclic"]), o = t ? function() {
    return !1;
  } : function(c) {
    return c.length > 0;
  }, a = r.doc, s = r.selection, l = [];
  return t ? (l = Fr(a, i, 0, s.from, o), !l.length && n && (l = Fr(a, i, s.from, a.content.size, o))) : (l = Fr(a, i, s.to, a.content.size, o), !l.length && n && (l = Fr(a, i, 0, s.to, o))), l.length ? l[l.length - 1] : null;
}, Qh = function(r, e) {
  return Fr(r, e, 0, r.content.size, function() {
    return !1;
  });
}, hk = function(r, e, t) {
  var n = r.from, i = r.to;
  return t.insertText(e, n, i).setSelection(oe.create(t.doc, n, n + e.length)), t;
}, dk = function(r, e, t) {
  var n = Qh(r.doc, t);
  if (n.length === 0)
    return null;
  for (var i = r.tr, o = n.length - 1; o >= 0; o--)
    i.insertText(e, n[o].from, n[o].to);
  return i;
}, su = /^[\s0-9~`!@#$%\^&*\(\)_\-=+\\|\[\]{};:'"\?/.,<>]?$/, pk = function(r, e) {
  if (e)
    if (e === !0) {
      var t = r.input, n = t.charAt(r.index - 1), i = t.charAt(r.index + r[0].length);
      return su.test(n) && su.test(i);
    } else
      return e(r);
  else
    return !0;
}, mk = function(r, e) {
  var t = r.replace(/[|\\{}()[\]^$+*?.]/g, "\\$&").replace(/-/g, "\\x2d").replace(/\s/g, "\\s");
  return new RegExp(t, e);
}, lu = /\s+/g, gk = /text-align/, vk = function(r) {
  return gk.test(r && r.attrs && r.attrs.style || "");
}, yk = function() {
  return new Ge({
    key: new Xe("spaces-fix"),
    props: {
      decorations: function(r) {
        var e = [], t = r.doc, n, i, o, a;
        return t.nodesBetween(0, t.content.size, function(s, l, c) {
          if (s.type.isText && vk(c))
            for (i = lu.exec(s.text || ""); i !== null; ) {
              if (n = l + i.index, o = i[0].length, i.index + o < i.input.length)
                for (a = 0; a <= o - 1; a += 2)
                  e.push(Ae.inline(n + a, n + a + 1, {
                    style: "white-space: normal"
                  }));
              i = lu.exec(s.text || "");
            }
        }), fe.create(t, e);
      }
    }
  });
}, ed = new Xe("highlight");
function wk(r) {
  return r === void 0 && (r = ed), new Ge({
    key: r,
    state: {
      init: function() {
        return null;
      },
      apply: function(e) {
        return e.getMeta(this.spec.key);
      }
    },
    props: {
      decorations: function(e) {
        var t = (this.spec.key.getState(e) || []).map(function(n) {
          return Ae.inline(n.from, n.to, n.attrs);
        });
        return fe.create(e.doc, t);
      }
    }
  });
}
var dl = {
  southeast: { x: 1, y: 1 },
  east: { x: 1, y: 0 },
  south: { x: 0, y: 1 },
  north: { x: 0, y: -1 },
  west: { x: -1, y: 0 },
  southwest: { x: -1, y: 1 },
  northwest: { x: -1, y: -1 },
  northeast: { x: 1, y: -1 }
  // top right
}, Ai = Object.keys(dl), mt = new Xe("image-resize"), cu = function(r, e, t) {
  r.style[e] = t + "px";
}, bk = /[^\-]width:|[^\-]height:/, uu = /^.+$/, Sk = (
  /** @class */
  function() {
    function r(e, t, n, i) {
      this.activeHandle = e, this.dragging = t, this.rect = n, this.nodePosition = i;
    }
    return r.prototype.apply = function(e) {
      var t = this, n = e.getMeta(mt);
      return n ? new r(n.activeHandle, n.setDragging, n.rect, n.nodePosition) : t;
    }, r;
  }()
), Ck = function(r, e, t) {
  var n = mt.getState(r.state), i = n.rect, o = n.dragging, a = n.nodePosition, s = n.activeHandle;
  if (!(!o || !i)) {
    var l = r.nodeDOM(a), c = dl[s], u = (e.clientX - o.startX) * c.x, f = (e.clientY - o.startY) * c.y, h = c.x ? u + l.width : i.width, d = c.y ? f + l.height : i.height;
    if (t.lockRatio && c.x && c.y) {
      var p = Math.min(h / l.width, d / l.height), m = l.width * p, v = l.height * p;
      o.startX = e.clientX - (h - m) * c.x, o.startY = e.clientY - (d - v) * c.y, h = m, d = v;
    } else
      o.startX = c.x ? e.clientX : o.startX, o.startY = c.y ? e.clientY : o.startY;
    cu(l, "width", h), cu(l, "height", d), i.top = l.offsetTop, i.left = l.offsetLeft, i.width = l.offsetWidth, i.height = l.offsetHeight;
    var y = l.nextElementSibling;
    y.style.width = i.width + "px", y.style.height = i.height + "px", y.style.top = i.top + "px", y.style.left = i.left + "px";
  }
}, kk = function(r) {
  var e = mt.getState(r.state), t = e.rect, n = e.dragging, i = e.nodePosition;
  if (n && t) {
    var o = r.state.selection;
    if (o instanceof te) {
      var a = o.node.attrs, s = t.width, l = t.height, c = void 0;
      if (bk.test(a.style || "")) {
        var u = wr(a.style, { style: "width", value: uu, newValue: s + "px" }), f = wr(u.style || "", { style: "height", value: uu, newValue: l + "px" }).style;
        c = A(A({}, a), { style: f });
      } else
        c = A(A({}, a), { width: s, height: l });
      var h = o.node.type.createAndFill(c);
      if (h) {
        var d = r.state.tr;
        d.replaceWith(i, i + 1, h), d.setSelection(te.create(d.doc, i)), d.setMeta("commandName", "image-resize"), d.setMeta("args", c), d.setMeta(mt, {
          setDragging: null,
          activeHandle: null,
          rect: t,
          nodePosition: i
        }), r.dispatch(d);
      }
    }
  }
}, xk = function(r, e, t) {
  var n = e.target, i = n.getAttribute(_f);
  if (!i)
    return !1;
  var o = mt.getState(r.state);
  e.preventDefault();
  var a = r.state.tr;
  a.setMeta(mt, {
    setDragging: { startX: e.clientX, startY: e.clientY },
    activeHandle: i,
    rect: o.rect,
    nodePosition: o.nodePosition
  }), a.setMeta("addToHistory", !1), r.dispatch(a);
  function s(c) {
    Ck(r, c, t);
  }
  function l(c) {
    c.view.removeEventListener("mouseup", l), c.view.removeEventListener("mousemove", s), kk(r);
  }
  return e.view.addEventListener("mouseup", l), e.view.addEventListener("mousemove", s), !0;
}, Ok = function(r) {
  return r === void 0 && (r = { node: "image", lockRatio: !0 }), new Ge({
    key: mt,
    view: function(e) {
      return {
        resize: function() {
          mt.getState(e.state).rect && e.dispatch(e.state.tr.setMeta("resize", !0));
        },
        get window() {
          return e.dom.ownerDocument && e.dom.ownerDocument.defaultView;
        },
        attachResize: function() {
          var t = this.window;
          t && (t.removeEventListener("resize", this.resize), t.addEventListener("resize", this.resize));
        },
        removeResize: function() {
          var t = this.window;
          t && t.removeEventListener("resize", this.resize);
        },
        update: function(t, n) {
          var i = t.state, o = i.selection, a = i.schema.nodes[r.node], s = mt.getState(i), l = s.rect;
          if (o instanceof te && a === o.node.type) {
            var c = t.nodeDOM(o.from), u = {
              top: c.offsetTop,
              left: c.offsetLeft,
              width: c.offsetWidth,
              height: c.offsetHeight
            };
            if (!n.selection.eq(o) || l && (l.width !== u.width || l.height !== u.height || l.top !== u.top || l.left !== u.left)) {
              var f = i.tr;
              f.setMeta(mt, { rect: u, nodePosition: o.from }), t.dispatch(f), this.attachResize();
            }
          } else
            l && (s.rect = null, s.nodePosition = -1);
        },
        destroy: function() {
          this.removeResize();
        }
      };
    },
    state: {
      init: function() {
        return new Sk("", null, null, -1);
      },
      apply: function(e, t) {
        return t.apply(e);
      }
    },
    props: {
      handleDOMEvents: {
        mousedown: function(e, t) {
          return xk(e, t, r);
        }
      },
      decorations: function(e) {
        var t = e.selection, n = e.schema.nodes[r.node], i = mt.getState(e).rect;
        if (i && t instanceof te && n === t.node.type) {
          var o = document.createElement("div");
          o.className = "k-editor-resize-handles-wrapper", o.style.width = i.width + "px", o.style.height = i.height + "px", o.style.top = i.top + "px", o.style.left = i.left + "px";
          for (var a = 0; a < Ai.length; a++) {
            var s = document.createElement("div");
            s.className = Ha + " " + Ai[a], s.setAttribute(_f, Ai[a]), o.appendChild(s);
          }
          return fe.create(e.doc, [Ae.widget(e.selection.from + 1, o)]);
        }
        return fe.empty;
      }
    }
  });
}, Tk = new Xe("caret-color");
function Mk() {
  return new Ge({
    key: Tk,
    props: {
      decorations: function(r) {
        var e = r.doc, t = r.selection, n = r.storedMarks;
        if (!t.empty || !n)
          return fe.empty;
        var i = Gs((n || []).find(function(s) {
          return s.type.name === "style";
        }), { name: "color", value: /^.+$/ });
        if (!i)
          return fe.empty;
        var o = t.$anchor.parent, a = [];
        return e.descendants(function(s, l) {
          s.eq(o) && a.push(Ae.node(l, l + s.nodeSize, {
            style: "caret-color: " + i
          }));
        }), fe.create(e, a);
      }
    }
  });
}
var _k = (
  /** @class */
  function() {
    function r(e, t) {
      this.node = e, this.view = t, this.dom = document.createElement("div"), this.dom.className = Xw, this.table = this.dom.appendChild(document.createElement("table")), e.attrs[we] && this.renderColgroup(e.attrs[we]);
      var n = this.table.appendChild(document.createElement("tbody"));
      this.setAttributes(this.table, e.attrs), this.resizeHandles = Ai.map(function(i) {
        var o = document.createElement("span");
        return o.className = Ha + " " + i, o.setAttribute(Mf, i), o;
      }), this.contentDOM = n;
    }
    return r.prototype.update = function(e) {
      var t = this;
      if (e.type !== this.node.type)
        return !1;
      var n = this.node;
      return this.node = e, e.attrs[Lt] ? this.resizeHandles.forEach(function(i) {
        t.dom.appendChild(i);
      }) : Array.from(this.dom.children).filter(function(i) {
        return i.classList.contains(Ha);
      }).forEach(function(i) {
        return i.remove();
      }), this.setAttributes(this.table, e.attrs), n.attrs[we] !== e.attrs[we] && this.renderColgroup(e.attrs[we]), !0;
    }, r.prototype.ignoreMutation = function(e) {
      var t = e.type === "attributes" && (e.target === this.table || e.target.firstChild === this.table || this.colgroup && this.colgroup.contains(e.target));
      return t;
    }, r.prototype.destroy = function() {
      this.node = void 0, this.view = void 0, this.table = void 0, this.colgroup = void 0, this.resizeHandles = void 0;
    }, r.prototype.renderColgroup = function(e) {
      this.table && this.table.firstChild && this.table.firstChild.nodeName === "COLGROUP" && this.table.removeChild(this.table.firstChild), e && (this.colgroup = So(e), this.table.insertBefore(this.colgroup, this.table.firstChild));
    }, r.prototype.setAttributes = function(e, t) {
      var n = [we, Lt];
      for (var i in t)
        if (i && n.indexOf(i) === -1) {
          var o = e.getAttribute(i), a = t[i];
          a && a !== o ? e.setAttribute(i, a) : a || e.removeAttribute(i);
        }
    }, r;
  }()
), Ik = /^.+$/, Jn = function(r) {
  var e = (r || "").split(/\s*;\s*/).filter(Boolean).map(function(t) {
    var n, i = t.split(/\s*:\s*/);
    return n = {}, n[i[0]] = i[1], n;
  }).reduce(function(t, n) {
    return A(A({}, t), n);
  }, {});
  return e;
};
function Ht(r, e, t) {
  var n;
  if (new RegExp("[^-]?" + e + ":").test(r.style || "")) {
    var i = wr(r.style || "", { style: e, value: Ik, newValue: t }).style;
    n = A(A({}, r), { style: i });
  } else
    r.style ? n = A(A({}, r), { style: r.style.replace(/;$/, "") + "; " + e + ": " + t + ";" }) : n = A(A({}, r), { style: e + ": " + t + ";" });
  return n;
}
var tt = new Xe("table-resize"), Me = new Xe("table-column-resizing"), _e = new Xe("table-row-resizing");
function Zi(r, e) {
  var t = !1;
  return t = t || r !== tt && !!tt.get(e) && tt.getState(e).dragging, t = t || r !== Me && !!Me.get(e) && Me.getState(e).dragging, t = t || r !== _e && !!_e.get(e) && _e.getState(e).dragging, t;
}
function td(r, e) {
  var t = !1;
  return t = t || r !== Me && !!Me.get(e) && Me.getState(e).activeHandle > -1, t = t || r !== _e && !!_e.get(e) && _e.getState(e).activeHandle > -1, t;
}
function Co(r) {
  return r && r.firstChild && r.firstChild.nodeName === "TABLE" ? r.firstChild : r;
}
function nd(r) {
  for (; r && r.nodeName !== "TD" && r.nodeName !== "TH"; )
    r = r.classList.contains("ProseMirror") ? null : r.parentNode;
  return r;
}
function Dk(r) {
  var e = Array.from(r && r.rows || []), t = Array.from(e && e[0] && e[0].cells || []).map(function(i) {
    return i.colSpan;
  }).reduce(function(i, o) {
    return i + o;
  }, 0), n = e.map(function() {
    return new Array(t);
  });
  return e.forEach(function(i, o) {
    var a = 0;
    Array.from(i.cells).forEach(function(s) {
      for (var l = 0; l < s.colSpan; l++) {
        for (var c = 0; c < s.rowSpan; c++) {
          var u = n[o + c].findIndex(function(f, h) {
            return h >= a && !f;
          });
          n[o + c][u] = s;
        }
        a++;
      }
    });
  }), n;
}
function rd(r) {
  for (var e = Dk(r.closest("table")), t = null, n = function(a) {
    var s = e[a];
    if (s.forEach(function(l, c) {
      r === l && (t = { rowIndex: a, cellIndex: c });
    }), t)
      return "break";
  }, i = 0; i < e.length; i++) {
    var o = n(i);
    if (o === "break")
      break;
  }
  return t || { rowIndex: -1, cellIndex: -1 };
}
function id(r, e) {
  for (var t = r.depth; t > 0; t--) {
    var n = r.node(t);
    if (e(n))
      return { node: n, depth: t };
  }
  return null;
}
function Qi(r, e, t) {
  var n = r.posAtCoords({ left: e.clientX, top: e.clientY });
  if (!n)
    return -1;
  var i = r.state.doc.resolve(n.pos), o = id(i, function(u) {
    return u.type.spec.tableRole === "table";
  });
  if (o === null)
    return -1;
  var a = i.start(o.depth), s = o.node, l = Te.get(s), c = a + l.map[l.width * t.rowIndex + t.cellIndex];
  return c;
}
function Ek() {
  var r = _k, e = 5, t = 25, n = new Ge({
    key: Me,
    state: {
      init: function(i, o) {
        return this.spec.props.nodeViews[He(o.schema).table.name] = function(a, s) {
          return new r(a, s);
        }, new Nk(-1, null);
      },
      apply: function(i, o) {
        return o.apply(i);
      }
    },
    props: {
      attributes: function(i) {
        if (td(Me, i))
          return null;
        var o = Me.getState(i);
        return o.activeHandle > -1 ? { class: "resize-cursor" } : null;
      },
      handleDOMEvents: {
        mousemove: function(i, o) {
          return Zi(Me, i.state) || Rk(i, o, e), !1;
        },
        mouseleave: function(i) {
          return Pk(i), !1;
        },
        mousedown: function(i, o) {
          return Lk(i, o, t);
        }
      },
      decorations: function(i) {
        if (!Zi(Me, i)) {
          var o = Me.getState(i);
          if (o.activeHandle > -1)
            return Bk(i, o.activeHandle);
        }
        return fe.empty;
      },
      nodeViews: {}
    }
  });
  return n;
}
function Ak(r) {
  return !!(r.parent.type.spec.tableRole === "row" && r.nodeAfter);
}
var Nk = (
  /** @class */
  function() {
    function r(e, t) {
      this.activeHandle = e, this.dragging = t;
    }
    return r.prototype.apply = function(e) {
      var t = this, n = e.getMeta(Me);
      if (n && n.setHandle != null)
        return new r(n.setHandle, null);
      if (n && n.setDragging !== void 0)
        return new r(t.activeHandle, n.setDragging);
      if (t.activeHandle > -1 && e.docChanged) {
        var i = e.mapping.map(t.activeHandle, -1);
        Ak(e.doc.resolve(i)) || (i = -1), t = new r(i, t.dragging);
      }
      return t;
    }, r;
  }()
);
function Rk(r, e, t) {
  var n = Me.getState(r.state);
  if (!n.dragging) {
    var i = nd(e.target), o = -1;
    if (i) {
      var a = rd(i), s = i.getBoundingClientRect(), l = s.left, c = s.right;
      Math.abs(e.clientX - l) <= t && a.cellIndex > 0 ? (a.cellIndex -= i.colSpan, o = Qi(r, e, a)) : c - e.clientX > 0 && c - e.clientX <= t && (o = Qi(r, e, a));
    }
    o !== n.activeHandle && od(r, o);
  }
}
function Pk(r) {
  var e = Me.getState(r.state);
  e.activeHandle > -1 && !e.dragging && od(r, -1);
}
function Lk(r, e, t) {
  var n, i = Me.getState(r.state);
  if (i.activeHandle === -1 || i.dragging)
    return !1;
  for (var o = r.state.doc.resolve(i.activeHandle), a = o.parent, s = o.index(), l = 0, c = 0; c <= s; c++)
    l += a.child(c).attrs.colspan;
  var u = o.node(o.depth - 1), f = r.domAtPos(i.activeHandle), h = f.node.childNodes[f.offset], d = h.closest("table"), p, m;
  if (u.attrs[we]) {
    var v = d.firstChild;
    p = v.children[l - 1], p.style.width || (p.style.width = p.offsetWidth + "px");
  } else {
    for (var y = 0, c = 0; c < a.childCount; c++)
      y += a.child(c).attrs.colspan;
    for (var v = document.createElement("colgroup"), b = new Array(y), c = 0; c < y; c++)
      b[c] = document.createElement("col"), v.appendChild(b[c]);
    d.insertBefore(v, d.firstChild), p = b[s], p.style.width = p.offsetWidth + "px", m = A(A({}, u.attrs), (n = {}, n[we] = "<colgroup>" + b.reduce(function(O, ne) {
      return O + ne.outerHTML;
    }, "") + "</colgroup>", n));
  }
  var k = parseFloat(p.style.width), M = r.state.tr.setMeta(Me, { setDragging: { startX: e.clientX, startWidth: k } });
  if (!d.style.width) {
    var D = Array.from(p.parentNode.children).map(function(K) {
      return K.style.width;
    });
    if (D.every(Boolean)) {
      var T = D.reduce(function(K, O) {
        return K + parseFloat(O);
      }, 0);
      m = Ht(m || u.attrs, "width", T + "px");
    }
  }
  if (m) {
    var z = o.posAtIndex(0, o.depth - 1) - 1;
    M.setNodeMarkup(z, null, m);
  }
  r.dispatch(M);
  function _(K) {
    K.view.removeEventListener("mouseup", _), K.view.removeEventListener("mousemove", ee);
    var O = Me.getState(r.state);
    if (O.dragging) {
      var ne = r.state.tr;
      Fk(r, ne, O.activeHandle, fu(O.dragging, K, t)), r.dispatch(ne.setMeta(Me, { setDragging: null }));
    }
  }
  function ee(K) {
    if (!K.which)
      return _(K);
    var O = Me.getState(r.state), ne = fu(O.dragging, K, t);
    zk(r, O.activeHandle, ne);
  }
  return e.view.addEventListener("mouseup", _), e.view.addEventListener("mousemove", ee), e.preventDefault(), !0;
}
function fu(r, e, t) {
  var n = e.clientX - r.startX;
  return Math.max(t, r.startWidth + n);
}
function od(r, e) {
  var t = r.state.tr;
  t.setMeta("addToHistory", !1), t.setMeta(Me, { setHandle: e }), r.dispatch(t);
}
function Fk(r, e, t, n) {
  var i, o = r.state.doc.resolve(t), a = o.node(-1), s = o.start(-1), l = o.posAtIndex(0, o.depth - 1) - 1, c = r.nodeDOM(s).closest("table"), u = a.attrs;
  if (a && u[we]) {
    var f = c.firstChild;
    u = A(A({}, u), (i = {}, i[we] = f.outerHTML, i));
  }
  var h = c.style.width;
  c && h && Jn(u.style).width !== h && (u = Ht(u, "width", h)), e.setNodeMarkup(l, null, u);
}
function zk(r, e, t, n) {
  var i = r.state.doc.resolve(e), o = i.node(-1), a = i.start(-1), s = Te.get(o).colCount(i.pos - a) + i.nodeAfter.attrs.colspan - 1, l = r.domAtPos(i.start(-1)).node;
  l.nodeName !== "TABLE" && (l = l.closest("table"));
  var c = l, u = c.firstChild, f = Array.from(u.children);
  if (f[s].style.width = t + "px", c.style.width) {
    var h = f.map(function(p) {
      return p.style.width;
    });
    if (h.every(Boolean)) {
      var d = h.reduce(function(p, m) {
        return p + parseFloat(m);
      }, 0);
      c.style.width = d + "px";
    }
  }
}
function Bk(r, e) {
  for (var t = [], n = r.doc.resolve(e), i = n.node(-1), o = Te.get(i), a = n.start(-1), s = [], l = e - a, c = -1, u = 0; u < o.height; u++)
    s.push(o.map.slice(u * o.width, u * o.width + o.width)), c === -1 && (c = s[u].lastIndexOf(l));
  var f = [];
  return s.forEach(function(h) {
    var d = h[c];
    h[c] !== h[c + 1] && f.push(d);
  }), f.forEach(function(h) {
    var d = a + h + i.nodeAt(h).nodeSize - 1, p = document.createElement("div");
    p.className = "column-resize-handle", t.push(Ae.widget(d, p));
  }), fe.create(r.doc, t);
}
var ad = {
  southeast: !0,
  southwest: !0,
  northwest: !0,
  northeast: !0
}, sd = A({ east: !0, west: !0 }, ad), ld = A({ south: !0, north: !0 }, ad), $k = (
  /** @class */
  function() {
    function r(e, t, n) {
      this.activeHandle = e, this.dragging = t, this.nodePosition = n;
    }
    return r.prototype.apply = function(e) {
      var t = this, n = e.getMeta(tt);
      if (n) {
        var i = new r(n.activeHandle, n.setDragging, n.nodePosition);
        return i;
      }
      return t;
    }, r;
  }()
), Hk = function(r, e) {
  var t = tt.getState(r.state), n = t.dragging, i = t.nodePosition, o = t.activeHandle;
  if (!(i < 0 || !n)) {
    var a = Co(r.nodeDOM(i)), s = a.getBoundingClientRect(), l = dl[o], c = (e.clientX - n.startX) * l.x, u = (e.clientY - n.startY) * l.y, f = a.ownerDocument && a.ownerDocument.defaultView || window, h = f.getComputedStyle(a), d = /px/.test(h.width) ? parseFloat(h.width) : a.offsetWidth, p = /px/.test(h.height) ? parseFloat(h.height) : a.offsetHeight, m = l.x ? c + d : s.width, v = l.y ? u + p : s.height;
    n.startX = l.x ? e.clientX : n.startX, n.startY = l.y ? e.clientY : n.startY, sd[o] && (a.style.width = m + "px"), ld[o] && (a.style.height = v + "px");
  }
}, jk = function(r, e, t) {
  var n = r.state.doc.nodeAt(t), i = Co(r.nodeDOM(t)), o = cd(i), a = o.width, s = o.height, l = o.colsWidth, c = o.rowsHeight, u = o.offsetWidth, f = o.offsetHeight, h = i.firstChild, d = Array.from(h && h.children || []), p = !1;
  d.forEach(function(y, b) {
    y.style.width && !/%$/.test(y.style.width) && (y.style.width = l[b] * 100 / a + "%", p = !0);
  });
  var m = !1;
  n.forEach(function(y, b, k) {
    var M = Jn(y.attrs.style).height;
    M && !/%$/.test(M) && (e.setNodeMarkup(t + b + 1, null, Ht(y.attrs, "height", c[k] * 100 / s + "%")), m = !0);
  });
  var v = n.attrs;
  Jn(v.style).width !== u + "px" && (v = Ht(v, "width", u + "px")), p && (v[we] = h.outerHTML), m && (v = Ht(v, "height", f + "px")), (p || m) && e.setNodeMarkup(t, null, v);
}, Wk = function(r, e, t, n) {
  var i = r.state.doc.nodeAt(t), o = Co(r.nodeDOM(t)), a = o.ownerDocument && o.ownerDocument.defaultView || window, s = a.getComputedStyle, l = Array.from(o.rows);
  i.forEach(function(d, p, m) {
    var v = Jn(d.attrs.style).height;
    v && !/px$/.test(v) && e.setNodeMarkup(t + p + 1, null, Ht(d.attrs, "height", s(l[m]).height));
  });
  var c = o.firstChild, u = Array.from(c && c.children || []), f = !1;
  u.forEach(function(d, p) {
    d.style.width && !/px$/.test(d.style.width) && (d.style.width = s(u[p]).width, f = !0);
  });
  var h = A({}, n);
  return f && (h[we] = c.outerHTML), h;
}, cd = function(r) {
  var e = Array.from(r.firstChild.children), t = e.map(function(l) {
    return l.offsetWidth;
  }), n = Array.from(r.rows).map(function(l) {
    return l.offsetHeight;
  }), i = t.reduce(function(l, c) {
    return l + c;
  }, 0), o = n.reduce(function(l, c) {
    return l + c;
  }, 0), a = r.offsetHeight, s = r.offsetWidth;
  return { width: i, height: o, colsWidth: t, rowsHeight: n, offsetWidth: s, offsetHeight: a };
}, Vk = function(r) {
  var e = tt.getState(r.state), t = e.dragging, n = e.nodePosition, i = e.activeHandle;
  if (t) {
    var o = r.state.doc.nodeAt(n), a = Co(r.nodeDOM(n)), s = cd(a);
    if (o) {
      var l = s.offsetWidth + "px", c = s.offsetHeight + "px", u = r.state.tr, f = o.attrs, h = Jn(f.style);
      sd[i] && a.style.width && h.width !== l && (f = Ht(f, "width", l)), ld[i] && a.style.height && h.height !== c && (f = Ht(f, "height", c)), f = Wk(r, u, n, f), u.setNodeMarkup(n, null, f), u.setMeta("commandName", "node-resize"), u.setMeta("args", f), u.setMeta(tt, {
        setDragging: null,
        activeHandle: null,
        nodePosition: n
      }), r.dispatch(u);
    }
  }
}, Uk = function(r, e) {
  var t = e.target, n = t.getAttribute(Mf);
  if (!n)
    return !1;
  var i = tt.getState(r.state);
  e.preventDefault();
  var o = r.state.tr;
  o.setMeta(tt, {
    setDragging: { startX: e.clientX, startY: e.clientY },
    activeHandle: n,
    nodePosition: i.nodePosition
  }), o.setMeta("addToHistory", !1), jk(r, o, i.nodePosition), r.dispatch(o);
  var a = e.view || window;
  function s(c) {
    Hk(r, c);
  }
  function l(c) {
    a.removeEventListener("mouseup", l), a.removeEventListener("mousemove", s), Vk(r);
  }
  return a.addEventListener("mouseup", l), a.addEventListener("mousemove", s), !0;
}, qk = function(r) {
  return r === void 0 && (r = { node: "table" }), new Ge({
    key: tt,
    view: function(e) {
      return {
        selectedNode: function(t, n) {
          var i = t.selection, o = i instanceof te && n === i.node.type;
          if (o && i instanceof te)
            return { node: i.node, pos: i.from };
          var a = id(i.$from, function(c) {
            return c.type === n;
          }), s = a && a.node;
          if (s) {
            var l = i.$from.start(a.depth) - 1;
            return { node: s, pos: l };
          }
          return null;
        },
        update: function(t, n) {
          var i, o, a, s, l, c = t.state, u = c.schema.nodes[r.node], f = this.selectedNode(c, u), h = this.selectedNode(n, u);
          if (!(!f && h && !n.doc.eq(t.state.doc)) && (f || h)) {
            var d = c.tr;
            d.setMeta("addToHistory", !1), f && h && f.pos !== h.pos ? (d.setMeta(tt, { nodePosition: f.pos }), d.setNodeMarkup(h.pos, u, A(A({}, h.node.attrs), (i = {}, i[Lt] = !1, i))), d.setNodeMarkup(f.pos, u, A(A({}, f.node.attrs), (o = {}, o[Lt] = !0, o))), t.dispatch(d)) : f && h && f.pos === h.pos && !f.node.attrs[Lt] && !c.selection.eq(n.selection) ? (d.setMeta(tt, { nodePosition: f.pos }), t.dispatch(d.setNodeMarkup(f.pos, u, A(A({}, f.node.attrs), (a = {}, a[Lt] = !0, a))))) : f && !h ? (d.setMeta(tt, { nodePosition: f.pos }), t.dispatch(d.setNodeMarkup(f.pos, u, A(A({}, f.node.attrs), (s = {}, s[Lt] = !0, s))))) : !f && h && (d.setMeta(tt, { nodePosition: -1 }), t.dispatch(d.setNodeMarkup(h.pos, u, A(A({}, h.node.attrs), (l = {}, l[Lt] = !1, l)))));
          }
        }
      };
    },
    state: {
      init: function() {
        return new $k("", null, -1);
      },
      apply: function(e, t) {
        return t.apply(e);
      }
    },
    props: {
      handleDOMEvents: {
        mousedown: function(e, t) {
          return Uk(e, t);
        }
      }
    }
  });
}, Kk = (
  /** @class */
  function() {
    function r() {
    }
    return r.prototype.ignoreMutation = function(e) {
      return e.type === "attributes" && e.attributeName === "style" && e.target.nodeName === "TR";
    }, r;
  }()
);
function Gk() {
  var r = 5, e = new Ge({
    key: _e,
    state: {
      init: function(t, n) {
        return this.spec.props.nodeViews[He(n.schema).row.name] = function(i, o) {
          return new Kk();
        }, new Xk(-1, null);
      },
      apply: function(t, n) {
        return n.apply(t);
      }
    },
    props: {
      attributes: function(t) {
        if (td(_e, t))
          return null;
        var n = _e.getState(t);
        return n.activeHandle > -1 ? { class: "resize-cursor-vertical" } : null;
      },
      handleDOMEvents: {
        mousemove: function(t, n) {
          return Zi(_e, t.state) || Yk(t, n, r), !1;
        },
        mouseleave: function(t) {
          return Zk(t), !1;
        },
        mousedown: function(t, n) {
          return Qk(t, n);
        }
      },
      decorations: function(t) {
        if (Zi(_e, t))
          return fe.empty;
        var n = _e.getState(t);
        if (n.activeHandle > -1)
          return rx(t, n.activeHandle);
      },
      nodeViews: {}
    }
  });
  return e;
}
function Jk(r) {
  return r.parent.type.spec.tableRole === "row" && r.nodeAfter;
}
var Xk = (
  /** @class */
  function() {
    function r(e, t) {
      this.activeHandle = e, this.dragging = t;
    }
    return r.prototype.apply = function(e) {
      var t = this, n = e.getMeta(_e);
      if (n && n.setHandle != null)
        return new r(n.setHandle, null);
      if (n && n.setDragging !== void 0)
        return new r(t.activeHandle, n.setDragging);
      if (t.activeHandle > -1) {
        var i = e.mapping.map(t.activeHandle, -1);
        Jk(e.doc.resolve(i)) || (i = null), t = new r(i, t.dragging);
      }
      return t;
    }, r;
  }()
);
function Yk(r, e, t) {
  var n = _e.getState(r.state);
  if (!n.dragging) {
    var i = nd(e.target), o = -1;
    if (i) {
      var a = rd(i), s = i.getBoundingClientRect(), l = s.top, c = s.bottom;
      Math.abs(e.clientY - l) <= t && a.rowIndex > 0 ? (a.rowIndex -= i.rowSpan, o = Qi(r, e, a)) : c - e.clientY > 0 && c - e.clientY <= t && (o = Qi(r, e, a));
    }
    o !== n.activeHandle && ud(r, o);
  }
}
function Zk(r) {
  var e = _e.getState(r.state);
  e.activeHandle > -1 && !e.dragging && ud(r, -1);
}
function Qk(r, e) {
  var t = _e.getState(r.state);
  if (t.activeHandle === -1 || t.dragging)
    return !1;
  var n = r.state.doc, i = n.resolve(t.activeHandle), o = i.parent, a = i.node(-1), s = Jn(o.attrs.style).height, l = Jn(a.attrs.style).height, c = s ? parseFloat(s) : 0;
  if (!s) {
    var u = r.nodeDOM(t.activeHandle);
    c = u.offsetHeight;
  }
  r.dispatch(r.state.tr.setMeta(_e, {
    setDragging: {
      startY: e.clientY,
      startHeight: { rowHeight: c, tableHeight: l }
    }
  }));
  function f(d) {
    d.view.removeEventListener("mouseup", f), d.view.removeEventListener("mousemove", h);
    var p = _e.getState(r.state);
    if (p.dragging) {
      var m = r.state.tr.setMeta(_e, { setDragging: null });
      tx(r, m, p.activeHandle), r.dispatch(m);
    }
  }
  function h(d) {
    if (!d.which)
      return f(d);
    var p = _e.getState(r.state), m = ex(p.dragging, d), v = d.clientY - p.dragging.startY;
    nx(r, p.activeHandle, m, v, l);
  }
  return e.view.addEventListener("mouseup", f), e.view.addEventListener("mousemove", h), e.preventDefault(), !0;
}
function ex(r, e) {
  var t = e.clientY - r.startY;
  return r.startHeight.rowHeight + t;
}
function ud(r, e) {
  var t = r.state.tr;
  t.setMeta("addToHistory", !1), t.setMeta(_e, { setHandle: e }), r.dispatch(t);
}
function tx(r, e, t) {
  var n = r.state.doc, i = n.resolve(t), o = i.parent, a = i.posAtIndex(0) - 1, s = r.nodeDOM(a), l = s.ownerDocument && s.ownerDocument.defaultView || window;
  s.style.height = l.getComputedStyle(s).height, e.setNodeMarkup(a, null, Ht(o.attrs, "height", s.style.height));
  var c = s && s.closest("table"), u = c && c.style.height;
  if (u) {
    var f = n.resolve(a), h = f.start(f.depth) - 1;
    e.setNodeMarkup(h, null, Ht(f.parent.attrs, "height", u));
  }
}
function nx(r, e, t, n, i) {
  var o = r.nodeDOM(e), a = o && o.parentNode;
  if (a) {
    a.style.height = t + "px";
    var s = a.ownerDocument && a.ownerDocument.defaultView || window;
    a.style.height = s.getComputedStyle(a).height;
    var l = a.closest("table"), c = parseFloat(i) + n + "px", u = l && l.style.height;
    u && u !== c && (l.style.height = parseFloat(i) + n + "px", l.style.height = s.getComputedStyle(l).height);
  }
}
function rx(r, e) {
  var t = [];
  if (typeof e != "number")
    return fe.empty;
  for (var n = r.doc.resolve(e), i = n.node(-1), o = Te.get(i), a = n.start(-1), s = [], l = e - a, c = -1, u = 0; u < o.height; u++)
    s.push(o.map.slice(u * o.width, u * o.width + o.width)), s[u].indexOf(l) !== -1 && (c = u);
  var f = [];
  return s[c].forEach(function(h, d) {
    (!s[c + 1] || h !== s[c + 1][d]) && f.push(h);
  }), f.forEach(function(h) {
    var d = i.nodeAt(h), p = a + h + (d ? d.nodeSize : 0) - 1, m = document.createElement("div");
    m.className = "row-resize-handle", t.push(Ae.widget(p, m));
  }), fe.create(r.doc, t);
}
var ix = function() {
  return [
    qk(),
    Ek(),
    Gk()
  ];
};
function ox(r = {}) {
  return new Ge({
    view(e) {
      return new ax(e, r);
    }
  });
}
class ax {
  constructor(e, t) {
    var n;
    this.editorView = e, this.cursorPos = null, this.element = null, this.timeout = -1, this.width = (n = t.width) !== null && n !== void 0 ? n : 1, this.color = t.color === !1 ? void 0 : t.color || "black", this.class = t.class, this.handlers = ["dragover", "dragend", "drop", "dragleave"].map((i) => {
      let o = (a) => {
        this[i](a);
      };
      return e.dom.addEventListener(i, o), { name: i, handler: o };
    });
  }
  destroy() {
    this.handlers.forEach(({ name: e, handler: t }) => this.editorView.dom.removeEventListener(e, t));
  }
  update(e, t) {
    this.cursorPos != null && t.doc != e.state.doc && (this.cursorPos > e.state.doc.content.size ? this.setCursor(null) : this.updateOverlay());
  }
  setCursor(e) {
    e != this.cursorPos && (this.cursorPos = e, e == null ? (this.element.parentNode.removeChild(this.element), this.element = null) : this.updateOverlay());
  }
  updateOverlay() {
    let e = this.editorView.state.doc.resolve(this.cursorPos), t = !e.parent.inlineContent, n;
    if (t) {
      let s = e.nodeBefore, l = e.nodeAfter;
      if (s || l) {
        let c = this.editorView.nodeDOM(this.cursorPos - (s ? s.nodeSize : 0));
        if (c) {
          let u = c.getBoundingClientRect(), f = s ? u.bottom : u.top;
          s && l && (f = (f + this.editorView.nodeDOM(this.cursorPos).getBoundingClientRect().top) / 2), n = { left: u.left, right: u.right, top: f - this.width / 2, bottom: f + this.width / 2 };
        }
      }
    }
    if (!n) {
      let s = this.editorView.coordsAtPos(this.cursorPos);
      n = { left: s.left - this.width / 2, right: s.left + this.width / 2, top: s.top, bottom: s.bottom };
    }
    let i = this.editorView.dom.offsetParent;
    this.element || (this.element = i.appendChild(document.createElement("div")), this.class && (this.element.className = this.class), this.element.style.cssText = "position: absolute; z-index: 50; pointer-events: none;", this.color && (this.element.style.backgroundColor = this.color)), this.element.classList.toggle("prosemirror-dropcursor-block", t), this.element.classList.toggle("prosemirror-dropcursor-inline", !t);
    let o, a;
    if (!i || i == document.body && getComputedStyle(i).position == "static")
      o = -pageXOffset, a = -pageYOffset;
    else {
      let s = i.getBoundingClientRect();
      o = s.left - i.scrollLeft, a = s.top - i.scrollTop;
    }
    this.element.style.left = n.left - o + "px", this.element.style.top = n.top - a + "px", this.element.style.width = n.right - n.left + "px", this.element.style.height = n.bottom - n.top + "px";
  }
  scheduleRemoval(e) {
    clearTimeout(this.timeout), this.timeout = setTimeout(() => this.setCursor(null), e);
  }
  dragover(e) {
    if (!this.editorView.editable)
      return;
    let t = this.editorView.posAtCoords({ left: e.clientX, top: e.clientY }), n = t && t.inside >= 0 && this.editorView.state.doc.nodeAt(t.inside), i = n && n.type.spec.disableDropCursor, o = typeof i == "function" ? i(this.editorView, t, e) : i;
    if (t && !o) {
      let a = t.pos;
      if (this.editorView.dragging && this.editorView.dragging.slice) {
        let s = yf(this.editorView.state.doc, a, this.editorView.dragging.slice);
        s != null && (a = s);
      }
      this.setCursor(a), this.scheduleRemoval(5e3);
    }
  }
  dragend() {
    this.scheduleRemoval(20);
  }
  drop() {
    this.scheduleRemoval(20);
  }
  dragleave(e) {
    (e.target == this.editorView.dom || !this.editorView.dom.contains(e.relatedTarget)) && this.setCursor(null);
  }
}
class Oe extends ie {
  /**
  Create a gap cursor.
  */
  constructor(e) {
    super(e, e);
  }
  map(e, t) {
    let n = e.resolve(t.map(this.head));
    return Oe.valid(n) ? new Oe(n) : ie.near(n);
  }
  content() {
    return $.empty;
  }
  eq(e) {
    return e instanceof Oe && e.head == this.head;
  }
  toJSON() {
    return { type: "gapcursor", pos: this.head };
  }
  /**
  @internal
  */
  static fromJSON(e, t) {
    if (typeof t.pos != "number")
      throw new RangeError("Invalid input for GapCursor.fromJSON");
    return new Oe(e.resolve(t.pos));
  }
  /**
  @internal
  */
  getBookmark() {
    return new pl(this.anchor);
  }
  /**
  @internal
  */
  static valid(e) {
    let t = e.parent;
    if (t.isTextblock || !sx(e) || !lx(e))
      return !1;
    let n = t.type.spec.allowGapCursor;
    if (n != null)
      return n;
    let i = t.contentMatchAt(e.index()).defaultType;
    return i && i.isTextblock;
  }
  /**
  @internal
  */
  static findGapCursorFrom(e, t, n = !1) {
    e:
      for (; ; ) {
        if (!n && Oe.valid(e))
          return e;
        let i = e.pos, o = null;
        for (let a = e.depth; ; a--) {
          let s = e.node(a);
          if (t > 0 ? e.indexAfter(a) < s.childCount : e.index(a) > 0) {
            o = s.child(t > 0 ? e.indexAfter(a) : e.index(a) - 1);
            break;
          } else if (a == 0)
            return null;
          i += t;
          let l = e.doc.resolve(i);
          if (Oe.valid(l))
            return l;
        }
        for (; ; ) {
          let a = t > 0 ? o.firstChild : o.lastChild;
          if (!a) {
            if (o.isAtom && !o.isText && !te.isSelectable(o)) {
              e = e.doc.resolve(i + o.nodeSize * t), n = !1;
              continue e;
            }
            break;
          }
          o = a, i += t;
          let s = e.doc.resolve(i);
          if (Oe.valid(s))
            return s;
        }
        return null;
      }
  }
}
Oe.prototype.visible = !1;
Oe.findFrom = Oe.findGapCursorFrom;
ie.jsonID("gapcursor", Oe);
class pl {
  constructor(e) {
    this.pos = e;
  }
  map(e) {
    return new pl(e.map(this.pos));
  }
  resolve(e) {
    let t = e.resolve(this.pos);
    return Oe.valid(t) ? new Oe(t) : ie.near(t);
  }
}
function sx(r) {
  for (let e = r.depth; e >= 0; e--) {
    let t = r.index(e), n = r.node(e);
    if (t == 0) {
      if (n.type.spec.isolating)
        return !0;
      continue;
    }
    for (let i = n.child(t - 1); ; i = i.lastChild) {
      if (i.childCount == 0 && !i.inlineContent || i.isAtom || i.type.spec.isolating)
        return !0;
      if (i.inlineContent)
        return !1;
    }
  }
  return !0;
}
function lx(r) {
  for (let e = r.depth; e >= 0; e--) {
    let t = r.indexAfter(e), n = r.node(e);
    if (t == n.childCount) {
      if (n.type.spec.isolating)
        return !0;
      continue;
    }
    for (let i = n.child(t); ; i = i.firstChild) {
      if (i.childCount == 0 && !i.inlineContent || i.isAtom || i.type.spec.isolating)
        return !0;
      if (i.inlineContent)
        return !1;
    }
  }
  return !0;
}
function cx() {
  return new Ge({
    props: {
      decorations: dx,
      createSelectionBetween(r, e, t) {
        return e.pos == t.pos && Oe.valid(t) ? new Oe(t) : null;
      },
      handleClick: fx,
      handleKeyDown: ux,
      handleDOMEvents: { beforeinput: hx }
    }
  });
}
const ux = ll({
  ArrowLeft: Oi("horiz", -1),
  ArrowRight: Oi("horiz", 1),
  ArrowUp: Oi("vert", -1),
  ArrowDown: Oi("vert", 1)
});
function Oi(r, e) {
  const t = r == "vert" ? e > 0 ? "down" : "up" : e > 0 ? "right" : "left";
  return function(n, i, o) {
    let a = n.selection, s = e > 0 ? a.$to : a.$from, l = a.empty;
    if (a instanceof oe) {
      if (!o.endOfTextblock(t) || s.depth == 0)
        return !1;
      l = !1, s = n.doc.resolve(e > 0 ? s.after() : s.before());
    }
    let c = Oe.findGapCursorFrom(s, e, l);
    return c ? (i && i(n.tr.setSelection(new Oe(c))), !0) : !1;
  };
}
function fx(r, e, t) {
  if (!r || !r.editable)
    return !1;
  let n = r.state.doc.resolve(e);
  if (!Oe.valid(n))
    return !1;
  let i = r.posAtCoords({ left: t.clientX, top: t.clientY });
  return i && i.inside > -1 && te.isSelectable(r.state.doc.nodeAt(i.inside)) ? !1 : (r.dispatch(r.state.tr.setSelection(new Oe(n))), !0);
}
function hx(r, e) {
  if (e.inputType != "insertCompositionText" || !(r.state.selection instanceof Oe))
    return !1;
  let { $from: t } = r.state.selection, n = t.parent.contentMatchAt(t.index()).findWrapping(r.state.schema.nodes.text);
  if (!n)
    return !1;
  let i = I.empty;
  for (let a = n.length - 1; a >= 0; a--)
    i = I.from(n[a].createAndFill(null, i));
  let o = r.state.tr.replace(t.pos, t.pos, new $(i, 0, 0));
  return o.setSelection(oe.near(o.doc.resolve(t.pos + 1))), r.dispatch(o), !1;
}
function dx(r) {
  if (!(r.selection instanceof Oe))
    return null;
  let e = document.createElement("div");
  return e.className = "ProseMirror-gapcursor", fe.create(r.doc, [Ae.widget(r.selection.head, e, { key: "gapcursor" })]);
}
var fd = function(r, e, t) {
  for (var n = r.table, i = r.table_row, o = r.table_cell, a = [], s, l = 0; l < e + 1; l++) {
    s = [];
    for (var c = 0; c < t + 1; c++)
      s.push(o.createAndFill());
    a.push(i.createAndFill(void 0, s));
  }
  return n.createAndFill(void 0, a);
}, ri = /^table$/, hd = /^table_row$/, px = /^table_cell|table_header$/, On = function(r, e) {
  for (var t = r.$head, n = t.depth; n > 0; n--) {
    var i = t.node(n);
    if (e.test(i.type.name))
      return {
        pos: t.before(n),
        node: i
      };
  }
  return null;
}, mx = function(r, e) {
  var t = e && function(n) {
    var i, o = On(n.selection, hd), a = On(n.selection, ri);
    if (o && a && o.node.attrs[$t]) {
      for (var s = 0, l = 0; l < a.node.nodeSize; l++)
        if (a.node.child(l).eq(o.node)) {
          s = l;
          break;
        }
      var c = a.node.child(s - 1), u = o.pos - c.nodeSize;
      n.setNodeMarkup(u, void 0, (i = {}, i[$t] = o.node.attrs[$t], i));
    }
    return e(n);
  };
  return aC(r, t);
}, gx = function(r, e) {
  var t = e && function(n) {
    var i, o = On(n.selection, hd);
    if (o && o.node.attrs[$t]) {
      var a = o.pos + o.node.nodeSize;
      n.setNodeMarkup(a, void 0, (i = {}, i[$t] = o.node.attrs[$t], i));
    }
    return e(n);
  };
  return sC(r, t);
}, dd = function(r, e) {
  if (!r)
    return -1;
  var t = Te.get(r.node), n = On(e, px), i = t.map.indexOf(n.pos - r.pos - 1), o = -1;
  return i !== -1 && (o = i % t.width), o;
}, pd = function(r, e, t) {
  var n, i = dd(e, r.selection), o = So(e.node.attrs[we]);
  o.insertBefore(o.ownerDocument.createElement("col"), o.children[i + t]), r.setNodeMarkup(e.pos, null, A(A({}, e.node.attrs), (n = {}, n[we] = o.outerHTML, n)));
}, vx = function(r, e, t) {
  var n, i = So(e.node.attrs[we]);
  i.removeChild(i.children[t]), r.setNodeMarkup(e.pos, null, A(A({}, e.node.attrs), (n = {}, n[we] = i.outerHTML, n)));
}, yx = function(r, e) {
  var t = e && function(n) {
    var i = On(n.selection, ri);
    return i.node.attrs[we] && pd(n, i, -1), e(n);
  };
  return tC(r, t);
}, wx = function(r, e) {
  var t = e && function(n) {
    var i = On(n.selection, ri);
    return i.node.attrs[we] && pd(n, i, 1), e(n);
  };
  return nC(r, t);
}, bx = function(r, e) {
  var t = dd(On(r.selection, ri), r.selection), n = e && function(i) {
    var o = On(i.selection, ri);
    return o.node.attrs[we] && vx(i, o, t), e(i);
  };
  return iC(r, n);
}, Sx = `
html, body {
    margin: 0;
    height: 100%;
    padding: 0;
}

html {
  min-height: 100%;
}

body {
  box-sizing: border-box;
  position: relative;
  word-wrap: break-word;
  padding: 8px;
}

body > .k-content {
  outline: 0;
  height: 100%;
  white-space: pre-wrap;
}

.k-content > p {
  margin: 0 0 1em;
}

.k-content table {
  white-space: pre-wrap;
}

.k-content .k-text-selected, .k-content::selection {
  color: HighlightText;
  background-color: Highlight;
}

.k-content .k-text-highlighted {
  background-color: #bbdefb;
}

.k-content .ProseMirror-selectednode {
  outline: 2px solid #8cf;
}

.ProseMirror-hideselection *::selection { background: transparent; }
.ProseMirror-hideselection *::-moz-selection { background: transparent; }
.ProseMirror-hideselection { caret-color: transparent; }

.ProseMirror-gapcursor {
  display: none;
  pointer-events: none;
  position: absolute;
}

.ProseMirror-gapcursor:after {
  content: "";
  display: block;
  position: absolute;
  top: -2px;
  width: 20px;
  border-top: 1px solid black;
  animation: ProseMirror-cursor-blink 1.1s steps(2, start) infinite;
}

@keyframes ProseMirror-cursor-blink {
  to {
    visibility: hidden;
  }
}

.ProseMirror-focused .ProseMirror-gapcursor {
  display: block;
}

.k-editor-resize-handles-wrapper {
  position: absolute;
  visibility: hidden;
}

.k-editor-resize-handle {
  position: absolute;
  visibility: visible;
  background-color: #fff;
  border: 1px solid #000;
  z-index: 100;
  width: 5px;
  height: 5px;
}

.k-editor-resize-handle.northwest {
  top: 0;
  left: 0;
  transform: translate(-50%, -50%);
  cursor: nw-resize;
}

.k-editor-resize-handle.north {
  top: 0;
  left: 50%;
  transform: translate(-50%, -50%);
  cursor: n-resize;
}

.k-editor-resize-handle.northeast {
  top: 0;
  right: 0;
  transform: translate(50%, -50%);
  cursor: ne-resize;
}

.k-editor-resize-handle.southwest {
  left: 0;
  bottom: 0;
  transform: translate(-50%, 50%);
  cursor: sw-resize;
}

.k-editor-resize-handle.south {
  bottom: 0;
  left: 50%;
  transform: translate(-50%, 50%);
  cursor: s-resize;
}

.k-editor-resize-handle.southeast {
  right: 0;
  bottom: 0;
  transform: translate(50%, 50%);
  cursor: se-resize;
}

.k-editor-resize-handle.west {
  top: 50%;
  left: 0;
  transform: translate(-50%, -50%);
  cursor: w-resize;
}

.k-editor-resize-handle.east {
  top: 50%;
  right: 0;
  transform: translate(50%, -50%);
  cursor: e-resize;
}

.k-editor-resize-wrap-element {
  display: inline-block;
  position: relative;
}

.ProseMirror .row-resize-handle {
  position: absolute;
  right: 0; left: 0; bottom: 0;
  transform: translate(0, 50%);
  height: 4px;
  z-index: 20;
  background-color: #adf;
  pointer-events: none;
}

.ProseMirror .column-resize-handle {
  position: absolute;
  right: -2px; top: 0; bottom: 0;
  width: 4px;
  z-index: 20;
  background-color: #adf;
  pointer-events: none;
}

.ProseMirror.resize-cursor {
  cursor: ew-resize;
  cursor: col-resize;
}

.ProseMirror.resize-cursor-vertical {
  cursor: sn-resize;
  cursor: row-resize;
}

.k-editor-resize-wrap-element table td p,
.k-editor-resize-wrap-element table th p {
  margin: 0 auto;
}
`, Cx = `
  .ProseMirror .tableWrapper {
    overflow-x: auto;
    margin: 1em 0;
  }

  .ProseMirror table {
    margin: 0;
    border-collapse: collapse;
    table-layout: fixed;
    width: 100%;
    overflow: hidden;
  }

  .ProseMirror td, .ProseMirror th {
    min-width: 1em;
    border: 1px solid #ddd;
    padding: 3px 5px;
    vertical-align: top;
    box-sizing: border-box;
    position: relative;
  }

  .ProseMirror th {
    font-weight: bold;
    text-align: left;
  }

  /* Give selected cells a blue overlay */
  .ProseMirror .selectedCell:after {
    z-index: 2;
    position: absolute;
    content: "";
    left: 0; right: 0; top: 0; bottom: 0;
    background: rgba(200, 200, 255, 0.4);
    pointer-events: none;
  }
`, kx = "body { direction: rtl }", F, md = "editor.bold", gd = "editor.italic", vd = "editor.underline", yd = "editor.strikethrough", wd = "editor.subscript", bd = "editor.superscript", Sd = "editor.hyperlink", Cd = "editor.insertFile", kd = "editor.print", xd = "editor.selectAll", Od = "editor.cleanFormatting", Td = "editor.pdf", Md = "editor.foregroundColor", _d = "editor.backgroundColor", Id = "editor.createTable", Dd = "editor.insertTableHint", Ed = "editor.addRowBefore", Ad = "editor.addRowAfter", Nd = "editor.addColumnBefore", Rd = "editor.addColumnAfter", Pd = "editor.deleteRow", Ld = "editor.deleteColumn", Fd = "editor.deleteTable", zd = "editor.mergeCells", Bd = "editor.splitCell", $d = "editor.hyperlink-dialog-title", Hd = "editor.hyperlink-dialog-content-address", jd = "editor.hyperlink-dialog-content-title", Wd = "editor.hyperlink-dialog-content-newwindow", Vd = "editor.hyperlink-dialog-cancel", Ud = "editor.hyperlink-dialog-insert", qd = "editor.insertfile-dialog-title", Kd = "editor.insertfile-dialog-content-address", Gd = "editor.insertfile-dialog-content-title", Jd = "editor.insertfile-dialog-cancel", Xd = "editor.insertfile-dialog-insert", Yd = "editor.image", Zd = "editor.image-dialog-title", Qd = "editor.image-address", ep = "editor.image-title", tp = "editor.image-altText", np = "editor.image-width", rp = "editor.image-height", ip = "editor.image-cancel", op = "editor.image-insert", ap = "editor.viewHtml", sp = "editor.viewHtml-dialog-title", lp = "editor.viewHtml-cancel", cp = "editor.viewHtml-update", up = "editor.unlink", fp = "editor.undo", hp = "editor.redo", dp = "editor.fontSize", pp = "editor.fontName", mp = "editor.format", gp = "editor.alignLeft", vp = "editor.alignRight", yp = "editor.alignCenter", wp = "editor.alignJustify", bp = "editor.indent", Sp = "editor.outdent", Cp = "editor.orderedList", kp = "editor.bulletList", xp = "editor.findReplace-tool-title", Op = "editor.findReplace-dialog-title", Tp = "editor.findReplace-tab-find", Mp = "editor.findReplace-tab-replace", _p = "editor.findReplace-findWhat", Ip = "editor.findReplace-replaceWith", Dp = "editor.findReplace-replace", Ep = "editor.findReplace-replaceAll", Ap = "editor.findReplace-matchCase", Np = "editor.findReplace-matchWord", Rp = "editor.findReplace-matchCyclic", Pp = "editor.findReplace-useRegExp", Lp = "editor.findReplace-prevMatch", Fp = "editor.findReplace-nextMatch", zp = "editor.findReplace-matches", Bp = "editor.iframeTitle", $p = "editorTools.foreColorLabel", Hp = "editorTools.backColorLabel", Y = (F = {}, F[md] = "Bold", F[gd] = "Italic", F[vd] = "Underline", F[yd] = "Strikethrough", F[wd] = "Subscript", F[bd] = "Superscript", F[up] = "Remove hyperlink", F[fp] = "Undo", F[hp] = "Redo", F[dp] = "Font Size", F[pp] = "Font Name", F[mp] = "Format", F[gp] = "Align text left", F[vp] = "Align text right", F[yp] = "Center text", F[wp] = "Justify", F[bp] = "Indent", F[Sp] = "Outdent", F[Cp] = "Insert ordered list", F[kp] = "Insert unordered list", F[kd] = "Print", F[xd] = "Select All", F[Od] = "Clean formatting", F[Td] = "Export as PDF", F[Md] = "Color", F[_d] = "Background color", // Tables
F[Id] = "Create a table", F[Dd] = "Create a {0} x {1} table", F[Ed] = "Add row above", F[Ad] = "Add row below", F[Nd] = "Add column on the left", F[Rd] = "Add column on the right", F[Pd] = "Delete row", F[Ld] = "Delete column", F[Fd] = "Delete table", F[zd] = "Merge cells", F[Bd] = "Split cell", // Insert Link
F[Sd] = "Insert hyperlink", F[$d] = "Insert hyperlink", F[Hd] = "Web address", F[jd] = "Title", F[Wd] = "Open link in new window", F[Vd] = "Cancel", F[Ud] = "Insert", // Insert File
F[Cd] = "Insert file", F[qd] = "Insert file", F[Kd] = "Web address", F[Gd] = "Title", F[Jd] = "Cancel", F[Xd] = "Insert", // Insert Image
F[Yd] = "Insert image", F[Zd] = "Insert image", F[Qd] = "Web address", F[ep] = "Title", F[tp] = "Alternate text", F[np] = "Width (px)", F[rp] = "Height (px)", F[ip] = "Cancel", F[op] = "Insert", // View HTML
F[ap] = "View HTML", F[sp] = "View HTML", F[lp] = "Cancel", F[cp] = "Update", // Find and Replace
F[xp] = "Find and Replace", F[Op] = "Find and Replace", F[Tp] = "Find", F[Mp] = "Replace", F[_p] = "Find What:", F[Ip] = "Replace With", F[Dp] = "Replace", F[Ep] = "Replace All", F[Ap] = "Match Case", F[Np] = "Match whole word only", F[Rp] = "Match cyclic (Wrap around)", F[Pp] = "Regular Expression", F[Lp] = "Prev", F[Fp] = "Next", F[zp] = "{0} of {1} matches", F[Bp] = "Editable area. Press Alt + F10 for toolbar.", F[$p] = "Fore Color", F[Hp] = "Back Color", F), P = {
  bold: md,
  italic: gd,
  underline: vd,
  strikethrough: yd,
  subscript: wd,
  superscript: bd,
  unlink: up,
  undo: fp,
  redo: hp,
  fontSize: dp,
  fontName: pp,
  format: mp,
  alignLeft: gp,
  alignRight: vp,
  alignCenter: yp,
  alignJustify: wp,
  indent: bp,
  outdent: Sp,
  orderedList: Cp,
  bulletList: kp,
  print: kd,
  selectAll: xd,
  cleanFormatting: Od,
  pdf: Td,
  foregroundColor: Md,
  backgroundColor: _d,
  createTable: Id,
  createTableHint: Dd,
  addRowBefore: Ed,
  addRowAfter: Ad,
  addColumnBefore: Nd,
  addColumnAfter: Rd,
  deleteRow: Pd,
  deleteColumn: Ld,
  deleteTable: Fd,
  mergeCells: zd,
  splitCell: Bd,
  insertHyperlink: Sd,
  insertHyperlinkDialogTitle: $d,
  insertHyperlinkAddress: Hd,
  insertHyperlinkTitle: jd,
  insertHyperlinkNewWindow: Wd,
  insertHyperlinkCancel: Vd,
  insertHyperlinkInsert: Ud,
  insertFile: Cd,
  insertFileDialogTitle: qd,
  insertFileAddress: Kd,
  insertFileTitle: Gd,
  insertFileCancel: Jd,
  insertFileInsert: Xd,
  insertImage: Yd,
  insertImageDialogTitle: Zd,
  insertImageAddress: Qd,
  insertImageTitle: ep,
  insertImageAltText: tp,
  insertImageWidth: np,
  insertImageHeight: rp,
  insertImageCancel: ip,
  insertImageInsert: op,
  viewHtml: ap,
  viewHtmlDialogTitle: sp,
  viewHtmlCancel: lp,
  viewHtmlUpdate: cp,
  findReplaceToolTitle: xp,
  findReplaceDialogTitle: Op,
  findReplaceTabFind: Tp,
  findReplaceTabReplace: Mp,
  findReplaceFindWhat: _p,
  findReplaceReplaceWith: Ip,
  findReplaceReplace: Dp,
  findReplaceReplaceAll: Ep,
  findReplaceMatchCase: Ap,
  findReplaceMatchWord: Np,
  findReplaceMatchCyclic: Rp,
  findReplaceUseRegExp: Pp,
  findReplacePrevMatch: Lp,
  findReplaceNextMatch: Fp,
  findReplaceMatches: zp,
  iframeTitle: Bp,
  foreColorLabel: $p,
  backColorLabel: Hp
}, G = globalThis && globalThis.__assign || function() {
  return G = Object.assign || function(r) {
    for (var e, t = 1, n = arguments.length; t < n; t++) {
      e = arguments[t];
      for (var i in e)
        Object.prototype.hasOwnProperty.call(e, i) && (r[i] = e[i]);
    }
    return r;
  }, G.apply(this, arguments);
}, Er = globalThis && globalThis.__spreadArray || function(r, e, t) {
  if (t || arguments.length === 2)
    for (var n = 0, i = e.length, o; n < i; n++)
      (o || !(n in e)) && (o || (o = Array.prototype.slice.call(e, 0, n)), o[n] = e[n]);
  return r.concat(o || Array.prototype.slice.call(e));
}, Dn = G({}, Xf.listsTypes), X;
(function(r) {
  var e = {
    type: "button"
  };
  r.bold = G(G({}, FC), { props: G({ icon: "bold", svgIcon: mm }, e), messages: {
    title: P.bold
  }, commandName: "Bold" }), r.italic = G(G({}, zC), { props: G({ icon: "italic", svgIcon: gm }, e), messages: {
    title: P.italic
  }, commandName: "Italic" }), r.underline = G(G({}, BC), { props: G({ icon: "underline", svgIcon: vm }, e), messages: {
    title: P.underline
  }, commandName: "Underline" }), r.strikethrough = G(G({}, $C), { props: G({ icon: "strikethrough", svgIcon: ym }, e), messages: {
    title: P.strikethrough
  }, commandName: "Strikethrough" }), r.subscript = G(G({}, HC), { props: G({ icon: "subscript", svgIcon: wm }, e), messages: {
    title: P.subscript
  }, commandName: "Subscript" }), r.superscript = G(G({}, jC), { props: G({ icon: "supscript", svgIcon: bm }, e), messages: {
    title: P.superscript
  }, commandName: "Superscript" }), r.link = G(G({}, pa), { props: G({ icon: "link", svgIcon: Sm }, e), messages: {
    insertHyperlink: P.insertHyperlink,
    insertHyperlinkDialogTitle: P.insertHyperlinkDialogTitle,
    insertHyperlinkAddress: P.insertHyperlinkAddress,
    insertHyperlinkTitle: P.insertHyperlinkTitle,
    insertHyperlinkNewWindow: P.insertHyperlinkNewWindow,
    insertHyperlinkCancel: P.insertHyperlinkCancel,
    insertHyperlinkInsert: P.insertHyperlinkInsert
  }, commandName: "Link" }), r.insertFile = G(G({}, pa), { props: G({ icon: "file-add", svgIcon: Cm }, e), messages: {
    insertHyperlink: P.insertFile,
    insertHyperlinkDialogTitle: P.insertFileDialogTitle,
    insertHyperlinkAddress: P.insertFileAddress,
    insertHyperlinkTitle: P.insertFileTitle,
    insertHyperlinkNewWindow: "",
    insertHyperlinkCancel: P.insertFileCancel,
    insertHyperlinkInsert: P.insertFileInsert
  }, commandName: "InsertFile", linkTarget: !1 }), r.insertTable = {
    props: G({ icon: "table-add", svgIcon: km }, e),
    messages: {
      createTable: P.createTable,
      createTableHint: P.createTableHint
    },
    commandName: "InsertTable"
  }, r.addRowBefore = {
    props: G({ icon: "table-row-insert-above", svgIcon: xm }, e),
    messages: {
      title: P.addRowBefore
    },
    commandName: "AddRowBefore"
  }, r.addRowAfter = {
    props: G({ icon: "table-row-insert-below", svgIcon: Om }, e),
    messages: {
      title: P.addRowAfter
    },
    commandName: "AddRowAfter"
  }, r.addColumnBefore = {
    props: G({ icon: "table-column-insert-left", svgIcon: Tm }, e),
    messages: {
      title: P.addColumnBefore
    },
    commandName: "AddColumnBefore"
  }, r.addColumnAfter = {
    props: G({ icon: "table-column-insert-right", svgIcon: Mm }, e),
    messages: {
      title: P.addColumnAfter
    },
    commandName: "AddColumnAfter"
  }, r.deleteRow = {
    props: G({ icon: "table-row-delete", svgIcon: _m }, e),
    messages: {
      title: P.deleteRow
    },
    commandName: "DeleteRow"
  }, r.deleteColumn = {
    props: G({ icon: "table-column-delete", svgIcon: Im }, e),
    messages: {
      title: P.deleteColumn
    },
    commandName: "DeleteColumn"
  }, r.deleteTable = {
    props: G({ icon: "table-delete", svgIcon: Dm }, e),
    messages: {
      title: P.deleteTable
    },
    commandName: "DeleteTable"
  }, r.mergeCells = {
    props: G({ icon: "cells-merge", svgIcon: Em }, e),
    messages: {
      title: P.mergeCells
    },
    commandName: "MergeCells"
  }, r.splitCell = {
    props: G({ icon: "cell-split-horizontally", svgIcon: Am }, e),
    messages: {
      title: P.splitCell
    },
    commandName: "SplitCell"
  }, r.print = {
    props: G({ icon: "print", svgIcon: Nm }, e),
    messages: {
      title: P.print
    }
  }, r.selectAll = {
    props: G({ icon: "select-all", svgIcon: Rm }, e),
    messages: {
      title: P.selectAll
    }
  }, r.pdf = {
    props: G({ icon: "file-pdf", svgIcon: Pm }, e),
    messages: {
      title: P.pdf
    }
  }, r.savePdfOptions = {
    fileName: "editor.pdf",
    paperSize: "A4",
    margin: "1cm"
  }, r.cleanFormatting = {
    props: G({ icon: "clear-css", svgIcon: Lm }, e),
    messages: {
      title: P.cleanFormatting
    },
    commandName: "CleanFormatting"
  }, r.image = {
    node: "image",
    props: G({ icon: "image", svgIcon: Fm }, e),
    messages: {
      insertImage: P.insertImage,
      insertImageDialogTitle: P.insertImageDialogTitle,
      insertImageAddress: P.insertImageAddress,
      insertImageTitle: P.insertImageTitle,
      insertImageAltText: P.insertImageAltText,
      insertImageWidth: P.insertImageWidth,
      insertImageHeight: P.insertImageHeight,
      insertImageCancel: P.insertImageCancel,
      insertImageInsert: P.insertImageInsert
    },
    commandName: "InsertImage"
  }, r.viewHtml = {
    props: G({ icon: "code", svgIcon: zm }, e),
    messages: {
      viewHtml: P.viewHtml,
      viewHtmlDialogTitle: P.viewHtmlDialogTitle,
      viewHtmlCancel: P.viewHtmlCancel,
      viewHtmlUpdate: P.viewHtmlUpdate
    },
    commandName: "SetContent"
  }, r.findAndReplace = {
    props: G({ icon: "find", svgIcon: Bm }, e),
    messages: {
      findReplaceToolTitle: P.findReplaceToolTitle,
      findReplaceDialogTitle: P.findReplaceDialogTitle,
      findReplaceTabFind: P.findReplaceTabFind,
      findReplaceTabReplace: P.findReplaceTabReplace,
      findReplaceFindWhat: P.findReplaceFindWhat,
      findReplaceReplaceWith: P.findReplaceReplaceWith,
      findReplaceReplace: P.findReplaceReplace,
      findReplaceReplaceAll: P.findReplaceReplaceAll,
      findReplaceMatchCase: P.findReplaceMatchCase,
      findReplaceMatchWord: P.findReplaceMatchWord,
      findReplaceMatchCyclic: P.findReplaceMatchCyclic,
      findReplaceUseRegExp: P.findReplaceUseRegExp,
      findReplacePrevMatch: P.findReplacePrevMatch,
      findReplaceNextMatch: P.findReplaceNextMatch,
      findReplaceMatches: P.findReplaceMatches
    }
  }, r.unlink = G(G({}, pa), { props: G({ icon: "unlink", svgIcon: $m }, e), messages: {
    title: P.unlink
  }, commandName: "Unlink" }), r.undo = {
    props: G({ icon: "undo", svgIcon: Hm }, e),
    messages: {
      title: P.undo
    },
    commandName: "Undo"
  }, r.redo = {
    props: G({ icon: "redo", svgIcon: jm }, e),
    messages: {
      title: P.redo
    },
    commandName: "Redo"
  }, r.fontSize = {
    style: "font-size",
    defaultItem: { text: Y[P.fontSize], value: "", localizationKey: P.fontSize },
    items: [
      { text: "1 (8pt)", value: "xx-small" },
      { text: "2 (10pt)", value: "x-small" },
      { text: "3 (12pt)", value: "small" },
      { text: "4 (14pt)", value: "medium" },
      { text: "5 (18pt)", value: "large" },
      { text: "6 (24pt)", value: "x-large" },
      { text: "7 (36pt)", value: "xx-large" }
    ],
    commandName: "FontSize"
  }, r.fontName = {
    style: "font-family",
    defaultItem: { text: Y[P.fontName], value: "", localizationKey: P.fontName },
    items: [
      {
        text: "Arial",
        value: "Arial, Helvetica, sans-serif",
        style: { fontFamily: "Arial, Helvetica, sans-serif" }
      },
      {
        text: "Courier New",
        value: "'Courier New', Courier, monospace",
        style: { fontFamily: "'Courier New', Courier, monospace" }
      },
      {
        text: "Georgia",
        value: "Georgia, serif",
        style: { fontFamily: "Georgia, serif" }
      },
      {
        text: "Impact",
        value: "Impact, Charcoal, sans-serif",
        style: { fontFamily: "Impact, Charcoal, sans-serif" }
      },
      {
        text: "Lucida Console",
        value: "'Lucida Console', Monaco, monospace",
        style: { fontFamily: "'Lucida Console', Monaco, monospace" }
      },
      {
        text: "Tahoma",
        value: "Tahoma, Geneva, sans-serif",
        style: { fontFamily: "Tahoma, Geneva, sans-serif" }
      },
      {
        text: "Times New Roman",
        value: "'Times New Roman', Times,serif",
        style: { fontFamily: "'Times New Roman', Times,serif" }
      },
      {
        text: "Trebuchet MS",
        value: "'Trebuchet MS', Helvetica, sans-serif",
        style: { fontFamily: "'Trebuchet MS', Helvetica, sans-serif" }
      },
      {
        text: "Verdana",
        value: "Verdana, Geneva, sans-serif",
        style: { fontFamily: "Verdana, Geneva, sans-serif" }
      }
    ],
    commandName: "FontName"
  }, r.formatBlock = {
    defaultItem: { text: Y[P.format], value: "", localizationKey: P.format },
    items: [
      { text: "Paragraph", value: "p", style: { display: "block", marginLeft: 0 } },
      { text: "Heading 1", value: "h1", style: { display: "block", fontSize: "2em", marginLeft: 0, fontWeight: "bold" } },
      { text: "Heading 2", value: "h2", style: { display: "block", fontSize: "1.5em", marginLeft: 0, fontWeight: "bold" } },
      { text: "Heading 3", value: "h3", style: { display: "block", fontSize: "1.17em", marginLeft: 0, fontWeight: "bold" } },
      { text: "Heading 4", value: "h4", style: { display: "block", fontSize: "1em", marginLeft: 0, fontWeight: "bold" } },
      { text: "Heading 5", value: "h5", style: { display: "block", fontSize: "0.83em", marginLeft: 0, fontWeight: "bold" } },
      { text: "Heading 6", value: "h6", style: { display: "block", fontSize: "0.67em", marginLeft: 0, fontWeight: "bold" } }
    ],
    commandName: "FormatBlock"
  }, r.foreColor = {
    style: "color",
    colorPickerProps: {
      icon: "foreground-color",
      svgIcon: Wm,
      view: "palette",
      title: P.foregroundColor,
      ariaLabel: P.foreColorLabel
    },
    commandName: "ForeColor"
  }, r.backColor = {
    style: "background-color",
    colorPickerProps: {
      icon: "droplet",
      svgIcon: Vm,
      view: "palette",
      title: P.backgroundColor,
      ariaLabel: P.backColorLabel
    },
    commandName: "BackColor"
  }, r.alignLeft = {
    actions: Er([], G0, !0),
    props: G({ icon: "align-left", svgIcon: Um }, e),
    messages: {
      title: P.alignLeft
    },
    commandName: "AlignLeft"
  }, r.alignRight = {
    actions: Er([], J0, !0),
    props: G({ icon: "align-right", svgIcon: qm }, e),
    messages: {
      title: P.alignRight
    },
    commandName: "AlignRight"
  }, r.alignCenter = {
    actions: Er([], X0, !0),
    props: G({ icon: "align-center", svgIcon: Km }, e),
    messages: {
      title: P.alignCenter
    },
    commandName: "AlignCenter"
  }, r.alignJustify = {
    actions: Er([], Y0, !0),
    props: G({ icon: "align-justify", svgIcon: Gm }, e),
    messages: {
      title: P.alignJustify
    },
    commandName: "AlignJustify"
  }, r.alignRemove = {
    actions: Er([], Z0, !0),
    props: G({ icon: "align-remove", svgIcon: Jm }, e),
    messages: {},
    commandName: "AlignRemove"
  }, r.indent = {
    actions: Xf.nodes,
    listsTypes: Dn,
    props: G({ icon: "indent", svgIcon: Xm }, e),
    messages: {
      title: P.indent
    },
    commandName: "Indent"
  }, r.outdent = {
    actions: y0.nodes,
    listsTypes: Dn,
    props: G({ icon: "outdent", svgIcon: Ym }, e),
    messages: {
      title: P.outdent
    },
    commandName: "Outdent"
  }, r.orderedList = {
    listType: Dn.orderedList,
    props: G({ icon: "list-ordered", svgIcon: ga }, e),
    messages: {
      title: P.orderedList
    },
    commandName: "OrderedList",
    types: G({}, Dn)
  }, r.bulletList = {
    listType: Dn.bulletList,
    props: G({ icon: "list-unordered", svgIcon: va }, e),
    messages: {
      title: P.bulletList
    },
    commandName: "UnorderedList",
    types: G({}, Dn)
  };
})(X || (X = {}));
var xx = globalThis && globalThis.__extends || function() {
  var r = function(e, t) {
    return r = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i)
        Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, r(e, t);
  };
  return function(e, t) {
    if (typeof t != "function" && t !== null)
      throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
    r(e, t);
    function n() {
      this.constructor = e;
    }
    e.prototype = t === null ? Object.create(t) : (n.prototype = t.prototype, new n());
  };
}(), Ox = globalThis && globalThis.__spreadArray || function(r, e, t) {
  if (t || arguments.length === 2)
    for (var n = 0, i = e.length, o; n < i; n++)
      (o || !(n in e)) && (o || (o = Array.prototype.slice.call(e, 0, n)), o[n] = e[n]);
  return r.concat(o || Array.prototype.slice.call(e));
}, jp = (
  /** @class */
  function(r) {
    xx(e, r);
    function e() {
      var t = r !== null && r.apply(this, arguments) || this;
      return t.href = null, t.title = null, t.target = null, t.onClose = function() {
        t.props.view.focus(), t.props.onClose();
      }, t.onInsert = function() {
        var n = t.props.view, i = t.props.settings.mark, o = {
          href: t.href ? t.href.value : void 0,
          title: t.title ? t.title.value : void 0,
          target: t.target && t.target.element && t.target.element.checked ? "_blank" : void 0
        };
        jf({ mark: i, attrs: o }, t.props.settings.commandName)(n.state, n.dispatch), t.onClose();
      }, t;
    }
    return e.prototype.render = function() {
      var t = this, n = this.props, i = n.view, o = n.settings, a = n.dir, s = n.render, l = Re(this), c = o.messages, u = c.insertHyperlinkDialogTitle, f = c.insertHyperlinkAddress, h = c.insertHyperlinkTitle, d = c.insertHyperlinkNewWindow, p = c.insertHyperlinkCancel, m = c.insertHyperlinkInsert, v = i ? mo(i.state, i.state.schema.marks[o.mark]) : !1, y = g.createElement(Ni, { render: function() {
        return g.createElement(
          Ri,
          { horizontal: !0 },
          g.createElement(
            Ft,
            null,
            g.createElement("label", { htmlFor: "k-editor-link-url", className: "k-form-label" }, l.toLanguageString(f, Y[f])),
            g.createElement(
              "div",
              { className: "k-form-field-wrap" },
              g.createElement(Xt, { type: "text", id: "k-editor-link-url", ref: function(M) {
                return t.href = M;
              }, defaultValue: v && v.attrs.href || void 0, autoFocus: !0 })
            )
          ),
          g.createElement(
            Ft,
            null,
            g.createElement("label", { htmlFor: "k-editor-link-text", className: "k-form-label" }, l.toLanguageString(h, Y[h])),
            g.createElement(
              "div",
              { className: "k-form-field-wrap" },
              g.createElement(Xt, { type: "text", id: "k-editor-link-text", ref: function(M) {
                return t.title = M;
              }, defaultValue: v && v.attrs.title || void 0 })
            )
          ),
          o.linkTarget !== !1 && g.createElement(
            Ft,
            null,
            g.createElement(
              "label",
              { htmlFor: "k-editor-link-target", className: "k-checkbox-label" },
              g.createElement(Ar, { id: "k-editor-link-target", ref: function(M) {
                return t.target = M;
              }, defaultChecked: v && !!v.attrs.target || void 0 }),
              l.toLanguageString(d, Y[d])
            )
          )
        );
      } }), b = [
        g.createElement(he, { onClick: this.onClose, dir: a, key: "cancel" }, l.toLanguageString(p, Y[p])),
        g.createElement(he, { onClick: this.onInsert, themeColor: "primary", dir: a, key: "insert" }, l.toLanguageString(m, Y[m]))
      ], k = g.createElement(
        ai,
        { initialWidth: 450, initialHeight: 250, className: "k-editor-window", title: l.toLanguageString(u, Y[u]), onClose: this.onClose, style: a === "rtl" ? { textAlign: "right" } : void 0, modal: !0, minimizeButton: function() {
          return null;
        }, maximizeButton: function() {
          return null;
        }, resizable: !1 },
        y,
        g.createElement.apply(g, Ox([gr, null], b, !1))
      );
      return s ? s(k, { content: y, actionButtons: b }) : k;
    }, e;
  }(g.Component)
);
Pe(jp);
var Tx = globalThis && globalThis.__extends || function() {
  var r = function(e, t) {
    return r = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i)
        Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, r(e, t);
  };
  return function(e, t) {
    if (typeof t != "function" && t !== null)
      throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
    r(e, t);
    function n() {
      this.constructor = e;
    }
    e.prototype = t === null ? Object.create(t) : (n.prototype = t.prototype, new n());
  };
}(), Mx = globalThis && globalThis.__spreadArray || function(r, e, t) {
  if (t || arguments.length === 2)
    for (var n = 0, i = e.length, o; n < i; n++)
      (o || !(n in e)) && (o || (o = Array.prototype.slice.call(e, 0, n)), o[n] = e[n]);
  return r.concat(o || Array.prototype.slice.call(e));
}, Wp = (
  /** @class */
  function(r) {
    Tx(e, r);
    function e() {
      var t = r !== null && r.apply(this, arguments) || this;
      return t.src = null, t.altText = null, t.title = null, t.width = null, t.height = null, t.onClose = function() {
        t.props.view.focus(), t.props.onClose();
      }, t.onInsert = function() {
        var n = t.props, i = n.view, o = n.settings, a = i.state.schema.nodes, s = a[o.node], l = {
          src: t.src ? t.src.value : null,
          title: t.title ? t.title.value : null,
          alt: t.altText ? t.altText.value : null,
          width: t.width ? t.width.value : null,
          height: t.height ? t.height.value : null
        }, c = Object.keys(l).filter(function(h) {
          return l[h] !== null && l[h] !== "";
        }).reduce(function(h, d) {
          var p;
          return Object.assign(h, (p = {}, p[d] = l[d], p));
        }, {}), u = s.createAndFill(c);
        if (u) {
          var f = qs(u, !0);
          f(i.state, function(h) {
            return i.dispatch(h.setMeta("commandName", o.commandName).setMeta("args", c));
          });
        }
        t.onClose();
      }, t;
    }
    return e.prototype.render = function() {
      var t = this, n = this.props, i = n.view, o = n.settings, a = n.dir, s = n.render, l = o.messages, c = l.insertImageDialogTitle, u = l.insertImageAddress, f = l.insertImageTitle, h = l.insertImageAltText, d = l.insertImageWidth, p = l.insertImageHeight, m = l.insertImageCancel, v = l.insertImageInsert, y = Re(this), b = i && i.state, k = {};
      b && b.selection instanceof te && b.selection.node.type === b.schema.nodes[o.node] && (k = b.selection.node.attrs);
      var M = g.createElement(Ni, { render: function() {
        return g.createElement(
          Ri,
          { horizontal: !0 },
          g.createElement(
            Ft,
            null,
            g.createElement("label", { htmlFor: "k-editor-image-url", className: "k-form-label" }, y.toLanguageString(u, Y[u])),
            g.createElement(
              "div",
              { className: "k-form-field-wrap" },
              g.createElement(Xt, { type: "text", id: "k-editor-image-url", defaultValue: k.src, ref: function(z) {
                return t.src = z;
              }, autoFocus: !0 })
            )
          ),
          g.createElement(
            Ft,
            null,
            g.createElement("label", { htmlFor: "k-editor-image-url", className: "k-form-label" }, y.toLanguageString(h, Y[h])),
            g.createElement(
              "div",
              { className: "k-form-field-wrap" },
              g.createElement(Xt, { type: "text", id: "k-editor-image-alt", defaultValue: k.alt, ref: function(z) {
                return t.altText = z;
              } })
            )
          ),
          g.createElement(
            Ft,
            null,
            g.createElement("label", { htmlFor: "k-editor-image-title", className: "k-form-label" }, y.toLanguageString(f, Y[f])),
            g.createElement(
              "div",
              { className: "k-form-field-wrap" },
              g.createElement(Xt, { type: "text", id: "k-editor-image-title", defaultValue: k.title, ref: function(z) {
                return t.title = z;
              } })
            )
          ),
          g.createElement(
            Ft,
            null,
            g.createElement("label", { htmlFor: "k-editor-image-width", className: "k-form-label" }, y.toLanguageString(d, Y[d])),
            g.createElement(
              "div",
              { className: "k-form-field-wrap" },
              g.createElement(Xt, { type: "text", id: "k-editor-image-width", defaultValue: k.width, ref: function(z) {
                return t.width = z;
              } })
            )
          ),
          g.createElement(
            Ft,
            null,
            g.createElement("label", { htmlFor: "k-editor-image-height", className: "k-form-label" }, y.toLanguageString(p, Y[p])),
            g.createElement(
              "div",
              { className: "k-form-field-wrap" },
              g.createElement(Xt, { id: "k-editor-image-height", defaultValue: k.height, ref: function(z) {
                return t.height = z;
              } })
            )
          )
        );
      } }), D = [g.createElement(he, { onClick: this.onClose, dir: a, key: "cancel" }, y.toLanguageString(m, Y[m])), g.createElement(he, { onClick: this.onInsert, themeColor: "primary", dir: a, key: "insert" }, y.toLanguageString(v, Y[v]))], T = g.createElement(
        ai,
        { initialWidth: 500, initialHeight: 350, className: "k-editor-window", title: y.toLanguageString(c, Y[c]), onClose: this.onClose, key: "dialog", style: a === "rtl" ? { textAlign: "right" } : void 0, modal: !0, minimizeButton: function() {
          return null;
        }, maximizeButton: function() {
          return null;
        }, resizable: !1 },
        M,
        g.createElement.apply(g, Mx([gr, null], D, !1))
      );
      return s ? s(T, { content: M, actionButtons: D }) : T;
    }, e;
  }(g.Component)
);
Pe(Wp);
var eo = new Xe("editor-props"), _x = globalThis && globalThis.__extends || function() {
  var r = function(e, t) {
    return r = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i)
        Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, r(e, t);
  };
  return function(e, t) {
    if (typeof t != "function" && t !== null)
      throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
    r(e, t);
    function n() {
      this.constructor = e;
    }
    e.prototype = t === null ? Object.create(t) : (n.prototype = t.prototype, new n());
  };
}(), Ix = globalThis && globalThis.__spreadArray || function(r, e, t) {
  if (t || arguments.length === 2)
    for (var n = 0, i = e.length, o; n < i; n++)
      (o || !(n in e)) && (o || (o = Array.prototype.slice.call(e, 0, n)), o[n] = e[n]);
  return r.concat(o || Array.prototype.slice.call(e));
}, Vp = (
  /** @class */
  function(r) {
    _x(e, r);
    function e() {
      var t = r !== null && r.apply(this, arguments) || this;
      return t.htmlArea = null, t.textAreaRef = function(n) {
        t.htmlArea = n;
        var i = n && n.element.current;
        i && (i.style.resize = "none");
      }, t.onUpdate = function() {
        var n = t.props, i = n.view, o = n.settings, a = ja(t.htmlArea && t.htmlArea.value || ""), s = eo.getState(i.state).preserveWhitespace;
        Rf(a, o.commandName, { preserveWhitespace: s })(i.state, i.dispatch), t.onClose();
      }, t.onClose = function() {
        t.props.view.focus(), t.props.onClose();
      }, t;
    }
    return e.prototype.render = function() {
      var t = this.props, n = t.view, i = t.settings, o = t.dir, a = t.render, s = Re(this), l = i.messages, c = l.viewHtmlDialogTitle, u = l.viewHtmlCancel, f = l.viewHtmlUpdate, h = g.createElement(vg, { className: "k-editor-textarea", defaultValue: Pf(Nf(n.state)), autoFocus: !0, autoSize: !1, ref: this.textAreaRef }), d = [
        g.createElement(he, { onClick: this.onClose, dir: o, key: "cancel" }, s.toLanguageString(u, Y[u])),
        g.createElement(he, { onClick: this.onUpdate, themeColor: "primary", dir: o, key: "update" }, s.toLanguageString(f, Y[f]))
      ], p = g.createElement(
        ai,
        { className: "k-editor-window", title: s.toLanguageString(c, Y[c]), onClose: this.onClose, key: "dialog", style: o === "rtl" ? { textAlign: "right" } : void 0, modal: !0, minimizeButton: function() {
          return null;
        }, maximizeButton: function() {
          return null;
        }, resizable: !0, initialHeight: 400, initialWidth: 500 },
        h,
        g.createElement.apply(g, Ix([gr, null], d, !1))
      );
      return a ? a(p, { content: h, actionButtons: d }) : p;
    }, e;
  }(g.Component)
);
Pe(Vp);
var Ve = {
  onMouseDown: function(r) {
    return r.preventDefault();
  },
  onPointerDown: function(r) {
    return r.preventDefault();
  }
}, Up = {
  userSelect: "none"
}, qp = function(r) {
  for (var e = [], t = 1; t < arguments.length; t++)
    e[t - 1] = arguments[t];
  return e.forEach(function(n, i) {
    r = r.replace("{" + i + "}", String(n));
  }), r;
}, Kp = function(r, e) {
  return e.dataItem.style ? g.cloneElement(r, r.props, g.createElement("span", { style: e.dataItem.style }, r.props.children)) : r;
}, Dx = globalThis && globalThis.__extends || function() {
  var r = function(e, t) {
    return r = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i)
        Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, r(e, t);
  };
  return function(e, t) {
    if (typeof t != "function" && t !== null)
      throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
    r(e, t);
    function n() {
      this.constructor = e;
    }
    e.prototype = t === null ? Object.create(t) : (n.prototype = t.prototype, new n());
  };
}(), Pn = globalThis && globalThis.__assign || function() {
  return Pn = Object.assign || function(r) {
    for (var e, t = 1, n = arguments.length; t < n; t++) {
      e = arguments[t];
      for (var i in e)
        Object.prototype.hasOwnProperty.call(e, i) && (r[i] = e[i]);
    }
    return r;
  }, Pn.apply(this, arguments);
}, Ex = 13, Ax = 27, Nx = X.findAndReplace, ml = (
  /** @class */
  function(r) {
    Dx(e, r);
    function e(t) {
      var n = r.call(this, t) || this;
      return n.onTabSelect = function(i) {
        n.setState({ selectedTab: i.selected });
      }, n.onClose = function() {
        var i = n.props.view, o = i.state, a = o.tr.setSelection(oe.create(o.doc, o.selection.from, o.selection.to));
        i.updateState(o.apply(a)), i.focus(), n.props.onClose.call(void 0);
      }, n.matchesMessage = function(i) {
        var o = n.state.matches, a = n.state.nextMatch, s = 0, l = 0;
        if (o && a) {
          var c = o.findIndex(function(u) {
            return u.eq(a);
          });
          s = c === -1 ? o.length : c + 1, l = o.length;
        }
        return qp(i, s, l);
      }, n.onFindNext = function() {
        n.onFind();
      }, n.onFindPrev = function() {
        n.onFind(!0);
      }, n.onFind = function(i) {
        i === void 0 && (i = !1);
        var o = n.props.view, a = n.state, s = a.searchText, l = a.matchCase, c = a.matchCyclic, u = a.matchWord, f = a.useRegExp, h = { text: s, matchWord: u, matchCase: l, useRegExp: f, backward: i, matchCyclic: c }, d = fk(o.state, h);
        if (d) {
          var p = o.state.tr.setSelection(d);
          p.scrollIntoView(), o.updateState(o.state.apply(p)), n.setState({ nextMatch: d });
        }
      }, n.onReplace = function() {
        var i = n.props.view, o = i.state.selection, a = n.state.replaceText;
        if (!o.empty) {
          var s = o.from, l = s + a.length, c = hk(o, a, i.state.tr);
          c.setSelection(oe.create(c.doc, s, l)), c.scrollIntoView(), i.dispatch(c), n.setNextState({});
        }
      }, n.onReplaceAll = function() {
        var i = n.props.view, o = n.state, a = o.searchText, s = o.replaceText, l = o.matchCase, c = o.matchWord, u = o.useRegExp, f = { text: a, matchWord: c, matchCase: l, useRegExp: u }, h = dk(i.state, s, f);
        h && i.dispatch(h), n.setNextState({});
      }, n.onKeyDown = function(i) {
        i.keyCode === Ex ? n.onFindNext() : i.keyCode === Ax && n.onClose();
      }, n.onMatchCaseChecked = function(i) {
        return n.setNextState({ matchCase: i.value });
      }, n.onMatchWordChecked = function(i) {
        return n.setNextState({ matchWord: i.value });
      }, n.onMatchCyclicChecked = function(i) {
        return n.setNextState({ matchCyclic: i.value });
      }, n.onUseRegExpChecked = function(i) {
        return n.setNextState({ useRegExp: i.value });
      }, n.onSearchChange = function(i) {
        return n.setNextState({ searchText: i.target.value });
      }, n.onReplaceChange = function(i) {
        return n.setNextState({ replaceText: i.target.value });
      }, n.setNextState = function(i) {
        var o = Pn(Pn(Pn({}, n.state), i), { matches: void 0, nextMatch: void 0 }), a = n.props.view;
        if (o.searchText) {
          var s = o.searchText, l = o.matchWord, c = o.matchCase, u = o.useRegExp, f = o.matchCyclic, h = { text: s, matchWord: l, matchCase: c, useRegExp: u }, d = a.state.selection, p = Qh(a.state.doc, h), m = !n.state.searchText && p[0] || p.find(function(v) {
            return v.from >= d.from;
          }) || f && p[0] || void 0;
          n.setState(Pn(Pn({}, o), { matches: p, nextMatch: m }));
        } else
          n.setState(o);
      }, n.state = {
        selectedTab: 0,
        searchText: r0(t.view.state),
        replaceText: "",
        matchCase: !1,
        matchWord: !1,
        matchCyclic: !1,
        useRegExp: !1
      }, n;
    }
    return Object.defineProperty(e.prototype, "settings", {
      get: function() {
        return this.props.settings || Nx;
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.componentDidUpdate = function(t, n) {
      var i = this.props.view, o = this.state, a = o.matches, s = a === void 0 ? [] : a, l = o.nextMatch;
      if (n.nextMatch !== l) {
        var c = i.state, u = c.tr, f = [];
        s.forEach(function(h) {
          f.push({
            from: h.from,
            to: h.to,
            attrs: {
              class: l && h.eq(l) ? "k-text-selected" : "k-text-highlighted"
            }
          });
        }), u.setMeta(ed, f), u.setSelection(l || oe.create(c.doc, c.selection.from)), i.dispatch(u);
      }
    }, e.prototype.render = function() {
      var t = this, n = Re(this), i = this.settings.messages, o = i.findReplaceDialogTitle, a = i.findReplaceTabFind, s = i.findReplaceTabReplace, l = i.findReplaceFindWhat, c = i.findReplaceReplaceWith, u = i.findReplaceReplace, f = i.findReplaceReplaceAll, h = i.findReplaceMatchCase, d = i.findReplaceMatchWord, p = i.findReplaceMatchCyclic, m = i.findReplaceUseRegExp, v = i.findReplacePrevMatch, y = i.findReplaceNextMatch, b = i.findReplaceMatches, k = this.state, M = k.matchCase, D = k.matchWord, T = k.matchCyclic, z = k.useRegExp, _ = k.searchText, ee = k.replaceText, K = k.nextMatch, O = g.createElement(
        "div",
        { className: "k-search-options" },
        g.createElement(
          "span",
          null,
          g.createElement(Ar, { id: "match-case", checked: M, onChange: this.onMatchCaseChecked }),
          g.createElement("label", { htmlFor: "match-case", className: "k-checkbox-label" }, n.toLanguageString(h, Y[h]))
        ),
        g.createElement(
          "span",
          null,
          g.createElement(Ar, { id: "match-whole", checked: D, onChange: this.onMatchWordChecked }),
          g.createElement("label", { htmlFor: "match-whole", className: "k-checkbox-label" }, n.toLanguageString(d, Y[d]))
        ),
        g.createElement(
          "span",
          null,
          g.createElement(Ar, { id: "match-cyclic", checked: T, onChange: this.onMatchCyclicChecked }),
          g.createElement("label", { htmlFor: "match-cyclic", className: "k-checkbox-label" }, n.toLanguageString(p, Y[p]))
        ),
        g.createElement(
          "span",
          null,
          g.createElement(Ar, { id: "regular-expression", checked: z, onChange: this.onUseRegExpChecked }),
          g.createElement("label", { htmlFor: "regular-expression", className: "k-checkbox-label" }, n.toLanguageString(m, Y[m]))
        )
      ), ne = g.createElement(
        "div",
        { className: "k-matches-container" },
        g.createElement(
          he,
          { fillMode: "flat", themeColor: "primary", onClick: this.onFindPrev },
          g.createElement(Pa, { name: "chevron-left", icon: Zm }),
          n.toLanguageString(v, Y[v])
        ),
        g.createElement("span", null, this.matchesMessage(n.toLanguageString(b, Y[b]))),
        g.createElement(
          he,
          { fillMode: "flat", themeColor: "primary", onClick: this.onFindNext },
          n.toLanguageString(y, Y[y]),
          g.createElement(Pa, { name: "chevron-right", icon: Qm })
        )
      ), B = g.createElement(Ni, { render: function() {
        return g.createElement(
          Ri,
          { horizontal: !0 },
          g.createElement(
            Ft,
            null,
            g.createElement("label", { htmlFor: "findWhat", className: "k-form-label" }, n.toLanguageString(l, Y[l])),
            g.createElement(
              "div",
              { className: "k-form-field-wrap" },
              g.createElement(Xt, { id: "findWhat", type: "text", value: _, onChange: t.onSearchChange, onFocus: t.onSearchChange, onKeyDown: t.onKeyDown, autoFocus: !0 })
            )
          )
        );
      } }), R = g.createElement(Ni, { render: function() {
        return g.createElement(
          Ri,
          { horizontal: !0 },
          g.createElement(
            Ft,
            null,
            g.createElement("label", { htmlFor: "replaceWith", className: "k-form-label" }, n.toLanguageString(c, Y[c])),
            g.createElement(
              "div",
              { className: "k-form-field-wrap" },
              g.createElement(Xt, { id: "replaceWith", type: "text", value: ee, onChange: t.onReplaceChange })
            )
          )
        );
      } });
      return g.createElement(
        ai,
        { title: n.toLanguageString(o, Y[o]), onClose: this.onClose, style: { width: "auto", height: "auto", userSelect: "none" }, resizable: !1, minimizeButton: function() {
          return null;
        }, maximizeButton: function() {
          return null;
        } },
        g.createElement(
          wg,
          { selected: this.state.selectedTab, className: "k-editor-find-replace", onSelect: this.onTabSelect, animation: !1 },
          g.createElement(
            Ml,
            { title: n.toLanguageString(a, Y[a]) },
            B,
            O,
            ne
          ),
          g.createElement(
            Ml,
            { title: n.toLanguageString(s, Y[s]) },
            B,
            R,
            g.createElement(
              "div",
              { className: "k-actions k-hstack k-justify-content-end" },
              g.createElement(he, { disabled: !K, onClick: this.onReplace }, n.toLanguageString(u, Y[u])),
              g.createElement(he, { disabled: !K, onClick: this.onReplaceAll }, n.toLanguageString(f, Y[f]))
            ),
            O,
            ne
          )
        )
      );
    }, e;
  }(g.Component)
);
Pe(ml);
var Ti = globalThis && globalThis.__extends || function() {
  var r = function(e, t) {
    return r = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i)
        Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, r(e, t);
  };
  return function(e, t) {
    if (typeof t != "function" && t !== null)
      throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
    r(e, t);
    function n() {
      this.constructor = e;
    }
    e.prototype = t === null ? Object.create(t) : (n.prototype = t.prototype, new n());
  };
}(), xr;
(function(r) {
  var e = (
    /** @class */
    function(o) {
      Ti(a, o);
      function a() {
        return o !== null && o.apply(this, arguments) || this;
      }
      return a;
    }(jp)
  );
  r.InsertLinkDialog = e;
  var t = (
    /** @class */
    function(o) {
      Ti(a, o);
      function a() {
        return o !== null && o.apply(this, arguments) || this;
      }
      return a;
    }(Wp)
  );
  r.InsertImageDialog = t;
  var n = (
    /** @class */
    function(o) {
      Ti(a, o);
      function a() {
        return o !== null && o.apply(this, arguments) || this;
      }
      return a;
    }(Vp)
  );
  r.ViewHtmlDialog = n;
  var i = (
    /** @class */
    function(o) {
      Ti(a, o);
      function a() {
        return o !== null && o.apply(this, arguments) || this;
      }
      return a;
    }(ml)
  );
  r.FindAndReplaceDialog = i;
})(xr || (xr = {}));
var cn = globalThis && globalThis.__assign || function() {
  return cn = Object.assign || function(r) {
    for (var e, t = 1, n = arguments.length; t < n; t++) {
      e = arguments[t];
      for (var i in e)
        Object.prototype.hasOwnProperty.call(e, i) && (r[i] = e[i]);
    }
    return r;
  }, cn.apply(this, arguments);
}, Rx = X.bold, Px = X.underline, Lx = X.italic, hu = typeof navigator < "u" ? /Mac/.test(navigator.platform) : !1, Fx = function(r) {
  var e = go(eh, function(o, a) {
    var s = r && r.types && r.types.hardBreak || "hard_break", l = o.schema.nodes[s];
    return a && a(o.tr.replaceSelectionWith(l.create()).scrollIntoView()), !0;
  }), t = r && r.types && r.types.listItem || "list_item", n = r && r.toolsSettings || {}, i = cn(cn(cn(cn({ "Mod-b": function(o, a) {
    return Hn(n.bold || Rx)(o, a);
  }, "Mod-i": function(o, a) {
    return Hn(n.italic || Lx)(o, a);
  }, "Mod-u": function(o, a) {
    return Hn(n.underline || Px)(o, a);
  }, "Mod-z": fl, "Shift-Mod-z": Yi }, cn({}, hu ? {} : { "Mod-y": Yi })), { Backspace: LC, "Mod-Enter": e, "Shift-Enter": e }), cn({}, hu ? { "Ctrl-Enter": e } : {})), { Enter: function(o, a) {
    return m0(o.schema.nodes[t])(o, a);
  }, Tab: tu(1), "Shift-Tab": tu(-1) });
  return i;
}, to = globalThis && globalThis.__assign || function() {
  return to = Object.assign || function(r) {
    for (var e, t = 1, n = arguments.length; t < n; t++) {
      e = arguments[t];
      for (var i in e)
        Object.prototype.hasOwnProperty.call(e, i) && (r[i] = e[i]);
    }
    return r;
  }, to.apply(this, arguments);
}, mr;
(function(r) {
  function e(C, N, q) {
    return !!qf(N, q)(C.state, C.dispatch);
  }
  r.alignBlocks = e;
  function t(C, N, q) {
    return Js(N, q)(C.state, C.dispatch);
  }
  r.applyInlineStyle = t;
  function n(C, N, q) {
    return jf(N, q)(C.state, C.dispatch);
  }
  r.applyLink = n;
  function i(C, N) {
    return oh(C, N);
  }
  r.canIndentList = i;
  function o(C, N) {
    return Us(C, N);
  }
  r.canInsert = o;
  function a(C, N) {
    return ah(C, { listsTypes: N, nodes: [] });
  }
  r.canOutdentList = a;
  function s(C) {
    return Xh(C);
  }
  r.convertMsLists = s;
  function l(C, N, q) {
    return Af(ja(N), C, q !== void 0 ? q : { preserveWhitespace: "full" });
  }
  r.createDocument = l;
  function c(C, N, q) {
    return fd(C, N, q);
  }
  r.createTable = c;
  function u(C, N, q) {
    return Wf(N, q)(C.state, C.dispatch);
  }
  r.formatBlockElements = u;
  function f(C) {
    return Vf(C);
  }
  r.getBlockFormats = f;
  function h(C) {
    return Nf(C);
  }
  r.getHtml = h;
  function d(C, N) {
    return Bf(C, N);
  }
  r.getInlineStyles = d;
  function p(C, N) {
    return mo(C, N);
  }
  r.getMark = p;
  function m(C, N) {
    return ci(C, N);
  }
  r.hasMark = m;
  function v(C, N) {
    return Zr(C, N);
  }
  r.hasNode = v;
  function y(C, N, q, de) {
    return !!Ys(N, q, de)(C.state, C.dispatch);
  }
  r.indentBlocks = y;
  function b(C) {
    return Pf(C);
  }
  r.indentHtml = b;
  function k(C, N, q) {
    qs(N, q)(C.state, C.dispatch);
  }
  r.insertNode = k;
  function M(C, N) {
    return Kf(C, N);
  }
  r.isAligned = M;
  function D(C, N, q) {
    return Zs(C, N, q);
  }
  r.isIndented = D;
  function T(C) {
    return YC(C);
  }
  r.removeComments = T;
  function z(C, N) {
    return Yh(C, N);
  }
  r.removeTag = z;
  function _(C, N) {
    return ik(C, N);
  }
  r.pasteCleanup = _;
  function ee(C) {
    ZC(C);
  }
  r.sanitizeClassAttr = ee;
  function K(C) {
    tk(C);
  }
  r.sanitizeStyleAttr = K;
  function O(C) {
    hl(C);
  }
  r.removeAttribute = O;
  function ne(C) {
    return XC(C);
  }
  r.sanitize = ne;
  function B(C, N) {
    return uk(C, N);
  }
  r.replaceImageSourcesFromRtf = B;
  function R(C) {
    return wk(C);
  }
  r.textHighlight = R;
  function U(C) {
    return Ok(C);
  }
  r.imageResizing = U;
  function S() {
    return ix();
  }
  r.tableResizing = S;
  function W(C, N, q, de) {
    var ce = ja(N);
    Rf(ce, q, de)(C.state, C.dispatch);
  }
  r.setHtml = W;
  function j(C, N, q, de) {
    return Hn(N, q, de)(C.state, C.dispatch);
  }
  r.toggleInlineFormat = j;
  function H(C, N, q) {
    return Ui(C.state, C.dispatch, C, N, q);
  }
  r.toggleList = H;
  function Z(C) {
    return Fx(C);
  }
  r.getShortcuts = Z, r.propsKey = eo, r.imageResizeKey = mt, r.marks = to({}, Uh), r.nodes = to({}, qh);
})(mr || (mr = {}));
var Mi = function(r, e) {
  var t = e.tr || r.state.tr.setSelection(new We(r.state.doc)).replaceSelectionWith(e.doc || mr.createDocument(r.state.schema, e.html || "")).setMeta("commandName", "setHTML");
  r.updateState(r.state.apply(t));
}, zx = function(r, e, t, n, i) {
  typeof e == "string" ? n && e === i ? Mi(r, { tr: n }) : e !== t && Mi(r, { html: e }) : n && e.eq(n.doc) ? Mi(r, { tr: n }) : r.state.doc.eq(e) || Mi(r, { doc: e });
}, du = typeof window < "u" && /Firefox/.test(window.navigator.userAgent), ma = {
  name: "@progress/kendo-react-editor",
  productName: "KendoReact",
  productCodes: ["KENDOUIREACT", "KENDOUICOMPLETE"],
  publishDate: 1686225982,
  version: "",
  licensingDocsUrl: "https://www.telerik.com/kendo-react-ui/my-license/?utm_medium=product&utm_source=kendoreact&utm_campaign=kendo-ui-react-purchase-license-keys-warning"
}, Bx = globalThis && globalThis.__extends || function() {
  var r = function(e, t) {
    return r = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i)
        Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, r(e, t);
  };
  return function(e, t) {
    if (typeof t != "function" && t !== null)
      throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
    r(e, t);
    function n() {
      this.constructor = e;
    }
    e.prototype = t === null ? Object.create(t) : (n.prototype = t.prototype, new n());
  };
}(), no = globalThis && globalThis.__assign || function() {
  return no = Object.assign || function(r) {
    for (var e, t = 1, n = arguments.length; t < n; t++) {
      e = arguments[t];
      for (var i in e)
        Object.prototype.hasOwnProperty.call(e, i) && (r[i] = e[i]);
    }
    return r;
  }, no.apply(this, arguments);
}, pu = globalThis && globalThis.__spreadArray || function(r, e, t) {
  if (t || arguments.length === 2)
    for (var n = 0, i = e.length, o; n < i; n++)
      (o || !(n in e)) && (o || (o = Array.prototype.slice.call(e, 0, n)), o[n] = e[n]);
  return r.concat(o || Array.prototype.slice.call(e));
}, mu = X.link, $x = X.bold, Hx = X.italic, jx = X.underline, Gp = (
  /** @class */
  function(r) {
    Bx(e, r);
    function e(t) {
      var n = r.call(this, t) || this;
      if (n.state = {
        view: void 0,
        linkDialog: !1
      }, n._element = null, n._contentElement = null, n.iframe = null, n.trOnChange = null, n.htmlOnChange = null, n.focus = function() {
        n.view && n.view.focus();
      }, n.renderDialog = function(o, a, s) {
        return n.state[s] && g.createElement(o, { view: n.view, settings: a, dir: n.props.dir, onClose: function() {
          var l;
          return n.setState((l = {}, l[s] = !1, l));
        } });
      }, n.renderTool = function(o, a) {
        var s = g.createElement(o, { view: n.view, dir: n.props.dir, key: a });
        return s.type === qg ? g.createElement(o, { key: a }) : s;
      }, n.updateTools = function(o, a) {
        n.setState({ view: o });
      }, n.filterTransaction = function(o, a) {
        var s = { target: n, transaction: o, state: a };
        return (n.props.onExecute && n.props.onExecute.call(void 0, s)) !== !1;
      }, n.onPasteHtml = function(o) {
        if (n.props.onPasteHtml && n.pasteEvent) {
          var a = {
            target: n,
            pastedHtml: o,
            nativeEvent: n.pasteEvent
          }, s = n.props.onPasteHtml.call(void 0, a);
          if (n.pasteEvent = void 0, typeof s == "string")
            return s;
        }
        return o;
      }, n.dispatchTransaction = function(o) {
        var a = o.docChanged;
        if (n.props.onChange && a) {
          n.trOnChange = o;
          var s = o.doc, l = o.doc.type.schema, c = n, u = {
            target: c,
            value: s,
            get html() {
              return c.htmlOnChange = mr.getHtml({ doc: s, schema: l }), c.htmlOnChange;
            },
            transaction: o,
            schema: l
          };
          n.props.onChange.call(void 0, u);
        }
        n.view && (n.props.value === void 0 || !a) && n.view.updateState(n.view.state.apply(o));
      }, n.onFocus = function(o, a) {
        if (n.props.onFocus) {
          var s = {
            target: n,
            nativeEvent: a
          };
          n.props.onFocus.call(void 0, s);
        }
        return !1;
      }, n.onBlur = function(o, a) {
        if (n.props.onBlur) {
          var s = {
            target: n,
            nativeEvent: a
          };
          n.props.onBlur.call(void 0, s);
        }
        return !1;
      }, n.onPaste = function(o, a) {
        return n.props.onPasteHtml && (n.pasteEvent = a), !1;
      }, typeof bg < "u")
        Sg(ma);
      else {
        var i = "License activation failed for ".concat(ma.name, `
`);
        i += `The @progress/kendo-licensing script is not loaded.
`, i += "See ".concat(ma.licensingDocsUrl, ` for more information.
`), console.warn(i);
      }
      return n;
    }
    return Object.defineProperty(e.prototype, "value", {
      /**
       * The value of the Editor.
       */
      get: function() {
        return this.trOnChange !== null ? this.trOnChange.doc : this.props.value !== void 0 ? this.props.value : this.view ? this.view.state.doc : this.props.defaultContent || "";
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "element", {
      /**
       * Returns the DOM element of the Editor.
       */
      get: function() {
        return this._element;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "contentElement", {
      /**
       * Returns the content-editable DOM element of the Editor.
       */
      get: function() {
        return this._contentElement;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "view", {
      /**
       * Returns the `view` object of the Editor.
       */
      get: function() {
        return this._view;
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.componentDidMount = function() {
      (!this.iframe || !du) && this.initialize();
    }, e.prototype.componentDidUpdate = function(t) {
      var n = this.props.value, i = this.view;
      n === void 0 || !i || (zx(i, n, t.value, this.trOnChange, this.htmlOnChange), this.trOnChange = null, this.htmlOnChange = null);
    }, e.prototype.componentWillUnmount = function() {
      this.view && this.view.destroy(), this._view = void 0;
      var t = this.iframe && this.iframe.contentWindow;
      if (t) {
        this._contentElement && this._contentElement.parentNode && this._contentElement.parentNode.removeChild(this._contentElement);
        for (var n = t.document.head; n && n.firstChild; )
          n.removeChild(n.firstChild);
      }
    }, e.prototype.render = function() {
      var t = this, n = this.props, i = n.tools, o = i === void 0 ? [] : i, a = n.defaultEditMode, s = a === void 0 ? "iframe" : a, l = n.preserveWhitespace, c = l === void 0 ? "full" : l, u = n.style, f = n.className, h = Re(this);
      if (this.view) {
        var d = eo.getState(this.view.state);
        d.preserveWhitespace = c;
      }
      var p = this.props.contentStyle;
      p === void 0 && (u || {}).height === void 0 && (p = { height: "300px" });
      var m = o.map(function(v, y) {
        return Array.isArray(v) ? g.createElement(om, { key: y }, v.map(t.renderTool, y)) : t.renderTool(v, y);
      });
      return g.createElement(
        "div",
        { ref: function(v) {
          return t._element = v;
        }, className: ut("k-editor", f, { "k-editor-resizable": this.props.resizable }), dir: this.props.dir, style: u },
        m.length > 0 && g.createElement(sm, { className: "k-editor-toolbar", keyboardNavigation: this.props.keyboardNavigation }, m),
        s === "iframe" ? g.createElement(
          "div",
          { className: "k-editor-content" },
          g.createElement("iframe", { onLoad: du ? function() {
            t.initialize();
          } : void 0, ref: function(v) {
            return t.iframe = v;
          }, frameBorder: "0", title: h.toLanguageString(P.iframeTitle, Y[P.iframeTitle]), style: p, className: "k-iframe" })
        ) : g.createElement(
          "div",
          { style: p, className: "k-editor-content" },
          g.createElement("div", { ref: function(v) {
            return t._contentElement = v;
          }, suppressContentEditableWarning: !0, role: "textbox", "aria-labelledby": this.props.ariaLabelledBy, "aria-describedby": this.props.ariaDescribedBy, "aria-label": this.props.ariaLabel })
        ),
        this.renderDialog(xr.InsertLinkDialog, mu, "linkDialog")
      );
    }, e.prototype.initialize = function() {
      var t = this, n = this.iframe && this.iframe.contentWindow;
      if (n) {
        var i = n.document;
        [Sx, Cx, this.props.dir === "rtl" ? kx : void 0].forEach(function(D) {
          if (D) {
            var T = i.createElement("style");
            T.appendChild(i.createTextNode(D)), i.head.appendChild(T);
          }
        });
        var o = i.createElement("meta");
        o.setAttribute("charset", "utf-8"), i.head.appendChild(o), this._contentElement = i.createElement("div"), i.body.appendChild(this._contentElement), this._contentElement.classList.add("k-content");
      }
      var a = this._contentElement;
      if (a) {
        var s = this.props.preserveWhitespace, l = s === void 0 ? "full" : s, c = this, u = [
          // https://prosemirror.net/docs/ref/#state.PluginSpec
          new Ge({
            view: function() {
              return { update: t.updateTools };
            },
            key: new Xe("toolbar-tools-update-plugin")
          }),
          new Ge({
            filterTransaction: this.filterTransaction,
            key: new Xe("onExecute-event-plugin")
          }),
          new Ge({
            key: eo,
            state: {
              init: function() {
                return { preserveWhitespace: l };
              },
              apply: function(D, T) {
                return T;
              }
            }
          }),
          yk(),
          Mk(),
          PC(),
          ox(),
          cx(),
          vC()
        ], f = no(no({}, mr.getShortcuts({
          types: { listItem: "list_item", hardBreak: "hard_break" },
          toolsSettings: { bold: $x, italic: Hx, underline: jx }
        })), { "Mod-k": function() {
          var D = t.state.linkDialog, T = t.view;
          if (T) {
            var z = T.state, _ = z.selection.empty, ee = mo(z, z.schema.marks[mu.mark]), K = _ && !ee;
            !D && !K && t.setState({ linkDialog: !0 });
          }
          return !D;
        }, "Alt-F10": function() {
          var D, T = (D = t.element) === null || D === void 0 ? void 0 : D.querySelector(".k-toolbar");
          if (T) {
            var z = T.querySelector(am.join(","));
            if (z)
              return z.focus(), !0;
          }
          return !1;
        } }), h = this.props, d = h.defaultContent, p = d === void 0 ? "" : d, m = h.value, v = h.onMount, y = m && typeof m != "string" ? m : mr.createDocument(new uf({ nodes: qh, marks: Uh }), m || p, { preserveWhitespace: l }), b = {
          state: Ln.create({
            plugins: pu(pu([], u, !0), [Uc(f), Uc(L0)], !1),
            doc: y
          }),
          transformPastedHTML: this.onPasteHtml,
          dispatchTransaction: this.dispatchTransaction,
          handleDOMEvents: {
            focus: this.onFocus,
            blur: this.onBlur,
            paste: this.onPaste
          }
        }, k = { plugins: u, shortcuts: f, target: c, viewProps: b, dom: a }, M = this._view = v && v.call(void 0, k) || new CS({ mount: a }, b);
        this.setState({
          view: M
        });
      }
    }, e.propTypes = {
      defaultContent: E.string,
      value: E.oneOfType([E.object, E.string]),
      defaultEditMode: E.oneOf(["iframe", "div"]),
      contentStyle: E.object,
      dir: E.string,
      className: E.string,
      ariaDescribedBy: E.string,
      ariaLabelledBy: E.string,
      ariaLabel: E.string,
      style: E.object,
      tools: E.arrayOf(E.any),
      keyboardNavigation: E.bool,
      resizable: E.bool,
      preserveWhitespace: E.oneOf([!0, !1, "full"]),
      onMount: E.func,
      onFocus: E.func,
      onBlur: E.func,
      onChange: E.func,
      onPasteHtml: E.func,
      onExecute: E.func
    }, e;
  }(g.Component)
);
Pe(Gp);
var Wx = globalThis && globalThis.__extends || function() {
  var r = function(e, t) {
    return r = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i)
        Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, r(e, t);
  };
  return function(e, t) {
    if (typeof t != "function" && t !== null)
      throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
    r(e, t);
    function n() {
      this.constructor = e;
    }
    e.prototype = t === null ? Object.create(t) : (n.prototype = t.prototype, new n());
  };
}(), Vx = "k-ct-cell k-disabled", Ux = "k-selected", qx = (
  /** @class */
  function(r) {
    Wx(e, r);
    function e() {
      var t = r !== null && r.apply(this, arguments) || this;
      return t.state = { row: -1, col: -1 }, t;
    }
    return e.prototype.renderCell = function(t, n, i) {
      var o = this, a = Math.floor(t / this.props.columns), s = t % this.props.columns, l = s <= i && a <= n;
      return g.createElement("span", { className: Vx + (l ? " ".concat(Ux) : ""), onMouseEnter: function() {
        return o.setState({ row: a, col: s });
      }, onClick: function() {
        return o.props.onCellClick.call(void 0, a, s);
      }, key: t });
    }, e.prototype.render = function() {
      var t = this, n = [], i = this.props.columns * this.props.rows, o = this.state, a = o.row, s = o.col, l = this.props.onDown, c = this.props.createTableMessage;
      s > -1 && (c = qp(this.props.createTableHintMessage, a + 1, s + 1));
      for (var u = 0; u < i; u++)
        n.push(this.renderCell(u, a, s));
      return [g.createElement("div", { onMouseLeave: function() {
        return t.setState({ row: -1, col: -1 });
      }, key: "cells", style: { borderColor: "inherit" }, onPointerDown: l, onMouseDown: l }, n), g.createElement("div", { className: "k-status", key: "status", onPointerDown: l, onMouseDown: l }, c)];
    }, e;
  }(g.Component)
);
const Kx = qx;
var Gx = globalThis && globalThis.__extends || function() {
  var r = function(e, t) {
    return r = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i)
        Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, r(e, t);
  };
  return function(e, t) {
    if (typeof t != "function" && t !== null)
      throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
    r(e, t);
    function n() {
      this.constructor = e;
    }
    e.prototype = t === null ? Object.create(t) : (n.prototype = t.prototype, new n());
  };
}(), ro;
(function(r) {
  var e = (
    /** @class */
    function(t) {
      Gx(n, t);
      function n() {
        var i = t !== null && t.apply(this, arguments) || this;
        return i.pointerdown = !1, i.onWindowDown = function(o) {
          var a = i.props.anchor;
          a && (a === o.target || a.firstElementChild === o.target) || (i.props.show && !i.pointerdown && i.props.onClose(), i.pointerdown = !1);
        }, i.onPointerDown = function() {
          return i.pointerdown = !0;
        }, i;
      }
      return n.prototype.componentDidUpdate = function(i) {
        i.show && this.props.show && this.props.onClose();
      }, n.prototype.componentDidMount = function() {
        window.addEventListener("mousedown", this.onWindowDown), window.addEventListener("pointerdown", this.onWindowDown);
      }, n.prototype.componentWillUnmount = function() {
        window.removeEventListener("mousedown", this.onWindowDown), window.removeEventListener("pointerdown", this.onWindowDown);
      }, n.prototype.render = function() {
        var i = this.props, o = i.show, a = i.anchor, s = i.dir, l = i.rows, c = l === void 0 ? n.defaultProps.rows : l, u = i.columns, f = u === void 0 ? n.defaultProps.columns : u, h = s === "rtl" ? "right" : "left";
        return g.createElement(
          Cg,
          { anchor: a, anchorAlign: { horizontal: h, vertical: "bottom" }, popupAlign: { horizontal: h, vertical: "top" }, popupClass: "k-ct-popup k-group k-reset k-state-border-up", show: o, style: s === "rtl" ? { direction: "rtl" } : void 0 },
          g.createElement(Kx, { rows: c, columns: f, createTableMessage: this.props.createTableMessage, createTableHintMessage: this.props.createTableHintMessage, onCellClick: this.props.onTableInsert, onDown: this.onPointerDown })
        );
      }, n.propTypes = {
        show: E.bool.isRequired,
        createTableMessage: E.string.isRequired,
        createTableHintMessage: E.string.isRequired,
        onClose: E.func.isRequired,
        onTableInsert: E.func.isRequired,
        anchor: E.any,
        rows: E.number,
        columns: E.number,
        dir: E.string
      }, n.defaultProps = {
        rows: 6,
        columns: 8
      }, n;
    }(g.Component)
  );
  r.InsertTablePopup = e;
})(ro || (ro = {}));
var Jx = globalThis && globalThis.__extends || function() {
  var r = function(e, t) {
    return r = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i)
        Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, r(e, t);
  };
  return function(e, t) {
    if (typeof t != "function" && t !== null)
      throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
    r(e, t);
    function n() {
      this.constructor = e;
    }
    e.prototype = t === null ? Object.create(t) : (n.prototype = t.prototype, new n());
  };
}(), is = globalThis && globalThis.__assign || function() {
  return is = Object.assign || function(r) {
    for (var e, t = 1, n = arguments.length; t < n; t++) {
      e = arguments[t];
      for (var i in e)
        Object.prototype.hasOwnProperty.call(e, i) && (r[i] = e[i]);
    }
    return r;
  }, is.apply(this, arguments);
}, Xx = globalThis && globalThis.__rest || function(r, e) {
  var t = {};
  for (var n in r)
    Object.prototype.hasOwnProperty.call(r, n) && e.indexOf(n) < 0 && (t[n] = r[n]);
  if (r != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, n = Object.getOwnPropertySymbols(r); i < n.length; i++)
      e.indexOf(n[i]) < 0 && Object.prototype.propertyIsEnumerable.call(r, n[i]) && (t[n[i]] = r[n[i]]);
  return t;
}, as;
(function(r) {
  r.createInsertTableTool = function(e) {
    var t = (
      /** @class */
      function(n) {
        Jx(i, n);
        function i() {
          var o = n !== null && n.apply(this, arguments) || this;
          return o.state = {
            openedPopup: !1
          }, o.button = null, o.togglePopup = function() {
            o.setState({
              openedPopup: !o.state.openedPopup
            });
          }, o.closePopup = function() {
            o.state.openedPopup && o.togglePopup();
          }, o.onTableInsert = function(a, s) {
            var l = o.props.view;
            if (l) {
              var c = l.state.schema.nodes, u = c.table, f = c.table_row, h = c.table_cell, d = fd({ table: u, table_row: f, table_cell: h }, a, s);
              d && qs(d, !0)(l.state, l.dispatch), l.focus(), o.closePopup();
            }
          }, o;
        }
        return i.prototype.render = function() {
          var o = this, a = this.props, s = a.view, l = a.render, c = Xx(a, ["view", "render"]), u = s && s.state, f = Re(this), h = e.messages, d = h.createTable, p = h.createTableHint, m = f.toLanguageString(d, Y[d]), v = f.toLanguageString(p, Y[p]), y = !u || !Us(u, u.schema.nodes.table), b = [g.createElement(he, is({ onClick: y ? void 0 : this.togglePopup, "aria-disabled": y ? !0 : void 0, ref: function(k) {
            return o.button = k && k.element;
          }, key: "InsertTable" }, Ve, { title: m }, e.props, c, { className: ut(c.className, e.props.className, { "k-disabled": y }) })), s && !y && g.createElement(ro.InsertTablePopup, { key: "insertTablePopup", createTableMessage: m, createTableHintMessage: v, dir: c.dir, anchor: this.button, show: this.state.openedPopup, onClose: this.closePopup, onTableInsert: this.onTableInsert }) || null];
          return l ? l.call(void 0, b, { view: s }) : b;
        }, i;
      }(g.Component)
    );
    return Pe(t), t;
  };
})(as || (as = {}));
var Yx = globalThis && globalThis.__extends || function() {
  var r = function(e, t) {
    return r = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i)
        Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, r(e, t);
  };
  return function(e, t) {
    if (typeof t != "function" && t !== null)
      throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
    r(e, t);
    function n() {
      this.constructor = e;
    }
    e.prototype = t === null ? Object.create(t) : (n.prototype = t.prototype, new n());
  };
}(), ss = globalThis && globalThis.__assign || function() {
  return ss = Object.assign || function(r) {
    for (var e, t = 1, n = arguments.length; t < n; t++) {
      e = arguments[t];
      for (var i in e)
        Object.prototype.hasOwnProperty.call(e, i) && (r[i] = e[i]);
    }
    return r;
  }, ss.apply(this, arguments);
}, Zx = globalThis && globalThis.__rest || function(r, e) {
  var t = {};
  for (var n in r)
    Object.prototype.hasOwnProperty.call(r, n) && e.indexOf(n) < 0 && (t[n] = r[n]);
  if (r != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, n = Object.getOwnPropertySymbols(r); i < n.length; i++)
      e.indexOf(n[i]) < 0 && Object.prototype.propertyIsEnumerable.call(r, n[i]) && (t[n[i]] = r[n[i]]);
  return t;
}, gu = X.alignRemove, Qx = function(r) {
  var e = (
    /** @class */
    function(t) {
      Yx(n, t);
      function n() {
        return t !== null && t.apply(this, arguments) || this;
      }
      return n.prototype.render = function() {
        var i = this.props, o = i.view, a = i.render, s = Zx(i, ["view", "render"]), l = o && o.state, c = !!l && Kf(l, r.actions), u = c ? gu.actions : r.actions, f = c ? gu.commandName : r.commandName, h = Re(this), d = r.messages.title, p = g.createElement(he, ss({ onClick: function() {
          return o && qf(u, f)(o.state, o.dispatch);
        }, selected: c, togglable: !0 }, Ve, { title: h.toLanguageString(d, Y[d]) }, r.props, s));
        return a ? a.call(void 0, p, { view: o }) : p;
      }, n;
    }(g.Component)
  );
  return Pe(e), e;
}, e1 = globalThis && globalThis.__extends || function() {
  var r = function(e, t) {
    return r = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i)
        Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, r(e, t);
  };
  return function(e, t) {
    if (typeof t != "function" && t !== null)
      throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
    r(e, t);
    function n() {
      this.constructor = e;
    }
    e.prototype = t === null ? Object.create(t) : (n.prototype = t.prototype, new n());
  };
}(), io = globalThis && globalThis.__assign || function() {
  return io = Object.assign || function(r) {
    for (var e, t = 1, n = arguments.length; t < n; t++) {
      e = arguments[t];
      for (var i in e)
        Object.prototype.hasOwnProperty.call(e, i) && (r[i] = e[i]);
    }
    return r;
  }, io.apply(this, arguments);
}, t1 = globalThis && globalThis.__rest || function(r, e) {
  var t = {};
  for (var n in r)
    Object.prototype.hasOwnProperty.call(r, n) && e.indexOf(n) < 0 && (t[n] = r[n]);
  if (r != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, n = Object.getOwnPropertySymbols(r); i < n.length; i++)
      e.indexOf(n[i]) < 0 && Object.prototype.propertyIsEnumerable.call(r, n[i]) && (t[n[i]] = r[n[i]]);
  return t;
}, ls;
(function(r) {
  r.createStyleDropDownList = function(e) {
    var t = (
      /** @class */
      function(n) {
        e1(i, n);
        function i() {
          var o = n !== null && n.apply(this, arguments) || this;
          return o.onChange = function(a) {
            var s = a.target.value, l = o.props.view, c = e.style;
            if (l) {
              Js({ style: c, value: s.value }, e.commandName)(l.state, l.dispatch);
              var u = a.syntheticEvent;
              u && u.type === "click" && l.focus();
            }
          }, o;
        }
        return i.prototype.render = function() {
          var o = e.style, a = this.props, s = a.view, l = a.render, c = a.data, u = a.defaultItem, f = t1(a, ["view", "render", "data", "defaultItem"]), h = c || e.items, d = u || e.defaultItem, p = s ? Bf(s.state, { name: o, value: /^.+$/ }) : [], m = Re(this);
          d && d.localizationKey && (d = io({}, d), d.text = d.localizationKey ? m.toLanguageString(d.localizationKey, Y[d.localizationKey]) : d.text);
          var v = new Set(p).size === 1 ? p[0] : null, y = g.createElement(ku, io({ value: v && h.find(function(b) {
            return b.value === v;
          }), data: h, defaultItem: d, itemRender: Kp, textField: "text", dataItemKey: "value", onChange: this.onChange, style: Up, leftRightKeysNavigation: !1, title: d.text }, f));
          return l ? l.call(void 0, y, { view: s }) : y;
        }, i;
      }(g.Component)
    );
    return Pe(t), t;
  };
})(ls || (ls = {}));
var cs = globalThis && globalThis.__assign || function() {
  return cs = Object.assign || function(r) {
    for (var e, t = 1, n = arguments.length; t < n; t++) {
      e = arguments[t];
      for (var i in e)
        Object.prototype.hasOwnProperty.call(e, i) && (r[i] = e[i]);
    }
    return r;
  }, cs.apply(this, arguments);
}, vu = function(r) {
  var e = r.view, t = r.style, n = r.colorPickerProps, i = r.commandName, o = n.title, a = n.ariaLabel, s = n.view, l = s === void 0 ? "palette" : s, c = g.useCallback(function(u) {
    e && (Js({ style: t, value: u.value }, i)(e.state, e.dispatch), l === "palette" && e.focus());
  }, [e, t, l, i]);
  return g.createElement(yg, cs({ onChange: c, onActiveColorClick: c }, n, { title: o && Cn().toLanguageString(o, Y[o]), ariaLabel: a && Cn().toLanguageString(a, Y[a]) }));
}, n1 = globalThis && globalThis.__extends || function() {
  var r = function(e, t) {
    return r = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i)
        Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, r(e, t);
  };
  return function(e, t) {
    if (typeof t != "function" && t !== null)
      throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
    r(e, t);
    function n() {
      this.constructor = e;
    }
    e.prototype = t === null ? Object.create(t) : (n.prototype = t.prototype, new n());
  };
}(), oo = globalThis && globalThis.__assign || function() {
  return oo = Object.assign || function(r) {
    for (var e, t = 1, n = arguments.length; t < n; t++) {
      e = arguments[t];
      for (var i in e)
        Object.prototype.hasOwnProperty.call(e, i) && (r[i] = e[i]);
    }
    return r;
  }, oo.apply(this, arguments);
}, r1 = globalThis && globalThis.__rest || function(r, e) {
  var t = {};
  for (var n in r)
    Object.prototype.hasOwnProperty.call(r, n) && e.indexOf(n) < 0 && (t[n] = r[n]);
  if (r != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, n = Object.getOwnPropertySymbols(r); i < n.length; i++)
      e.indexOf(n[i]) < 0 && Object.prototype.propertyIsEnumerable.call(r, n[i]) && (t[n[i]] = r[n[i]]);
  return t;
}, us;
(function(r) {
  r.createFormatBlockDropDownList = function(e) {
    var t = (
      /** @class */
      function(n) {
        n1(i, n);
        function i() {
          var o = n !== null && n.apply(this, arguments) || this;
          return o.onChange = function(a) {
            var s = a.target.value, l = o.props.view;
            if (l && Wf(s.value, e.commandName)(l.state, l.dispatch)) {
              var c = a.syntheticEvent;
              c && c.type === "click" && l.focus();
            }
          }, o;
        }
        return i.prototype.render = function() {
          var o = this.props, a = o.view, s = o.render, l = o.data, c = o.defaultItem, u = r1(o, ["view", "render", "data", "defaultItem"]), f = l || e.items, h = c || e.defaultItem, d = a && a.state, p = d ? Vf(d) : [], m = Re(this);
          h && h.localizationKey && (h = oo({}, h), h.text = h.localizationKey ? m.toLanguageString(h.localizationKey, Y[h.localizationKey]) : h.text);
          var v = new Set(p).size === 1 ? p[0] : null, y = g.createElement(ku, oo({ value: v && f.find(function(b) {
            return b.value === v;
          }), onChange: this.onChange, itemRender: Kp, data: f, defaultItem: h, textField: "text", dataItemKey: "value", style: Up, leftRightKeysNavigation: !1, title: h.text }, u));
          return s ? s.call(void 0, y, { view: a }) : y;
        }, i;
      }(g.Component)
    );
    return Pe(t), t;
  };
})(us || (us = {}));
var i1 = globalThis && globalThis.__extends || function() {
  var r = function(e, t) {
    return r = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i)
        Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, r(e, t);
  };
  return function(e, t) {
    if (typeof t != "function" && t !== null)
      throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
    r(e, t);
    function n() {
      this.constructor = e;
    }
    e.prototype = t === null ? Object.create(t) : (n.prototype = t.prototype, new n());
  };
}(), fs = globalThis && globalThis.__assign || function() {
  return fs = Object.assign || function(r) {
    for (var e, t = 1, n = arguments.length; t < n; t++) {
      e = arguments[t];
      for (var i in e)
        Object.prototype.hasOwnProperty.call(e, i) && (r[i] = e[i]);
    }
    return r;
  }, fs.apply(this, arguments);
}, o1 = globalThis && globalThis.__rest || function(r, e) {
  var t = {};
  for (var n in r)
    Object.prototype.hasOwnProperty.call(r, n) && e.indexOf(n) < 0 && (t[n] = r[n]);
  if (r != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, n = Object.getOwnPropertySymbols(r); i < n.length; i++)
      e.indexOf(n[i]) < 0 && Object.prototype.propertyIsEnumerable.call(r, n[i]) && (t[n[i]] = r[n[i]]);
  return t;
}, xt = function(r, e) {
  var t = (
    /** @class */
    function(n) {
      i1(i, n);
      function i() {
        return n !== null && n.apply(this, arguments) || this;
      }
      return i.prototype.render = function() {
        var o = this.props, a = o.view, s = o.render, l = o1(o, ["view", "render"]), c = Re(this), u = r.messages.title, f = a && a.state, h = f ? !e(f) : !1, d = g.createElement(he, fs({ onClick: h ? void 0 : function() {
          return a && e(a.state, function(p) {
            return a.dispatch(p.setMeta("commandName", r.commandName));
          });
        }, "aria-disabled": h ? !0 : void 0 }, Ve, { title: c.toLanguageString(u, Y[u]) }, r.props, l, { className: ut(l.className, r.props.className, { "k-disabled": h }) }));
        return s ? s.call(void 0, d, { view: a }) : d;
      }, i;
    }(g.Component)
  );
  return Pe(t), t;
}, ao;
(function(r) {
  r.createUndoTool = function(e) {
    return xt(e, fl);
  }, r.createRedoTool = function(e) {
    return xt(e, Yi);
  };
})(ao || (ao = {}));
var a1 = globalThis && globalThis.__extends || function() {
  var r = function(e, t) {
    return r = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i)
        Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, r(e, t);
  };
  return function(e, t) {
    if (typeof t != "function" && t !== null)
      throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
    r(e, t);
    function n() {
      this.constructor = e;
    }
    e.prototype = t === null ? Object.create(t) : (n.prototype = t.prototype, new n());
  };
}(), hs = globalThis && globalThis.__assign || function() {
  return hs = Object.assign || function(r) {
    for (var e, t = 1, n = arguments.length; t < n; t++) {
      e = arguments[t];
      for (var i in e)
        Object.prototype.hasOwnProperty.call(e, i) && (r[i] = e[i]);
    }
    return r;
  }, hs.apply(this, arguments);
}, s1 = globalThis && globalThis.__rest || function(r, e) {
  var t = {};
  for (var n in r)
    Object.prototype.hasOwnProperty.call(r, n) && e.indexOf(n) < 0 && (t[n] = r[n]);
  if (r != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, n = Object.getOwnPropertySymbols(r); i < n.length; i++)
      e.indexOf(n[i]) < 0 && Object.prototype.propertyIsEnumerable.call(r, n[i]) && (t[n[i]] = r[n[i]]);
  return t;
}, ds;
(function(r) {
  r.createIndentTool = function(e) {
    var t = (
      /** @class */
      function(n) {
        a1(i, n);
        function i() {
          return n !== null && n.apply(this, arguments) || this;
        }
        return i.prototype.render = function() {
          var o = this.props, a = o.view, s = o.render, l = s1(o, ["view", "render"]), c = l.dir, u = a && a.state, f = u && u.schema.nodes, h = f && f[e.listsTypes.listItem], d = e.actions, p = !!u && !!h && (Zs(u, d, c) || d.some(function(D) {
            return f && f[D.node] && Zr(u, f[D.node]);
          })) && !Zr(u, h), m = !!u && oh(u, h), v = p || m, y = Re(this), b = e.messages.title, k = !v, M = g.createElement(he, hs({ onClick: k ? void 0 : function() {
            a && m && h ? Jf(h)(a.state, a.dispatch) : a && p && Ys(d, e.commandName, c)(a.state, a.dispatch);
          }, "aria-disabled": k ? !0 : void 0, title: y.toLanguageString(b, Y[b]) }, Ve, e.props, l, { className: ut(l.className, e.props.className, { "k-disabled": k }) }));
          return s ? s.call(void 0, M, { view: a }) : M;
        }, i;
      }(g.Component)
    );
    return Pe(t), t;
  };
})(ds || (ds = {}));
var l1 = globalThis && globalThis.__extends || function() {
  var r = function(e, t) {
    return r = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i)
        Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, r(e, t);
  };
  return function(e, t) {
    if (typeof t != "function" && t !== null)
      throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
    r(e, t);
    function n() {
      this.constructor = e;
    }
    e.prototype = t === null ? Object.create(t) : (n.prototype = t.prototype, new n());
  };
}(), ps = globalThis && globalThis.__assign || function() {
  return ps = Object.assign || function(r) {
    for (var e, t = 1, n = arguments.length; t < n; t++) {
      e = arguments[t];
      for (var i in e)
        Object.prototype.hasOwnProperty.call(e, i) && (r[i] = e[i]);
    }
    return r;
  }, ps.apply(this, arguments);
}, c1 = globalThis && globalThis.__rest || function(r, e) {
  var t = {};
  for (var n in r)
    Object.prototype.hasOwnProperty.call(r, n) && e.indexOf(n) < 0 && (t[n] = r[n]);
  if (r != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, n = Object.getOwnPropertySymbols(r); i < n.length; i++)
      e.indexOf(n[i]) < 0 && Object.prototype.propertyIsEnumerable.call(r, n[i]) && (t[n[i]] = r[n[i]]);
  return t;
}, ms;
(function(r) {
  r.createInlineFormatTool = function(e) {
    var t = (
      /** @class */
      function(n) {
        l1(i, n);
        function i() {
          return n !== null && n.apply(this, arguments) || this;
        }
        return i.prototype.render = function() {
          var o = this.props, a = o.view, s = o.render, l = c1(o, ["view", "render"]), c = a && a.state, u = e.mark, f = e.altMarks, h = e.altStyle, d = { mark: u, altMarks: f, altStyle: h }, p = Re(this), m = e.messages.title, v = g.createElement(he, ps({ onClick: function() {
            return a && Hn(d, c && c.tr.setMeta("commandName", e.commandName))(a.state, a.dispatch);
          }, selected: !!c && ci(c, d), togglable: !0 }, Ve, { title: p.toLanguageString(m, Y[m]) }, e.props, l));
          return s ? s.call(void 0, v, { view: a }) : v;
        }, i;
      }(g.Component)
    );
    return Pe(t), t;
  };
})(ms || (ms = {}));
var u1 = globalThis && globalThis.__extends || function() {
  var r = function(e, t) {
    return r = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i)
        Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, r(e, t);
  };
  return function(e, t) {
    if (typeof t != "function" && t !== null)
      throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
    r(e, t);
    function n() {
      this.constructor = e;
    }
    e.prototype = t === null ? Object.create(t) : (n.prototype = t.prototype, new n());
  };
}(), gs = globalThis && globalThis.__assign || function() {
  return gs = Object.assign || function(r) {
    for (var e, t = 1, n = arguments.length; t < n; t++) {
      e = arguments[t];
      for (var i in e)
        Object.prototype.hasOwnProperty.call(e, i) && (r[i] = e[i]);
    }
    return r;
  }, gs.apply(this, arguments);
}, f1 = globalThis && globalThis.__rest || function(r, e) {
  var t = {};
  for (var n in r)
    Object.prototype.hasOwnProperty.call(r, n) && e.indexOf(n) < 0 && (t[n] = r[n]);
  if (r != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, n = Object.getOwnPropertySymbols(r); i < n.length; i++)
      e.indexOf(n[i]) < 0 && Object.prototype.propertyIsEnumerable.call(r, n[i]) && (t[n[i]] = r[n[i]]);
  return t;
}, h1 = function(r) {
  var e = (
    /** @class */
    function(t) {
      u1(n, t);
      function n() {
        var i = t !== null && t.apply(this, arguments) || this;
        return i.state = {
          openedDialog: !1
        }, i.toggleDialog = function() {
          i.setState({
            openedDialog: !i.state.openedDialog
          });
        }, i;
      }
      return n.prototype.render = function() {
        var i = this.props, o = i.view, a = i.render, s = f1(i, ["view", "render"]), l = o && o.state, c = l ? l.schema.nodes[r.node] : void 0, u = Re(this), f = r.messages.insertImage, h = !c || !l || !Us(l, c), d = [g.createElement(he, gs({ onClick: h ? void 0 : this.toggleDialog, "aria-disabled": h ? !0 : void 0, key: "insertImage" }, Ve, { title: u.toLanguageString(f, Y[f]) }, r.props, s, { className: ut(s.className, r.props.className, { "k-disabled": h }) })), this.state.openedDialog && o && g.createElement(xr.InsertImageDialog, { key: "insertImageDialog", view: o, settings: r, dir: s.dir, onClose: this.toggleDialog }) || null];
        return a ? a.call(void 0, d, { view: o }) : d;
      }, n;
    }(g.Component)
  );
  return Pe(e), e;
}, d1 = globalThis && globalThis.__extends || function() {
  var r = function(e, t) {
    return r = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i)
        Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, r(e, t);
  };
  return function(e, t) {
    if (typeof t != "function" && t !== null)
      throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
    r(e, t);
    function n() {
      this.constructor = e;
    }
    e.prototype = t === null ? Object.create(t) : (n.prototype = t.prototype, new n());
  };
}(), vs = globalThis && globalThis.__assign || function() {
  return vs = Object.assign || function(r) {
    for (var e, t = 1, n = arguments.length; t < n; t++) {
      e = arguments[t];
      for (var i in e)
        Object.prototype.hasOwnProperty.call(e, i) && (r[i] = e[i]);
    }
    return r;
  }, vs.apply(this, arguments);
}, p1 = globalThis && globalThis.__rest || function(r, e) {
  var t = {};
  for (var n in r)
    Object.prototype.hasOwnProperty.call(r, n) && e.indexOf(n) < 0 && (t[n] = r[n]);
  if (r != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, n = Object.getOwnPropertySymbols(r); i < n.length; i++)
      e.indexOf(n[i]) < 0 && Object.prototype.propertyIsEnumerable.call(r, n[i]) && (t[n[i]] = r[n[i]]);
  return t;
}, ys;
(function(r) {
  r.createLinkTool = function(e) {
    var t = (
      /** @class */
      function(n) {
        d1(i, n);
        function i() {
          var o = n !== null && n.apply(this, arguments) || this;
          return o.state = {
            openedDialog: !1
          }, o.toggleDialog = function() {
            o.setState({
              openedDialog: !o.state.openedDialog
            });
          }, o;
        }
        return i.prototype.render = function() {
          var o = this.props, a = o.view, s = o.render, l = p1(o, ["view", "render"]), c = a && a.state, u = c ? c.selection.empty : !0, f = c && mo(c, c.schema.marks[e.mark]), h = Re(this), d = e.messages.insertHyperlink, p = u && !f, m = [g.createElement(he, vs({ onClick: p ? void 0 : this.toggleDialog, "aria-disabled": p ? !0 : void 0, key: "link" }, Ve, { title: h.toLanguageString(d, Y[d]) }, e.props, l, { className: ut(l.className, e.props.className, { "k-disabled": p }) })), this.state.openedDialog && a && g.createElement(xr.InsertLinkDialog, { key: "insertLinkDialog", settings: e, dir: l.dir, view: a, onClose: this.toggleDialog }) || null];
          return s ? s.call(void 0, m, { view: a }) : m;
        }, i;
      }(g.Component)
    );
    return Pe(t), t;
  };
})(ys || (ys = {}));
var m1 = globalThis && globalThis.__extends || function() {
  var r = function(e, t) {
    return r = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i)
        Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, r(e, t);
  };
  return function(e, t) {
    if (typeof t != "function" && t !== null)
      throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
    r(e, t);
    function n() {
      this.constructor = e;
    }
    e.prototype = t === null ? Object.create(t) : (n.prototype = t.prototype, new n());
  };
}(), so = globalThis && globalThis.__assign || function() {
  return so = Object.assign || function(r) {
    for (var e, t = 1, n = arguments.length; t < n; t++) {
      e = arguments[t];
      for (var i in e)
        Object.prototype.hasOwnProperty.call(e, i) && (r[i] = e[i]);
    }
    return r;
  }, so.apply(this, arguments);
}, g1 = globalThis && globalThis.__rest || function(r, e) {
  var t = {};
  for (var n in r)
    Object.prototype.hasOwnProperty.call(r, n) && e.indexOf(n) < 0 && (t[n] = r[n]);
  if (r != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, n = Object.getOwnPropertySymbols(r); i < n.length; i++)
      e.indexOf(n[i]) < 0 && Object.prototype.propertyIsEnumerable.call(r, n[i]) && (t[n[i]] = r[n[i]]);
  return t;
}, ws;
(function(r) {
  r.createListTool = function(e) {
    var t = (
      /** @class */
      function(n) {
        m1(i, n);
        function i() {
          return n !== null && n.apply(this, arguments) || this;
        }
        return i.prototype.render = function() {
          var o = this.props, a = o.view, s = o.render, l = g1(o, ["view", "render"]), c = !1, u = Re(this), f = e.messages.title, h = e.types, d = e.listType;
          if (a) {
            var p = a.state, m = p.schema.nodes, v = Zr(p, m[h.orderedList]), y = Zr(p, m[h.bulletList]);
            d === h.orderedList ? c = v && !y : c = !v && y;
          }
          var b = g.createElement(he, so({ onClick: function() {
            return a && Ui(a.state, a.dispatch, a, so({ listType: d }, h), e.commandName);
          }, togglable: !0, selected: c, title: u.toLanguageString(f, Y[f]) }, Ve, e.props, l));
          return s ? s.call(void 0, b, { view: a }) : b;
        }, i;
      }(g.Component)
    );
    return Pe(t), t;
  };
})(ws || (ws = {}));
var v1 = globalThis && globalThis.__extends || function() {
  var r = function(e, t) {
    return r = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i)
        Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, r(e, t);
  };
  return function(e, t) {
    if (typeof t != "function" && t !== null)
      throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
    r(e, t);
    function n() {
      this.constructor = e;
    }
    e.prototype = t === null ? Object.create(t) : (n.prototype = t.prototype, new n());
  };
}(), bs = globalThis && globalThis.__assign || function() {
  return bs = Object.assign || function(r) {
    for (var e, t = 1, n = arguments.length; t < n; t++) {
      e = arguments[t];
      for (var i in e)
        Object.prototype.hasOwnProperty.call(e, i) && (r[i] = e[i]);
    }
    return r;
  }, bs.apply(this, arguments);
}, y1 = globalThis && globalThis.__rest || function(r, e) {
  var t = {};
  for (var n in r)
    Object.prototype.hasOwnProperty.call(r, n) && e.indexOf(n) < 0 && (t[n] = r[n]);
  if (r != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, n = Object.getOwnPropertySymbols(r); i < n.length; i++)
      e.indexOf(n[i]) < 0 && Object.prototype.propertyIsEnumerable.call(r, n[i]) && (t[n[i]] = r[n[i]]);
  return t;
}, Ss;
(function(r) {
  r.createOutdentTool = function(e) {
    var t = (
      /** @class */
      function(n) {
        v1(i, n);
        function i() {
          return n !== null && n.apply(this, arguments) || this;
        }
        return i.prototype.render = function() {
          var o = this.props, a = o.view, s = o.render, l = y1(o, ["view", "render"]), c = a && a.state, u = l.dir, f = !!c && Zs(c, e.actions, u), h = c && c.schema.nodes[e.listsTypes.listItem], d = !!c && ah(c, { nodes: e.actions, listsTypes: e.listsTypes }), p = f || d, m = Re(this), v = e.messages.title, y = !p, b = g.createElement(he, bs({ onClick: y ? void 0 : function() {
            a && d && h ? Gf(h)(a.state, a.dispatch) : a && f && Ys(e.actions, e.commandName, u)(a.state, a.dispatch);
          }, "aria-disabled": y ? !0 : void 0, title: m.toLanguageString(v, Y[v]) }, Ve, e.props, l, { className: ut(l.className, e.props.className, { "k-disabled": y }) }));
          return s ? s.call(void 0, b, { view: a }) : b;
        }, i;
      }(g.Component)
    );
    return Pe(t), t;
  };
})(Ss || (Ss = {}));
var w1 = function(r, e) {
  var t = bx(r, e);
  if (t && !e) {
    var n = hi(r), i = n && n.node(n.depth);
    if (i && i.content.childCount === 1)
      return !1;
  }
  return t;
}, b1 = function(r, e) {
  var t = cC(r, e);
  if (t && !e) {
    var n = hi(r), i = n && n.node(n.depth - 1);
    if (i && i.content.childCount === 1)
      return !1;
  }
  return t;
}, Ot;
(function(r) {
  r.createAddRowBeforeTool = function(e) {
    return xt(e, mx);
  }, r.createAddRowAfterTool = function(e) {
    return xt(e, gx);
  }, r.createAddColumnBeforeTool = function(e) {
    return xt(e, yx);
  }, r.createAddColumnAfterTool = function(e) {
    return xt(e, wx);
  }, r.createDeleteRowTool = function(e) {
    return xt(e, b1);
  }, r.createDeleteColumnTool = function(e) {
    return xt(e, w1);
  }, r.createDeleteTableTool = function(e) {
    return xt(e, gC);
  }, r.createMergeCellsTool = function(e) {
    return xt(e, fC);
  }, r.createSplitCellTool = function(e) {
    return xt(e, hC);
  };
})(Ot || (Ot = {}));
var S1 = globalThis && globalThis.__extends || function() {
  var r = function(e, t) {
    return r = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i)
        Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, r(e, t);
  };
  return function(e, t) {
    if (typeof t != "function" && t !== null)
      throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
    r(e, t);
    function n() {
      this.constructor = e;
    }
    e.prototype = t === null ? Object.create(t) : (n.prototype = t.prototype, new n());
  };
}(), Cs = globalThis && globalThis.__assign || function() {
  return Cs = Object.assign || function(r) {
    for (var e, t = 1, n = arguments.length; t < n; t++) {
      e = arguments[t];
      for (var i in e)
        Object.prototype.hasOwnProperty.call(e, i) && (r[i] = e[i]);
    }
    return r;
  }, Cs.apply(this, arguments);
}, C1 = globalThis && globalThis.__rest || function(r, e) {
  var t = {};
  for (var n in r)
    Object.prototype.hasOwnProperty.call(r, n) && e.indexOf(n) < 0 && (t[n] = r[n]);
  if (r != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, n = Object.getOwnPropertySymbols(r); i < n.length; i++)
      e.indexOf(n[i]) < 0 && Object.prototype.propertyIsEnumerable.call(r, n[i]) && (t[n[i]] = r[n[i]]);
  return t;
}, ks;
(function(r) {
  r.createUnlinkTool = function(e) {
    var t = (
      /** @class */
      function(n) {
        S1(i, n);
        function i() {
          return n !== null && n.apply(this, arguments) || this;
        }
        return i.prototype.render = function() {
          var o = this.props, a = o.view, s = o.render, l = C1(o, ["view", "render"]), c = { mark: e.mark }, u = a ? ci(a.state, c) : !1, f = Re(this), h = e.messages.title, d = !u, p = g.createElement(he, Cs({ onClick: d ? void 0 : function() {
            return a && Hf(c, a.state.tr.setMeta("commandName", e.commandName))(a.state, a.dispatch);
          }, "aria-disabled": d ? !0 : void 0 }, Ve, { title: f.toLanguageString(h, Y[h]) }, e.props, l, { className: ut(l.className, e.props.className, { "k-disabled": d }) }));
          return s ? s.call(void 0, p, { view: a }) : p;
        }, i;
      }(g.Component)
    );
    return Pe(t), t;
  };
})(ks || (ks = {}));
var k1 = globalThis && globalThis.__extends || function() {
  var r = function(e, t) {
    return r = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i)
        Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, r(e, t);
  };
  return function(e, t) {
    if (typeof t != "function" && t !== null)
      throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
    r(e, t);
    function n() {
      this.constructor = e;
    }
    e.prototype = t === null ? Object.create(t) : (n.prototype = t.prototype, new n());
  };
}(), xs = globalThis && globalThis.__assign || function() {
  return xs = Object.assign || function(r) {
    for (var e, t = 1, n = arguments.length; t < n; t++) {
      e = arguments[t];
      for (var i in e)
        Object.prototype.hasOwnProperty.call(e, i) && (r[i] = e[i]);
    }
    return r;
  }, xs.apply(this, arguments);
}, x1 = globalThis && globalThis.__rest || function(r, e) {
  var t = {};
  for (var n in r)
    Object.prototype.hasOwnProperty.call(r, n) && e.indexOf(n) < 0 && (t[n] = r[n]);
  if (r != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, n = Object.getOwnPropertySymbols(r); i < n.length; i++)
      e.indexOf(n[i]) < 0 && Object.prototype.propertyIsEnumerable.call(r, n[i]) && (t[n[i]] = r[n[i]]);
  return t;
}, Os;
(function(r) {
  r.createViewHtmlTool = function(e) {
    var t = (
      /** @class */
      function(n) {
        k1(i, n);
        function i() {
          var o = n !== null && n.apply(this, arguments) || this;
          return o.state = {
            openedDialog: !1
          }, o.toggleDialog = function() {
            o.setState({
              openedDialog: !o.state.openedDialog
            });
          }, o;
        }
        return i.prototype.render = function() {
          var o = this.props, a = o.view, s = o.render, l = x1(o, ["view", "render"]), c = Re(this), u = e.messages.viewHtml, f = [g.createElement(he, xs({ onClick: this.toggleDialog, key: "viewHtml" }, Ve, { title: c.toLanguageString(u, Y[u]) }, e.props, l)), this.state.openedDialog && a && g.createElement(xr.ViewHtmlDialog, { key: "viewHtmlDialog", view: a, settings: e, dir: l.dir, onClose: this.toggleDialog }) || null];
          return s ? s.call(void 0, f, { view: a }) : f;
        }, i;
      }(g.Component)
    );
    return Pe(t), t;
  };
})(Os || (Os = {}));
var Ts = globalThis && globalThis.__assign || function() {
  return Ts = Object.assign || function(r) {
    for (var e, t = 1, n = arguments.length; t < n; t++) {
      e = arguments[t];
      for (var i in e)
        Object.prototype.hasOwnProperty.call(e, i) && (r[i] = e[i]);
    }
    return r;
  }, Ts.apply(this, arguments);
}, O1 = globalThis && globalThis.__rest || function(r, e) {
  var t = {};
  for (var n in r)
    Object.prototype.hasOwnProperty.call(r, n) && e.indexOf(n) < 0 && (t[n] = r[n]);
  if (r != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, n = Object.getOwnPropertySymbols(r); i < n.length; i++)
      e.indexOf(n[i]) < 0 && Object.prototype.propertyIsEnumerable.call(r, n[i]) && (t[n[i]] = r[n[i]]);
  return t;
}, T1 = X.print, M1 = function(r) {
  var e = r.view, t = r.render, n = r.settings, i = n === void 0 ? T1 : n, o = O1(r, ["view", "render", "settings"]), a = e && e.dom, s = a && a.ownerDocument, l = s && s.defaultView, c = i.messages.title, u = !l || l === window, f = g.useCallback(function() {
    l && l.print();
  }, [l]), h = g.createElement(he, Ts({ onClick: u ? void 0 : f, "aria-disabled": u ? !0 : void 0, title: Cn().toLanguageString(c, Y[c]) }, Ve, i.props, o, { className: ut(o.className, i.props.className, { "k-disabled": u }) }));
  return t ? t.call(void 0, h, { view: e }) : h;
}, _1 = "export.pdf", I1 = "KendoReact PDF Generator", D1 = (
  /** @class */
  function() {
    function r(e, t, n, i, o) {
      o === void 0 && (o = {});
      var a = this;
      this.drawDOM = e, this.exportPDF = t, this.saveAs = n, this.domElement = i, this.options = o, this.convertPageTemplateToHtml = function(s) {
        var l = Og(g.createElement(a.options.pageTemplate, {
          pageNum: s.pageNum,
          totalPages: s.totalPages
        }));
        return "<span>".concat(l, "</span>");
      };
    }
    return r.prototype.savePDF = function(e) {
      var t = this, n = this.drawDOM(this.domElement, this.getDrawOptions()).then(function(i) {
        return t.exportPDF(i, t.getPDFOptions());
      }).then(function(i) {
        return t.saveAs(i, t.options.fileName || _1, t.getSaveOptions());
      });
      e && n.then(e, e);
    }, r.prototype.getDrawOptions = function() {
      return {
        avoidLinks: this.options.avoidLinks,
        forcePageBreak: this.options.forcePageBreak,
        keepTogether: this.options.keepTogether,
        margin: this.options.margin,
        paperSize: this.options.paperSize,
        landscape: this.options.landscape,
        repeatHeaders: this.options.repeatHeaders,
        scale: this.options.scale,
        template: this.options.pageTemplate && this.convertPageTemplateToHtml
      };
    }, r.prototype.getPDFOptions = function() {
      return {
        author: this.options.author,
        creator: this.options.creator || I1,
        date: this.options.date,
        imgDPI: this.options.imageResolution,
        keywords: this.options.keywords,
        landscape: this.options.landscape,
        margin: this.options.margin,
        multiPage: !0,
        paperSize: this.options.paperSize,
        producer: this.options.producer,
        subject: this.options.subject,
        title: this.options.title
      };
    }, r.prototype.getSaveOptions = function() {
      return {
        forceProxy: this.options.forceProxy,
        proxyData: this.options.proxyData,
        proxyTarget: this.options.proxyTarget,
        proxyURL: this.options.proxyURL
      };
    }, r;
  }()
);
const E1 = D1;
function A1(r, e, t) {
  e === void 0 && (e = {}), new E1(hy, oy, kg, r, e).savePDF(t);
}
var qr = globalThis && globalThis.__assign || function() {
  return qr = Object.assign || function(r) {
    for (var e, t = 1, n = arguments.length; t < n; t++) {
      e = arguments[t];
      for (var i in e)
        Object.prototype.hasOwnProperty.call(e, i) && (r[i] = e[i]);
    }
    return r;
  }, qr.apply(this, arguments);
}, N1 = globalThis && globalThis.__rest || function(r, e) {
  var t = {};
  for (var n in r)
    Object.prototype.hasOwnProperty.call(r, n) && e.indexOf(n) < 0 && (t[n] = r[n]);
  if (r != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, n = Object.getOwnPropertySymbols(r); i < n.length; i++)
      e.indexOf(n[i]) < 0 && Object.prototype.propertyIsEnumerable.call(r, n[i]) && (t[n[i]] = r[n[i]]);
  return t;
}, R1 = X.pdf, P1 = X.savePdfOptions, L1 = function(r) {
  var e = r.view, t = r.render, n = r.settings, i = n === void 0 ? R1 : n, o = r.savePdfOptions, a = r.savePdfCallback, s = N1(r, ["view", "render", "settings", "savePdfOptions", "savePdfCallback"]), l = i.messages.title, c = g.useCallback(function() {
    e && A1(e.dom, qr(qr({}, P1), o || {}), a);
  }, [e, o, a]), u = g.createElement(he, qr({ onClick: c, title: Cn().toLanguageString(l, Y[l]) }, Ve, i.props, s));
  return t ? t.call(void 0, u, { view: e }) : u;
}, Ms = globalThis && globalThis.__assign || function() {
  return Ms = Object.assign || function(r) {
    for (var e, t = 1, n = arguments.length; t < n; t++) {
      e = arguments[t];
      for (var i in e)
        Object.prototype.hasOwnProperty.call(e, i) && (r[i] = e[i]);
    }
    return r;
  }, Ms.apply(this, arguments);
}, F1 = globalThis && globalThis.__rest || function(r, e) {
  var t = {};
  for (var n in r)
    Object.prototype.hasOwnProperty.call(r, n) && e.indexOf(n) < 0 && (t[n] = r[n]);
  if (r != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, n = Object.getOwnPropertySymbols(r); i < n.length; i++)
      e.indexOf(n[i]) < 0 && Object.prototype.propertyIsEnumerable.call(r, n[i]) && (t[n[i]] = r[n[i]]);
  return t;
}, z1 = X.selectAll, B1 = function(r) {
  var e = r.view, t = r.render, n = r.settings, i = n === void 0 ? z1 : n, o = F1(r, ["view", "render", "settings"]), a = i.messages.title, s = g.useCallback(function() {
    e && (th(e.state, e.dispatch), e.focus());
  }, [e]), l = g.createElement(he, Ms({ onClick: s, title: Cn().toLanguageString(a, Y[a]) }, Ve, i.props, o));
  return t ? t.call(void 0, l, { view: e }) : l;
}, _s = globalThis && globalThis.__assign || function() {
  return _s = Object.assign || function(r) {
    for (var e, t = 1, n = arguments.length; t < n; t++) {
      e = arguments[t];
      for (var i in e)
        Object.prototype.hasOwnProperty.call(e, i) && (r[i] = e[i]);
    }
    return r;
  }, _s.apply(this, arguments);
}, $1 = globalThis && globalThis.__rest || function(r, e) {
  var t = {};
  for (var n in r)
    Object.prototype.hasOwnProperty.call(r, n) && e.indexOf(n) < 0 && (t[n] = r[n]);
  if (r != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, n = Object.getOwnPropertySymbols(r); i < n.length; i++)
      e.indexOf(n[i]) < 0 && Object.prototype.propertyIsEnumerable.call(r, n[i]) && (t[n[i]] = r[n[i]]);
  return t;
}, H1 = X.cleanFormatting, yu = h0(), j1 = function(r) {
  var e = r.view, t = r.render, n = r.settings, i = n === void 0 ? H1 : n, o = $1(r, ["view", "render", "settings"]), a = i.messages.title, s = !e || !yu(e.state), l = g.useCallback(function() {
    e && yu(e.state, function(u) {
      u.setMeta("commandName", i.commandName), e.dispatch(u);
    });
  }, [e]), c = g.createElement(he, _s({ onClick: s ? void 0 : l, "aria-disabled": s ? !0 : void 0, title: Cn().toLanguageString(a, Y[a]) }, Ve, i.props, o, { className: ut(r.className, i.props.className, { "k-disabled": s }) }));
  return t ? t.call(void 0, c, { view: e }) : c;
}, W1 = globalThis && globalThis.__extends || function() {
  var r = function(e, t) {
    return r = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i)
        Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, r(e, t);
  };
  return function(e, t) {
    if (typeof t != "function" && t !== null)
      throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
    r(e, t);
    function n() {
      this.constructor = e;
    }
    e.prototype = t === null ? Object.create(t) : (n.prototype = t.prototype, new n());
  };
}(), Is = globalThis && globalThis.__assign || function() {
  return Is = Object.assign || function(r) {
    for (var e, t = 1, n = arguments.length; t < n; t++) {
      e = arguments[t];
      for (var i in e)
        Object.prototype.hasOwnProperty.call(e, i) && (r[i] = e[i]);
    }
    return r;
  }, Is.apply(this, arguments);
}, V1 = globalThis && globalThis.__rest || function(r, e) {
  var t = {};
  for (var n in r)
    Object.prototype.hasOwnProperty.call(r, n) && e.indexOf(n) < 0 && (t[n] = r[n]);
  if (r != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, n = Object.getOwnPropertySymbols(r); i < n.length; i++)
      e.indexOf(n[i]) < 0 && Object.prototype.propertyIsEnumerable.call(r, n[i]) && (t[n[i]] = r[n[i]]);
  return t;
}, wu = X.findAndReplace, Jp = (
  /** @class */
  function(r) {
    W1(e, r);
    function e() {
      var t = r !== null && r.apply(this, arguments) || this;
      return t.state = { showDialog: !1 }, t.onClose = function() {
        return t.setState({ showDialog: !1 });
      }, t.onOpen = function() {
        return t.setState({ showDialog: !0 });
      }, t;
    }
    return e.prototype.render = function() {
      var t = this.props, n = t.view, i = V1(t, ["view"]), o = wu.props, a = Re(this), s = wu.messages.findReplaceToolTitle, l = !n;
      return [g.createElement(he, Is({ onClick: l ? void 0 : this.onOpen, "aria-disabled": l ? !0 : void 0 }, Ve, { title: a.toLanguageString(s, Y[s]), key: "tool" }, o, i, { className: ut(i.className, o.className, { "k-disabled": l }) })), this.state.showDialog && n && g.createElement(ml, { view: n, onClose: this.onClose, dir: i.dir, key: "dialog" })];
    }, e;
  }(g.Component)
);
Pe(Jp);
var un = globalThis && globalThis.__assign || function() {
  return un = Object.assign || function(r) {
    for (var e, t = 1, n = arguments.length; t < n; t++) {
      e = arguments[t];
      for (var i in e)
        Object.prototype.hasOwnProperty.call(e, i) && (r[i] = e[i]);
    }
    return r;
  }, un.apply(this, arguments);
}, U1 = globalThis && globalThis.__spreadArray || function(r, e, t) {
  if (t || arguments.length === 2)
    for (var n = 0, i = e.length, o; n < i; n++)
      (o || !(n in e)) && (o || (o = Array.prototype.slice.call(e, 0, n)), o[n] = e[n]);
  return r.concat(o || Array.prototype.slice.call(e));
}, bu = function(r, e) {
  var t = r.selection, n = t.from, i = t.to, o = null;
  return r.doc.nodesBetween(n, i, function(a) {
    return o = o || (a.type === e ? a : null), !o;
  }), o;
}, Su = function(r) {
  var e = !1, t = r.view, n = Dn, i = r.listType, o = Cn(), a = U1([], r.items || [], !0), s, l;
  if (t) {
    var c = t.state, u = c && c.schema.nodes;
    s = u && bu(c, u[n.orderedList]), l = u && bu(c, u[n.bulletList]), e = !!(i === n.orderedList ? s && !l : !s && l);
  }
  var f = function(p) {
    t && (Ui(t.state, t.dispatch, t, un(un({ listType: i }, n), { listAttrs: {} }), "InsertList"), t.focus());
  }, h = function(p) {
    if (t) {
      var m = p.item.style ? { style: "list-style-type: " + p.item.style + ";" } : {}, v = s || l;
      if (v && lr(v.attrs) !== p.item.style) {
        var y = t.state.selection.$head.posAtIndex(0, -2) - 1;
        t.dispatch(t.state.tr.setNodeMarkup(y, t.state.schema.nodes[i], m));
      } else
        Ui(t.state, t.dispatch, t, un(un({ listType: i }, n), { listAttrs: m }), "InsertList");
      t.focus();
    }
  };
  if (e && (s || l)) {
    var d = lr((s || l).attrs);
    a = a.map(function(p, m) {
      return un(un({}, p), { selected: d ? p.style === d : m === 0 });
    });
  }
  return g.createElement(
    "span",
    { onMouseDown: function(p) {
      p.preventDefault();
    } },
    g.createElement(Vg, { textField: "text", items: a, icon: r.icon, svgIcon: r.svgIcon, onButtonClick: f, onItemClick: h, buttonClass: e ? "k-selected" : void 0, title: r.title !== void 0 ? r.title : o.toLanguageString(r.titleKey, Y[r.titleKey]) })
  );
}, ae = globalThis && globalThis.__extends || function() {
  var r = function(e, t) {
    return r = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
      n.__proto__ = i;
    } || function(n, i) {
      for (var o in i)
        Object.prototype.hasOwnProperty.call(i, o) && (n[o] = i[o]);
    }, r(e, t);
  };
  return function(e, t) {
    if (typeof t != "function" && t !== null)
      throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
    r(e, t);
    function n() {
      this.constructor = e;
    }
    e.prototype = t === null ? Object.create(t) : (n.prototype = t.prototype, new n());
  };
}(), Rt = globalThis && globalThis.__assign || function() {
  return Rt = Object.assign || function(r) {
    for (var e, t = 1, n = arguments.length; t < n; t++) {
      e = arguments[t];
      for (var i in e)
        Object.prototype.hasOwnProperty.call(e, i) && (r[i] = e[i]);
    }
    return r;
  }, Rt.apply(this, arguments);
}, Ds;
(function(r) {
  function e(w) {
    return Qx(w);
  }
  r.createAlignTool = e;
  var t = (
    /** @class */
    function(w) {
      ae(x, w);
      function x() {
        return w !== null && w.apply(this, arguments) || this;
      }
      return x;
    }(e(X.alignLeft))
  );
  r.AlignLeft = t;
  var n = (
    /** @class */
    function(w) {
      ae(x, w);
      function x() {
        return w !== null && w.apply(this, arguments) || this;
      }
      return x;
    }(e(X.alignRight))
  );
  r.AlignRight = n;
  var i = (
    /** @class */
    function(w) {
      ae(x, w);
      function x() {
        return w !== null && w.apply(this, arguments) || this;
      }
      return x;
    }(e(X.alignCenter))
  );
  r.AlignCenter = i;
  var o = (
    /** @class */
    function(w) {
      ae(x, w);
      function x() {
        return w !== null && w.apply(this, arguments) || this;
      }
      return x;
    }(e(X.alignJustify))
  );
  r.AlignJustify = o;
  function a(w) {
    return as.createInsertTableTool(w);
  }
  r.createInsertTableTool = a;
  var s = (
    /** @class */
    function(w) {
      ae(x, w);
      function x() {
        return w !== null && w.apply(this, arguments) || this;
      }
      return x;
    }(a(X.insertTable))
  );
  r.InsertTable = s;
  var l = (
    /** @class */
    function(w) {
      ae(x, w);
      function x() {
        return w !== null && w.apply(this, arguments) || this;
      }
      return x;
    }(ro.InsertTablePopup)
  );
  r.InsertTablePopup = l;
  function c(w) {
    return ls.createStyleDropDownList(w);
  }
  r.createStyleDropDownList = c;
  var u = (
    /** @class */
    function(w) {
      ae(x, w);
      function x() {
        return w !== null && w.apply(this, arguments) || this;
      }
      return x;
    }(c(X.fontSize))
  );
  r.FontSize = u;
  var f = (
    /** @class */
    function(w) {
      ae(x, w);
      function x() {
        return w !== null && w.apply(this, arguments) || this;
      }
      return x;
    }(c(X.fontName))
  );
  r.FontName = f, r.ForeColor = function(w) {
    return g.createElement(vu, Rt({}, X.foreColor, w));
  }, r.BackColor = function(w) {
    return g.createElement(vu, Rt({}, X.backColor, w));
  };
  function h(w) {
    return us.createFormatBlockDropDownList(w);
  }
  r.createFormatBlockDropDownList = h;
  var d = (
    /** @class */
    function(w) {
      ae(x, w);
      function x() {
        return w !== null && w.apply(this, arguments) || this;
      }
      return x;
    }(h(X.formatBlock))
  );
  r.FormatBlock = d;
  function p(w) {
    return ao.createUndoTool(w);
  }
  r.createUndoTool = p;
  function m(w) {
    return ao.createRedoTool(w);
  }
  r.createRedoTool = m;
  var v = (
    /** @class */
    function(w) {
      ae(x, w);
      function x() {
        return w !== null && w.apply(this, arguments) || this;
      }
      return x;
    }(p(X.undo))
  );
  r.Undo = v;
  var y = (
    /** @class */
    function(w) {
      ae(x, w);
      function x() {
        return w !== null && w.apply(this, arguments) || this;
      }
      return x;
    }(m(X.redo))
  );
  r.Redo = y;
  function b(w) {
    return ds.createIndentTool(w);
  }
  r.createIndentTool = b;
  var k = (
    /** @class */
    function(w) {
      ae(x, w);
      function x() {
        return w !== null && w.apply(this, arguments) || this;
      }
      return x;
    }(b(X.indent))
  );
  r.Indent = k;
  function M(w) {
    return ms.createInlineFormatTool(w);
  }
  r.createInlineFormatTool = M;
  var D = (
    /** @class */
    function(w) {
      ae(x, w);
      function x() {
        return w !== null && w.apply(this, arguments) || this;
      }
      return x;
    }(M(X.bold))
  );
  r.Bold = D;
  var T = (
    /** @class */
    function(w) {
      ae(x, w);
      function x() {
        return w !== null && w.apply(this, arguments) || this;
      }
      return x;
    }(M(X.italic))
  );
  r.Italic = T;
  var z = (
    /** @class */
    function(w) {
      ae(x, w);
      function x() {
        return w !== null && w.apply(this, arguments) || this;
      }
      return x;
    }(M(X.underline))
  );
  r.Underline = z;
  var _ = (
    /** @class */
    function(w) {
      ae(x, w);
      function x() {
        return w !== null && w.apply(this, arguments) || this;
      }
      return x;
    }(M(X.strikethrough))
  );
  r.Strikethrough = _;
  var ee = (
    /** @class */
    function(w) {
      ae(x, w);
      function x() {
        return w !== null && w.apply(this, arguments) || this;
      }
      return x;
    }(M(X.subscript))
  );
  r.Subscript = ee;
  var K = (
    /** @class */
    function(w) {
      ae(x, w);
      function x() {
        return w !== null && w.apply(this, arguments) || this;
      }
      return x;
    }(M(X.superscript))
  );
  r.Superscript = K;
  function O(w) {
    return h1(w);
  }
  r.createInsertImageTool = O;
  var ne = (
    /** @class */
    function(w) {
      ae(x, w);
      function x() {
        return w !== null && w.apply(this, arguments) || this;
      }
      return x;
    }(O(X.image))
  );
  r.InsertImage = ne;
  function B(w) {
    return ys.createLinkTool(w);
  }
  r.createLinkTool = B;
  var R = (
    /** @class */
    function(w) {
      ae(x, w);
      function x() {
        return w !== null && w.apply(this, arguments) || this;
      }
      return x;
    }(B(X.link))
  );
  r.Link = R;
  var U = (
    /** @class */
    function(w) {
      ae(x, w);
      function x() {
        return w !== null && w.apply(this, arguments) || this;
      }
      return x;
    }(B(X.insertFile))
  );
  r.InsertFile = U;
  function S(w) {
    return ws.createListTool(w);
  }
  r.createListTool = S;
  var W = (
    /** @class */
    function(w) {
      ae(x, w);
      function x() {
        return w !== null && w.apply(this, arguments) || this;
      }
      return x;
    }(S(X.orderedList))
  );
  r.OrderedList = W;
  var j = (
    /** @class */
    function(w) {
      ae(x, w);
      function x() {
        return w !== null && w.apply(this, arguments) || this;
      }
      return x;
    }(S(X.bulletList))
  );
  r.UnorderedList = j, r.BulletedList = function(w) {
    var x = [
      { icon: "list-unordered", svgIcon: va, text: "Disc", style: "disc" },
      { icon: "list-unordered-outline", svgIcon: eg, text: "Circle", style: "circle" },
      { icon: "list-unordered-square", svgIcon: tg, text: "Square", style: "square" }
    ];
    return g.createElement(Su, Rt({ listType: X.bulletList.listType, items: x, icon: "list-unordered", svgIcon: va, titleKey: X.bulletList.messages.title }, w));
  }, r.NumberedList = function(w) {
    var x = [
      { icon: "list-ordered", svgIcon: ga, text: "Decimal" },
      // { icon: 'list-leading-zero', text: 'Decimal with leading zero', styleType: 'decimal-leading-zero' },
      { icon: "list-roman-upper", svgIcon: ng, text: "Upper roman", style: "upper-roman" },
      { icon: "list-roman-lower", svgIcon: rg, text: "Lower roman", style: "lower-roman" },
      { icon: "list-latin-big", svgIcon: ig, text: "Upper latin", style: "upper-latin" },
      { icon: "list-latin-small", svgIcon: og, text: "Lower latin", style: "lower-latin" }
    ];
    return g.createElement(Su, Rt({ listType: X.orderedList.listType, items: x, icon: "list-ordered", svgIcon: ga, titleKey: X.orderedList.messages.title }, w));
  };
  function H(w) {
    return Ss.createOutdentTool(w);
  }
  r.createOutdentTool = H;
  var Z = (
    /** @class */
    function(w) {
      ae(x, w);
      function x() {
        return w !== null && w.apply(this, arguments) || this;
      }
      return x;
    }(H(X.outdent))
  );
  r.Outdent = Z, r.Print = function(w) {
    return g.createElement(M1, Rt({}, w));
  }, r.Pdf = function(w) {
    return g.createElement(L1, Rt({}, w));
  }, r.SelectAll = function(w) {
    return g.createElement(B1, Rt({}, w));
  }, r.CleanFormatting = function(w) {
    return g.createElement(j1, Rt({}, w));
  };
  function C(w) {
    return Ot.createAddRowBeforeTool(w);
  }
  r.createAddRowBeforeTool = C;
  function N(w) {
    return Ot.createAddRowAfterTool(w);
  }
  r.createAddRowAfterTool = N;
  function q(w) {
    return Ot.createAddColumnBeforeTool(w);
  }
  r.createAddColumnBeforeTool = q;
  function de(w) {
    return Ot.createAddColumnAfterTool(w);
  }
  r.createAddColumnAfterTool = de;
  function ce(w) {
    return Ot.createDeleteRowTool(w);
  }
  r.createDeleteRowTool = ce;
  function be(w) {
    return Ot.createDeleteColumnTool(w);
  }
  r.createDeleteColumnTool = be;
  function pe(w) {
    return Ot.createDeleteTableTool(w);
  }
  r.createDeleteTableTool = pe;
  function ue(w) {
    return Ot.createMergeCellsTool(w);
  }
  r.createMergeCellsTool = ue;
  function yt(w) {
    return Ot.createSplitCellTool(w);
  }
  r.createSplitCellTool = yt;
  var wt = (
    /** @class */
    function(w) {
      ae(x, w);
      function x() {
        return w !== null && w.apply(this, arguments) || this;
      }
      return x;
    }(C(X.addRowBefore))
  );
  r.AddRowBefore = wt;
  var ke = (
    /** @class */
    function(w) {
      ae(x, w);
      function x() {
        return w !== null && w.apply(this, arguments) || this;
      }
      return x;
    }(N(X.addRowAfter))
  );
  r.AddRowAfter = ke;
  var ve = (
    /** @class */
    function(w) {
      ae(x, w);
      function x() {
        return w !== null && w.apply(this, arguments) || this;
      }
      return x;
    }(q(X.addColumnBefore))
  );
  r.AddColumnBefore = ve;
  var it = (
    /** @class */
    function(w) {
      ae(x, w);
      function x() {
        return w !== null && w.apply(this, arguments) || this;
      }
      return x;
    }(de(X.addColumnAfter))
  );
  r.AddColumnAfter = it;
  var le = (
    /** @class */
    function(w) {
      ae(x, w);
      function x() {
        return w !== null && w.apply(this, arguments) || this;
      }
      return x;
    }(ce(X.deleteRow))
  );
  r.DeleteRow = le;
  var De = (
    /** @class */
    function(w) {
      ae(x, w);
      function x() {
        return w !== null && w.apply(this, arguments) || this;
      }
      return x;
    }(be(X.deleteColumn))
  );
  r.DeleteColumn = De;
  var Mn = (
    /** @class */
    function(w) {
      ae(x, w);
      function x() {
        return w !== null && w.apply(this, arguments) || this;
      }
      return x;
    }(pe(X.deleteTable))
  );
  r.DeleteTable = Mn;
  var _n = (
    /** @class */
    function(w) {
      ae(x, w);
      function x() {
        return w !== null && w.apply(this, arguments) || this;
      }
      return x;
    }(ue(X.mergeCells))
  );
  r.MergeCells = _n;
  var Et = (
    /** @class */
    function(w) {
      ae(x, w);
      function x() {
        return w !== null && w.apply(this, arguments) || this;
      }
      return x;
    }(yt(X.splitCell))
  );
  r.SplitCell = Et;
  function qt(w) {
    return ks.createUnlinkTool(w);
  }
  r.createUnlinkTool = qt;
  var rn = (
    /** @class */
    function(w) {
      ae(x, w);
      function x() {
        return w !== null && w.apply(this, arguments) || this;
      }
      return x;
    }(qt(X.unlink))
  );
  r.Unlink = rn;
  function Tr(w) {
    return Os.createViewHtmlTool(w);
  }
  r.createViewHtmlTool = Tr;
  var di = (
    /** @class */
    function(w) {
      ae(x, w);
      function x() {
        return w !== null && w.apply(this, arguments) || this;
      }
      return x;
    }(Tr(X.viewHtml))
  );
  r.ViewHtml = di;
  var pi = (
    /** @class */
    function(w) {
      ae(x, w);
      function x() {
        return w !== null && w.apply(this, arguments) || this;
      }
      return x;
    }(Jp)
  );
  r.FindAndReplace = pi;
})(Ds || (Ds = {}));
const {
  Bold: q1,
  Italic: K1,
  Underline: G1,
  Strikethrough: J1,
  AlignLeft: X1,
  AlignCenter: Y1,
  AlignRight: Z1,
  AlignJustify: Q1,
  Indent: eO,
  Outdent: tO,
  OrderedList: nO,
  UnorderedList: rO,
  Undo: iO,
  Redo: oO,
  Link: aO,
  Unlink: sO,
  InsertImage: lO,
  ViewHtml: cO
} = Ds;
class JO extends g.Component {
  constructor() {
    super(...arguments);
    mi(this, "defaultTools", [
      [q1, K1, G1, J1],
      [eO, tO, nO, rO]
    ]);
    mi(this, "linkTools", [iO, oO, aO, sO, lO, cO]);
    mi(this, "alignTextTools", [X1, Y1, Z1, Q1]);
  }
  render() {
    let t = [];
    return this.props.showTools && (t = this.defaultTools, this.props.showLinkTools && (t = [...t, this.linkTools]), this.props.showAlignText && (t = [...t, this.alignTextTools])), /* @__PURE__ */ im.jsx(Gp, { ...this.props, tools: t });
  }
}
export {
  JO as TextEditor
};
